
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire61fd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire61fd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRegister("gbH6E", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $bc8f1c68f78f02e6$export$bf730a2d8bf68b42, (v) => $bc8f1c68f78f02e6$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bc8f1c68f78f02e6$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");
function $bc8f1c68f78f02e6$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bc8f1c68f78f02e6$var$p = "function" === typeof Object.is ? Object.is : $bc8f1c68f78f02e6$var$n, $bc8f1c68f78f02e6$var$q = $acw62.useSyncExternalStore, $bc8f1c68f78f02e6$var$r = $acw62.useRef, $bc8f1c68f78f02e6$var$t = $acw62.useEffect, $bc8f1c68f78f02e6$var$u = $acw62.useMemo, $bc8f1c68f78f02e6$var$v = $acw62.useDebugValue;
$bc8f1c68f78f02e6$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $bc8f1c68f78f02e6$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $bc8f1c68f78f02e6$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($bc8f1c68f78f02e6$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $bc8f1c68f78f02e6$var$q(a, c[0], c[1]);
    $bc8f1c68f78f02e6$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $bc8f1c68f78f02e6$var$v(d);
    return d;
};

});

parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function("return this")();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});


parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;






/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};



var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $ccdf93292345e76e$export$b86cef4a23233c8c = "__awsuiMetadata__";
function $ccdf93292345e76e$export$9e6be7bb393f4fdd(componentName, packageVersion, analyticsMetadata) {
    const elementRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (elementRef.current) {
            const node = elementRef.current;
            const metadata = {
                name: componentName,
                version: packageVersion
            };
            // Only add analytics property to metadata if analytics property is non-empty
            if (analyticsMetadata && Object.keys(analyticsMetadata).length > 0) metadata.analytics = analyticsMetadata;
            Object.freeze(metadata);
            Object.defineProperty(node, $ccdf93292345e76e$export$b86cef4a23233c8c, {
                value: metadata,
                writable: false,
                configurable: true
            });
        }
    });
    return elementRef;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $1ffeda400a26e1c2$var$validateLength(value, maxLength) {
    return !value || value.length <= maxLength;
}
class $1ffeda400a26e1c2$export$8b31d0d9057d2d6a {
    /**
     * Sends metric but only if Console Platform client logging JS API is present in the page.
     */ sendMetric(metricName, value, detail) {
        if (!metricName || !/^[a-zA-Z0-9_-]+$/.test(metricName)) {
            console.error(`Invalid metric name: ${metricName}`);
            return;
        }
        if (!$1ffeda400a26e1c2$var$validateLength(metricName, 1000)) {
            console.error(`Metric name ${metricName} is too long`);
            return;
        }
        if (!$1ffeda400a26e1c2$var$validateLength(detail, 4000)) {
            console.error(`Detail for metric ${metricName} is too long: ${detail}`);
            return;
        }
        const AWSC = this.findAWSC(window);
        if (typeof AWSC === "object" && typeof AWSC.Clog === "object" && typeof AWSC.Clog.log === "function") AWSC.Clog.log(metricName, value, detail);
    }
    findAWSC(currentWindow) {
        try {
            if (typeof (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.AWSC) === "object") return currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.AWSC;
            if (!currentWindow || currentWindow.parent === currentWindow) // When the window has no more parents, it references itself
            return undefined;
            return this.findAWSC(currentWindow.parent);
        } catch (ex) {
            // Most likely a cross-origin access error
            return undefined;
        }
    }
}
class $1ffeda400a26e1c2$export$9dce1d7c57dc9951 {
    /**
     * Sends metric but only if Console Platform client v2 logging JS API is present in the page.
     */ sendMetric(metric) {
        if (typeof metric.eventDetail === "object") metric.eventDetail = JSON.stringify(metric.eventDetail);
        if (typeof metric.eventValue === "object") metric.eventValue = JSON.stringify(metric.eventValue);
        if (!$1ffeda400a26e1c2$var$validateLength(metric.eventDetail, 4000)) {
            console.error(`Event detail for metric is too long: ${metric.eventDetail}`);
            return;
        }
        if (!$1ffeda400a26e1c2$var$validateLength(metric.eventValue, 4000)) {
            console.error(`Event value for metric is too long: ${metric.eventValue}`);
            return;
        }
        if (!$1ffeda400a26e1c2$var$validateLength(metric.eventContext, 4000)) {
            console.error(`Event context for metric is too long: ${metric.eventContext}`);
            return;
        }
        if (!$1ffeda400a26e1c2$var$validateLength(metric.eventType, 50)) {
            console.error(`Event type for metric is too long: ${metric.eventType}`);
            return;
        }
        const panorama = this.findPanorama(window);
        if (typeof panorama === "function") panorama("trackCustomEvent", Object.assign({
            timestamp: Date.now()
        }, metric));
    }
    findPanorama(currentWindow) {
        try {
            if (typeof (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.panorama) === "function") return currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.panorama;
            if (!currentWindow || currentWindow.parent === currentWindow) // When the window has no more parents, it references itself
            return undefined;
            return this.findPanorama(currentWindow.parent);
        } catch (ex) {
            // Most likely a cross-origin access error
            return undefined;
        }
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// React is the only framework we're using.
const $f34830c0df2b3501$var$framework = "react";
function $f34830c0df2b3501$export$85689840887b5ea9({ source: source, action: action, version: version, configuration: configuration }, theme) {
    const metricOrigin = typeof AWSUI_METRIC_ORIGIN !== "undefined" ? AWSUI_METRIC_ORIGIN : "main";
    const detailObject = {
        o: metricOrigin,
        s: source,
        t: theme,
        a: action,
        f: $f34830c0df2b3501$var$framework,
        v: $f34830c0df2b3501$export$b7b98818e44ffeee(version),
        c: configuration
    };
    return $f34830c0df2b3501$export$1f8609334739c2b6(detailObject);
}
function $f34830c0df2b3501$export$1f8609334739c2b6(detailObject) {
    return JSON.stringify(detailObject, $f34830c0df2b3501$var$detailSerializer);
}
function $f34830c0df2b3501$var$detailSerializer(key, value) {
    // Report NaN and Infinity as strings instead of `null` (default behavior)
    if (typeof value === "number" && !Number.isFinite(value)) return `${value}`;
    return value;
}
function $f34830c0df2b3501$export$6cc688d993704b6c({ source: source, version: version }, theme) {
    return [
        "awsui",
        source,
        `${$f34830c0df2b3501$export$5f9cfe5fc766cd85(theme, version)}`
    ].join("_");
}
function $f34830c0df2b3501$export$b7b98818e44ffeee(version) {
    return version.replace(/\s/g, "");
}
function $f34830c0df2b3501$export$5f9cfe5fc766cd85(theme, version) {
    return `${theme.charAt(0)}${$f34830c0df2b3501$var$getMajorVersion(version).replace(".", "")}`;
}
function $f34830c0df2b3501$var$getMajorVersion(versionString) {
    const majorVersionMatch = versionString.match(/^(\d+\.\d+)/);
    return majorVersionMatch ? majorVersionMatch[1] : "";
}


const $27492222c394d7f3$var$oneTimeMetrics = new Set();
// In case we need to override the theme for VR.
let $27492222c394d7f3$var$theme = "";
function $27492222c394d7f3$var$setTheme(newTheme) {
    $27492222c394d7f3$var$theme = newTheme;
}
class $27492222c394d7f3$export$ed9166ec0f465b5e {
    constructor(source, packageVersion){
        this.clog = new (0, $1ffeda400a26e1c2$export$8b31d0d9057d2d6a)();
        this.panorama = new (0, $1ffeda400a26e1c2$export$9dce1d7c57dc9951)();
        this.source = source;
        this.packageVersion = packageVersion;
    }
    initMetrics(theme) {
        $27492222c394d7f3$var$setTheme(theme);
    }
    /**
     * Calls Console Platform's client logging JS API with provided metric name, value, and detail.
     * Does nothing if Console Platform client logging JS is not present in page.
     */ sendMetric(metricName, value, detail) {
        if (!$27492222c394d7f3$var$theme) {
            // Metrics need to be initialized first (initMetrics)
            console.error("Metrics need to be initialized first.");
            return;
        }
        this.clog.sendMetric(metricName, value, detail);
    }
    /**
     * Calls Console Platform's client v2 logging JS API with provided metric name and detail.
     * Does nothing if Console Platform client logging JS is not present in page.
     */ sendPanoramaMetric(metric) {
        this.panorama.sendMetric(metric);
    }
    sendMetricObject(metric, value) {
        this.sendMetric((0, $f34830c0df2b3501$export$6cc688d993704b6c)(metric, $27492222c394d7f3$var$theme), value, (0, $f34830c0df2b3501$export$85689840887b5ea9)(metric, $27492222c394d7f3$var$theme));
    }
    sendMetricObjectOnce(metric, value) {
        const metricKey = (0, $f34830c0df2b3501$export$1f8609334739c2b6)(metric);
        if (!$27492222c394d7f3$var$oneTimeMetrics.has(metricKey)) {
            this.sendMetricObject(metric, value);
            $27492222c394d7f3$var$oneTimeMetrics.add(metricKey);
        }
    }
    /*
     * Calls Console Platform's client logging only the first time the provided metricName is used.
     * Subsequent calls with the same metricName are ignored.
     */ sendMetricOnce(metricName, value, detail) {
        if (!$27492222c394d7f3$var$oneTimeMetrics.has(metricName)) {
            this.sendMetric(metricName, value, detail);
            $27492222c394d7f3$var$oneTimeMetrics.add(metricName);
        }
    }
    /*
     * Reports a metric value 1 to Console Platform's client logging service to indicate that the
     * component was loaded. The component load event will only be reported as used to client logging
     * service once per page view.
     */ logComponentsLoaded() {
        this.sendMetricObjectOnce({
            source: this.source,
            action: "loaded",
            version: this.packageVersion
        }, 1);
    }
    /*
     * Reports a metric value 1 to Console Platform's client logging service to indicate that the
     * component was used in the page.  A component will only be reported as used to client logging
     * service once per page view.
     */ logComponentUsed(componentName, configuration) {
        this.sendMetricObjectOnce({
            source: componentName,
            action: "used",
            version: this.packageVersion,
            configuration: configuration
        }, 1);
    }
}
class $27492222c394d7f3$export$8943b291ee4b0d9d {
    resetOneTimeMetricsCache() {
        $27492222c394d7f3$var$oneTimeMetrics.clear();
    }
}


function $927d1efec68c45ed$export$cebe2da0a47a6ceb(componentName, { packageSource: packageSource, packageVersion: packageVersion, theme: theme }, configuration = {
    props: {}
}) {
    (0, $acw62.useEffect)(()=>{
        const metrics = new (0, $27492222c394d7f3$export$ed9166ec0f465b5e)(packageSource, packageVersion);
        metrics.initMetrics(theme);
        if (typeof window !== "undefined") {
            metrics.sendMetricOnce("awsui-viewport-width", window.innerWidth || 0);
            metrics.sendMetricOnce("awsui-viewport-height", window.innerHeight || 0);
        }
        metrics.logComponentsLoaded();
        metrics.logComponentUsed(componentName.toLowerCase(), configuration);
    // Components do not change the name dynamically. Explicit empty array to prevent accidental double metrics
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// expose version info, so it can be checked using the browser devtools
function $c9df79a03158a684$export$a1cd0337e8f19610(source, packageVersion) {
    if (typeof window !== "undefined") {
        if (!window.awsuiVersions) window.awsuiVersions = {};
        if (!window.awsuiVersions[source]) window.awsuiVersions[source] = [];
        window.awsuiVersions[source].push(packageVersion);
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $5c7908f42ed9bb37$export$402e76927ebf6a24 = [];


var $08f51855f5aa1c67$export$63c81bd924f89474 = function() {
    return (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $16b09d5982f07c6f$export$8ca35300535e324d = function() {
    return (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $a94d1125331cd631$var$msg = "ResizeObserver loop completed with undelivered notifications.";
var $a94d1125331cd631$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === "function") event = new ErrorEvent("error", {
        message: $a94d1125331cd631$var$msg
    });
    else {
        event = document.createEvent("Event");
        event.initEvent("error", false, false);
        event.message = $a94d1125331cd631$var$msg;
    }
    window.dispatchEvent(event);
};



var $eb9a41c17c565fb1$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($eb9a41c17c565fb1$export$416d111b83cd1483 || ($eb9a41c17c565fb1$export$416d111b83cd1483 = {}));


var $4aa2fd75c74ae252$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};


var $ef95acc2cc2e837a$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)(this);
    }
    return ResizeObserverSize;
}();



var $9347cb8a23412ffc$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $8243f40f6e04f737$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && "getBBox" in target;
};
var $8243f40f6e04f737$export$ee695c13482bb5dd = function(target) {
    if ($8243f40f6e04f737$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $8243f40f6e04f737$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $8243f40f6e04f737$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case "INPUT":
            if (target.type !== "image") break;
        case "VIDEO":
        case "AUDIO":
        case "EMBED":
        case "OBJECT":
        case "CANVAS":
        case "IFRAME":
        case "IMG":
            return true;
    }
    return false;
};



var $5970d6d9ee6c5784$export$90b4d2ff6acb88af = typeof window !== "undefined" ? window : {};


var $f202245796aa2855$var$cache = new WeakMap();
var $f202245796aa2855$var$scrollRegexp = /auto|scroll/;
var $f202245796aa2855$var$verticalRegexp = /^tb|vertical/;
var $f202245796aa2855$var$IE = /msie|trident/i.test((0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).navigator && (0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).navigator.userAgent);
var $f202245796aa2855$var$parseDimension = function(pixel) {
    return parseFloat(pixel || "0");
};
var $f202245796aa2855$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $ef95acc2cc2e837a$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $f202245796aa2855$var$zeroBoxes = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $f202245796aa2855$var$size(),
    borderBoxSize: $f202245796aa2855$var$size(),
    contentBoxSize: $f202245796aa2855$var$size(),
    contentRect: new (0, $9347cb8a23412ffc$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $f202245796aa2855$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($f202245796aa2855$var$cache.has(target) && !forceRecalculation) return $f202245796aa2855$var$cache.get(target);
    if ((0, $8243f40f6e04f737$export$ee695c13482bb5dd)(target)) {
        $f202245796aa2855$var$cache.set(target, $f202245796aa2855$var$zeroBoxes);
        return $f202245796aa2855$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $8243f40f6e04f737$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$f202245796aa2855$var$IE && cs.boxSizing === "border-box";
    var switchSizes = $f202245796aa2855$var$verticalRegexp.test(cs.writingMode || "");
    var canScrollVertically = !svg && $f202245796aa2855$var$scrollRegexp.test(cs.overflowY || "");
    var canScrollHorizontally = !svg && $f202245796aa2855$var$scrollRegexp.test(cs.overflowX || "");
    var paddingTop = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $f202245796aa2855$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $f202245796aa2855$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $f202245796aa2855$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $f202245796aa2855$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $f202245796aa2855$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $9347cb8a23412ffc$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $f202245796aa2855$var$cache.set(target, boxes);
    return boxes;
};
var $f202245796aa2855$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $f202245796aa2855$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $eb9a41c17c565fb1$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $eb9a41c17c565fb1$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $01e136febfef5919$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $f202245796aa2855$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();



var $df3e726c86d9d6ad$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $8243f40f6e04f737$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $3f0a2fbc64f46fd3$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $01e136febfef5919$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $df3e726c86d9d6ad$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $f202245796aa2855$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $638acb999774387d$export$9c17b8913a2a3572 = function(depth) {
    (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $df3e726c86d9d6ad$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $ecda2146b87bdeae$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $638acb999774387d$export$9c17b8913a2a3572)(depth);
    while((0, $08f51855f5aa1c67$export$63c81bd924f89474)()){
        depth = (0, $3f0a2fbc64f46fd3$export$9cac928141e5443b)();
        (0, $638acb999774387d$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $16b09d5982f07c6f$export$8ca35300535e324d)()) (0, $a94d1125331cd631$export$888cb69481582149)();
    return depth > 0;
};



var $4a6a87bff7ef9ac1$var$trigger;
var $4a6a87bff7ef9ac1$var$callbacks = [];
var $4a6a87bff7ef9ac1$var$notify = function() {
    return $4a6a87bff7ef9ac1$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $4a6a87bff7ef9ac1$export$4c995d4933c4abb = function(callback) {
    if (!$4a6a87bff7ef9ac1$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode("");
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $4a6a87bff7ef9ac1$var$notify();
        }).observe(el_1, config);
        $4a6a87bff7ef9ac1$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $4a6a87bff7ef9ac1$var$callbacks.push(callback);
    $4a6a87bff7ef9ac1$var$trigger();
};


var $b7d7256b374777b1$export$5755c7b572e34c6 = function(cb) {
    (0, $4a6a87bff7ef9ac1$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $068e7d416abba7c5$var$watching = 0;
var $068e7d416abba7c5$var$isWatching = function() {
    return !!$068e7d416abba7c5$var$watching;
};
var $068e7d416abba7c5$var$CATCH_PERIOD = 250;
var $068e7d416abba7c5$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $068e7d416abba7c5$var$events = [
    "resize",
    "load",
    "transitionend",
    "animationend",
    "animationstart",
    "animationiteration",
    "keyup",
    "keydown",
    "mouseup",
    "mousedown",
    "mouseover",
    "mouseout",
    "blur",
    "focus"
];
var $068e7d416abba7c5$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $068e7d416abba7c5$var$scheduled = false;
var $068e7d416abba7c5$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $068e7d416abba7c5$var$CATCH_PERIOD;
        if ($068e7d416abba7c5$var$scheduled) return;
        $068e7d416abba7c5$var$scheduled = true;
        var until = $068e7d416abba7c5$var$time(timeout);
        (0, $b7d7256b374777b1$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $ecda2146b87bdeae$export$e54fe5b0f43758f7)();
            } finally{
                $068e7d416abba7c5$var$scheduled = false;
                timeout = until - $068e7d416abba7c5$var$time();
                if (!$068e7d416abba7c5$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $068e7d416abba7c5$var$observerConfig);
        };
        document.body ? cb() : (0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).addEventListener("DOMContentLoaded", cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $068e7d416abba7c5$var$events.forEach(function(name) {
                return (0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $068e7d416abba7c5$var$events.forEach(function(name) {
                return (0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $068e7d416abba7c5$export$d30788f2c20241cd = new $068e7d416abba7c5$var$Scheduler();
var $068e7d416abba7c5$export$1f18a74d42722835 = function(n) {
    !$068e7d416abba7c5$var$watching && n > 0 && $068e7d416abba7c5$export$d30788f2c20241cd.start();
    $068e7d416abba7c5$var$watching += n;
    !$068e7d416abba7c5$var$watching && $068e7d416abba7c5$export$d30788f2c20241cd.stop();
};





var $4b08a70ac8b1df2b$var$skipNotifyOnElement = function(target) {
    return !(0, $8243f40f6e04f737$export$165b39ed277223c2)(target) && !(0, $8243f40f6e04f737$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === "inline";
};
var $4b08a70ac8b1df2b$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $eb9a41c17c565fb1$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $f202245796aa2855$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($4b08a70ac8b1df2b$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $53daa9aad498b184$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();



var $d48ceca8c6d96018$var$observerMap = new WeakMap();
var $d48ceca8c6d96018$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $d48ceca8c6d96018$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $53daa9aad498b184$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $d48ceca8c6d96018$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $d48ceca8c6d96018$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($d48ceca8c6d96018$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $4b08a70ac8b1df2b$export$fea412043713122)(target, options && options.box));
            (0, $068e7d416abba7c5$export$1f18a74d42722835)(1);
            (0, $068e7d416abba7c5$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $d48ceca8c6d96018$var$observerMap.get(resizeObserver);
        var index = $d48ceca8c6d96018$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).splice((0, $5c7908f42ed9bb37$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $068e7d416abba7c5$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $d48ceca8c6d96018$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $ba00521e8d0ae023$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== "function") throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $d48ceca8c6d96018$export$ed99c5bafbaf8300).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $8243f40f6e04f737$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $d48ceca8c6d96018$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $8243f40f6e04f737$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $d48ceca8c6d96018$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $d48ceca8c6d96018$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return "function ResizeObserver () { [polyfill code] }";
    };
    return ResizeObserver;
}();







var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0(fn) {
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = fn;
    });
    return (0, $acw62.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.apply(undefined, args);
    }, []);
}


function $444535e54951fdea$export$683480f191c0e3ea(elementRef, onObserve) {
    const stableOnObserve = (0, $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0)(onObserve);
    // This effect provides a synchronous update required to prevent flakiness when initial state and first observed state are different.
    // Can potentially conflict with React concurrent mode: https://17.reactjs.org/docs/concurrent-mode-intro.html.
    // TODO: A possible solution would be to make consumers not render any content until the first (asynchronous) observation is available.
    (0, $acw62.useLayoutEffect)(()=>{
        const element = typeof elementRef === "function" ? elementRef() : elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        if (element) onObserve($444535e54951fdea$var$convertResizeObserverEntry(new (0, $01e136febfef5919$export$226159b441fc89f8)(element)));
    }, // This effect is only needed for the first render to provide a synchronous update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $acw62.useEffect)(()=>{
        const element = typeof elementRef === "function" ? elementRef() : elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        if (element) {
            let connected = true;
            const observer = new (0, $ba00521e8d0ae023$export$9caf76241ca21a11)((entries)=>{
                // Prevent observe notifications on already unmounted component.
                if (connected) stableOnObserve($444535e54951fdea$var$convertResizeObserverEntry(entries[0]));
            });
            observer.observe(element);
            return ()=>{
                connected = false;
                observer.disconnect();
            };
        }
    }, [
        elementRef,
        stableOnObserve
    ]);
}
function $444535e54951fdea$var$convertResizeObserverEntry(entry) {
    return {
        target: entry.target,
        contentBoxWidth: entry.contentBoxSize[0].inlineSize,
        contentBoxHeight: entry.contentBoxSize[0].blockSize,
        borderBoxWidth: entry.borderBoxSize[0].inlineSize,
        borderBoxHeight: entry.borderBoxSize[0].blockSize
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $0eab7c44803f46fb$export$dcf465db4b1d75b1(factory) {
    const listeners = [];
    const callback = (value)=>{
        (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
            for (const listener of listeners)listener(value);
        });
    };
    let cleanup;
    return function useSingleton(listener) {
        (0, $acw62.useEffect)(()=>{
            if (listeners.length === 0) cleanup = factory(callback);
            listeners.push(listener);
            return ()=>{
                listeners.splice(listeners.indexOf(listener), 1);
                if (listeners.length === 0) {
                    cleanup();
                    cleanup = undefined;
                }
            };
        // register handlers only on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    };
}
function $0eab7c44803f46fb$export$415a0fd45cdbcd56({ factory: factory, initialState: initialState }) {
    const useSingleton = $0eab7c44803f46fb$export$dcf465db4b1d75b1(factory);
    let value = initialState;
    return function useSingletonState() {
        const [state, setState] = (0, $acw62.useState)(value);
        useSingleton((newValue)=>{
            value = newValue;
            setState(newValue);
        });
        return state;
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Checks if the current element or any of its parent is matched with `test` function.
 *
 * @example
 * Check if there is an ancestor with a CSS class matching regex
 * ```
 * const matchContext = (element) => element.className.match(/my-context-([\w-]+)/)
 * const contextElement = findUpUntil(currentElement, matchContext)
 * ```
 *
 * @param from Element to search from
 * @param test Returns `true` if the given element satisfies the search criteria
 * @returns First matched element or `null`
 */ function $b679de281b3ba268$export$2e2bcd8739ae039(from, test) {
    let current = from;
    while(current && !test(current)){
        current = current.parentElement;
        // If a component is used within an svg (i.e. as foreignObject), then it will
        // have some ancestor elements that are SVGElement. We want to skip those,
        // as they have very different properties to HTMLElements.
        while(current && !(current instanceof HTMLElement))current = current.parentElement;
    }
    return current;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Checks whether the given node is a parent of the other descendant node.
 * @param parent Parent node
 * @param descendant Node that is checked to be a descendant of the parent node
 */ function $af285507a4cbfe46$export$2e2bcd8739ae039(parent, descendant) {
    // ('nodeType' in descendant) is a workaround to check if descendant is a node
    //  Node interface is tied to the window it's created in, if the descendant was moved to an iframe after it was created,
    //  descendant instanceof Node will be false since Node has a different window
    if (!parent || !descendant || !("nodeType" in descendant)) return false;
    return parent.contains(descendant);
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Whether the bundle is a development bundle.
 * Only use this in an if condition and on its own! This will help bundlers find
 * and remove the conditional statement for production bundles.
 */ const $ea769919060d7f5c$export$df77466336fe5355 = false;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $dd646455762bc7b9$var$messageCache = new Set();
function $dd646455762bc7b9$export$5b28268982f175ba(component, message) {
    if (0, $ea769919060d7f5c$export$df77466336fe5355) {
        const warning = `[AwsUi] [${component}] ${message}`;
        if (!$dd646455762bc7b9$var$messageCache.has(warning)) {
            $dd646455762bc7b9$var$messageCache.add(warning);
            console.warn(warning);
        }
    }
}
function $dd646455762bc7b9$export$897447febe1f8d38() {
    $dd646455762bc7b9$var$messageCache.clear();
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $127791eee0e6430c$export$2e1ace48c9d20d83 = Symbol.for("awsui-visual-refresh-flag");
const $127791eee0e6430c$export$e586d5217e8bc2d3 = Symbol.for("awsui-global-flags");
const $127791eee0e6430c$export$104ac743431a5ed3 = ()=>{
    return window.top;
};
function $127791eee0e6430c$export$a4e55266d2135a7f() {
    return typeof window !== "undefined" ? window : globalThis;
}
function $127791eee0e6430c$var$readFlag(holder, flagName) {
    var _a;
    return (_a = holder === null || holder === void 0 ? void 0 : holder[$127791eee0e6430c$export$e586d5217e8bc2d3]) === null || _a === void 0 ? void 0 : _a[flagName];
}
const $127791eee0e6430c$export$cdbb7c478433ee77 = (flagName)=>{
    try {
        const ownFlag = $127791eee0e6430c$var$readFlag($127791eee0e6430c$export$a4e55266d2135a7f(), flagName);
        if (ownFlag !== undefined) return ownFlag;
        return $127791eee0e6430c$var$readFlag($127791eee0e6430c$export$104ac743431a5ed3(), flagName);
    } catch (e) {
        return undefined;
    }
};
const $127791eee0e6430c$export$46bf5ab4bdfe653f = (flagName, value)=>{
    const holder = $127791eee0e6430c$export$a4e55266d2135a7f();
    if (value === undefined) {
        const currentValue = $127791eee0e6430c$var$readFlag(holder, flagName);
        if (currentValue !== undefined) delete holder[$127791eee0e6430c$export$e586d5217e8bc2d3][flagName];
    } else {
        holder[$127791eee0e6430c$export$e586d5217e8bc2d3] = holder[$127791eee0e6430c$export$e586d5217e8bc2d3] || {};
        holder[$127791eee0e6430c$export$e586d5217e8bc2d3][flagName] = value;
    }
};


function $020c722843a7a503$export$399d33c9aa459b99(element) {
    var _a, _b;
    return !!(0, $b679de281b3ba268$export$2e2bcd8739ae039)(element, (node)=>node.classList.contains("awsui-motion-disabled")) || ((_b = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)").matches) !== null && _b !== void 0 ? _b : false);
}
function $020c722843a7a503$export$8eda93b51c73aab(elementRef) {
    const [value, setValue] = (0, $acw62.useState)("light");
    $020c722843a7a503$var$useMutationObserver(elementRef, (node)=>{
        const darkModeParent = (0, $b679de281b3ba268$export$2e2bcd8739ae039)(node, (node)=>node.classList.contains("awsui-polaris-dark-mode") || node.classList.contains("awsui-dark-mode"));
        setValue(darkModeParent ? "dark" : "light");
    });
    return value;
}
function $020c722843a7a503$export$e45e01e5e9ef1b27(elementRef) {
    const [value, setValue] = (0, $acw62.useState)("comfortable");
    $020c722843a7a503$var$useMutationObserver(elementRef, (node)=>{
        const compactModeParent = (0, $b679de281b3ba268$export$2e2bcd8739ae039)(node, (node)=>node.classList.contains("awsui-polaris-compact-mode") || node.classList.contains("awsui-compact-mode"));
        setValue(compactModeParent ? "compact" : "comfortable");
    });
    return value;
}
function $020c722843a7a503$export$6a42007cf1e7b6f8(elementRef) {
    const [value, setValue] = (0, $acw62.useState)(false);
    $020c722843a7a503$var$useMutationObserver(elementRef, (node)=>{
        setValue($020c722843a7a503$export$399d33c9aa459b99(node));
    });
    return value;
}
const $020c722843a7a503$var$useMutationSingleton = (0, $0eab7c44803f46fb$export$dcf465db4b1d75b1)((handler)=>{
    const observer = new MutationObserver(()=>handler());
    observer.observe(document.body, {
        attributes: true,
        subtree: true
    });
    return ()=>observer.disconnect();
});
function $020c722843a7a503$var$useMutationObserver(elementRef, onChange) {
    const handler = (0, $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0)(()=>{
        if (elementRef.current) onChange(elementRef.current);
    });
    $020c722843a7a503$var$useMutationSingleton(handler);
    (0, $acw62.useEffect)(()=>{
        handler();
    }, [
        handler
    ]);
}
// We expect VR is to be set only once and before the application is rendered.
let $020c722843a7a503$var$visualRefreshState = undefined;
function $020c722843a7a503$export$c9915e68fb5dc586() {
    $020c722843a7a503$var$visualRefreshState = undefined;
}
function $020c722843a7a503$var$detectVisualRefreshClassName() {
    return typeof document !== "undefined" && !!document.querySelector(".awsui-visual-refresh");
}
function $020c722843a7a503$var$detectVisualRefreshFlag() {
    var _a, _b;
    const global = (0, $127791eee0e6430c$export$a4e55266d2135a7f)();
    return (_b = (_a = global === null || global === void 0 ? void 0 : global[0, $127791eee0e6430c$export$2e1ace48c9d20d83]) === null || _a === void 0 ? void 0 : _a.call(global)) !== null && _b !== void 0 ? _b : false;
}
function $020c722843a7a503$export$536e98eff356e6c2() {
    if ($020c722843a7a503$var$visualRefreshState === undefined) {
        $020c722843a7a503$var$visualRefreshState = $020c722843a7a503$var$detectVisualRefreshClassName();
        if (!$020c722843a7a503$var$visualRefreshState) {
            if ($020c722843a7a503$var$detectVisualRefreshFlag()) {
                $020c722843a7a503$var$visualRefreshState = true;
                if (typeof document !== "undefined") document.body.classList.add("awsui-visual-refresh");
            }
        }
    }
    if (0, $ea769919060d7f5c$export$df77466336fe5355) {
        const newVisualRefreshState = $020c722843a7a503$var$detectVisualRefreshClassName() || $020c722843a7a503$var$detectVisualRefreshFlag();
        if (newVisualRefreshState !== $020c722843a7a503$var$visualRefreshState) (0, $dd646455762bc7b9$export$5b28268982f175ba)("Visual Refresh", "Dynamic visual refresh change detected. This is not supported. Make sure `awsui-visual-refresh` is attached to the `<body>` element before initial React render");
    }
    return $020c722843a7a503$var$visualRefreshState;
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $558545a5feadf817$export$c3f2dc1a1afd265d(element) {
    if (!element) return false;
    return getComputedStyle(element).direction === "rtl";
}
function $558545a5feadf817$export$46ef7e361fb70912(element) {
    var _a, _b;
    const offsetParentWidth = (_b = (_a = element.offsetParent) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
    return $558545a5feadf817$export$c3f2dc1a1afd265d(element) ? offsetParentWidth - element.offsetWidth - element.offsetLeft : element.offsetLeft;
}
function $558545a5feadf817$export$2ba840c8e91736fd(element) {
    return $558545a5feadf817$export$c3f2dc1a1afd265d(element) ? Math.floor(element.scrollLeft) * -1 : Math.ceil(element.scrollLeft);
}
function $558545a5feadf817$export$f04bb9050f053eba(event, IsRtl) {
    return IsRtl ? document.documentElement.clientWidth - event.clientX : event.clientX;
}
function $558545a5feadf817$export$322fb6cc2f904670(element) {
    const boundingClientRect = element.getBoundingClientRect();
    const blockSize = boundingClientRect.height;
    const inlineSize = boundingClientRect.width;
    const insetBlockStart = boundingClientRect.top;
    const insetBlockEnd = boundingClientRect.bottom;
    const insetInlineStart = $558545a5feadf817$export$c3f2dc1a1afd265d(element) ? document.documentElement.clientWidth - boundingClientRect.right : boundingClientRect.left;
    const insetInlineEnd = insetInlineStart + inlineSize;
    return {
        blockSize: blockSize,
        inlineSize: inlineSize,
        insetBlockStart: insetBlockStart,
        insetBlockEnd: insetBlockEnd,
        insetInlineStart: insetInlineStart,
        insetInlineEnd: insetInlineEnd
    };
}
function $558545a5feadf817$export$62e2497973acfa99(event) {
    return event.target instanceof HTMLElement && $558545a5feadf817$export$c3f2dc1a1afd265d(event.target) ? document.documentElement.clientWidth - event.pageX : event.pageX;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $9c48dcf56f2dc374$export$e9e0d96f49f57c33;
(function(KeyCode) {
    KeyCode[KeyCode["pageUp"] = 33] = "pageUp";
    KeyCode[KeyCode["pageDown"] = 34] = "pageDown";
    KeyCode[KeyCode["end"] = 35] = "end";
    KeyCode[KeyCode["home"] = 36] = "home";
    KeyCode[KeyCode["backspace"] = 8] = "backspace";
    KeyCode[KeyCode["space"] = 32] = "space";
    KeyCode[KeyCode["down"] = 40] = "down";
    KeyCode[KeyCode["left"] = 37] = "left";
    KeyCode[KeyCode["right"] = 39] = "right";
    KeyCode[KeyCode["up"] = 38] = "up";
    KeyCode[KeyCode["escape"] = 27] = "escape";
    KeyCode[KeyCode["enter"] = 13] = "enter";
    KeyCode[KeyCode["tab"] = 9] = "tab";
    KeyCode[KeyCode["shift"] = 16] = "shift";
    KeyCode[KeyCode["control"] = 17] = "control";
    KeyCode[KeyCode["alt"] = 18] = "alt";
    KeyCode[KeyCode["meta"] = 91] = "meta";
})($9c48dcf56f2dc374$export$e9e0d96f49f57c33 || ($9c48dcf56f2dc374$export$e9e0d96f49f57c33 = {}));
function $9c48dcf56f2dc374$export$90788ad2c69b4f50(event) {
    // we do not want to highlight focused element
    // when special keys are pressed
    return [
        $9c48dcf56f2dc374$export$e9e0d96f49f57c33.shift,
        $9c48dcf56f2dc374$export$e9e0d96f49f57c33.alt,
        $9c48dcf56f2dc374$export$e9e0d96f49f57c33.control,
        $9c48dcf56f2dc374$export$e9e0d96f49f57c33.meta
    ].indexOf(event.keyCode) > -1;
}


function $07cc8ef4b4d5d146$var$setIsKeyboard(active) {
    if (active) document.body.setAttribute("data-awsui-focus-visible", "true");
    else document.body.removeAttribute("data-awsui-focus-visible");
}
function $07cc8ef4b4d5d146$var$handleMousedown() {
    return $07cc8ef4b4d5d146$var$setIsKeyboard(false);
}
function $07cc8ef4b4d5d146$var$handleKeydown(event) {
    if (!(0, $9c48dcf56f2dc374$export$90788ad2c69b4f50)(event)) $07cc8ef4b4d5d146$var$setIsKeyboard(true);
}
let $07cc8ef4b4d5d146$var$componentsCount = 0;
function $07cc8ef4b4d5d146$var$addListeners() {
    document.addEventListener("mousedown", $07cc8ef4b4d5d146$var$handleMousedown);
    document.addEventListener("keydown", $07cc8ef4b4d5d146$var$handleKeydown);
}
function $07cc8ef4b4d5d146$var$removeListeners() {
    document.removeEventListener("mousedown", $07cc8ef4b4d5d146$var$handleMousedown);
    document.removeEventListener("keydown", $07cc8ef4b4d5d146$var$handleKeydown);
}
function $07cc8ef4b4d5d146$export$ffd9e5021c1fb2d6() {
    (0, $acw62.useEffect)(()=>{
        if ($07cc8ef4b4d5d146$var$componentsCount === 0) $07cc8ef4b4d5d146$var$addListeners();
        $07cc8ef4b4d5d146$var$componentsCount++;
        return ()=>{
            $07cc8ef4b4d5d146$var$componentsCount--;
            if ($07cc8ef4b4d5d146$var$componentsCount === 0) $07cc8ef4b4d5d146$var$removeListeners();
        };
    }, []);
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $93d122f201f7d1ff$export$e264257b4e6b5774 = "components";
var $93d122f201f7d1ff$export$4a03ffab3315ee34 = "3.0.0 (df4cffb5)";
var $93d122f201f7d1ff$export$5714e40777c1bcc2 = "open-source-visual-refresh";
var $93d122f201f7d1ff$export$6d52b47269698ace = true;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


const $1306e73bd1cbbb9a$export$976bb239ea6ecef8 = (0, $93d122f201f7d1ff$export$6d52b47269698ace) ? ()=>true : (0, $020c722843a7a503$export$536e98eff356e6c2);


function $c811d3d9d2e4e8a0$export$a15d15518a3ec33d(componentName, config) {
    const theme = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)() ? "vr" : (0, $93d122f201f7d1ff$export$5714e40777c1bcc2);
    (0, $927d1efec68c45ed$export$cebe2da0a47a6ceb)(componentName, {
        packageSource: (0, $93d122f201f7d1ff$export$e264257b4e6b5774),
        packageVersion: (0, $93d122f201f7d1ff$export$4a03ffab3315ee34),
        theme: theme
    }, config);
}



function $970c67f83063979b$export$2e2bcd8739ae039(componentName, config, analyticsMetadata) {
    (0, $c811d3d9d2e4e8a0$export$a15d15518a3ec33d)(componentName, config);
    (0, $07cc8ef4b4d5d146$export$ffd9e5021c1fb2d6)();
    const elementRef = (0, $ccdf93292345e76e$export$9e6be7bb393f4fdd)(componentName, (0, $93d122f201f7d1ff$export$4a03ffab3315ee34), Object.assign({}, analyticsMetadata));
    return {
        __internalRootRef: elementRef
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $4d65e7166b5544ac$export$59475d4ceaadaaa9 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    locale: null,
    format: (_namespace, _component, _key, provided)=>provided
});
function $4d65e7166b5544ac$export$43bb16f9c6d9e3f7() {
    return (0, $acw62.useContext)($4d65e7166b5544ac$export$59475d4ceaadaaa9).locale;
}
function $4d65e7166b5544ac$export$35d4b88fdfc54b46(componentName) {
    const { format: format } = (0, $acw62.useContext)($4d65e7166b5544ac$export$59475d4ceaadaaa9);
    return (key, provided, customHandler)=>{
        return format("@cloudscape-design/components", componentName, key, provided, customHandler);
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var $90a8cbcc33afaf65$export$2e2bcd8739ae039 = {};


(0, $c9df79a03158a684$export$a1cd0337e8f19610)((0, $93d122f201f7d1ff$export$e264257b4e6b5774), (0, $93d122f201f7d1ff$export$4a03ffab3315ee34));
function $75a0355e989dd450$export$a7ec8144096537e7(props) {
    const baseProps = {};
    Object.keys(props).forEach((prop)=>{
        if (prop === "id" || prop === "className" || prop.match(/^data-/)) baseProps[prop] = props[prop];
    });
    return baseProps;
}
function $75a0355e989dd450$export$dba32c398c4b8fa1(props) {
    return props === null || props === void 0 ? void 0 : props.__analyticsMetadata;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $bc3b0639056cd743$export$12dc22cc47108d02(component, displayName) {
    component.displayName = displayName;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $15e6d94060e5d8b6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $15e6d94060e5d8b6$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $15e6d94060e5d8b6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $15e6d94060e5d8b6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15e6d94060e5d8b6$export$2e2bcd8739ae039 = $15e6d94060e5d8b6$export$4f5d2d50c9deca37;



var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Whether the bundle is a development bundle.
 * Only use this in an if condition and on its own! This will help bundlers find
 * and remove the conditional statement for production bundles.
 */ const $bf737c197e11d40f$export$df77466336fe5355 = false;



function $7c41f87eb31b9657$export$454217e89aea72b(controlledValue, handler, defaultValue, { componentName: componentName, changeHandler: changeHandler, controlledProp: controlledProp }) {
    // The decision whether a component is controlled or uncontrolled is made on its first render and cannot be changed afterwards.
    const isControlled = $acw62.useState(controlledValue !== undefined)[0];
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        // Print a warning if the component switches between controlled and uncontrolled mode.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useEffect(()=>{
            if (isControlled && handler === undefined) (0, $dd646455762bc7b9$export$5b28268982f175ba)(componentName, `You provided a \`${controlledProp}\` prop without an \`${changeHandler}\` handler. This will render a non-interactive component.`);
        }, [
            handler,
            isControlled,
            componentName,
            changeHandler,
            controlledProp
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useEffect(()=>{
            const isControlledNow = controlledValue !== undefined;
            if (isControlled !== isControlledNow) {
                const initialMode = isControlled ? "controlled" : "uncontrolled";
                const modeNow = isControlledNow ? "controlled" : "uncontrolled";
                (0, $dd646455762bc7b9$export$5b28268982f175ba)(componentName, `A component tried to change ${initialMode} '${controlledProp}' property to be ${modeNow}. ` + `This is not supported. Properties should not switch from ${initialMode} to ${modeNow} (or vice versa). ` + `Decide between using a controlled or uncontrolled mode for the lifetime of the component. ` + `More info: https://fb.me/react-controlled-components`);
            }
        }, [
            isControlled,
            controlledProp,
            componentName,
            controlledValue
        ]);
    }
    // This is the value that is used if the component is uncontrolled.
    const [valueState, setValue] = $acw62.useState(defaultValue);
    const [valueHasBeenSet, setValueHasBeenSet] = $acw62.useState(false);
    // We track changes to the defaultValue
    const currentUncontrolledValue = valueHasBeenSet ? valueState : defaultValue;
    const setUncontrolledValue = $acw62.useCallback((newValue)=>{
        setValue(newValue);
        setValueHasBeenSet(true);
    }, [
        setValue,
        setValueHasBeenSet
    ]);
    if (isControlled) return [
        controlledValue,
        $7c41f87eb31b9657$var$defaultCallback
    ];
    else return [
        currentUncontrolledValue,
        setUncontrolledValue
    ];
}
function $7c41f87eb31b9657$var$defaultCallback() {
    return void 0;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $1be283cfa47851a8$var$BREAKPOINT_MAPPING = [
    [
        "xl",
        1840
    ],
    [
        "l",
        1320
    ],
    [
        "m",
        1120
    ],
    [
        "s",
        912
    ],
    [
        "xs",
        688
    ],
    [
        "xxs",
        465
    ],
    [
        "default",
        -1
    ]
];
const $1be283cfa47851a8$export$2e65b7c7134e01f0 = $1be283cfa47851a8$var$BREAKPOINT_MAPPING.filter((b)=>b[0] === "xs")[0][1];
const $1be283cfa47851a8$var$BREAKPOINTS_DESCENDING = $1be283cfa47851a8$var$BREAKPOINT_MAPPING.map(([bp])=>bp);
function $1be283cfa47851a8$export$1decca26c2f3798f(subset, actual) {
    const qualifyingBreakpoints = $1be283cfa47851a8$var$BREAKPOINT_MAPPING.slice($1be283cfa47851a8$var$BREAKPOINTS_DESCENDING.indexOf(actual));
    for (const [breakpoint] of qualifyingBreakpoints){
        const breakpointValue = subset[breakpoint];
        if (breakpointValue !== undefined) return breakpointValue;
    }
    return null;
}
function $1be283cfa47851a8$export$21bc4262e291071d(width, breakpointFilter) {
    for (const [breakpoint, breakpointWidth] of $1be283cfa47851a8$var$BREAKPOINT_MAPPING){
        if (width > breakpointWidth && (!breakpointFilter || breakpointFilter.indexOf(breakpoint) !== -1)) return breakpoint;
    }
    return "default";
}
function $1be283cfa47851a8$export$4adb988360925c51(breakpoint) {
    return $1be283cfa47851a8$var$BREAKPOINT_MAPPING.find((bp)=>bp[0] === breakpoint)[1];
}


function $60d79f8943c0bbd8$var$getIsMobile() {
    if (typeof window === "undefined") // assume desktop in server-rendering
    return false;
    if (window.matchMedia) /**
         * Some browsers include the scrollbar width in their media query calculations, but
         * some browsers don't. Thus we can't use `window.innerWidth` or
         * `document.documentElement.clientWidth` to get a very accurate result (since we
         * wouldn't know which one of them to use).
         * Instead, we use the media query here in JS too.
         */ return window.matchMedia(`(max-width: ${(0, $1be283cfa47851a8$export$2e65b7c7134e01f0)}px)`).matches;
    return (0, $1be283cfa47851a8$export$21bc4262e291071d)(window.innerWidth, [
        "xs"
    ]) !== "xs";
}
const $60d79f8943c0bbd8$export$d7da5fa076846028 = (0, $0eab7c44803f46fb$export$415a0fd45cdbcd56)({
    initialState: ()=>$60d79f8943c0bbd8$var$getIsMobile(),
    factory: (handler)=>{
        const listener = ()=>handler($60d79f8943c0bbd8$var$getIsMobile());
        window.addEventListener("resize", listener);
        return ()=>{
            window.removeEventListener("resize", listener);
        };
    }
});


class $fc537b925f715587$var$CustomEventStub {
    constructor(cancelable = false, detail = null){
        this.cancelable = cancelable;
        this.detail = detail;
        this.defaultPrevented = false;
        this.cancelBubble = false;
    }
    preventDefault() {
        this.defaultPrevented = true;
    }
    stopPropagation() {
        this.cancelBubble = true;
    }
}
function $fc537b925f715587$export$1dfc1997f02563ab({ cancelable: cancelable, detail: detail }) {
    return new $fc537b925f715587$var$CustomEventStub(cancelable, detail);
}
function $fc537b925f715587$export$e36a47fa496fb0d2(handler, detail) {
    if (!handler) return;
    const event = $fc537b925f715587$export$1dfc1997f02563ab({
        cancelable: false,
        detail: detail
    });
    handler(event);
}
function $fc537b925f715587$export$d7e1721720edbb03(handler, detail, sourceEvent) {
    if (!handler) return false;
    const event = $fc537b925f715587$export$1dfc1997f02563ab({
        cancelable: true,
        detail: detail
    });
    handler(event);
    if (event.defaultPrevented && sourceEvent) sourceEvent.preventDefault();
    if (event.cancelBubble && sourceEvent) sourceEvent.stopPropagation();
    return event.defaultPrevented;
}
function $fc537b925f715587$export$d23d807e6c464ee0(handler, reactEvent) {
    return $fc537b925f715587$export$d7e1721720edbb03(handler, {
        keyCode: reactEvent.keyCode,
        key: reactEvent.key,
        ctrlKey: reactEvent.ctrlKey,
        shiftKey: reactEvent.shiftKey,
        altKey: reactEvent.altKey,
        metaKey: reactEvent.metaKey
    }, reactEvent);
}
const $fc537b925f715587$var$isMouseEvent = (e)=>{
    return e.button !== undefined;
};
function $fc537b925f715587$export$17ddd23cbcfe5784(event) {
    return event.ctrlKey || event.altKey || event.shiftKey || event.metaKey;
}
function $fc537b925f715587$export$aaf9a36dd84c3909(event) {
    return event && (!$fc537b925f715587$var$isMouseEvent(event) || event.button === 0) && !$fc537b925f715587$export$17ddd23cbcfe5784(event);
}




var $acw62 = parcelRequire("acw62");

var $6cdf4c073ae3a9ed$export$2e2bcd8739ae039 = {
    "notifications": "awsui_notifications_1hmm4_ujmgu_9",
    "notifications-sticky": "awsui_notifications-sticky_1hmm4_ujmgu_10",
    "no-content-paddings": "awsui_no-content-paddings_1hmm4_ujmgu_25"
};



const $6787200e64d912d4$export$36ba2f559d49a8f6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var _b, _c;
    var { sticky: sticky, disableContentPaddings: disableContentPaddings } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "sticky",
        "disableContentPaddings"
    ]);
    return sticky ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $6cdf4c073ae3a9ed$export$2e2bcd8739ae039)["notifications-sticky"],
        style: {
            top: props.topOffset
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "region",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(props.testUtilsClassName, disableContentPaddings && (0, $6cdf4c073ae3a9ed$export$2e2bcd8739ae039)["no-content-paddings"]),
        "aria-label": (_b = props.labels) === null || _b === void 0 ? void 0 : _b.notifications
    }, props.children)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "region",
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(props.testUtilsClassName, (0, $6cdf4c073ae3a9ed$export$2e2bcd8739ae039).notifications, disableContentPaddings && (0, $6cdf4c073ae3a9ed$export$2e2bcd8739ae039)["no-content-paddings"]),
        "aria-label": (_c = props.labels) === null || _c === void 0 ? void 0 : _c.notifications
    }, props.children);
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $e72aa8d9fd756822$export$2e2bcd8739ae039(mainRef, controlRef) {
    (0, $acw62.useImperativeHandle)(mainRef, ()=>({
            focus (...args) {
                var _a;
                (_a = controlRef.current) === null || _a === void 0 || _a.focus(...args);
            }
        }), [
        controlRef
    ]);
}



var $e49660893c408df4$export$2e2bcd8739ae039 = {
    "content": "awsui_content_vjswe_15u39_101",
    "button": "awsui_button_vjswe_15u39_105",
    "variant-normal": "awsui_variant-normal_vjswe_15u39_156",
    "variant-icon": "awsui_variant-icon_vjswe_15u39_199",
    "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_15u39_199",
    "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_15u39_199",
    "variant-inline-icon": "awsui_variant-inline-icon_vjswe_15u39_220",
    "disabled": "awsui_disabled_vjswe_15u39_241",
    "variant-primary": "awsui_variant-primary_vjswe_15u39_248",
    "variant-link": "awsui_variant-link_vjswe_15u39_340",
    "variant-inline-link": "awsui_variant-inline-link_vjswe_15u39_616",
    "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_15u39_896",
    "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_15u39_993",
    "button-no-text": "awsui_button-no-text_vjswe_15u39_1085",
    "button-no-wrap": "awsui_button-no-wrap_vjswe_15u39_1089",
    "full-width": "awsui_full-width_vjswe_15u39_1092",
    "icon-left": "awsui_icon-left_vjswe_15u39_1111",
    "icon-right": "awsui_icon-right_vjswe_15u39_1116",
    "icon": "awsui_icon_vjswe_15u39_1111",
    "link": "awsui_link_vjswe_15u39_1135"
};



var $226dc03e7e835ea6$export$2e2bcd8739ae039 = {
    "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_1ueyk_1gfsc_5"
};





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



var $ac283450f3f763d1$export$2e2bcd8739ae039 = {
    "icon": "awsui_icon_h11ix_ayzd6_101",
    "icon-flex-height": "awsui_icon-flex-height_h11ix_ayzd6_109",
    "size-small": "awsui_size-small_h11ix_ayzd6_134",
    "size-small-mapped-height": "awsui_size-small-mapped-height_h11ix_ayzd6_138",
    "size-normal": "awsui_size-normal_h11ix_ayzd6_153",
    "size-normal-mapped-height": "awsui_size-normal-mapped-height_h11ix_ayzd6_157",
    "size-medium": "awsui_size-medium_h11ix_ayzd6_172",
    "size-medium-mapped-height": "awsui_size-medium-mapped-height_h11ix_ayzd6_176",
    "size-big": "awsui_size-big_h11ix_ayzd6_191",
    "size-big-mapped-height": "awsui_size-big-mapped-height_h11ix_ayzd6_195",
    "size-large": "awsui_size-large_h11ix_ayzd6_210",
    "size-large-mapped-height": "awsui_size-large-mapped-height_h11ix_ayzd6_214",
    "variant-normal": "awsui_variant-normal_h11ix_ayzd6_229",
    "variant-disabled": "awsui_variant-disabled_h11ix_ayzd6_232",
    "variant-inverted": "awsui_variant-inverted_h11ix_ayzd6_235",
    "variant-subtle": "awsui_variant-subtle_h11ix_ayzd6_238",
    "variant-warning": "awsui_variant-warning_h11ix_ayzd6_241",
    "variant-error": "awsui_variant-error_h11ix_ayzd6_244",
    "variant-success": "awsui_variant-success_h11ix_ayzd6_247",
    "variant-link": "awsui_variant-link_h11ix_ayzd6_250",
    "name-angle-left-double": "awsui_name-angle-left-double_h11ix_ayzd6_253",
    "name-angle-left": "awsui_name-angle-left_h11ix_ayzd6_253",
    "name-angle-right-double": "awsui_name-angle-right-double_h11ix_ayzd6_255",
    "name-angle-right": "awsui_name-angle-right_h11ix_ayzd6_255",
    "name-arrow-left": "awsui_name-arrow-left_h11ix_ayzd6_257",
    "name-caret-left-filled": "awsui_name-caret-left-filled_h11ix_ayzd6_258",
    "name-caret-right-filled": "awsui_name-caret-right-filled_h11ix_ayzd6_259",
    "name-audio-full": "awsui_name-audio-full_h11ix_ayzd6_260",
    "name-audio-half": "awsui_name-audio-half_h11ix_ayzd6_261",
    "name-audio-off": "awsui_name-audio-off_h11ix_ayzd6_262",
    "name-external": "awsui_name-external_h11ix_ayzd6_263",
    "name-redo": "awsui_name-redo_h11ix_ayzd6_264",
    "name-resize-area": "awsui_name-resize-area_h11ix_ayzd6_265",
    "name-send": "awsui_name-send_h11ix_ayzd6_266",
    "name-shrink": "awsui_name-shrink_h11ix_ayzd6_267",
    "name-undo": "awsui_name-undo_h11ix_ayzd6_268",
    "name-view-vertical": "awsui_name-view-vertical_h11ix_ayzd6_269",
    "badge": "awsui_badge_h11ix_ayzd6_292"
};



var $acw62 = parcelRequire("acw62");
const $8d972b37456b0691$var$icons = {
    "add-plus": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 1v14M15 8H1"
    })),
    "anchor-link": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 8H5",
        className: "stroke-linecap-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 4H5a4 4 0 0 0 0 8h2M9 4h2a4 4 0 0 1 0 8H9"
    })),
    "angle-down": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m1 4 7 7 7-7"
    })),
    "angle-left-double": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 1 7 8l7 7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 1 2 8l7 7"
    })),
    "angle-left": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 1 5 8l7 7"
    })),
    "angle-right-double": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m2 1 7 7-7 7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m7 1 7 7-7 7"
    })),
    "angle-right": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m4 1 7 7-7 7"
    })),
    "angle-up": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m1 12 7-7 7 7"
    })),
    "arrow-left": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 1 2 8l7 7M2 8h13"
    })),
    "arrow-right": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M1 8h13M7 1l7 7-7 7"
    })),
    "audio-full": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 15V1L1 6v4l6 5ZM15 3v10M11 5v6",
        className: "stroke-linejoin-round"
    })),
    "audio-half": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 15V1L1 6v4l6 5ZM11 5v6",
        className: "stroke-linejoin-round"
    })),
    "audio-off": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 15V1L1 6v4l6 5Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m15.01 5.75-4.5 4.5M15.01 10.25l-4.5-4.5"
    })),
    "bug": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 5h6a1 1 0 0 1 1 1v5.5A3.5 3.5 0 0 1 8.5 15h-1A3.5 3.5 0 0 1 4 11.5V6a1 1 0 0 1 1-1ZM5 5a3 3 0 0 1 6 0",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 9h3M1 9h3M12 12h2l1 2M4 12H2l-1 2M12 6h2l1-2M4 6H2L1 4"
    })),
    "calendar": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 2h12v12H2z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4.99 8H5v.01h-.01zM7.99 8H8v.01h-.01zM10.99 8H11v.01h-.01zM4.99 5H5v.01h-.01zM7.99 5H8v.01h-.01zM10.99 5H11v.01h-.01zM4.99 11H5v.01h-.01zM7.99 11H8v.01h-.01z"
    })),
    "call": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 2c2.8 0 5 2.2 5 5M7.9 13c1.3 1.3 3.5 1.3 4.8 0l1-1c.4-.4.4-1 0-1.4l-1.5-1.5c-.3-.3-1-.2-1.3.1l-.1.1c-.5.5-1.4.5-2 0L6.6 7.2c-.5-.5-.5-1.4 0-2l.1-.1c.3-.3.4-1 .1-1.3L5.3 2.3c-.3-.4-1-.4-1.3 0l-1 1C1.7 4.6 1.7 6.7 3 8.1L7.9 13z"
    })),
    "caret-down-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4 5h8l-4 6-4-6z",
        className: "filled stroke-linejoin-round"
    })),
    "caret-down": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4 5h8l-4 6-4-6z",
        className: "stroke-linejoin-round"
    })),
    "caret-left-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 4v8L5 8l6-4z",
        className: "filled stroke-linejoin-round"
    })),
    "caret-right-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 4v8l6-4-6-4z",
        className: "filled stroke-linejoin-round"
    })),
    "caret-up-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4 11h8L8 5l-4 6z",
        className: "filled stroke-linejoin-round"
    })),
    "caret-up": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4 11h8L8 5l-4 6z",
        className: "stroke-linejoin-round"
    })),
    "check": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m14.254 4.254-8.25 8.25L6 12.5l-.004.004-4.25-4.25.008-.008L6 12.493l8.246-8.247.008.008Z"
    })),
    "close": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m2 2 12 12M14 2 2 14"
    })),
    "contact": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 12.286h5.143L8.857 14l1.714-1.714H14V2H2v10.286z",
        className: "stroke-linejoin-round stroke-linecap-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4.99 7H5v.01h-.01zM7.99 7H8v.01h-.01zM10.99 7H11v.01h-.01z",
        className: "stroke-linecap-round"
    })),
    "copy": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 5h9v9H2z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 5V2h9v9h-3",
        className: "stroke-linejoin-round"
    })),
    "delete-marker": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 7V1h6l5 5v9H9",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 1v6h6M1 15l6-6M7 15 1 9",
        className: "stroke-linejoin-round"
    })),
    "download": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 2h3v12H2V2h3",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m4 6 4 4 4-4M8 1v9"
    })),
    "drag-indicator": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "5.5",
        cy: "2.5",
        r: ".5",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "5.5",
        cy: "13.5",
        r: ".5",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "5.5",
        cy: "8",
        r: ".5",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "10.5",
        cy: "2.5",
        r: ".5",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "10.5",
        cy: "13.5",
        r: ".5",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "10.5",
        cy: "8",
        r: ".5",
        className: "filled"
    })),
    "edit": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8.2 13.9H14v.1H8.1l.1-.1Zm2.37-9.17.7.7-5.3 5.3-.7-.7 5.3-5.3Zm2.71-2.7a.1.1 0 0 1 .14 0l.57.57a.1.1 0 0 1 0 .14l-.58.58-.71-.71.58-.58ZM3.15 12.15l.7.71-.24.24a1 1 0 0 1-.43.26l-.74.2.21-.73a1 1 0 0 1 .26-.44l.24-.24Z",
        className: "filled"
    })),
    "ellipsis": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "2.5",
        r: ".5",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: ".5",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "13.5",
        r: ".5",
        className: "filled"
    })),
    "envelope": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M1 2h14v12H1z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m1 4 7 6 7-6",
        className: "stroke-linejoin-round"
    })),
    "expand": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 2h5v5M7 2H2v5M7 14H2V9M9 14h5V9M2 2l12 12M14 2 2 14"
    })),
    "external": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10 2h4v4",
        className: "stroke-linecap-square"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m6 10 8-8"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 9.048V14H2V2h5",
        className: "stroke-linejoin-round"
    })),
    "file-open": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 1v4a1 1 0 0 0 1 1h4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 15h10V5L9 1H3v14z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m3 8 7 7"
    })),
    "file": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 1v5h5",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 15V1h6l4 4v10H3z",
        className: "stroke-linejoin-round"
    })),
    "filter": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14.986 2.016A.01.01 0 0 0 14.98 2H1.02a.01.01 0 0 0-.007.016l4.984 5.981A.01.01 0 0 1 6 8.004v6.98a.01.01 0 0 0 .014.009l3.98-1.99a.01.01 0 0 0 .006-.01v-4.99c0-.002 0-.004.002-.006l4.984-5.98Z"
    })),
    "flag": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m2.71 9.18 1.11-.39C5.2 8.3 6.74 8.44 8 9.18c1.27.74 2.8.89 4.18.39l1.11-.39v-6l-1.11.39c-1.38.49-2.92.35-4.18-.39-1.27-.74-2.8-.89-4.18-.39l-1.11.39v11.83",
        className: "stroke-linejoin-round"
    })),
    "folder-open": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 7V2h7l1 2h5v9a1 1 0 0 1-1 1H3L1 7h10l2.006 7",
        className: "stroke-linejoin-round"
    })),
    "folder": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 14H2V2h5.143L9 5h5v9z",
        className: "stroke-linejoin-round"
    })),
    "gen-ai": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7.981 1.047a.02.02 0 0 1 .038 0l1.96 4.973 4.974 1.961a.02.02 0 0 1 0 .038L9.98 9.979l-1.961 4.974a.02.02 0 0 1-.038 0L6.021 9.98 1.046 8.019a.02.02 0 0 1 0-.038l4.973-1.96 1.961-4.974Z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m2.5 2.65.045-.095.095-.045-.095-.045L2.5 2.37l-.045.095-.095.045.095.045.045.095Z",
        className: "filled"
    })),
    "group-active": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 4a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM9 11v3h6v-3c0-1.66-1.34-3-3-3s-3 1.34-3 3Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 4a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM1 11v3h6v-3c0-1.66-1.34-3-3-3s-3 1.34-3 3Z",
        className: "filled stroke-linejoin-round"
    })),
    "group": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 4a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM9 11v3h6v-3c0-1.66-1.34-3-3-3s-3 1.34-3 3ZM6 4a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM1 11v3h6v-3c0-1.66-1.34-3-3-3s-3 1.34-3 3Z",
        className: "stroke-linejoin-round"
    })),
    "heart-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13.92 3.061a3.73 3.73 0 0 0-5.21 0L8 3.76l-.71-.699a3.729 3.729 0 0 0-5.21 0 3.58 3.58 0 0 0 0 5.123l5.21 5.124.003-.004L8 14l.707-.696.004.004 5.21-5.124a3.58 3.58 0 0 0-.001-5.123Z",
        className: "filled"
    })),
    "heart": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13.92 3.061a3.729 3.729 0 0 0-5.21 0L8 3.76l-.71-.699a3.729 3.729 0 0 0-5.21 0 3.58 3.58 0 0 0 0 5.123l5.21 5.124.003-.004L8 14l.707-.696.004.004 5.21-5.124a3.58 3.58 0 0 0 0-5.123Z"
    })),
    "insert-row": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 6V3H1v9h5M16 11H8M12 15V7",
        className: "stroke-linejoin-round"
    })),
    "key": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 10a5.023 5.023 0 0 1 0 1 3.996 3.996 0 1 1-3-3.874L13 1h2v5h-2v2h-2l.016 1.983Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4.99 11H5v.01h-.01z"
    })),
    "keyboard": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 2H1v12h14V2Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 5H4M9 5H7M12 5h-2M6 8H4M12 11H4M9 8H7M12 8h-2"
    })),
    "lock-private": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 7h12v7H2z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4 7V5a4 4 0 0 1 8 0v2"
    })),
    "menu": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 8H1M15 3H1M15 13H1"
    })),
    "microphone-off": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13.76 1.34 2.11 12.98M4.75 10.8A5.002 5.002 0 0 0 13 7V6M8 15v-3M3 15h10",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 1c-1.1 0-2 .9-2 2v1.09l2.88-2.88C8.61 1.08 8.32 1 8 1ZM6.64 8.46A2 2 0 0 0 8 9c1.1 0 2-.9 2-2V5.09L6.64 8.45v.01Z",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3.37 8.53C3.024 8.184 3 7.537 3 7V6",
        className: "stroke-linejoin-round"
    })),
    "microphone": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "6",
        y: "1",
        width: "4",
        height: "8",
        rx: "2",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 6v1a5 5 0 0 0 10 0V6M8 12v3M3 15h10",
        className: "stroke-linejoin-round"
    })),
    "multiscreen": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 5H1v7h10V5Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 8.229h4v-7H5V5M1 15h10M6 15v-3",
        className: "stroke-linejoin-round"
    })),
    "notification": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 2.167c-3.5 0-3.5 4.666-3.5 4.666L1 11.5h14l-3.5-4.667s0-4.666-3.5-4.666ZM5.667 11.5v1.167a2.333 2.333 0 0 0 4.666 0V11.5",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 1v1.167",
        className: "stroke-linecap-round"
    })),
    "redo": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 5H6.38c-4.5 0-4.5 8 0 8H13",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m10 8 3-3-3-3",
        className: "stroke-linejoin-round"
    })),
    "refresh": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10 5h5V0"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15 8a6.957 6.957 0 0 1-7 7 6.957 6.957 0 0 1-7-7 6.957 6.957 0 0 1 7-7 6.87 6.87 0 0 1 6.3 4"
    })),
    "remove": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m3 3 1 11h8l1-11H3ZM1 3h14M10 2H6v1h4V2Z",
        className: "stroke-linejoin-round"
    })),
    "resize-area": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m9.5 14.5 5-5M4 14.5 14.5 4"
    })),
    "script": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 17",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m9.53 4.397-3.06 7.4M4.5 11.597 1 8.097l3.5-3.5M11.5 11.597l3.5-3.5-3.5-3.5",
        className: "stroke-linejoin-round"
    })),
    "search": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "7",
        cy: "7",
        r: "5"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m15 15-4.5-4.5"
    })),
    "security": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 14.83s-6-1.925-6-6.74V3.265c3.31 0 5.99-1.916 5.99-1.916s2.7 1.916 6.01 1.916V8.09c0 4.815-6 6.74-6 6.74Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 8.09V3.265c3.31 0 5.99-1.916 5.99-1.916M13.99 8.09V3.265C10.68 3.265 8 1.35 8 1.35"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 4v5M8 10v2",
        className: "stroke-linejoin-round"
    })),
    "send": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m1 1.001 14 7.004L1 15l2.693-6.994L1 1.001ZM3.693 8.005h10.271",
        className: "stroke-linejoin-round"
    })),
    "settings": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13.33 5.792a1.942 1.942 0 0 1 .287-1.97 6.984 6.984 0 0 0-1.44-1.439 1.943 1.943 0 0 1-3.159-1.308 6.965 6.965 0 0 0-2.037 0 1.943 1.943 0 0 1-3.158 1.308 6.962 6.962 0 0 0-1.44 1.44 1.943 1.943 0 0 1-1.308 3.158 6.972 6.972 0 0 0 0 2.037 1.943 1.943 0 0 1 1.308 3.159 6.952 6.952 0 0 0 1.44 1.44 1.942 1.942 0 0 1 3.159 1.308 6.962 6.962 0 0 0 2.036 0 1.942 1.942 0 0 1 3.159-1.308 6.974 6.974 0 0 0 1.44-1.44 1.943 1.943 0 0 1 1.308-3.159 6.974 6.974 0 0 0 0-2.037 1.942 1.942 0 0 1-1.596-1.189Z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "2"
    })),
    "share": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "11",
        cy: "4",
        r: "2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "4",
        cy: "8",
        r: "2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "11",
        cy: "12",
        r: "2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9.2 4.9 5.8 7.1M9.2 11.1 5.8 8.9"
    })),
    "shrink": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10 1v5h5M10 6l5-5M6 15v-5H1M6 10l-5 5"
    })),
    "star-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m8 1 2.16 4.61 4.84.74-3.5 3.58.83 5.07L8 12.61 3.67 15l.83-5.07L1 6.35l4.84-.74L8 1z",
        className: "filled stroke-linejoin-round stroke-linecap-round"
    })),
    "star-half": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m8 1 2.16 4.61 4.84.74-3.5 3.58.83 5.07L8 12.61 3.67 15l.83-5.07L1 6.35l4.84-.74L8 1z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 12.61 3.67 15l.83-5.07L1 6.35l4.84-.74L8 1v11.61z",
        className: "filled"
    })),
    "star": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m8 1 2.16 4.61 4.84.74-3.5 3.58.83 5.07L8 12.61 3.67 15l.83-5.07L1 6.35l4.84-.74L8 1z",
        className: "stroke-linejoin-round stroke-linecap-round"
    })),
    "status-in-progress": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4.99 7.995H5v.01h-.01zM7.99 7.995H8v.01h-.01zM10.99 7.995H11v.01h-.01z",
        className: "stroke-linecap-round"
    })),
    "status-info": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 11V8H6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10 11H6",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7.99 5H8v.01h-.01z"
    })),
    "status-negative": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m10.828 5.172-5.656 5.656M10.828 10.828 5.172 5.172"
    })),
    "status-pending": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 5v4H5",
        className: "stroke-linecap-square"
    })),
    "status-positive": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m5 8 2 2 3.521-3.521",
        className: "stroke-linecap-square"
    })),
    "status-stopped": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 8H5",
        className: "stroke-linecap-square"
    })),
    "status-warning": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m8 1 7 14H1L8 1z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7.99 12H8v.01h-.01zM8 6v4"
    })),
    "subtract-minus": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M1 8h14"
    })),
    "suggestions": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 14h4",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 11h1c0-1.53 3-2.46 3-5.24.02-1.36-.61-2.4-1.57-3.09a4.208 4.208 0 0 0-4.86 0C4.61 3.36 3.98 4.4 4 5.76 4 8.54 7 9.47 7 11h1Z"
    })),
    "thumbs-down-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 9.58c0 .27.06.55.19.79l1.64 3.28c.1.21.32.34.55.34.34 0 .62-.28.62-.62v-3.33h3.44a2 2 0 0 0 1.94-2.48l-1.01-4.05a2 2 0 0 0-1.94-1.52H6v7.59Z",
        className: "filled stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 2H2v7h4",
        className: "stroke-linejoin-round"
    })),
    "thumbs-down": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 9.58c0 .27.06.55.19.79l1.64 3.28c.1.21.32.34.55.34.34 0 .62-.28.62-.62v-3.33h3.44a2 2 0 0 0 1.94-2.48l-1.01-4.05a2 2 0 0 0-1.94-1.52H6v7.59ZM6 2H2v7h4",
        className: "stroke-linejoin-round"
    })),
    "thumbs-up-filled": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 6.42c0-.27.06-.55.19-.79l1.64-3.28c.1-.21.32-.34.55-.34.34 0 .62.28.62.62v3.33h3.44a2 2 0 0 1 1.94 2.48l-1.01 4.05a2 2 0 0 1-1.94 1.52H6V6.42Z",
        className: "filled stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 14H2V7h4",
        className: "stroke-linejoin-round"
    })),
    "thumbs-up": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 6.42c0-.27.06-.55.19-.79l1.64-3.28c.1-.21.32-.34.55-.34.34 0 .62.28.62.62v3.33h3.44a2 2 0 0 1 1.94 2.48l-1.01 4.05a2 2 0 0 1-1.94 1.52H6V6.42ZM6 14H2V7h4",
        className: "stroke-linejoin-round"
    })),
    "ticket": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 4.275a2 2 0 0 1-2-2H3v12h3a2 2 0 1 1 4 0h3v-12h-3a2 2 0 0 1-2 2Z",
        className: "stroke-linejoin-round"
    })),
    "treeview-collapse": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 8h6M2 2h12v12H2z",
        className: "stroke-linejoin-round"
    })),
    "treeview-expand": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 8h6M8 11V5M2 2h12v12H2z",
        className: "stroke-linejoin-round"
    })),
    "undo": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4 13h5.625c4.5 0 4.5-8 0-8H3",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M6 2 3 5l3 3",
        className: "stroke-linejoin-round"
    })),
    "unlocked": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 7h12v7H2z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11.874 4A4 4 0 0 0 4 5v2"
    })),
    "upload-download": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 13.701v-10M8 6.702l3-3 3 3M4.98 2.662v10.04M7.98 9.662l-3 3-3-3"
    })),
    "upload": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 14H2V2h12v12h-3",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 10 8 6l-4 4M8 6v9"
    })),
    "user-profile-active": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4.61 4.39C4.61 2.52 6.13 1 8 1s3.39 1.52 3.39 3.39S9.87 7.78 8 7.78 4.61 6.26 4.61 4.39M2.05 14.08h11.91c0-2.25-1.17-4.23-2.9-5.3A5.77 5.77 0 0 0 8 7.91c-3.29 0-5.95 2.76-5.95 6.17z",
        className: "filled stroke-linejoin-round"
    })),
    "user-profile": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4.61 4.39C4.61 2.52 6.13 1 8 1s3.39 1.52 3.39 3.39S9.87 7.78 8 7.78 4.61 6.26 4.61 4.39M2.05 14.08h11.91c0-2.25-1.17-4.23-2.9-5.3A5.77 5.77 0 0 0 8 7.91c-3.29 0-5.95 2.76-5.95 6.17z",
        className: "stroke-linejoin-round"
    })),
    "video-off": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 15h10M8 15v-3M8 12A5 5 0 1 0 8 2a5 5 0 0 0 0 10ZM6 5l4 4M10 5 6 9",
        className: "stroke-linejoin-round"
    })),
    "video-on": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 15h10M8 15v-3M8 12A5 5 0 1 0 8 2a5 5 0 0 0 0 10Z",
        className: "stroke-linejoin-round"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        className: "stroke-linejoin-round"
    })),
    "video-unavailable": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3 15h10M8 15v-3M8 12A5 5 0 1 0 8 2a5 5 0 0 0 0 10ZM5.5 7h5",
        className: "stroke-linejoin-round"
    })),
    "view-full": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 5h6v6H5z",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 2h12v12H2z",
        className: "stroke-linejoin-round"
    })),
    "view-horizontal": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 9h6v2H5z",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 2h12v12H2z",
        className: "stroke-linejoin-round"
    })),
    "view-vertical": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11 5v6H9V5z",
        className: "filled"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2 2h12v12H2z",
        className: "stroke-linejoin-round"
    })),
    "zoom-in": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "6.885",
        cy: "6.885",
        r: "5.385"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m14.5 14.5-3.846-3.846M7 4v6M10 7H4"
    })),
    "zoom-out": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "6.885",
        cy: "6.885",
        r: "5.385"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m14.5 14.5-3.846-3.846M10 7H4"
    })),
    "zoom-to-fit": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 11v3h-4M2 11v3h4M2 5V2h4M14 5V2h-4M10 6H6v4h4V6Z"
    }))
};
var $8d972b37456b0691$export$2e2bcd8739ae039 = $8d972b37456b0691$var$icons;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $adb603d9351d0211$export$74665b213cb5c4cf(...refs) {
    return (0, $acw62.useMemo)(()=>{
        if (refs.every((ref)=>ref === null || ref === undefined)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === "function") ref(value);
                else if (ref !== null && ref !== undefined) ref.current = value;
            });
        };
    // ESLint expects an array literal which we can not provide here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}



function $4ede5ec7997eb329$var$iconSizeMap(height) {
    if (height === null) // This is the best guess for the contextual height while server rendering.
    return "normal";
    if (height >= 50) return "large";
    else if (height >= 36) return "big";
    else if (height >= 24) return "medium";
    else if (height <= 16) return "small";
    else return "normal";
}
const $4ede5ec7997eb329$var$InternalIcon = (_a)=>{
    var { name: name, size: size = "normal", variant: variant = "normal", url: url, alt: alt, svg: svg, badge: badge, __internalRootRef: __internalRootRef = null } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "name",
        "size",
        "variant",
        "url",
        "alt",
        "svg",
        "badge",
        "__internalRootRef"
    ]);
    const iconRef = (0, $acw62.useRef)(null);
    // To ensure a re-render is triggered on visual mode changes
    (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const [parentHeight, setParentHeight] = (0, $acw62.useState)(null);
    const contextualSize = size === "inherit";
    const iconSize = contextualSize ? $4ede5ec7997eb329$var$iconSizeMap(parentHeight) : size;
    const inlineStyles = contextualSize && parentHeight !== null ? {
        height: `${parentHeight}px`
    } : {};
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    baseProps.className = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $ac283450f3f763d1$export$2e2bcd8739ae039).icon, contextualSize && (0, $ac283450f3f763d1$export$2e2bcd8739ae039)["icon-flex-height"], badge && (0, $ac283450f3f763d1$export$2e2bcd8739ae039).badge, !contextualSize && (0, $ac283450f3f763d1$export$2e2bcd8739ae039)[`size-${iconSize}-mapped-height`], (0, $ac283450f3f763d1$export$2e2bcd8739ae039)[`size-${iconSize}`], (0, $ac283450f3f763d1$export$2e2bcd8739ae039)[`variant-${variant}`], (0, $ac283450f3f763d1$export$2e2bcd8739ae039)[`name-${name}`]);
    // Possible infinite loop is not a concern here because line
    // height should not change without an external state update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $acw62.useLayoutEffect)(()=>{
        if (!contextualSize || !iconRef.current) return;
        const { lineHeight: lineHeight } = getComputedStyle(iconRef.current);
        const newParentHeight = parseInt(lineHeight, 10);
        setParentHeight(newParentHeight);
    });
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(iconRef, __internalRootRef);
    if (svg) {
        if (url) (0, $dd646455762bc7b9$export$5b28268982f175ba)("Icon", "You have specified both `url` and `svg`. `svg` will take precedence and `url` will be ignored.");
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, baseProps, {
            ref: mergedRef,
            "aria-hidden": "true",
            style: inlineStyles
        }), svg);
    }
    if (url) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, baseProps, {
        ref: mergedRef,
        style: inlineStyles
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: url,
        alt: alt
    }));
    const validIcon = name && Object.prototype.hasOwnProperty.call((0, $8d972b37456b0691$export$2e2bcd8739ae039), name);
    function iconMap(name) {
        if (name === "gen-ai" && iconSize === "small") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            focusable: "false",
            "aria-hidden": "true",
            "data-testid": "gen-ai-filled"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "m8 4.4 1.018 2.582L11.6 8 9.018 9.018 8 11.6 6.982 9.018 4.4 8l2.582-1.018L8 4.4ZM2.405 2.41l.002-.003.003-.002-.003-.002-.002-.003-.002.003-.003.002.003.002.002.003Z",
            className: "filled"
        }));
        else return (0, $8d972b37456b0691$export$2e2bcd8739ae039)[name];
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, baseProps, {
        ref: mergedRef,
        style: inlineStyles
    }), validIcon ? iconMap(name) : undefined);
};
var $4ede5ec7997eb329$export$2e2bcd8739ae039 = $4ede5ec7997eb329$var$InternalIcon;





var $acw62 = parcelRequire("acw62");


var $7a3ef8fc211697e7$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1612d_andhz_131",
    "spinner-rotator": "awsui_spinner-rotator_1612d_andhz_1",
    "size-normal": "awsui_size-normal_1612d_andhz_146",
    "size-big": "awsui_size-big_1612d_andhz_154",
    "size-large": "awsui_size-large_1612d_andhz_162",
    "variant-normal": "awsui_variant-normal_1612d_andhz_170",
    "variant-disabled": "awsui_variant-disabled_1612d_andhz_173",
    "variant-inverted": "awsui_variant-inverted_1612d_andhz_176",
    "circle": "awsui_circle_1612d_andhz_188",
    "circle-left": "awsui_circle-left_1612d_andhz_216",
    "spinner-line-left": "awsui_spinner-line-left_1612d_andhz_1",
    "circle-right": "awsui_circle-right_1612d_andhz_221",
    "spinner-line-right": "awsui_spinner-line-right_1612d_andhz_1"
};


function $1101525b84777b8e$export$2e2bcd8739ae039(_a) {
    var { size: size = "normal", variant: variant = "normal", __internalRootRef: __internalRootRef } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "size",
        "variant",
        "__internalRootRef"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $7a3ef8fc211697e7$export$2e2bcd8739ae039).root, (0, $7a3ef8fc211697e7$export$2e2bcd8739ae039)[`size-${size}`], (0, $7a3ef8fc211697e7$export$2e2bcd8739ae039)[`variant-${variant}`]),
        ref: __internalRootRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7a3ef8fc211697e7$export$2e2bcd8739ae039).circle, (0, $7a3ef8fc211697e7$export$2e2bcd8739ae039)["circle-left"])
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7a3ef8fc211697e7$export$2e2bcd8739ae039).circle, (0, $7a3ef8fc211697e7$export$2e2bcd8739ae039)["circle-right"])
    }));
}



function $c055d7846609c581$var$getIconAlign(props) {
    const standalone = props.variant === "icon" || props.variant === "inline-icon";
    return standalone ? "left" : props.iconAlign;
}
function $c055d7846609c581$var$IconWrapper(_a) {
    var { iconName: iconName, iconUrl: iconUrl, iconAlt: iconAlt, iconSvg: iconSvg, iconSize: iconSize, badge: badge } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "iconName",
        "iconUrl",
        "iconAlt",
        "iconSvg",
        "iconSize",
        "badge"
    ]);
    if (!iconName && !iconUrl && !iconSvg) return null;
    return $acw62.createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $e49660893c408df4$export$2e2bcd8739ae039).icon, (0, $e49660893c408df4$export$2e2bcd8739ae039)[`icon-${$c055d7846609c581$var$getIconAlign(props)}`], props.iconClass),
        name: iconName,
        url: iconUrl,
        svg: iconSvg,
        alt: iconAlt,
        size: iconSize,
        badge: badge
    });
}
function $c055d7846609c581$export$c5a3a065f2cddabb(props) {
    if (props.loading) return $acw62.createElement((0, $1101525b84777b8e$export$2e2bcd8739ae039), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $e49660893c408df4$export$2e2bcd8739ae039).icon, (0, $e49660893c408df4$export$2e2bcd8739ae039)["icon-left"])
    });
    else if ($c055d7846609c581$var$getIconAlign(props) === "left") return $acw62.createElement($c055d7846609c581$var$IconWrapper, Object.assign({}, props));
    return null;
}
function $c055d7846609c581$export$990119d7b3385d31(props) {
    if ($c055d7846609c581$var$getIconAlign(props) === "right") return $acw62.createElement($c055d7846609c581$var$IconWrapper, Object.assign({}, props));
    return null;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $3de0f29144bb4e85$var$allowedJavascriptUrls = [
    "javascript:void(0)",
    "javascript:void(0);",
    "javascript:;"
];
function $3de0f29144bb4e85$export$6661f6891a200a5f(component, url) {
    if (!url) return;
    if ($3de0f29144bb4e85$var$allowedJavascriptUrls.indexOf(url.toLowerCase()) !== -1) return;
    let parsedUrl;
    try {
        parsedUrl = new URL(url);
    } catch (e) {
        // If the URL cannot be parsed by the browser, it likely does not pose a security risk.
        return;
    }
    if (parsedUrl.protocol === "javascript:") {
        (0, $dd646455762bc7b9$export$5b28268982f175ba)(component, `A javascript: URL was blocked as a security precaution. The URL was "${url}".`);
        // This mirrors the error message that React will use:
        // https://github.com/facebook/react/blob/a724a3b578dce77d427bef313102a4d0e978d9b4/packages/react-dom/src/shared/sanitizeURL.js#L30
        throw new Error(`A javascript: URL was blocked as a security precaution.`);
    }
    return;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");

var $710f0a879f8b63c2$export$2e2bcd8739ae039 = {
    "root": "awsui_root_xttbq_1fuh1_97"
};


function $b8469ab82402f2dd$export$2e2bcd8739ae039(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, props, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $710f0a879f8b63c2$export$2e2bcd8739ae039).root, props.className)
    }));
}



var $f8a3880947574dfb$export$2e2bcd8739ae039 = {
    "root": "awsui_root_3bgfn_64bxr_5",
    "source": "awsui_source_3bgfn_64bxr_9"
};


var /**
 * The live region is hidden in the layout, but visible for screen readers.
 * It's purpose it to announce changes e.g. when custom navigation logic is used.
 *
 * The way live region works differently in different browsers and screen readers and
 * it is recommended to manually test every new implementation.
 *
 * If you notice there are different words being merged together,
 * check if there are text nodes not being wrapped in elements, like:
 * ```
 * <LiveRegion>
 *   {title}
 *   <span><Details /></span>
 * </LiveRegion>
 * ```
 *
 * To fix, wrap "title" in an element:
 * ```
 * <LiveRegion>
 *   <span>{title}</span>
 *   <span><Details /></span>
 * </LiveRegion>
 * ```
 *
 * Or create a single text node if possible:
 * ```
 * <LiveRegion>
 *   {`${title} ${details}`}
 * </LiveRegion>
 * ```
 *
 * The live region is always atomic, because non-atomic regions can be treated by screen readers
 * differently and produce unexpected results. To imitate non-atomic announcements simply use
 * multiple live regions:
 * ```
 * <>
 *   <LiveRegion>{title}</LiveRegion>
 *   <LiveRegion><Details /></LiveRegion>
 * </>
 * ```
 *
 * If you place interactive content inside the LiveRegion, the content will still be
 * interactive (e.g. as a tab stop). Consider using the `source` property instead.
 */ $c27ae43b338ed19e$export$2e2bcd8739ae039 = (0, $acw62.memo)($c27ae43b338ed19e$var$LiveRegion);
function $c27ae43b338ed19e$var$LiveRegion(_a) {
    var { assertive: assertive = false, delay: delay = 10, visible: visible = false, tagName: TagName = "span", children: children, id: id, source: source } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "assertive",
        "delay",
        "visible",
        "tagName",
        "children",
        "id",
        "source"
    ]);
    const sourceRef = (0, $acw62.useRef)(null);
    const targetRef = (0, $acw62.useRef)(null);
    /*
      When React state changes, React often produces too many DOM updates, causing NVDA to
      issue many announcements for the same logical event (See https://github.com/nvaccess/nvda/issues/7996).
  
      The code below imitates a debouncing, scheduling a callback every time new React state
      update is detected. When a callback resolves, it copies content from a muted element
      to the live region, which is recognized by screen readers as an update.
  
      If the use case requires no announcement to be ignored, use delay = 0, but ensure it
      does not impact the performance. If it does, prefer using a string as children prop.
    */ (0, $acw62.useEffect)(()=>{
        function getSourceContent() {
            if (source) return source.map((item)=>{
                if (!item) return undefined;
                if (typeof item === "string") return item;
                if (item.current) return $c27ae43b338ed19e$var$extractInnerText(item.current);
            }).filter(Boolean).join(" ");
            if (sourceRef.current) return $c27ae43b338ed19e$var$extractInnerText(sourceRef.current);
        }
        function updateLiveRegion() {
            const sourceContent = getSourceContent();
            if (targetRef.current && sourceContent) {
                const targetContent = $c27ae43b338ed19e$var$extractInnerText(targetRef.current);
                if (targetContent !== sourceContent) // The aria-atomic does not work properly in Voice Over, causing
                // certain parts of the content to be ignored. To fix that,
                // we assign the source text content as a single node.
                targetRef.current.innerText = sourceContent;
            }
        }
        let timeoutId;
        if (delay) timeoutId = setTimeout(updateLiveRegion, delay);
        else updateLiveRegion();
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, visible && !source && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TagName, {
        ref: sourceRef,
        id: id,
        className: (0, $f8a3880947574dfb$export$2e2bcd8739ae039).source
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b8469ab82402f2dd$export$2e2bcd8739ae039), Object.assign({}, restProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f8a3880947574dfb$export$2e2bcd8739ae039).root, restProps.className)
    }), !visible && !source && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TagName, {
        ref: sourceRef,
        "aria-hidden": "true",
        className: (0, $f8a3880947574dfb$export$2e2bcd8739ae039).source
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: targetRef,
        "aria-atomic": "true",
        "aria-live": assertive ? "assertive" : "polite"
    })));
}
// This only extracts text content from the node including all its children which is enough for now.
// To make it more powerful, it is possible to create a more sophisticated extractor with respect to
// ARIA properties to ignore aria-hidden nodes and read ARIA labels from the live content.
function $c27ae43b338ed19e$var$extractInnerText(node) {
    return (node.innerText || "").replace(/\s+/g, " ").trim();
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $edea5ac281b34b48$export$24d547caef80ccd1 = (0, $acw62.createContext)({
    onClick: ()=>{}
});
function $edea5ac281b34b48$export$d891409b33cf7746() {
    return (0, $acw62.useContext)($edea5ac281b34b48$export$24d547caef80ccd1);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $285a09b860d2bebc$export$367d27e950572013 = "data-analytics-funnel";
const $285a09b860d2bebc$export$6f6189a197458f7a = `${$285a09b860d2bebc$export$367d27e950572013}-interaction-id`;
const $285a09b860d2bebc$export$22b484224f7ab69a = `${$285a09b860d2bebc$export$367d27e950572013}-key`;
const $285a09b860d2bebc$export$39e42cde97dfcad = `${$285a09b860d2bebc$export$367d27e950572013}-value`;
const $285a09b860d2bebc$export$35cc9e5d8841ad00 = `${$285a09b860d2bebc$export$367d27e950572013}-step`;
const $285a09b860d2bebc$export$e4865c712b63120 = `${$285a09b860d2bebc$export$367d27e950572013}-substep`;
const $285a09b860d2bebc$export$7f7018c0ba6d811a = "data-analytics-field-label";
const $285a09b860d2bebc$export$374a078abad6179f = "data-analytics-field-error";
const $285a09b860d2bebc$export$886c79e627389031 = "data-analytics-alert";
const $285a09b860d2bebc$export$5acc5b69fd3e0afc = "data-analytics-flashbar";
const $285a09b860d2bebc$export$f707bfc38f5d283 = "funnel-name";
const $285a09b860d2bebc$export$5a2a1cf91319a1cd = "step-name";
const $285a09b860d2bebc$export$7eef17de8ae91f78 = "substep-name";
const $285a09b860d2bebc$export$3e712eeacbba81a0 = ()=>`[${$285a09b860d2bebc$export$22b484224f7ab69a}="${$285a09b860d2bebc$export$f707bfc38f5d283}"]`;
const $285a09b860d2bebc$export$984fbea25848566f = (key)=>`[${$285a09b860d2bebc$export$22b484224f7ab69a}="${key}"]`;
const $285a09b860d2bebc$export$c0773214960ddccc = (value)=>`[${$285a09b860d2bebc$export$39e42cde97dfcad}="${value}"]`;
const $285a09b860d2bebc$export$57dc544ae10998c7 = ()=>`[${$285a09b860d2bebc$export$e4865c712b63120}]`;
const $285a09b860d2bebc$export$ee83c691e298510a = (subStepId)=>`[${$285a09b860d2bebc$export$e4865c712b63120}="${subStepId}"]`;
const $285a09b860d2bebc$export$d82de5788b5a2d19 = (subStepId)=>[
        subStepId ? $285a09b860d2bebc$export$ee83c691e298510a(subStepId) : "",
        `[${$285a09b860d2bebc$export$22b484224f7ab69a}="${$285a09b860d2bebc$export$7eef17de8ae91f78}"]`
    ].join(" ");
const $285a09b860d2bebc$export$9b7aa6f73a756b51 = (id)=>id ? `[id="${id}"]` : undefined;
const $285a09b860d2bebc$export$ad08a5942dca04f8 = (selector)=>{
    var _a, _b;
    return selector ? (_b = (_a = document.querySelector(selector)) === null || _a === void 0 ? void 0 : _a.innerText) === null || _b === void 0 ? void 0 : _b.trim() : undefined;
};


const $2c7360a12f6b0b92$export$7a5dd0cfd3639f1b = (0, $acw62.createContext)({
    funnelInteractionId: undefined,
    funnelNameSelector: (0, $285a09b860d2bebc$export$3e712eeacbba81a0)(),
    setFunnelInteractionId: ()=>{},
    funnelType: "single-page",
    optionalStepNumbers: [],
    totalFunnelSteps: 0,
    funnelSubmit: ()=>{},
    funnelCancel: ()=>{},
    submissionAttempt: 0,
    funnelNextOrSubmitAttempt: ()=>{},
    funnelState: {
        current: "default"
    },
    errorCount: {
        current: 0
    },
    loadingButtonCount: {
        current: 0
    },
    latestFocusCleanupFunction: {
        current: undefined
    },
    isInFunnel: false,
    wizardCount: {
        current: 0
    }
});
const $2c7360a12f6b0b92$export$8b0d9233e68df2ee = (0, $acw62.createContext)({
    stepNameSelector: "",
    stepNumber: 0,
    subStepCount: {
        current: 0
    },
    isInStep: false,
    funnelInteractionId: undefined,
    onStepChange: ()=>{},
    subStepConfiguration: {
        current: new Map()
    }
});
const $2c7360a12f6b0b92$export$3030a14ef22dab15 = (0, $acw62.createContext)({
    subStepId: "",
    subStepSelector: "",
    subStepNameSelector: "",
    subStepRef: {
        current: null
    },
    isNestedSubStep: false,
    mousePressed: {
        current: false
    },
    isFocusedSubStep: {
        current: false
    },
    focusCleanupFunction: {
        current: undefined
    }
});
const $2c7360a12f6b0b92$export$6763bc96d4aa4bf8 = (0, $acw62.createContext)(undefined);



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/* istanbul ignore file */ function $54d511b0978bc73c$export$ccbd7b3cec4e5298(funnelMetrics) {
    $54d511b0978bc73c$export$300ddd9f131af3a = funnelMetrics;
}
function $54d511b0978bc73c$export$91f5f1215e029975(performanceMetrics) {
    $54d511b0978bc73c$export$68015ba807c17f26 = performanceMetrics;
}
let $54d511b0978bc73c$export$300ddd9f131af3a = {
    funnelStart () {
        return "";
    },
    funnelError () {},
    funnelComplete () {},
    funnelSuccessful () {},
    funnelCancelled () {},
    funnelChange () {},
    funnelStepStart () {},
    funnelStepComplete () {},
    funnelStepNavigation () {},
    funnelStepError () {},
    funnelStepChange () {},
    funnelSubStepStart () {},
    funnelSubStepComplete () {},
    funnelSubStepError () {},
    helpPanelInteracted () {},
    externalLinkInteracted () {}
};
let $54d511b0978bc73c$export$68015ba807c17f26 = {
    tableInteraction () {}
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $30933cb119085804$exports = {};
"use strict";
$30933cb119085804$exports = $30933cb119085804$var$balanced;
function $30933cb119085804$var$balanced(a, b, str) {
    if (a instanceof RegExp) a = $30933cb119085804$var$maybeMatch(a, str);
    if (b instanceof RegExp) b = $30933cb119085804$var$maybeMatch(b, str);
    var r = $30933cb119085804$var$range(a, b, str);
    return r && {
        start: r[0],
        end: r[1],
        pre: str.slice(0, r[0]),
        body: str.slice(r[0] + a.length, r[1]),
        post: str.slice(r[1] + b.length)
    };
}
function $30933cb119085804$var$maybeMatch(reg, str) {
    var m = str.match(reg);
    return m ? m[0] : null;
}
$30933cb119085804$var$balanced.range = $30933cb119085804$var$range;
function $30933cb119085804$var$range(a, b, str) {
    var begs, beg, left, right, result;
    var ai = str.indexOf(a);
    var bi = str.indexOf(b, ai + 1);
    var i = ai;
    if (ai >= 0 && bi > 0) {
        if (a === b) return [
            ai,
            bi
        ];
        begs = [];
        left = str.length;
        while(i >= 0 && !result){
            if (i == ai) {
                begs.push(i);
                ai = str.indexOf(a, i + 1);
            } else if (begs.length == 1) result = [
                begs.pop(),
                bi
            ];
            else {
                beg = begs.pop();
                if (beg < left) {
                    left = beg;
                    right = bi;
                }
                bi = str.indexOf(b, i + 1);
            }
            i = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length) result = [
            left,
            right
        ];
    }
    return result;
}


function $38f6480185c49d6f$export$184ef262a758e3c4(node, callback) {
    let current = node;
    while(current && !callback(current)){
        current = current.parentElement;
        // If a component is used within an svg (i.e. as foreignObject), then it will
        // have some ancestor nodes that are SVGElement. We want to skip those,
        // as they have very different properties to HTMLElements.
        while(current && !(current instanceof HTMLElement))current = current.parentElement;
    }
    return current;
}
function $38f6480185c49d6f$export$940d8225183e1404(startElement) {
    if (!startElement.parentElement) return null;
    return $38f6480185c49d6f$export$184ef262a758e3c4(startElement.parentElement, (element)=>{
        var _a;
        const computedStyle = getComputedStyle(element);
        return !!computedStyle.transform && computedStyle.transform !== "none" || !!computedStyle.perspective && computedStyle.perspective !== "none" || !!computedStyle.containerType && computedStyle.containerType !== "normal" || ((_a = computedStyle.contain) === null || _a === void 0 ? void 0 : _a.split(" ").some((s)=>[
                "layout",
                "paint",
                "strict",
                "content"
            ].includes(s)));
    });
}
const $38f6480185c49d6f$var$cssVariableExpression = /--.+?\s*,\s*(.+)/;
function $38f6480185c49d6f$export$db8c23dd9d27b78f(value) {
    var _a, _b, _c;
    if ((_c = (_b = (_a = window.CSS) === null || _a === void 0 ? void 0 : _a.supports) === null || _b === void 0 ? void 0 : _b.call(_a, "color", "var(--dummy, #000)")) !== null && _c !== void 0 ? _c : false) return value;
    const varIndex = value.lastIndexOf("var(");
    if (varIndex === -1) return value;
    const expr = (0, (/*@__PURE__*/$parcel$interopDefault($30933cb119085804$exports)))("(", ")", value.substr(varIndex));
    if (!expr) return value;
    const match = expr.body.match($38f6480185c49d6f$var$cssVariableExpression);
    return match ? match[1] : value;
}



function $4c778684f125e678$export$57d4cb221e1d1857(container, target) {
    var _a;
    if (!(target instanceof Node)) return false;
    const portal = (0, $38f6480185c49d6f$export$184ef262a758e3c4)(target, (node)=>node === container || node instanceof HTMLElement && !!node.dataset.awsuiReferrerId);
    if (portal && portal === container) // We found the container as a direct ancestor without a portal
    return true;
    const referrer = portal instanceof HTMLElement ? document.getElementById((_a = portal.dataset.awsuiReferrerId) !== null && _a !== void 0 ? _a : "") : null;
    return referrer ? (0, $af285507a4cbfe46$export$2e2bcd8739ae039)(container, referrer) : (0, $af285507a4cbfe46$export$2e2bcd8739ae039)(container, target);
}


const $777318d005be2fce$export$eaa6680ad4907dec = ()=>{
    const context = (0, $acw62.useContext)((0, $2c7360a12f6b0b92$export$3030a14ef22dab15));
    const { funnelInteractionId: funnelInteractionId, funnelIdentifier: funnelIdentifier, funnelState: funnelState, latestFocusCleanupFunction: latestFocusCleanupFunction } = $777318d005be2fce$export$88e1f0f171a7843e();
    const { stepNumber: stepNumber, stepIdentifier: stepIdentifier, stepNameSelector: stepNameSelector, subStepConfiguration: subStepConfiguration } = $777318d005be2fce$export$77e0136e4218bd7f();
    const { subStepIdentifier: subStepIdentifier, subStepId: subStepId, subStepSelector: subStepSelector, subStepNameSelector: subStepNameSelector, subStepRef: subStepRef, isNestedSubStep: isNestedSubStep, mousePressed: mousePressed, isFocusedSubStep: isFocusedSubStep, focusCleanupFunction: focusCleanupFunction } = context;
    if (isNestedSubStep) return context;
    const onFocus = (event)=>(0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            const element = event.target;
            // Ignore spurious focus events, such as when the browser window is focused again.
            yield new Promise((r)=>setTimeout(r, 1));
            if (document.activeElement !== element) return;
            if (isFocusedSubStep.current) return;
            isFocusedSubStep.current = true;
            if (funnelInteractionId && subStepId) {
                /*
              If the previously focused substep has provided a cleanup function, we
              call it here on behalf of the previously focused substep.
            */ (_a = latestFocusCleanupFunction.current) === null || _a === void 0 || _a.call(latestFocusCleanupFunction);
                const subStepName = (0, $285a09b860d2bebc$export$ad08a5942dca04f8)(subStepNameSelector);
                const stepName = (0, $285a09b860d2bebc$export$ad08a5942dca04f8)(stepNameSelector);
                const subStepNumber = (_d = (_c = (_b = subStepConfiguration.current) === null || _b === void 0 ? void 0 : _b.get(stepNumber)) === null || _c === void 0 ? void 0 : _c.find((step)=>step.name === subStepName)) === null || _d === void 0 ? void 0 : _d.number;
                (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelSubStepStart({
                    funnelIdentifier: funnelIdentifier,
                    funnelInteractionId: funnelInteractionId,
                    subStepIdentifier: subStepIdentifier,
                    subStepSelector: subStepSelector,
                    subStepNameSelector: subStepNameSelector,
                    subStepName: subStepName,
                    subStepNumber: subStepNumber,
                    stepIdentifier: stepIdentifier,
                    stepNumber: stepNumber,
                    stepName: stepName,
                    stepNameSelector: stepNameSelector,
                    subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)()
                });
                /*
              This cleanup function will be called when the user leaves this substep.
              The function might be called either:
      
                - by the next focused substep as `latestFocusCleanupFunction`
                  (through a separate instance of the function we're currently in), or
      
                - by the same substep as `focusCleanupFunction`
                  (through the `onMouseUp` handler or the `onBlur` handler).
            */ let cleanupFunctionHasBeenRun = false;
                focusCleanupFunction.current = ()=>{
                    var _a, _b, _c;
                    if (cleanupFunctionHasBeenRun) return;
                    cleanupFunctionHasBeenRun = true;
                    const subStepNumber = (_c = (_b = (_a = subStepConfiguration.current) === null || _a === void 0 ? void 0 : _a.get(stepNumber)) === null || _b === void 0 ? void 0 : _b.find((s)=>s.name === subStepName)) === null || _c === void 0 ? void 0 : _c.number;
                    if (funnelState.current !== "cancelled") (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelSubStepComplete({
                        funnelIdentifier: funnelIdentifier,
                        funnelInteractionId: funnelInteractionId,
                        subStepIdentifier: subStepIdentifier,
                        subStepSelector: subStepSelector,
                        subStepNameSelector: subStepNameSelector,
                        subStepName: subStepName,
                        subStepNumber: subStepNumber,
                        stepIdentifier: stepIdentifier,
                        stepNumber: stepNumber,
                        stepName: stepName,
                        stepNameSelector: stepNameSelector,
                        subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)()
                    });
                };
                latestFocusCleanupFunction.current = focusCleanupFunction.current;
            }
        });
    const onBlur = (event)=>{
        var _a;
        if (mousePressed.current) /*
             Ignore blur events that are caused by mouse interaction, because these events don't
             always reflect user intention. For example, clicking the label of an interactive form
             element will briefly blur it.
             The mouse-caused events are handled in the global `onMouseUp` handler of the substep
             context instead.
             */ return;
        if (!subStepRef.current || !event.relatedTarget || !(0, $4c778684f125e678$export$57d4cb221e1d1857)(subStepRef.current, event.relatedTarget)) {
            isFocusedSubStep.current = false;
            if (funnelInteractionId && subStepId && funnelState.current !== "cancelled") /*
                 Run this substep's own focus cleanup function if another substep
                 hasn't already done it for us.
                 */ (_a = focusCleanupFunction.current) === null || _a === void 0 || _a.call(focusCleanupFunction);
        }
    };
    const funnelSubStepProps = funnelInteractionId ? {
        [(0, $285a09b860d2bebc$export$e4865c712b63120)]: subStepId,
        onFocus: onFocus,
        onBlur: onBlur
    } : {};
    return Object.assign({
        funnelSubStepProps: funnelSubStepProps
    }, context);
};
const $777318d005be2fce$export$77e0136e4218bd7f = ()=>{
    const context = (0, $acw62.useContext)((0, $2c7360a12f6b0b92$export$8b0d9233e68df2ee));
    return context;
};
const $777318d005be2fce$export$88e1f0f171a7843e = ()=>{
    const context = (0, $acw62.useContext)((0, $2c7360a12f6b0b92$export$7a5dd0cfd3639f1b));
    const funnelProps = context.funnelInteractionId ? {
        [(0, $285a09b860d2bebc$export$6f6189a197458f7a)]: context.funnelInteractionId
    } : {};
    return Object.assign({
        funnelProps: funnelProps
    }, context);
};
const $777318d005be2fce$export$330d990b59bc48da = ()=>{
    const context = (0, $acw62.useContext)((0, $2c7360a12f6b0b92$export$6763bc96d4aa4bf8));
    return context;
};





var $acw62 = parcelRequire("acw62");
var $cbf2b8f79dc6eee9$var$_a;
let $cbf2b8f79dc6eee9$var$counter = 0;
const $cbf2b8f79dc6eee9$export$bc16067c9902c2bf = ()=>{
    const idRef = (0, $acw62.useRef)(null);
    if (!idRef.current) idRef.current = `${$cbf2b8f79dc6eee9$var$counter++}-${Date.now()}-${Math.round(Math.random() * 10000)}`;
    return idRef.current;
};
const $cbf2b8f79dc6eee9$var$useId = ($cbf2b8f79dc6eee9$var$_a = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) !== null && $cbf2b8f79dc6eee9$var$_a !== void 0 ? $cbf2b8f79dc6eee9$var$_a : $cbf2b8f79dc6eee9$export$bc16067c9902c2bf;
function $cbf2b8f79dc6eee9$export$c485849f2e393253(prefix) {
    return `${prefix ? prefix : ""}` + $cbf2b8f79dc6eee9$var$useId();
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $134bbee1801695be$export$21dfe79102a9caab(callback, deps) {
    const isFirstRender = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else return callback();
    // This is a useEffect extension, will be validated at the call site
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $584c4a19f0ba0537$export$ab57792b9b6974a6 = (0, $acw62.createContext)({
    isInModal: false
});
const $584c4a19f0ba0537$export$4cc1699d46f42cae = ()=>{
    const modalContext = (0, $acw62.useContext)($584c4a19f0ba0537$export$ab57792b9b6974a6);
    return modalContext;
};


/*
This hook allows setting an HTML attribute after the first render, without rerendering the component.
*/ function $d1a7bb38399fdadf$var$usePerformanceMarkAttribute(elementRef, value) {
    const attributeName = "data-analytics-performance-mark";
    const attributeValueRef = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        var _a;
        // With this effect, we apply the attribute only on the client, to avoid hydration errors.
        attributeValueRef.current = value;
        (_a = elementRef.current) === null || _a === void 0 || _a.setAttribute(attributeName, value);
    }, [
        value,
        elementRef
    ]);
    return {
        [attributeName]: attributeValueRef.current
    };
}
function $d1a7bb38399fdadf$export$2ea7ecdb51f088f5(name, enabled, elementRef, getDetails, dependencies) {
    const id = (0, $cbf2b8f79dc6eee9$export$bc16067c9902c2bf)();
    const { isInModal: isInModal } = (0, $584c4a19f0ba0537$export$4cc1699d46f42cae)();
    const attributes = $d1a7bb38399fdadf$var$usePerformanceMarkAttribute(elementRef, id);
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !elementRef.current || isInModal) return;
        const elementVisible = elementRef.current.offsetWidth > 0 && elementRef.current.offsetHeight > 0 && getComputedStyle(elementRef.current).visibility !== "hidden";
        if (!elementVisible) return;
        const renderedMarkName = `${name}Rendered`;
        performance.mark(renderedMarkName, {
            detail: Object.assign({
                source: "awsui",
                instanceIdentifier: id
            }, getDetails())
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $134bbee1801695be$export$21dfe79102a9caab)(()=>{
        if (!enabled || !elementRef.current || isInModal) return;
        const elementVisible = elementRef.current.offsetWidth > 0 && elementRef.current.offsetHeight > 0 && getComputedStyle(elementRef.current).visibility !== "hidden";
        if (!elementVisible) return;
        const updatedMarkName = `${name}Updated`;
        performance.mark(updatedMarkName, {
            detail: Object.assign({
                source: "awsui",
                instanceIdentifier: id
            }, getDetails())
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
    return attributes;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $7f9661e47bcc5460$export$1a01ae0705bafd37 = {
    navigationActive: false,
    registerFocusable: ()=>()=>{}
};
const $7f9661e47bcc5460$export$d883ceba1e571843 = (0, $acw62.createContext)($7f9661e47bcc5460$export$1a01ae0705bafd37);
function $7f9661e47bcc5460$export$4cf30df7bba16ac9(focusable, options) {
    var _a;
    const { navigationActive: contextNavigationActive, registerFocusable: registerFocusable } = (0, $acw62.useContext)($7f9661e47bcc5460$export$d883ceba1e571843);
    const [focusTargetActive, setFocusTargetActive] = (0, $acw62.useState)(false);
    const navigationDisabled = (options === null || options === void 0 ? void 0 : options.tabIndex) && (options === null || options === void 0 ? void 0 : options.tabIndex) < 0;
    const navigationActive = contextNavigationActive && !navigationDisabled;
    (0, $acw62.useLayoutEffect)(()=>{
        if (navigationActive && focusable && focusable.current) {
            const unregister = registerFocusable(focusable.current, (isFocusable)=>setFocusTargetActive(isFocusable));
            return ()=>unregister();
        }
    });
    let tabIndex = options === null || options === void 0 ? void 0 : options.tabIndex;
    if (navigationActive) tabIndex = !focusTargetActive ? -1 : (_a = options === null || options === void 0 ? void 0 : options.tabIndex) !== null && _a !== void 0 ? _a : 0;
    return {
        navigationActive: navigationActive,
        tabIndex: tabIndex
    };
}
const $7f9661e47bcc5460$export$44f87403d31a265f = (0, $acw62.forwardRef)(({ navigationActive: navigationActive, children: children, getNextFocusTarget: getNextFocusTarget, isElementSuppressed: isElementSuppressed, onRegisterFocusable: onRegisterFocusable, onUnregisterFocusable: onUnregisterFocusable }, ref)=>{
    // A set of registered focusable elements that can use keyboard navigation.
    const focusables = (0, $acw62.useRef)(new Set());
    // A map of registered focusable element handlers to update the respective tab indices.
    const focusHandlers = (0, $acw62.useRef)(new Map());
    // A map of focusable element states to avoid issuing unnecessary updates to registered elements.
    const focusablesState = (0, $acw62.useRef)(new WeakMap());
    // A reference to the currently focused element.
    const focusTarget = (0, $acw62.useRef)(null);
    // Register a focusable element to allow navigating into it.
    // The focusable element tabIndex is only set to 0 if the element matches the focus target.
    function registerFocusable(focusableElement, changeHandler) {
        focusables.current.add(focusableElement);
        focusHandlers.current.set(focusableElement, changeHandler);
        const isFocusable = !!focusablesState.current.get(focusableElement);
        const newIsFocusable = focusTarget.current === focusableElement || !!(isElementSuppressed === null || isElementSuppressed === void 0 ? void 0 : isElementSuppressed(focusableElement));
        if (newIsFocusable !== isFocusable) {
            focusablesState.current.set(focusableElement, newIsFocusable);
            changeHandler(newIsFocusable);
        }
        onRegisterFocusable === null || onRegisterFocusable === void 0 || onRegisterFocusable(focusableElement);
        return ()=>unregisterFocusable(focusableElement);
    }
    function unregisterFocusable(focusableElement) {
        focusables.current.delete(focusableElement);
        focusHandlers.current.delete(focusableElement);
        onUnregisterFocusable === null || onUnregisterFocusable === void 0 || onUnregisterFocusable(focusableElement);
    }
    // Update focus target with next single focusable element and notify all registered focusables of a change.
    function updateFocusTarget() {
        var _a;
        focusTarget.current = getNextFocusTarget();
        for (const focusableElement of focusables.current){
            const isFocusable = (_a = focusablesState.current.get(focusableElement)) !== null && _a !== void 0 ? _a : false;
            const newIsFocusable = focusTarget.current === focusableElement || !!(isElementSuppressed === null || isElementSuppressed === void 0 ? void 0 : isElementSuppressed(focusableElement));
            if (newIsFocusable !== isFocusable) {
                focusablesState.current.set(focusableElement, newIsFocusable);
                focusHandlers.current.get(focusableElement)(newIsFocusable);
            }
        }
    }
    function getFocusTarget() {
        return focusTarget.current;
    }
    function isRegistered(element) {
        return focusables.current.has(element);
    }
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            updateFocusTarget: updateFocusTarget,
            getFocusTarget: getFocusTarget,
            isRegistered: isRegistered
        }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7f9661e47bcc5460$export$d883ceba1e571843.Provider, {
        value: {
            navigationActive: navigationActive,
            registerFocusable: registerFocusable
        }
    }, children);
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}




var $acw62 = parcelRequire("acw62");

var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = "unmounted";
var $0fef977f04119bf5$export$84cbff306f539230 = "exited";
var $0fef977f04119bf5$export$df38205c966be359 = "entering";
var $0fef977f04119bf5$export$78e9e6e3e014d60a = "entered";
var $0fef977f04119bf5$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;



function $29f6cc3f65ba768c$export$be58926105124dd4(_a) {
    var { in: isIn, children: children, exit: exit = true, onStatusChange: onStatusChange = ()=>void 0, disabled: disabled = false, transitionChangeDelay: transitionChangeDelay } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "in",
        "children",
        "exit",
        "onStatusChange",
        "disabled",
        "transitionChangeDelay"
    ]);
    const transitionRootElement = (0, $acw62.useRef)(null);
    // the initial state of the transition should be either 'exited' or 'entered' depending
    // on the `in` property, this mimicks how internally the Transition component works here:
    // https://github.com/reactjs/react-transition-group/blob/6cbd6aaedaf8e9472007640b429ddb48c6c24158/src/Transition.js#L121
    const [transitionState, setTransitionState] = (0, $acw62.useState)(isIn ? "entered" : "exited");
    const motionDisabled = (0, $020c722843a7a503$export$6a42007cf1e7b6f8)(transitionRootElement) || disabled;
    const addTransitionEndListener = (0, $acw62.useCallback)((done)=>{
        const node = transitionRootElement.current;
        if (node === null) return;
        const listener = (e)=>{
            if (e.target === node) {
                node.removeEventListener("transitionend", listener);
                node.removeEventListener("animationend", listener);
                done();
            }
        };
        node.addEventListener("transitionend", listener);
        node.addEventListener("animationend", listener);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0fef977f04119bf5$export$2e2bcd8739ae039), Object.assign({
        addEndListener: addTransitionEndListener,
        timeout: motionDisabled ? 0 : undefined,
        in: isIn,
        nodeRef: transitionRootElement,
        exit: exit,
        onEnter: (isAppearing)=>{
            if (!isAppearing) {
                setTransitionState("enter");
                onStatusChange("enter");
            }
        },
        onEntering: (isAppearing)=>{
            var _a;
            if (!isAppearing) {
                // This line forces the browser to recalculate the layout because we want the starting state in the 'enter' style
                // to be applied before the animation starts.
                (_a = transitionRootElement.current) === null || _a === void 0 || _a.offsetHeight;
                if (transitionChangeDelay === null || transitionChangeDelay === void 0 ? void 0 : transitionChangeDelay.entering) setTimeout(()=>{
                    setTransitionState("entering");
                    onStatusChange("entering");
                }, transitionChangeDelay === null || transitionChangeDelay === void 0 ? void 0 : transitionChangeDelay.entering);
                else {
                    setTransitionState("entering");
                    onStatusChange("entering");
                }
            }
        },
        onEntered: (isAppearing)=>{
            if (!isAppearing) {
                setTransitionState("entered");
                onStatusChange("entered");
            }
        },
        onExit: ()=>{
            setTransitionState("exit");
            onStatusChange("exit");
        },
        onExiting: ()=>{
            setTransitionState("exiting");
            onStatusChange("exiting");
        },
        onExited: ()=>{
            setTransitionState("exited");
            onStatusChange("exited");
        }
    }, rest), ()=>children(transitionState, transitionRootElement));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $350807ffd27dc31c$export$2e2bcd8739ae039 = {
    "arrow": "awsui_arrow_xjuzf_dzn3k_193",
    "arrow-outer": "awsui_arrow-outer_xjuzf_dzn3k_197",
    "arrow-inner": "awsui_arrow-inner_xjuzf_dzn3k_197",
    "refresh": "awsui_refresh_xjuzf_dzn3k_232",
    "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_dzn3k_242",
    "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_dzn3k_242",
    "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_dzn3k_245",
    "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_dzn3k_245",
    "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_dzn3k_248",
    "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_dzn3k_248",
    "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_dzn3k_248",
    "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_dzn3k_248",
    "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_dzn3k_251",
    "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_dzn3k_251",
    "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_dzn3k_251",
    "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_dzn3k_251",
    "body": "awsui_body_xjuzf_dzn3k_351",
    "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_dzn3k_390",
    "has-dismiss": "awsui_has-dismiss_xjuzf_dzn3k_394",
    "dismiss": "awsui_dismiss_xjuzf_dzn3k_399",
    "dismiss-control": "awsui_dismiss-control_xjuzf_dzn3k_407",
    "header-row": "awsui_header-row_xjuzf_dzn3k_411",
    "header": "awsui_header_xjuzf_dzn3k_411",
    "content": "awsui_content_xjuzf_dzn3k_436",
    "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_dzn3k_444",
    "container": "awsui_container_xjuzf_dzn3k_544",
    "container-body": "awsui_container-body_xjuzf_dzn3k_552",
    "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_dzn3k_595",
    "container-body-size-small": "awsui_container-body-size-small_xjuzf_dzn3k_600",
    "fixed-width": "awsui_fixed-width_xjuzf_dzn3k_603",
    "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_dzn3k_607",
    "container-body-size-large": "awsui_container-body-size-large_xjuzf_dzn3k_614",
    "container-arrow": "awsui_container-arrow_xjuzf_dzn3k_626",
    "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_dzn3k_630",
    "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_dzn3k_630",
    "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_dzn3k_647",
    "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_dzn3k_647",
    "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_dzn3k_664",
    "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_dzn3k_664",
    "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_dzn3k_664",
    "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_dzn3k_664",
    "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_dzn3k_680",
    "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_dzn3k_684",
    "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_dzn3k_688",
    "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_dzn3k_1",
    "root": "awsui_root_xjuzf_dzn3k_832",
    "trigger": "awsui_trigger_xjuzf_dzn3k_868",
    "overflow-ellipsis": "awsui_overflow-ellipsis_xjuzf_dzn3k_875",
    "trigger-type-text": "awsui_trigger-type-text_xjuzf_dzn3k_883",
    "popover-inline-content": "awsui_popover-inline-content_xjuzf_dzn3k_919"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $6bb895fb37385d1b$var$ARROW_OFFSET = 12;
const $6bb895fb37385d1b$export$75ff5b418e887e52 = {
    top: [
        "top-center",
        "top-right",
        "top-left",
        "bottom-center",
        "bottom-right",
        "bottom-left",
        "right-top",
        "right-bottom",
        "left-top",
        "left-bottom"
    ],
    bottom: [
        "bottom-center",
        "bottom-right",
        "bottom-left",
        "top-center",
        "top-right",
        "top-left",
        "right-top",
        "right-bottom",
        "left-top",
        "left-bottom"
    ],
    left: [
        "left-top",
        "left-bottom",
        "right-top",
        "right-bottom",
        "bottom-center",
        "top-center",
        "bottom-left",
        "top-left",
        "bottom-right",
        "top-right"
    ],
    right: [
        "right-top",
        "right-bottom",
        "left-top",
        "left-bottom",
        "bottom-center",
        "top-center",
        "bottom-right",
        "top-right",
        "bottom-left",
        "top-left"
    ]
};
const $6bb895fb37385d1b$var$RECTANGLE_CALCULATIONS = {
    "top-center": ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart - body.blockSize - arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 - body.inlineSize / 2,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    "top-right": ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart - body.blockSize - arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 - $6bb895fb37385d1b$var$ARROW_OFFSET - arrow.inlineSize / 2,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    "top-left": ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart - body.blockSize - arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 + $6bb895fb37385d1b$var$ARROW_OFFSET + arrow.inlineSize / 2 - body.inlineSize,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    "bottom-center": ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart + trigger.blockSize + arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 - body.inlineSize / 2,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    "bottom-right": ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart + trigger.blockSize + arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 - $6bb895fb37385d1b$var$ARROW_OFFSET - arrow.inlineSize / 2,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    "bottom-left": ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart + trigger.blockSize + arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize / 2 + $6bb895fb37385d1b$var$ARROW_OFFSET + arrow.inlineSize / 2 - body.inlineSize,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    "right-top": ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart + trigger.blockSize / 2 - $6bb895fb37385d1b$var$ARROW_OFFSET - arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize + arrow.blockSize,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    "right-bottom": ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart + trigger.blockSize / 2 - body.blockSize + $6bb895fb37385d1b$var$ARROW_OFFSET + arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart + trigger.inlineSize + arrow.blockSize,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    "left-top": ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart + trigger.blockSize / 2 - $6bb895fb37385d1b$var$ARROW_OFFSET - arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart - body.inlineSize - arrow.blockSize,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    },
    "left-bottom": ({ body: body, trigger: trigger, arrow: arrow })=>{
        return {
            insetBlockStart: trigger.insetBlockStart + trigger.blockSize / 2 - body.blockSize + $6bb895fb37385d1b$var$ARROW_OFFSET + arrow.blockSize,
            insetInlineStart: trigger.insetInlineStart - body.inlineSize - arrow.blockSize,
            inlineSize: body.inlineSize,
            blockSize: body.blockSize
        };
    }
};
function $6bb895fb37385d1b$var$fitIntoContainer(inner, outer) {
    let { insetInlineStart: insetInlineStart, inlineSize: inlineSize, insetBlockStart: insetBlockStart, blockSize: blockSize } = inner;
    // Adjust left boundary.
    if (insetInlineStart < outer.insetInlineStart) {
        inlineSize = insetInlineStart + inlineSize - outer.insetInlineStart;
        insetInlineStart = outer.insetInlineStart;
    } else if (insetInlineStart + inlineSize > outer.insetInlineStart + outer.inlineSize) inlineSize = outer.insetInlineStart + outer.inlineSize - insetInlineStart;
    // Adjust top boundary.
    if (insetBlockStart < outer.insetBlockStart) {
        blockSize = insetBlockStart + blockSize - outer.insetBlockStart;
        insetBlockStart = outer.insetBlockStart;
    } else if (insetBlockStart + blockSize > outer.insetBlockStart + outer.blockSize) blockSize = outer.insetBlockStart + outer.blockSize - insetBlockStart;
    return {
        insetInlineStart: insetInlineStart,
        inlineSize: inlineSize,
        insetBlockStart: insetBlockStart,
        blockSize: blockSize
    };
}
function $6bb895fb37385d1b$var$getTallestRect(rect1, rect2) {
    return rect1.blockSize >= rect2.blockSize ? rect1 : rect2;
}
function $6bb895fb37385d1b$var$getIntersection(rectangles) {
    let boundingBox = null;
    for (const currentRect of rectangles){
        if (!boundingBox) {
            boundingBox = currentRect;
            continue;
        }
        const insetInlineStart = Math.max(boundingBox.insetInlineStart, currentRect.insetInlineStart);
        const insetBlockStart = Math.max(boundingBox.insetBlockStart, currentRect.insetBlockStart);
        const insetInlineEnd = Math.min(boundingBox.insetInlineStart + boundingBox.inlineSize, currentRect.insetInlineStart + currentRect.inlineSize);
        const insetBlockEnd = Math.min(boundingBox.insetBlockStart + boundingBox.blockSize, currentRect.insetBlockStart + currentRect.blockSize);
        if (insetInlineEnd < insetInlineStart || insetBlockEnd < insetBlockStart) return null;
        boundingBox = {
            insetInlineStart: insetInlineStart,
            insetBlockStart: insetBlockStart,
            inlineSize: insetInlineEnd - insetInlineStart,
            blockSize: insetBlockEnd - insetBlockStart
        };
    }
    return boundingBox;
}
function $6bb895fb37385d1b$export$3c843d0917c4676c(rectangles) {
    const boundingBox = $6bb895fb37385d1b$var$getIntersection(rectangles);
    return boundingBox && boundingBox.blockSize * boundingBox.inlineSize;
}
function $6bb895fb37385d1b$export$b3ceb0cbf1056d98({ preferredPosition: preferredPosition, fixedInternalPosition: fixedInternalPosition, trigger: trigger, arrow: arrow, body: body, container: container, viewport: viewport, renderWithPortal: // the popover is only bound by the viewport if it is rendered in a portal
renderWithPortal, allowVerticalOverflow: allowVerticalOverflow }) {
    let bestOption = null;
    // If a fixed internal position is passed, only consider this one.
    const preferredInternalPositions = fixedInternalPosition ? [
        fixedInternalPosition
    ] : $6bb895fb37385d1b$export$75ff5b418e887e52[preferredPosition];
    // Attempt to position the popover based on the priority list for this position.
    for (const internalPosition of preferredInternalPositions){
        const rect = $6bb895fb37385d1b$var$RECTANGLE_CALCULATIONS[internalPosition]({
            body: body,
            trigger: trigger,
            arrow: arrow
        });
        const visibleArea = renderWithPortal ? $6bb895fb37385d1b$var$getIntersection([
            rect,
            viewport
        ]) : $6bb895fb37385d1b$var$getIntersection([
            rect,
            viewport,
            container
        ]);
        const fitsWithoutOverflow = visibleArea && visibleArea.inlineSize === body.inlineSize && visibleArea.blockSize === body.blockSize;
        if (fitsWithoutOverflow) return {
            internalPosition: internalPosition,
            rect: rect
        };
        const newOption = {
            rect: rect,
            internalPosition: internalPosition,
            visibleArea: visibleArea
        };
        bestOption = $6bb895fb37385d1b$var$getBestOption(newOption, bestOption);
    }
    // Use best possible placement.
    const internalPosition = (bestOption === null || bestOption === void 0 ? void 0 : bestOption.internalPosition) || "right-top";
    // Get default rect for that placement.
    const rect = $6bb895fb37385d1b$var$RECTANGLE_CALCULATIONS[internalPosition]({
        body: body,
        trigger: trigger,
        arrow: arrow
    });
    // Get largest possible rect that fits into the viewport or container.
    // We allow the popover to overflow the viewport if allowVerticalOverflow is true _and_ the popover will be anchored to the top or the bottom.
    // If it is anchored to the right or left, we consider that it should have enough vertical space so that applying scroll to it is a better option.
    const tallestBoundingContainer = $6bb895fb37385d1b$var$getTallestRect(viewport, container);
    const boundingContainer = allowVerticalOverflow && $6bb895fb37385d1b$var$isTopOrBottom(internalPosition) ? {
        insetBlockStart: tallestBoundingContainer.insetBlockStart,
        blockSize: tallestBoundingContainer.blockSize,
        insetInlineStart: viewport.insetInlineStart,
        inlineSize: viewport.inlineSize
    } : viewport;
    const optimizedRect = $6bb895fb37385d1b$var$fitIntoContainer(rect, boundingContainer);
    // If largest possible rect is shorter than original - set body scroll.
    const scrollable = optimizedRect.blockSize < rect.blockSize;
    return {
        internalPosition: internalPosition,
        rect: optimizedRect,
        scrollable: scrollable
    };
}
function $6bb895fb37385d1b$var$getBestOption(option1, option2) {
    // Within calculatePosition, the only case where option2 will not be defined will be in the first call.
    // The only case where the visibleArea of an option will be null is when the popover is totally outside of the viewport.
    if (!(option2 === null || option2 === void 0 ? void 0 : option2.visibleArea)) return option1;
    if (!option1.visibleArea) return option2;
    // Only if none of the two options overflows horizontally, choose the best based on the visible height.
    if (option1.visibleArea.inlineSize === option2.visibleArea.inlineSize) return option1.visibleArea.blockSize > option2.visibleArea.blockSize ? option1 : option2;
    // Otherwise, choose the option that is less cut off horizontally.
    return option1.visibleArea.inlineSize > option2.visibleArea.inlineSize ? option1 : option2;
}
function $6bb895fb37385d1b$export$41aa892fb2ec05ef(element) {
    return {
        offsetHeight: element.offsetHeight,
        offsetWidth: element.offsetWidth
    };
}
function $6bb895fb37385d1b$export$d1aa971bf69c7e87(element) {
    const computedStyle = getComputedStyle(element);
    return {
        inlineSize: parseFloat(computedStyle.inlineSize),
        blockSize: parseFloat(computedStyle.blockSize)
    };
}
function $6bb895fb37385d1b$var$isTopOrBottom(internalPosition) {
    return [
        "top",
        "bottom"
    ].includes(internalPosition.split("-")[0]);
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $24d40242cc6554ee$export$f32edd573b1049e6 = (element)=>{
    const parents = [];
    let node = element;
    while((node = node.parentElement) && node !== document.body)getComputedStyle(node).overflow !== "visible" && parents.push(node);
    return parents;
};
const $24d40242cc6554ee$export$788cd595d1360cb2 = ({ element: element, excludeClosestParent: excludeClosestParent = false, expandToViewport: expandToViewport = false, canExpandOutsideViewport: canExpandOutsideViewport = false })=>{
    var _a, _b, _c, _d;
    const parents = expandToViewport ? [] : $24d40242cc6554ee$export$f32edd573b1049e6(element).map((el)=>{
        const { height: height, width: width, top: top, left: left } = el.getBoundingClientRect();
        return {
            // Treat the whole scrollable area as the available height
            // if we're allowed to expand past the viewport.
            blockSize: canExpandOutsideViewport ? el.scrollHeight : height,
            inlineSize: width,
            insetBlockStart: top,
            insetInlineStart: left
        };
    });
    if (canExpandOutsideViewport && !expandToViewport) {
        const documentDimensions = document.documentElement.getBoundingClientRect();
        parents.push({
            inlineSize: Math.max(documentDimensions.width, document.documentElement.clientWidth),
            blockSize: Math.max(documentDimensions.height, document.documentElement.clientHeight),
            insetBlockStart: documentDimensions.top,
            insetInlineStart: documentDimensions.left
        });
    } else parents.push({
        blockSize: (_b = (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) !== null && _b !== void 0 ? _b : window.innerHeight,
        inlineSize: (_d = (_c = window.visualViewport) === null || _c === void 0 ? void 0 : _c.width) !== null && _d !== void 0 ? _d : window.innerWidth,
        insetBlockStart: 0,
        insetInlineStart: 0
    });
    if (excludeClosestParent && !expandToViewport) parents.shift();
    return parents;
};
function $24d40242cc6554ee$export$a904af9c1628c179(element, options = {
    block: "nearest",
    inline: "nearest"
}) {
    var _a;
    (_a = element === null || element === void 0 ? void 0 : element.scrollIntoView) === null || _a === void 0 || _a.call(element, options);
}
function $24d40242cc6554ee$export$9f07ffdb65d93a3a({ insetBlockStart: insetBlockStart, blockSize: blockSize }) {
    if (insetBlockStart < 0) return insetBlockStart;
    else if (insetBlockStart + blockSize > window.innerHeight) {
        if (blockSize > window.innerHeight) return insetBlockStart;
        else return insetBlockStart + blockSize - window.innerHeight;
    }
    return 0;
}
function $24d40242cc6554ee$export$daa0070c3a783245(box, scrollableParent) {
    const scrollAmount = $24d40242cc6554ee$export$9f07ffdb65d93a3a(box);
    if (scrollAmount) (scrollableParent || window).scrollBy(0, scrollAmount);
}
function $24d40242cc6554ee$export$421df48f39898a3d(element) {
    return (0, $38f6480185c49d6f$export$184ef262a758e3c4)(element, (el)=>{
        const overflows = el.scrollHeight > el.clientHeight;
        return overflows && [
            "scroll",
            "auto"
        ].includes(getComputedStyle(el).overflowY);
    }) || undefined;
}




function $45ec260cea817966$export$2e2bcd8739ae039({ popoverRef: popoverRef, bodyRef: bodyRef, arrowRef: arrowRef, trackRef: trackRef, contentRef: contentRef, allowScrollToFit: allowScrollToFit, allowVerticalOverflow: allowVerticalOverflow, preferredPosition: preferredPosition, renderWithPortal: renderWithPortal, keepPosition: keepPosition }) {
    const previousInternalPositionRef = (0, $acw62.useRef)(null);
    const [popoverStyle, setPopoverStyle] = (0, $acw62.useState)({});
    const [internalPosition, setInternalPosition] = (0, $acw62.useState)(null);
    // Store the handler in a ref so that it can still be replaced from outside of the listener closure.
    const positionHandlerRef = (0, $acw62.useRef)(()=>{});
    const updatePositionHandler = (0, $acw62.useCallback)((onContentResize = false)=>{
        var _a;
        if (!trackRef.current || !popoverRef.current || !bodyRef.current || !contentRef.current || !arrowRef.current) return;
        // Get important elements
        const popover = popoverRef.current;
        const body = bodyRef.current;
        const arrow = arrowRef.current;
        const document = popover.ownerDocument;
        const track = trackRef.current;
        // If the popover body isn't being rendered for whatever reason (e.g. "display: none" or JSDOM),
        // or track does not belong to the document - bail on calculating dimensions.
        const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = (0, $6bb895fb37385d1b$export$41aa892fb2ec05ef)(popover);
        if (offsetWidth === 0 || offsetHeight === 0 || !(0, $af285507a4cbfe46$export$2e2bcd8739ae039)(document.body, track)) return;
        // Imperatively move body off-screen to give it room to expand.
        // Not doing this in React because this recalculation should happen
        // in the span of a single frame without rerendering anything.
        const prevInsetBlockStart = popover.style.insetBlockStart;
        const prevInsetInlineStart = popover.style.insetInlineStart;
        popover.style.insetBlockStart = "0";
        popover.style.insetInlineStart = "0";
        // Imperatively remove body styles that can remain from the previous computation.
        body.style.maxBlockSize = "";
        body.style.overflowX = "";
        body.style.overflowY = "";
        // Get rects representing key elements
        // Use getComputedStyle for arrowRect to avoid modifications made by transform
        const viewportRect = $45ec260cea817966$var$getViewportRect(document.defaultView);
        const trackRect = (0, $558545a5feadf817$export$322fb6cc2f904670)(track);
        const arrowRect = (0, $6bb895fb37385d1b$export$d1aa971bf69c7e87)(arrow);
        const containingBlock = (0, $38f6480185c49d6f$export$940d8225183e1404)(popover);
        const containingBlockRect = containingBlock ? (0, $558545a5feadf817$export$322fb6cc2f904670)(containingBlock) : viewportRect;
        const bodyBorderWidth = $45ec260cea817966$var$getBorderWidth(body);
        const contentRect = (0, $558545a5feadf817$export$322fb6cc2f904670)(contentRef.current);
        const contentBoundingBox = {
            inlineSize: contentRect.inlineSize + 2 * bodyBorderWidth,
            blockSize: contentRect.blockSize + 2 * bodyBorderWidth
        };
        // When keepPosition is true and the recalculation was triggered by a resize of the popover content,
        // we maintain the previously defined internal position,
        // but we still call calculatePosition to know if the popover should be scrollable.
        const shouldKeepPosition = keepPosition && onContentResize && !!previousInternalPositionRef.current;
        const fixedInternalPosition = (_a = shouldKeepPosition && previousInternalPositionRef.current) !== null && _a !== void 0 ? _a : undefined;
        // Calculate the arrow direction and viewport-relative position of the popover.
        const { scrollable: scrollable, internalPosition: newInternalPosition, rect: rect } = (0, $6bb895fb37385d1b$export$b3ceb0cbf1056d98)({
            preferredPosition: preferredPosition,
            fixedInternalPosition: fixedInternalPosition,
            trigger: trackRect,
            arrow: arrowRect,
            body: contentBoundingBox,
            container: containingBlock ? containingBlockRect : $45ec260cea817966$var$getDocumentRect(document),
            viewport: viewportRect,
            renderWithPortal: renderWithPortal,
            allowVerticalOverflow: allowVerticalOverflow
        });
        // Get the position of the popover relative to the offset parent.
        const popoverOffset = $45ec260cea817966$var$toRelativePosition(rect, containingBlockRect);
        // Cache the distance between the trigger and the popover (which stays the same as you scroll),
        // and use that to recalculate the new popover position.
        const trackRelativeOffset = $45ec260cea817966$var$toRelativePosition(popoverOffset, $45ec260cea817966$var$toRelativePosition(trackRect, containingBlockRect));
        // Bring back the container to its original position to prevent any flashing.
        popover.style.insetBlockStart = prevInsetBlockStart;
        popover.style.insetInlineStart = prevInsetInlineStart;
        // Allow popover body to scroll if can't fit the popover into the container/viewport otherwise.
        if (scrollable) {
            body.style.maxBlockSize = rect.blockSize + "px";
            body.style.overflowX = "hidden";
            body.style.overflowY = "auto";
        }
        // Remember the internal position in case we want to keep it later.
        previousInternalPositionRef.current = newInternalPosition;
        setInternalPosition(newInternalPosition);
        const shouldScroll = allowScrollToFit && !shouldKeepPosition;
        // Position the popover
        const insetBlockStart = shouldScroll ? popoverOffset.insetBlockStart + (0, $24d40242cc6554ee$export$9f07ffdb65d93a3a)(rect) : popoverOffset.insetBlockStart;
        setPopoverStyle({
            insetBlockStart: insetBlockStart,
            insetInlineStart: popoverOffset.insetInlineStart
        });
        // Scroll if necessary
        if (shouldScroll) {
            const scrollableParent = (0, $24d40242cc6554ee$export$421df48f39898a3d)(popover);
            (0, $24d40242cc6554ee$export$daa0070c3a783245)(rect, scrollableParent);
        }
        positionHandlerRef.current = ()=>{
            const newTrackOffset = $45ec260cea817966$var$toRelativePosition((0, $558545a5feadf817$export$322fb6cc2f904670)(track), containingBlock ? (0, $558545a5feadf817$export$322fb6cc2f904670)(containingBlock) : viewportRect);
            setPopoverStyle({
                insetBlockStart: newTrackOffset.insetBlockStart + trackRelativeOffset.insetBlockStart,
                insetInlineStart: newTrackOffset.insetInlineStart + trackRelativeOffset.insetInlineStart
            });
        };
    }, [
        trackRef,
        popoverRef,
        bodyRef,
        contentRef,
        arrowRef,
        keepPosition,
        allowScrollToFit,
        preferredPosition,
        renderWithPortal,
        allowVerticalOverflow
    ]);
    return {
        updatePositionHandler: updatePositionHandler,
        popoverStyle: popoverStyle,
        internalPosition: internalPosition,
        positionHandlerRef: positionHandlerRef
    };
}
function $45ec260cea817966$var$getBorderWidth(element) {
    return parseInt(getComputedStyle(element).borderWidth) || 0;
}
/**
 * Convert a viewport-relative offset to an element-relative offset.
 */ function $45ec260cea817966$var$toRelativePosition(element, parent) {
    return {
        insetBlockStart: element.insetBlockStart - parent.insetBlockStart,
        insetInlineStart: element.insetInlineStart - parent.insetInlineStart
    };
}
/**
 * Get a BoundingBox that represents the visible viewport.
 */ function $45ec260cea817966$var$getViewportRect(window) {
    var _a, _b, _c, _d;
    return {
        insetBlockStart: 0,
        insetInlineStart: 0,
        inlineSize: (_b = (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : window.innerWidth,
        blockSize: (_d = (_c = window.visualViewport) === null || _c === void 0 ? void 0 : _c.height) !== null && _d !== void 0 ? _d : window.innerHeight
    };
}
function $45ec260cea817966$var$getDocumentRect(document) {
    const { insetBlockStart: insetBlockStart, insetInlineStart: insetInlineStart } = (0, $558545a5feadf817$export$322fb6cc2f904670)(document.documentElement);
    return {
        insetBlockStart: insetBlockStart,
        insetInlineStart: insetInlineStart,
        inlineSize: document.documentElement.scrollWidth,
        blockSize: document.documentElement.scrollHeight
    };
}


function $129a117414eb7922$export$2e2bcd8739ae039({ position: position, trackRef: trackRef, trackKey: trackKey, arrow: arrow, children: children, zIndex: zIndex, renderWithPortal: renderWithPortal, size: size, fixedWidth: fixedWidth, variant: variant, keepPosition: keepPosition, allowScrollToFit: allowScrollToFit, allowVerticalOverflow: allowVerticalOverflow }) {
    const bodyRef = (0, $acw62.useRef)(null);
    const contentRef = (0, $acw62.useRef)(null);
    const popoverRef = (0, $acw62.useRef)(null);
    const arrowRef = (0, $acw62.useRef)(null);
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    // Updates the position handler.
    const { updatePositionHandler: updatePositionHandler, popoverStyle: popoverStyle, internalPosition: internalPosition, positionHandlerRef: positionHandlerRef } = (0, $45ec260cea817966$export$2e2bcd8739ae039)({
        popoverRef: popoverRef,
        bodyRef: bodyRef,
        arrowRef: arrowRef,
        trackRef: trackRef,
        contentRef: contentRef,
        allowScrollToFit: allowScrollToFit,
        allowVerticalOverflow: allowVerticalOverflow,
        preferredPosition: position,
        renderWithPortal: renderWithPortal,
        keepPosition: keepPosition
    });
    // Recalculate position when properties change.
    (0, $acw62.useLayoutEffect)(()=>{
        updatePositionHandler();
    }, [
        updatePositionHandler,
        trackKey
    ]);
    // Recalculate position when content size changes.
    (0, $444535e54951fdea$export$683480f191c0e3ea)(contentRef, ()=>{
        updatePositionHandler(true);
    });
    // Recalculate position on DOM events.
    (0, $acw62.useLayoutEffect)(()=>{
        /*
        This is a heuristic. Some layout changes are caused by user clicks (e.g. toggling the tools panel, submitting a form),
        and by tracking the click event we can adapt the popover's position to the new layout.
    
        TODO: extend this to Enter and Spacebar?
        */ const onClick = (event)=>{
            if (// Do not update position if keepPosition is true.
            keepPosition || // If the click was on the trigger, this will make the popover appear or disappear,
            // so no need to update its position either in this case.
            (0, $af285507a4cbfe46$export$2e2bcd8739ae039)(trackRef.current, event.target)) return;
            requestAnimationFrame(()=>{
                updatePositionHandler();
            });
        };
        const updatePositionOnResize = ()=>requestAnimationFrame(()=>updatePositionHandler());
        const refreshPosition = ()=>requestAnimationFrame(()=>positionHandlerRef.current());
        window.addEventListener("click", onClick);
        window.addEventListener("resize", updatePositionOnResize);
        window.addEventListener("scroll", refreshPosition, true);
        return ()=>{
            window.removeEventListener("click", onClick);
            window.removeEventListener("resize", updatePositionOnResize);
            window.removeEventListener("scroll", refreshPosition, true);
        };
    }, [
        keepPosition,
        positionHandlerRef,
        trackRef,
        updatePositionHandler
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: popoverRef,
        style: Object.assign(Object.assign({}, popoverStyle), {
            zIndex: zIndex
        }),
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039).container, isRefresh && (0, $350807ffd27dc31c$export$2e2bcd8739ae039).refresh)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: arrowRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039)[`container-arrow`], (0, $350807ffd27dc31c$export$2e2bcd8739ae039)[`container-arrow-position-${internalPosition}`]),
        "aria-hidden": true
    }, arrow(internalPosition)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: bodyRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039)["container-body"], (0, $350807ffd27dc31c$export$2e2bcd8739ae039)[`container-body-size-${size}`], {
            [(0, $350807ffd27dc31c$export$2e2bcd8739ae039)["fixed-width"]]: fixedWidth,
            [(0, $350807ffd27dc31c$export$2e2bcd8739ae039)[`container-body-variant-${variant}`]]: variant
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: contentRef
    }, children)));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// When updating the list of key codes, don't forget
// to modify corresponding list in test-utils
// to avoid failing unit tests
var $bb11bd44b752b968$export$e9e0d96f49f57c33;
(function(KeyCode) {
    KeyCode[KeyCode["pageUp"] = 33] = "pageUp";
    KeyCode[KeyCode["pageDown"] = 34] = "pageDown";
    KeyCode[KeyCode["end"] = 35] = "end";
    KeyCode[KeyCode["home"] = 36] = "home";
    KeyCode[KeyCode["backspace"] = 8] = "backspace";
    KeyCode[KeyCode["space"] = 32] = "space";
    KeyCode[KeyCode["down"] = 40] = "down";
    KeyCode[KeyCode["left"] = 37] = "left";
    KeyCode[KeyCode["right"] = 39] = "right";
    KeyCode[KeyCode["up"] = 38] = "up";
    KeyCode[KeyCode["escape"] = 27] = "escape";
    KeyCode[KeyCode["enter"] = 13] = "enter";
    KeyCode[KeyCode["tab"] = 9] = "tab";
    KeyCode[KeyCode["shift"] = 16] = "shift";
    KeyCode[KeyCode["control"] = 17] = "control";
    KeyCode[KeyCode["alt"] = 18] = "alt";
    KeyCode[KeyCode["meta"] = 91] = "meta";
})($bb11bd44b752b968$export$e9e0d96f49f57c33 || ($bb11bd44b752b968$export$e9e0d96f49f57c33 = {}));




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $de7ebe5c886b994d$export$2e2bcd8739ae039({ focusNextCallback: focusNextCallback, disabled: disabled = false }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        tabIndex: disabled ? -1 : 0,
        onFocus: focusNextCallback
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Credits to
// https://github.com/theKashey/focus-lock/blob/33f8b4bd9675d2605b15e2e4015b77fe35fbd6d0/src/utils/tabbables.ts
const $eaddf2de854ee801$var$tabbables = [
    "button:enabled",
    "select:enabled",
    "textarea:enabled",
    "input:enabled",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
].join(",");
function $eaddf2de854ee801$export$3fcce23e1e72b35b(container) {
    return Array.prototype.slice.call(container.querySelectorAll($eaddf2de854ee801$var$tabbables));
}
function $eaddf2de854ee801$export$f6768025e418420e(container) {
    return $eaddf2de854ee801$export$3fcce23e1e72b35b(container).filter((element)=>element.tabIndex !== -1);
}
function $eaddf2de854ee801$export$748138f04a69bf21(container) {
    var _a;
    const focusables = $eaddf2de854ee801$export$f6768025e418420e(container);
    return (_a = focusables[0]) !== null && _a !== void 0 ? _a : null;
}
function $eaddf2de854ee801$export$73e81fa65335a75b(container) {
    var _a;
    const focusables = $eaddf2de854ee801$export$f6768025e418420e(container);
    return (_a = focusables[focusables.length - 1]) !== null && _a !== void 0 ? _a : null;
}


function $48646398710f9406$var$FocusLock({ className: className, disabled: disabled, autoFocus: autoFocus, restoreFocus: restoreFocus, children: children }, ref) {
    const returnFocusToRef = (0, $acw62.useRef)(null);
    const containerRef = (0, $acw62.useRef)(null);
    const focusFirst = ()=>{
        var _a;
        if (containerRef.current) (_a = (0, $eaddf2de854ee801$export$748138f04a69bf21)(containerRef.current)) === null || _a === void 0 || _a.focus();
    };
    const focusLast = ()=>{
        var _a;
        if (containerRef.current) (_a = (0, $eaddf2de854ee801$export$73e81fa65335a75b)(containerRef.current)) === null || _a === void 0 || _a.focus();
    };
    // Captures focus when `autoFocus` is set, and the component is mounted or
    // `disabled` changes from true to false.
    (0, $acw62.useEffect)(()=>{
        if (autoFocus && !disabled) {
            returnFocusToRef.current = document.activeElement;
            focusFirst();
        }
    }, [
        autoFocus,
        disabled
    ]);
    // Restore focus if `restoreFocus` is set, and `disabled` changes from false
    // to true.
    const [previouslyDisabled, setPreviouslyDisabled] = (0, $acw62.useState)(!!disabled);
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (previouslyDisabled !== !!disabled) {
            setPreviouslyDisabled(!!disabled);
            if (restoreFocus && disabled) {
                (_a = returnFocusToRef.current) === null || _a === void 0 || _a.focus();
                returnFocusToRef.current = null;
            }
        }
    }, [
        previouslyDisabled,
        disabled,
        restoreFocus
    ]);
    // Restore focus if `restoreFocus` is set and the component is unmounted.
    // Using a callback ref for this is safer than using useEffect cleanups.
    const restoreFocusHandler = (0, $acw62.useCallback)((elem)=>{
        var _a;
        if (elem === null && restoreFocus) {
            (_a = returnFocusToRef.current) === null || _a === void 0 || _a.focus();
            returnFocusToRef.current = null;
        }
    }, [
        restoreFocus
    ]);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            focusFirst: focusFirst
        }));
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(containerRef, restoreFocusHandler);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $de7ebe5c886b994d$export$2e2bcd8739ae039), {
        disabled: disabled,
        focusNextCallback: focusLast
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        ref: mergedRef
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $de7ebe5c886b994d$export$2e2bcd8739ae039), {
        disabled: disabled,
        focusNextCallback: focusFirst
    }));
}
var $48646398710f9406$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($48646398710f9406$var$FocusLock);




function $763097fcb7ec031e$export$2e2bcd8739ae039({ dismissButton: showDismissButton, dismissAriaLabel: dismissAriaLabel, header: header, children: children, onDismiss: onDismiss, variant: variant, overflowVisible: overflowVisible, className: className, ariaLabelledby: ariaLabelledby }) {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("popover");
    const labelledById = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("awsui-popover-");
    const dismissButtonFocused = (0, $acw62.useRef)(false);
    const dismissButtonRef = (0, $acw62.useRef)(null);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).escape) {
            event.stopPropagation();
            onDismiss === null || onDismiss === void 0 || onDismiss();
        }
    }, [
        onDismiss
    ]);
    // Implement our own auto-focus rather than using FocusLock's,
    // because we also want to focus the dismiss button when it
    // is added dynamically (e.g. in chart popovers)
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (showDismissButton && !dismissButtonFocused.current) (_a = dismissButtonRef.current) === null || _a === void 0 || _a.focus({
            preventScroll: true
        });
        dismissButtonFocused.current = showDismissButton;
    }, [
        showDismissButton
    ]);
    const dismissButton = (showDismissButton !== null && showDismissButton !== void 0 ? showDismissButton : null) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $350807ffd27dc31c$export$2e2bcd8739ae039).dismiss
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        variant: "icon",
        formAction: "none",
        iconName: "close",
        className: (0, $350807ffd27dc31c$export$2e2bcd8739ae039)["dismiss-control"],
        ariaLabel: i18n("dismissAriaLabel", dismissAriaLabel),
        onClick: ()=>onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss(),
        ref: dismissButtonRef
    }));
    const isDialog = showDismissButton;
    const shouldTrapFocus = showDismissButton && variant !== "annotation";
    const dialogProps = isDialog ? {
        role: "dialog",
        "aria-modal": shouldTrapFocus ? true : undefined,
        "aria-labelledby": ariaLabelledby !== null && ariaLabelledby !== void 0 ? ariaLabelledby : header ? labelledById : undefined
    } : {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039).body, className, {
            [(0, $350807ffd27dc31c$export$2e2bcd8739ae039)["body-overflow-visible"]]: overflowVisible === "both"
        }),
        onKeyDown: onKeyDown
    }, dialogProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48646398710f9406$export$2e2bcd8739ae039), {
        disabled: !shouldTrapFocus,
        autoFocus: false
    }, header && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039)["header-row"], showDismissButton && (0, $350807ffd27dc31c$export$2e2bcd8739ae039)["has-dismiss"])
    }, dismissButton, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $350807ffd27dc31c$export$2e2bcd8739ae039).header,
        id: labelledById
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", null, header))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: !header && showDismissButton ? (0, $350807ffd27dc31c$export$2e2bcd8739ae039)["has-dismiss"] : undefined
    }, !header && dismissButton, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039).content, {
            [(0, $350807ffd27dc31c$export$2e2bcd8739ae039)["content-overflow-visible"]]: !!overflowVisible
        })
    }, children))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



function $014cec8599be1408$var$manageDefaultContainer(setState) {
    const newContainer = document.createElement("div");
    document.body.appendChild(newContainer);
    setState(newContainer);
    return ()=>{
        document.body.removeChild(newContainer);
    };
}
function $014cec8599be1408$var$manageAsyncContainer(getContainer, removeContainer, setState) {
    let newContainer;
    getContainer().then((container)=>{
        newContainer = container;
        setState(container);
    }, (error)=>{
        console.warn("[AwsUi] [portal]: failed to load portal root", error);
    });
    return ()=>{
        removeContainer(newContainer);
    };
}
function $014cec8599be1408$export$2e2bcd8739ae039({ container: container, getContainer: getContainer, removeContainer: removeContainer, children: children }) {
    const [activeContainer, setActiveContainer] = (0, $acw62.useState)(container !== null && container !== void 0 ? container : null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (container) {
            setActiveContainer(container);
            return;
        }
        if (0, $bf737c197e11d40f$export$df77466336fe5355) {
            if (getContainer && !removeContainer) (0, $dd646455762bc7b9$export$5b28268982f175ba)("portal", "`removeContainer` is required when `getContainer` is provided");
            if (!getContainer && removeContainer) (0, $dd646455762bc7b9$export$5b28268982f175ba)("portal", "`getContainer` is required when `removeContainer` is provided");
        }
        if (getContainer && removeContainer) return $014cec8599be1408$var$manageAsyncContainer(getContainer, removeContainer, setActiveContainer);
        return $014cec8599be1408$var$manageDefaultContainer(setActiveContainer);
    }, [
        container,
        getContainer,
        removeContainer
    ]);
    return activeContainer && (0, $11492dca620dcaa5$exports.createPortal)(children, activeContainer);
}




var $0c2548ea1dbf37f8$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1qprf_160mh_5"
};


function $76f4c84fd1bac364$export$2e2bcd8739ae039({ value: value, trackRef: trackRef, trackKey: trackKey, className: className, contentAttributes: contentAttributes = {}, position: position = "top" }) {
    if (!trackKey && (typeof value === "string" || typeof value === "number")) trackKey = value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $014cec8599be1408$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $0c2548ea1dbf37f8$export$2e2bcd8739ae039).root, className)
    }, contentAttributes, {
        "data-testid": trackKey
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
        in: true
    }, ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $129a117414eb7922$export$2e2bcd8739ae039), {
            trackRef: trackRef,
            trackKey: trackKey,
            size: "small",
            fixedWidth: false,
            position: position,
            arrow: (position)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039).arrow, (0, $350807ffd27dc31c$export$2e2bcd8739ae039)[`arrow-position-${position}`])
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: (0, $350807ffd27dc31c$export$2e2bcd8739ae039)["arrow-outer"]
                }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: (0, $350807ffd27dc31c$export$2e2bcd8739ae039)["arrow-inner"]
                }))
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $763097fcb7ec031e$export$2e2bcd8739ae039), {
            dismissButton: false,
            dismissAriaLabel: undefined,
            onDismiss: undefined,
            header: undefined
        }, value)))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $b36e5053a31bf154$export$2e2bcd8739ae039(description) {
    const id = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)();
    return {
        targetProps: {
            "aria-describedby": description ? id : undefined
        },
        descriptionEl: description ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            id: id,
            hidden: true
        }, description) : null,
        descriptionId: id
    };
}


const $3aceff6b46a02363$export$6e98354c7167985b = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { children: children, iconName: iconName, __iconClass: __iconClass, onClick: onClick, onFollow: onFollow, iconAlign: iconAlign = "left", iconUrl: iconUrl, iconSvg: iconSvg, iconAlt: iconAlt, variant: variant = "normal", loading: loading = false, loadingText: loadingText, disabled: disabled = false, disabledReason: disabledReason, wrapText: wrapText = true, href: href, target: target, rel: rel, download: download, formAction: formAction = "submit", ariaLabel: ariaLabel, ariaDescribedby: ariaDescribedby, ariaExpanded: ariaExpanded, ariaControls: ariaControls, fullWidth: fullWidth, badge: badge, __nativeAttributes: __nativeAttributes, __internalRootRef: __internalRootRef = null, __focusable: __focusable = false } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "children",
        "iconName",
        "__iconClass",
        "onClick",
        "onFollow",
        "iconAlign",
        "iconUrl",
        "iconSvg",
        "iconAlt",
        "variant",
        "loading",
        "loadingText",
        "disabled",
        "disabledReason",
        "wrapText",
        "href",
        "target",
        "rel",
        "download",
        "formAction",
        "ariaLabel",
        "ariaDescribedby",
        "ariaExpanded",
        "ariaControls",
        "fullWidth",
        "badge",
        "__nativeAttributes",
        "__internalRootRef",
        "__focusable"
    ]);
    const [showTooltip, setShowTooltip] = (0, $acw62.useState)(false);
    (0, $3de0f29144bb4e85$export$6661f6891a200a5f)("Button", href);
    const isAnchor = Boolean(href);
    const isNotInteractive = loading || disabled;
    const isDisabledWithReason = (variant === "normal" || variant === "primary") && !!disabledReason && disabled;
    const hasAriaDisabled = loading && !disabled || disabled && __focusable || isDisabledWithReason;
    const shouldHaveContent = children && [
        "icon",
        "inline-icon",
        "flashbar-icon",
        "modal-dismiss"
    ].indexOf(variant) === -1;
    const buttonRef = (0, $acw62.useRef)(null);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, buttonRef);
    const buttonContext = (0, $edea5ac281b34b48$export$d891409b33cf7746)();
    const uniqueId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("button");
    const { funnelInteractionId: funnelInteractionId } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const { stepNumber: stepNumber, stepNameSelector: stepNameSelector } = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const { subStepSelector: subStepSelector, subStepNameSelector: subStepNameSelector } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    const performanceMarkAttributes = (0, $d1a7bb38399fdadf$export$2ea7ecdb51f088f5)("primaryButton", variant === "primary", buttonRef, ()=>{
        var _a;
        return {
            loading: loading,
            disabled: disabled,
            text: (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.innerText
        };
    }, [
        loading,
        disabled
    ]);
    const { targetProps: targetProps, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(disabledReason);
    const handleClick = (event)=>{
        if (isNotInteractive) return event.preventDefault();
        if (isAnchor && (0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) {
            (0, $fc537b925f715587$export$d7e1721720edbb03)(onFollow, {
                href: href,
                target: target
            }, event);
            if ((iconName === "external" || target === "_blank") && funnelInteractionId) {
                const stepName = (0, $285a09b860d2bebc$export$ad08a5942dca04f8)(stepNameSelector);
                const subStepName = (0, $285a09b860d2bebc$export$ad08a5942dca04f8)(subStepNameSelector);
                (0, $54d511b0978bc73c$export$300ddd9f131af3a).externalLinkInteracted({
                    funnelInteractionId: funnelInteractionId,
                    stepNumber: stepNumber,
                    stepName: stepName,
                    stepNameSelector: stepNameSelector,
                    subStepSelector: subStepSelector,
                    subStepName: subStepName,
                    subStepNameSelector: subStepNameSelector,
                    elementSelector: (0, $285a09b860d2bebc$export$c0773214960ddccc)(uniqueId),
                    subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)()
                });
            }
        }
        const { altKey: altKey, button: button, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = event;
        (0, $fc537b925f715587$export$d7e1721720edbb03)(onClick, {
            altKey: altKey,
            button: button,
            ctrlKey: ctrlKey,
            metaKey: metaKey,
            shiftKey: shiftKey
        }, event);
        buttonContext.onClick({
            variant: variant
        });
    };
    const buttonClass = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(props.className, (0, $e49660893c408df4$export$2e2bcd8739ae039).button, (0, $e49660893c408df4$export$2e2bcd8739ae039)[`variant-${variant}`], {
        [(0, $e49660893c408df4$export$2e2bcd8739ae039).disabled]: isNotInteractive,
        [(0, $e49660893c408df4$export$2e2bcd8739ae039)["button-no-wrap"]]: !wrapText,
        [(0, $e49660893c408df4$export$2e2bcd8739ae039)["button-no-text"]]: !shouldHaveContent,
        [(0, $e49660893c408df4$export$2e2bcd8739ae039)["full-width"]]: shouldHaveContent && fullWidth,
        [(0, $e49660893c408df4$export$2e2bcd8739ae039).link]: isAnchor
    });
    const explicitTabIndex = __nativeAttributes && "tabIndex" in __nativeAttributes ? __nativeAttributes.tabIndex : undefined;
    const { tabIndex: tabIndex } = (0, $7f9661e47bcc5460$export$4cf30df7bba16ac9)(buttonRef, {
        tabIndex: isAnchor && isNotInteractive ? -1 : explicitTabIndex
    });
    const buttonProps = Object.assign(Object.assign(Object.assign(Object.assign({}, props), __nativeAttributes), performanceMarkAttributes), {
        tabIndex: tabIndex,
        // https://github.com/microsoft/TypeScript/issues/36659
        ref: (0, $adb603d9351d0211$export$74665b213cb5c4cf)(buttonRef, __internalRootRef),
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedby,
        "aria-expanded": ariaExpanded,
        "aria-controls": ariaControls,
        // add ariaLabel as `title` as visible hint text
        title: ariaLabel,
        className: buttonClass,
        onClick: handleClick,
        [(0, $285a09b860d2bebc$export$39e42cde97dfcad)]: uniqueId
    });
    const iconProps = {
        loading: loading,
        iconName: iconName,
        iconAlign: iconAlign,
        iconUrl: iconUrl,
        iconSvg: iconSvg,
        iconAlt: iconAlt,
        variant: variant,
        badge: badge,
        iconClass: __iconClass,
        iconSize: variant === "modal-dismiss" ? "medium" : "normal"
    };
    const buttonContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c055d7846609c581$export$c5a3a065f2cddabb), Object.assign({}, iconProps)), shouldHaveContent && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $e49660893c408df4$export$2e2bcd8739ae039).content
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c055d7846609c581$export$990119d7b3385d31), Object.assign({}, iconProps)));
    const { loadingButtonCount: loadingButtonCount } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    (0, $acw62.useEffect)(()=>{
        if (loading) {
            loadingButtonCount.current++;
            return ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                loadingButtonCount.current--;
            };
        }
    }, [
        loading,
        loadingButtonCount
    ]);
    if (isAnchor) return(// https://github.com/yannickcr/eslint-plugin-react/issues/2962
    // eslint-disable-next-line react/jsx-no-target-blank
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({}, buttonProps, {
        href: href,
        target: target,
        // security recommendation: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target
        rel: rel !== null && rel !== void 0 ? rel : target === "_blank" ? "noopener noreferrer" : undefined,
        "aria-disabled": isNotInteractive ? true : undefined,
        download: download
    }), buttonContent), loading && loadingText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), null, loadingText)));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({}, buttonProps, {
        type: formAction === "none" ? "button" : "submit",
        disabled: disabled && !__focusable && !isDisabledWithReason,
        "aria-disabled": hasAriaDisabled ? true : undefined,
        onFocus: isDisabledWithReason ? ()=>setShowTooltip(true) : undefined,
        onBlur: isDisabledWithReason ? ()=>setShowTooltip(false) : undefined,
        onMouseEnter: isDisabledWithReason ? ()=>setShowTooltip(true) : undefined,
        onMouseLeave: isDisabledWithReason ? ()=>setShowTooltip(false) : undefined
    }, isDisabledWithReason ? targetProps : {}), buttonContent, isDisabledWithReason && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, descriptionEl, showTooltip && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $76f4c84fd1bac364$export$2e2bcd8739ae039), {
        className: (0, $226dc03e7e835ea6$export$2e2bcd8739ae039)["disabled-reason-tooltip"],
        trackRef: buttonRef,
        value: disabledReason
    }))), loading && loadingText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), null, loadingText));
});
var $3aceff6b46a02363$export$2e2bcd8739ae039 = $3aceff6b46a02363$export$6e98354c7167985b;




var $287069b5043d9ece$export$2e2bcd8739ae039 = {
    "toggle-button": "awsui_toggle-button_16w0h_112uf_97",
    "close-button": "awsui_close-button_16w0h_112uf_132"
};


const $917b74cb04fa7906$export$e0ae33479bcb926a = {
    navigation: {
        TagName: "nav",
        iconName: "menu",
        getLabels: (labels = {})=>({
                mainLabel: labels.navigation,
                openLabel: labels.navigationToggle,
                closeLabel: labels.navigationClose
            })
    },
    tools: {
        TagName: "aside",
        iconName: "status-info",
        getLabels: (labels = {})=>({
                mainLabel: labels.tools,
                openLabel: labels.toolsToggle,
                closeLabel: labels.toolsClose
            })
    }
};
const $917b74cb04fa7906$export$d2b052e7b4be1756 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ariaLabel: ariaLabel, ariaExpanded: ariaExpanded, ariaControls: ariaControls, iconName: iconName, iconSvg: iconSvg, disabled: disabled, testId: testId, onClick: onClick, badge: badge }, ref)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $287069b5043d9ece$export$2e2bcd8739ae039)["toggle-button"]),
        "aria-label": ariaLabel,
        type: "button",
        onClick: onClick,
        disabled: disabled,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaExpanded ? undefined : true,
        "aria-controls": ariaControls,
        "data-testid": testId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        svg: iconSvg,
        name: iconName,
        badge: badge
    }));
});
const $917b74cb04fa7906$export$de65de8213222d10 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ariaLabel: ariaLabel, onClick: onClick }, ref)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $287069b5043d9ece$export$2e2bcd8739ae039)["close-button"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ref: ref,
        className: className,
        ariaLabel: ariaLabel,
        variant: "icon",
        formAction: "none",
        iconName: "close",
        onClick: onClick
    }));
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $ad928a6240f442f3$export$2e2bcd8739ae039 = {
    "button-dropdown": "awsui_button-dropdown_sne0l_1b2xj_97",
    "items-list-container": "awsui_items-list-container_sne0l_1b2xj_101",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_sne0l_1b2xj_1",
    "rotate-up": "awsui_rotate-up_sne0l_1b2xj_120",
    "rotate-down": "awsui_rotate-down_sne0l_1b2xj_135",
    "header": "awsui_header_sne0l_1b2xj_150",
    "title": "awsui_title_sne0l_1b2xj_161",
    "description": "awsui_description_sne0l_1b2xj_162",
    "split-trigger-wrapper": "awsui_split-trigger-wrapper_sne0l_1b2xj_166",
    "trigger-item": "awsui_trigger-item_sne0l_1b2xj_169",
    "trigger-button": "awsui_trigger-button_sne0l_1b2xj_172",
    "visual-refresh": "awsui_visual-refresh_sne0l_1b2xj_183",
    "split-trigger": "awsui_split-trigger_sne0l_1b2xj_166",
    "dropdown-trigger": "awsui_dropdown-trigger_sne0l_1b2xj_191",
    "test-utils-button-trigger": "awsui_test-utils-button-trigger_sne0l_1b2xj_195"
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $1ddb2649063bc7db$export$2e2bcd8739ae039 = {
    "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_qwoo0_qnerm_97",
    "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_qwoo0_qnerm_1",
    "refresh": "awsui_refresh_qwoo0_qnerm_118",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_qwoo0_qnerm_1",
    "root": "awsui_root_qwoo0_qnerm_147",
    "interior": "awsui_interior_qwoo0_qnerm_183",
    "dropdown": "awsui_dropdown_qwoo0_qnerm_97",
    "use-portal": "awsui_use-portal_qwoo0_qnerm_194",
    "is-empty": "awsui_is-empty_qwoo0_qnerm_240",
    "dropdown-drop-up": "awsui_dropdown-drop-up_qwoo0_qnerm_247",
    "with-limited-width": "awsui_with-limited-width_qwoo0_qnerm_251",
    "dropdown-drop-left": "awsui_dropdown-drop-left_qwoo0_qnerm_254",
    "dropdown-drop-right": "awsui_dropdown-drop-right_qwoo0_qnerm_261",
    "occupy-entire-width": "awsui_occupy-entire-width_qwoo0_qnerm_268",
    "stretch-beyond-trigger-width": "awsui_stretch-beyond-trigger-width_qwoo0_qnerm_271",
    "hide-block-border": "awsui_hide-block-border_qwoo0_qnerm_278",
    "open": "awsui_open_qwoo0_qnerm_287",
    "nowrap": "awsui_nowrap_qwoo0_qnerm_296",
    "dropdown-content": "awsui_dropdown-content_qwoo0_qnerm_97",
    "stretch-trigger-height": "awsui_stretch-trigger-height_qwoo0_qnerm_307"
};





var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




const $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_DEFAULT = 50;
const $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_MOBILE_VERTICAL = 19; // 50 - 31
const $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_MOBILE_HORIZONTAL = 20;
const $a1c35d16322b3b4d$var$getClosestParentDimensions = (element)=>{
    const parents = (0, $24d40242cc6554ee$export$f32edd573b1049e6)(element).map((element)=>{
        const { blockSize: blockSize, inlineSize: inlineSize, insetBlockStart: insetBlockStart, insetInlineStart: insetInlineStart } = (0, $558545a5feadf817$export$322fb6cc2f904670)(element);
        return {
            blockSize: blockSize,
            inlineSize: inlineSize,
            insetBlockStart: insetBlockStart,
            insetInlineStart: insetInlineStart
        };
    });
    return parents.shift();
};
const $a1c35d16322b3b4d$export$ba2e7617379b909c = (0, $1be283cfa47851a8$export$4adb988360925c51)("xxs");
const $a1c35d16322b3b4d$export$6b30263f9f864720 = ({ trigger: trigger, overflowParents: overflowParents, stretchWidth: stretchWidth = false, stretchHeight: stretchHeight = false, isMobile: isMobile })=>{
    const availableSpaceReserveVertical = stretchHeight ? 0 : isMobile ? $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_MOBILE_VERTICAL : $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_DEFAULT;
    const availableSpaceReserveHorizontal = stretchWidth ? 0 : isMobile ? $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_MOBILE_HORIZONTAL : $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_DEFAULT;
    const { insetBlockEnd: triggerBlockEnd, insetInlineStart: triggerInlineStart, insetInlineEnd: triggerInlineEnd } = (0, $558545a5feadf817$export$322fb6cc2f904670)(trigger);
    return overflowParents.reduce(({ blockStart: blockStart, blockEnd: blockEnd, inlineStart: inlineStart, inlineEnd: inlineEnd }, overflowParent)=>{
        const offsetTop = triggerBlockEnd - overflowParent.insetBlockStart;
        const currentBlockStart = offsetTop - trigger.offsetHeight - availableSpaceReserveVertical;
        const currentBlockEnd = overflowParent.blockSize - offsetTop - availableSpaceReserveVertical;
        const currentInlineStart = triggerInlineEnd - overflowParent.insetInlineStart - availableSpaceReserveHorizontal;
        const currentInlineEnd = overflowParent.insetInlineStart + overflowParent.inlineSize - triggerInlineStart - availableSpaceReserveHorizontal;
        return {
            blockStart: Math.min(blockStart, currentBlockStart),
            blockEnd: Math.min(blockEnd, currentBlockEnd),
            inlineStart: Math.min(inlineStart, currentInlineStart),
            inlineEnd: Math.min(inlineEnd, currentInlineEnd)
        };
    }, {
        blockStart: Number.MAX_VALUE,
        blockEnd: Number.MAX_VALUE,
        inlineStart: Number.MAX_VALUE,
        inlineEnd: Number.MAX_VALUE
    });
};
const $a1c35d16322b3b4d$export$8788e0fa4251ea97 = ({ trigger: trigger, overflowParents: overflowParents, isMobile: isMobile })=>{
    const AVAILABLE_SPACE_RESERVE_VERTICAL = isMobile ? $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_MOBILE_VERTICAL : $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_DEFAULT;
    const AVAILABLE_SPACE_RESERVE_HORIZONTAL = isMobile ? $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_MOBILE_HORIZONTAL : $a1c35d16322b3b4d$var$AVAILABLE_SPACE_RESERVE_DEFAULT;
    const { insetBlockEnd: triggerBlockEnd, insetBlockStart: triggerBlockStart, insetInlineStart: triggerInlineStart, insetInlineEnd: triggerInlineEnd } = (0, $558545a5feadf817$export$322fb6cc2f904670)(trigger);
    return overflowParents.reduce(({ blockStart: blockStart, blockEnd: blockEnd, inlineStart: inlineStart, inlineEnd: inlineEnd }, overflowParent)=>{
        const currentBlockStart = triggerBlockEnd - overflowParent.insetBlockStart - AVAILABLE_SPACE_RESERVE_VERTICAL;
        const currentBlockEnd = overflowParent.blockSize - triggerBlockStart + overflowParent.insetBlockStart - AVAILABLE_SPACE_RESERVE_VERTICAL;
        const currentInlineStart = triggerInlineStart - overflowParent.insetInlineStart - AVAILABLE_SPACE_RESERVE_HORIZONTAL;
        const currentInlineEnd = overflowParent.insetInlineStart + overflowParent.inlineSize - triggerInlineEnd - AVAILABLE_SPACE_RESERVE_HORIZONTAL;
        return {
            blockStart: Math.min(blockStart, currentBlockStart),
            blockEnd: Math.min(blockEnd, currentBlockEnd),
            inlineStart: Math.min(inlineStart, currentInlineStart),
            inlineEnd: Math.min(inlineEnd, currentInlineEnd)
        };
    }, {
        blockStart: Number.MAX_VALUE,
        blockEnd: Number.MAX_VALUE,
        inlineStart: Number.MAX_VALUE,
        inlineEnd: Number.MAX_VALUE
    });
};
const $a1c35d16322b3b4d$export$becc1b48c6679b33 = ({ triggerElement: triggerElement, dropdownElement: dropdownElement, desiredMinWidth: desiredMinWidth, stretchBeyondTriggerWidth: stretchBeyondTriggerWidth = false })=>{
    // Determine the width of the trigger
    const { inlineSize: triggerInlineSize } = (0, $558545a5feadf817$export$322fb6cc2f904670)(triggerElement);
    // Minimum width is determined by either an explicit number (desiredMinWidth) or the trigger width
    const minWidth = desiredMinWidth ? Math.min(triggerInlineSize, desiredMinWidth) : triggerInlineSize;
    // If stretchBeyondTriggerWidth is true, the maximum width is the XS breakpoint (465px) or the trigger width (if bigger).
    const maxWidth = stretchBeyondTriggerWidth ? Math.max($a1c35d16322b3b4d$export$ba2e7617379b909c, triggerInlineSize) : Number.MAX_VALUE;
    // Determine the actual dropdown width, the size that it "wants" to be
    const { inlineSize: requiredWidth } = (0, $558545a5feadf817$export$322fb6cc2f904670)(dropdownElement);
    // Try to achieve the required/desired width within the given parameters
    const idealWidth = Math.min(Math.max(requiredWidth, minWidth), maxWidth);
    return {
        idealWidth: idealWidth,
        minWidth: minWidth,
        triggerInlineSize: triggerInlineSize
    };
};
const $a1c35d16322b3b4d$export$9b21e9fccc33c5d4 = ({ triggerElement: triggerElement, dropdownElement: dropdownElement, desiredMinWidth: desiredMinWidth, expandToViewport: expandToViewport, stretchWidth: stretchWidth, stretchHeight: stretchHeight, isMobile: isMobile })=>{
    const overflowParents = (0, $24d40242cc6554ee$export$788cd595d1360cb2)({
        element: dropdownElement,
        excludeClosestParent: false,
        expandToViewport: expandToViewport,
        canExpandOutsideViewport: stretchHeight
    });
    const { idealWidth: idealWidth } = $a1c35d16322b3b4d$export$becc1b48c6679b33({
        triggerElement: triggerElement,
        dropdownElement: dropdownElement,
        desiredMinWidth: desiredMinWidth,
        stretchBeyondTriggerWidth: true
    });
    const availableSpace = $a1c35d16322b3b4d$export$6b30263f9f864720({
        trigger: triggerElement,
        overflowParents: overflowParents,
        stretchWidth: stretchWidth,
        stretchHeight: stretchHeight,
        isMobile: isMobile
    });
    return idealWidth <= availableSpace.inlineStart || idealWidth <= availableSpace.inlineEnd;
};
const $a1c35d16322b3b4d$export$7b2b760a2a5bbf54 = ({ triggerElement: triggerElement, dropdownElement: dropdownElement, overflowParents: overflowParents, minWidth: desiredMinWidth, preferCenter: preferCenter = false, stretchWidth: stretchWidth = false, stretchHeight: stretchHeight = false, isMobile: isMobile = false, stretchBeyondTriggerWidth: stretchBeyondTriggerWidth = false })=>{
    // Determine the space available around the dropdown that it can grow in
    const availableSpace = $a1c35d16322b3b4d$export$6b30263f9f864720({
        trigger: triggerElement,
        overflowParents: overflowParents,
        stretchWidth: stretchWidth,
        stretchHeight: stretchHeight,
        isMobile: isMobile
    });
    const { idealWidth: idealWidth, minWidth: minWidth, triggerInlineSize: triggerInlineSize } = $a1c35d16322b3b4d$export$becc1b48c6679b33({
        triggerElement: triggerElement,
        dropdownElement: dropdownElement,
        desiredMinWidth: desiredMinWidth,
        stretchBeyondTriggerWidth: stretchBeyondTriggerWidth
    });
    let dropInlineStart;
    let insetInlineStart = null;
    let inlineSize = idealWidth;
    //1. Can it be positioned with ideal width to the right?
    if (idealWidth <= availableSpace.inlineEnd) dropInlineStart = false;
    else if (idealWidth <= availableSpace.inlineStart) dropInlineStart = true;
    else {
        dropInlineStart = availableSpace.inlineStart > availableSpace.inlineEnd;
        inlineSize = Math.max(availableSpace.inlineStart, availableSpace.inlineEnd, minWidth);
    }
    if (preferCenter) {
        const spillOver = (idealWidth - triggerInlineSize) / 2;
        // availableSpace always includes the trigger width, but we want to exclude that
        const availableOutsideLeft = availableSpace.inlineStart - triggerInlineSize;
        const availableOutsideRight = availableSpace.inlineEnd - triggerInlineSize;
        const fitsInCenter = availableOutsideLeft >= spillOver && availableOutsideRight >= spillOver;
        if (fitsInCenter) insetInlineStart = -spillOver;
    }
    const dropBlockStart = availableSpace.blockEnd < dropdownElement.offsetHeight && availableSpace.blockStart > availableSpace.blockEnd;
    const availableHeight = dropBlockStart ? availableSpace.blockStart : availableSpace.blockEnd;
    // Try and crop the bottom item when all options can't be displayed, affordance for "there's more"
    const croppedHeight = stretchHeight ? availableHeight : Math.floor(availableHeight / 31) * 31 + 16;
    return {
        dropBlockStart: dropBlockStart,
        dropInlineStart: dropInlineStart,
        insetInlineStart: insetInlineStart === null ? "auto" : `${insetInlineStart}px`,
        blockSize: `${croppedHeight}px`,
        inlineSize: `${inlineSize}px`
    };
};
const $a1c35d16322b3b4d$export$321e5f17a0c3a6f2 = (trigger, dropdown, overflowParents, isMobile)=>{
    const availableSpace = $a1c35d16322b3b4d$export$8788e0fa4251ea97({
        trigger: trigger,
        overflowParents: overflowParents,
        isMobile: isMobile
    });
    const { insetBlockEnd: triggerBlockEnd, insetBlockStart: triggerBlockStart, inlineSize: triggerInlineSize } = (0, $558545a5feadf817$export$322fb6cc2f904670)(trigger);
    const { insetBlockStart: parentDropdownBlockStart, blockSize: parentDropdownHeight } = $a1c35d16322b3b4d$var$getClosestParentDimensions(trigger);
    let dropInlineStart;
    let { inlineSize: inlineSize } = (0, $558545a5feadf817$export$322fb6cc2f904670)(dropdown);
    const insetBlockStart = triggerBlockStart - parentDropdownBlockStart;
    if (inlineSize <= availableSpace.inlineEnd) dropInlineStart = false;
    else if (inlineSize <= availableSpace.inlineStart) dropInlineStart = true;
    else {
        dropInlineStart = availableSpace.inlineStart > availableSpace.inlineEnd;
        inlineSize = Math.max(availableSpace.inlineStart, availableSpace.inlineEnd);
    }
    const insetInlineStart = dropInlineStart ? 0 - inlineSize : triggerInlineSize;
    const dropBlockStart = availableSpace.blockEnd < dropdown.offsetHeight && availableSpace.blockStart > availableSpace.blockEnd;
    const insetBlockEnd = dropBlockStart ? parentDropdownBlockStart + parentDropdownHeight - triggerBlockEnd : 0;
    const availableHeight = dropBlockStart ? availableSpace.blockStart : availableSpace.blockEnd;
    // Try and crop the bottom item when all options can't be displayed, affordance for "there's more"
    const croppedHeight = Math.floor(availableHeight / 31) * 31 + 16;
    return {
        dropBlockStart: dropBlockStart,
        dropInlineStart: dropInlineStart,
        blockSize: `${croppedHeight}px`,
        inlineSize: `${inlineSize}px`,
        insetBlockStart: `${insetBlockStart}px`,
        insetBlockEnd: `${insetBlockEnd}px`,
        insetInlineStart: `${insetInlineStart}px`
    };
};
const $a1c35d16322b3b4d$export$b3ceb0cbf1056d98 = (dropdownElement, triggerElement, verticalContainerElement, interior, expandToViewport, preferCenter, stretchWidth, stretchHeight, isMobile, minWidth, stretchBeyondTriggerWidth)=>{
    // cleaning previously assigned values,
    // so that they are not reused in case of screen resize and similar events
    verticalContainerElement.style.maxBlockSize = "";
    dropdownElement.style.inlineSize = "";
    dropdownElement.style.insetBlockStart = "";
    dropdownElement.style.insetBlockEnd = "";
    dropdownElement.style.insetInlineStart = "";
    dropdownElement.classList.remove((0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["dropdown-drop-left"]);
    dropdownElement.classList.remove((0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["dropdown-drop-right"]);
    dropdownElement.classList.remove((0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["dropdown-drop-up"]);
    const overflowParents = (0, $24d40242cc6554ee$export$788cd595d1360cb2)({
        element: dropdownElement,
        excludeClosestParent: interior,
        expandToViewport: expandToViewport,
        canExpandOutsideViewport: stretchHeight
    });
    const position = interior ? $a1c35d16322b3b4d$export$321e5f17a0c3a6f2(triggerElement, dropdownElement, overflowParents, isMobile) : $a1c35d16322b3b4d$export$7b2b760a2a5bbf54({
        triggerElement: triggerElement,
        dropdownElement: dropdownElement,
        overflowParents: overflowParents,
        minWidth: minWidth,
        preferCenter: preferCenter,
        stretchWidth: stretchWidth,
        stretchHeight: stretchHeight,
        isMobile: isMobile,
        stretchBeyondTriggerWidth: stretchBeyondTriggerWidth
    });
    const triggerBox = triggerElement.getBoundingClientRect();
    return [
        position,
        triggerBox
    ];
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");

const $8856d0c7df08fd8d$var$contextMatch = /awsui-context-([\w-]+)/;
function $8856d0c7df08fd8d$export$c894375248ea16f2(elementRef) {
    const [value, setValue] = (0, $acw62.useState)("");
    (0, $acw62.useLayoutEffect)(()=>{
        var _a;
        if (elementRef.current) {
            const contextParent = (0, $38f6480185c49d6f$export$184ef262a758e3c4)(elementRef.current, (node)=>!!node.className.match($8856d0c7df08fd8d$var$contextMatch));
            setValue((_a = contextParent === null || contextParent === void 0 ? void 0 : contextParent.className.match($8856d0c7df08fd8d$var$contextMatch)[1]) !== null && _a !== void 0 ? _a : "");
        }
    }, [
        elementRef
    ]);
    return value;
}
function $8856d0c7df08fd8d$export$6c7ba3d6c6708d3(contextName) {
    return `awsui-context-${contextName}`;
}
function $8856d0c7df08fd8d$export$2e2bcd8739ae039({ contextName: contextName, className: className, children: children }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)($8856d0c7df08fd8d$export$6c7ba3d6c6708d3(contextName), className)
    }, children);
}




function $f509ecfba65f3bd6$export$464b090d8a567e1e(ref) {
    const colorMode = (0, $020c722843a7a503$export$8eda93b51c73aab)(ref);
    const densityMode = (0, $020c722843a7a503$export$e45e01e5e9ef1b27)(ref);
    const context = (0, $8856d0c7df08fd8d$export$c894375248ea16f2)(ref);
    const visualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    return (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
        "awsui-polaris-dark-mode awsui-dark-mode": colorMode === "dark",
        "awsui-polaris-compact-mode awsui-compact-mode": densityMode === "compact",
        "awsui-visual-refresh": visualRefresh,
        [`awsui-context-${context}`]: context
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $6dba20b13890af88$var$DropdownContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    position: "bottom-right"
});
function $6dba20b13890af88$export$22388a4cee803578({ children: children, position: position = "bottom-right" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6dba20b13890af88$var$DropdownContext.Provider, {
        value: {
            position: position
        }
    }, children);
}
function $6dba20b13890af88$export$28c3a9869c2838c2() {
    return (0, $acw62.useContext)($6dba20b13890af88$var$DropdownContext);
}






const $7c3a34cd41432ad1$var$customCSSPropertiesMap = {
    "maxContentWidth": "--awsui-max-content-width-g964ok",
    "minContentWidth": "--awsui-min-content-width-g964ok",
    "breadcrumbsGap": "--awsui-breadcrumbs-gap-g964ok",
    "contentGapLeft": "--awsui-content-gap-left-g964ok",
    "contentGapRight": "--awsui-content-gap-right-g964ok",
    "contentHeight": "--awsui-content-height-g964ok",
    "contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-g964ok",
    "contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-g964ok",
    "contentLayoutMainGap": "--awsui-content-layout-main-gap-g964ok",
    "defaultMaxContentWidth": "--awsui-default-max-content-width-g964ok",
    "defaultMinContentWidth": "--awsui-default-min-content-width-g964ok",
    "drawerSize": "--awsui-drawer-size-g964ok",
    "footerHeight": "--awsui-footer-height-g964ok",
    "headerGap": "--awsui-header-gap-g964ok",
    "headerHeight": "--awsui-header-height-g964ok",
    "layoutWidth": "--awsui-layout-width-g964ok",
    "mainGap": "--awsui-main-gap-g964ok",
    "mainOffsetLeft": "--awsui-main-offset-left-g964ok",
    "mainTemplateRows": "--awsui-main-template-rows-g964ok",
    "mobileBarHeight": "--awsui-mobile-bar-height-g964ok",
    "notificationsHeight": "--awsui-notifications-height-g964ok",
    "offsetTop": "--awsui-offset-top-g964ok",
    "overlapHeight": "--awsui-overlap-height-g964ok",
    "navigationWidth": "--awsui-navigation-width-g964ok",
    "splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-g964ok",
    "splitPanelReportedSize": "--awsui-split-panel-reported-size-g964ok",
    "splitPanelHeight": "--awsui-split-panel-height-g964ok",
    "splitPanelMinWidth": "--awsui-split-panel-min-width-g964ok",
    "splitPanelMaxWidth": "--awsui-split-panel-max-width-g964ok",
    "toolsMaxWidth": "--awsui-tools-max-width-g964ok",
    "toolsWidth": "--awsui-tools-width-g964ok",
    "toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-g964ok",
    "contentScrollMargin": "--awsui-content-scroll-margin-g964ok",
    "flashbarStackDepth": "--awsui-flashbar-stack-depth-g964ok",
    "flashbarStackIndex": "--awsui-flashbar-stack-index-g964ok",
    "flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-g964ok",
    "stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-g964ok",
    "stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-g964ok",
    "dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-g964ok",
    "spinnerRotatorFrom": "--awsui-spinner-rotator-from-g964ok",
    "spinnerRotatorTo": "--awsui-spinner-rotator-to-g964ok",
    "spinnerLineLeftFrom": "--awsui-spinner-line-left-from-g964ok",
    "spinnerLineLeftTo": "--awsui-spinner-line-left-to-g964ok",
    "spinnerLineRightFrom": "--awsui-spinner-line-right-from-g964ok",
    "spinnerLineRightTo": "--awsui-spinner-line-right-to-g964ok",
    "sliderLabelCount": "--awsui-slider-label-count-g964ok",
    "sliderTickCount": "--awsui-slider-tick-count-g964ok",
    "sliderReferenceColumn": "--awsui-slider-reference-column-g964ok",
    "sliderNextReferenceColumn": "--awsui-slider-next-reference-column-g964ok",
    "sliderMaxStart": "--awsui-slider-max-start-g964ok",
    "sliderMinEnd": "--awsui-slider-min-end-g964ok",
    "sliderRangeInlineSize": "--awsui-slider-range-inline-size-g964ok",
    "sliderTooltipPosition": "--awsui-slider-tooltip-position-g964ok",
    "togglesLeftWidth": "--awsui-toggles-left-width-g964ok",
    "togglesRightWidth": "--awsui-toggles-right-width-g964ok",
    "promptInputMaxRows": "--awsui-prompt-input-max-rows-g964ok",
    "promptInputScrollHeight": "--awsui-prompt-input-scroll-height-g964ok"
};
var $7c3a34cd41432ad1$export$2e2bcd8739ae039 = $7c3a34cd41432ad1$var$customCSSPropertiesMap;




const $1fd689c8894b21bd$var$DropdownContainer = ({ children: children, renderWithPortal: renderWithPortal = false, id: id, referrerId: referrerId, open: open })=>{
    if (renderWithPortal) {
        if (open) return (0, $11492dca620dcaa5$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            id: id,
            "data-awsui-referrer-id": referrerId
        }, children), document.body);
        else return null;
    } else return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
};
const $1fd689c8894b21bd$var$TransitionContent = ({ state: state, transitionRef: transitionRef, dropdownClasses: dropdownClasses, stretchWidth: stretchWidth, interior: interior, isRefresh: isRefresh, dropdownRef: dropdownRef, verticalContainerRef: verticalContainerRef, expandToViewport: expandToViewport, stretchBeyondTriggerWidth: stretchBeyondTriggerWidth, header: header, children: children, footer: footer, position: position, open: open, onMouseDown: onMouseDown, id: id, role: role, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby })=>{
    const contentRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(dropdownRef, transitionRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1ddb2649063bc7db$export$2e2bcd8739ae039).dropdown, dropdownClasses, {
            [(0, $1ddb2649063bc7db$export$2e2bcd8739ae039).open]: open,
            [(0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["with-limited-width"]]: !stretchWidth,
            [(0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["hide-block-border"]]: stretchWidth,
            [(0, $1ddb2649063bc7db$export$2e2bcd8739ae039).interior]: interior,
            [(0, $1ddb2649063bc7db$export$2e2bcd8739ae039).refresh]: isRefresh,
            [(0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["use-portal"]]: expandToViewport && !interior,
            [(0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["stretch-beyond-trigger-width"]]: stretchBeyondTriggerWidth
        }),
        ref: contentRef,
        id: id,
        role: role,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        "data-open": open,
        "data-animating": state !== "exited",
        "aria-hidden": !open,
        style: stretchBeyondTriggerWidth ? {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).dropdownDefaultMaxWidth]: `${0, $a1c35d16322b3b4d$export$ba2e7617379b909c}px`
        } : {},
        onMouseDown: onMouseDown
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["dropdown-content-wrapper"], !header && !children && (0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["is-empty"], isRefresh && (0, $1ddb2649063bc7db$export$2e2bcd8739ae039).refresh)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: verticalContainerRef,
        className: (0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["dropdown-content"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6dba20b13890af88$export$22388a4cee803578), {
        position: position
    }, header, children, footer))));
};
const $1fd689c8894b21bd$var$Dropdown = ({ children: children, trigger: trigger, open: open, onDropdownClose: onDropdownClose, onMouseDown: onMouseDown, header: header, footer: footer, dropdownId: dropdownId, stretchTriggerHeight: stretchTriggerHeight = false, stretchWidth: stretchWidth = true, stretchHeight: stretchHeight = false, stretchToTriggerWidth: stretchToTriggerWidth = true, stretchBeyondTriggerWidth: stretchBeyondTriggerWidth = false, expandToViewport: expandToViewport = false, preferCenter: preferCenter = false, interior: interior = false, minWidth: minWidth, scrollable: scrollable = true, loopFocus: loopFocus = expandToViewport, onFocus: onFocus, onBlur: onBlur, contentKey: contentKey, dropdownContentId: dropdownContentId, dropdownContentRole: dropdownContentRole, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby })=>{
    const wrapperRef = (0, $acw62.useRef)(null);
    const triggerRef = (0, $acw62.useRef)(null);
    const dropdownRef = (0, $acw62.useRef)(null);
    const dropdownContainerRef = (0, $acw62.useRef)(null);
    const verticalContainerRef = (0, $acw62.useRef)(null);
    // To keep track of the initial position (drop up/down) which is kept the same during fixed repositioning
    const fixedPosition = (0, $acw62.useRef)(null);
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const dropdownClasses = (0, $f509ecfba65f3bd6$export$464b090d8a567e1e)(triggerRef);
    const [position, setPosition] = (0, $acw62.useState)("bottom-right");
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const setDropdownPosition = (position, triggerBox, target, verticalContainer)=>{
        const entireWidth = !interior && stretchWidth;
        if (!stretchWidth) // 1px offset for dropdowns where the dropdown itself needs a border, rather than on the items
        verticalContainer.style.maxBlockSize = `${parseInt(position.blockSize) + 1}px`;
        else verticalContainer.style.maxBlockSize = position.blockSize;
        if (entireWidth && !expandToViewport) {
            if (stretchToTriggerWidth) target.classList.add((0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["occupy-entire-width"]);
        } else target.style.inlineSize = position.inlineSize;
        // Using styles for main dropdown to adjust its position as preferred alternative
        if (position.dropBlockStart && !interior) {
            target.classList.add((0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["dropdown-drop-up"]);
            if (!expandToViewport) target.style.insetBlockEnd = "100%";
        } else target.classList.remove((0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["dropdown-drop-up"]);
        target.classList.add(position.dropInlineStart ? (0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["dropdown-drop-left"] : (0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["dropdown-drop-right"]);
        if (position.insetInlineStart && position.insetInlineStart !== "auto") target.style.insetInlineStart = position.insetInlineStart;
        // Position normal overflow dropdowns with fixed positioning relative to viewport
        if (expandToViewport && !interior) {
            target.style.position = "fixed";
            if (position.dropBlockStart) target.style.insetBlockEnd = `calc(100% - ${triggerBox.top}px)`;
            else target.style.insetBlockStart = `${triggerBox.bottom}px`;
            if (position.dropInlineStart) target.style.insetInlineStart = `calc(${triggerBox.right}px - ${position.inlineSize})`;
            else target.style.insetInlineStart = `${triggerBox.left}px`;
            // Keep track of the initial dropdown position and direction.
            // Dropdown direction doesn't need to change as the user scrolls, just needs to stay attached to the trigger.
            fixedPosition.current = position;
            return;
        }
        // For an interior dropdown (the fly out) we need exact values for positioning
        // and classes are not enough
        // usage of relative position is impossible due to overwrite of overflow-x
        if (interior && $1fd689c8894b21bd$var$isInteriorPosition(position)) {
            if (position.dropBlockStart) target.style.insetBlockEnd = position.insetBlockEnd;
            else target.style.insetBlockStart = position.insetBlockStart;
            target.style.insetInlineStart = position.insetInlineStart;
        }
        if (position.dropBlockStart && position.dropInlineStart) setPosition("top-left");
        else if (position.dropBlockStart) setPosition("top-right");
        else if (position.dropInlineStart) setPosition("bottom-left");
        else setPosition("bottom-right");
    };
    const isOutsideDropdown = (element)=>(!wrapperRef.current || !(0, $4c778684f125e678$export$57d4cb221e1d1857)(wrapperRef.current, element)) && (!dropdownContainerRef.current || !(0, $4c778684f125e678$export$57d4cb221e1d1857)(dropdownContainerRef.current, element));
    const focusHandler = (event)=>{
        if (!event.relatedTarget || isOutsideDropdown(event.relatedTarget)) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus, event);
    };
    const blurHandler = (event)=>{
        if (!event.relatedTarget || isOutsideDropdown(event.relatedTarget)) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur, event);
    };
    // Prevent the dropdown width from stretching beyond the trigger width
    // if that is going to cause the dropdown to be cropped because of overflow
    const fixStretching = ()=>{
        const classNameToRemove = (0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["stretch-beyond-trigger-width"];
        if (open && stretchBeyondTriggerWidth && dropdownRef.current && triggerRef.current && dropdownRef.current.classList.contains(classNameToRemove) && !(0, $a1c35d16322b3b4d$export$9b21e9fccc33c5d4)({
            triggerElement: triggerRef.current,
            dropdownElement: dropdownRef.current,
            desiredMinWidth: minWidth,
            expandToViewport: expandToViewport,
            stretchWidth: stretchWidth,
            stretchHeight: stretchHeight,
            isMobile: isMobile
        })) dropdownRef.current.classList.remove(classNameToRemove);
    };
    (0, $444535e54951fdea$export$683480f191c0e3ea)(()=>dropdownRef.current, fixStretching);
    (0, $acw62.useLayoutEffect)(()=>{
        const onDropdownOpen = ()=>{
            if (open && dropdownRef.current && triggerRef.current && verticalContainerRef.current) {
                // calculate scroll width only for dropdowns that has a scrollbar and ignore it for date picker components
                if (scrollable) dropdownRef.current.classList.add((0, $1ddb2649063bc7db$export$2e2bcd8739ae039).nowrap);
                setDropdownPosition(...(0, $a1c35d16322b3b4d$export$b3ceb0cbf1056d98)(dropdownRef.current, triggerRef.current, verticalContainerRef.current, interior, expandToViewport, preferCenter, stretchWidth, stretchHeight, isMobile, minWidth, stretchBeyondTriggerWidth), dropdownRef.current, verticalContainerRef.current);
                if (scrollable) dropdownRef.current.classList.remove((0, $1ddb2649063bc7db$export$2e2bcd8739ae039).nowrap);
            }
        };
        onDropdownOpen();
        if (open) {
            // window may scroll when dropdown opens, for example when soft keyboard shows up
            window.addEventListener("scroll", onDropdownOpen);
            // only listen to window scroll within very short time after the dropdown opens
            // do not want to interfere dropdown position on scroll afterwards
            const timeoutId = setTimeout(()=>{
                window.removeEventListener("scroll", onDropdownOpen);
            }, 500);
            return ()=>{
                clearTimeout(timeoutId);
                window.removeEventListener("scroll", onDropdownOpen);
            };
        }
    // See AWSUI-13040
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open,
        dropdownRef,
        triggerRef,
        verticalContainerRef,
        interior,
        stretchWidth,
        isMobile,
        contentKey
    ]);
    // subscribe to outside click
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const clickListener = (e)=>{
            if (!(0, $4c778684f125e678$export$57d4cb221e1d1857)(dropdownRef.current, e.target) && !(0, $4c778684f125e678$export$57d4cb221e1d1857)(triggerRef.current, e.target)) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDropdownClose);
        };
        window.addEventListener("click", clickListener, true);
        return ()=>{
            window.removeEventListener("click", clickListener, true);
        };
    }, [
        open,
        onDropdownClose
    ]);
    // sync dropdown position on scroll and resize
    (0, $acw62.useLayoutEffect)(()=>{
        if (!expandToViewport || !open) return;
        const updateDropdownPosition = ()=>{
            if (triggerRef.current && dropdownRef.current && verticalContainerRef.current) {
                const triggerRect = (0, $558545a5feadf817$export$322fb6cc2f904670)(triggerRef.current);
                const target = dropdownRef.current;
                if (fixedPosition.current) {
                    if (fixedPosition.current.dropBlockStart) dropdownRef.current.style.insetBlockEnd = `calc(100% - ${triggerRect.insetBlockStart}px)`;
                    else target.style.insetBlockStart = `${triggerRect.insetBlockEnd}px`;
                    if (fixedPosition.current.dropInlineStart) target.style.insetInlineStart = `calc(${triggerRect.insetInlineEnd}px - ${fixedPosition.current.inlineSize})`;
                    else target.style.insetInlineStart = `${triggerRect.insetInlineStart}px`;
                }
            }
        };
        updateDropdownPosition();
        window.addEventListener("scroll", updateDropdownPosition, true);
        window.addEventListener("resize", updateDropdownPosition, true);
        return ()=>{
            window.removeEventListener("scroll", updateDropdownPosition, true);
            window.removeEventListener("resize", updateDropdownPosition, true);
        };
    }, [
        open,
        expandToViewport
    ]);
    const referrerId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1ddb2649063bc7db$export$2e2bcd8739ae039).root, interior && (0, $1ddb2649063bc7db$export$2e2bcd8739ae039).interior, stretchTriggerHeight && (0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["stretch-trigger-height"]),
        ref: wrapperRef,
        onFocus: focusHandler,
        onBlur: blurHandler
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: referrerId,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(stretchTriggerHeight && (0, $1ddb2649063bc7db$export$2e2bcd8739ae039)["stretch-trigger-height"]),
        ref: triggerRef
    }, trigger), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $de7ebe5c886b994d$export$2e2bcd8739ae039), {
        focusNextCallback: ()=>{
            var _a;
            return dropdownRef.current && ((_a = (0, $eaddf2de854ee801$export$748138f04a69bf21)(dropdownRef.current)) === null || _a === void 0 ? void 0 : _a.focus());
        },
        disabled: !open || !loopFocus
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1fd689c8894b21bd$var$DropdownContainer, {
        renderWithPortal: expandToViewport && !interior,
        id: dropdownId,
        referrerId: referrerId,
        open: open
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
        in: open !== null && open !== void 0 ? open : false,
        exit: false
    }, (state, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: dropdownContainerRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $de7ebe5c886b994d$export$2e2bcd8739ae039), {
            focusNextCallback: ()=>{
                var _a;
                return triggerRef.current && ((_a = (0, $eaddf2de854ee801$export$73e81fa65335a75b)(triggerRef.current)) === null || _a === void 0 ? void 0 : _a.focus());
            },
            disabled: !open || !loopFocus
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1fd689c8894b21bd$var$TransitionContent, {
            state: state,
            transitionRef: ref,
            dropdownClasses: dropdownClasses,
            open: open,
            stretchWidth: stretchWidth,
            interior: interior,
            header: header,
            expandToViewport: expandToViewport,
            stretchBeyondTriggerWidth: stretchBeyondTriggerWidth,
            footer: footer,
            onMouseDown: onMouseDown,
            isRefresh: isRefresh,
            dropdownRef: dropdownRef,
            verticalContainerRef: verticalContainerRef,
            position: position,
            id: dropdownContentId,
            role: dropdownContentRole,
            ariaLabelledby: ariaLabelledby,
            ariaDescribedby: ariaDescribedby
        }, children), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $de7ebe5c886b994d$export$2e2bcd8739ae039), {
            focusNextCallback: ()=>{
                var _a;
                return triggerRef.current && ((_a = (0, $eaddf2de854ee801$export$748138f04a69bf21)(triggerRef.current)) === null || _a === void 0 ? void 0 : _a.focus());
            },
            disabled: !open || !loopFocus
        })))));
};
const $1fd689c8894b21bd$var$isInteriorPosition = (position)=>position.insetBlockEnd !== undefined;
var $1fd689c8894b21bd$export$2e2bcd8739ae039 = $1fd689c8894b21bd$var$Dropdown;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $e58a724b895c53bc$export$2e2bcd8739ae039(items) {
    const itemToIndex = new Map();
    const indexToItem = new Map();
    const flatIndices = [];
    $e58a724b895c53bc$export$219e7a8d0539f56b(items, (item, index)=>{
        const indexKey = $e58a724b895c53bc$var$stringifyIndex(index);
        itemToIndex.set(item, indexKey);
        indexToItem.set(indexKey, item);
        flatIndices.push(indexKey);
    });
    return {
        getItem: (index)=>{
            const indexKey = $e58a724b895c53bc$var$stringifyIndex(index);
            return indexToItem.get(indexKey) || null;
        },
        getItemIndex: (item)=>{
            const indexKey = itemToIndex.get(item);
            if (!indexKey) throw new Error("Invariant violation: item is not found.");
            return $e58a724b895c53bc$var$parseIndex(indexKey);
        },
        getSequentialIndex: (index, direction)=>{
            const indexKey = $e58a724b895c53bc$var$stringifyIndex(index);
            const position = flatIndices.indexOf(indexKey);
            const nextIndexKey = flatIndices[position + direction];
            if (!nextIndexKey) return null;
            return $e58a724b895c53bc$var$parseIndex(nextIndexKey);
        },
        getParentIndex: (item)=>{
            const indexKey = itemToIndex.get(item);
            if (!indexKey) throw new Error("Invariant violation: item is not found.");
            const index = $e58a724b895c53bc$var$parseIndex(indexKey);
            // No parent
            if (index.length === 1) return null;
            return index.slice(0, index.length - 1);
        }
    };
}
function $e58a724b895c53bc$export$219e7a8d0539f56b(items, act, parentIndex = []) {
    items.forEach((item, index)=>{
        const itemIndex = [
            ...parentIndex,
            index
        ];
        act(item, itemIndex);
        if ((0, $36113732f360ff28$export$15306afaeadd4bdb)(item)) $e58a724b895c53bc$export$219e7a8d0539f56b(item.items, act, itemIndex);
    });
}
function $e58a724b895c53bc$var$stringifyIndex(index) {
    return index.join("-");
}
function $e58a724b895c53bc$var$parseIndex(index) {
    return index.split("-").map((it)=>parseInt(it));
}


const $36113732f360ff28$export$15306afaeadd4bdb = (item)=>item && item.items !== undefined;
const $36113732f360ff28$export$211c15450d7814f3 = (item)=>item && item.href !== undefined;
const $36113732f360ff28$export$15d7d26473d9c458 = (item)=>item && item.itemType === "checkbox";
const $36113732f360ff28$export$9d8ee2045b99eb06 = (item)=>item.external ? "_blank" : undefined;
function $36113732f360ff28$export$76dd2cf5deab69c6(source, target) {
    for(let index = 0; index < source.length; index++){
        if (source[index] !== target[index]) return false;
    }
    return true;
}
function $36113732f360ff28$export$22fe9d5ba1e722ce(left, right) {
    if (left.length !== right.length) return false;
    for(let index = 0; index < left.length; index++){
        if (left[index] !== right[index]) return false;
    }
    return true;
}
function $36113732f360ff28$export$31764348ecae41a2(items) {
    let hasCheckboxItems = false;
    (0, $e58a724b895c53bc$export$219e7a8d0539f56b)(items, (item)=>{
        if (item.itemType === "checkbox") hasCheckboxItems = true;
    });
    return hasCheckboxItems;
}



var $05774784c67f3e3d$export$2e2bcd8739ae039 = {
    "item-element": "awsui_item-element_93a1u_16wwy_97",
    "disabled": "awsui_disabled_93a1u_16wwy_109",
    "show-divider": "awsui_show-divider_93a1u_16wwy_116",
    "highlighted": "awsui_highlighted_93a1u_16wwy_119",
    "is-focused": "awsui_is-focused_93a1u_16wwy_134",
    "menu-item": "awsui_menu-item_93a1u_16wwy_139",
    "has-category-header": "awsui_has-category-header_93a1u_16wwy_154",
    "item-tooltip-wrapper": "awsui_item-tooltip-wrapper_93a1u_16wwy_154",
    "has-checkmark": "awsui_has-checkmark_93a1u_16wwy_154",
    "icon": "awsui_icon_93a1u_16wwy_158",
    "checkmark": "awsui_checkmark_93a1u_16wwy_162",
    "external-icon": "awsui_external-icon_93a1u_16wwy_169"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



const $b971696cf22f0db1$var$Arrow = (props)=>{
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039).arrow, props.position && (0, $350807ffd27dc31c$export$2e2bcd8739ae039)[`arrow-position-${props.position}`])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $350807ffd27dc31c$export$2e2bcd8739ae039)["arrow-outer"]
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $350807ffd27dc31c$export$2e2bcd8739ae039)["arrow-inner"], isVisualRefresh && (0, $350807ffd27dc31c$export$2e2bcd8739ae039).refresh)
    }));
};
var $b971696cf22f0db1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($b971696cf22f0db1$var$Arrow);







const $b3bc414964f00db1$var$DEFAULT_OPEN_TIMEOUT_IN_MS = 120;
function $b3bc414964f00db1$export$2e2bcd8739ae039({ children: children, content: content, position: position = "right", className: className }) {
    const ref = (0, $acw62.useRef)(null);
    const isReducedMotion = (0, $020c722843a7a503$export$6a42007cf1e7b6f8)(ref);
    const { open: open, triggerProps: triggerProps } = $b3bc414964f00db1$var$useTooltipOpen(isReducedMotion ? 0 : $b3bc414964f00db1$var$DEFAULT_OPEN_TIMEOUT_IN_MS);
    const portalClasses = (0, $f509ecfba65f3bd6$export$464b090d8a567e1e)(ref);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        ref: ref
    }, triggerProps, {
        className: className
    }), children, open && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $014cec8599be1408$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: portalClasses
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $129a117414eb7922$export$2e2bcd8739ae039), {
        size: "small",
        fixedWidth: false,
        position: position,
        trackRef: ref,
        arrow: (position)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b971696cf22f0db1$export$2e2bcd8739ae039), {
                position: position
            }),
        renderWithPortal: true,
        zIndex: 7000
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $763097fcb7ec031e$export$2e2bcd8739ae039), {
        dismissButton: false,
        dismissAriaLabel: undefined,
        header: null,
        onDismiss: ()=>{},
        overflowVisible: "both"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "button-dropdown-disabled-reason",
        role: "tooltip"
    }, content))))));
}
function $b3bc414964f00db1$var$useTooltipOpen(timeout) {
    const handle = (0, $acw62.useRef)();
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const close = ()=>{
        clearTimeout(handle.current);
        setIsOpen(false);
    };
    const open = ()=>setIsOpen(true);
    const openDelayed = ()=>{
        handle.current = setTimeout(open, timeout);
    };
    const onKeyDown = (e)=>{
        if (isOpen && $b3bc414964f00db1$var$isEscape(e.key)) {
            e.preventDefault();
            e.stopPropagation();
            close();
        }
    };
    const onFocus = openDelayed;
    const onBlur = close;
    return {
        open: isOpen,
        triggerProps: {
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyDown: onKeyDown
        }
    };
}
const $b3bc414964f00db1$var$isEscape = (key)=>key === "Escape" || key === "Esc";





/**
 * @returns attributes for a menuitem widget given parameters
 */ const $961ccbb638b2620b$export$9163b7ae6a25ed9 = ({ disabled: disabled, parent: parent, expanded: expanded })=>({
        role: "menuitem",
        "aria-disabled": disabled ? "true" : undefined,
        "aria-haspopup": parent ? "true" : undefined,
        "aria-expanded": expanded ? "true" : parent ? "false" : undefined
    });
const $961ccbb638b2620b$export$26300457f4d17b16 = ({ disabled: disabled, checked: checked })=>({
        role: "menuitemcheckbox",
        "aria-disabled": disabled ? "true" : undefined,
        "aria-checked": checked ? "true" : "false"
    });


const $a34fe9b438b4d7bf$var$ItemElement = ({ item: item, disabled: disabled, onItemActivate: onItemActivate, highlighted: highlighted, highlightItem: highlightItem, showDivider: showDivider, hasCategoryHeader: hasCategoryHeader, isKeyboardHighlighted: isKeyboardHighlighted = false, variant: variant = "normal" })=>{
    const isLink = (0, $36113732f360ff28$export$211c15450d7814f3)(item);
    const isCheckbox = (0, $36113732f360ff28$export$15d7d26473d9c458)(item);
    const onClick = (event)=>{
        // Stop propagation to parent node and handle event exclusively in here. This ensures
        // that no group will interfere with the default behavior of links
        event.stopPropagation();
        if (!isLink) event.preventDefault();
        if (!disabled) onItemActivate(item, event);
    };
    const onHover = ()=>{
        highlightItem(item);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $05774784c67f3e3d$export$2e2bcd8739ae039)["item-element"], (0, $05774784c67f3e3d$export$2e2bcd8739ae039)[`variant-${variant}`], {
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039).highlighted]: highlighted,
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039).disabled]: disabled,
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039)["has-category-header"]]: hasCategoryHeader,
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039)["has-checkmark"]]: isCheckbox,
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039)["show-divider"]]: showDivider,
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039)["is-focused"]]: isKeyboardHighlighted
        }),
        role: "presentation",
        "data-testid": item.id,
        "data-description": item.description,
        onClick: onClick,
        onMouseEnter: onHover,
        onTouchStart: onHover
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a34fe9b438b4d7bf$var$MenuItem, {
        item: item,
        disabled: disabled,
        highlighted: highlighted
    }));
};
function $a34fe9b438b4d7bf$var$MenuItem({ item: item, disabled: disabled, highlighted: highlighted }) {
    const menuItemRef = (0, $acw62.useRef)(null);
    const isCheckbox = (0, $36113732f360ff28$export$15d7d26473d9c458)(item);
    (0, $acw62.useEffect)(()=>{
        if (highlighted && menuItemRef.current) menuItemRef.current.focus();
    }, [
        highlighted
    ]);
    const isDisabledWithReason = disabled && item.disabledReason;
    const { targetProps: targetProps, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(item.disabledReason);
    const menuItemProps = Object.assign(Object.assign({
        className: (0, $05774784c67f3e3d$export$2e2bcd8739ae039)["menu-item"],
        lang: item.lang,
        ref: menuItemRef,
        // We are using the roving tabindex technique to manage the focus state of the dropdown.
        // The current element will always have tabindex=0 which means that it can be tabbed to,
        // while all other items have tabindex=-1 so we can focus them when necessary.
        tabIndex: highlighted ? 0 : -1
    }, isCheckbox ? (0, $961ccbb638b2620b$export$26300457f4d17b16)({
        disabled: disabled,
        checked: item.checked
    }) : (0, $961ccbb638b2620b$export$9163b7ae6a25ed9)({
        disabled: disabled
    })), isDisabledWithReason ? targetProps : {});
    const menuItem = (0, $36113732f360ff28$export$211c15450d7814f3)(item) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({}, menuItemProps, {
        href: !disabled ? item.href : undefined,
        target: (0, $36113732f360ff28$export$9d8ee2045b99eb06)(item),
        rel: item.external ? "noopener noreferrer" : undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a34fe9b438b4d7bf$var$MenuItemContent, {
        item: item,
        disabled: disabled
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, menuItemProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a34fe9b438b4d7bf$var$MenuItemContent, {
        item: item,
        disabled: disabled
    }));
    const { position: position } = (0, $6dba20b13890af88$export$28c3a9869c2838c2)();
    const tooltipPosition = position === "bottom-left" || position === "top-left" ? "left" : "right";
    return isDisabledWithReason ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b3bc414964f00db1$export$2e2bcd8739ae039), {
        content: item.disabledReason,
        position: tooltipPosition,
        className: (0, $05774784c67f3e3d$export$2e2bcd8739ae039)["item-tooltip-wrapper"]
    }, menuItem, descriptionEl) : menuItem;
}
const $a34fe9b438b4d7bf$var$MenuItemContent = ({ item: item, disabled: disabled })=>{
    const hasIcon = !!(item.iconName || item.iconUrl || item.iconSvg);
    const hasExternal = (0, $36113732f360ff28$export$211c15450d7814f3)(item) && item.external;
    const isCheckbox = (0, $36113732f360ff28$export$15d7d26473d9c458)(item);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, isCheckbox && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a34fe9b438b4d7bf$var$MenuItemCheckmark, {
        checked: item.checked,
        disabled: disabled
    }), hasIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a34fe9b438b4d7bf$var$MenuItemIcon, {
        name: item.iconName,
        url: item.iconUrl,
        svg: item.iconSvg,
        alt: item.iconAlt,
        badge: item.badge
    }), item.text, hasExternal && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a34fe9b438b4d7bf$var$ExternalIcon, {
        disabled: disabled,
        ariaLabel: item.externalIconAriaLabel
    }));
};
const $a34fe9b438b4d7bf$var$MenuItemIcon = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $05774784c67f3e3d$export$2e2bcd8739ae039).icon
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), Object.assign({}, props)));
// Toggle has aria-hidden set because it's just used as a graphical element,
// a11y attributes for the checkmark are communicated through the role and aria-checked state
// of the menu element item.
const $a34fe9b438b4d7bf$var$MenuItemCheckmark = ({ disabled: disabled, checked: checked })=>{
    const checkmark = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        variant: disabled ? "disabled" : "normal",
        name: "check"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $05774784c67f3e3d$export$2e2bcd8739ae039).icon, (0, $05774784c67f3e3d$export$2e2bcd8739ae039).checkmark, {
            [(0, $05774784c67f3e3d$export$2e2bcd8739ae039).disabled]: disabled
        }),
        "aria-hidden": "true",
        style: {
            visibility: checked ? "visible" : "hidden"
        }
    }, checkmark);
};
const $a34fe9b438b4d7bf$var$ExternalIcon = ({ disabled: disabled, ariaLabel: ariaLabel })=>{
    const icon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        variant: disabled ? "disabled" : "normal",
        name: "external"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $05774784c67f3e3d$export$2e2bcd8739ae039)["external-icon"],
        role: ariaLabel ? "img" : undefined,
        "aria-label": ariaLabel
    }, icon);
};
var $a34fe9b438b4d7bf$export$2e2bcd8739ae039 = $a34fe9b438b4d7bf$var$ItemElement;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $faef8237080e4d9e$export$2e2bcd8739ae039 = {
    "header": "awsui_header_16mm3_qvubm_97",
    "disabled": "awsui_disabled_16mm3_qvubm_114",
    "expandable-header": "awsui_expandable-header_16mm3_qvubm_118",
    "rolled-down": "awsui_rolled-down_16mm3_qvubm_129",
    "highlighted": "awsui_highlighted_16mm3_qvubm_132",
    "is-focused": "awsui_is-focused_16mm3_qvubm_150",
    "category": "awsui_category_16mm3_qvubm_155",
    "expandable": "awsui_expandable_16mm3_qvubm_118",
    "variant-navigation": "awsui_variant-navigation_16mm3_qvubm_170",
    "expand-icon": "awsui_expand-icon_16mm3_qvubm_177",
    "expand-icon-up": "awsui_expand-icon-up_16mm3_qvubm_184",
    "expand-icon-right": "awsui_expand-icon-right_16mm3_qvubm_187",
    "items-list-container": "awsui_items-list-container_16mm3_qvubm_205",
    "in-dropdown": "awsui_in-dropdown_16mm3_qvubm_214"
};








const $2363ad66200e58be$var$ExpandableCategoryElement = ({ item: item, onItemActivate: onItemActivate, onGroupToggle: onGroupToggle, targetItem: targetItem, isHighlighted: isHighlighted, isKeyboardHighlight: isKeyboardHighlight, isExpanded: isExpanded, lastInDropdown: lastInDropdown, highlightItem: highlightItem, disabled: disabled, expandToViewport: expandToViewport, variant: variant })=>{
    const highlighted = isHighlighted(item);
    const expanded = isExpanded(item);
    const isKeyboardHighlighted = isKeyboardHighlight(item);
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (triggerRef.current && highlighted && !expanded) triggerRef.current.focus();
    }, [
        expanded,
        highlighted
    ]);
    const onClick = (event)=>{
        var _a;
        if (!disabled) {
            event.preventDefault();
            onGroupToggle(item, event);
            (_a = triggerRef.current) === null || _a === void 0 || _a.focus();
        }
    };
    const onHover = ()=>{
        highlightItem(item);
    };
    const isDisabledWithReason = !!item.disabledReason && item.disabled;
    const { targetProps: targetProps, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(item.disabledReason);
    const trigger = item.text && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039).header, (0, $faef8237080e4d9e$export$2e2bcd8739ae039)["expandable-header"], (0, $faef8237080e4d9e$export$2e2bcd8739ae039)[`variant-${variant}`], {
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).disabled]: disabled,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).highlighted]: highlighted,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039)["is-focused"]]: isKeyboardHighlighted
        }),
        // We are using the roving tabindex technique to manage the focus state of the dropdown.
        // The current element will always have tabindex=0 which means that it can be tabbed to,
        // while all other items have tabindex=-1 so we can focus them when necessary.
        tabIndex: highlighted ? 0 : -1,
        ref: triggerRef
    }, (0, $961ccbb638b2620b$export$9163b7ae6a25ed9)({
        parent: true,
        expanded: expanded,
        disabled: disabled
    }), isDisabledWithReason ? targetProps : {}), item.text, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039)["expand-icon"], (0, $faef8237080e4d9e$export$2e2bcd8739ae039)["expand-icon-right"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "caret-down-filled"
    })));
    let content;
    // If the category element is disabled, we do not render a dropdown.
    // Screenreaders are confused by additional sections
    if (isDisabledWithReason) content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b3bc414964f00db1$export$2e2bcd8739ae039), {
        content: item.disabledReason
    }, trigger, descriptionEl);
    else if (disabled) content = trigger;
    else content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1fd689c8894b21bd$export$2e2bcd8739ae039), {
        open: expanded,
        stretchWidth: false,
        interior: true,
        expandToViewport: expandToViewport,
        trigger: trigger
    }, item.items && expanded && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        role: "menu",
        "aria-label": item.text,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039)["items-list-container"], (0, $faef8237080e4d9e$export$2e2bcd8739ae039)["in-dropdown"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $95690548a868d7d0$export$2e2bcd8739ae039), {
        items: item.items,
        onItemActivate: onItemActivate,
        onGroupToggle: onGroupToggle,
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        lastInDropdown: lastInDropdown,
        highlightItem: highlightItem,
        variant: variant
    })));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039).category, (0, $faef8237080e4d9e$export$2e2bcd8739ae039)[`variant-${variant}`], (0, $faef8237080e4d9e$export$2e2bcd8739ae039).expandable, {
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).expanded]: expanded,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).disabled]: disabled,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).highlighted]: highlighted
        }),
        role: "presentation",
        "data-testid": item.id,
        ref: ref,
        onClick: onClick,
        onMouseEnter: onHover,
        onTouchStart: onHover
    }, content);
};
var $2363ad66200e58be$export$2e2bcd8739ae039 = $2363ad66200e58be$var$ExpandableCategoryElement;



var $acw62 = parcelRequire("acw62");



const $d17284c265bc2b95$var$CategoryElement = ({ item: item, onItemActivate: onItemActivate, onGroupToggle: onGroupToggle, targetItem: targetItem, isHighlighted: isHighlighted, isKeyboardHighlight: isKeyboardHighlight, isExpanded: isExpanded, lastInDropdown: lastInDropdown, highlightItem: highlightItem, disabled: disabled, variant: variant })=>{
    // Hide the category title element from screen readers because it will be
    // provided as an ARIA label.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039).category, (0, $faef8237080e4d9e$export$2e2bcd8739ae039)[`variant-${variant}`], disabled && (0, $faef8237080e4d9e$export$2e2bcd8739ae039).disabled),
        role: "presentation",
        "aria-disabled": disabled ? "true" : undefined
    }, item.text && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039).header, {
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).disabled]: disabled
        }),
        "aria-hidden": "true"
    }, item.text), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: (0, $faef8237080e4d9e$export$2e2bcd8739ae039)["items-list-container"],
        role: "group",
        "aria-label": item.text
    }, item.items && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $95690548a868d7d0$export$2e2bcd8739ae039), {
        items: item.items,
        onItemActivate: onItemActivate,
        onGroupToggle: onGroupToggle,
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        lastInDropdown: lastInDropdown,
        highlightItem: highlightItem,
        categoryDisabled: disabled,
        hasCategoryHeader: !!item.text,
        variant: variant
    })));
};
var $d17284c265bc2b95$export$2e2bcd8739ae039 = $d17284c265bc2b95$var$CategoryElement;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $cbe5d6461765a476$export$2e2bcd8739ae039 = {
    "root": "awsui_root_14cnr_adl8i_97",
    "trigger": "awsui_trigger_14cnr_adl8i_134",
    "dropdown": "awsui_dropdown_14cnr_adl8i_137",
    "nowrap": "awsui_nowrap_14cnr_adl8i_148",
    "open": "awsui_open_14cnr_adl8i_151"
};


const $a22e606bd520344e$var$MobileExpandableGroup = ({ children: children, trigger: trigger, open: open })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $cbe5d6461765a476$export$2e2bcd8739ae039).root
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $cbe5d6461765a476$export$2e2bcd8739ae039).trigger
    }, trigger), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $cbe5d6461765a476$export$2e2bcd8739ae039).dropdown, {
            [(0, $cbe5d6461765a476$export$2e2bcd8739ae039).open]: open
        }),
        "data-open": open
    }, children));
};
var $a22e606bd520344e$export$2e2bcd8739ae039 = $a22e606bd520344e$var$MobileExpandableGroup;





const $93350c5f4fe1e921$var$MobileExpandableCategoryElement = ({ item: item, onItemActivate: onItemActivate, onGroupToggle: onGroupToggle, targetItem: targetItem, isHighlighted: isHighlighted, isKeyboardHighlight: isKeyboardHighlight, isExpanded: isExpanded, lastInDropdown: lastInDropdown, highlightItem: highlightItem, disabled: disabled, variant: variant })=>{
    const highlighted = isHighlighted(item);
    const expanded = isExpanded(item);
    const isKeyboardHighlighted = isKeyboardHighlight(item);
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, $acw62.useEffect)(()=>{
        if (triggerRef.current && highlighted && !expanded) triggerRef.current.focus();
    }, [
        expanded,
        highlighted
    ]);
    const onClick = (e)=>{
        if (!disabled) {
            e.preventDefault();
            onGroupToggle(item, e);
        }
    };
    const onHover = ()=>{
        highlightItem(item);
    };
    const isDisabledWithReason = !!item.disabledReason && item.disabled;
    const { targetProps: targetProps, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(item.disabledReason);
    const trigger = item.text && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039).header, (0, $faef8237080e4d9e$export$2e2bcd8739ae039)["expandable-header"], (0, $faef8237080e4d9e$export$2e2bcd8739ae039)[`variant-${variant}`], {
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).highlighted]: highlighted,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039)["rolled-down"]]: expanded,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).disabled]: disabled,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039)["is-focused"]]: isKeyboardHighlighted
        }),
        // We are using the roving tabindex technique to manage the focus state of the dropdown.
        // The current element will always have tabindex=0 which means that it can be tabbed to,
        // while all other items have tabindex=-1 so we can focus them when necessary.
        tabIndex: highlighted ? 0 : -1,
        ref: triggerRef
    }, (0, $961ccbb638b2620b$export$9163b7ae6a25ed9)({
        parent: true,
        disabled: disabled,
        expanded: expanded
    }), isDisabledWithReason ? targetProps : {}), item.text, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039)["expand-icon"], {
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039)["expand-icon-up"]]: expanded
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "caret-down-filled"
    })));
    let content;
    if (isDisabledWithReason) content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, descriptionEl, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b3bc414964f00db1$export$2e2bcd8739ae039), {
        content: item.disabledReason
    }, trigger));
    else if (disabled) content = trigger;
    else content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a22e606bd520344e$export$2e2bcd8739ae039), {
        open: expanded,
        trigger: trigger
    }, item.items && expanded && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        role: "menu",
        "aria-label": item.text,
        className: (0, $faef8237080e4d9e$export$2e2bcd8739ae039)["items-list-container"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $95690548a868d7d0$export$2e2bcd8739ae039), {
        items: item.items,
        onItemActivate: onItemActivate,
        onGroupToggle: onGroupToggle,
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        lastInDropdown: lastInDropdown,
        highlightItem: highlightItem,
        hasCategoryHeader: true,
        variant: variant
    })));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $faef8237080e4d9e$export$2e2bcd8739ae039).category, (0, $faef8237080e4d9e$export$2e2bcd8739ae039)[`variant-${variant}`], (0, $faef8237080e4d9e$export$2e2bcd8739ae039).expandable, {
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).expanded]: expanded,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).disabled]: disabled,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).highlighted]: highlighted || expanded,
            [(0, $faef8237080e4d9e$export$2e2bcd8739ae039).expandable]: true
        }),
        role: "presentation",
        onClick: onClick,
        onMouseEnter: onHover,
        onTouchStart: onHover,
        "data-testid": item.id
    }, content);
};
var $93350c5f4fe1e921$export$2e2bcd8739ae039 = $93350c5f4fe1e921$var$MobileExpandableCategoryElement;


function $95690548a868d7d0$export$2e2bcd8739ae039({ items: items, onItemActivate: onItemActivate, onGroupToggle: onGroupToggle, targetItem: targetItem, isHighlighted: isHighlighted, isKeyboardHighlight: isKeyboardHighlight, isExpanded: isExpanded, lastInDropdown: lastInDropdown, highlightItem: highlightItem, categoryDisabled: categoryDisabled = false, hasExpandableGroups: hasExpandableGroups = false, hasCategoryHeader: hasCategoryHeader = false, expandToViewport: expandToViewport = false, variant: variant = "normal" }) {
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const elements = items.map((item, index)=>{
        var _a, _b, _c, _d;
        if (!(0, $36113732f360ff28$export$15306afaeadd4bdb)(item)) {
            const showDivider = index === items.length - 1 && !lastInDropdown || (0, $36113732f360ff28$export$15306afaeadd4bdb)(items[index + 1]);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a34fe9b438b4d7bf$export$2e2bcd8739ae039), {
                key: index,
                item: item,
                onItemActivate: onItemActivate,
                disabled: (_a = item.disabled) !== null && _a !== void 0 ? _a : categoryDisabled,
                highlighted: isHighlighted(item),
                isKeyboardHighlighted: isKeyboardHighlight(item),
                highlightItem: highlightItem,
                showDivider: showDivider,
                hasCategoryHeader: hasCategoryHeader,
                variant: variant
            });
        }
        if (hasExpandableGroups) return item.text ? isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $93350c5f4fe1e921$export$2e2bcd8739ae039), {
            key: index,
            item: item,
            onItemActivate: onItemActivate,
            onGroupToggle: onGroupToggle,
            targetItem: targetItem,
            isHighlighted: isHighlighted,
            isKeyboardHighlight: isKeyboardHighlight,
            isExpanded: isExpanded,
            lastInDropdown: lastInDropdown && index === items.length - 1,
            highlightItem: highlightItem,
            disabled: (_b = item.disabled) !== null && _b !== void 0 ? _b : false,
            variant: variant
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2363ad66200e58be$export$2e2bcd8739ae039), {
            key: index,
            item: item,
            onItemActivate: onItemActivate,
            onGroupToggle: onGroupToggle,
            targetItem: targetItem,
            isHighlighted: isHighlighted,
            isKeyboardHighlight: isKeyboardHighlight,
            isExpanded: isExpanded,
            lastInDropdown: true,
            highlightItem: highlightItem,
            disabled: (_c = item.disabled) !== null && _c !== void 0 ? _c : false,
            expandToViewport: expandToViewport,
            variant: variant
        }) : null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d17284c265bc2b95$export$2e2bcd8739ae039), {
            key: index,
            item: item,
            onItemActivate: onItemActivate,
            onGroupToggle: onGroupToggle,
            targetItem: targetItem,
            isHighlighted: isHighlighted,
            isKeyboardHighlight: isKeyboardHighlight,
            isExpanded: isExpanded,
            lastInDropdown: lastInDropdown && index === items.length - 1,
            highlightItem: highlightItem,
            disabled: (_d = item.disabled) !== null && _d !== void 0 ? _d : false,
            variant: variant
        });
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, elements);
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $aff605ad4173beb7$export$7d3a09d5141ab1f4 = ({ onOpen: onOpen, onClose: onClose })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [openedWithKeyboard, setOpenedWithKeyboard] = (0, $acw62.useState)(false);
    const openDropdown = (isKeyboard)=>{
        if (!isOpen) {
            setIsOpen(true);
            setOpenedWithKeyboard(!!isKeyboard);
            onOpen === null || onOpen === void 0 || onOpen();
        }
    };
    const closeDropdown = ()=>{
        if (isOpen) {
            setIsOpen(false);
            onClose === null || onClose === void 0 || onClose();
        }
    };
    const toggleDropdown = ()=>{
        if (isOpen) closeDropdown();
        else openDropdown(false);
    };
    return {
        isOpen: isOpen,
        openDropdown: openDropdown,
        closeDropdown: closeDropdown,
        toggleDropdown: toggleDropdown,
        openedWithKeyboard: openedWithKeyboard
    };
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $6ece526d45739594$export$2e2bcd8739ae039({ startIndex: startIndex, expandedIndex: expandedIndex, getNext: getNext, hasExpandableGroups: hasExpandableGroups, isInRestrictedView: isInRestrictedView }) {
    const tryMove = (currentIndex)=>{
        var _a;
        const next = getNext(currentIndex);
        if (!next) return null;
        // Prevents stepping into disabled expandable groups. However,
        // it's possible to navigate nested groups.
        if (((_a = next.parent) === null || _a === void 0 ? void 0 : _a.disabled) && hasExpandableGroups) return tryMove(next.index);
        // it is not allowed to highlight groups when non-expandable
        if ((0, $36113732f360ff28$export$15306afaeadd4bdb)(next.item) && !hasExpandableGroups) return tryMove(next.index);
        // can only move within same parent unless is in restricted view
        if (hasExpandableGroups && !isInRestrictedView && !$6ece526d45739594$var$isSameParent(startIndex, next.index)) return tryMove(next.index);
        // in restricted view can only navigate to children if group is expanded
        if (hasExpandableGroups && isInRestrictedView && !$6ece526d45739594$var$isSameLevel(next.index, expandedIndex) && !$6ece526d45739594$var$isIncluded(expandedIndex, next.index)) return tryMove(next.index);
        return next.index;
    };
    return tryMove(startIndex);
}
function $6ece526d45739594$var$isSameParent(left, right) {
    return (0, $36113732f360ff28$export$22fe9d5ba1e722ce)(left.slice(0, -1), right.slice(0, -1));
}
function $6ece526d45739594$var$isSameLevel(left, right) {
    return left.length === right.length;
}
function $6ece526d45739594$var$isIncluded(parent, child) {
    return (0, $36113732f360ff28$export$22fe9d5ba1e722ce)(parent, child.slice(0, -1));
}


function $a4b3e8c6b24a6e84$export$2e2bcd8739ae039({ items: items, hasExpandableGroups: hasExpandableGroups, isInRestrictedView: isInRestrictedView = false }) {
    const [targetIndex, setTargetIndex] = (0, $acw62.useState)([]);
    const [expandedIndex, setExpandedIndex] = (0, $acw62.useState)([]);
    const [isUsingMouse, setIsUsingMouse] = (0, $acw62.useState)(true);
    const { getItem: getItem, getItemIndex: getItemIndex, getSequentialIndex: getSequentialIndex, getParentIndex: getParentIndex } = (0, $acw62.useMemo)(()=>(0, $e58a724b895c53bc$export$2e2bcd8739ae039)(items), [
        items
    ]);
    const targetItem = (0, $acw62.useMemo)(()=>getItem(targetIndex), [
        targetIndex,
        getItem
    ]);
    const isHighlighted = (0, $acw62.useCallback)((item)=>{
        const index = getItemIndex(item);
        return (0, $36113732f360ff28$export$76dd2cf5deab69c6)(index, targetIndex);
    }, [
        targetIndex,
        getItemIndex
    ]);
    // check if keyboard focus is on the element
    const isKeyboardHighlight = (0, $acw62.useCallback)((item)=>{
        const index = getItemIndex(item);
        return !isUsingMouse && (0, $36113732f360ff28$export$22fe9d5ba1e722ce)(index, targetIndex);
    }, [
        targetIndex,
        getItemIndex,
        isUsingMouse
    ]);
    const isExpanded = (0, $acw62.useCallback)((group)=>{
        const index = getItemIndex(group);
        return (0, $36113732f360ff28$export$76dd2cf5deab69c6)(index, expandedIndex);
    }, [
        expandedIndex,
        getItemIndex
    ]);
    const moveHighlight = (0, $acw62.useCallback)((direction)=>{
        const getNext = (index)=>{
            const nextIndex = getSequentialIndex(index, direction);
            const item = getItem(nextIndex || [
                -1
            ]);
            if (!nextIndex || !item) return null;
            const parentIndex = getParentIndex(item);
            const parentItem = parentIndex && getItem(parentIndex);
            return {
                index: nextIndex,
                item: item,
                parent: parentItem || undefined
            };
        };
        const nextIndex = (0, $6ece526d45739594$export$2e2bcd8739ae039)({
            startIndex: targetIndex,
            expandedIndex: expandedIndex,
            getNext: getNext,
            hasExpandableGroups: hasExpandableGroups,
            isInRestrictedView: isInRestrictedView
        });
        if (nextIndex) setTargetIndex(nextIndex);
    }, [
        targetIndex,
        expandedIndex,
        getItem,
        getSequentialIndex,
        getParentIndex,
        hasExpandableGroups,
        isInRestrictedView
    ]);
    const highlightItem = (0, $acw62.useCallback)((item)=>{
        setTargetIndex(getItemIndex(item));
    }, [
        getItemIndex
    ]);
    const expandGroup = (0, $acw62.useCallback)((group)=>{
        const groupIndex = group ? getItemIndex(group) : targetIndex;
        const firstChildIndex = [
            ...groupIndex,
            0
        ];
        // move to the first child item unless in restricted mode
        setTargetIndex(isInRestrictedView ? groupIndex : firstChildIndex);
        setExpandedIndex(groupIndex);
    }, [
        targetIndex,
        getItemIndex,
        isInRestrictedView
    ]);
    const collapseGroup = (0, $acw62.useCallback)(()=>{
        if (expandedIndex.length > 0) {
            setTargetIndex(expandedIndex);
            setExpandedIndex(expandedIndex.slice(0, -1));
        }
    }, [
        expandedIndex
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        setTargetIndex([]);
        setExpandedIndex([]);
    }, []);
    return {
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        moveHighlight: moveHighlight,
        highlightItem: highlightItem,
        expandGroup: expandGroup,
        collapseGroup: collapseGroup,
        reset: reset,
        setIsUsingMouse: setIsUsingMouse
    };
}


function $671527e64731e5aa$export$9df7c146789633dd({ items: items, onItemClick: onItemClick, onItemFollow: onItemFollow, onReturnFocus: onReturnFocus, hasExpandableGroups: hasExpandableGroups, isInRestrictedView: isInRestrictedView = false, expandToViewport: expandToViewport = false }) {
    const { targetItem: targetItem, isHighlighted: isHighlighted, isKeyboardHighlight: isKeyboardHighlight, isExpanded: isExpanded, highlightItem: highlightItem, moveHighlight: moveHighlight, expandGroup: expandGroup, collapseGroup: collapseGroup, reset: reset, setIsUsingMouse: setIsUsingMouse } = (0, $a4b3e8c6b24a6e84$export$2e2bcd8739ae039)({
        items: items,
        hasExpandableGroups: hasExpandableGroups,
        isInRestrictedView: isInRestrictedView
    });
    const _a = (0, $aff605ad4173beb7$export$7d3a09d5141ab1f4)({
        onClose: reset
    }), { isOpen: isOpen, closeDropdown: closeDropdown } = _a, openStateProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "isOpen",
        "closeDropdown"
    ]);
    const toggleDropdown = (options = {})=>{
        var _a;
        const moveHighlightOnOpen = (_a = options.moveHighlightOnOpen) !== null && _a !== void 0 ? _a : true;
        if (!isOpen && moveHighlightOnOpen) moveHighlight(1);
        openStateProps.toggleDropdown();
    };
    const onGroupToggle = (item)=>!isExpanded(item) ? expandGroup(item) : collapseGroup();
    const onItemActivate = (item, event)=>{
        const isCheckbox = (0, $36113732f360ff28$export$15d7d26473d9c458)(item);
        const isLink = (0, $36113732f360ff28$export$211c15450d7814f3)(item);
        const details = {
            id: item.id || "undefined",
            href: isLink ? item.href : undefined,
            external: isLink ? item.external : undefined,
            target: isLink ? (0, $36113732f360ff28$export$9d8ee2045b99eb06)(item) : undefined,
            checked: isCheckbox ? !item.checked : undefined
        };
        if (onItemFollow && isLink && (0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) (0, $fc537b925f715587$export$d7e1721720edbb03)(onItemFollow, details, event);
        if (onItemClick) (0, $fc537b925f715587$export$d7e1721720edbb03)(onItemClick, details, event);
        onReturnFocus();
        closeDropdown();
    };
    const doVerticalNavigation = (direction)=>{
        if (isOpen) moveHighlight(direction);
    };
    const openAndSelectFirst = (event)=>{
        toggleDropdown();
        event.preventDefault();
    };
    const actOnParentDropdown = (event)=>{
        // if there is no highlighted item we act on the trigger by opening or closing dropdown
        if (!targetItem) {
            if (isOpen && !isInRestrictedView) toggleDropdown();
            else openAndSelectFirst(event);
        } else if ((0, $36113732f360ff28$export$15306afaeadd4bdb)(targetItem)) onGroupToggle(targetItem, event);
        else onItemActivate(targetItem, event);
    };
    const activate = (event, isEnter)=>{
        setIsUsingMouse(false);
        // if item is a link we rely on default behavior of an anchor, no need to prevent
        if (targetItem && (0, $36113732f360ff28$export$211c15450d7814f3)(targetItem) && isEnter) return;
        event.preventDefault();
        actOnParentDropdown(event);
    };
    const onKeyDown = (event)=>{
        setIsUsingMouse(false);
        switch(event.keyCode){
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down:
                doVerticalNavigation(1);
                event.preventDefault();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up:
                doVerticalNavigation(-1);
                event.preventDefault();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space:
                // Prevent scrolling the list of items and highlighting the trigger
                event.preventDefault();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter:
                if (!(targetItem === null || targetItem === void 0 ? void 0 : targetItem.disabled)) activate(event, true);
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).left:
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right:
                if (targetItem && !targetItem.disabled && (0, $36113732f360ff28$export$15306afaeadd4bdb)(targetItem) && !isExpanded(targetItem)) expandGroup();
                else if (hasExpandableGroups) collapseGroup();
                event.preventDefault();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).escape:
                onReturnFocus();
                closeDropdown();
                event.preventDefault();
                if (isOpen) event.stopPropagation();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).tab:
                // When expanded to viewport the focus can't move naturally to the next element.
                // Returning the focus to the trigger instead.
                if (expandToViewport) onReturnFocus();
                closeDropdown();
                break;
        }
    };
    const onKeyUp = (event)=>{
        // We need to handle activating items with Space separately because there is a bug
        // in Firefox where changing the focus during a Space keydown event it will trigger
        // unexpected click events on the new element: https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
        if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space && !(targetItem === null || targetItem === void 0 ? void 0 : targetItem.disabled)) activate(event);
    };
    return {
        isOpen: isOpen,
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        highlightItem: highlightItem,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onItemActivate: onItemActivate,
        onGroupToggle: onGroupToggle,
        toggleDropdown: toggleDropdown,
        closeDropdown: closeDropdown,
        setIsUsingMouse: setIsUsingMouse
    };
}






var $acw62 = parcelRequire("acw62");




var $89495c474e85c0d6$export$2e2bcd8739ae039 = {
    "options-list": "awsui_options-list_19gcf_kye0l_97",
    "decrease-block-margin": "awsui_decrease-block-margin_19gcf_kye0l_147"
};



const $4b0a4cb0aaef194c$var$BOTTOM_TRIGGER_OFFSET = 80;
const $4b0a4cb0aaef194c$var$getItemIndex = (containerRef, event)=>{
    const target = (0, $38f6480185c49d6f$export$184ef262a758e3c4)(event.target, (element)=>element === containerRef.current || !!element.dataset.mouseTarget);
    const mouseTarget = target === null || target === void 0 ? void 0 : target.dataset.mouseTarget;
    return mouseTarget ? parseInt(mouseTarget) : -1;
};
const $4b0a4cb0aaef194c$var$OptionsList = (_a, ref)=>{
    var { open: open, statusType: statusType, children: children, nativeAttributes: nativeAttributes = {}, onKeyDown: onKeyDown, onBlur: onBlur, onFocus: onFocus, onLoadMore: onLoadMore, onMouseUp: onMouseUp, onMouseMove: onMouseMove, position: position = "relative", role: role = "listbox", decreaseBlockMargin: decreaseBlockMargin = false, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "open",
        "statusType",
        "children",
        "nativeAttributes",
        "onKeyDown",
        "onBlur",
        "onFocus",
        "onLoadMore",
        "onMouseUp",
        "onMouseMove",
        "position",
        "role",
        "decreaseBlockMargin",
        "ariaLabel",
        "ariaLabelledby",
        "ariaDescribedby"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const menuRef = (0, $acw62.useRef)(null);
    const handleScroll = (0, $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0)(()=>{
        const scrollContainer = menuRef === null || menuRef === void 0 ? void 0 : menuRef.current;
        if (scrollContainer) {
            const bottomEdgePosition = scrollContainer.scrollTop + scrollContainer.clientHeight;
            const remainingScrollHeight = scrollContainer.scrollHeight - bottomEdgePosition;
            if (remainingScrollHeight < $4b0a4cb0aaef194c$var$BOTTOM_TRIGGER_OFFSET) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onLoadMore);
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (open && statusType === "pending") handleScroll();
    }, [
        open,
        statusType,
        handleScroll
    ]);
    const className = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89495c474e85c0d6$export$2e2bcd8739ae039)["options-list"], {
        [(0, $89495c474e85c0d6$export$2e2bcd8739ae039)["decrease-block-margin"]]: decreaseBlockMargin
    });
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(ref, menuRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", Object.assign({}, baseProps, nativeAttributes, {
        className: className,
        ref: mergedRef,
        style: {
            position: position
        },
        role: role,
        onScroll: handleScroll,
        onKeyDown: (event)=>onKeyDown && (0, $fc537b925f715587$export$d23d807e6c464ee0)(onKeyDown, event),
        onMouseMove: (event)=>onMouseMove === null || onMouseMove === void 0 ? void 0 : onMouseMove($4b0a4cb0aaef194c$var$getItemIndex(menuRef, event)),
        onMouseUp: (event)=>onMouseUp === null || onMouseUp === void 0 ? void 0 : onMouseUp($4b0a4cb0aaef194c$var$getItemIndex(menuRef, event)),
        onBlur: (event)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur, {
                relatedTarget: event.relatedTarget
            }),
        onFocus: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus),
        tabIndex: -1,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby
    }), open && children);
};
var $4b0a4cb0aaef194c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($4b0a4cb0aaef194c$var$OptionsList);







var $acw62 = parcelRequire("acw62");



var $a3bb2b713f638a5c$export$2e2bcd8739ae039 = {
    "box": "awsui_box_18wu0_16wz6_108",
    "p-variant": "awsui_p-variant_18wu0_16wz6_108",
    "color-default": "awsui_color-default_18wu0_16wz6_108",
    "b-variant": "awsui_b-variant_18wu0_16wz6_108",
    "strong-variant": "awsui_strong-variant_18wu0_16wz6_108",
    "code-variant": "awsui_code-variant_18wu0_16wz6_108",
    "pre-variant": "awsui_pre-variant_18wu0_16wz6_108",
    "samp-variant": "awsui_samp-variant_18wu0_16wz6_108",
    "h1-variant": "awsui_h1-variant_18wu0_16wz6_112",
    "h2-variant": "awsui_h2-variant_18wu0_16wz6_112",
    "h3-variant": "awsui_h3-variant_18wu0_16wz6_112",
    "h4-variant": "awsui_h4-variant_18wu0_16wz6_112",
    "h5-variant": "awsui_h5-variant_18wu0_16wz6_112",
    "small-variant": "awsui_small-variant_18wu0_16wz6_116",
    "a-variant": "awsui_a-variant_18wu0_16wz6_120",
    "font-size-default": "awsui_font-size-default_18wu0_16wz6_124",
    "font-weight-default": "awsui_font-weight-default_18wu0_16wz6_164",
    "key-label-variant": "awsui_key-label-variant_18wu0_16wz6_206",
    "gen-ai-label-variant": "awsui_gen-ai-label-variant_18wu0_16wz6_213",
    "value-large-variant": "awsui_value-large-variant_18wu0_16wz6_220",
    "font-weight-heavy": "awsui_font-weight-heavy_18wu0_16wz6_227",
    "color-inverted": "awsui_color-inverted_18wu0_16wz6_232",
    "color-text-label": "awsui_color-text-label_18wu0_16wz6_235",
    "color-text-body-secondary": "awsui_color-text-body-secondary_18wu0_16wz6_238",
    "color-text-status-error": "awsui_color-text-status-error_18wu0_16wz6_241",
    "color-text-status-success": "awsui_color-text-status-success_18wu0_16wz6_244",
    "color-text-status-info": "awsui_color-text-status-info_18wu0_16wz6_247",
    "color-text-status-inactive": "awsui_color-text-status-inactive_18wu0_16wz6_250",
    "color-text-status-warning": "awsui_color-text-status-warning_18wu0_16wz6_253",
    "color-inherit": "awsui_color-inherit_18wu0_16wz6_256",
    "font-size-body-s": "awsui_font-size-body-s_18wu0_16wz6_259",
    "font-size-body-m": "awsui_font-size-body-m_18wu0_16wz6_264",
    "font-size-heading-xs": "awsui_font-size-heading-xs_18wu0_16wz6_268",
    "font-size-heading-s": "awsui_font-size-heading-s_18wu0_16wz6_272",
    "font-size-heading-m": "awsui_font-size-heading-m_18wu0_16wz6_277",
    "font-size-heading-l": "awsui_font-size-heading-l_18wu0_16wz6_282",
    "font-size-heading-xl": "awsui_font-size-heading-xl_18wu0_16wz6_287",
    "font-size-display-l": "awsui_font-size-display-l_18wu0_16wz6_292",
    "font-weight-light": "awsui_font-weight-light_18wu0_16wz6_297",
    "font-weight-normal": "awsui_font-weight-normal_18wu0_16wz6_300",
    "font-weight-bold": "awsui_font-weight-bold_18wu0_16wz6_303",
    "t-left": "awsui_t-left_18wu0_16wz6_310",
    "t-right": "awsui_t-right_18wu0_16wz6_314",
    "t-center": "awsui_t-center_18wu0_16wz6_318",
    "p-n": "awsui_p-n_18wu0_16wz6_326",
    "p-top-n": "awsui_p-top-n_18wu0_16wz6_331",
    "p-vertical-n": "awsui_p-vertical-n_18wu0_16wz6_332",
    "p-right-n": "awsui_p-right-n_18wu0_16wz6_336",
    "p-horizontal-n": "awsui_p-horizontal-n_18wu0_16wz6_337",
    "p-bottom-n": "awsui_p-bottom-n_18wu0_16wz6_341",
    "p-left-n": "awsui_p-left-n_18wu0_16wz6_346",
    "p-xxxs": "awsui_p-xxxs_18wu0_16wz6_351",
    "p-top-xxxs": "awsui_p-top-xxxs_18wu0_16wz6_356",
    "p-vertical-xxxs": "awsui_p-vertical-xxxs_18wu0_16wz6_357",
    "p-right-xxxs": "awsui_p-right-xxxs_18wu0_16wz6_361",
    "p-horizontal-xxxs": "awsui_p-horizontal-xxxs_18wu0_16wz6_362",
    "p-bottom-xxxs": "awsui_p-bottom-xxxs_18wu0_16wz6_366",
    "p-left-xxxs": "awsui_p-left-xxxs_18wu0_16wz6_371",
    "p-xxs": "awsui_p-xxs_18wu0_16wz6_376",
    "p-top-xxs": "awsui_p-top-xxs_18wu0_16wz6_381",
    "p-vertical-xxs": "awsui_p-vertical-xxs_18wu0_16wz6_382",
    "p-right-xxs": "awsui_p-right-xxs_18wu0_16wz6_386",
    "p-horizontal-xxs": "awsui_p-horizontal-xxs_18wu0_16wz6_387",
    "p-bottom-xxs": "awsui_p-bottom-xxs_18wu0_16wz6_391",
    "p-left-xxs": "awsui_p-left-xxs_18wu0_16wz6_396",
    "p-xs": "awsui_p-xs_18wu0_16wz6_401",
    "p-top-xs": "awsui_p-top-xs_18wu0_16wz6_406",
    "p-vertical-xs": "awsui_p-vertical-xs_18wu0_16wz6_407",
    "p-right-xs": "awsui_p-right-xs_18wu0_16wz6_411",
    "p-horizontal-xs": "awsui_p-horizontal-xs_18wu0_16wz6_412",
    "p-bottom-xs": "awsui_p-bottom-xs_18wu0_16wz6_416",
    "p-left-xs": "awsui_p-left-xs_18wu0_16wz6_421",
    "p-s": "awsui_p-s_18wu0_16wz6_426",
    "p-top-s": "awsui_p-top-s_18wu0_16wz6_431",
    "p-vertical-s": "awsui_p-vertical-s_18wu0_16wz6_432",
    "p-right-s": "awsui_p-right-s_18wu0_16wz6_436",
    "p-horizontal-s": "awsui_p-horizontal-s_18wu0_16wz6_437",
    "p-bottom-s": "awsui_p-bottom-s_18wu0_16wz6_441",
    "p-left-s": "awsui_p-left-s_18wu0_16wz6_446",
    "p-m": "awsui_p-m_18wu0_16wz6_451",
    "p-top-m": "awsui_p-top-m_18wu0_16wz6_456",
    "p-vertical-m": "awsui_p-vertical-m_18wu0_16wz6_457",
    "p-right-m": "awsui_p-right-m_18wu0_16wz6_461",
    "p-horizontal-m": "awsui_p-horizontal-m_18wu0_16wz6_462",
    "p-bottom-m": "awsui_p-bottom-m_18wu0_16wz6_466",
    "p-left-m": "awsui_p-left-m_18wu0_16wz6_471",
    "p-l": "awsui_p-l_18wu0_16wz6_346",
    "p-top-l": "awsui_p-top-l_18wu0_16wz6_481",
    "p-vertical-l": "awsui_p-vertical-l_18wu0_16wz6_482",
    "p-right-l": "awsui_p-right-l_18wu0_16wz6_486",
    "p-horizontal-l": "awsui_p-horizontal-l_18wu0_16wz6_487",
    "p-bottom-l": "awsui_p-bottom-l_18wu0_16wz6_491",
    "p-left-l": "awsui_p-left-l_18wu0_16wz6_496",
    "p-xl": "awsui_p-xl_18wu0_16wz6_501",
    "p-top-xl": "awsui_p-top-xl_18wu0_16wz6_506",
    "p-vertical-xl": "awsui_p-vertical-xl_18wu0_16wz6_507",
    "p-right-xl": "awsui_p-right-xl_18wu0_16wz6_511",
    "p-horizontal-xl": "awsui_p-horizontal-xl_18wu0_16wz6_512",
    "p-bottom-xl": "awsui_p-bottom-xl_18wu0_16wz6_516",
    "p-left-xl": "awsui_p-left-xl_18wu0_16wz6_521",
    "p-xxl": "awsui_p-xxl_18wu0_16wz6_526",
    "p-top-xxl": "awsui_p-top-xxl_18wu0_16wz6_531",
    "p-vertical-xxl": "awsui_p-vertical-xxl_18wu0_16wz6_532",
    "p-right-xxl": "awsui_p-right-xxl_18wu0_16wz6_536",
    "p-horizontal-xxl": "awsui_p-horizontal-xxl_18wu0_16wz6_537",
    "p-bottom-xxl": "awsui_p-bottom-xxl_18wu0_16wz6_541",
    "p-left-xxl": "awsui_p-left-xxl_18wu0_16wz6_546",
    "p-xxxl": "awsui_p-xxxl_18wu0_16wz6_551",
    "p-top-xxxl": "awsui_p-top-xxxl_18wu0_16wz6_556",
    "p-vertical-xxxl": "awsui_p-vertical-xxxl_18wu0_16wz6_557",
    "p-right-xxxl": "awsui_p-right-xxxl_18wu0_16wz6_561",
    "p-horizontal-xxxl": "awsui_p-horizontal-xxxl_18wu0_16wz6_562",
    "p-bottom-xxxl": "awsui_p-bottom-xxxl_18wu0_16wz6_566",
    "p-left-xxxl": "awsui_p-left-xxxl_18wu0_16wz6_571",
    "m-n": "awsui_m-n_18wu0_16wz6_576",
    "m-top-n": "awsui_m-top-n_18wu0_16wz6_581",
    "m-vertical-n": "awsui_m-vertical-n_18wu0_16wz6_582",
    "m-right-n": "awsui_m-right-n_18wu0_16wz6_586",
    "m-horizontal-n": "awsui_m-horizontal-n_18wu0_16wz6_587",
    "m-bottom-n": "awsui_m-bottom-n_18wu0_16wz6_591",
    "m-left-n": "awsui_m-left-n_18wu0_16wz6_596",
    "m-xxxs": "awsui_m-xxxs_18wu0_16wz6_601",
    "m-top-xxxs": "awsui_m-top-xxxs_18wu0_16wz6_606",
    "m-vertical-xxxs": "awsui_m-vertical-xxxs_18wu0_16wz6_607",
    "m-right-xxxs": "awsui_m-right-xxxs_18wu0_16wz6_611",
    "m-horizontal-xxxs": "awsui_m-horizontal-xxxs_18wu0_16wz6_612",
    "m-bottom-xxxs": "awsui_m-bottom-xxxs_18wu0_16wz6_616",
    "m-left-xxxs": "awsui_m-left-xxxs_18wu0_16wz6_621",
    "m-xxs": "awsui_m-xxs_18wu0_16wz6_626",
    "m-top-xxs": "awsui_m-top-xxs_18wu0_16wz6_631",
    "m-vertical-xxs": "awsui_m-vertical-xxs_18wu0_16wz6_632",
    "m-right-xxs": "awsui_m-right-xxs_18wu0_16wz6_636",
    "m-horizontal-xxs": "awsui_m-horizontal-xxs_18wu0_16wz6_637",
    "m-bottom-xxs": "awsui_m-bottom-xxs_18wu0_16wz6_641",
    "m-left-xxs": "awsui_m-left-xxs_18wu0_16wz6_646",
    "m-xs": "awsui_m-xs_18wu0_16wz6_651",
    "m-top-xs": "awsui_m-top-xs_18wu0_16wz6_656",
    "m-vertical-xs": "awsui_m-vertical-xs_18wu0_16wz6_657",
    "m-right-xs": "awsui_m-right-xs_18wu0_16wz6_661",
    "m-horizontal-xs": "awsui_m-horizontal-xs_18wu0_16wz6_662",
    "m-bottom-xs": "awsui_m-bottom-xs_18wu0_16wz6_666",
    "m-left-xs": "awsui_m-left-xs_18wu0_16wz6_671",
    "m-s": "awsui_m-s_18wu0_16wz6_676",
    "m-top-s": "awsui_m-top-s_18wu0_16wz6_681",
    "m-vertical-s": "awsui_m-vertical-s_18wu0_16wz6_682",
    "m-right-s": "awsui_m-right-s_18wu0_16wz6_686",
    "m-horizontal-s": "awsui_m-horizontal-s_18wu0_16wz6_687",
    "m-bottom-s": "awsui_m-bottom-s_18wu0_16wz6_691",
    "m-left-s": "awsui_m-left-s_18wu0_16wz6_696",
    "m-m": "awsui_m-m_18wu0_16wz6_701",
    "m-top-m": "awsui_m-top-m_18wu0_16wz6_706",
    "m-vertical-m": "awsui_m-vertical-m_18wu0_16wz6_707",
    "m-right-m": "awsui_m-right-m_18wu0_16wz6_711",
    "m-horizontal-m": "awsui_m-horizontal-m_18wu0_16wz6_712",
    "m-bottom-m": "awsui_m-bottom-m_18wu0_16wz6_716",
    "m-left-m": "awsui_m-left-m_18wu0_16wz6_721",
    "m-l": "awsui_m-l_18wu0_16wz6_596",
    "m-top-l": "awsui_m-top-l_18wu0_16wz6_731",
    "m-vertical-l": "awsui_m-vertical-l_18wu0_16wz6_732",
    "m-right-l": "awsui_m-right-l_18wu0_16wz6_736",
    "m-horizontal-l": "awsui_m-horizontal-l_18wu0_16wz6_737",
    "m-bottom-l": "awsui_m-bottom-l_18wu0_16wz6_741",
    "m-left-l": "awsui_m-left-l_18wu0_16wz6_746",
    "m-xl": "awsui_m-xl_18wu0_16wz6_751",
    "m-top-xl": "awsui_m-top-xl_18wu0_16wz6_756",
    "m-vertical-xl": "awsui_m-vertical-xl_18wu0_16wz6_757",
    "m-right-xl": "awsui_m-right-xl_18wu0_16wz6_761",
    "m-horizontal-xl": "awsui_m-horizontal-xl_18wu0_16wz6_762",
    "m-bottom-xl": "awsui_m-bottom-xl_18wu0_16wz6_766",
    "m-left-xl": "awsui_m-left-xl_18wu0_16wz6_771",
    "m-xxl": "awsui_m-xxl_18wu0_16wz6_776",
    "m-top-xxl": "awsui_m-top-xxl_18wu0_16wz6_781",
    "m-vertical-xxl": "awsui_m-vertical-xxl_18wu0_16wz6_782",
    "m-right-xxl": "awsui_m-right-xxl_18wu0_16wz6_786",
    "m-horizontal-xxl": "awsui_m-horizontal-xxl_18wu0_16wz6_787",
    "m-bottom-xxl": "awsui_m-bottom-xxl_18wu0_16wz6_791",
    "m-left-xxl": "awsui_m-left-xxl_18wu0_16wz6_796",
    "m-xxxl": "awsui_m-xxxl_18wu0_16wz6_801",
    "m-top-xxxl": "awsui_m-top-xxxl_18wu0_16wz6_806",
    "m-vertical-xxxl": "awsui_m-vertical-xxxl_18wu0_16wz6_807",
    "m-right-xxxl": "awsui_m-right-xxxl_18wu0_16wz6_811",
    "m-horizontal-xxxl": "awsui_m-horizontal-xxxl_18wu0_16wz6_812",
    "m-bottom-xxxl": "awsui_m-bottom-xxxl_18wu0_16wz6_816",
    "m-left-xxxl": "awsui_m-left-xxxl_18wu0_16wz6_821",
    "d-block": "awsui_d-block_18wu0_16wz6_826",
    "d-inline": "awsui_d-inline_18wu0_16wz6_829",
    "d-inline-block": "awsui_d-inline-block_18wu0_16wz6_832",
    "d-none": "awsui_d-none_18wu0_16wz6_835",
    "f-left": "awsui_f-left_18wu0_16wz6_839",
    "f-right": "awsui_f-right_18wu0_16wz6_843",
    "root": "awsui_root_18wu0_16wz6_851"
};


function $897e30f655d0e79f$export$2e2bcd8739ae039(_a) {
    var { variant: variant = "div", tagOverride: tagOverride, margin: margin = {}, padding: padding = {}, display: display, textAlign: textAlign, float: float, fontSize: fontSize, fontWeight: fontWeight, color: color, children: children, __internalRootRef: __internalRootRef = null } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "variant",
        "tagOverride",
        "margin",
        "padding",
        "display",
        "textAlign",
        "float",
        "fontSize",
        "fontWeight",
        "color",
        "children",
        "__internalRootRef"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const marginsClassNamesSuffices = $897e30f655d0e79f$var$getClassNamesSuffixes(margin);
    const paddingsClassNamesSuffices = $897e30f655d0e79f$var$getClassNamesSuffixes(padding);
    // This can be any arbitrary string if passed into tagOverride.
    // We appease the compiler with an incorrect type.
    const Tag = $897e30f655d0e79f$var$getTag(variant, tagOverride);
    const className = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039).root, (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039).box, (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`${variant.replace(/^awsui-/, "")}-variant`], marginsClassNamesSuffices.map((suffix)=>(0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`m-${suffix}`]), paddingsClassNamesSuffices.map((suffix)=>(0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`p-${suffix}`]), (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`d-${display}`], (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`f-${float}`], (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`color-${color || "default"}`], (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`font-size-${fontSize || "default"}`], (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`font-weight-${fontWeight || "default"}`], (0, $a3bb2b713f638a5c$export$2e2bcd8739ae039)[`t-${textAlign}`]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, Object.assign({}, baseProps, {
        className: className,
        ref: __internalRootRef
    }), children);
}
const $897e30f655d0e79f$var$getClassNamesSuffixes = (value)=>{
    if (typeof value === "string") return [
        value
    ];
    const sides = [
        "top",
        "right",
        "bottom",
        "left",
        "horizontal",
        "vertical"
    ];
    return sides.filter((side)=>!!value[side]).map((side)=>`${side}-${value[side]}`);
};
const $897e30f655d0e79f$var$getTag = (variant, tagOverride)=>{
    if (tagOverride) return tagOverride;
    if (variant === "awsui-value-large") return "span";
    if (variant === "awsui-key-label" || variant === "awsui-gen-ai-label") return "div";
    return variant;
};








const $eed8d7153e9df678$var$InternalButtonDropdown = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var _b;
    var { items: items, variant: variant = "normal", loading: loading = false, loadingText: loadingText, disabled: disabled = false, disabledReason: disabledReason, expandableGroups: expandableGroups = false, children: children, onItemClick: onItemClick, onItemFollow: onItemFollow, customTriggerBuilder: customTriggerBuilder, expandToViewport: expandToViewport, ariaLabel: ariaLabel, title: title, description: description, preferCenter: preferCenter, mainAction: mainAction, __internalRootRef: __internalRootRef } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "items",
        "variant",
        "loading",
        "loadingText",
        "disabled",
        "disabledReason",
        "expandableGroups",
        "children",
        "onItemClick",
        "onItemFollow",
        "customTriggerBuilder",
        "expandToViewport",
        "ariaLabel",
        "title",
        "description",
        "preferCenter",
        "mainAction",
        "__internalRootRef"
    ]);
    const isInRestrictedView = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const dropdownId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("dropdown");
    for (const item of items)if ((0, $36113732f360ff28$export$211c15450d7814f3)(item)) (0, $3de0f29144bb4e85$export$6661f6891a200a5f)("ButtonDropdown", item.href);
    if (mainAction) (0, $3de0f29144bb4e85$export$6661f6891a200a5f)("ButtonDropdown", mainAction.href);
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        if (mainAction && variant !== "primary" && variant !== "normal") (0, $dd646455762bc7b9$export$5b28268982f175ba)("ButtonDropdown", 'Main action is only supported for "primary" and "normal" component variant.');
    }
    const isMainAction = mainAction && (variant === "primary" || variant === "normal");
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const { isOpen: isOpen, targetItem: targetItem, isHighlighted: isHighlighted, isKeyboardHighlight: isKeyboardHighlight, isExpanded: isExpanded, highlightItem: highlightItem, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onItemActivate: onItemActivate, onGroupToggle: onGroupToggle, toggleDropdown: toggleDropdown, closeDropdown: closeDropdown, setIsUsingMouse: setIsUsingMouse } = (0, $671527e64731e5aa$export$9df7c146789633dd)({
        items: items,
        onItemClick: onItemClick,
        onItemFollow: onItemFollow,
        // Scroll is unnecessary when moving focus back to the dropdown trigger.
        onReturnFocus: ()=>{
            var _a;
            return (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus({
                preventScroll: true
            });
        },
        expandToViewport: expandToViewport,
        hasExpandableGroups: expandableGroups,
        isInRestrictedView: isInRestrictedView
    });
    const handleMouseEvent = ()=>{
        setIsUsingMouse(true);
    };
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const mainActionRef = (0, $acw62.useRef)(null);
    const triggerRef = (0, $acw62.useRef)(null);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, isMainAction ? mainActionRef : triggerRef);
    const clickHandler = ()=>{
        if (!loading && !disabled) // Prevent moving highlight on mobiles to avoid disabled state reason popup if defined.
        toggleDropdown({
            moveHighlightOnOpen: !isInRestrictedView
        });
    };
    const canBeOpened = !loading && !disabled;
    const triggerVariant = variant === "navigation" ? undefined : variant === "inline-icon" ? "inline-icon" : variant;
    const iconProps = variant === "icon" || variant === "inline-icon" ? {
        iconName: "ellipsis"
    } : {
        iconName: "caret-down-filled",
        iconAlign: "right",
        __iconClass: canBeOpened && isOpen ? (0, $ad928a6240f442f3$export$2e2bcd8739ae039)["rotate-up"] : (0, $ad928a6240f442f3$export$2e2bcd8739ae039)["rotate-down"]
    };
    const baseTriggerProps = Object.assign(Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ad928a6240f442f3$export$2e2bcd8739ae039)["trigger-button"], (0, $ad928a6240f442f3$export$2e2bcd8739ae039)["test-utils-button-trigger"])
    }, iconProps), {
        variant: triggerVariant,
        loading: loading,
        loadingText: loadingText,
        disabled: disabled,
        disabledReason: disabledReason,
        onClick: (event)=>{
            event.preventDefault();
            clickHandler();
        },
        ariaLabel: ariaLabel,
        ariaExpanded: canBeOpened && isOpen,
        formAction: "none",
        __nativeAttributes: {
            "aria-haspopup": true
        }
    });
    const triggerId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("awsui-button-dropdown__trigger");
    const triggerHasBadge = ()=>{
        const flatItems = items.flatMap((item)=>{
            if ("items" in item) return item.items;
            return item;
        });
        return variant === "icon" && !!(flatItems === null || flatItems === void 0 ? void 0 : flatItems.find((item)=>{
            if ("badge" in item) return item.badge;
        }));
    };
    let trigger = null;
    if (customTriggerBuilder) trigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $ad928a6240f442f3$export$2e2bcd8739ae039)["dropdown-trigger"]
    }, customTriggerBuilder({
        testUtilsClass: (0, $ad928a6240f442f3$export$2e2bcd8739ae039)["test-utils-button-trigger"],
        ariaExpanded: canBeOpened && isOpen,
        onClick: clickHandler,
        triggerRef: triggerRef,
        ariaLabel: ariaLabel,
        disabled: disabled,
        disabledReason: disabledReason,
        isOpen: isOpen
    }));
    else if (isMainAction) {
        const { text: text, iconName: iconName, iconAlt: iconAlt, iconSvg: iconSvg, iconUrl: iconUrl, external: external, externalIconAriaLabel: externalIconAriaLabel } = mainAction, mainActionProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(mainAction, [
            "text",
            "iconName",
            "iconAlt",
            "iconSvg",
            "iconUrl",
            "external",
            "externalIconAriaLabel"
        ]);
        const mainActionIconProps = external ? {
            iconName: "external",
            iconAlign: "right"
        } : {
            iconName: iconName,
            iconAlt: iconAlt,
            iconSvg: iconSvg,
            iconUrl: iconUrl
        };
        const mainActionAriaLabel = externalIconAriaLabel ? `${(_b = mainAction.ariaLabel) !== null && _b !== void 0 ? _b : mainAction.text} ${mainAction.externalIconAriaLabel}` : undefined;
        trigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "group",
            "aria-label": ariaLabel,
            className: (0, $ad928a6240f442f3$export$2e2bcd8739ae039)["split-trigger-wrapper"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ad928a6240f442f3$export$2e2bcd8739ae039)["trigger-item"], (0, $ad928a6240f442f3$export$2e2bcd8739ae039)["split-trigger"]),
            // Close dropdown upon main action click unless event is cancelled.
            onClick: closeDropdown,
            // Prevent keyboard events from propagation to the button dropdown handler.
            onKeyDown: (e)=>e.stopPropagation(),
            onKeyUp: (e)=>e.stopPropagation()
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), Object.assign({
            ref: mainActionRef
        }, mainActionProps, mainActionIconProps, {
            className: (0, $ad928a6240f442f3$export$2e2bcd8739ae039)["trigger-button"],
            variant: variant,
            ariaLabel: mainActionAriaLabel,
            formAction: "none"
        }), text)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ad928a6240f442f3$export$2e2bcd8739ae039)["trigger-item"], (0, $ad928a6240f442f3$export$2e2bcd8739ae039)["dropdown-trigger"], isVisualRefresh && (0, $ad928a6240f442f3$export$2e2bcd8739ae039)["visual-refresh"])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), Object.assign({
            ref: triggerRef
        }, baseTriggerProps))));
    } else trigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $ad928a6240f442f3$export$2e2bcd8739ae039)["dropdown-trigger"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), Object.assign({
        ref: triggerRef,
        id: triggerId
    }, baseTriggerProps, {
        badge: triggerHasBadge()
    }), children));
    const hasHeader = title || description;
    const headerId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("awsui-button-dropdown__header");
    const shouldLabelWithTrigger = !ariaLabel && !mainAction && variant !== "icon" && variant !== "inline-icon";
    const { loadingButtonCount: loadingButtonCount } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    (0, $acw62.useEffect)(()=>{
        if (loading) {
            loadingButtonCount.current++;
            return ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                loadingButtonCount.current--;
            };
        }
    }, [
        loading,
        loadingButtonCount
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseDown: handleMouseEvent,
        onMouseMove: handleMouseEvent,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ad928a6240f442f3$export$2e2bcd8739ae039)["button-dropdown"], (0, $ad928a6240f442f3$export$2e2bcd8739ae039)[`variant-${variant}`], baseProps.className),
        "aria-owns": expandToViewport && isOpen ? dropdownId : undefined,
        ref: __internalRootRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1fd689c8894b21bd$export$2e2bcd8739ae039), {
        open: canBeOpened && isOpen,
        stretchWidth: false,
        stretchTriggerHeight: variant === "navigation",
        expandToViewport: expandToViewport,
        preferCenter: preferCenter,
        onDropdownClose: ()=>toggleDropdown(),
        trigger: trigger,
        dropdownId: dropdownId
    }, hasHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $ad928a6240f442f3$export$2e2bcd8739ae039).header,
        id: headerId
    }, title && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $ad928a6240f442f3$export$2e2bcd8739ae039).title
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        fontSize: "heading-s",
        fontWeight: "bold",
        color: "inherit",
        tagOverride: "h2",
        margin: {
            vertical: "n",
            horizontal: "n"
        }
    }, title)), description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        fontSize: "body-s"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $ad928a6240f442f3$export$2e2bcd8739ae039).description
    }, description))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b0a4cb0aaef194c$export$2e2bcd8739ae039), {
        open: canBeOpened && isOpen,
        position: "static",
        role: "menu",
        decreaseBlockMargin: true,
        ariaLabel: ariaLabel,
        ariaLabelledby: hasHeader ? headerId : shouldLabelWithTrigger ? triggerId : undefined,
        statusType: "finished"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $95690548a868d7d0$export$2e2bcd8739ae039), {
        items: items,
        onItemActivate: onItemActivate,
        onGroupToggle: onGroupToggle,
        hasExpandableGroups: expandableGroups,
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isKeyboardHighlight: isKeyboardHighlight,
        isExpanded: isExpanded,
        lastInDropdown: true,
        highlightItem: highlightItem,
        expandToViewport: expandToViewport,
        variant: variant
    }))));
});
var $eed8d7153e9df678$export$2e2bcd8739ae039 = $eed8d7153e9df678$var$InternalButtonDropdown;



var $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1fj9k_3pu9z_5",
    "navigation": "awsui_navigation_1fj9k_3pu9z_9",
    "navigation-toggle": "awsui_navigation-toggle_1fj9k_3pu9z_13",
    "navigation-close": "awsui_navigation-close_1fj9k_3pu9z_17",
    "content": "awsui_content_1fj9k_3pu9z_21",
    "notifications": "awsui_notifications_1fj9k_3pu9z_25",
    "breadcrumbs": "awsui_breadcrumbs_1fj9k_3pu9z_29",
    "tools": "awsui_tools_1fj9k_3pu9z_33",
    "tools-close": "awsui_tools-close_1fj9k_3pu9z_37",
    "tools-toggle": "awsui_tools-toggle_1fj9k_3pu9z_41",
    "drawer-closed": "awsui_drawer-closed_1fj9k_3pu9z_45",
    "mobile-bar": "awsui_mobile-bar_1fj9k_3pu9z_49",
    "disable-body-scroll-root": "awsui_disable-body-scroll-root_1fj9k_3pu9z_53",
    "drawers-trigger": "awsui_drawers-trigger_1fj9k_3pu9z_57",
    "active-drawer": "awsui_active-drawer_1fj9k_3pu9z_61",
    "active-drawer-close-button": "awsui_active-drawer-close-button_1fj9k_3pu9z_65",
    "overflow-menu": "awsui_overflow-menu_1fj9k_3pu9z_69",
    "drawers-slider": "awsui_drawers-slider_1fj9k_3pu9z_73"
};


function $68640640380c1033$export$2e2bcd8739ae039({ items: items, onItemClick: onItemClick, customTriggerBuilder: customTriggerBuilder, ariaLabel: ariaLabel }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eed8d7153e9df678$export$2e2bcd8739ae039), {
        items: items.map((item)=>({
                id: item.id,
                text: item.ariaLabels.drawerName,
                iconName: item.trigger.iconName,
                iconSvg: item.trigger.iconSvg,
                badge: item.badge
            })),
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["overflow-menu"],
        onItemClick: onItemClick,
        ariaLabel: ariaLabel,
        variant: "icon",
        customTriggerBuilder: customTriggerBuilder,
        expandToViewport: true
    });
}



var $8f2f8f8a4015f30b$export$2e2bcd8739ae039 = {
    "block-body-scroll": "awsui_block-body-scroll_19d8l_142in_101",
    "mobile-bar": "awsui_mobile-bar_19d8l_142in_105",
    "mobile-bar-breadcrumbs": "awsui_mobile-bar-breadcrumbs_19d8l_142in_118",
    "mobile-toggle": "awsui_mobile-toggle_19d8l_142in_125",
    "mobile-toggle-type-navigation": "awsui_mobile-toggle-type-navigation_19d8l_142in_134",
    "mobile-toggle-type-tools": "awsui_mobile-toggle-type-tools_19d8l_142in_137",
    "mobile-toggle-type-drawer": "awsui_mobile-toggle-type-drawer_19d8l_142in_137",
    "drawers-container": "awsui_drawers-container_19d8l_142in_144"
};



var $1e16b5b5cece95db$export$2e2bcd8739ae039 = {
    "resize-active": "awsui_resize-active_lm6vo_w4b3v_102",
    "resize-side": "awsui_resize-side_lm6vo_w4b3v_108",
    "resize-bottom": "awsui_resize-bottom_lm6vo_w4b3v_111",
    "with-motion": "awsui_with-motion_lm6vo_w4b3v_116",
    "root": "awsui_root_lm6vo_w4b3v_131",
    "root-no-scroll": "awsui_root-no-scroll_lm6vo_w4b3v_138",
    "layout": "awsui_layout_lm6vo_w4b3v_143",
    "layout-no-scroll": "awsui_layout-no-scroll_lm6vo_w4b3v_149",
    "layout-main": "awsui_layout-main_lm6vo_w4b3v_153",
    "layout-main-scrollable": "awsui_layout-main-scrollable_lm6vo_w4b3v_159",
    "unfocusable": "awsui_unfocusable_lm6vo_w4b3v_164",
    "breadcrumbs-desktop": "awsui_breadcrumbs-desktop_lm6vo_w4b3v_168",
    "content-header-wrapper": "awsui_content-header-wrapper_lm6vo_w4b3v_173",
    "content-wrapper": "awsui_content-wrapper_lm6vo_w4b3v_177",
    "content-overlapped": "awsui_content-overlapped_lm6vo_w4b3v_181",
    "content-extra-top-padding": "awsui_content-extra-top-padding_lm6vo_w4b3v_185"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $cd10a1d6e571a030$export$855cafbbae95d7a8(maybeItems, splitIndex, activeId) {
    const items = maybeItems !== null && maybeItems !== void 0 ? maybeItems : [];
    const visibleItems = items.slice(0, splitIndex);
    const overflowItems = items.slice(splitIndex);
    if (overflowItems.length === 1) return {
        visibleItems: items,
        overflowItems: []
    };
    if (activeId && overflowItems.length > 0 && visibleItems.length > 0) {
        const activeInOverflow = overflowItems.find((item)=>item.id === activeId);
        if (activeInOverflow) {
            overflowItems.splice(overflowItems.indexOf(activeInOverflow), 1);
            overflowItems.unshift(visibleItems.pop());
            visibleItems.push(activeInOverflow);
        }
    }
    return {
        visibleItems: visibleItems,
        overflowItems: overflowItems
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// default delay for components defined by UX
const $3f63db4ba00e1128$export$d1a6d9ea0ea6ab23 = 200;
function $3f63db4ba00e1128$export$2e2bcd8739ae039(func, delay = $3f63db4ba00e1128$export$d1a6d9ea0ea6ab23) {
    let timeout;
    return function(...args) {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(()=>{
            timeout = null;
            func(...args);
        }, delay);
    };
}


class $bafc331e35e8ca5f$export$f0d3882597ab64cd {
    constructor(){
        this.drawers = [];
        this.drawersRegistrationListener = null;
        this.scheduleUpdate = (0, $3f63db4ba00e1128$export$2e2bcd8739ae039)(()=>{
            var _a;
            (_a = this.drawersRegistrationListener) === null || _a === void 0 || _a.call(this, this.drawers);
        }, 0);
        this.registerDrawer = (config)=>{
            this.drawers = this.drawers.concat(config);
            this.scheduleUpdate();
        };
        this.onDrawersRegistered = (listener)=>{
            if (this.drawersRegistrationListener !== null) console.warn("[AwsUi] [runtime drawers] multiple app layout instances detected");
            this.drawersRegistrationListener = listener;
            this.scheduleUpdate();
            return ()=>{
                this.drawersRegistrationListener = null;
            };
        };
        this.clearRegisteredDrawers = ()=>{
            this.drawers = [];
        };
    }
    installPublic(api = {}) {
        var _a;
        (_a = api.registerDrawer) !== null && _a !== void 0 ? _a : api.registerDrawer = this.registerDrawer;
        return api;
    }
    installInternal(internalApi = {}) {
        var _a, _b;
        (_a = internalApi.clearRegisteredDrawers) !== null && _a !== void 0 ? _a : internalApi.clearRegisteredDrawers = this.clearRegisteredDrawers;
        (_b = internalApi.onDrawersRegistered) !== null && _b !== void 0 ? _b : internalApi.onDrawersRegistered = this.onDrawersRegistered;
        return internalApi;
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $f9a0c98d405a6b2e$export$c3e9367b9aa13a23(items) {
    return items.slice().sort((a, b)=>{
        var _a, _b;
        if (b.orderPriority !== a.orderPriority) return Math.sign(((_a = b.orderPriority) !== null && _a !== void 0 ? _a : 0) - ((_b = a.orderPriority) !== null && _b !== void 0 ? _b : 0));
        return b.id < a.id ? 1 : -1;
    });
}


class $669e12e768f7d5b7$export$d181f35107806ecc {
    constructor(){
        this.listeners = [];
        this.actions = [];
        this.scheduleUpdate = (0, $3f63db4ba00e1128$export$2e2bcd8739ae039)(()=>{
            this.listeners.forEach((listener)=>listener(this.actions));
        }, 0);
        this.registerAction = (action)=>{
            this.actions.push(action);
            this.actions = (0, $f9a0c98d405a6b2e$export$c3e9367b9aa13a23)(this.actions);
            this.scheduleUpdate();
        };
        this.clearRegisteredActions = ()=>{
            this.actions = [];
        };
        this.onActionRegistered = (listener)=>{
            this.listeners.push(listener);
            this.scheduleUpdate();
            return ()=>{
                this.listeners = this.listeners.filter((item)=>item !== listener);
            };
        };
    }
    installPublic(api = {}) {
        var _a;
        (_a = api.registerAction) !== null && _a !== void 0 ? _a : api.registerAction = this.registerAction;
        return api;
    }
    installInternal(internalApi = {}) {
        var _a, _b;
        (_a = internalApi.clearRegisteredActions) !== null && _a !== void 0 ? _a : internalApi.clearRegisteredActions = this.clearRegisteredActions;
        (_b = internalApi.onActionRegistered) !== null && _b !== void 0 ? _b : internalApi.onActionRegistered = this.onActionRegistered;
        return internalApi;
    }
}




var $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyAppLayout, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyBreadcrumbs;
class $0e3fcb4f5802ba31$export$a601395342951fe2 {
    constructor(){
        $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback.set(this, null);
        $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances.set(this, []);
        $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations.set(this, []);
        $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyAppLayout.set(this, (0, $3f63db4ba00e1128$export$2e2bcd8739ae039)(()=>{
            var _a;
            if (!(0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, "f")) return;
            const latestBreadcrumb = (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances, "f")[(0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances, "f").length - 1];
            (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, "f").call(this, (_a = latestBreadcrumb === null || latestBreadcrumb === void 0 ? void 0 : latestBreadcrumb.props) !== null && _a !== void 0 ? _a : null);
        }, 0));
        $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyBreadcrumbs.set(this, (0, $3f63db4ba00e1128$export$2e2bcd8739ae039)(()=>{
            if (!(0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, "f")) return;
            (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations, "f").forEach((listener)=>listener());
        }, 0));
        this.registerAppLayout = (changeCallback)=>{
            if ((0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, "f")) return;
            (0, $5c96a02c592fcff1$export$d40a35129aaff81f)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, changeCallback, "f");
            (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyBreadcrumbs, "f").call(this);
            return ()=>{
                (0, $5c96a02c592fcff1$export$d40a35129aaff81f)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, null, "f");
            };
        };
        this.registerBreadcrumbs = (props, onRegistered)=>{
            const instance = {
                props: props
            };
            (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances, "f").push(instance);
            (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations, "f").push(onRegistered);
            (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyBreadcrumbs, "f").call(this);
            (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyAppLayout, "f").call(this);
            return {
                update: (props)=>{
                    instance.props = props;
                    (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyAppLayout, "f").call(this);
                },
                cleanup: ()=>{
                    (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances, "f").splice((0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances, "f").indexOf(instance), 1);
                    (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations, "f").splice((0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations, "f").indexOf(onRegistered), 1);
                    (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyAppLayout, "f").call(this);
                }
            };
        };
        this.getStateForTesting = ()=>{
            return {
                appLayoutUpdateCallback: (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback, "f"),
                breadcrumbInstances: (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances, "f"),
                breadcrumbRegistrations: (0, $5c96a02c592fcff1$export$d5dcaf168c640c35)(this, $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations, "f")
            };
        };
    }
    installInternal(internalApi = {}) {
        var _a, _b, _c;
        (_a = internalApi.registerBreadcrumbs) !== null && _a !== void 0 ? _a : internalApi.registerBreadcrumbs = this.registerBreadcrumbs;
        (_b = internalApi.registerAppLayout) !== null && _b !== void 0 ? _b : internalApi.registerAppLayout = this.registerAppLayout;
        (_c = internalApi.getStateForTesting) !== null && _c !== void 0 ? _c : internalApi.getStateForTesting = this.getStateForTesting;
        return internalApi;
    }
}
$0e3fcb4f5802ba31$var$_BreadcrumbsController_appLayoutUpdateCallback = new WeakMap(), $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbInstances = new WeakMap(), $0e3fcb4f5802ba31$var$_BreadcrumbsController_breadcrumbRegistrations = new WeakMap(), $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyAppLayout = new WeakMap(), $0e3fcb4f5802ba31$var$_BreadcrumbsController_notifyBreadcrumbs = new WeakMap();


const $2ec6e52915a41fcf$var$storageKey = Symbol.for("awsui-plugin-api");
function $2ec6e52915a41fcf$var$findUpApi(currentWindow) {
    try {
        if (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow[$2ec6e52915a41fcf$var$storageKey]) return currentWindow[$2ec6e52915a41fcf$var$storageKey];
        if (!currentWindow || currentWindow.parent === currentWindow) // When the window has no more parents, it references itself
        return undefined;
        return $2ec6e52915a41fcf$var$findUpApi(currentWindow.parent);
    } catch (ex) {
        // Most likely a cross-origin access error
        return undefined;
    }
}
function $2ec6e52915a41fcf$export$1fed1876a7d5b3d0() {
    if (typeof window === "undefined") return $2ec6e52915a41fcf$var$installApi({});
    const win = window;
    const existingApi = $2ec6e52915a41fcf$var$findUpApi(win);
    win[$2ec6e52915a41fcf$var$storageKey] = $2ec6e52915a41fcf$var$installApi(existingApi !== null && existingApi !== void 0 ? existingApi : {});
    return win[$2ec6e52915a41fcf$var$storageKey];
}
const { awsuiPlugins: $2ec6e52915a41fcf$export$3e1465788a9d72b0, awsuiPluginsInternal: $2ec6e52915a41fcf$export$90753eb139627d74 } = $2ec6e52915a41fcf$export$1fed1876a7d5b3d0();
function $2ec6e52915a41fcf$var$installApi(api) {
    var _a, _b;
    (_a = api.awsuiPlugins) !== null && _a !== void 0 ? _a : api.awsuiPlugins = {};
    (_b = api.awsuiPluginsInternal) !== null && _b !== void 0 ? _b : api.awsuiPluginsInternal = {};
    const appLayoutDrawers = new (0, $bafc331e35e8ca5f$export$f0d3882597ab64cd)();
    api.awsuiPlugins.appLayout = appLayoutDrawers.installPublic(api.awsuiPlugins.appLayout);
    api.awsuiPluginsInternal.appLayout = appLayoutDrawers.installInternal(api.awsuiPluginsInternal.appLayout);
    const alertActions = new (0, $669e12e768f7d5b7$export$d181f35107806ecc)();
    api.awsuiPlugins.alert = alertActions.installPublic(api.awsuiPlugins.alert);
    api.awsuiPluginsInternal.alert = alertActions.installInternal(api.awsuiPluginsInternal.alert);
    const flashbarActions = new (0, $669e12e768f7d5b7$export$d181f35107806ecc)();
    api.awsuiPlugins.flashbar = flashbarActions.installPublic(api.awsuiPlugins.flashbar);
    api.awsuiPluginsInternal.flashbar = flashbarActions.installInternal(api.awsuiPluginsInternal.flashbar);
    const breadcrumbs = new (0, $0e3fcb4f5802ba31$export$a601395342951fe2)();
    api.awsuiPluginsInternal.breadcrumbs = breadcrumbs.installInternal(api.awsuiPluginsInternal.breadcrumbs);
    return api;
}





var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $4e5302bcc569601f$export$4943976e4fdbb0cd({ mountContent: mountContent, unmountContent: unmountContent }) {
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const container = ref.current;
        mountContent(container);
        return ()=>unmountContent(container);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref
    });
}




function $90fd17997085dbf5$export$230994d0fa2896d5(drawers) {
    const converted = drawers.map((_a)=>{
        var _b;
        var { mountContent: mountContent, unmountContent: unmountContent, trigger: trigger } = _a, runtimeDrawer = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "mountContent",
            "unmountContent",
            "trigger"
        ]);
        return Object.assign(Object.assign({}, runtimeDrawer), {
            ariaLabels: Object.assign({
                drawerName: (_b = runtimeDrawer.ariaLabels.content) !== null && _b !== void 0 ? _b : ""
            }, runtimeDrawer.ariaLabels),
            trigger: {
                iconSvg: // eslint-disable-next-line react/no-danger
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    dangerouslySetInnerHTML: {
                        __html: trigger.iconSvg
                    }
                })
            },
            content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e5302bcc569601f$export$4943976e4fdbb0cd), {
                key: runtimeDrawer.id,
                mountContent: mountContent,
                unmountContent: unmountContent
            }),
            onResize: (event)=>{
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(runtimeDrawer.onResize, {
                    size: event.detail.size,
                    id: runtimeDrawer.id
                });
            }
        });
    });
    const sorted = (0, $f9a0c98d405a6b2e$export$c3e9367b9aa13a23)(converted);
    return {
        before: sorted.filter((item)=>{
            var _a;
            return ((_a = item.orderPriority) !== null && _a !== void 0 ? _a : 0) > 0;
        }),
        after: sorted.filter((item)=>{
            var _a;
            return ((_a = item.orderPriority) !== null && _a !== void 0 ? _a : 0) <= 0;
        })
    };
}



const $892ef2b582c4882d$export$329f249760e831ae = "awsui-internal-tools";
function $892ef2b582c4882d$var$getToolsDrawerItem(props) {
    if (props.toolsHide) return null;
    const { iconName: iconName, getLabels: getLabels } = (0, $917b74cb04fa7906$export$e0ae33479bcb926a).tools;
    const { mainLabel: mainLabel, closeLabel: closeLabel, openLabel: openLabel } = getLabels(props.ariaLabels);
    return {
        id: $892ef2b582c4882d$export$329f249760e831ae,
        content: props.tools,
        resizable: false,
        ariaLabels: {
            triggerButton: openLabel,
            closeButton: closeLabel,
            drawerName: mainLabel !== null && mainLabel !== void 0 ? mainLabel : ""
        },
        trigger: {
            iconName: iconName
        }
    };
}
function $892ef2b582c4882d$var$useRuntimeDrawers(disableRuntimeDrawers, activeDrawerId, onActiveDrawerChange) {
    const [runtimeDrawers, setRuntimeDrawers] = (0, $acw62.useState)({
        before: [],
        after: []
    });
    const onActiveDrawerChangeStable = (0, $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0)(onActiveDrawerChange);
    const drawerWasOpenRef = (0, $acw62.useRef)(false);
    drawerWasOpenRef.current = drawerWasOpenRef.current || !!activeDrawerId;
    (0, $acw62.useEffect)(()=>{
        if (disableRuntimeDrawers) return;
        const unsubscribe = (0, $2ec6e52915a41fcf$export$90753eb139627d74).appLayout.onDrawersRegistered((drawers)=>{
            setRuntimeDrawers((0, $90fd17997085dbf5$export$230994d0fa2896d5)(drawers));
            if (!drawerWasOpenRef.current) {
                const defaultActiveDrawer = (0, $f9a0c98d405a6b2e$export$c3e9367b9aa13a23)(drawers).find((drawer)=>drawer.defaultActive);
                if (defaultActiveDrawer) onActiveDrawerChangeStable(defaultActiveDrawer.id);
            }
        });
        return ()=>{
            unsubscribe();
            setRuntimeDrawers({
                before: [],
                after: []
            });
        };
    }, [
        disableRuntimeDrawers,
        onActiveDrawerChangeStable
    ]);
    return runtimeDrawers;
}
function $892ef2b582c4882d$var$applyToolsDrawer(toolsProps, runtimeDrawers) {
    const drawers = [
        ...runtimeDrawers.before,
        ...runtimeDrawers.after
    ];
    if (drawers.length === 0 && toolsProps.disableDrawersMerge) return null;
    const toolsItem = $892ef2b582c4882d$var$getToolsDrawerItem(toolsProps);
    if (toolsItem) drawers.unshift(toolsItem);
    return drawers;
}
function $892ef2b582c4882d$export$468f52f962f49bf5({ drawers: drawers, activeDrawerId: controlledActiveDrawerId, onDrawerChange: onDrawerChange, __disableRuntimeDrawers: disableRuntimeDrawers }, ariaLabels, toolsProps) {
    var _a, _b, _c, _d;
    const [activeDrawerId = null, setActiveDrawerId] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledActiveDrawerId, onDrawerChange, null, {
        componentName: "AppLayout",
        controlledProp: "activeDrawerId",
        changeHandler: "onChange"
    });
    const [drawerSizes, setDrawerSizes] = (0, $acw62.useState)({});
    function onActiveDrawerResize({ id: id, size: size }) {
        setDrawerSizes((oldSizes)=>Object.assign(Object.assign({}, oldSizes), {
                [id]: size
            }));
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.onResize, {
            id: id,
            size: size
        });
    }
    function onActiveDrawerChange(newDrawerId) {
        setActiveDrawerId(newDrawerId);
        if (hasOwnDrawers) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDrawerChange, {
            activeDrawerId: newDrawerId
        });
        else if (!toolsProps.toolsHide) toolsProps.onToolsToggle(newDrawerId === $892ef2b582c4882d$export$329f249760e831ae);
    }
    const hasOwnDrawers = !!drawers;
    const runtimeDrawers = $892ef2b582c4882d$var$useRuntimeDrawers(disableRuntimeDrawers, activeDrawerId, onActiveDrawerChange);
    const combinedDrawers = drawers ? [
        ...runtimeDrawers.before,
        ...drawers,
        ...runtimeDrawers.after
    ] : $892ef2b582c4882d$var$applyToolsDrawer(toolsProps, runtimeDrawers);
    // support toolsOpen in runtime-drawers-only mode
    let activeDrawerIdResolved = (toolsProps === null || toolsProps === void 0 ? void 0 : toolsProps.toolsOpen) && !hasOwnDrawers ? $892ef2b582c4882d$export$329f249760e831ae : activeDrawerId;
    const activeDrawer = combinedDrawers === null || combinedDrawers === void 0 ? void 0 : combinedDrawers.find((drawer)=>drawer.id === activeDrawerIdResolved);
    // ensure that id is only defined when the drawer exists
    activeDrawerIdResolved = (_a = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id) !== null && _a !== void 0 ? _a : null;
    const activeDrawerSize = activeDrawerIdResolved ? (_c = (_b = drawerSizes[activeDrawerIdResolved]) !== null && _b !== void 0 ? _b : activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.defaultSize) !== null && _c !== void 0 ? _c : toolsProps.toolsWidth : 0;
    const minDrawerSize = Math.min((_d = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.defaultSize) !== null && _d !== void 0 ? _d : 290, 290);
    return {
        ariaLabelsWithDrawers: ariaLabels,
        drawers: combinedDrawers || undefined,
        activeDrawer: activeDrawer,
        activeDrawerId: activeDrawerIdResolved,
        activeDrawerSize: activeDrawerSize,
        minDrawerSize: minDrawerSize,
        onActiveDrawerChange: onActiveDrawerChange,
        onActiveDrawerResize: onActiveDrawerResize
    };
}


const $61eeb350f8678116$var$MobileToggle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ariaLabels: ariaLabels, type: type, disabled: disabled, onClick: onClick }, ref)=>{
    const { TagName: TagName, iconName: iconName, getLabels: getLabels } = (0, $917b74cb04fa7906$export$e0ae33479bcb926a)[type];
    const { mainLabel: mainLabel, openLabel: openLabel } = getLabels(ariaLabels);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TagName, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)["mobile-toggle"], (0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)[`mobile-toggle-type-${type}`]),
        "aria-hidden": disabled,
        "aria-label": mainLabel,
        onClick: (e)=>e.target === e.currentTarget && onClick()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $917b74cb04fa7906$export$d2b052e7b4be1756), {
        ref: ref,
        className: className,
        iconName: iconName,
        onClick: onClick,
        ariaLabel: openLabel,
        disabled: disabled,
        ariaExpanded: disabled
    }));
});
function $61eeb350f8678116$export$ad5e3cc87670c145({ ariaLabels: ariaLabels, toggleRefs: toggleRefs, topOffset: topOffset, navigationHide: navigationHide, toolsHide: toolsHide, anyPanelOpen: anyPanelOpen, unfocusable: unfocusable, drawers: drawers, activeDrawerId: activeDrawerId, children: children, onNavigationOpen: onNavigationOpen, onToolsOpen: onToolsOpen, onDrawerChange: onDrawerChange, mobileBarRef: mobileBarRef }) {
    (0, $acw62.useEffect)(()=>{
        if (anyPanelOpen) {
            document.body.classList.add((0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)["block-body-scroll"]);
            return ()=>{
                document.body.classList.remove((0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)["block-body-scroll"]);
            };
        } else document.body.classList.remove((0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)["block-body-scroll"]);
    }, [
        anyPanelOpen
    ]);
    const { overflowItems: overflowItems, visibleItems: visibleItems } = (0, $cd10a1d6e571a030$export$855cafbbae95d7a8)(drawers, 2, activeDrawerId);
    const overflowMenuHasBadge = !!overflowItems.find((item)=>item.badge);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: mobileBarRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)["mobile-bar"], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["mobile-bar"], unfocusable && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039).unfocusable),
        style: {
            top: topOffset
        }
    }, !navigationHide && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($61eeb350f8678116$var$MobileToggle, {
        ref: toggleRefs.navigation,
        type: "navigation",
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["navigation-toggle"],
        ariaLabels: ariaLabels,
        disabled: anyPanelOpen,
        onClick: onNavigationOpen
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)["mobile-bar-breadcrumbs"]
    }, children && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).breadcrumbs
    }, children)), !toolsHide && !drawers && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($61eeb350f8678116$var$MobileToggle, {
        ref: toggleRefs.tools,
        type: "tools",
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-toggle"],
        ariaLabels: ariaLabels,
        disabled: anyPanelOpen,
        onClick: onToolsOpen
    }), drawers && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawers,
        role: "region"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)["drawers-container"],
        role: "toolbar",
        "aria-orientation": "horizontal"
    }, visibleItems.map((item, index)=>{
        var _a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)["mobile-toggle"], (0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)["mobile-toggle-type-drawer"]),
            key: index,
            onClick: ()=>onDrawerChange(item.id)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $917b74cb04fa7906$export$d2b052e7b4be1756), {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawers-trigger"], item.id === (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-toggle"]),
            iconName: item.trigger.iconName,
            iconSvg: item.trigger.iconSvg,
            badge: item.badge,
            ariaLabel: (_a = item.ariaLabels) === null || _a === void 0 ? void 0 : _a.triggerButton,
            ariaExpanded: activeDrawerId === item.id,
            testId: `awsui-app-layout-trigger-${item.id}`
        }));
    }), overflowItems.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)["mobile-toggle"], (0, $8f2f8f8a4015f30b$export$2e2bcd8739ae039)["mobile-toggle-type-drawer"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $68640640380c1033$export$2e2bcd8739ae039), {
        ariaLabel: overflowMenuHasBadge ? ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawersOverflowWithBadge : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawersOverflow,
        items: overflowItems,
        onItemClick: ({ detail: detail })=>onDrawerChange(detail.id)
    })))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $84d3a2bbe2557e44$export$817e5b4536f33d83(isOpen, restoreFocus = false, activeDrawerId) {
    const refs = {
        toggle: (0, $acw62.useRef)(null),
        close: (0, $acw62.useRef)(null),
        slider: (0, $acw62.useRef)(null)
    };
    const previousFocusedElement = (0, $acw62.useRef)();
    const shouldFocus = (0, $acw62.useRef)(false);
    const doFocus = ()=>{
        var _a, _b, _c;
        if (!shouldFocus.current) return;
        if (isOpen) {
            previousFocusedElement.current = document.activeElement !== document.body ? document.activeElement : undefined;
            if (refs.slider.current) (_a = refs.slider.current) === null || _a === void 0 || _a.focus();
            else (_b = refs.close.current) === null || _b === void 0 || _b.focus();
        } else if (restoreFocus && previousFocusedElement.current && document.contains(previousFocusedElement.current)) {
            previousFocusedElement.current.focus();
            previousFocusedElement.current = undefined;
        } else (_c = refs.toggle.current) === null || _c === void 0 || _c.focus();
        shouldFocus.current = false;
    };
    const setFocus = (force)=>{
        shouldFocus.current = true;
        if (force && isOpen) doFocus();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $acw62.useEffect)(doFocus, [
        isOpen,
        activeDrawerId
    ]);
    const loseFocus = (0, $acw62.useCallback)(()=>{
        previousFocusedElement.current = undefined;
    }, []);
    return {
        refs: refs,
        setFocus: setFocus,
        loseFocus: loseFocus
    };
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The page height where the page is considered constrained.
 */ const $582c00c3ff10d4e2$export$221784c3b0ae64c0 = 400;
const $582c00c3ff10d4e2$export$bed14608432f307e = 250;
const $582c00c3ff10d4e2$export$99ee445a84ec4a0d = 40;
function $582c00c3ff10d4e2$export$9d9d5fcac617b082(position) {
    if (typeof document === "undefined") return 0; // render the split panel in its minimum possible size
    return position === "side" ? document.documentElement.clientWidth / 3 : document.documentElement.clientHeight / 2;
}
function $582c00c3ff10d4e2$export$2e85165fee4e4eeb(min, value, max) {
    if (min > max) return min;
    if (value < min) return min;
    if (value > max) return max;
    return value;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");

var $6b9279bdd85bd752$export$2e2bcd8739ae039 = {
    "content-wrapper": "awsui_content-wrapper_zycdx_1j9tc_101",
    "content-wrapper-mobile": "awsui_content-wrapper-mobile_zycdx_1j9tc_105",
    "content-type-dashboard": "awsui_content-type-dashboard_zycdx_1j9tc_110"
};


const $22602bc147daf734$var$ContentWrapper = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, style: style, contentType: contentType, children: children, toolsPadding: toolsPadding, disablePaddings: disablePaddings, navigationPadding: navigationPadding, isMobile: isMobile, contentWidthStyles: contentWidthStyles }, ref)=>{
    if (disablePaddings) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        ref: ref,
        style: style
    }, children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6b9279bdd85bd752$export$2e2bcd8739ae039)["content-wrapper"], !navigationPadding && (0, $6b9279bdd85bd752$export$2e2bcd8739ae039)["content-wrapper-no-navigation-padding"], !toolsPadding && (0, $6b9279bdd85bd752$export$2e2bcd8739ae039)["content-wrapper-no-tools-padding"], isMobile && (0, $6b9279bdd85bd752$export$2e2bcd8739ae039)["content-wrapper-mobile"]),
        style: style
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: contentWidthStyles,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $6b9279bdd85bd752$export$2e2bcd8739ae039)[`content-type-${contentType}`])
    }, children));
});
var $22602bc147daf734$export$2e2bcd8739ae039 = $22602bc147daf734$var$ContentWrapper;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");



var $3b5852da42b0f2f1$export$2e2bcd8739ae039 = {
    "toggle": "awsui_toggle_1uo6m_1exhv_101",
    "drawer-triggers": "awsui_drawer-triggers_1uo6m_1exhv_107",
    "drawer": "awsui_drawer_1uo6m_1exhv_107",
    "drawer-mobile": "awsui_drawer-mobile_1uo6m_1exhv_117",
    "drawer-closed": "awsui_drawer-closed_1uo6m_1exhv_120",
    "drawer-content": "awsui_drawer-content_1uo6m_1exhv_127",
    "drawer-content-clickable": "awsui_drawer-content-clickable_1uo6m_1exhv_139",
    "drawer-resize-content": "awsui_drawer-resize-content_1uo6m_1exhv_149",
    "drawer-triggers-wrapper": "awsui_drawer-triggers-wrapper_1uo6m_1exhv_155",
    "drawer-trigger": "awsui_drawer-trigger_1uo6m_1exhv_107",
    "drawer-trigger-active": "awsui_drawer-trigger-active_1uo6m_1exhv_174",
    "resize-handle-wrapper": "awsui_resize-handle-wrapper_1uo6m_1exhv_182",
    "hide": "awsui_hide_1uo6m_1exhv_192"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $6e052e2d296ab854$export$2e2bcd8739ae039(mapFn, deps = []) {
    const elementRef = (0, $acw62.useRef)(null);
    const [state, setState] = (0, $acw62.useState)(null);
    // Update getElement when deps change to trigger new observation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getElement = (0, $acw62.useCallback)(()=>elementRef.current, deps);
    (0, $444535e54951fdea$export$683480f191c0e3ea)(getElement, (entry)=>setState((prevState)=>mapFn(entry, prevState)));
    return [
        state,
        elementRef
    ];
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



function $17765ea6eb0d3746$export$2e2bcd8739ae039(controlledValue, changeHandler, defaultValue, propertyDescriptions, fireEvent = (value, handler)=>handler(value)) {
    const { componentName: componentName, changeHandlerName: changeHandlerName, propertyName: propertyName } = propertyDescriptions;
    // The decision whether a component is controlled or uncontrolled is made on
    // its first render and cannot be changed afterwards.
    const [isControlled] = (0, $acw62.useState)(controlledValue !== undefined);
    // Most build tools will just strip this block from production builds, so we can
    // skip the conditional hook lint error.
    if (0, $ea769919060d7f5c$export$df77466336fe5355) {
        // Print a warning if a controlled property was passed in without a change handler.
        // This may fire every render if the change handler isn't memoized, but warnOnce
        // will dedupe the error messages.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $acw62.useEffect)(()=>{
            if (isControlled && changeHandler === undefined) (0, $dd646455762bc7b9$export$5b28268982f175ba)(componentName, `You provided a \`${propertyName}\` prop without an \`${changeHandlerName}\` handler. This will render a non-interactive component.`);
        }, [
            changeHandler,
            isControlled,
            componentName,
            changeHandlerName,
            propertyName
        ]);
        // Print a warning if the component switches between controlled and uncontrolled mode.
        const isControlledValueProvided = controlledValue !== undefined;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $acw62.useEffect)(()=>{
            if (isControlled !== isControlledValueProvided) {
                const initialMode = isControlled ? "controlled" : "uncontrolled";
                const modeNow = isControlledValueProvided ? "controlled" : "uncontrolled";
                (0, $dd646455762bc7b9$export$5b28268982f175ba)(componentName, `A component tried to change ${initialMode} '${propertyName}' property to be ${modeNow}. ` + `This is not supported. Properties should not switch from ${initialMode} to ${modeNow} (or vice versa). ` + `Decide between using a controlled or uncontrolled mode for the lifetime of the component. ` + `More info: https://fb.me/react-controlled-components`);
            }
        }, [
            isControlled,
            isControlledValueProvided,
            propertyName,
            componentName
        ]);
    }
    // This is the value that is used if the component is uncontrolled.
    const [valueState, setValue] = (0, $acw62.useState)(defaultValue);
    const [isUncontrolledValueSet, setIsUncontrolledValueSet] = (0, $acw62.useState)(false);
    const stableFireEvent = (0, $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0)((value, handler)=>fireEvent(value, handler));
    const setControlledValue = (0, $acw62.useCallback)((value)=>{
        if (changeHandler) stableFireEvent(value, changeHandler);
    }, [
        changeHandler,
        stableFireEvent
    ]);
    // We allow changes to the defaultValue prop to be reflected until the component
    // starts controlling it internally.
    const currentUncontrolledValue = isUncontrolledValueSet ? valueState : defaultValue;
    const setUncontrolledValue = (0, $acw62.useCallback)((newValue)=>{
        setValue(newValue);
        setIsUncontrolledValueSet(true);
    }, []);
    return isControlled ? [
        controlledValue,
        setControlledValue
    ] : [
        currentUncontrolledValue,
        setUncontrolledValue
    ];
}







const $dedc90907529521f$export$4071300121a182f5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ id: id, contentClassName: contentClassName, toggleClassName: toggleClassName, closeClassName: closeClassName, width: width, type: type, toggleRefs: toggleRefs, topOffset: topOffset, bottomOffset: bottomOffset, ariaLabels: ariaLabels, children: children, hideOpenButton: hideOpenButton, isOpen: isOpen, isHidden: isHidden, isMobile: isMobile, onToggle: onToggle, onClick: onClick, onLoseFocus: onLoseFocus, resizeHandle: resizeHandle }, ref)=>{
    const openButtonWrapperRef = (0, $acw62.useRef)(null);
    const { TagName: TagName, iconName: iconName } = (0, $917b74cb04fa7906$export$e0ae33479bcb926a)[type];
    const { mainLabel: mainLabel, closeLabel: closeLabel, openLabel: openLabel } = ariaLabels;
    const drawerContentWidthOpen = isMobile ? undefined : width;
    const drawerContentWidth = isOpen ? drawerContentWidthOpen : undefined;
    const regularOpenButton = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TagName, {
        ref: openButtonWrapperRef,
        "aria-label": mainLabel,
        className: (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039).toggle,
        "aria-hidden": isOpen
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $917b74cb04fa7906$export$d2b052e7b4be1756), {
        ref: toggleRefs.toggle,
        className: toggleClassName,
        iconName: iconName,
        ariaLabel: openLabel,
        onClick: ()=>onToggle(true),
        ariaExpanded: isOpen ? undefined : false
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b5852da42b0f2f1$export$2e2bcd8739ae039).drawer, {
            [(0, $3b5852da42b0f2f1$export$2e2bcd8739ae039).hide]: isHidden,
            [(0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)["drawer-closed"]]: !isOpen,
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawer-closed"]]: !isOpen,
            [(0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)["drawer-mobile"]]: isMobile
        }),
        style: {
            width: drawerContentWidth
        },
        onBlur: onLoseFocus ? (e)=>{
            if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) onLoseFocus(e);
        } : undefined,
        onClick: (event)=>{
            var _a;
            if (onClick) onClick(event);
            if (!isOpen) // to prevent calling onToggle from the drawer when it's called from the toggle button
            {
                if (openButtonWrapperRef.current === event.target || !((_a = openButtonWrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) onToggle(true);
            }
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        style: {
            width: drawerContentWidth,
            top: topOffset,
            bottom: bottomOffset
        },
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)["drawer-content"], (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)["drawer-content-clickable"], contentClassName)
    }, !isMobile && !hideOpenButton && regularOpenButton, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TagName, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(resizeHandle && (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)["drawer-resize-content"]),
        "aria-label": mainLabel,
        "aria-hidden": !isOpen
    }, !isMobile && isOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)["resize-handle-wrapper"]
    }, resizeHandle), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $917b74cb04fa7906$export$de65de8213222d10), {
        ref: toggleRefs.close,
        className: closeClassName,
        ariaLabel: closeLabel,
        onClick: ()=>{
            onToggle(false);
        }
    }), children)));
});
const $dedc90907529521f$var$DrawerTrigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ testUtilsClassName: testUtilsClassName, ariaLabel: ariaLabel, ariaExpanded: ariaExpanded, ariaControls: ariaControls, badge: badge, itemId: itemId, isActive: isActive, trigger: trigger, onClick: onClick }, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)["drawer-trigger"], isActive && (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)["drawer-trigger-active"]),
        onClick: onClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $917b74cb04fa7906$export$d2b052e7b4be1756), {
        ref: ref,
        className: testUtilsClassName,
        iconName: trigger.iconName,
        iconSvg: trigger.iconSvg,
        ariaLabel: ariaLabel,
        ariaExpanded: ariaExpanded,
        ariaControls: ariaControls,
        badge: badge,
        testId: itemId && `awsui-app-layout-trigger-${itemId}`
    })));
const $dedc90907529521f$export$30e27a27f04aa467 = ({ isMobile: isMobile, topOffset: topOffset, bottomOffset: bottomOffset, activeDrawerId: activeDrawerId, ariaLabels: ariaLabels, drawers: drawers, drawerRefs: drawerRefs, onDrawerChange: onDrawerChange })=>{
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const previousActiveDrawerId = (0, $acw62.useRef)(activeDrawerId);
    const [containerHeight, triggersContainerRef] = (0, $6e052e2d296ab854$export$2e2bcd8739ae039)((rect)=>rect.contentBoxHeight);
    const isCompactMode = (0, $020c722843a7a503$export$e45e01e5e9ef1b27)(containerRef) === "compact";
    if (activeDrawerId) previousActiveDrawerId.current = activeDrawerId;
    const getIndexOfOverflowItem = ()=>{
        if (containerHeight) {
            const ITEM_HEIGHT = isCompactMode ? 34 : 38;
            const overflowSpot = containerHeight / 1.5;
            const index = Math.floor(overflowSpot / ITEM_HEIGHT);
            return index;
        }
        return 0;
    };
    const { visibleItems: visibleItems, overflowItems: overflowItems } = (0, $cd10a1d6e571a030$export$855cafbbae95d7a8)(drawers, getIndexOfOverflowItem(), activeDrawerId);
    const overflowMenuHasBadge = !!overflowItems.find((item)=>item.badge);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b5852da42b0f2f1$export$2e2bcd8739ae039).drawer, (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)["drawer-closed"], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawer-closed"], {
            [(0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)["drawer-mobile"]]: isMobile,
            [(0, $3b5852da42b0f2f1$export$2e2bcd8739ae039).hide]: drawers.length === 1 && !!activeDrawerId
        }),
        ref: containerRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: triggersContainerRef,
        style: {
            top: topOffset,
            bottom: bottomOffset
        },
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)["drawer-content"], {
            [(0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)["drawer-content-clickable"]]: drawers.length === 1
        }),
        onClick: drawers.length === 1 ? ()=>onDrawerChange(drawers[0].id !== activeDrawerId ? drawers[0].id : null) : undefined
    }, !isMobile && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawers,
        role: "region"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)["drawer-triggers-wrapper"],
        role: "toolbar",
        "aria-orientation": "vertical"
    }, visibleItems.map((item, index)=>{
        var _a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dedc90907529521f$var$DrawerTrigger, {
            key: index,
            testUtilsClassName: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawers-trigger"], item.id === (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-toggle"]),
            ariaExpanded: activeDrawerId === item.id,
            ref: item.id === previousActiveDrawerId.current ? drawerRefs.toggle : undefined,
            ariaLabel: (_a = item.ariaLabels) === null || _a === void 0 ? void 0 : _a.triggerButton,
            ariaControls: activeDrawerId === item.id ? item.id : undefined,
            trigger: item.trigger,
            badge: item.badge,
            itemId: item.id,
            isActive: activeDrawerId === item.id,
            onClick: drawers.length !== 1 ? ()=>onDrawerChange(item.id !== activeDrawerId ? item.id : null) : undefined
        });
    }), overflowItems.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039)["drawer-trigger"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $68640640380c1033$export$2e2bcd8739ae039), {
        ariaLabel: overflowMenuHasBadge ? ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawersOverflowWithBadge : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawersOverflow,
        items: overflowItems,
        onItemClick: ({ detail: detail })=>onDrawerChange(detail.id)
    }))))));
};





var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


const $0d7a0c5aa5b38dc9$export$69c48c1cbbd6dc69 = ({ position: position, panelRef: panelRef, handleRef: handleRef, onResize: onResize, hasTransitions: hasTransitions = false })=>{
    const onDocumentPointerMove = (0, $acw62.useCallback)((event)=>{
        if (!panelRef || !panelRef.current || !handleRef || !handleRef.current) return;
        panelRef.current.classList.remove((0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["with-motion"]);
        if (position === "side") {
            const mouseClientX = (0, $558545a5feadf817$export$f04bb9050f053eba)(event, (0, $558545a5feadf817$export$c3f2dc1a1afd265d)(panelRef.current)) || 0;
            // The handle offset aligns the cursor with the middle of the resize handle.
            const handleOffset = (0, $558545a5feadf817$export$322fb6cc2f904670)(handleRef.current).inlineSize / 2;
            const width = (0, $558545a5feadf817$export$322fb6cc2f904670)(panelRef.current).insetInlineEnd - mouseClientX + handleOffset;
            onResize(width);
        } else {
            const mouseClientY = event.clientY || 0;
            // The handle offset aligns the cursor with the middle of the resize handle.
            const handleOffset = (0, $558545a5feadf817$export$322fb6cc2f904670)(handleRef.current).blockSize / 2;
            const height = (0, $558545a5feadf817$export$322fb6cc2f904670)(panelRef.current).insetBlockEnd - mouseClientY + handleOffset;
            onResize(height);
        }
    }, [
        position,
        panelRef,
        handleRef,
        onResize
    ]);
    const onDocumentPointerUp = (0, $acw62.useCallback)(()=>{
        if (!panelRef || !panelRef.current) return;
        if (hasTransitions) panelRef.current.classList.add((0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["with-motion"]);
        document.body.classList.remove((0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["resize-active"]);
        document.body.classList.remove((0, $1e16b5b5cece95db$export$2e2bcd8739ae039)[`resize-${position}`]);
        document.removeEventListener("pointerup", onDocumentPointerUp);
        document.removeEventListener("pointermove", onDocumentPointerMove);
    }, [
        panelRef,
        onDocumentPointerMove,
        position,
        hasTransitions
    ]);
    const onSliderPointerDown = (0, $acw62.useCallback)(()=>{
        document.body.classList.add((0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["resize-active"]);
        document.body.classList.add((0, $1e16b5b5cece95db$export$2e2bcd8739ae039)[`resize-${position}`]);
        document.addEventListener("pointerup", onDocumentPointerUp);
        document.addEventListener("pointermove", onDocumentPointerMove);
    }, [
        onDocumentPointerMove,
        onDocumentPointerUp,
        position
    ]);
    return onSliderPointerDown;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $d790fc2d8f354fdb$export$f11fd8c04cad088d(event) {
    return event.currentTarget instanceof HTMLElement || event.currentTarget instanceof SVGElement;
}
function $d790fc2d8f354fdb$export$2e2bcd8739ae039(event, { onActivate: onActivate, onBlockEnd: onBlockEnd, onBlockStart: onBlockStart, onDefault: onDefault, onEnd: onEnd, onEscape: onEscape, onHome: onHome, onInlineEnd: onInlineEnd, onInlineStart: onInlineStart, onPageDown: onPageDown, onPageUp: onPageUp }) {
    switch(event.keyCode){
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down:
            onBlockEnd === null || onBlockEnd === void 0 || onBlockEnd();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).end:
            onEnd === null || onEnd === void 0 || onEnd();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter:
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space:
            onActivate === null || onActivate === void 0 || onActivate();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).escape:
            onEscape === null || onEscape === void 0 || onEscape();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).home:
            onHome === null || onHome === void 0 || onHome();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).left:
            (0, $558545a5feadf817$export$c3f2dc1a1afd265d)(event.currentTarget) ? onInlineEnd === null || onInlineEnd === void 0 || onInlineEnd() : onInlineStart === null || onInlineStart === void 0 || onInlineStart();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).pageDown:
            onPageDown === null || onPageDown === void 0 || onPageDown();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).pageUp:
            onPageUp === null || onPageUp === void 0 || onPageUp();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right:
            (0, $558545a5feadf817$export$c3f2dc1a1afd265d)(event.currentTarget) ? onInlineStart === null || onInlineStart === void 0 || onInlineStart() : onInlineEnd === null || onInlineEnd === void 0 || onInlineEnd();
            break;
        case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up:
            onBlockStart === null || onBlockStart === void 0 || onBlockStart();
            break;
        default:
            onDefault === null || onDefault === void 0 || onDefault();
            break;
    }
}


const $f3562f2817c11205$var$KEYBOARD_SINGLE_STEP_SIZE = 10;
const $f3562f2817c11205$var$KEYBOARD_MULTIPLE_STEPS_SIZE = 60;
const $f3562f2817c11205$var$getCurrentSize = (panelRef)=>{
    if (!panelRef || !panelRef.current) return {
        panelHeight: 0,
        panelWidth: 0
    };
    return {
        panelHeight: panelRef.current.clientHeight,
        panelWidth: panelRef.current.clientWidth
    };
};
const $f3562f2817c11205$export$2ba6c1a0edf6483a = ({ position: position, onResize: onResize, panelRef: panelRef })=>{
    return (event)=>{
        let currentSize;
        let maxSize;
        const { panelHeight: panelHeight, panelWidth: panelWidth } = $f3562f2817c11205$var$getCurrentSize(panelRef);
        if (position === "side") {
            currentSize = panelWidth;
            // don't need the exact max size as it's constrained in the set size function
            maxSize = window.innerWidth;
        } else {
            currentSize = panelHeight;
            // don't need the exact max size as it's constrained in the set size function
            maxSize = window.innerHeight;
        }
        let isEventHandled = true;
        const singleStepUp = ()=>onResize(currentSize + $f3562f2817c11205$var$KEYBOARD_SINGLE_STEP_SIZE);
        const singleStepDown = ()=>onResize(currentSize - $f3562f2817c11205$var$KEYBOARD_SINGLE_STEP_SIZE);
        const multipleStepUp = ()=>onResize(currentSize + $f3562f2817c11205$var$KEYBOARD_MULTIPLE_STEPS_SIZE);
        const multipleStepDown = ()=>onResize(currentSize - $f3562f2817c11205$var$KEYBOARD_MULTIPLE_STEPS_SIZE);
        (0, $d790fc2d8f354fdb$export$2e2bcd8739ae039)(event, {
            onBlockStart: ()=>{
                position === "bottom" ? singleStepUp() : singleStepDown();
            },
            onBlockEnd: ()=>{
                position === "bottom" ? singleStepDown() : singleStepUp();
            },
            onInlineEnd: ()=>{
                position === "bottom" ? singleStepUp() : singleStepDown();
            },
            onInlineStart: ()=>{
                position === "bottom" ? singleStepDown() : singleStepUp();
            },
            onPageDown: ()=>multipleStepDown(),
            onPageUp: ()=>multipleStepUp(),
            onHome: ()=>onResize(maxSize),
            onEnd: ()=>onResize(0),
            onDefault: ()=>isEventHandled = false
        });
        if (isEventHandled) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $7ee5d8fe9928c41b$export$2e2bcd8739ae039({ className: className }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        focusable: false,
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        "aria-hidden": true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        strokeWidth: "2",
        x1: "2",
        y1: "5",
        x2: "14",
        y2: "5"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        strokeWidth: "2",
        x1: "14",
        y1: "10",
        x2: "2",
        y2: "10"
    }));
}



var $6b3dd944ba6cee6d$export$2e2bcd8739ae039 = {
    "slider": "awsui_slider_cqzlk_1w6ku_97",
    "slider-side": "awsui_slider-side_cqzlk_1w6ku_132",
    "slider-icon": "awsui_slider-icon_cqzlk_1w6ku_139",
    "slider-icon-bottom": "awsui_slider-icon-bottom_cqzlk_1w6ku_145",
    "slider-icon-side": "awsui_slider-icon-side_cqzlk_1w6ku_149"
};


var $df0c014177452109$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function PanelResizeHandle({ className: className, ariaLabel: ariaLabel, ariaValuenow: ariaValuenow, position: position, onKeyDown: onKeyDown, onPointerDown: onPointerDown }, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $6b3dd944ba6cee6d$export$2e2bcd8739ae039).slider, (0, $6b3dd944ba6cee6d$export$2e2bcd8739ae039)[`slider-${position}`]),
        role: "slider",
        tabIndex: 0,
        "aria-label": ariaLabel,
        "aria-valuemax": 100,
        "aria-valuemin": 0,
        "aria-valuenow": ariaValuenow,
        onKeyDown: onKeyDown,
        onPointerDown: onPointerDown
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ee5d8fe9928c41b$export$2e2bcd8739ae039), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6b3dd944ba6cee6d$export$2e2bcd8739ae039)["slider-icon"], (0, $6b3dd944ba6cee6d$export$2e2bcd8739ae039)[`slider-icon-${position}`])
    }));
});




const $fbbfc7e7be429ab7$export$c2945a2d20d1b49a = (_a)=>{
    var _b, _c, _d, _e;
    var { onResize: onResize, maxWidth: maxWidth, minWidth: minWidth, refs: refs, activeDrawer: activeDrawer, toolsContent: toolsContent } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "onResize",
        "maxWidth",
        "minWidth",
        "refs",
        "activeDrawer",
        "toolsContent"
    ]);
    const { isOpen: isOpen, children: children, width: width, isMobile: isMobile } = props;
    const clampedWidth = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minWidth, width, maxWidth);
    const relativeSize = (clampedWidth - minWidth) / (maxWidth - minWidth) * 100;
    const setSidePanelWidth = (newWidth)=>{
        const size = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minWidth, newWidth, maxWidth);
        const id = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id;
        if (isOpen && id && maxWidth >= minWidth) onResize({
            size: size,
            id: id
        });
    };
    const drawerRefObject = (0, $acw62.useRef)(null);
    const sizeControlProps = {
        position: "side",
        panelRef: drawerRefObject,
        handleRef: refs.slider,
        onResize: setSidePanelWidth
    };
    const onSliderPointerDown = (0, $0d7a0c5aa5b38dc9$export$69c48c1cbbd6dc69)(sizeControlProps);
    const onKeyDown = (0, $f3562f2817c11205$export$2ba6c1a0edf6483a)(sizeControlProps);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dedc90907529521f$export$4071300121a182f5), Object.assign({}, props, {
        id: activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id,
        width: clampedWidth,
        ref: drawerRefObject,
        isHidden: !activeDrawer,
        resizeHandle: !isMobile && (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.resizable) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df0c014177452109$export$2e2bcd8739ae039), {
            ref: refs.slider,
            position: "side",
            className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawers-slider"],
            ariaLabel: (_b = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.resizeHandle,
            ariaValuenow: relativeSize,
            onKeyDown: onKeyDown,
            onPointerDown: onSliderPointerDown
        }),
        ariaLabels: {
            openLabel: (_c = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _c === void 0 ? void 0 : _c.triggerButton,
            mainLabel: (_d = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _d === void 0 ? void 0 : _d.drawerName,
            closeLabel: (_e = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _e === void 0 ? void 0 : _e.closeButton
        }
    }), toolsContent && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id) !== (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $3b5852da42b0f2f1$export$2e2bcd8739ae039).hide)
    }, toolsContent), (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id) !== (0, $892ef2b582c4882d$export$329f249760e831ae) ? children : null);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");

var $b863a32023c65e65$export$2e2bcd8739ae039 = {
    "drawer-displayed": "awsui_drawer-displayed_1lh3u_mzbvz_101",
    "drawer-content": "awsui_drawer-content_1lh3u_mzbvz_105"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $0b5fa47dfe2910a6$var$SplitPanelContext = (0, $acw62.createContext)(null);
const $0b5fa47dfe2910a6$export$135e17255f989a61 = $0b5fa47dfe2910a6$var$SplitPanelContext.Provider;
function $0b5fa47dfe2910a6$export$5a37a347a11159b8() {
    const ctx = (0, $acw62.useContext)($0b5fa47dfe2910a6$var$SplitPanelContext);
    if (!ctx) throw new Error("Split panel can only be used inside app layout");
    return ctx;
}


function $b5261664e6ade23b$export$5bff16c6294339ae({ displayed: displayed, children: children }) {
    const { isOpen: isOpen, size: size, topOffset: topOffset, bottomOffset: bottomOffset } = (0, $0b5fa47dfe2910a6$export$5a37a347a11159b8)();
    const width = isOpen && children ? size : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(displayed && (0, $b863a32023c65e65$export$2e2bcd8739ae039)["drawer-displayed"]),
        style: {
            width: width
        },
        "data-testid": "side-split-panel-drawer"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $b863a32023c65e65$export$2e2bcd8739ae039)["drawer-content"],
        style: {
            width: width,
            top: topOffset,
            bottom: bottomOffset
        }
    }, children));
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $346c1f4e54c7d4ae$export$f9c7cae0dbc726b2 = 160;
const $346c1f4e54c7d4ae$export$c1bd455843613e23 = 280;



var $acw62 = parcelRequire("acw62");



function $846ec670e2f21dff$export$fe6de1726a5559a(_a) {
    var { children: children, size: size, getMaxHeight: getMaxHeight, maxWidth: maxWidth, reportSize: reportSize, onResize: onResize } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "children",
        "size",
        "getMaxHeight",
        "maxWidth",
        "reportSize",
        "onResize"
    ]);
    const { position: position, isOpen: isOpen } = rest;
    const [maxHeight, setMaxHeight] = (0, $acw62.useState)(size);
    const minSize = position === "bottom" ? (0, $346c1f4e54c7d4ae$export$f9c7cae0dbc726b2) : (0, $346c1f4e54c7d4ae$export$c1bd455843613e23);
    const maxSize = position === "bottom" ? maxHeight : maxWidth;
    const cappedSize = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minSize, size, maxSize);
    const relativeSize = (size - minSize) / (maxSize - minSize) * 100;
    const onResizeWithValidation = (newSize)=>{
        const maxSize = position === "side" ? maxWidth : getMaxHeight();
        const isResizeValid = position === "side" ? maxSize >= (0, $346c1f4e54c7d4ae$export$c1bd455843613e23) : maxSize >= (0, $346c1f4e54c7d4ae$export$f9c7cae0dbc726b2);
        if (isOpen && isResizeValid) onResize((0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minSize, newSize, maxSize));
    };
    (0, $acw62.useEffect)(()=>{
        if (position !== "bottom") return;
        // effects are called inside out in the components tree
        // wait one frame to allow app-layout to complete its calculations
        const handle = requestAnimationFrame(()=>setMaxHeight(getMaxHeight()));
        return ()=>cancelAnimationFrame(handle);
    }, [
        size,
        minSize,
        position,
        getMaxHeight
    ]);
    (0, $acw62.useEffect)(()=>{
        reportSize(cappedSize);
    }, [
        reportSize,
        cappedSize
    ]);
    (0, $acw62.useEffect)(()=>{
        if (position !== "bottom") return;
        const handler = ()=>setMaxHeight(getMaxHeight());
        window.addEventListener("resize", handler);
        return ()=>window.removeEventListener("resize", handler);
    }, [
        position,
        getMaxHeight
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0b5fa47dfe2910a6$export$135e17255f989a61), {
        value: Object.assign(Object.assign({}, rest), {
            size: cappedSize,
            relativeSize: relativeSize,
            onResize: onResizeWithValidation
        })
    }, children);
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $d19d77c31ea1086e$export$ba7387b5ce3f72be(dependencies) {
    const refs = {
        toggle: (0, $acw62.useRef)(null),
        slider: (0, $acw62.useRef)(null),
        preferences: (0, $acw62.useRef)(null)
    };
    const lastInteraction = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        var _a, _b, _c, _d;
        switch((_a = lastInteraction.current) === null || _a === void 0 ? void 0 : _a.type){
            case "open":
                (_b = refs.slider.current) === null || _b === void 0 || _b.focus();
                break;
            case "close":
                (_c = refs.toggle.current) === null || _c === void 0 || _c.focus();
                break;
            case "position":
                (_d = refs.preferences.current) === null || _d === void 0 || _d.focus();
                break;
        }
        lastInteraction.current = null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
    return {
        refs: refs,
        setLastInteraction: (interaction)=>lastInteraction.current = interaction
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $822db745899a2b07$var$globalVars = {
    stickyVerticalTopOffset: "--awsui-sticky-vertical-top-offset",
    stickyVerticalBottomOffset: "--awsui-sticky-vertical-bottom-offset"
};
var $822db745899a2b07$export$2e2bcd8739ae039 = $822db745899a2b07$var$globalVars;


function $218e10bc7e8580c0$export$7f13b984303df6e1(headerHeight, footerHeight, stickyNotificationsHeight, mobileToolbarHeight, disableBodyScroll, isMobile) {
    return {
        [(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalTopOffset]: `calc(${!disableBodyScroll ? headerHeight : 0}px + ${isMobile ? mobileToolbarHeight : stickyNotificationsHeight})`,
        [(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalBottomOffset]: `${!disableBodyScroll ? footerHeight : 0}px`
    };
}




const $6ad7a06c5c5b5cb1$var$ClassicAppLayout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var _b, _c, _d, _e, _f, _g;
    var { navigation: navigation, navigationWidth: navigationWidth, navigationHide: navigationHide, navigationOpen: navigationOpen, tools: tools, toolsWidth: toolsWidth, toolsHide: toolsHide, toolsOpen: controlledToolsOpen, breadcrumbs: breadcrumbs, notifications: notifications, stickyNotifications: stickyNotifications, contentHeader: contentHeader, disableContentHeaderOverlap: disableContentHeaderOverlap, content: content, contentType: contentType, disableContentPaddings: disableContentPaddings, disableBodyScroll: disableBodyScroll, maxContentWidth: maxContentWidth, minContentWidth: minContentWidth, placement: placement, ariaLabels: ariaLabels, splitPanel: splitPanel, splitPanelSize: controlledSplitPanelSize, splitPanelOpen: controlledSplitPanelOpen, splitPanelPreferences: controlledSplitPanelPreferences, onSplitPanelPreferencesChange: onSplitPanelPreferencesChange, onSplitPanelResize: onSplitPanelResize, onSplitPanelToggle: onSplitPanelToggle, onNavigationChange: onNavigationChange, onToolsChange: onToolsChange, drawers: controlledDrawers, onDrawerChange: onDrawerChange, activeDrawerId: controlledActiveDrawerId } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "navigation",
        "navigationWidth",
        "navigationHide",
        "navigationOpen",
        "tools",
        "toolsWidth",
        "toolsHide",
        "toolsOpen",
        "breadcrumbs",
        "notifications",
        "stickyNotifications",
        "contentHeader",
        "disableContentHeaderOverlap",
        "content",
        "contentType",
        "disableContentPaddings",
        "disableBodyScroll",
        "maxContentWidth",
        "minContentWidth",
        "placement",
        "ariaLabels",
        "splitPanel",
        "splitPanelSize",
        "splitPanelOpen",
        "splitPanelPreferences",
        "onSplitPanelPreferencesChange",
        "onSplitPanelResize",
        "onSplitPanelToggle",
        "onNavigationChange",
        "onToolsChange",
        "drawers",
        "onDrawerChange",
        "activeDrawerId"
    ]);
    // Private API for embedded view mode
    const __embeddedViewMode = Boolean(rest.__embeddedViewMode);
    const rootRef = (0, $acw62.useRef)(null);
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const [toolsOpen = false, setToolsOpen] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledToolsOpen, onToolsChange, false, {
        componentName: "AppLayout",
        controlledProp: "toolsOpen",
        changeHandler: "onToolsChange"
    });
    const onToolsToggle = (open)=>{
        setToolsOpen(open);
        focusToolsButtons();
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onToolsChange, {
            open: open
        });
    };
    const { drawers: drawers, activeDrawer: activeDrawer, minDrawerSize: minDrawerSize, activeDrawerSize: activeDrawerSize, activeDrawerId: activeDrawerId, ariaLabelsWithDrawers: ariaLabelsWithDrawers, onActiveDrawerChange: onActiveDrawerChange, onActiveDrawerResize: onActiveDrawerResize } = (0, $892ef2b582c4882d$export$468f52f962f49bf5)(Object.assign({
        drawers: controlledDrawers,
        onDrawerChange: onDrawerChange,
        activeDrawerId: controlledActiveDrawerId
    }, rest), ariaLabels, {
        disableDrawersMerge: true,
        ariaLabels: ariaLabels,
        tools: tools,
        toolsOpen: toolsOpen,
        toolsHide: toolsHide,
        toolsWidth: toolsWidth,
        onToolsToggle: onToolsToggle
    });
    ariaLabels = ariaLabelsWithDrawers;
    const hasDrawers = !!drawers;
    const { refs: navigationRefs, setFocus: focusNavButtons } = (0, $84d3a2bbe2557e44$export$817e5b4536f33d83)(navigationOpen);
    const { refs: toolsRefs, setFocus: focusToolsButtons, loseFocus: loseToolsFocus } = (0, $84d3a2bbe2557e44$export$817e5b4536f33d83)(toolsOpen || activeDrawer !== undefined, true);
    const { refs: drawerRefs, setFocus: focusDrawersButtons, loseFocus: loseDrawersFocus } = (0, $84d3a2bbe2557e44$export$817e5b4536f33d83)(!!activeDrawerId, true, activeDrawerId);
    const onNavigationToggle = (0, $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0)((open)=>{
        focusNavButtons();
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onNavigationChange, {
            open: open
        });
    });
    const onNavigationClick = (event)=>{
        const hasLink = (0, $38f6480185c49d6f$export$184ef262a758e3c4)(event.target, (node)=>node.tagName === "A" && !!node.href);
        if (hasLink) onNavigationToggle(false);
    };
    (0, $acw62.useEffect)(()=>{
        // Close navigation drawer on mobile so that the main content is visible
        if (isMobile) onNavigationToggle(false);
    }, [
        isMobile,
        onNavigationToggle
    ]);
    const navigationVisible = !navigationHide && navigationOpen;
    const toolsVisible = !toolsHide && toolsOpen;
    const [headerFooterHeight, setHeaderFooterHeight] = (0, $acw62.useState)(0);
    // Delay applying changes in header/footer height, as applying them immediately can cause
    // ResizeOberver warnings due to the algorithm thinking that the change might have side-effects
    // further up the tree, therefore blocking notifications to prevent loops
    (0, $acw62.useEffect)(()=>{
        const id = requestAnimationFrame(()=>setHeaderFooterHeight(placement.insetBlockStart + placement.insetBlockEnd));
        return ()=>cancelAnimationFrame(id);
    }, [
        placement.insetBlockStart,
        placement.insetBlockEnd
    ]);
    const contentHeightStyle = {
        [disableBodyScroll ? "height" : "minHeight"]: `calc(100vh - ${headerFooterHeight}px)`
    };
    const [notificationsHeight, notificationsRef] = (0, $6e052e2d296ab854$export$2e2bcd8739ae039)((rect)=>rect.contentBoxHeight);
    const anyPanelOpen = navigationVisible || toolsVisible || !!activeDrawer;
    const hasRenderedNotifications = notificationsHeight ? notificationsHeight > 0 : false;
    const stickyNotificationsHeight = stickyNotifications ? notificationsHeight !== null && notificationsHeight !== void 0 ? notificationsHeight : 0 : 0;
    const [splitPanelPreferences, setSplitPanelPreferences] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledSplitPanelPreferences, onSplitPanelPreferencesChange, undefined, {
        componentName: "AppLayout",
        controlledProp: "splitPanelPreferences",
        changeHandler: "onSplitPanelPreferencesChange"
    });
    const [splitPanelOpen = false, setSplitPanelOpen] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledSplitPanelOpen, onSplitPanelToggle, false, {
        componentName: "AppLayout",
        controlledProp: "splitPanelOpen",
        changeHandler: "onSplitPanelToggle"
    });
    const splitPanelPosition = (splitPanelPreferences === null || splitPanelPreferences === void 0 ? void 0 : splitPanelPreferences.position) || "bottom";
    const [splitPanelReportedToggle, setSplitPanelReportedToggle] = (0, $acw62.useState)({
        displayed: false,
        ariaLabel: undefined
    });
    const splitPanelDisplayed = !!(splitPanel && (splitPanelReportedToggle.displayed || splitPanelOpen));
    const closedDrawerWidth = 40;
    const effectiveNavigationWidth = navigationHide ? 0 : navigationOpen ? navigationWidth : closedDrawerWidth;
    const getEffectiveToolsWidth = ()=>{
        if (activeDrawerSize) return activeDrawerSize;
        if (toolsHide || drawers) return 0;
        if (toolsOpen) return toolsWidth;
        return closedDrawerWidth;
    };
    const effectiveToolsWidth = getEffectiveToolsWidth();
    const defaultSplitPanelSize = (0, $582c00c3ff10d4e2$export$9d9d5fcac617b082)(splitPanelPosition);
    const [splitPanelSize = defaultSplitPanelSize, setSplitPanelSize] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledSplitPanelSize, onSplitPanelResize, defaultSplitPanelSize, {
        componentName: "AppLayout",
        controlledProp: "splitPanelSize",
        changeHandler: "onSplitPanelResize"
    });
    const mainContentRef = (0, $acw62.useRef)(null);
    const legacyScrollRootRef = (0, $acw62.useRef)(null);
    const { refs: splitPanelRefs, setLastInteraction: setSplitPanelLastInteraction } = (0, $d19d77c31ea1086e$export$ba7387b5ce3f72be)([
        splitPanelPreferences,
        splitPanelOpen
    ]);
    const onSplitPanelPreferencesSet = (0, $acw62.useCallback)((detail)=>{
        setSplitPanelPreferences(detail);
        setSplitPanelLastInteraction({
            type: "position"
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSplitPanelPreferencesChange, detail);
    }, [
        setSplitPanelPreferences,
        onSplitPanelPreferencesChange,
        setSplitPanelLastInteraction
    ]);
    const onSplitPanelSizeSet = (0, $acw62.useCallback)((newSize)=>{
        setSplitPanelSize(newSize);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSplitPanelResize, {
            size: newSize
        });
    }, [
        setSplitPanelSize,
        onSplitPanelResize
    ]);
    const onSplitPanelToggleHandler = (0, $acw62.useCallback)(()=>{
        setSplitPanelOpen(!splitPanelOpen);
        setSplitPanelLastInteraction({
            type: splitPanelOpen ? "close" : "open"
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSplitPanelToggle, {
            open: !splitPanelOpen
        });
    }, [
        setSplitPanelOpen,
        splitPanelOpen,
        onSplitPanelToggle,
        setSplitPanelLastInteraction
    ]);
    const getSplitPanelMaxHeight = (0, $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0)(()=>{
        if (typeof document === "undefined") return 0; // render the split panel in its minimum possible size
        else if (disableBodyScroll && legacyScrollRootRef.current) {
            const availableHeight = legacyScrollRootRef.current.clientHeight;
            return availableHeight < (0, $582c00c3ff10d4e2$export$221784c3b0ae64c0) ? availableHeight : availableHeight - (0, $582c00c3ff10d4e2$export$bed14608432f307e);
        } else {
            const availableHeight = document.documentElement.clientHeight - placement.insetBlockStart - placement.insetBlockEnd;
            return availableHeight < (0, $582c00c3ff10d4e2$export$221784c3b0ae64c0) ? availableHeight - (0, $582c00c3ff10d4e2$export$99ee445a84ec4a0d) : availableHeight - (0, $582c00c3ff10d4e2$export$bed14608432f307e);
        }
    });
    const rightDrawerBarWidth = drawers ? drawers.length > 1 ? closedDrawerWidth : 0 : 0;
    const contentPadding = 80;
    // all content except split-panel + drawers/tools area
    const resizableSpaceAvailable = Math.max(0, placement.inlineSize - effectiveNavigationWidth - minContentWidth - contentPadding - rightDrawerBarWidth);
    // if there is no space to display split panel in the side, force to bottom
    const isSplitPanelForcedPosition = isMobile || resizableSpaceAvailable - effectiveToolsWidth < (0, $346c1f4e54c7d4ae$export$c1bd455843613e23);
    const finalSplitPanePosition = isSplitPanelForcedPosition ? "bottom" : splitPanelPosition;
    const splitPaneAvailableOnTheSide = splitPanelDisplayed && finalSplitPanePosition === "side";
    const sideSplitPanelSize = splitPaneAvailableOnTheSide ? splitPanelOpen ? splitPanelSize : closedDrawerWidth : 0;
    const splitPanelMaxWidth = Math.max(0, resizableSpaceAvailable - effectiveToolsWidth);
    const drawerMaxSize = Math.max(0, resizableSpaceAvailable - sideSplitPanelSize);
    const navigationClosedWidth = navigationHide || isMobile ? 0 : closedDrawerWidth;
    const contentMaxWidthStyle = !isMobile ? {
        maxWidth: maxContentWidth
    } : undefined;
    const [splitPanelReportedSize, setSplitPanelReportedSize] = (0, $acw62.useState)(0);
    const [splitPanelReportedHeaderHeight, setSplitPanelReportedHeaderHeight] = (0, $acw62.useState)(0);
    const splitPanelContextProps = {
        topOffset: placement.insetBlockStart + (finalSplitPanePosition === "bottom" ? stickyNotificationsHeight : 0),
        bottomOffset: placement.insetBlockEnd,
        leftOffset: placement.insetInlineStart + (isMobile ? 0 : !navigationHide && navigationOpen ? navigationWidth : navigationClosedWidth),
        rightOffset: isMobile ? 0 : placement.insetInlineEnd + effectiveToolsWidth + rightDrawerBarWidth,
        position: finalSplitPanePosition,
        size: splitPanelSize,
        maxWidth: splitPanelMaxWidth,
        getMaxHeight: getSplitPanelMaxHeight,
        disableContentPaddings: disableContentPaddings,
        contentWidthStyles: contentMaxWidthStyle,
        isOpen: splitPanelOpen,
        isForcedPosition: isSplitPanelForcedPosition,
        onResize: onSplitPanelSizeSet,
        onToggle: onSplitPanelToggleHandler,
        onPreferencesChange: onSplitPanelPreferencesSet,
        setSplitPanelToggle: setSplitPanelReportedToggle,
        reportSize: setSplitPanelReportedSize,
        reportHeaderHeight: setSplitPanelReportedHeaderHeight,
        refs: splitPanelRefs
    };
    const splitPanelWrapped = splitPanel && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $846ec670e2f21dff$export$fe6de1726a5559a), Object.assign({}, splitPanelContextProps), finalSplitPanePosition === "side" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b5261664e6ade23b$export$5bff16c6294339ae), {
        displayed: splitPanelDisplayed
    }, splitPanel) : splitPanel);
    const contentWrapperProps = {
        contentType: contentType,
        navigationPadding: navigationHide || !!navigationOpen,
        contentWidthStyles: !isMobile ? {
            minWidth: minContentWidth,
            maxWidth: maxContentWidth
        } : undefined,
        toolsPadding: // tools padding is displayed in one of the three cases
        // 1. Nothing on the that screen edge (no tools panel and no split panel)
        toolsHide || hasDrawers && !activeDrawer && (!splitPanelDisplayed || finalSplitPanePosition !== "side") || // 2. Tools panel is present and open
        toolsVisible || // 3. Split panel is open in side position
        splitPaneAvailableOnTheSide && splitPanelOpen,
        isMobile: isMobile
    };
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            openTools: ()=>onToolsToggle(true),
            closeNavigationIfNecessary: ()=>{
                if (isMobile) onNavigationToggle(false);
            },
            focusToolsClose: ()=>{
                if (hasDrawers) focusDrawersButtons(true);
                else focusToolsButtons(true);
            },
            focusActiveDrawer: ()=>focusDrawersButtons(true),
            focusSplitPanel: ()=>{
                var _a;
                return (_a = splitPanelRefs.slider.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }));
    const splitPanelBottomOffset = (_b = !splitPanelDisplayed || finalSplitPanePosition !== "bottom" ? undefined : splitPanelOpen ? splitPanelReportedSize : splitPanelReportedHeaderHeight) !== null && _b !== void 0 ? _b : undefined;
    const [mobileBarHeight, mobileBarRef] = (0, $6e052e2d296ab854$export$2e2bcd8739ae039)((rect)=>rect.contentBoxHeight);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e16b5b5cece95db$export$2e2bcd8739ae039).root, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).root, disableBodyScroll && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["root-no-scroll"]),
        ref: rootRef,
        style: contentHeightStyle
    }, isMobile && !__embeddedViewMode && (!toolsHide || !navigationHide || breadcrumbs) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $61eeb350f8678116$export$ad5e3cc87670c145), {
        anyPanelOpen: anyPanelOpen,
        toggleRefs: {
            navigation: navigationRefs.toggle,
            tools: toolsRefs.toggle
        },
        topOffset: placement.insetBlockStart,
        ariaLabels: ariaLabels,
        navigationHide: navigationHide,
        toolsHide: toolsHide,
        onNavigationOpen: ()=>onNavigationToggle(true),
        onToolsOpen: ()=>onToolsToggle(true),
        unfocusable: anyPanelOpen,
        mobileBarRef: mobileBarRef,
        drawers: drawers,
        activeDrawerId: activeDrawerId,
        onDrawerChange: (newDrawerId)=>{
            onActiveDrawerChange(newDrawerId);
            if (newDrawerId !== activeDrawerId) {
                focusToolsButtons();
                focusDrawersButtons();
            }
        }
    }, breadcrumbs), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e16b5b5cece95db$export$2e2bcd8739ae039).layout, disableBodyScroll && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["layout-no-scroll"])
    }, !navigationHide && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dedc90907529521f$export$4071300121a182f5), {
        contentClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).navigation,
        toggleClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["navigation-toggle"],
        closeClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["navigation-close"],
        ariaLabels: (0, $917b74cb04fa7906$export$e0ae33479bcb926a).navigation.getLabels(ariaLabels),
        bottomOffset: placement.insetBlockEnd,
        topOffset: placement.insetBlockStart,
        isMobile: isMobile,
        isOpen: navigationOpen,
        onClick: isMobile ? onNavigationClick : undefined,
        onToggle: onNavigationToggle,
        toggleRefs: navigationRefs,
        type: "navigation",
        width: navigationWidth
    }, navigation), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("main", {
        ref: legacyScrollRootRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["layout-main"], {
            [(0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["layout-main-scrollable"]]: disableBodyScroll,
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["disable-body-scroll-root"]]: disableBodyScroll,
            [(0, $1e16b5b5cece95db$export$2e2bcd8739ae039).unfocusable]: isMobile && anyPanelOpen
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginBottom: splitPanelBottomOffset
        }
    }, notifications && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6787200e64d912d4$export$36ba2f559d49a8f6), {
        disableContentPaddings: disableContentPaddings,
        testUtilsClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).notifications,
        labels: ariaLabels,
        topOffset: disableBodyScroll ? 0 : placement.insetBlockStart,
        sticky: !isMobile && stickyNotifications,
        ref: notificationsRef
    }, notifications), (!isMobile && breadcrumbs || contentHeader) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $22602bc147daf734$export$2e2bcd8739ae039), Object.assign({}, contentWrapperProps), !isMobile && breadcrumbs && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).breadcrumbs, (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["breadcrumbs-desktop"])
    }, breadcrumbs), contentHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["content-header-wrapper"], !hasRenderedNotifications && (isMobile || !breadcrumbs) && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["content-extra-top-padding"], !hasRenderedNotifications && !breadcrumbs && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["content-header-wrapper-first-child"], !disableContentHeaderOverlap && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["content-header-wrapper-overlapped"])
    }, contentHeader)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $22602bc147daf734$export$2e2bcd8739ae039), Object.assign({}, contentWrapperProps, {
        ref: mainContentRef,
        disablePaddings: disableContentPaddings,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(!disableContentPaddings && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["content-wrapper"], !disableContentPaddings && (isMobile || !breadcrumbs) && !contentHeader && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["content-extra-top-padding"], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).content, !disableContentHeaderOverlap && contentHeader && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["content-overlapped"], !hasRenderedNotifications && !breadcrumbs && !isMobile && !contentHeader && (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["content-wrapper-first-child"]),
        style: (0, $218e10bc7e8580c0$export$7f13b984303df6e1)(placement.insetBlockStart, placement.insetBlockEnd + (splitPanelBottomOffset || 0), `${stickyNotificationsHeight}px`, mobileBarHeight && !disableBodyScroll ? `${mobileBarHeight}px` : "0px", !!disableBodyScroll, isMobile)
    }), content)), finalSplitPanePosition === "bottom" && splitPanelWrapped), finalSplitPanePosition === "side" && splitPanelWrapped, hasDrawers ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fbbfc7e7be429ab7$export$c2945a2d20d1b49a), {
        contentClassName: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(activeDrawerId && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["active-drawer"], activeDrawerId === (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).tools),
        toggleClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-toggle"],
        closeClassName: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["active-drawer-close-button"], activeDrawerId === (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-close"]),
        ariaLabels: {
            openLabel: (_c = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _c === void 0 ? void 0 : _c.triggerButton,
            closeLabel: (_d = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _d === void 0 ? void 0 : _d.closeButton,
            mainLabel: (_e = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _e === void 0 ? void 0 : _e.drawerName,
            resizeHandle: (_f = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _f === void 0 ? void 0 : _f.resizeHandle
        },
        minWidth: minDrawerSize,
        maxWidth: drawerMaxSize,
        width: activeDrawerSize,
        bottomOffset: placement.insetBlockEnd,
        topOffset: placement.insetBlockStart,
        isMobile: isMobile,
        onToggle: (isOpen)=>{
            if (!isOpen) {
                focusToolsButtons();
                focusDrawersButtons();
                onActiveDrawerChange(null);
            }
        },
        isOpen: true,
        hideOpenButton: true,
        toggleRefs: drawerRefs,
        type: "tools",
        onLoseFocus: loseDrawersFocus,
        activeDrawer: activeDrawer,
        onResize: (changeDetail)=>onActiveDrawerResize(changeDetail),
        refs: drawerRefs,
        toolsContent: (_g = drawers === null || drawers === void 0 ? void 0 : drawers.find((drawer)=>drawer.id === (0, $892ef2b582c4882d$export$329f249760e831ae))) === null || _g === void 0 ? void 0 : _g.content
    }, activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.content) : !toolsHide && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dedc90907529521f$export$4071300121a182f5), {
        contentClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).tools,
        toggleClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-toggle"],
        closeClassName: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-close"],
        ariaLabels: (0, $917b74cb04fa7906$export$e0ae33479bcb926a).tools.getLabels(ariaLabels),
        width: toolsWidth,
        bottomOffset: placement.insetBlockEnd,
        topOffset: placement.insetBlockStart,
        isMobile: isMobile,
        onToggle: onToolsToggle,
        isOpen: toolsOpen,
        toggleRefs: toolsRefs,
        type: "tools",
        onLoseFocus: loseToolsFocus
    }, tools), hasDrawers && drawers.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dedc90907529521f$export$30e27a27f04aa467), {
        drawerRefs: drawerRefs,
        bottomOffset: placement.insetBlockEnd,
        topOffset: placement.insetBlockStart,
        isMobile: isMobile,
        drawers: drawers,
        activeDrawerId: activeDrawerId,
        onDrawerChange: (newDrawerId)=>{
            if (activeDrawerId !== newDrawerId) {
                focusToolsButtons();
                focusDrawersButtons();
            }
            onActiveDrawerChange(newDrawerId);
        },
        ariaLabels: ariaLabels
    })));
});
var $6ad7a06c5c5b5cb1$export$2e2bcd8739ae039 = $6ad7a06c5c5b5cb1$var$ClassicAppLayout;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $011bca9bf46093da$export$70fcc38162d125af = (0, $acw62.createContext)(()=>{});





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $7419c94a5186c7f4$export$2e2bcd8739ae039 = {
    "background": "awsui_background_hyvsj_fae1z_97",
    "scrolling-background": "awsui_scrolling-background_hyvsj_fae1z_100",
    "breadcrumbs": "awsui_breadcrumbs_hyvsj_fae1z_111",
    "drawers-container": "awsui_drawers-container_hyvsj_fae1z_124",
    "has-open-drawer": "awsui_has-open-drawer_hyvsj_fae1z_135",
    "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_fae1z_156",
    "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_fae1z_161",
    "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_fae1z_202",
    "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_fae1z_212",
    "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_fae1z_217",
    "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_fae1z_231",
    "drawers-trigger": "awsui_drawers-trigger_hyvsj_fae1z_217",
    "drawer": "awsui_drawer_hyvsj_fae1z_124",
    "drawer-content-container": "awsui_drawer-content-container_hyvsj_fae1z_262",
    "drawer-close-button": "awsui_drawer-close-button_hyvsj_fae1z_271",
    "drawer-content": "awsui_drawer-content_hyvsj_fae1z_262",
    "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_fae1z_279",
    "drawer-slider": "awsui_drawer-slider_hyvsj_fae1z_282",
    "is-drawer-open": "awsui_is-drawer-open_hyvsj_fae1z_289",
    "content": "awsui_content_hyvsj_fae1z_315",
    "layout": "awsui_layout_hyvsj_fae1z_336",
    "has-max-content-width": "awsui_has-max-content-width_hyvsj_fae1z_408",
    "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_fae1z_423",
    "content-type-table": "awsui_content-type-table_hyvsj_fae1z_437",
    "content-type-cards": "awsui_content-type-cards_hyvsj_fae1z_437",
    "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_fae1z_443",
    "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_fae1z_446",
    "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_fae1z_460",
    "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_fae1z_463",
    "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_fae1z_473",
    "content-first-child-header": "awsui_content-first-child-header_hyvsj_fae1z_476",
    "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_fae1z_476",
    "has-header": "awsui_has-header_hyvsj_fae1z_476",
    "content-first-child-main": "awsui_content-first-child-main_hyvsj_fae1z_491",
    "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_fae1z_491",
    "has-left-toggles-gutter": "awsui_has-left-toggles-gutter_hyvsj_fae1z_511",
    "has-right-toggles-gutter": "awsui_has-right-toggles-gutter_hyvsj_fae1z_514",
    "has-split-panel": "awsui_has-split-panel_hyvsj_fae1z_534",
    "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_fae1z_534",
    "block-body-scroll": "awsui_block-body-scroll_hyvsj_fae1z_542",
    "unfocusable": "awsui_unfocusable_hyvsj_fae1z_547",
    "container": "awsui_container_hyvsj_fae1z_557",
    "is-navigation-open": "awsui_is-navigation-open_hyvsj_fae1z_583",
    "is-tools-open": "awsui_is-tools-open_hyvsj_fae1z_586",
    "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_fae1z_586",
    "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_fae1z_586",
    "has-active-drawer": "awsui_has-active-drawer_hyvsj_fae1z_586",
    "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_fae1z_595",
    "remove-high-contrast-header": "awsui_remove-high-contrast-header_hyvsj_fae1z_612",
    "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_fae1z_616",
    "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_fae1z_620",
    "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_fae1z_624",
    "navigation-container": "awsui_navigation-container_hyvsj_fae1z_633",
    "show-navigation": "awsui_show-navigation_hyvsj_fae1z_671",
    "animating": "awsui_animating_hyvsj_fae1z_694",
    "showButtons": "awsui_showButtons_hyvsj_fae1z_1",
    "navigation": "awsui_navigation_hyvsj_fae1z_633",
    "openNavigation": "awsui_openNavigation_hyvsj_fae1z_1",
    "animated-content": "awsui_animated-content_hyvsj_fae1z_756",
    "hide-navigation": "awsui_hide-navigation_hyvsj_fae1z_765",
    "notifications": "awsui_notifications_hyvsj_fae1z_775",
    "has-notification-content": "awsui_has-notification-content_hyvsj_fae1z_780",
    "sticky-notifications": "awsui_sticky-notifications_hyvsj_fae1z_784",
    "high-contrast": "awsui_high-contrast_hyvsj_fae1z_789",
    "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_fae1z_807",
    "position-bottom": "awsui_position-bottom_hyvsj_fae1z_854",
    "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_fae1z_1",
    "split-panel-side": "awsui_split-panel-side_hyvsj_fae1z_883",
    "position-side": "awsui_position-side_hyvsj_fae1z_896",
    "tools-container": "awsui_tools-container_hyvsj_fae1z_918",
    "tools": "awsui_tools_hyvsj_fae1z_918",
    "openTools": "awsui_openTools_hyvsj_fae1z_1",
    "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_fae1z_1007",
    "hide-tools": "awsui_hide-tools_hyvsj_fae1z_1017",
    "show-tools": "awsui_show-tools_hyvsj_fae1z_1029",
    "has-tools-form": "awsui_has-tools-form_hyvsj_fae1z_1007",
    "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_fae1z_1112",
    "trigger": "awsui_trigger_hyvsj_fae1z_1112",
    "selected": "awsui_selected_hyvsj_fae1z_1190",
    "badge": "awsui_badge_hyvsj_fae1z_1210",
    "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_fae1z_1214",
    "dot": "awsui_dot_hyvsj_fae1z_1225"
};





/**
 * If there is no Split Panel in the AppLayout context then the SplitPanel
 * will pass through the AppLayout children without the context.
 */ function $eda04021d4548892$var$SplitPanel({ children: children }) {
    const { footerHeight: footerHeight, handleSplitPanelClick: handleSplitPanelClick, handleSplitPanelPreferencesChange: handleSplitPanelPreferencesChange, handleSplitPanelResize: handleSplitPanelResize, headerHeight: headerHeight, isSplitPanelForcedPosition: isSplitPanelForcedPosition, isSplitPanelOpen: isSplitPanelOpen, setSplitPanelReportedSize: setSplitPanelReportedSize, setSplitPanelReportedHeaderHeight: setSplitPanelReportedHeaderHeight, setSplitPanelToggle: setSplitPanelToggle, splitPanelPosition: splitPanelPosition, splitPanelRefs: splitPanelRefs, splitPanelSize: splitPanelSize } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const props = {
        bottomOffset: 0,
        getMaxHeight: ()=>{
            const availableHeight = document.documentElement.clientHeight - headerHeight - footerHeight;
            // If the page is likely zoomed in at 200%, allow the split panel to fill the content area.
            return availableHeight < 400 ? availableHeight - 40 : availableHeight - 250;
        },
        maxWidth: typeof document !== "undefined" ? document.documentElement.clientWidth : Number.POSITIVE_INFINITY,
        isForcedPosition: isSplitPanelForcedPosition,
        isOpen: isSplitPanelOpen,
        leftOffset: 0,
        onPreferencesChange: handleSplitPanelPreferencesChange,
        onResize: handleSplitPanelResize,
        onToggle: handleSplitPanelClick,
        position: splitPanelPosition,
        reportSize: setSplitPanelReportedSize,
        reportHeaderHeight: setSplitPanelReportedHeaderHeight,
        rightOffset: 0,
        size: splitPanelSize || 0,
        topOffset: 0,
        setSplitPanelToggle: setSplitPanelToggle,
        refs: splitPanelRefs
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $846ec670e2f21dff$export$fe6de1726a5559a), Object.assign({}, props), children);
}
/**
 * This is the render function for the SplitPanel when it is in bottom position.
 * The Split Panel container will be another row entry in the grid definition in
 * the Layout component. The start and finish columns will be variable based
 * on the presence and state of the Navigation and Tools components.
 */ function $eda04021d4548892$var$SplitPanelBottom() {
    const { disableBodyScroll: disableBodyScroll, hasOpenDrawer: hasOpenDrawer, navigationOpen: navigationOpen, isSplitPanelOpen: isSplitPanelOpen, splitPanel: splitPanel, splitPanelPosition: splitPanelPosition, splitPanelReportedSize: splitPanelReportedSize, splitPanelReportedHeaderHeight: splitPanelReportedHeaderHeight } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (!splitPanel) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
        in: isSplitPanelOpen !== null && isSplitPanelOpen !== void 0 ? isSplitPanelOpen : false,
        exit: false
    }, (state, transitionEventsRef)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["split-panel-bottom"], (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)[`position-${splitPanelPosition}`], {
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).animating]: state === "entering",
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["disable-body-scroll"]]: disableBodyScroll,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-open-drawer"]]: hasOpenDrawer,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["is-navigation-open"]]: navigationOpen,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["is-split-panel-open"]]: isSplitPanelOpen
            }),
            ref: transitionEventsRef,
            style: {
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).splitPanelReportedSize]: `${splitPanelReportedSize}px`,
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).splitPanelReportedHeaderSize]: `${splitPanelReportedHeaderHeight}px`
            }
        }, splitPanelPosition === "bottom" && splitPanel));
}
/**
 * This is the render function for the SplitPanel when it is side position.
 * The Split Panel will not be within the grid defined in the Layout component
 * but instead a direct child of the Tools component. The width constraints
 * for this position are computed in the Tools component.
 */ /**
 * This component has no opening animations because it causes lots of rerenders that makes the component lag. *
 */ function $eda04021d4548892$var$SplitPanelSide() {
    const { isSplitPanelOpen: isSplitPanelOpen, splitPanel: splitPanel, splitPanelPosition: splitPanelPosition, splitPanelMaxWidth: splitPanelMaxWidth, splitPanelControlId: splitPanelControlId, isToolsOpen: isToolsOpen, activeDrawerId: activeDrawerId } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (!splitPanel) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        id: splitPanelControlId,
        "aria-hidden": !isSplitPanelOpen || splitPanelPosition === "bottom" ? true : false,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["split-panel-side"], (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)[`position-${splitPanelPosition}`], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["is-split-panel-open"]]: isSplitPanelOpen,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-open-drawer"]]: !!activeDrawerId || isToolsOpen
        }),
        style: {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).splitPanelMaxWidth]: `${splitPanelMaxWidth}px`,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).splitPanelMinWidth]: `${(0, $346c1f4e54c7d4ae$export$c1bd455843613e23)}px`
        }
    }, splitPanelPosition === "side" && splitPanel);
}
function $eda04021d4548892$export$5582f2db528b4683(isSplitPanelForcedPosition, splitPanelPreferences) {
    let splitPanelPosition = "bottom";
    if (!isSplitPanelForcedPosition && (splitPanelPreferences === null || splitPanelPreferences === void 0 ? void 0 : splitPanelPreferences.position) === "side") splitPanelPosition = "side";
    return splitPanelPosition;
}
$eda04021d4548892$var$SplitPanel.Bottom = $eda04021d4548892$var$SplitPanelBottom;
$eda04021d4548892$var$SplitPanel.Side = $eda04021d4548892$var$SplitPanelSide;
var $eda04021d4548892$export$2e2bcd8739ae039 = $eda04021d4548892$var$SplitPanel;






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





function $022a29f861c64d70$var$useResize(drawerRefObject, { activeDrawer: activeDrawer, activeDrawerSize: activeDrawerSize, onActiveDrawerResize: onActiveDrawerResize, drawersRefs: drawersRefs, isToolsOpen: isToolsOpen, drawersMinWidth: drawersMinWidth, drawersMaxWidth: drawersMaxWidth }) {
    var _a;
    const [relativeSize, setRelativeSize] = (0, $acw62.useState)(0);
    const drawerSize = !activeDrawer && !isToolsOpen ? 0 : activeDrawerSize;
    (0, $acw62.useEffect)(()=>{
        // effects are called inside out in the components tree
        // wait one frame to allow app-layout to complete its calculations
        const handle = requestAnimationFrame(()=>{
            const maxSize = drawersMaxWidth;
            setRelativeSize((drawerSize - drawersMinWidth) / (maxSize - drawersMinWidth) * 100);
        });
        return ()=>cancelAnimationFrame(handle);
    }, [
        drawerSize,
        drawersMaxWidth,
        drawersMinWidth
    ]);
    const setSidePanelWidth = (width)=>{
        const maxWidth = drawersMaxWidth;
        const size = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(drawersMinWidth, width, maxWidth);
        const id = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id;
        if (id && maxWidth >= drawersMinWidth) onActiveDrawerResize({
            size: size,
            id: id
        });
    };
    const sizeControlProps = {
        position: "side",
        panelRef: drawerRefObject,
        handleRef: drawersRefs.slider,
        onResize: setSidePanelWidth,
        hasTransitions: true
    };
    const onSliderPointerDown = (0, $0d7a0c5aa5b38dc9$export$69c48c1cbbd6dc69)(sizeControlProps);
    const onKeyDown = (0, $f3562f2817c11205$export$2ba6c1a0edf6483a)(sizeControlProps);
    const resizeHandle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df0c014177452109$export$2e2bcd8739ae039), {
        ref: drawersRefs.slider,
        position: "side",
        ariaLabel: (_a = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _a === void 0 ? void 0 : _a.resizeHandle,
        ariaValuenow: relativeSize,
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawers-slider"],
        onKeyDown: onKeyDown,
        onPointerDown: onSliderPointerDown
    });
    return {
        resizeHandle: resizeHandle,
        drawerSize: drawerSize
    };
}
var $022a29f861c64d70$export$2e2bcd8739ae039 = $022a29f861c64d70$var$useResize;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $78ac35921a119528$export$2e2bcd8739ae039({ contentHeader: contentHeader, disableContentHeaderOverlap: disableContentHeaderOverlap, layoutElement: layoutElement }) {
    const hasContentHeader = !!contentHeader;
    const [hasBackgroundOverlap, setHasBackgroundOverlap] = (0, $acw62.useState)(hasContentHeader);
    const updateBackgroundOverlapHeight = (0, $acw62.useCallback)((height)=>{
        const hasOverlap = hasContentHeader || height > 0;
        setHasBackgroundOverlap(hasOverlap);
        /**
         * React 18 will trigger a paint before the state is correctly updated
         * (see https://github.com/facebook/react/issues/24331).
         * To work around this, we bypass React state updates and imperatively update the custom property on the DOM.
         * An alternative would be to use `queueMicrotask` and `flushSync` in the ResizeObserver callback,
         * but that would have some performance impact as it would delay the render.
         */ // Layout component uses RefObject, we don't expect a RefCallback
        const element = typeof layoutElement !== "function" && (layoutElement === null || layoutElement === void 0 ? void 0 : layoutElement.current);
        if (!element) return;
        if (disableContentHeaderOverlap || !hasOverlap || height <= 0) element.style.removeProperty((0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).overlapHeight);
        else element.style.setProperty((0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).overlapHeight, `${height}px`);
    }, [
        hasContentHeader,
        layoutElement,
        disableContentHeaderOverlap
    ]);
    return {
        hasBackgroundOverlap: hasBackgroundOverlap,
        updateBackgroundOverlapHeight: updateBackgroundOverlapHeight
    };
}





/**
 * The default values are destructured in the context instantiation to
 * prevent downstream Typescript errors. This could likely be replaced
 * by a context interface definition that extends the AppLayout interface.
 */ const $6e9ace527e915055$var$AppLayoutInternalsContext = (0, $acw62.createContext)(null);
function $6e9ace527e915055$export$8790094283eeada6() {
    const ctx = (0, $acw62.useContext)($6e9ace527e915055$var$AppLayoutInternalsContext);
    if (!ctx) throw new Error("Invariant violation: this context is only available inside app layout");
    return ctx;
}
const $6e9ace527e915055$export$56942bf202ca3905 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardRef)=>{
    var _a, _b, _c, _d, _e;
    const { toolsHide: toolsHide, toolsOpen: controlledToolsOpen, navigationHide: navigationHide, navigationOpen: navigationOpen, contentType: contentType, placement: placement, children: children, splitPanel: splitPanel } = props;
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    // Private API for embedded view mode
    const __embeddedViewMode = Boolean(props.__embeddedViewMode);
    /**
     * Set the default values for minimum and maximum content width.
     */ const geckoMaxCssLength = (1073741824 - 1) / 60;
    const halfGeckoMaxCssLength = geckoMaxCssLength / 2;
    // CSS lengths in Gecko are limited to at most (1<<30)-1 app units (Gecko uses 60 as app unit).
    // Limit the maxContentWidth to the half of the upper boundary (≈4230^2) to be on the safe side.
    const maxContentWidth = props.maxContentWidth && props.maxContentWidth > halfGeckoMaxCssLength ? halfGeckoMaxCssLength : (_a = props.maxContentWidth) !== null && _a !== void 0 ? _a : 0;
    const minContentWidth = (_b = props.minContentWidth) !== null && _b !== void 0 ? _b : 280;
    const { refs: navigationRefs, setFocus: focusNavButtons } = (0, $84d3a2bbe2557e44$export$817e5b4536f33d83)(navigationOpen);
    const handleNavigationClick = (0, $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0)(function handleNavigationChange(isOpen) {
        focusNavButtons();
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(props.onNavigationChange, {
            open: isOpen
        });
    });
    (0, $acw62.useEffect)(()=>{
        // Close navigation drawer on mobile so that the main content is visible
        if (isMobile) handleNavigationClick(false);
    }, [
        isMobile,
        handleNavigationClick
    ]);
    const toolsWidth = props.toolsWidth;
    const [isToolsOpen = false, setIsToolsOpen] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledToolsOpen, props.onToolsChange, false, {
        componentName: "AppLayout",
        controlledProp: "toolsOpen",
        changeHandler: "onToolsChange"
    });
    const { refs: toolsRefs, setFocus: focusToolsButtons, loseFocus: loseToolsFocus } = (0, $84d3a2bbe2557e44$export$817e5b4536f33d83)(isToolsOpen, true);
    const handleToolsClick = (0, $acw62.useCallback)(function handleToolsChange(isOpen, skipFocusControl) {
        setIsToolsOpen(isOpen);
        !skipFocusControl && focusToolsButtons();
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(props.onToolsChange, {
            open: isOpen
        });
    }, [
        props.onToolsChange,
        setIsToolsOpen,
        focusToolsButtons
    ]);
    /**
     * Set the default values for the minimum and maximum Split Panel width when it is
     * in the side position. The useLayoutEffect will compute the available space in the
     * DOM for the Split Panel given the current state. The minimum and maximum
     * widths will potentially trigger a side effect that will put the Split Panel into
     * a forced position on the bottom.
     */ const [splitPanelMaxWidth, setSplitPanelMaxWidth] = (0, $acw62.useState)((0, $346c1f4e54c7d4ae$export$c1bd455843613e23));
    /**
     * The useControllable hook will set the default value and manage either
     * the controlled or uncontrolled state of the Split Panel. By default
     * the Split Panel should always be closed on page load.
     *
     * The callback that will be passed to the SplitPanel component
     * to handle the click events that will change the state of the SplitPanel
     * to open or closed given the current state. It will set the isSplitPanelOpen
     * controlled state and fire the onSplitPanelToggle event.
     */ const [isSplitPanelOpen, setIsSplitPanelOpen] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(props.splitPanelOpen, props.onSplitPanelToggle, false, {
        componentName: "AppLayout",
        controlledProp: "splitPanelOpen",
        changeHandler: "onSplitPanelToggle"
    });
    /**
     * The useControllable hook will manage the controlled or uncontrolled
     * state of the splitPanelPreferences. By default the splitPanelPreferences
     * is undefined. When set the object shape should have a single key to indicate
     * either bottom or side position.
     *
     * The callback that will handle changes to the splitPanelPreferences
     * object that will determine if the SplitPanel is rendered either on the
     * bottom of the viewport or within the Tools container.
     */ const [splitPanelPreferences, setSplitPanelPreferences] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(props.splitPanelPreferences, props.onSplitPanelPreferencesChange, undefined, {
        componentName: "AppLayout",
        controlledProp: "splitPanelPreferences",
        changeHandler: "onSplitPanelPreferencesChange"
    });
    const { refs: splitPanelRefs, setLastInteraction: setSplitPanelLastInteraction } = (0, $d19d77c31ea1086e$export$ba7387b5ce3f72be)([
        splitPanelPreferences,
        isSplitPanelOpen
    ]);
    const handleSplitPanelClick = (0, $acw62.useCallback)(function handleSplitPanelChange() {
        setIsSplitPanelOpen(!isSplitPanelOpen);
        setSplitPanelLastInteraction({
            type: isSplitPanelOpen ? "close" : "open"
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(props.onSplitPanelToggle, {
            open: !isSplitPanelOpen
        });
    }, [
        props.onSplitPanelToggle,
        isSplitPanelOpen,
        setIsSplitPanelOpen,
        setSplitPanelLastInteraction
    ]);
    /**
     * The Split Panel will be in forced (bottom) position if the defined minimum width is
     * greater than the maximum width. In other words, the maximum width is the currently
     * available horizontal space based on all other components that are rendered. If the
     * minimum width exceeds this value then there is not enough horizontal space and we must
     * force it to the bottom position.
     */ const isSplitPanelForcedPosition = isMobile || (0, $346c1f4e54c7d4ae$export$c1bd455843613e23) > splitPanelMaxWidth;
    const splitPanelPosition = (0, $eda04021d4548892$export$5582f2db528b4683)(isSplitPanelForcedPosition, splitPanelPreferences);
    /**
     * The useControllable hook will set the default size of the SplitPanel based
     * on the default position set in the splitPanelPreferences. The logic for the
     * default size is contained in the SplitPanel component. The splitPanelControlledSize
     * will be bound to the size property in the SplitPanel context for rendering.
     *
     * The callback that will be passed to the SplitPanel component
     * to handle the resize events that will change the size of the SplitPanel.
     * It will set the splitPanelControlledSize controlled state and fire the
     * onSplitPanelResize event.
     */ const [splitPanelReportedSize, setSplitPanelReportedSize] = (0, $acw62.useState)(0);
    const [splitPanelReportedHeaderHeight, setSplitPanelReportedHeaderHeight] = (0, $acw62.useState)(0);
    const [splitPanelToggle, setSplitPanelToggle] = (0, $acw62.useState)({
        displayed: false,
        ariaLabel: undefined
    });
    const splitPanelDisplayed = !!(splitPanelToggle.displayed || isSplitPanelOpen) && !!splitPanel;
    const splitPanelControlId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("split-panel-");
    const toolsControlId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("tools-");
    const [splitPanelSize, setSplitPanelSize] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(props.splitPanelSize, props.onSplitPanelResize, (0, $582c00c3ff10d4e2$export$9d9d5fcac617b082)(splitPanelPosition), {
        componentName: "AppLayout",
        controlledProp: "splitPanelSize",
        changeHandler: "onSplitPanelResize"
    });
    const handleSplitPanelResize = (0, $acw62.useCallback)((size)=>{
        setSplitPanelSize(size);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(props.onSplitPanelResize, {
            size: size
        });
    }, [
        props.onSplitPanelResize,
        setSplitPanelSize
    ]);
    const handleSplitPanelPreferencesChange = (0, $acw62.useCallback)(function handleSplitPanelChange(detail) {
        setSplitPanelPreferences(detail);
        setSplitPanelLastInteraction({
            type: "position"
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(props.onSplitPanelPreferencesChange, detail);
    }, [
        props.onSplitPanelPreferencesChange,
        setSplitPanelPreferences,
        setSplitPanelLastInteraction
    ]);
    const _f = (0, $892ef2b582c4882d$export$468f52f962f49bf5)(props, props.ariaLabels, {
        disableDrawersMerge: true,
        ariaLabels: props.ariaLabels,
        toolsHide: toolsHide,
        toolsOpen: isToolsOpen,
        tools: props.tools,
        toolsWidth: toolsWidth,
        onToolsToggle: handleToolsClick
    }), { drawers: drawers, activeDrawer: activeDrawer, activeDrawerId: activeDrawerId, minDrawerSize: drawersMinWidth, onActiveDrawerChange: onActiveDrawerChange, onActiveDrawerResize: onActiveDrawerResize, activeDrawerSize: activeDrawerSize } = _f, drawersProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_f, [
        "drawers",
        "activeDrawer",
        "activeDrawerId",
        "minDrawerSize",
        "onActiveDrawerChange",
        "onActiveDrawerResize",
        "activeDrawerSize"
    ]);
    const [drawersMaxWidth, setDrawersMaxWidth] = (0, $acw62.useState)(toolsWidth);
    const hasDrawers = !!drawers && drawers.length > 0;
    const { refs: drawersRefs, setFocus: focusDrawersButtons, loseFocus: loseDrawersFocus } = (0, $84d3a2bbe2557e44$export$817e5b4536f33d83)(!!activeDrawerId, true, activeDrawerId);
    const drawerRef = (0, $acw62.useRef)(null);
    const { resizeHandle: resizeHandle, drawerSize: drawerSize } = (0, $022a29f861c64d70$export$2e2bcd8739ae039)(drawerRef, {
        onActiveDrawerResize: onActiveDrawerResize,
        activeDrawerSize: activeDrawerSize,
        activeDrawer: activeDrawer,
        drawersRefs: drawersRefs,
        isToolsOpen: isToolsOpen,
        drawersMaxWidth: drawersMaxWidth,
        drawersMinWidth: drawersMinWidth
    });
    const handleDrawersClick = (id, skipFocusControl)=>{
        const newActiveDrawerId = id !== activeDrawerId ? id : null;
        onActiveDrawerChange(newActiveDrawerId);
        !skipFocusControl && focusDrawersButtons();
    };
    let drawersTriggerCount = drawers ? drawers.length : !toolsHide ? 1 : 0;
    if (splitPanelDisplayed && splitPanelPosition === "side") drawersTriggerCount++;
    const hasOpenDrawer = !!activeDrawerId || !toolsHide && isToolsOpen || splitPanelDisplayed && splitPanelPosition === "side" && isSplitPanelOpen;
    const hasDrawerViewportOverlay = isMobile && (!!activeDrawerId || !navigationHide && navigationOpen || !toolsHide && isToolsOpen);
    const layoutElement = (0, $acw62.useRef)(null);
    const mainElement = (0, $acw62.useRef)(null);
    const [mainOffsetLeft, setMainOffsetLeft] = (0, $acw62.useState)(0);
    const { hasBackgroundOverlap: hasBackgroundOverlap, updateBackgroundOverlapHeight: updateBackgroundOverlapHeight } = (0, $78ac35921a119528$export$2e2bcd8739ae039)({
        contentHeader: props.contentHeader,
        disableContentHeaderOverlap: props.disableContentHeaderOverlap,
        layoutElement: layoutElement
    });
    (0, $acw62.useLayoutEffect)(function handleMainOffsetLeft() {
        const offsetInlineStart = (mainElement === null || mainElement === void 0 ? void 0 : mainElement.current) ? (0, $558545a5feadf817$export$46ef7e361fb70912)(mainElement === null || mainElement === void 0 ? void 0 : mainElement.current) : 0;
        setMainOffsetLeft(offsetInlineStart);
    }, [
        placement.inlineSize,
        navigationOpen,
        isToolsOpen,
        splitPanelReportedSize
    ]);
    /**
     * On mobile viewports the navigation and tools drawers are adjusted to a fixed position
     * that consumes 100% of the viewport height and width. The body content could potentially
     * be scrollable underneath the drawer. In order to prevent this a CSS class needs to be
     * added to the document body that sets overflow to hidden.
     */ (0, $acw62.useEffect)(function handleBodyScroll() {
        if (isMobile && (navigationOpen || isToolsOpen || !!activeDrawer)) document.body.classList.add((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["block-body-scroll"]);
        else document.body.classList.remove((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["block-body-scroll"]);
        // Ensure the CSS class is removed from the body on side effect cleanup
        return function cleanup() {
            document.body.classList.remove((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["block-body-scroll"]);
        };
    }, [
        isMobile,
        navigationOpen,
        isToolsOpen,
        activeDrawer
    ]);
    const [notificationsHeight, setNotificationsHeight] = (0, $acw62.useState)(0);
    const hasNotificationsContent = notificationsHeight > 0;
    /**
     * Determine the offsetBottom value based on the presence of a footer element and
     * the SplitPanel component. Ignore the SplitPanel if it is not in the bottom
     * position. Use the size property if it is open and the header height if it is closed.
     */ let offsetBottom = placement.insetBlockEnd;
    if (splitPanelDisplayed && splitPanelPosition === "bottom") {
        if (isSplitPanelOpen) offsetBottom += splitPanelReportedSize;
        else offsetBottom += splitPanelReportedHeaderHeight;
    }
    /**
     * Warning! This is a hack! In order to accurately calculate if there is adequate
     * horizontal space for the Split Panel to be in the side position we need two values
     * that are not available in JavaScript.
     *
     * The first is the the content gap on the right which is stored in a design token
     * and applied in the Layout CSS:
     *
     * $contentGapRight: #{awsui.$space-layout-content-horizontal};
     *
     * The second is the width of the element that has the circular buttons for the
     * Tools and Split Panel. This could be suppressed given the state of the Tools
     * drawer returning a zero value. It would, however, be rendered if the Split Panel
     * were to move into the side position. This is calculated in the Tools CSS and
     * the Trigger button CSS with design tokens:
     *
     * padding: awsui.$space-scaled-s awsui.$space-layout-toggle-padding;
     * width: awsui.$space-layout-toggle-diameter;
     *
     * These values will be defined below as static integers that are rough approximations
     * of their computed width when rendered in the DOM, but doubled to ensure adequate
     * spacing for the Split Panel to be in side position.
     */ (0, $acw62.useLayoutEffect)(function handleSplitPanelMaxWidth() {
        const contentGapRight = 50; // Approximately 24px when rendered but doubled for safety
        const toolsFormOffsetWidth = 120; // Approximately 60px when rendered but doubled for safety
        const getPanelOffsetWidth = ()=>{
            if (drawers) return activeDrawerId ? drawerSize : 0;
            return isToolsOpen ? toolsWidth : 0;
        };
        setSplitPanelMaxWidth(placement.inlineSize - mainOffsetLeft - minContentWidth - contentGapRight - toolsFormOffsetWidth - getPanelOffsetWidth());
        setDrawersMaxWidth(placement.inlineSize - mainOffsetLeft - minContentWidth - contentGapRight - toolsFormOffsetWidth);
    }, [
        activeDrawerId,
        drawerSize,
        drawers,
        navigationOpen,
        isToolsOpen,
        placement.inlineSize,
        mainOffsetLeft,
        minContentWidth,
        toolsWidth
    ]);
    /**
     * The useImperativeHandle hook in conjunction with the forwardRef function
     * in the AppLayout component definition expose the following callable
     * functions to component consumers when they put a ref as a property on
     * their component implementation.
     */ (0, $acw62.useImperativeHandle)(forwardRef, function createImperativeHandle() {
        return {
            closeNavigationIfNecessary: function() {
                isMobile && handleNavigationClick(false);
            },
            openTools: function() {
                handleToolsClick(true);
            },
            focusToolsClose: ()=>{
                if (hasDrawers) focusDrawersButtons(true);
                else focusToolsButtons(true);
            },
            focusActiveDrawer: ()=>focusDrawersButtons(true),
            focusSplitPanel: ()=>{
                var _a;
                return (_a = splitPanelRefs.slider.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        };
    }, [
        isMobile,
        handleNavigationClick,
        handleToolsClick,
        focusToolsButtons,
        focusDrawersButtons,
        splitPanelRefs.slider,
        hasDrawers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6e9ace527e915055$var$AppLayoutInternalsContext.Provider, {
        value: Object.assign(Object.assign({}, props), {
            activeDrawerId: activeDrawerId,
            contentType: contentType,
            drawers: drawers,
            drawersAriaLabel: (_c = drawersProps.ariaLabelsWithDrawers) === null || _c === void 0 ? void 0 : _c.drawers,
            drawersOverflowAriaLabel: (_d = drawersProps.ariaLabelsWithDrawers) === null || _d === void 0 ? void 0 : _d.drawersOverflow,
            drawersOverflowWithBadgeAriaLabel: (_e = drawersProps.ariaLabelsWithDrawers) === null || _e === void 0 ? void 0 : _e.drawersOverflowWithBadge,
            drawersRefs: drawersRefs,
            drawersMinWidth: drawersMinWidth,
            drawersMaxWidth: drawersMaxWidth,
            drawerSize: drawerSize,
            drawerRef: drawerRef,
            resizeHandle: resizeHandle,
            drawersTriggerCount: drawersTriggerCount,
            headerHeight: placement.insetBlockStart,
            footerHeight: placement.insetBlockEnd,
            hasDrawerViewportOverlay: hasDrawerViewportOverlay,
            handleDrawersClick: handleDrawersClick,
            handleNavigationClick: handleNavigationClick,
            handleSplitPanelClick: handleSplitPanelClick,
            handleSplitPanelPreferencesChange: handleSplitPanelPreferencesChange,
            handleSplitPanelResize: handleSplitPanelResize,
            handleToolsClick: handleToolsClick,
            hasBackgroundOverlap: hasBackgroundOverlap,
            hasNotificationsContent: hasNotificationsContent,
            hasOpenDrawer: hasOpenDrawer,
            isBackgroundOverlapDisabled: props.disableContentHeaderOverlap || !hasBackgroundOverlap,
            isMobile: isMobile,
            isSplitPanelForcedPosition: isSplitPanelForcedPosition,
            isSplitPanelOpen: isSplitPanelOpen,
            isToolsOpen: isToolsOpen,
            layoutElement: layoutElement,
            layoutWidth: placement.inlineSize,
            loseToolsFocus: loseToolsFocus,
            loseDrawersFocus: loseDrawersFocus,
            mainElement: mainElement,
            mainOffsetLeft: mainOffsetLeft,
            maxContentWidth: maxContentWidth,
            minContentWidth: minContentWidth,
            navigationHide: navigationHide,
            navigationRefs: navigationRefs,
            notificationsHeight: notificationsHeight,
            setNotificationsHeight: setNotificationsHeight,
            offsetBottom: offsetBottom,
            setSplitPanelReportedSize: setSplitPanelReportedSize,
            setSplitPanelReportedHeaderHeight: setSplitPanelReportedHeaderHeight,
            splitPanel: splitPanel,
            splitPanelControlId: splitPanelControlId,
            splitPanelDisplayed: splitPanelDisplayed,
            splitPanelMaxWidth: splitPanelMaxWidth,
            splitPanelPosition: splitPanelPosition,
            splitPanelPreferences: splitPanelPreferences,
            splitPanelReportedSize: splitPanelReportedSize,
            splitPanelReportedHeaderHeight: splitPanelReportedHeaderHeight,
            splitPanelSize: splitPanelSize,
            splitPanelToggle: splitPanelToggle,
            setSplitPanelToggle: setSplitPanelToggle,
            splitPanelRefs: splitPanelRefs,
            toolsControlId: toolsControlId,
            toolsHide: toolsHide,
            toolsOpen: isToolsOpen,
            toolsWidth: toolsWidth,
            toolsRefs: toolsRefs,
            __embeddedViewMode: __embeddedViewMode
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $011bca9bf46093da$export$70fcc38162d125af).Provider, {
        value: updateBackgroundOverlapHeight
    }, children));
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9c98cc94ae829c40$export$ebd33a9e3a891abd = "awsui-context-content-header";




function $e6b9304cc8ecd5f8$export$2e2bcd8739ae039() {
    const { breadcrumbs: breadcrumbs, hasBackgroundOverlap: hasBackgroundOverlap, hasNotificationsContent: hasNotificationsContent, isMobile: isMobile, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (!hasNotificationsContent && (!breadcrumbs || isMobile) && !hasBackgroundOverlap) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).background, {
            [(0, $9c98cc94ae829c40$export$ebd33a9e3a891abd)]: headerVariant === "high-contrast"
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["scrolling-background"]
    }));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





function $870116fec74b536c$export$2e2bcd8739ae039() {
    const { breadcrumbs: breadcrumbs, isMobile: isMobile, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (isMobile || !breadcrumbs) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).breadcrumbs, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).breadcrumbs, {
            [(0, $9c98cc94ae829c40$export$ebd33a9e3a891abd)]: headerVariant === "high-contrast"
        })
    }, breadcrumbs);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



function $6a3757dc95ec4d39$var$TriggerButton({ ariaLabel: ariaLabel, className: className, iconName: iconName, iconSvg: iconSvg, ariaExpanded: ariaExpanded, ariaControls: ariaControls, onClick: onClick, testId: testId, badge: badge, selected: selected = false, highContrastHeader: highContrastHeader }, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["trigger-wrapper"], !highContrastHeader && (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["remove-high-contrast-header"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-expanded": ariaExpanded,
        "aria-controls": ariaControls,
        "aria-haspopup": true,
        "aria-label": ariaLabel,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).trigger, {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).selected]: selected,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).badge]: badge
        }, className),
        onClick: onClick,
        ref: ref,
        type: "button",
        "data-testid": testId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(badge && (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["trigger-badge-wrapper"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: iconName,
        svg: iconSvg
    }))), badge && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039).dot
    }));
}
var $6a3757dc95ec4d39$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($6a3757dc95ec4d39$var$TriggerButton);






var $e24acb969e7c7c7f$export$2e2bcd8739ae039 = {
    "root": "awsui_root_rjqu5_zu8o5_5",
    "header-text": "awsui_header-text_rjqu5_zu8o5_6",
    "open-button": "awsui_open-button_rjqu5_zu8o5_7",
    "close-button": "awsui_close-button_rjqu5_zu8o5_8",
    "preferences-button": "awsui_preferences-button_rjqu5_zu8o5_9",
    "slider": "awsui_slider_rjqu5_zu8o5_10",
    "open-position-bottom": "awsui_open-position-bottom_rjqu5_zu8o5_11",
    "open-position-side": "awsui_open-position-side_rjqu5_zu8o5_12"
};







function $80840cb1e803926f$export$2e2bcd8739ae039() {
    const { disableBodyScroll: disableBodyScroll, drawers: drawers, drawersTriggerCount: drawersTriggerCount, hasDrawerViewportOverlay: hasDrawerViewportOverlay, hasOpenDrawer: hasOpenDrawer, navigationOpen: navigationOpen, navigationHide: navigationHide, isMobile: isMobile } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const isUnfocusable = hasDrawerViewportOverlay && navigationOpen && !navigationHide;
    if (!drawers || drawersTriggerCount === 0) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["drawers-container"], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["disable-body-scroll"]]: disableBodyScroll,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-open-drawer"]]: hasOpenDrawer,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: isUnfocusable
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eda04021d4548892$export$2e2bcd8739ae039).Side, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($80840cb1e803926f$var$ActiveDrawer, null), !isMobile && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($80840cb1e803926f$var$DesktopTriggers, null));
}
function $80840cb1e803926f$var$ActiveDrawer() {
    var _a, _b, _c, _d;
    const { activeDrawerId: activeDrawerId, ariaLabels: ariaLabels, drawers: drawers, drawersRefs: drawersRefs, handleDrawersClick: handleDrawersClick, handleToolsClick: handleToolsClick, hasDrawerViewportOverlay: hasDrawerViewportOverlay, isMobile: isMobile, navigationOpen: navigationOpen, navigationHide: navigationHide, loseDrawersFocus: loseDrawersFocus, resizeHandle: resizeHandle, drawerSize: drawerSize, drawersMinWidth: drawersMinWidth, drawersMaxWidth: drawersMaxWidth, drawerRef: drawerRef } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const activeDrawer = (_a = drawers === null || drawers === void 0 ? void 0 : drawers.find((item)=>item.id === activeDrawerId)) !== null && _a !== void 0 ? _a : null;
    const computedAriaLabels = {
        closeButton: activeDrawerId ? (_b = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.closeButton : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsClose,
        content: activeDrawerId ? (_c = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _c === void 0 ? void 0 : _c.drawerName : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools
    };
    const isHidden = !activeDrawerId;
    const isUnfocusable = isHidden || hasDrawerViewportOverlay && navigationOpen && !navigationHide;
    const isToolsDrawer = activeDrawerId === (0, $892ef2b582c4882d$export$329f249760e831ae);
    const toolsContent = (_d = drawers === null || drawers === void 0 ? void 0 : drawers.find((drawer)=>drawer.id === (0, $892ef2b582c4882d$export$329f249760e831ae))) === null || _d === void 0 ? void 0 : _d.content;
    const size = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(drawersMinWidth, drawerSize, drawersMaxWidth);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        id: activeDrawerId !== null && activeDrawerId !== void 0 ? activeDrawerId : undefined,
        "aria-hidden": isHidden,
        "aria-label": computedAriaLabels.content,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).drawer, {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["is-drawer-open"]]: activeDrawerId,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: isUnfocusable,
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["active-drawer"]]: activeDrawerId,
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).tools]: isToolsDrawer
        }),
        style: Object.assign({}, !isMobile && drawerSize && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).drawerSize]: `${size}px`
        }),
        ref: drawerRef,
        onBlur: (e)=>{
            if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) loseDrawersFocus();
        }
    }, !isMobile && (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.resizable) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["drawer-slider"]
    }, resizeHandle), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["drawer-content-container"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["drawer-close-button"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ariaLabel: computedAriaLabels.closeButton,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["active-drawer-close-button"]]: activeDrawerId,
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-close"]]: isToolsDrawer
        }),
        formAction: "none",
        iconName: isMobile ? "close" : "angle-right",
        onClick: ()=>{
            handleDrawersClick(activeDrawerId);
            handleToolsClick(false);
        },
        ref: drawersRefs.close,
        variant: "icon"
    })), toolsContent && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["drawer-content"], activeDrawerId !== (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["drawer-content-hidden"])
    }, toolsContent), activeDrawerId !== (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["drawer-content"]
    }, activeDrawerId && (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.content))));
}
/**
 * The DesktopTriggers will render the trigger buttons for Tools, Drawers, and the
 * SplitPanel in non mobile viewports. Changes to the activeDrawerId need to be
 * tracked by the previousActiveDrawerId property in order to appropriately apply
 * the ref required to manage focus control.
 */ function $80840cb1e803926f$var$DesktopTriggers() {
    const { activeDrawerId: activeDrawerId, drawers: drawers, drawersAriaLabel: drawersAriaLabel, drawersOverflowAriaLabel: drawersOverflowAriaLabel, drawersOverflowWithBadgeAriaLabel: drawersOverflowWithBadgeAriaLabel, drawersRefs: drawersRefs, drawersTriggerCount: drawersTriggerCount, handleDrawersClick: handleDrawersClick, handleSplitPanelClick: handleSplitPanelClick, hasOpenDrawer: hasOpenDrawer, isSplitPanelOpen: isSplitPanelOpen, splitPanel: splitPanel, splitPanelControlId: splitPanelControlId, splitPanelDisplayed: splitPanelDisplayed, splitPanelPosition: splitPanelPosition, splitPanelRefs: splitPanelRefs, splitPanelToggle: splitPanelToggle, splitPanelReportedHeaderHeight: splitPanelReportedHeaderHeight, splitPanelReportedSize: splitPanelReportedSize, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const hasMultipleTriggers = drawersTriggerCount > 1;
    const hasSplitPanel = splitPanel && splitPanelDisplayed && splitPanelPosition === "side";
    const previousActiveDrawerId = (0, $acw62.useRef)(activeDrawerId);
    const [containerHeight, triggersContainerRef] = (0, $6e052e2d296ab854$export$2e2bcd8739ae039)((rect)=>rect.contentBoxHeight);
    if (activeDrawerId) previousActiveDrawerId.current = activeDrawerId;
    const splitPanelHeight = isSplitPanelOpen && splitPanelPosition === "bottom" ? splitPanelReportedSize : splitPanelReportedHeaderHeight;
    const getIndexOfOverflowItem = ()=>{
        if (containerHeight) {
            const ITEM_HEIGHT = 48;
            const overflowSpot = activeDrawerId && isSplitPanelOpen ? (containerHeight - splitPanelReportedHeaderHeight) / 1.5 : (containerHeight - splitPanelHeight) / 1.5;
            const index = Math.floor(overflowSpot / ITEM_HEIGHT);
            let splitPanelItem = 0;
            if (hasSplitPanel && splitPanelToggle.displayed) splitPanelItem = 1;
            return index - splitPanelItem;
        }
        return 0;
    };
    const { visibleItems: visibleItems, overflowItems: overflowItems } = (0, $cd10a1d6e571a030$export$855cafbbae95d7a8)(drawers !== null && drawers !== void 0 ? drawers : undefined, getIndexOfOverflowItem(), activeDrawerId);
    const overflowMenuHasBadge = !!overflowItems.find((item)=>item.badge);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["drawers-desktop-triggers-container"], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-multiple-triggers"]]: hasMultipleTriggers,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-open-drawer"]]: hasOpenDrawer
        }),
        "aria-label": drawersAriaLabel,
        ref: triggersContainerRef,
        role: "region"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["drawers-trigger-content"], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-multiple-triggers"]]: hasMultipleTriggers,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-open-drawer"]]: hasOpenDrawer
        }),
        role: "toolbar",
        "aria-orientation": "vertical"
    }, visibleItems.map((item)=>{
        var _a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a3757dc95ec4d39$export$2e2bcd8739ae039), {
            ariaLabel: (_a = item.ariaLabels) === null || _a === void 0 ? void 0 : _a.triggerButton,
            ariaExpanded: item.id === activeDrawerId,
            ariaControls: activeDrawerId === item.id ? item.id : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["drawers-trigger"], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawers-trigger"], item.id === (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-toggle"]),
            iconName: item.trigger.iconName,
            iconSvg: item.trigger.iconSvg,
            key: item.id,
            onClick: ()=>handleDrawersClick(item.id),
            ref: item.id === previousActiveDrawerId.current ? drawersRefs.toggle : undefined,
            selected: item.id === activeDrawerId,
            badge: item.badge,
            testId: `awsui-app-layout-trigger-${item.id}`,
            highContrastHeader: headerVariant === "high-contrast"
        });
    }), overflowItems.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $68640640380c1033$export$2e2bcd8739ae039), {
        items: overflowItems,
        ariaLabel: overflowMenuHasBadge ? drawersOverflowWithBadgeAriaLabel : drawersOverflowAriaLabel,
        customTriggerBuilder: ({ onClick: onClick, triggerRef: triggerRef, ariaLabel: ariaLabel, ariaExpanded: ariaExpanded, testUtilsClass: testUtilsClass })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a3757dc95ec4d39$export$2e2bcd8739ae039), {
                ref: triggerRef,
                ariaLabel: ariaLabel,
                ariaExpanded: ariaExpanded,
                badge: overflowMenuHasBadge,
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["drawers-trigger"], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawers-trigger"], testUtilsClass),
                iconName: "ellipsis",
                onClick: onClick,
                highContrastHeader: headerVariant === "high-contrast"
            }),
        onItemClick: ({ detail: detail })=>{
            handleDrawersClick(detail.id);
        }
    }), hasSplitPanel && splitPanelToggle.displayed && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a3757dc95ec4d39$export$2e2bcd8739ae039), {
        ariaLabel: splitPanelToggle.ariaLabel,
        ariaControls: splitPanelControlId,
        ariaExpanded: !!isSplitPanelOpen,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["drawers-trigger"], (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)["open-button"]),
        iconName: "view-vertical",
        onClick: ()=>handleSplitPanelClick(),
        selected: hasSplitPanel && isSplitPanelOpen,
        ref: splitPanelRefs.toggle,
        highContrastHeader: headerVariant === "high-contrast"
    })));
}
function $80840cb1e803926f$export$3327f5ebc2d6865() {
    const { activeDrawerId: activeDrawerId, drawers: drawers, drawersAriaLabel: drawersAriaLabel, drawersOverflowAriaLabel: drawersOverflowAriaLabel, drawersOverflowWithBadgeAriaLabel: drawersOverflowWithBadgeAriaLabel, drawersRefs: drawersRefs, handleDrawersClick: handleDrawersClick, hasDrawerViewportOverlay: hasDrawerViewportOverlay } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const previousActiveDrawerId = (0, $acw62.useRef)(activeDrawerId);
    if (!drawers) return null;
    if (activeDrawerId) previousActiveDrawerId.current = activeDrawerId;
    const { visibleItems: visibleItems, overflowItems: overflowItems } = (0, $cd10a1d6e571a030$export$855cafbbae95d7a8)(drawers, 2, activeDrawerId);
    const overflowMenuHasBadge = !!overflowItems.find((item)=>item.badge);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        "aria-hidden": hasDrawerViewportOverlay,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: hasDrawerViewportOverlay
        }),
        "aria-label": drawersAriaLabel,
        role: "region"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["drawers-mobile-triggers-container"],
        role: "toolbar",
        "aria-orientation": "horizontal"
    }, visibleItems.map((item)=>{
        var _a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            ariaExpanded: item.id === activeDrawerId,
            ariaLabel: (_a = item.ariaLabels) === null || _a === void 0 ? void 0 : _a.triggerButton,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["drawers-trigger"], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawers-trigger"], item.id === (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-toggle"]),
            disabled: hasDrawerViewportOverlay,
            ref: item.id === previousActiveDrawerId.current ? drawersRefs.toggle : undefined,
            formAction: "none",
            iconName: item.trigger.iconName,
            iconSvg: item.trigger.iconSvg,
            badge: item.badge,
            key: item.id,
            onClick: ()=>handleDrawersClick(item.id),
            variant: "icon",
            __nativeAttributes: {
                "aria-haspopup": true,
                "data-testid": `awsui-app-layout-trigger-${item.id}`
            }
        });
    }), overflowItems.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $68640640380c1033$export$2e2bcd8739ae039), {
        items: overflowItems,
        ariaLabel: overflowMenuHasBadge ? drawersOverflowWithBadgeAriaLabel : drawersOverflowAriaLabel,
        onItemClick: ({ detail: detail })=>handleDrawersClick(detail.id)
    })));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




function $267aa9df9137ec77$export$2e2bcd8739ae039() {
    const { breadcrumbs: breadcrumbs, contentHeader: contentHeader, hasDrawerViewportOverlay: hasDrawerViewportOverlay, hasNotificationsContent: hasNotificationsContent, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (!contentHeader) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).content, {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-breadcrumbs"]]: breadcrumbs,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-notifications-content"]]: hasNotificationsContent,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: hasDrawerViewportOverlay,
            [(0, $9c98cc94ae829c40$export$ebd33a9e3a891abd)]: headerVariant === "high-contrast"
        })
    }, contentHeader);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





function $52c91a8fefd6ceb2$export$2e2bcd8739ae039({ children: children }) {
    const { breadcrumbs: breadcrumbs, contentHeader: contentHeader, contentType: contentType, disableBodyScroll: disableBodyScroll, disableContentPaddings: disableContentPaddings, drawersTriggerCount: drawersTriggerCount, footerHeight: footerHeight, hasNotificationsContent: hasNotificationsContent, hasOpenDrawer: hasOpenDrawer, headerHeight: headerHeight, isBackgroundOverlapDisabled: isBackgroundOverlapDisabled, isMobile: isMobile, navigationOpen: navigationOpen, layoutElement: layoutElement, layoutWidth: layoutWidth, mainOffsetLeft: mainOffsetLeft, maxContentWidth: maxContentWidth, minContentWidth: minContentWidth, navigationHide: navigationHide, notificationsHeight: notificationsHeight, __embeddedViewMode: __embeddedViewMode, splitPanelPosition: splitPanelPosition, splitPanelDisplayed: splitPanelDisplayed } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    // Determine the first content child so the gap will vertically align with the trigger buttons
    const contentFirstChild = $52c91a8fefd6ceb2$var$getContentFirstChild(breadcrumbs, contentHeader, hasNotificationsContent, isMobile);
    // Content gaps on the left and right are used with the minmax function in the CSS grid column definition
    const hasContentGapLeft = navigationOpen || navigationHide;
    const hasContentGapRight = drawersTriggerCount === 0 || hasOpenDrawer;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("main", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).layout, (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)[`content-first-child-${contentFirstChild}`], (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)[`content-type-${contentType}`], (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)[`split-panel-position-${splitPanelPosition !== null && splitPanelPosition !== void 0 ? splitPanelPosition : "bottom"}`], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["disable-body-scroll"]]: disableBodyScroll,
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["disable-body-scroll-root"]]: disableBodyScroll,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["disable-content-paddings"]]: disableContentPaddings,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-breadcrumbs"]]: breadcrumbs && !isMobile,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-content-gap-left"]]: hasContentGapLeft,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-content-gap-right"]]: hasContentGapRight,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-header"]]: contentHeader,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-max-content-width"]]: maxContentWidth && maxContentWidth > 0,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-split-panel"]]: splitPanelDisplayed,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["is-overlap-disabled"]]: isBackgroundOverlapDisabled,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["is-hide-mobile-toolbar"]]: __embeddedViewMode,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-left-toggles-gutter"]]: !(isMobile || navigationHide || navigationOpen),
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-right-toggles-gutter"]]: !isMobile && !hasContentGapRight
        }, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).root),
        ref: layoutElement,
        style: Object.assign(Object.assign(Object.assign({
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).headerHeight]: `${headerHeight}px`,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).footerHeight]: `${footerHeight}px`,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).layoutWidth]: `${layoutWidth}px`,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).mainOffsetLeft]: `${mainOffsetLeft}px`
        }, maxContentWidth && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).maxContentWidth]: `${maxContentWidth}px`
        }), minContentWidth && {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).minContentWidth]: `${minContentWidth}px`
        }), {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).notificationsHeight]: `${notificationsHeight}px`
        })
    }, children);
}
/*
The Notifications, Breadcrumbs, Header, and Main are all rendered in the center
column of the grid layout. Any of these could be the first child to render in the
content area if the previous siblings do not exist. The grid gap before the first
child will be different to ensure vertical alignment with the trigger buttons.
*/ function $52c91a8fefd6ceb2$var$getContentFirstChild(breadcrumbs, contentHeader, hasNotificationsContent, isMobile) {
    let contentFirstChild = "main";
    if (hasNotificationsContent) contentFirstChild = "notifications";
    else if (breadcrumbs && !isMobile) contentFirstChild = "breadcrumbs";
    else if (contentHeader) contentFirstChild = "header";
    return contentFirstChild;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






var $17a6dd8285442c36$export$7fe3b7cb5ea7da63 = "var(--color-amazon-orange-gsvdv7, #ff9900)";
var $17a6dd8285442c36$export$235769fc99cea3e4 = "var(--color-aws-squid-ink-uuesmr, #232f3e)";
var $17a6dd8285442c36$export$5a09d2027d7b4316 = "var(--color-black-q5so4f, #000000)";
var $17a6dd8285442c36$export$6493569267fe4240 = "var(--color-blue-100-weysyn, #f2f8fd)";
var $17a6dd8285442c36$export$837d9b91fe473c15 = "var(--color-blue-200-d32cp4, #d3e7f9)";
var $17a6dd8285442c36$export$edaccd67a5c07740 = "var(--color-blue-300-jkp6w2, #b5d6f4)";
var $17a6dd8285442c36$export$b565e8bde2360f78 = "var(--color-blue-400-7bxm3i, #89bdee)";
var $17a6dd8285442c36$export$c3887f63f582159f = "var(--color-blue-500-kd3aso, #539fe5)";
var $17a6dd8285442c36$export$af452b73992c6c12 = "var(--color-blue-600-71kjka, #0972d3)";
var $17a6dd8285442c36$export$3bd3abc1d9644182 = "var(--color-blue-700-iue0ce, #065299)";
var $17a6dd8285442c36$export$58655c36418bb77b = "var(--color-blue-800-cgfbin, #033160)";
var $17a6dd8285442c36$export$9fa395951dc7b30b = "var(--color-blue-900-83cq5c, #00142b)";
var $17a6dd8285442c36$export$8013d55174f62611 = "var(--color-blue-opaque-gzkvwf, rgba(51, 136, 221, 0.5))";
var $17a6dd8285442c36$export$10a9129d30d7a1bf = "var(--color-green-100-bdu8xp, #f2fcf3)";
var $17a6dd8285442c36$export$8449751ffd2014ac = "var(--color-green-500-gikgfc, #29ad32)";
var $17a6dd8285442c36$export$6d0c82261279840a = "var(--color-green-600-mp0fiq, #037f0c)";
var $17a6dd8285442c36$export$7029ae543908207b = "var(--color-green-700-rkinot, #1a520f)";
var $17a6dd8285442c36$export$83848bb208de5f2a = "var(--color-green-900-8c9h2m, #001a02)";
var $17a6dd8285442c36$export$ed24602dc14c91c5 = "var(--color-grey-100-jhkxvy, #fbfbfb)";
var $17a6dd8285442c36$export$863590e3fbcbae31 = "var(--color-grey-125-vgqc37, #f8f8f8)";
var $17a6dd8285442c36$export$2e7ba6fddd2b98ab = "var(--color-grey-150-b2e5ja, #f4f4f4)";
var $17a6dd8285442c36$export$4375f263d524d51f = "var(--color-grey-200-w3zm5l, #e9ebed)";
var $17a6dd8285442c36$export$a9fc903c548ef330 = "var(--color-grey-300-6uke44, #d1d5db)";
var $17a6dd8285442c36$export$3fb402287eceb5b = "var(--color-grey-350-f8nt1k, #b6bec9)";
var $17a6dd8285442c36$export$328dff5851989f4b = "var(--color-grey-400-ovyv8h, #9ba7b6)";
var $17a6dd8285442c36$export$22ddb7428a7a5e5 = "var(--color-grey-450-4d2li9, #8d99a8)";
var $17a6dd8285442c36$export$15859a9372987526 = "var(--color-grey-500-smhp37, #7d8998)";
var $17a6dd8285442c36$export$8650f321d9a4a4d5 = "var(--color-grey-550-r96hyi, #5f6b7a)";
var $17a6dd8285442c36$export$4a237a9cbe6a88e4 = "var(--color-grey-600-hd8ea7, #414d5c)";
var $17a6dd8285442c36$export$c00c2331279e6b21 = "var(--color-grey-650-1qo59q, #354150)";
var $17a6dd8285442c36$export$54cedc0291f613bd = "var(--color-grey-700-haaq6z, #232f3e)";
var $17a6dd8285442c36$export$99407f45e1bee0c5 = "var(--color-grey-750-fgajeq, #192534)";
var $17a6dd8285442c36$export$c131d3600ffdc96b = "var(--color-grey-800-vaw4c4, #0f1b2a)";
var $17a6dd8285442c36$export$8fe70712f893923a = "var(--color-grey-850-a5pd8s, #081120)";
var $17a6dd8285442c36$export$7487412d62dff607 = "var(--color-grey-900-fhjw67, #000716)";
var $17a6dd8285442c36$export$4039321750849e76 = "var(--color-grey-950-i7xp6k, #222222)";
var $17a6dd8285442c36$export$45ccfbc6266aab7a = "var(--color-orange-100-akgi2l, #fef6f0)";
var $17a6dd8285442c36$export$702375a5a4e12f8d = "var(--color-orange-500-dpl1nc, #ec7211)";
var $17a6dd8285442c36$export$1861107274e6c698 = "var(--color-orange-600-5vsg33, #eb5f07)";
var $17a6dd8285442c36$export$ac09c4a971b22146 = "var(--color-orange-700-3igdeo, #dd6b10)";
var $17a6dd8285442c36$export$d235588518303c81 = "var(--color-purple-400-wvnlma, #bf80ff)";
var $17a6dd8285442c36$export$52917581833e2430 = "var(--color-purple-600-468euy, #7300e5)";
var $17a6dd8285442c36$export$472f2a14ac20b27a = "var(--color-red-100-wywj7v, #fff7f7)";
var $17a6dd8285442c36$export$a5d1d9a1e89a92ab = "var(--color-red-500-9zl15j, #eb6f6f)";
var $17a6dd8285442c36$export$80230352264c6859 = "var(--color-red-600-gv9so7, #d91515)";
var $17a6dd8285442c36$export$d363291b7322e215 = "var(--color-red-700-4exdbi, #7c2718)";
var $17a6dd8285442c36$export$845ac4c3743159c7 = "var(--color-red-900-944b65, #1a0000)";
var $17a6dd8285442c36$export$a719537fc32a0aa2 = "var(--color-transparent-0ltpn5, transparent)";
var $17a6dd8285442c36$export$e440a56bff5718e8 = "var(--color-white-s5xhu1, #ffffff)";
var $17a6dd8285442c36$export$eb0b1e0a417e9364 = "var(--color-yellow-100-nbkqkq, #fffce9)";
var $17a6dd8285442c36$export$d31c73f9faaac1a = "var(--color-yellow-600-0l8ygq, #ffe457)";
var $17a6dd8285442c36$export$2160d69841363856 = "var(--color-yellow-700-0u7yhy, #e0ca57)";
var $17a6dd8285442c36$export$12c4142f539d4fdf = "var(--color-yellow-800-5b0f4g, #8d6605)";
var $17a6dd8285442c36$export$62bb24a3ccba79fd = "var(--color-yellow-900-mo2qow, #1d1906)";
var $17a6dd8285442c36$export$a9828e023a63e078 = "var(--color-charts-red-300-l64jkq, #ea7158)";
var $17a6dd8285442c36$export$3ddd14fcdaa95b53 = "var(--color-charts-red-400-wa91b2, #dc5032)";
var $17a6dd8285442c36$export$1a306ed4b826934c = "var(--color-charts-red-500-clvvu0, #d13313)";
var $17a6dd8285442c36$export$79a6d94ebedfd01 = "var(--color-charts-red-600-n5f5z7, #ba2e0f)";
var $17a6dd8285442c36$export$d960014a824484b0 = "var(--color-charts-red-700-9qnabz, #a82a0c)";
var $17a6dd8285442c36$export$631d21ddd5abb1d7 = "var(--color-charts-red-800-03myov, #972709)";
var $17a6dd8285442c36$export$c400b33753785114 = "var(--color-charts-red-900-t7y4st, #892407)";
var $17a6dd8285442c36$export$fb765c63f729809b = "var(--color-charts-red-1000-2569eu, #7d2105)";
var $17a6dd8285442c36$export$273d3369fc6a4ee5 = "var(--color-charts-red-1100-utabtk, #721e03)";
var $17a6dd8285442c36$export$1eeb7b834075fe15 = "var(--color-charts-red-1200-p41vo4, #671c00)";
var $17a6dd8285442c36$export$f25129d912299510 = "var(--color-charts-orange-300-8xdemd, #e07941)";
var $17a6dd8285442c36$export$24b4dc9333132fb4 = "var(--color-charts-orange-400-98kh01, #cc5f21)";
var $17a6dd8285442c36$export$1525cd8d2b9a3aec = "var(--color-charts-orange-500-3exfo1, #bc4d01)";
var $17a6dd8285442c36$export$88d8ea3f3895d62c = "var(--color-charts-orange-600-tyzxch, #a84401)";
var $17a6dd8285442c36$export$c566e45c689e6204 = "var(--color-charts-orange-700-9es7jg, #983c02)";
var $17a6dd8285442c36$export$3288ddf390914f31 = "var(--color-charts-orange-800-zzyr3p, #8a3603)";
var $17a6dd8285442c36$export$85ed935da9e7515 = "var(--color-charts-orange-900-ozn3mk, #7e3103)";
var $17a6dd8285442c36$export$a73a38b81ac70eaa = "var(--color-charts-orange-1000-2j9x6g, #732c02)";
var $17a6dd8285442c36$export$e23af496e2f87b8f = "var(--color-charts-orange-1100-gbb7zd, #692801)";
var $17a6dd8285442c36$export$8baf5ef2e631b1cf = "var(--color-charts-orange-1200-k1a2bc, #602400)";
var $17a6dd8285442c36$export$64da22293492db29 = "var(--color-charts-yellow-300-ud5z8m, #b2911c)";
var $17a6dd8285442c36$export$9bb0488a094d1e = "var(--color-charts-yellow-400-er893i, #9c7b0b)";
var $17a6dd8285442c36$export$de4dbac299bcf140 = "var(--color-charts-yellow-500-zf6yw3, #8a6b05)";
var $17a6dd8285442c36$export$9ef13172cddad464 = "var(--color-charts-yellow-600-e1b0zr, #7b5f04)";
var $17a6dd8285442c36$export$1506a692c1076c86 = "var(--color-charts-yellow-700-3ihyrv, #6f5504)";
var $17a6dd8285442c36$export$1067e4388f339352 = "var(--color-charts-yellow-800-2luor7, #654d03)";
var $17a6dd8285442c36$export$fe738ab100d4646e = "var(--color-charts-yellow-900-k8cds4, #5d4503)";
var $17a6dd8285442c36$export$cf2e7654cbb19eef = "var(--color-charts-yellow-1000-9ibbxn, #553f03)";
var $17a6dd8285442c36$export$ba5a4bc5d4f36844 = "var(--color-charts-yellow-1100-igbqae, #4d3901)";
var $17a6dd8285442c36$export$190b6c7610b5600b = "var(--color-charts-yellow-1200-qg1amh, #483300)";
var $17a6dd8285442c36$export$a46e743d6cf8dc40 = "var(--color-charts-green-300-gduyir, #67a353)";
var $17a6dd8285442c36$export$885b99bde512dad6 = "var(--color-charts-green-400-jvx3c1, #41902c)";
var $17a6dd8285442c36$export$7fc39ea62df7ea0 = "var(--color-charts-green-500-uj364g, #1f8104)";
var $17a6dd8285442c36$export$873500ed0bd4cc47 = "var(--color-charts-green-600-mbov5u, #1a7302)";
var $17a6dd8285442c36$export$baac9fc999a67937 = "var(--color-charts-green-700-m7xx1p, #176702)";
var $17a6dd8285442c36$export$51c1b24e63fe0d1a = "var(--color-charts-green-800-97d577, #145d02)";
var $17a6dd8285442c36$export$3acc6c7e05c5758c = "var(--color-charts-green-900-79vtkm, #125502)";
var $17a6dd8285442c36$export$5036b53c310b7202 = "var(--color-charts-green-1000-dw0ace, #104d01)";
var $17a6dd8285442c36$export$421453d2cb20f600 = "var(--color-charts-green-1100-fdxgm3, #0f4601)";
var $17a6dd8285442c36$export$dbe41ef0261311ef = "var(--color-charts-green-1200-0w78ld, #0d4000)";
var $17a6dd8285442c36$export$30c9b2e10b0c1bf9 = "var(--color-charts-teal-300-b1amlp, #2ea597)";
var $17a6dd8285442c36$export$8058b6032adcb032 = "var(--color-charts-teal-400-75fmn4, #1c8e81)";
var $17a6dd8285442c36$export$32f62b57e6e0a934 = "var(--color-charts-teal-500-5p6o7k, #0d7d70)";
var $17a6dd8285442c36$export$78d8816af4cf79a4 = "var(--color-charts-teal-600-1ar5in, #096f64)";
var $17a6dd8285442c36$export$36314ab851f5924f = "var(--color-charts-teal-700-3m4vci, #06645a)";
var $17a6dd8285442c36$export$d690b383d2895ed4 = "var(--color-charts-teal-800-0fx1b9, #045b52)";
var $17a6dd8285442c36$export$74ea4a4121522142 = "var(--color-charts-teal-900-a0x7u4, #03524a)";
var $17a6dd8285442c36$export$17088dc74eaf0a1f = "var(--color-charts-teal-1000-n2wukj, #014b44)";
var $17a6dd8285442c36$export$bed6713920bf05f2 = "var(--color-charts-teal-1100-3rvzfn, #01443e)";
var $17a6dd8285442c36$export$12f8fb954448f141 = "var(--color-charts-teal-1200-hfik8s, #003e38)";
var $17a6dd8285442c36$export$fa79a04a9a906132 = "var(--color-charts-blue-1-300-uwr1wq, #529ccb)";
var $17a6dd8285442c36$export$48c509c34f957d0d = "var(--color-charts-blue-1-400-y4dmzv, #3184c2)";
var $17a6dd8285442c36$export$7c96a8085bc16a8f = "var(--color-charts-blue-1-500-jj2qqx, #0273bb)";
var $17a6dd8285442c36$export$56c10107965bf615 = "var(--color-charts-blue-1-600-ntcnzw, #0166ab)";
var $17a6dd8285442c36$export$33d56a52826fc658 = "var(--color-charts-blue-1-700-vhr7bu, #015b9d)";
var $17a6dd8285442c36$export$371cb8863fa18e6a = "var(--color-charts-blue-1-800-zq4na2, #015292)";
var $17a6dd8285442c36$export$6eee3d6351916f94 = "var(--color-charts-blue-1-900-pu28p4, #014a87)";
var $17a6dd8285442c36$export$a60489d676ad76d8 = "var(--color-charts-blue-1-1000-a1wpur, #01437d)";
var $17a6dd8285442c36$export$deb9678842096613 = "var(--color-charts-blue-1-1100-fyl0u6, #003c75)";
var $17a6dd8285442c36$export$7f85fdbf5bd9af7 = "var(--color-charts-blue-1-1200-y913fp, #00366d)";
var $17a6dd8285442c36$export$f48eb8499824d5a = "var(--color-charts-blue-2-300-sh1kxw, #688ae8)";
var $17a6dd8285442c36$export$e2be5cd8c0068595 = "var(--color-charts-blue-2-400-s269w5, #5978e3)";
var $17a6dd8285442c36$export$a8c4d6f1fe5a2686 = "var(--color-charts-blue-2-500-y9grom, #4066df)";
var $17a6dd8285442c36$export$48f86d39aae0f8a1 = "var(--color-charts-blue-2-600-ljsd9s, #3759ce)";
var $17a6dd8285442c36$export$71338f5286602841 = "var(--color-charts-blue-2-700-8pne2y, #314fbf)";
var $17a6dd8285442c36$export$3163e1f30c8ec91c = "var(--color-charts-blue-2-800-v3m6dn, #2c46b1)";
var $17a6dd8285442c36$export$198212de992173ed = "var(--color-charts-blue-2-900-2rg9qw, #273ea5)";
var $17a6dd8285442c36$export$5242cd4d7ebdc0ca = "var(--color-charts-blue-2-1000-ore46l, #23379b)";
var $17a6dd8285442c36$export$a0a3f0d95c78cb24 = "var(--color-charts-blue-2-1100-rj1e0b, #1f3191)";
var $17a6dd8285442c36$export$fab6ea3a2ef9b143 = "var(--color-charts-blue-2-1200-i1tjtx, #1b2b88)";
var $17a6dd8285442c36$export$c0e6120be009810e = "var(--color-charts-purple-300-egsaob, #a783e1)";
var $17a6dd8285442c36$export$2f2588c4abedb3ce = "var(--color-charts-purple-400-y2qlpj, #9469d6)";
var $17a6dd8285442c36$export$63648664c68ba17f = "var(--color-charts-purple-500-akrt38, #8456ce)";
var $17a6dd8285442c36$export$6b451975572ae71b = "var(--color-charts-purple-600-dnhyx7, #7749bf)";
var $17a6dd8285442c36$export$883cb1d43efde767 = "var(--color-charts-purple-700-sk05tr, #6b40b2)";
var $17a6dd8285442c36$export$2415a2a0d767fc27 = "var(--color-charts-purple-800-g5mys1, #6237a7)";
var $17a6dd8285442c36$export$4f35d0b4f4b582b = "var(--color-charts-purple-900-ap3bee, #59309d)";
var $17a6dd8285442c36$export$4fcf8a1b8d9efba6 = "var(--color-charts-purple-1000-pymhe3, #512994)";
var $17a6dd8285442c36$export$b60e0d30572d54bb = "var(--color-charts-purple-1100-f2iopl, #4a238b)";
var $17a6dd8285442c36$export$645aaa5557dc849d = "var(--color-charts-purple-1200-aic8dr, #431d84)";
var $17a6dd8285442c36$export$3c36e75e4dd6dd52 = "var(--color-charts-pink-300-cctxfi, #da7596)";
var $17a6dd8285442c36$export$e0fab26f937fb578 = "var(--color-charts-pink-400-kpryka, #ce567c)";
var $17a6dd8285442c36$export$2653997ab7b13509 = "var(--color-charts-pink-500-tccj7z, #c33d69)";
var $17a6dd8285442c36$export$cc83a77bc22ca0ea = "var(--color-charts-pink-600-4bki3e, #b1325c)";
var $17a6dd8285442c36$export$1ccd30d400c559 = "var(--color-charts-pink-700-gexeia, #a32952)";
var $17a6dd8285442c36$export$ec4ed67240ac961 = "var(--color-charts-pink-800-9fchm4, #962249)";
var $17a6dd8285442c36$export$d708622ae799c02f = "var(--color-charts-pink-900-z4eeu8, #8b1b42)";
var $17a6dd8285442c36$export$d3cf77ffa2701f78 = "var(--color-charts-pink-1000-7uou4m, #81143b)";
var $17a6dd8285442c36$export$181adccaa4683619 = "var(--color-charts-pink-1100-j0uevl, #780d35)";
var $17a6dd8285442c36$export$44143009802fb029 = "var(--color-charts-pink-1200-jpnl1t, #6f062f)";
var $17a6dd8285442c36$export$bfcc9a367dce467c = "var(--color-charts-status-critical-vygogl, #7d2105)";
var $17a6dd8285442c36$export$63afa5b22146e506 = "var(--color-charts-status-high-xmh5vl, #ba2e0f)";
var $17a6dd8285442c36$export$45986c6080dcdc0 = "var(--color-charts-status-medium-le4kdn, #cc5f21)";
var $17a6dd8285442c36$export$1d67a95b254591df = "var(--color-charts-status-low-seyj13, #b2911c)";
var $17a6dd8285442c36$export$7d29b8df987fbf1a = "var(--color-charts-status-positive-g1vr65, #67a353)";
var $17a6dd8285442c36$export$479c6aff2f5a8046 = "var(--color-charts-status-info-10v3c7, #3184c2)";
var $17a6dd8285442c36$export$d3ba4fc130aa8209 = "var(--color-charts-status-neutral-f30kx5, #7d8998)";
var $17a6dd8285442c36$export$847e6d8938982101 = "var(--color-charts-threshold-negative-jxxft8, #d91515)";
var $17a6dd8285442c36$export$88ffb411b14150aa = "var(--color-charts-threshold-positive-gxjdw9, #037f0c)";
var $17a6dd8285442c36$export$d376339af37b4fc8 = "var(--color-charts-threshold-info-jheddl, #0972d3)";
var $17a6dd8285442c36$export$8b8189d069458cd7 = "var(--color-charts-threshold-neutral-9351o8, #5f6b7a)";
var $17a6dd8285442c36$export$1e98244f4770dbab = "var(--color-charts-line-grid-9oxvql, #d1d5db)";
var $17a6dd8285442c36$export$fbb1afcfcdd7999f = "var(--color-charts-line-tick-mf5hvw, #d1d5db)";
var $17a6dd8285442c36$export$cceeb5c018206c7 = "var(--color-charts-line-axis-r7291n, #d1d5db)";
var $17a6dd8285442c36$export$387e810215b93949 = "var(--color-charts-palette-categorical-1-ld9m1p, #688ae8)";
var $17a6dd8285442c36$export$6b36f8ebdaeda401 = "var(--color-charts-palette-categorical-2-jwteam, #c33d69)";
var $17a6dd8285442c36$export$aa40dc30e0465617 = "var(--color-charts-palette-categorical-3-tlwr5r, #2ea597)";
var $17a6dd8285442c36$export$985cbe030db91279 = "var(--color-charts-palette-categorical-4-prlvih, #8456ce)";
var $17a6dd8285442c36$export$1cfcf138c0b430ef = "var(--color-charts-palette-categorical-5-04vsso, #e07941)";
var $17a6dd8285442c36$export$f7cd0f2448817d94 = "var(--color-charts-palette-categorical-6-2wgmsi, #3759ce)";
var $17a6dd8285442c36$export$f00671b06e030449 = "var(--color-charts-palette-categorical-7-w06irv, #962249)";
var $17a6dd8285442c36$export$39d802f927087260 = "var(--color-charts-palette-categorical-8-1qnvcp, #096f64)";
var $17a6dd8285442c36$export$f6f2c1390544458a = "var(--color-charts-palette-categorical-9-0342zm, #6237a7)";
var $17a6dd8285442c36$export$e1d059d390446292 = "var(--color-charts-palette-categorical-10-u73kns, #a84401)";
var $17a6dd8285442c36$export$cd54ac9f9496eab8 = "var(--color-charts-palette-categorical-11-tloc2a, #273ea5)";
var $17a6dd8285442c36$export$283ff2a8517cf212 = "var(--color-charts-palette-categorical-12-23xv0d, #780d35)";
var $17a6dd8285442c36$export$f9d2aa43ebf6ccbf = "var(--color-charts-palette-categorical-13-tuq7ce, #03524a)";
var $17a6dd8285442c36$export$63d2a3dc1009d04d = "var(--color-charts-palette-categorical-14-bom4ss, #4a238b)";
var $17a6dd8285442c36$export$f36e7e14362eb76b = "var(--color-charts-palette-categorical-15-kpqcpe, #7e3103)";
var $17a6dd8285442c36$export$8fcf4bdb057ad1ef = "var(--color-charts-palette-categorical-16-pzlo2l, #1b2b88)";
var $17a6dd8285442c36$export$941a557cef6aef8 = "var(--color-charts-palette-categorical-17-spn4mx, #ce567c)";
var $17a6dd8285442c36$export$29753c2eb4750135 = "var(--color-charts-palette-categorical-18-kxbv8i, #003e38)";
var $17a6dd8285442c36$export$9477505cf3b71a85 = "var(--color-charts-palette-categorical-19-cl97gf, #9469d6)";
var $17a6dd8285442c36$export$b9cc240a469d1703 = "var(--color-charts-palette-categorical-20-gzcnb4, #602400)";
var $17a6dd8285442c36$export$50648c0e1fe04995 = "var(--color-charts-palette-categorical-21-vyqcuq, #4066df)";
var $17a6dd8285442c36$export$ed03176497684e82 = "var(--color-charts-palette-categorical-22-6r7gq7, #a32952)";
var $17a6dd8285442c36$export$98e3384f0b29784e = "var(--color-charts-palette-categorical-23-7c98ot, #0d7d70)";
var $17a6dd8285442c36$export$894969d8a39baa17 = "var(--color-charts-palette-categorical-24-0i0wmq, #6b40b2)";
var $17a6dd8285442c36$export$4732b6b1b9140474 = "var(--color-charts-palette-categorical-25-7j0tso, #bc4d01)";
var $17a6dd8285442c36$export$9059896a901b59e2 = "var(--color-charts-palette-categorical-26-eql7mt, #2c46b1)";
var $17a6dd8285442c36$export$eeecb22a0367ff8c = "var(--color-charts-palette-categorical-27-8doiqc, #81143b)";
var $17a6dd8285442c36$export$c92f5bb324988073 = "var(--color-charts-palette-categorical-28-tlstes, #045b52)";
var $17a6dd8285442c36$export$dd63dbbdfd71c80 = "var(--color-charts-palette-categorical-29-noa7ft, #512994)";
var $17a6dd8285442c36$export$a532446888646b04 = "var(--color-charts-palette-categorical-30-ttbs6s, #8a3603)";
var $17a6dd8285442c36$export$643a76d5577063d5 = "var(--color-charts-palette-categorical-31-lz0ukh, #1f3191)";
var $17a6dd8285442c36$export$7ca4d0fd1c5b00c2 = "var(--color-charts-palette-categorical-32-ncpn1t, #da7596)";
var $17a6dd8285442c36$export$5d841c22b33103a7 = "var(--color-charts-palette-categorical-33-fpbcye, #01443e)";
var $17a6dd8285442c36$export$a1da779d6b047036 = "var(--color-charts-palette-categorical-34-sk46nw, #a783e1)";
var $17a6dd8285442c36$export$747cbb87e687e631 = "var(--color-charts-palette-categorical-35-wwtyjx, #692801)";
var $17a6dd8285442c36$export$e72d5d73aa047a48 = "var(--color-charts-palette-categorical-36-7v0fgy, #5978e3)";
var $17a6dd8285442c36$export$8a5e1bcf65ef875b = "var(--color-charts-palette-categorical-37-b2rc0w, #b1325c)";
var $17a6dd8285442c36$export$a976a97095cdd9ad = "var(--color-charts-palette-categorical-38-nlzlk1, #1c8e81)";
var $17a6dd8285442c36$export$65fff8610bdb3e4e = "var(--color-charts-palette-categorical-39-esgczm, #7749bf)";
var $17a6dd8285442c36$export$34c5e846b011c6d = "var(--color-charts-palette-categorical-40-0hdln6, #cc5f21)";
var $17a6dd8285442c36$export$6f00bd99fa761c32 = "var(--color-charts-palette-categorical-41-bsk8cf, #314fbf)";
var $17a6dd8285442c36$export$2d603d581b5acb78 = "var(--color-charts-palette-categorical-42-97om84, #8b1b42)";
var $17a6dd8285442c36$export$30e404c1b8690bed = "var(--color-charts-palette-categorical-43-euzcqg, #06645a)";
var $17a6dd8285442c36$export$5b808d0a2f45a41f = "var(--color-charts-palette-categorical-44-a7wos6, #59309d)";
var $17a6dd8285442c36$export$604289a782503a0a = "var(--color-charts-palette-categorical-45-iz0wz2, #983c02)";
var $17a6dd8285442c36$export$ad68fdf838355a7c = "var(--color-charts-palette-categorical-46-nzigym, #23379b)";
var $17a6dd8285442c36$export$dc3a491108121404 = "var(--color-charts-palette-categorical-47-croxgd, #6f062f)";
var $17a6dd8285442c36$export$a692b0645cf6a893 = "var(--color-charts-palette-categorical-48-tptw1p, #014b44)";
var $17a6dd8285442c36$export$3d613fc4079e0097 = "var(--color-charts-palette-categorical-49-6lrkes, #431d84)";
var $17a6dd8285442c36$export$522d2a779702d9b9 = "var(--color-charts-palette-categorical-50-mqbaxr, #732c02)";
var $17a6dd8285442c36$export$11a94f9ea82ee978 = "var(--color-grey-opaque-25-igqnxy, rgba(255, 255, 255, 0.25))";
var $17a6dd8285442c36$export$7680f79f88ee05cd = "var(--color-grey-opaque-40-wxjof3, rgba(0, 0, 0, 0.4))";
var $17a6dd8285442c36$export$2d5ad0d73aaa1f9 = "var(--color-grey-opaque-50-akurqr, rgba(0, 0, 0, 0.5))";
var $17a6dd8285442c36$export$5ff2af5f32b6f5d1 = "var(--color-grey-opaque-70-naqvbh, rgba(35, 47, 62, 0.7))";
var $17a6dd8285442c36$export$eaa8720fef73a91d = "var(--color-grey-opaque-80-dkpq62, rgba(22, 25, 31, 0.8))";
var $17a6dd8285442c36$export$611e40961361c982 = "var(--color-grey-opaque-90-vv6tpi, rgba(242, 243, 243, 0.9))";
var $17a6dd8285442c36$export$5d90c30a91722174 = "var(--color-grey-transparent-ekx6mv, rgba(0, 7, 22, 0.12))";
var $17a6dd8285442c36$export$6dc26d060817f5fc = "var(--color-grey-transparent-heavy-iqptxt, rgba(0, 7, 22, 0.12))";
var $17a6dd8285442c36$export$729e6073df6a8851 = "var(--color-grey-transparent-light-6bril0, rgba(0, 7, 22, 0.12))";
var $17a6dd8285442c36$export$560b534b5441d146 = "var(--color-background-badge-icon-q1kfox, #d91515)";
var $17a6dd8285442c36$export$a3e968957b9b7d91 = "var(--color-background-button-link-active-cbd6sf, #d3e7f9)";
var $17a6dd8285442c36$export$1aec95d5b8e6cf26 = "var(--color-background-button-link-hover-t0fnno, #f2f8fd)";
var $17a6dd8285442c36$export$851ddd51fe884fa0 = "var(--color-background-button-normal-active-qmds3y, #d3e7f9)";
var $17a6dd8285442c36$export$7d3b14c589268c67 = "var(--color-background-button-normal-default-klhbuw, #ffffff)";
var $17a6dd8285442c36$export$6fceb2c87c97025d = "var(--color-background-button-normal-disabled-3ksod4, #ffffff)";
var $17a6dd8285442c36$export$f5b8c697e46541c3 = "var(--color-background-button-normal-hover-imnrq7, #f2f8fd)";
var $17a6dd8285442c36$export$be40f60c52121476 = "var(--color-background-button-primary-active-1ucrg4, #033160)";
var $17a6dd8285442c36$export$cfb4680cc8fc3bd2 = "var(--color-background-button-primary-default-jrg2xu, #0972d3)";
var $17a6dd8285442c36$export$6989cb41d9003aa4 = "var(--color-background-button-primary-disabled-yblour, #e9ebed)";
var $17a6dd8285442c36$export$5c450568da4333da = "var(--color-background-button-primary-hover-l3mbyt, #033160)";
var $17a6dd8285442c36$export$8380385764d8dd5c = "var(--color-background-calendar-current-date-kmb0ji, #f4f4f4)";
var $17a6dd8285442c36$export$238e24eb9c4c802 = "var(--color-background-cell-shaded-7v0jy4, #f8f8f8)";
var $17a6dd8285442c36$export$b0250cb39ec1b995 = "var(--color-background-code-editor-gutter-active-line-default-n2dsul, #5f6b7a)";
var $17a6dd8285442c36$export$f292145a4ddf89f3 = "var(--color-background-code-editor-gutter-active-line-error-ov6y7a, #d91515)";
var $17a6dd8285442c36$export$be559e903087d458 = "var(--color-background-code-editor-gutter-default-om1nsh, #f4f4f4)";
var $17a6dd8285442c36$export$e42fc948412cf2b9 = "var(--color-background-code-editor-loading-0hc882, #fbfbfb)";
var $17a6dd8285442c36$export$c05caaa8fe8b8712 = "var(--color-background-code-editor-pane-item-hover-7wgkyr, #e9ebed)";
var $17a6dd8285442c36$export$c356bef1ab71912f = "var(--color-background-code-editor-status-bar-x8dalt, #f4f4f4)";
var $17a6dd8285442c36$export$296d47a2f46b1742 = "var(--color-background-container-content-4un1ap, #ffffff)";
var $17a6dd8285442c36$export$7c771e775c7524b4 = "var(--color-background-container-header-8b9fgi, #ffffff)";
var $17a6dd8285442c36$export$99a13a6ce59539ae = "var(--color-background-control-checked-w517i0, #0972d3)";
var $17a6dd8285442c36$export$d80a4e111a0f80e5 = "var(--color-background-control-default-qzruqy, #ffffff)";
var $17a6dd8285442c36$export$b62f5d074e74b81b = "var(--color-background-control-disabled-pwkvgd, #d1d5db)";
var $17a6dd8285442c36$export$3dca3358588fc615 = "var(--color-background-dropdown-item-default-be16w5, #ffffff)";
var $17a6dd8285442c36$export$f1f135154edccf74 = "var(--color-background-dropdown-item-dimmed-dlm6wk, transparent)";
var $17a6dd8285442c36$export$d917fb8174a4da69 = "var(--color-background-dropdown-item-filter-match-h5rjsp, #f2f8fd)";
var $17a6dd8285442c36$export$1a8607b2d00c3400 = "var(--color-background-dropdown-item-hover-swsulg, #f4f4f4)";
var $17a6dd8285442c36$export$cc370251354814af = "var(--color-background-dropdown-item-selected-n136dm, #f2f8fd)";
var $17a6dd8285442c36$export$fd449b4efba1c256 = "var(--color-background-home-header-2rudu7, #000716)";
var $17a6dd8285442c36$export$5dbf2b85241be89c = "var(--color-background-input-default-igdh5e, #ffffff)";
var $17a6dd8285442c36$export$77d0dd56aff4474b = "var(--color-background-input-disabled-ab59a3, #e9ebed)";
var $17a6dd8285442c36$export$c09220b4798cd0fb = "var(--color-background-item-selected-hcx8l4, #f2f8fd)";
var $17a6dd8285442c36$export$ecf310dc9384002a = "var(--color-background-layout-main-nx09lr, #ffffff)";
var $17a6dd8285442c36$export$17fa709cee464516 = "var(--color-background-layout-mobile-panel-0ussje, #000716)";
var $17a6dd8285442c36$export$bf959fe6f411f963 = "var(--color-background-layout-panel-content-t82vgh, #ffffff)";
var $17a6dd8285442c36$export$8f53ce0ce04b7367 = "var(--color-background-layout-panel-hover-n9apd3, #e9ebed)";
var $17a6dd8285442c36$export$4c32a80d3bd2febf = "var(--color-background-layout-toggle-active-aa8dko, #414d5c)";
var $17a6dd8285442c36$export$9cfe95af5ad0a88c = "var(--color-background-layout-toggle-default-o2evu2, #414d5c)";
var $17a6dd8285442c36$export$e5eb190094d5ac48 = "var(--color-background-layout-toggle-hover-awem6j, #5f6b7a)";
var $17a6dd8285442c36$export$b85f55144ddbaf31 = "var(--color-background-layout-toggle-selected-active-xfk480, #0972d3)";
var $17a6dd8285442c36$export$6437ca8e29afbb60 = "var(--color-background-layout-toggle-selected-default-caco0q, #0972d3)";
var $17a6dd8285442c36$export$3438cce4b8f16349 = "var(--color-background-layout-toggle-selected-hover-kjak2q, #065299)";
var $17a6dd8285442c36$export$cb44c8b96306859a = "var(--color-background-modal-overlay-ljm46n, rgba(35, 47, 62, 0.7))";
var $17a6dd8285442c36$export$8ed753c2fc92a99f = "var(--color-background-notification-blue-g2q2z0, #0972d3)";
var $17a6dd8285442c36$export$f5d9948982cf2dbd = "var(--color-background-notification-green-1jtqmb, #037f0c)";
var $17a6dd8285442c36$export$c2e092073bc1d66 = "var(--color-background-notification-grey-2odmfy, #414d5c)";
var $17a6dd8285442c36$export$c134581152c00795 = "var(--color-background-notification-red-ovptxu, #d91515)";
var $17a6dd8285442c36$export$389fd72e07e2625d = "var(--color-background-notification-yellow-seoi5y, #ffe457)";
var $17a6dd8285442c36$export$f3f567e353056c5d = "var(--color-background-notification-stack-bar-btgysg, #232f3e)";
var $17a6dd8285442c36$export$929131bbb43fa587 = "var(--color-background-notification-stack-bar-active-g701bg, #232f3e)";
var $17a6dd8285442c36$export$a3b7cb72e45aaba5 = "var(--color-background-notification-stack-bar-hover-905myr, #414d5c)";
var $17a6dd8285442c36$export$58604a7291b2ee8a = "var(--color-background-popover-szburm, #ffffff)";
var $17a6dd8285442c36$export$eb8e77a9a6c8b1a2 = "var(--color-background-progress-bar-content-default-yvwdkl, #0972d3)";
var $17a6dd8285442c36$export$2bbc15c0b22f6334 = "var(--color-background-progress-bar-content-in-flash-ccuxyt, #ffffff)";
var $17a6dd8285442c36$export$70b2a95820a38982 = "var(--color-background-progress-bar-layout-default-ktc0zl, #e9ebed)";
var $17a6dd8285442c36$export$a631faeaa4f152e9 = "var(--color-background-progress-bar-layout-in-flash-rlu77n, rgba(255, 255, 255, 0.25))";
var $17a6dd8285442c36$export$1e4b82141f2b1495 = "var(--color-background-segment-active-366806, #0972d3)";
var $17a6dd8285442c36$export$22d451f21f527ebb = "var(--color-background-segment-default-3arros, #ffffff)";
var $17a6dd8285442c36$export$10f7455e64466bb = "var(--color-background-segment-disabled-o4y9v5, #ffffff)";
var $17a6dd8285442c36$export$1791628190961638 = "var(--color-background-segment-hover-jysoxv, #ffffff)";
var $17a6dd8285442c36$export$9796a91ad8016e6a = "var(--color-background-slider-handle-default-atrlod, #0972d3)";
var $17a6dd8285442c36$export$870b95565f97fc9b = "var(--color-background-slider-handle-active-ccegzg, #065299)";
var $17a6dd8285442c36$export$a3265186590fa696 = "var(--color-background-slider-track-3m68rn, #7d8998)";
var $17a6dd8285442c36$export$9e44ac155cb1221c = "var(--color-background-slider-handle-ring-31445h, #ffffff)";
var $17a6dd8285442c36$export$f0859078b6736036 = "var(--color-background-slider-error-pressed-g7oqnt, #7c2718)";
var $17a6dd8285442c36$export$2a2885e6261082d6 = "var(--color-background-slider-warning-pressed-9xuhwf, #8d6605)";
var $17a6dd8285442c36$export$96da102a897ab4bf = "var(--color-background-status-error-pbprvn, #fff7f7)";
var $17a6dd8285442c36$export$f932e11b6b47e95e = "var(--color-background-status-info-mvnbre, #f2f8fd)";
var $17a6dd8285442c36$export$19a27966008aaa29 = "var(--color-background-status-success-jp14wa, #f2fcf3)";
var $17a6dd8285442c36$export$3e42e679dbf98aa4 = "var(--color-background-status-warning-oor4hw, #fffce9)";
var $17a6dd8285442c36$export$418d588cd1fd4f9 = "var(--color-background-table-header-82ew8p, #ffffff)";
var $17a6dd8285442c36$export$c18e6c272dd9dc7a = "var(--color-background-tiles-disabled-0j6ior, #e9ebed)";
var $17a6dd8285442c36$export$381775e80eb95c8c = "var(--color-background-toggle-checked-disabled-uqvx2z, #b5d6f4)";
var $17a6dd8285442c36$export$7f6c6e0e80fbab8c = "var(--color-background-toggle-default-6qtbef, #414d5c)";
var $17a6dd8285442c36$export$6814c0e0de242e7d = "var(--color-background-avatar-gen-ai-i9hcw6, radial-gradient(circle farthest-corner at top left,rgba(0, 150, 250, 1) -25%,rgba(0, 150, 250, 0) 55%),radial-gradient(circle farthest-corner at top right, rgba(216, 178, 255, 1) -10%, rgba(115, 0, 229, 1) 50%))";
var $17a6dd8285442c36$export$b3bb607884158857 = "var(--color-background-avatar-default-vm4u8g, #414d5c)";
var $17a6dd8285442c36$export$ed831b962e883834 = "var(--color-text-avatar-jddpvm, #ffffff)";
var $17a6dd8285442c36$export$f04a8d03d93ee845 = "var(--color-background-loading-bar-gen-ai-7qfi9s, linear-gradient(90deg, #99f7ff 0%, #0096fa 10%, #bf80ff 24%, #7300e5 50%, #bf80ff 76%, #0096fa 90%, #99f7ff 100%))";
var $17a6dd8285442c36$export$e3e7feb75e4133c1 = "var(--color-border-button-normal-active-tc4102, #033160)";
var $17a6dd8285442c36$export$fb6983d30261bfaa = "var(--color-border-button-normal-default-x52rkp, #0972d3)";
var $17a6dd8285442c36$export$4a460fb6c3800af9 = "var(--color-border-button-normal-disabled-40wkb4, #9ba7b6)";
var $17a6dd8285442c36$export$85f61c65019db4a0 = "var(--color-text-button-normal-disabled-h3ul0e, #7d8998)";
var $17a6dd8285442c36$export$21bbd00e71e50aab = "var(--color-border-button-normal-hover-qs1x3s, #033160)";
var $17a6dd8285442c36$export$82b3aa5f391b7647 = "var(--color-border-button-primary-disabled-mewj5j, #e9ebed)";
var $17a6dd8285442c36$export$8b56c15e5a260ee7 = "var(--color-text-button-primary-disabled-gxu2gk, #7d8998)";
var $17a6dd8285442c36$export$85d894dd0ecb1e5a = "var(--color-border-calendar-grid-u86q1u, transparent)";
var $17a6dd8285442c36$export$7834474c559e3cfb = "var(--color-border-calendar-grid-selected-focus-ring-thqa8y, #fbfbfb)";
var $17a6dd8285442c36$export$4aab3eadca401d6 = "var(--color-border-code-editor-ace-active-line-light-theme-37hmmo, #d1d5db)";
var $17a6dd8285442c36$export$8142da277bc2ea05 = "var(--color-border-code-editor-ace-active-line-dark-theme-5oxz8x, #5f6b7a)";
var $17a6dd8285442c36$export$51ebf8e6c56e574c = "var(--color-border-code-editor-default-c1jpix, #d1d5db)";
var $17a6dd8285442c36$export$cf9140936855564d = "var(--color-border-code-editor-pane-item-hover-std69p, #7d8998)";
var $17a6dd8285442c36$export$9aad68da3fc64587 = "var(--color-border-container-divider-p2uygo, transparent)";
var $17a6dd8285442c36$export$fa1e43b885bf45ea = "var(--color-border-container-top-736buh, transparent)";
var $17a6dd8285442c36$export$d093672d17c0de96 = "var(--color-border-control-checked-wlsmbn, #0972d3)";
var $17a6dd8285442c36$export$e8c5d615f15f5e76 = "var(--color-border-control-default-0fzxw0, #7d8998)";
var $17a6dd8285442c36$export$9cfb54df372559c7 = "var(--color-border-control-disabled-bv2kkn, #d1d5db)";
var $17a6dd8285442c36$export$e44173cef7897bf = "var(--color-border-divider-active-k4haaf, #000716)";
var $17a6dd8285442c36$export$13f70a45b59d5f8b = "var(--color-border-divider-default-j74lyz, #b6bec9)";
var $17a6dd8285442c36$export$a44b693dc5993f76 = "var(--color-border-divider-panel-bottom-dwyqvg, #b6bec9)";
var $17a6dd8285442c36$export$fc16e8dc7d404c5b = "var(--color-border-divider-panel-side-93n0qu, #b6bec9)";
var $17a6dd8285442c36$export$ac43eeb57f91d764 = "var(--color-border-divider-secondary-um17yo, #e9ebed)";
var $17a6dd8285442c36$export$69bef49d54f5dd71 = "var(--color-border-dropdown-container-5boaph, #9ba7b6)";
var $17a6dd8285442c36$export$1f6651cf07fc241b = "var(--color-border-dropdown-group-yakmix, #b6bec9)";
var $17a6dd8285442c36$export$741a8ce3d247b977 = "var(--color-border-dropdown-item-default-k36ra7, #b6bec9)";
var $17a6dd8285442c36$export$50f59cdad678c0dd = "var(--color-border-dropdown-item-hover-461g78, #7d8998)";
var $17a6dd8285442c36$export$c4d27d83094bd624 = "var(--color-border-dropdown-item-dimmed-hover-xdu0hf, #7d8998)";
var $17a6dd8285442c36$export$7fc52b80c956560f = "var(--color-border-dropdown-item-selected-096aj1, #0972d3)";
var $17a6dd8285442c36$export$3baa383d112607d = "var(--color-border-dropdown-item-top-ky64jq, transparent)";
var $17a6dd8285442c36$export$62adfa6b7b328cf8 = "var(--color-border-editable-cell-hover-nqrv6y, #7d8998)";
var $17a6dd8285442c36$export$21afa3ade758638c = "var(--color-border-input-default-1zl7hq, #7d8998)";
var $17a6dd8285442c36$export$ec8bd66c0156738c = "var(--color-border-input-disabled-rx2aau, #e9ebed)";
var $17a6dd8285442c36$export$ec963abecb04d303 = "var(--color-border-input-focused-3d15sl, #033160)";
var $17a6dd8285442c36$export$861654f1938d1f98 = "var(--color-border-item-focused-b2ntyl, #0972d3)";
var $17a6dd8285442c36$export$3f1ce4cc66f844e1 = "var(--color-border-dropdown-item-focused-5hbaf3, #414d5c)";
var $17a6dd8285442c36$export$22ae6baddbc6e3c9 = "var(--color-border-item-placeholder-h8j85e, #0972d3)";
var $17a6dd8285442c36$export$aafa50fcd0bf473e = "var(--color-border-item-selected-k00wlz, #0972d3)";
var $17a6dd8285442c36$export$e3904b4916291c65 = "var(--color-border-layout-ownedw, #d1d5db)";
var $17a6dd8285442c36$export$7fef254eb1b70093 = "var(--color-border-notification-stack-bar-t3aws2, #232f3e)";
var $17a6dd8285442c36$export$cfcb693971ed251a = "var(--color-border-panel-header-lf0q4c, #b6bec9)";
var $17a6dd8285442c36$export$693c156e69be0284 = "var(--color-border-popover-umqvld, #9ba7b6)";
var $17a6dd8285442c36$export$293770c391b8bbd7 = "var(--color-border-segment-active-9ah16u, #414d5c)";
var $17a6dd8285442c36$export$e24ad1b781f47c8f = "var(--color-border-segment-default-a5zrkd, #414d5c)";
var $17a6dd8285442c36$export$e12f0f1ebf9eb9d4 = "var(--color-border-segment-disabled-ylnixy, #414d5c)";
var $17a6dd8285442c36$export$6ce770691b3e0927 = "var(--color-border-segment-hover-ggg2rz, #414d5c)";
var $17a6dd8285442c36$export$cbc24658d2fb9487 = "var(--color-border-status-error-dj6icm, #d91515)";
var $17a6dd8285442c36$export$f3c43f03ab377031 = "var(--color-border-status-info-8upc6f, #0972d3)";
var $17a6dd8285442c36$export$b93f266d442a4415 = "var(--color-border-status-success-wmgb40, #037f0c)";
var $17a6dd8285442c36$export$7e4932b8a8f6c584 = "var(--color-border-status-warning-52glov, #8d6605)";
var $17a6dd8285442c36$export$78bfd3b23208a4e0 = "var(--color-border-divider-interactive-default-byy830, #7d8998)";
var $17a6dd8285442c36$export$9591885b4360f487 = "var(--color-border-tabs-divider-6vpso4, #b6bec9)";
var $17a6dd8285442c36$export$423a7f6153e1b641 = "var(--color-border-tabs-shadow-w5xpb4, rgba(0, 7, 22, 0.12))";
var $17a6dd8285442c36$export$28dbd52c273d4b7 = "var(--color-border-tabs-underline-f1qo5r, #0972d3)";
var $17a6dd8285442c36$export$d058d361ba133ca1 = "var(--color-border-tiles-disabled-q5e1so, #e9ebed)";
var $17a6dd8285442c36$export$4ef42a9d5871f18 = "var(--color-border-tutorial-kk53ya, #d1d5db)";
var $17a6dd8285442c36$export$5846f2c78fe18c7f = "var(--color-foreground-control-default-wq2gpa, #ffffff)";
var $17a6dd8285442c36$export$7bc49731426c5ff9 = "var(--color-foreground-control-disabled-zmz2k2, #ffffff)";
var $17a6dd8285442c36$export$23f341fc399c3d71 = "var(--color-foreground-control-read-only-ibiswj, #5f6b7a)";
var $17a6dd8285442c36$export$311a9f2d28f07e7c = "var(--color-shadow-default-8jp634, rgba(0, 7, 22, 0.12))";
var $17a6dd8285442c36$export$805fa7d3cf10a9f6 = "var(--color-shadow-medium-wuskz4, rgba(0, 7, 22, 0.12))";
var $17a6dd8285442c36$export$5641087cd2c643f7 = "var(--color-shadow-side-75ahs7, rgba(0, 7, 22, 0.12))";
var $17a6dd8285442c36$export$adfb5d6d7405f089 = "var(--color-stroke-chart-line-ppq5nh, #7d8998)";
var $17a6dd8285442c36$export$c72f92a6eb009bd8 = "var(--color-stroke-code-editor-resize-handler-lv2a3k, #414d5c)";
var $17a6dd8285442c36$export$b178e95dfaec580f = "var(--color-stroke-code-editor-gutter-active-line-default-0bl22a, #d1d5db)";
var $17a6dd8285442c36$export$27b0788b70e0957e = "var(--color-stroke-code-editor-gutter-active-line-hover-i9389t, #fbfbfb)";
var $17a6dd8285442c36$export$42d86111d6f9cac1 = "var(--color-text-accent-n2acxv, #0972d3)";
var $17a6dd8285442c36$export$99fafe6b96819d06 = "var(--color-text-body-default-at06ol, #000716)";
var $17a6dd8285442c36$export$7ed8f2bb2f12e659 = "var(--color-text-body-secondary-w9jvno, #414d5c)";
var $17a6dd8285442c36$export$24880e6990a0adb2 = "var(--color-text-breadcrumb-current-bnqeha, #5f6b7a)";
var $17a6dd8285442c36$export$2ceebbdc1000cfb4 = "var(--color-text-breadcrumb-icon-ma8w3r, #7d8998)";
var $17a6dd8285442c36$export$922335eb1ef6a73 = "var(--color-text-button-inline-icon-default-s3yux9, #0972d3)";
var $17a6dd8285442c36$export$98fcc14a4823bf86 = "var(--color-text-button-inline-icon-disabled-mz5gmn, #9ba7b6)";
var $17a6dd8285442c36$export$9cc92cfa1634ca = "var(--color-text-button-inline-icon-hover-my2daf, #033160)";
var $17a6dd8285442c36$export$63e7d68a830c9ae2 = "var(--color-text-button-normal-active-4it2mv, #033160)";
var $17a6dd8285442c36$export$97f2d9ae0dc6d73e = "var(--color-text-button-normal-default-mo7k6u, #0972d3)";
var $17a6dd8285442c36$export$cd3f5c4941958390 = "var(--color-text-button-normal-hover-04pe0y, #033160)";
var $17a6dd8285442c36$export$be42745d99acf7c2 = "var(--color-text-link-button-normal-default-px6yl8, #0972d3)";
var $17a6dd8285442c36$export$83589dd4e57b517e = "var(--color-text-link-button-normal-hover-4psj43, #033160)";
var $17a6dd8285442c36$export$cb3f53ac38870aaa = "var(--color-text-link-button-normal-active-pv8vqs, #033160)";
var $17a6dd8285442c36$export$49a08c3d4865a6b5 = "var(--color-text-button-primary-active-jqjf9n, #ffffff)";
var $17a6dd8285442c36$export$4b9f38ba4c3a17 = "var(--color-text-button-primary-default-ltldxu, #ffffff)";
var $17a6dd8285442c36$export$8d1cd4b4de370118 = "var(--color-text-button-primary-hover-tcoaeg, #ffffff)";
var $17a6dd8285442c36$export$fa17c6da10611502 = "var(--color-text-calendar-date-hover-llr4as, #000716)";
var $17a6dd8285442c36$export$46e57defcea022db = "var(--color-text-calendar-date-selected-otk0dm, #0972d3)";
var $17a6dd8285442c36$export$7b67940acd4285c7 = "var(--color-text-calendar-month-hxx5ey, #5f6b7a)";
var $17a6dd8285442c36$export$cdb37e98b35f1870 = "var(--color-text-code-editor-gutter-active-line-zmlu0u, #ffffff)";
var $17a6dd8285442c36$export$e3c59ff3d97a7e4e = "var(--color-text-code-editor-gutter-default-n16krn, #000716)";
var $17a6dd8285442c36$export$5c8a158dea93561b = "var(--color-text-code-editor-status-bar-disabled-mrlsxh, #7d8998)";
var $17a6dd8285442c36$export$dfe05a14127d6c2a = "var(--color-text-code-editor-tab-button-error-5ax346, #ffffff)";
var $17a6dd8285442c36$export$c438f00c0302b457 = "var(--color-text-column-header-czuvwg, #414d5c)";
var $17a6dd8285442c36$export$c52aae78f22065ee = "var(--color-text-column-sorting-icon-8or30j, #414d5c)";
var $17a6dd8285442c36$export$edab525602307245 = "var(--color-text-control-disabled-ircsnq, #9ba7b6)";
var $17a6dd8285442c36$export$18f2dc4137d83cf7 = "var(--color-text-counter-zqugin, #5f6b7a)";
var $17a6dd8285442c36$export$857c200a76b814d0 = "var(--color-text-disabled-f4c52h, #9ba7b6)";
var $17a6dd8285442c36$export$e1c203ec8aff3c13 = "var(--color-text-disabled-inline-edit-zrb7bp, #414d5c)";
var $17a6dd8285442c36$export$54d684990ca4aaea = "var(--color-text-dropdown-footer-7d1eld, #5f6b7a)";
var $17a6dd8285442c36$export$6e6dd0370f5223d6 = "var(--color-text-dropdown-group-label-4x4uyw, #414d5c)";
var $17a6dd8285442c36$export$e25a4b7952ed9fb1 = "var(--color-text-dropdown-item-default-4o4hes, #000716)";
var $17a6dd8285442c36$export$e4ca2e371ee4d531 = "var(--color-text-dropdown-item-dimmed-f2joj8, #9ba7b6)";
var $17a6dd8285442c36$export$4f904e7f556bf04e = "var(--color-text-dropdown-item-disabled-6oq3n6, #9ba7b6)";
var $17a6dd8285442c36$export$bd72e46ce6e21dd6 = "var(--color-text-dropdown-item-filter-match-6moumb, #0972d3)";
var $17a6dd8285442c36$export$56a5d6c04184dd38 = "var(--color-text-dropdown-item-highlighted-a51hdb, #000716)";
var $17a6dd8285442c36$export$9591a8460cdde3a7 = "var(--color-text-dropdown-item-secondary-jho0ju, #5f6b7a)";
var $17a6dd8285442c36$export$9efa36f8cfd415f6 = "var(--color-text-dropdown-item-secondary-hover-zfmqjr, #5f6b7a)";
var $17a6dd8285442c36$export$aa35dbb3aad6a65b = "var(--color-text-empty-2wfcyr, #5f6b7a)";
var $17a6dd8285442c36$export$d75e83bfc8c0be57 = "var(--color-text-expandable-section-default-djhi83, #000716)";
var $17a6dd8285442c36$export$1b4c65d205376275 = "var(--color-text-expandable-section-hover-2d1zpj, #0972d3)";
var $17a6dd8285442c36$export$74009e11f21bb45c = "var(--color-text-expandable-section-navigation-icon-default-htcovl, #414d5c)";
var $17a6dd8285442c36$export$7d1dc906b1b805c3 = "var(--color-text-form-default-vh42kd, #000716)";
var $17a6dd8285442c36$export$4e05f8acfec5c66c = "var(--color-text-form-label-ktbzsd, #000716)";
var $17a6dd8285442c36$export$8ff2878df57d760d = "var(--color-text-form-secondary-dxc248, #5f6b7a)";
var $17a6dd8285442c36$export$192033fa7a73efac = "var(--color-text-group-label-jpw8sm, #414d5c)";
var $17a6dd8285442c36$export$86bbad4e14c6062 = "var(--color-text-label-gen-ai-76ots7, #7300e5)";
var $17a6dd8285442c36$export$8fe365f5a6ae70aa = "var(--color-text-heading-default-lstrpn, #000716)";
var $17a6dd8285442c36$export$2ace79b7e81a7323 = "var(--color-text-heading-secondary-37b2tq, #414d5c)";
var $17a6dd8285442c36$export$3b21a9010b3111e5 = "var(--color-text-home-header-default-efg900, #e9ebed)";
var $17a6dd8285442c36$export$fc21ae35df42867b = "var(--color-text-home-header-secondary-v3y5co, #b6bec9)";
var $17a6dd8285442c36$export$d6227c677f296693 = "var(--color-text-icon-caret-3dlaji, #7d8998)";
var $17a6dd8285442c36$export$e553b8131808490c = "var(--color-text-icon-subtle-c4qyia, #5f6b7a)";
var $17a6dd8285442c36$export$257858c4198e525 = "var(--color-text-input-disabled-f8pjm5, #9ba7b6)";
var $17a6dd8285442c36$export$1b5853a0f4e17e5 = "var(--color-text-input-placeholder-mx1ygd, #5f6b7a)";
var $17a6dd8285442c36$export$ef5bdf9e3981f664 = "var(--color-text-input-placeholder-disabled-abhb0d, #9ba7b6)";
var $17a6dd8285442c36$export$27973045a319f5d1 = "var(--color-text-interactive-active-ox3ozh, #000716)";
var $17a6dd8285442c36$export$917409e24b36a327 = "var(--color-text-interactive-default-lnx6lk, #414d5c)";
var $17a6dd8285442c36$export$2544926b6b965541 = "var(--color-text-interactive-disabled-z7a3t4, #9ba7b6)";
var $17a6dd8285442c36$export$56be1b21083f2ecc = "var(--color-text-interactive-hover-mj8add, #000716)";
var $17a6dd8285442c36$export$1ace3632b151abd0 = "var(--color-text-interactive-inverted-default-yhw7hw, #d1d5db)";
var $17a6dd8285442c36$export$586fbfdef511d74f = "var(--color-text-interactive-inverted-hover-zzkght, #fbfbfb)";
var $17a6dd8285442c36$export$1da3dbae9b70c2e = "var(--color-text-inverted-70cpkk, #ffffff)";
var $17a6dd8285442c36$export$4d79623668a3004f = "var(--color-text-label-rj4jdv, #000716)";
var $17a6dd8285442c36$export$60752a0ef4f0a222 = "var(--color-text-layout-toggle-zybz0r, #ffffff)";
var $17a6dd8285442c36$export$8a9b3ed37003767f = "var(--color-text-layout-toggle-active-p0m0v1, #ffffff)";
var $17a6dd8285442c36$export$6a6284cae6fe86a2 = "var(--color-text-layout-toggle-hover-1r0lo8, #0972d3)";
var $17a6dd8285442c36$export$4a375d38c14027cc = "var(--color-text-layout-toggle-selected-b93usl, #ffffff)";
var $17a6dd8285442c36$export$87fd46c2adb0565a = "var(--color-text-link-default-latg1a, #0972d3)";
var $17a6dd8285442c36$export$b9118f081e6adc14 = "var(--color-text-link-hover-8j6p14, #033160)";
var $17a6dd8285442c36$export$760c1828e1d1b351 = "var(--color-text-link-inverted-hover-09cw7h, #ffffff)";
var $17a6dd8285442c36$export$67db7ec9a0bc21f9 = "var(--color-text-link-button-underline-ik5r9i, transparent)";
var $17a6dd8285442c36$export$ddf6b0c6528b3df8 = "var(--color-text-link-button-underline-hover-gyir88, transparent)";
var $17a6dd8285442c36$export$3f8a1f629cf02acc = "var(--color-text-notification-default-rdawv9, #fbfbfb)";
var $17a6dd8285442c36$export$46dd282a0b58a932 = "var(--color-text-notification-stack-bar-jc9tvx, #ffffff)";
var $17a6dd8285442c36$export$21252f62bbad2125 = "var(--color-text-notification-yellow-p027cz, #000716)";
var $17a6dd8285442c36$export$4730513fe3b1f162 = "var(--color-text-pagination-page-number-active-disabled-pnozll, #9ba7b6)";
var $17a6dd8285442c36$export$6b6720412e870e83 = "var(--color-text-pagination-page-number-default-i8se09, #414d5c)";
var $17a6dd8285442c36$export$6d37a0482ee6fd89 = "var(--color-text-segment-active-6s77n9, #ffffff)";
var $17a6dd8285442c36$export$ba8d3cb8859b9cda = "var(--color-text-segment-default-nncpby, #414d5c)";
var $17a6dd8285442c36$export$4ffd0943b22f4363 = "var(--color-text-segment-hover-k5ujfk, #0972d3)";
var $17a6dd8285442c36$export$c9e859a315128530 = "var(--color-text-small-zfvvfc, #5f6b7a)";
var $17a6dd8285442c36$export$2daf8207ed230a8a = "var(--color-text-status-error-wdvepn, #d91515)";
var $17a6dd8285442c36$export$fca183cf8dc818d1 = "var(--color-text-status-inactive-m7co45, #5f6b7a)";
var $17a6dd8285442c36$export$af992c7c57616b19 = "var(--color-text-status-info-ahz8zp, #0972d3)";
var $17a6dd8285442c36$export$a5cc488071f3db86 = "var(--color-text-status-success-bpiyjm, #037f0c)";
var $17a6dd8285442c36$export$b0a9d296733744f4 = "var(--color-text-status-warning-yik8vi, #8d6605)";
var $17a6dd8285442c36$export$789dbe3ee06794db = "var(--color-text-top-navigation-title-v7rgbf, #000716)";
var $17a6dd8285442c36$export$4ce75865f8956095 = "var(--color-board-placeholder-active-jh49z8, #e9ebed)";
var $17a6dd8285442c36$export$d5dc59ad54217992 = "var(--color-board-placeholder-hover-ombmcs, #d3e7f9)";
var $17a6dd8285442c36$export$eb6c4c2099c875f8 = "var(--color-drag-placeholder-active-j62q9o, #e9ebed)";
var $17a6dd8285442c36$export$1f89d9e32f8d6b9e = "var(--color-drag-placeholder-hover-4im65s, #d3e7f9)";
var $17a6dd8285442c36$export$4cb248b55f3d01ab = "var(--color-dropzone-background-active-g7hjqs, #e9ebed)";
var $17a6dd8285442c36$export$b4aab8b16da3aa95 = "var(--color-dropzone-background-hover-42q8nb, #d3e7f9)";
var $17a6dd8285442c36$export$a79038af2b526e56 = "var(--color-dropzone-text-active-8e1lcf, #5f6b7a)";
var $17a6dd8285442c36$export$73d7d5da118148f7 = "var(--color-dropzone-text-hover-4qxymq, #033160)";
var $17a6dd8285442c36$export$5a5d81c9ba8db0dc = "var(--font-box-value-large-weight-onoq9k, 700)";
var $17a6dd8285442c36$export$6cea02332282f81c = "var(--font-button-letter-spacing-65ug0o, 0.005em)";
var $17a6dd8285442c36$export$c105956e72fdfddf = "var(--font-button-weight-hv56tz, 700)";
var $17a6dd8285442c36$export$97c97058d95ef0c = "var(--font-chart-detail-size-1n389u, 12px)";
var $17a6dd8285442c36$export$a26c7707d8b80ef2 = "var(--font-display-label-weight-815ja9, 700)";
var $17a6dd8285442c36$export$947ebdf5d486852d = "var(--font-expandable-heading-size-smdiul, 16px)";
var $17a6dd8285442c36$export$d6d0beee51714e68 = "var(--font-family-base-dnvic8, 'Open Sans', 'Helvetica Neue', Roboto, Arial, sans-serif)";
var $17a6dd8285442c36$export$f0a6663ff0bec29b = "var(--font-family-monospace-bftdwf, Monaco, Menlo, Consolas, 'Courier Prime', Courier, 'Courier New', monospace)";
var $17a6dd8285442c36$export$5dd33e724c44736 = "var(--font-header-h2-description-line-height-rtewek, 20px)";
var $17a6dd8285442c36$export$fa61d38260e1aa7f = "var(--font-header-h2-description-size-2hj97p, 14px)";
var $17a6dd8285442c36$export$899038b1221ac378 = "var(--font-link-button-letter-spacing-yi9f0l, 0.005em)";
var $17a6dd8285442c36$export$78395bf113ea0316 = "var(--font-link-button-weight-jephf1, 700)";
var $17a6dd8285442c36$export$a98c4a0b02ae57aa = "var(--font-panel-header-line-height-kxi4u2, 22px)";
var $17a6dd8285442c36$export$82533652d6b4f903 = "var(--font-panel-header-size-edjz3l, 18px)";
var $17a6dd8285442c36$export$de81818e89f6d1c = "var(--font-size-body-m-x4okxb, 14px)";
var $17a6dd8285442c36$export$dff12ce2697b4214 = "var(--font-size-body-s-asqx2i, 12px)";
var $17a6dd8285442c36$export$802031699d2e324 = "var(--font-size-display-l-htkq3e, 42px)";
var $17a6dd8285442c36$export$78893ab79410136f = "var(--font-size-heading-xl-ypc05a, 24px)";
var $17a6dd8285442c36$export$8855834baaf16ab9 = "var(--font-size-heading-l-ou0d0l, 20px)";
var $17a6dd8285442c36$export$b747afecae25382c = "var(--font-size-heading-m-sjd256, 18px)";
var $17a6dd8285442c36$export$e57a6c9ad7e1cf4a = "var(--font-size-heading-s-yykzif, 16px)";
var $17a6dd8285442c36$export$b41f1e4e3d64cfa6 = "var(--font-size-heading-xs-wo4hpf, 14px)";
var $17a6dd8285442c36$export$ea4831bdeb80d215 = "var(--font-smoothing-moz-osx-foywby, grayscale)";
var $17a6dd8285442c36$export$584c04b0ccacae2a = "var(--font-smoothing-webkit-m8nc84, antialiased)";
var $17a6dd8285442c36$export$f26159ce525e15ef = "var(--font-tabs-disabled-weight-1xcs5l, 700)";
var $17a6dd8285442c36$export$c040d70e16297339 = "var(--font-tabs-line-height-dzo7k3, 20px)";
var $17a6dd8285442c36$export$d2e204a7313b6b1f = "var(--font-tabs-size-8zzqp2, 16px)";
var $17a6dd8285442c36$export$57d5578d1c0dd031 = "var(--font-wayfinding-link-active-weight-rbmzei, 700)";
var $17a6dd8285442c36$export$72d6edb9be191d20 = "var(--font-weight-heading-xl-yvsksd, 700)";
var $17a6dd8285442c36$export$463f7297c66c5659 = "var(--font-weight-heading-l-f8711v, 700)";
var $17a6dd8285442c36$export$9f0bb5f0d2fad1a7 = "var(--font-weight-heading-m-m2ekmb, 700)";
var $17a6dd8285442c36$export$f32c723296820b10 = "var(--font-weight-heading-s-cwn6wc, 700)";
var $17a6dd8285442c36$export$7260e7109913629b = "var(--font-weight-heading-xs-l7rqme, 700)";
var $17a6dd8285442c36$export$db2388352ecb5150 = "var(--font-weight-heavy-cqd9pv, 700)";
var $17a6dd8285442c36$export$264349a9e414770f = "var(--letter-spacing-body-s-z9jkwp, 0.005em)";
var $17a6dd8285442c36$export$5b77f6808836ac1b = "var(--letter-spacing-display-l-9cigop, -0.03em)";
var $17a6dd8285442c36$export$abf0281c74f07dbf = "var(--letter-spacing-heading-xl-sagq9c, -0.02em)";
var $17a6dd8285442c36$export$833d03d6446bc9a8 = "var(--letter-spacing-heading-l-qqjd4y, -0.015em)";
var $17a6dd8285442c36$export$e563f57566f5a16c = "var(--letter-spacing-heading-m-0w575i, -0.010em)";
var $17a6dd8285442c36$export$dcf2b798cdae05fe = "var(--letter-spacing-heading-s-jr3mor, -0.005em)";
var $17a6dd8285442c36$export$960c67453f7bf2c4 = "var(--line-height-body-m-30ar75, 20px)";
var $17a6dd8285442c36$export$dfe0e027c81f3fb4 = "var(--line-height-body-s-7zv1j5, 16px)";
var $17a6dd8285442c36$export$a2ccddd9c8b22337 = "var(--line-height-display-l-8nioft, 48px)";
var $17a6dd8285442c36$export$8252c71e3e8f47ad = "var(--line-height-heading-xl-avbttk, 30px)";
var $17a6dd8285442c36$export$4a1a8478677e8661 = "var(--line-height-heading-l-mmm3my, 24px)";
var $17a6dd8285442c36$export$eccc5884669941d3 = "var(--line-height-heading-m-50evfk, 22px)";
var $17a6dd8285442c36$export$ab1c754ed3ed46cf = "var(--line-height-heading-s-4i6ewn, 20px)";
var $17a6dd8285442c36$export$be5dafb62c47ddb3 = "var(--line-height-heading-xs-aeleja, 18px)";
var $17a6dd8285442c36$export$2254d56a2db9aaa4 = "var(--border-active-width-9dmqf4, 4px)";
var $17a6dd8285442c36$export$b857bd6df1943933 = "var(--border-code-editor-status-divider-width-tf47q3, 1px)";
var $17a6dd8285442c36$export$df9fd67728cbecdd = "var(--border-container-sticky-width-6asz33, 0px)";
var $17a6dd8285442c36$export$af181704b6845b8f = "var(--border-container-top-width-uugwwl, 0px)";
var $17a6dd8285442c36$export$24ea37ef9c8f8fd9 = "var(--border-control-focus-ring-shadow-spread-0ctpjf, 0px)";
var $17a6dd8285442c36$export$85ffa7850802bbcf = "var(--border-control-invalid-focus-ring-shadow-spread-fhmbjn, 2px)";
var $17a6dd8285442c36$export$dbc87f9a80f6e622 = "var(--border-divider-list-width-27y3k5, 1px)";
var $17a6dd8285442c36$export$b5bc0a4da20f31fe = "var(--border-divider-section-width-1061zr, 1px)";
var $17a6dd8285442c36$export$dd22823a0a352bcf = "var(--border-dropdown-virtual-offset-width-kekgc0, 2px)";
var $17a6dd8285442c36$export$a5fb99c35111c75c = "var(--border-field-width-09w7vk, 2px)";
var $17a6dd8285442c36$export$32aca878b5c7fdb3 = "var(--border-invalid-width-5ktjp2, 8px)";
var $17a6dd8285442c36$export$16bb82810c487486 = "var(--border-item-width-yel47s, 2px)";
var $17a6dd8285442c36$export$e48f263823f3a26b = "var(--border-line-chart-dash-array-k49cgz, 3 5)";
var $17a6dd8285442c36$export$ffe30aa9ee1bf93 = "var(--border-line-chart-line-join-hdz0jf, round)";
var $17a6dd8285442c36$export$45491abb80b1b00d = "var(--border-line-chart-width-9mzos2, 2px)";
var $17a6dd8285442c36$export$1840171bbd801836 = "var(--border-panel-header-width-3w1py7, 1px)";
var $17a6dd8285442c36$export$a76a9c28849b8bd4 = "var(--border-panel-top-width-7uc0w9, 1px)";
var $17a6dd8285442c36$export$935c733d90884a1e = "var(--border-radius-alert-mdtrse, 12px)";
var $17a6dd8285442c36$export$5fecae2e6866e59b = "var(--border-radius-badge-0z09dt, 4px)";
var $17a6dd8285442c36$export$cc74298e2de4c08a = "var(--border-radius-button-ypmfry, 20px)";
var $17a6dd8285442c36$export$619970e6a624b9e4 = "var(--border-radius-calendar-day-focus-ring-545h0w, 3px)";
var $17a6dd8285442c36$export$78364b6834dce34f = "var(--border-radius-code-editor-qvw11o, 8px)";
var $17a6dd8285442c36$export$889ee0b119aa6cec = "var(--border-radius-container-wqv1zi, 16px)";
var $17a6dd8285442c36$export$5853edbe7ce5fc1a = "var(--border-radius-control-circular-focus-ring-w07mub, 4px)";
var $17a6dd8285442c36$export$873f4d472370aae2 = "var(--border-radius-control-default-focus-ring-u8zbsz, 4px)";
var $17a6dd8285442c36$export$856fe769595fe7bd = "var(--border-radius-dropdown-0dhh79, 8px)";
var $17a6dd8285442c36$export$4dc1eacc5288b1ff = "var(--border-radius-dropzone-4sx861, 12px)";
var $17a6dd8285442c36$export$289362cd463e61c = "var(--border-radius-flashbar-hcdl9q, 12px)";
var $17a6dd8285442c36$export$366d043df26e3678 = "var(--border-radius-item-05df9h, 8px)";
var $17a6dd8285442c36$export$966ead158ef9e27f = "var(--border-radius-input-plgbrq, 8px)";
var $17a6dd8285442c36$export$e53441319a919031 = "var(--border-radius-popover-clv1ya, 8px)";
var $17a6dd8285442c36$export$74e50aa3cc90a49c = "var(--border-radius-tabs-focus-ring-1q0rjo, 20px)";
var $17a6dd8285442c36$export$8bc7996a7815312b = "var(--border-radius-tiles-60y8e6, 8px)";
var $17a6dd8285442c36$export$1bbac3b61fc38ae7 = "var(--border-radius-token-923jqq, 8px)";
var $17a6dd8285442c36$export$4d5854d57d002eda = "var(--border-radius-tutorial-panel-item-b44p0a, 8px)";
var $17a6dd8285442c36$export$eae4af9286e447e4 = "var(--border-table-sticky-width-87kf12, 1px)";
var $17a6dd8285442c36$export$b676aea5f4dfd626 = "var(--border-link-focus-ring-outline-kkfop6, 0)";
var $17a6dd8285442c36$export$f709f75889a62293 = "var(--border-link-focus-ring-shadow-spread-v8hkrl, 2px)";
var $17a6dd8285442c36$export$90f113ab45c40d26 = "var(--motion-duration-extra-fast-3huyux, 45ms)";
var $17a6dd8285442c36$export$c53bdc46c518ce23 = "var(--motion-duration-extra-slow-ngjb9g, 270ms)";
var $17a6dd8285442c36$export$b194457277388a75 = "var(--motion-duration-fast-sbm3r7, 90ms)";
var $17a6dd8285442c36$export$8248960b4daa03ef = "var(--motion-duration-moderate-5k1phv, 135ms)";
var $17a6dd8285442c36$export$13c749b0e529d502 = "var(--motion-duration-refresh-only-ambient-hnjwnd, 2000ms)";
var $17a6dd8285442c36$export$fb284f102e23f210 = "var(--motion-duration-refresh-only-fast-4jn2d7, 115ms)";
var $17a6dd8285442c36$export$b79895462792a7d = "var(--motion-duration-refresh-only-medium-nf6485, 165ms)";
var $17a6dd8285442c36$export$7c2d105804d5f376 = "var(--motion-duration-refresh-only-slow-zbvbxt, 250ms)";
var $17a6dd8285442c36$export$9152560867a17034 = "var(--motion-duration-avatar-gen-ai-gradient-xetl2o, 3600ms)";
var $17a6dd8285442c36$export$8a39eae61e1a77dc = "var(--motion-duration-avatar-loading-dots-pe8a3q, 1200ms)";
var $17a6dd8285442c36$export$7780a7af350c4e0e = "var(--motion-duration-rotate-180-dpvl4m, 135ms)";
var $17a6dd8285442c36$export$733fae6fd0e54b99 = "var(--motion-duration-rotate-90-4ry26y, 135ms)";
var $17a6dd8285442c36$export$2f0f38baa3369786 = "var(--motion-duration-show-paced-q2lo2h, 180ms)";
var $17a6dd8285442c36$export$9210a1855b2e6614 = "var(--motion-duration-show-quick-aq3ump, 135ms)";
var $17a6dd8285442c36$export$7f72f8e57fea3727 = "var(--motion-duration-slow-z2kaah, 180ms)";
var $17a6dd8285442c36$export$f9d740b165e1915c = "var(--motion-duration-transition-quick-6npj01, 90ms)";
var $17a6dd8285442c36$export$761a964467a31f8e = "var(--motion-duration-transition-show-paced-9s9l5z, 180ms)";
var $17a6dd8285442c36$export$7ae9f4804b80bb45 = "var(--motion-duration-transition-show-quick-osg026, 90ms)";
var $17a6dd8285442c36$export$6039388d85198df4 = "var(--motion-easing-ease-out-quart-rrej5m, cubic-bezier(0.165, 0.84, 0.44, 1))";
var $17a6dd8285442c36$export$8ac551728ae781f3 = "var(--motion-easing-refresh-only-a-8flf9q, cubic-bezier(0, 0, 0, 1))";
var $17a6dd8285442c36$export$db463fd1dbae14e = "var(--motion-easing-refresh-only-b-ufhmjm, cubic-bezier(1, 0, 0.83, 1))";
var $17a6dd8285442c36$export$a18224124e18d33c = "var(--motion-easing-refresh-only-c-vg1m9h, cubic-bezier(0.84, 0, 0.16, 1))";
var $17a6dd8285442c36$export$6c97e2d04d00ba3c = "var(--motion-easing-refresh-only-d-3kjugn, cubic-bezier(0.33, 0, 0.67, 1))";
var $17a6dd8285442c36$export$b34c36cd9a8ca9a0 = "var(--motion-easing-avatar-gen-ai-gradient-tjyrpp, cubic-bezier(0.7, 0, 0.3, 1))";
var $17a6dd8285442c36$export$3a3d6668700e9350 = "var(--motion-easing-rotate-180-e270ko, cubic-bezier(0.165, 0.84, 0.44, 1))";
var $17a6dd8285442c36$export$3080d41267244626 = "var(--motion-easing-rotate-90-sb4dk7, cubic-bezier(0.165, 0.84, 0.44, 1))";
var $17a6dd8285442c36$export$5fa8477512f355b8 = "var(--motion-easing-show-paced-ne2o0s, ease-out)";
var $17a6dd8285442c36$export$7253578fe3cd30ce = "var(--motion-easing-show-quick-vc5zgd, ease-out)";
var $17a6dd8285442c36$export$4b21a4ae15d6b590 = "var(--motion-easing-transition-quick-l9jfsx, linear)";
var $17a6dd8285442c36$export$ae5affb845de4c95 = "var(--motion-easing-transition-show-paced-eobwvi, ease-out)";
var $17a6dd8285442c36$export$c4796655c1feb618 = "var(--motion-easing-transition-show-quick-urd1sm, linear)";
var $17a6dd8285442c36$export$3272749b8942e8ae = "var(--motion-easing-responsive-vbn2t8, cubic-bezier(0, 0, 0, 1))";
var $17a6dd8285442c36$export$9224677e2fccea55 = "var(--motion-easing-sticky-56u8cd, cubic-bezier(1, 0, 0.83, 1))";
var $17a6dd8285442c36$export$5e3e9ef096fde57f = "var(--motion-easing-expressive-jz8pes, cubic-bezier(0.84, 0, 0.16, 1))";
var $17a6dd8285442c36$export$aafbf48949c0f053 = "var(--motion-duration-responsive-67fgfp, 115ms)";
var $17a6dd8285442c36$export$84ea3327d390cf38 = "var(--motion-duration-expressive-0by09d, 165ms)";
var $17a6dd8285442c36$export$bde394b5d5d9b56c = "var(--motion-duration-complex-vy4sma, 250ms)";
var $17a6dd8285442c36$export$3a3408fdb1e29b3b = "var(--motion-keyframes-fade-in-gpabjb, awsui-fade-in-35003c)";
var $17a6dd8285442c36$export$8699c08b470406ee = "var(--motion-keyframes-fade-out-kva0ei, awsui-fade-out-35003c)";
var $17a6dd8285442c36$export$b9d46f4676b7d1c = "var(--motion-keyframes-status-icon-error-ldv006, awsui-status-icon-error-35003c)";
var $17a6dd8285442c36$export$545dc454e500e431 = "var(--motion-keyframes-scale-popup-d42fd1, awsui-scale-popup-35003c)";
var $17a6dd8285442c36$export$13e718164e7a069a = "var(--size-calendar-grid-width-lrunz7, 238px)";
var $17a6dd8285442c36$export$6095f90852178a3d = "var(--size-control-28i7hr, 16px)";
var $17a6dd8285442c36$export$23fa4976b85f2056 = "var(--size-icon-big-zkdryd, 32px)";
var $17a6dd8285442c36$export$d04b8b9f637b72ff = "var(--size-icon-large-bivhmh, 48px)";
var $17a6dd8285442c36$export$3bdd084b4bcfa640 = "var(--size-icon-medium-y9xuoq, 20px)";
var $17a6dd8285442c36$export$d69d712f9e825571 = "var(--size-icon-normal-0m1722, 16px)";
var $17a6dd8285442c36$export$fc160442471465b9 = "var(--size-table-selection-horizontal-oqvl1b, 40px)";
var $17a6dd8285442c36$export$e8026a7b8005ab0f = "var(--size-vertical-input-v5iwwf, 32px)";
var $17a6dd8285442c36$export$c8014675e924201b = "var(--size-vertical-panel-icon-offset-wy8j08, 15px)";
var $17a6dd8285442c36$export$8caf7f29e9746daa = "var(--space-alert-action-left-ea9czk, 12px)";
var $17a6dd8285442c36$export$114e3f7518b96412 = "var(--space-alert-horizontal-eyt1xx, 16px)";
var $17a6dd8285442c36$export$765c1a481904b843 = "var(--space-alert-message-right-knlb6u, 4px)";
var $17a6dd8285442c36$export$555392da743e7396 = "var(--space-alert-vertical-l6cc71, 8px)";
var $17a6dd8285442c36$export$358b02745b4237f4 = "var(--space-button-focus-outline-gutter-cqfd0c, 4px)";
var $17a6dd8285442c36$export$c6e0e857492b34a1 = "var(--space-button-horizontal-8jxzea, 20px)";
var $17a6dd8285442c36$export$cc526c0c1526fabd = "var(--space-button-icon-focus-outline-gutter-vertical-zgqy8m, 0px)";
var $17a6dd8285442c36$export$c55e243d1528a8aa = "var(--space-button-icon-only-horizontal-zsf2nw, 6px)";
var $17a6dd8285442c36$export$f30fb22b2a0ea0fb = "var(--space-button-inline-icon-focus-outline-gutter-vk4r2v, 0px)";
var $17a6dd8285442c36$export$7d0c4752ccfb7c0a = "var(--space-button-modal-dismiss-vertical-0n4y5m, 2px)";
var $17a6dd8285442c36$export$c5a3f263971e4328 = "var(--space-calendar-grid-focus-outline-gutter-g00bgj, -5px)";
var $17a6dd8285442c36$export$b9ba69ae8f61b35e = "var(--space-calendar-grid-selected-focus-outline-gutter-hxbct6, -5px)";
var $17a6dd8285442c36$export$60e20fd0235c1eb0 = "var(--space-calendar-grid-gutter-2jsrps, 6px)";
var $17a6dd8285442c36$export$cbd6ab7cbe6ae4d6 = "var(--space-card-horizontal-tuwbbd, 20px)";
var $17a6dd8285442c36$export$3f58f5d9a17104fa = "var(--space-card-vertical-m591he, 16px)";
var $17a6dd8285442c36$export$1df636762f9ea9d7 = "var(--space-code-editor-status-focus-outline-gutter-dqxswe, -7px)";
var $17a6dd8285442c36$export$621ac375178a4ee2 = "var(--space-container-content-top-1ae0r3, 4px)";
var $17a6dd8285442c36$export$8b8ab07c79f75307 = "var(--space-container-header-top-5qav00, 12px)";
var $17a6dd8285442c36$export$3ec430ae25cd3010 = "var(--space-container-header-bottom-vj01hn, 8px)";
var $17a6dd8285442c36$export$c98bf9221ed3cbcf = "var(--space-container-horizontal-wfukh3, 20px)";
var $17a6dd8285442c36$export$77d777204ec7c3e0 = "var(--space-content-header-padding-bottom-y2enua, 16px)";
var $17a6dd8285442c36$export$9074ad80b2b98886 = "var(--space-dark-header-overlap-distance-lxpp0s, 36px)";
var $17a6dd8285442c36$export$26a90042aea6bee3 = "var(--space-expandable-section-icon-offset-top-ekk5vc, 4px)";
var $17a6dd8285442c36$export$b1d68397db4b962b = "var(--space-field-horizontal-gg19kw, 12px)";
var $17a6dd8285442c36$export$dabd99aa1c88a1f2 = "var(--space-field-icon-offset-csk9vw, 36px)";
var $17a6dd8285442c36$export$58060bd8e9494153 = "var(--space-filtering-token-dismiss-button-focus-outline-gutter-76gsim, -5px)";
var $17a6dd8285442c36$export$97fe88d007d6d032 = "var(--space-filtering-token-operation-select-focus-outline-gutter-0ailok, -5px)";
var $17a6dd8285442c36$export$6270ed8509018f35 = "var(--space-flashbar-action-left-qkhz5m, 12px)";
var $17a6dd8285442c36$export$b4401cfb5ae161f6 = "var(--space-flashbar-dismiss-right-tcpfax, 0px)";
var $17a6dd8285442c36$export$48379331462cb7b7 = "var(--space-flashbar-horizontal-xmjla3, 16px)";
var $17a6dd8285442c36$export$cf5f99ac262e6d42 = "var(--space-grid-gutter-ieqn7e, 20px)";
var $17a6dd8285442c36$export$3875e03ade049d4c = "var(--space-key-value-gap-0517k5, 0px)";
var $17a6dd8285442c36$export$37e7ffb8e4b64c96 = "var(--space-layout-content-bottom-noqzmw, 40px)";
var $17a6dd8285442c36$export$36a9b22e1cfcaf2e = "var(--space-layout-content-horizontal-7l52k3, 24px)";
var $17a6dd8285442c36$export$3c52453e523fed6e = "var(--space-layout-toggle-diameter-hb85rk, 36px)";
var $17a6dd8285442c36$export$42dd034b87086400 = "var(--space-layout-toggle-padding-lcu6qi, 12px)";
var $17a6dd8285442c36$export$88a492a594185c11 = "var(--space-modal-content-bottom-hqahub, 16px)";
var $17a6dd8285442c36$export$8094d629742a169c = "var(--space-modal-horizontal-f89syl, 20px)";
var $17a6dd8285442c36$export$12dfbdb966213dd = "var(--space-option-icon-big-top-hybljv, 0px)";
var $17a6dd8285442c36$export$e1367fa4dc864245 = "var(--space-panel-content-bottom-7k6er3, 40px)";
var $17a6dd8285442c36$export$d4713302d7c26e6b = "var(--space-panel-content-top-wac3yp, 20px)";
var $17a6dd8285442c36$export$c0afa28f51a226ec = "var(--space-panel-divider-margin-horizontal-sbik1z, 8px)";
var $17a6dd8285442c36$export$8908b689c362bccd = "var(--space-panel-header-vertical-gv9pti, 20px)";
var $17a6dd8285442c36$export$c92939981b1f1050 = "var(--space-panel-nav-left-b1g0mt, 28px)";
var $17a6dd8285442c36$export$584f6b4cb681baaf = "var(--space-panel-side-left-5t0who, 28px)";
var $17a6dd8285442c36$export$4fd59b8d0b4e83e = "var(--space-panel-side-right-xofg51, 24px)";
var $17a6dd8285442c36$export$101d157c05609dd2 = "var(--space-panel-split-top-q1pux4, 20px)";
var $17a6dd8285442c36$export$e6fcc00599618311 = "var(--space-panel-split-bottom-qwdduf, 20px)";
var $17a6dd8285442c36$export$bf95ce2b0aa5e6b8 = "var(--space-segmented-control-focus-outline-gutter-gbye20, 4px)";
var $17a6dd8285442c36$export$8e46cb5ff7790e7 = "var(--space-tabs-content-top-dedu0k, 12px)";
var $17a6dd8285442c36$export$88c0b22bb51273e5 = "var(--space-tabs-focus-outline-gutter-xm37ly, -8px)";
var $17a6dd8285442c36$export$219b36a1d1f10241 = "var(--space-table-content-bottom-9yr834, 4px)";
var $17a6dd8285442c36$export$5ebf2bf42680f3a6 = "var(--space-table-embedded-header-top-bfjeam, 0px)";
var $17a6dd8285442c36$export$981faddf39ea8f3 = "var(--space-table-footer-horizontal-ptapb9, 0px)";
var $17a6dd8285442c36$export$108d9c4210ddc555 = "var(--space-table-header-focus-outline-gutter-7js4en, 0px)";
var $17a6dd8285442c36$export$ac872ce2d2ad6167 = "var(--space-table-header-horizontal-wl3ykr, 0px)";
var $17a6dd8285442c36$export$8a53ff70d0c3ab23 = "var(--space-table-header-tools-bottom-25ubsj, 0px)";
var $17a6dd8285442c36$export$b7e9cde6d5f652fa = "var(--space-table-header-tools-full-page-bottom-xulfq9, 4px)";
var $17a6dd8285442c36$export$ec8a6ce7fae01cc3 = "var(--space-table-horizontal-8davlm, 20px)";
var $17a6dd8285442c36$export$1d72b68ed36d0565 = "var(--space-scaled-2x-none-8i5al4, 0px)";
var $17a6dd8285442c36$export$8c49418839301222 = "var(--space-scaled-2x-xxxs-fp07j9, 2px)";
var $17a6dd8285442c36$export$9d8d727fe595d20b = "var(--space-scaled-2x-xxs-7v8ivz, 4px)";
var $17a6dd8285442c36$export$b06c1318950ec513 = "var(--space-scaled-2x-xs-cijznx, 8px)";
var $17a6dd8285442c36$export$910646e1df5f63cb = "var(--space-scaled-2x-s-owsac7, 12px)";
var $17a6dd8285442c36$export$eb3b309217380584 = "var(--space-scaled-2x-m-owtj1o, 16px)";
var $17a6dd8285442c36$export$ab735f4edff2823c = "var(--space-scaled-2x-l-ujnz41, 20px)";
var $17a6dd8285442c36$export$2f7ce83aac952c4f = "var(--space-scaled-2x-xl-udij7m, 24px)";
var $17a6dd8285442c36$export$73095c83cff228f1 = "var(--space-scaled-2x-xxl-ts4prk, 32px)";
var $17a6dd8285442c36$export$10ac8e9e5f1cd8bd = "var(--space-scaled-2x-xxxl-eqb3m6, 40px)";
var $17a6dd8285442c36$export$8c1a206b8e2cd2b0 = "var(--space-scaled-none-vhzhxe, 0px)";
var $17a6dd8285442c36$export$8d806ce0c65dbdd9 = "var(--space-scaled-xxxs-27y4hv, 2px)";
var $17a6dd8285442c36$export$5da13f39cac5ae10 = "var(--space-scaled-xxs-7597g1, 4px)";
var $17a6dd8285442c36$export$76d2c885680712dd = "var(--space-scaled-xs-26e2du, 8px)";
var $17a6dd8285442c36$export$3af9271f55a32e1a = "var(--space-scaled-s-aqzyko, 12px)";
var $17a6dd8285442c36$export$fafa295c751d307c = "var(--space-scaled-m-mo5yse, 16px)";
var $17a6dd8285442c36$export$5f54ec147ef18962 = "var(--space-scaled-l-0hpmd7, 20px)";
var $17a6dd8285442c36$export$7c6da9d513d46a3b = "var(--space-scaled-xl-kswcw7, 24px)";
var $17a6dd8285442c36$export$2a66e8119d8ca862 = "var(--space-scaled-xxl-wbot5q, 32px)";
var $17a6dd8285442c36$export$e3665984e119e598 = "var(--space-scaled-xxxl-fdg8ai, 40px)";
var $17a6dd8285442c36$export$b50e0e5009ac1ea = "var(--space-static-xxxs-3gu9os, 2px)";
var $17a6dd8285442c36$export$555e78b2d9228651 = "var(--space-static-xxs-82cdfi, 4px)";
var $17a6dd8285442c36$export$974c039c1f9f4a58 = "var(--space-static-xs-7sfb63, 8px)";
var $17a6dd8285442c36$export$10f5b0fba44658b8 = "var(--space-static-s-n2eb28, 12px)";
var $17a6dd8285442c36$export$4adbb95e68b43364 = "var(--space-static-m-lrhgl2, 16px)";
var $17a6dd8285442c36$export$a8c78948aabff143 = "var(--space-static-l-0xsx8r, 20px)";
var $17a6dd8285442c36$export$acce525ed75272e2 = "var(--space-static-xl-qalw6z, 24px)";
var $17a6dd8285442c36$export$3306f40812e234ae = "var(--space-static-xxl-02zgl2, 32px)";
var $17a6dd8285442c36$export$294dff5030234a12 = "var(--space-static-xxxl-qj5g91, 40px)";
var $17a6dd8285442c36$export$246544137bdbab = "var(--space-none-zrljql, 0px)";
var $17a6dd8285442c36$export$82f2c4c06e9eaf08 = "var(--space-xxxs-zbmxqb, 2px)";
var $17a6dd8285442c36$export$8153dca95b50fd18 = "var(--space-xxs-p8yyaw, 4px)";
var $17a6dd8285442c36$export$a60788ae5e849781 = "var(--space-xs-zb16t3, 8px)";
var $17a6dd8285442c36$export$c491c1b55afe1022 = "var(--space-s-34lx8l, 12px)";
var $17a6dd8285442c36$export$4491a3f8ef608cd8 = "var(--space-m-udix3p, 16px)";
var $17a6dd8285442c36$export$c24c82b22872b30a = "var(--space-l-t419sm, 20px)";
var $17a6dd8285442c36$export$58c2f5ffaa69b3d9 = "var(--space-xl-lmui9r, 24px)";
var $17a6dd8285442c36$export$9a48af44bea2a2d8 = "var(--space-xxl-cu2m1r, 32px)";
var $17a6dd8285442c36$export$232473c916f8d19c = "var(--space-xxxl-4x2gki, 40px)";
var $17a6dd8285442c36$export$9aac36b601df0b58 = "var(--shadow-container-fxmdn3, 0px 0px 1px 1px #e9ebed, 0px 1px 8px 2px rgba(0, 7, 22, 0.12))";
var $17a6dd8285442c36$export$dfef42a21bd78a1b = "var(--shadow-container-stacked-4gw245, -1px 1px 1px 0px #e9ebed, 1px 1px 1px 0px #e9ebed, 0px 9px 8px -7px rgb(0 7 22 / 12%), 8px 0px 8px -7px rgb(0 7 22 / 12%), -8px 0px 8px -7px rgb(0 7 22 / 12%))";
var $17a6dd8285442c36$export$8c87d891ebc198e = "var(--shadow-container-active-kl29x9, 0px 1px 1px 1px #e9ebed, 0px 6px 36px #0007161a)";
var $17a6dd8285442c36$export$6fcd3ad9fd10d9ab = "var(--shadow-dropdown-e5guvm, 0px 4px 20px 1px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$560134d5bcf74749 = "var(--shadow-dropup-xqkiza, 0px 4px 20px 1px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$afe074a2ceafee28 = "var(--shadow-flash-collapsed-s7gipk, 0px 4px 4px rgba(0, 0, 0, 0.25))";
var $17a6dd8285442c36$export$3116eac1bcb7e0a2 = "var(--shadow-flash-sticky-pq8cuq, 0px 4px 8px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$1067ab98941c6613 = "var(--shadow-modal-2ennni, 0px 4px 20px 1px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$c8e4d733a7a682ea = "var(--shadow-panel-g6fkp1, 0px 0px 0px 1px #b6bec9)";
var $17a6dd8285442c36$export$cd151389984aa898 = "var(--shadow-panel-toggle-0l64f2, 0px 6px 12px 1px rgba(0, 7, 22, 0.12))";
var $17a6dd8285442c36$export$1c6a2e702215849a = "var(--shadow-popover-8zls8c, 0px 4px 20px 1px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$9ea96948d635fa85 = "var(--shadow-split-bottom-5e389u, 0px -36px 36px -36px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$8894fc2c6a098f7 = "var(--shadow-split-side-ggdtnk, -1px 0px 1px 0px #e9ebed, -36px 6px 36px -36px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$508ae22026e4a8ec = "var(--shadow-sticky-blixp9, 0px 4px 8px 1px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$ecaf9a88594aea82 = "var(--shadow-sticky-embedded-uvh5ry, 0px 2px 0px 0px #e9ebed, 0px 16px 16px -12px rgba(0, 7, 22, 0.10))";
var $17a6dd8285442c36$export$7f330c5d92588e86 = "var(--shadow-sticky-column-first-039dqs, 4px 0px 8px 1px rgba(0, 7, 22, 0.1))";
var $17a6dd8285442c36$export$694e992736d5d212 = "var(--shadow-sticky-column-last-n170vw, -4px 0 8px 1px rgba(0, 28, 36, 0.1))";


function $face838852c85adc$export$2e2bcd8739ae039() {
    const { content: content, disableBodyScroll: disableBodyScroll, disableContentPaddings: disableContentPaddings, footerHeight: footerHeight, hasDrawerViewportOverlay: hasDrawerViewportOverlay, navigationOpen: navigationOpen, placement: placement, isMobile: isMobile, isSplitPanelOpen: isSplitPanelOpen, isToolsOpen: isToolsOpen, mainElement: mainElement, notificationsHeight: notificationsHeight, stickyNotifications: stickyNotifications, offsetBottom: offsetBottom, splitPanelDisplayed: splitPanelDisplayed, splitPanelPosition: splitPanelPosition, activeDrawerId: activeDrawerId } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const splitPanelHeight = offsetBottom - footerHeight;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).container, (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)[`split-panel-position-${splitPanelPosition !== null && splitPanelPosition !== void 0 ? splitPanelPosition : "bottom"}`], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["disable-content-paddings"]]: disableContentPaddings,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-split-panel"]]: splitPanelDisplayed,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["is-navigation-open"]]: navigationOpen,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["is-tools-open"]]: isToolsOpen,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-active-drawer"]]: !!activeDrawerId,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["is-split-panel-open"]]: isSplitPanelOpen,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: hasDrawerViewportOverlay
        }, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).content),
        ref: mainElement,
        style: Object.assign({
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).splitPanelHeight]: `${splitPanelHeight}px`
        }, (0, $218e10bc7e8580c0$export$7f13b984303df6e1)(placement.insetBlockStart, offsetBottom, stickyNotifications && notificationsHeight > 0 ? `${$17a6dd8285442c36$export$a60788ae5e849781} + ${notificationsHeight}px` : "0px", `var(${(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).mobileBarHeight})`, !!disableBodyScroll, isMobile))
    }, content);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







function $a4506ba612c715bc$export$2e2bcd8739ae039() {
    var _a, _b, _c;
    const { ariaLabels: ariaLabels, breadcrumbs: breadcrumbs, drawers: drawers, handleNavigationClick: handleNavigationClick, handleToolsClick: handleToolsClick, hasDrawerViewportOverlay: hasDrawerViewportOverlay, isMobile: isMobile, navigationOpen: navigationOpen, __embeddedViewMode: __embeddedViewMode, isToolsOpen: isToolsOpen, navigationHide: navigationHide, navigationRefs: navigationRefs, toolsHide: toolsHide, toolsRefs: toolsRefs, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (!isMobile || __embeddedViewMode || navigationHide && !breadcrumbs && toolsHide && (!drawers || drawers.length === 0)) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["mobile-toolbar"], [
            (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["mobile-bar"]
        ], {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-breadcrumbs"]]: breadcrumbs,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: hasDrawerViewportOverlay,
            [(0, $9c98cc94ae829c40$export$ebd33a9e3a891abd)]: headerVariant === "high-contrast"
        }, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["mobile-bar"], headerVariant !== "high-contrast" && (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["remove-high-contrast-header"])
    }, !navigationHide && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        "aria-hidden": navigationOpen,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["mobile-toolbar-nav"], {
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawer-closed"]]: !navigationOpen
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ariaLabel: (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigationToggle) !== null && _a !== void 0 ? _a : undefined,
        ariaExpanded: navigationOpen ? undefined : false,
        iconName: "menu",
        formAction: "none",
        onClick: ()=>handleNavigationClick(true),
        variant: "icon",
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["navigation-toggle"],
        ref: navigationRefs.toggle,
        disabled: hasDrawerViewportOverlay,
        __nativeAttributes: {
            "aria-haspopup": navigationOpen ? undefined : true
        }
    })), breadcrumbs && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["mobile-toolbar-breadcrumbs"], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).breadcrumbs)
    }, breadcrumbs), drawers ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $80840cb1e803926f$export$3327f5ebc2d6865), null) : !toolsHide && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        "aria-hidden": isToolsOpen,
        "aria-label": (_b = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools) !== null && _b !== void 0 ? _b : undefined,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["mobile-toolbar-tools"], {
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawer-closed"]]: !isToolsOpen
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-toggle"],
        ariaExpanded: isToolsOpen,
        disabled: hasDrawerViewportOverlay,
        ariaLabel: (_c = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsToggle) !== null && _c !== void 0 ? _c : undefined,
        iconName: "status-info",
        formAction: "none",
        onClick: ()=>handleToolsClick(true),
        variant: "icon",
        ref: toolsRefs.toggle,
        __nativeAttributes: {
            "aria-haspopup": true
        }
    })));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");









function $949807764b15a199$export$2e2bcd8739ae039() {
    const { ariaLabels: ariaLabels, disableBodyScroll: disableBodyScroll, handleNavigationClick: handleNavigationClick, hasDrawerViewportOverlay: hasDrawerViewportOverlay, isMobile: isMobile, navigationOpen: navigationOpen, isToolsOpen: isToolsOpen, navigation: navigation, navigationHide: navigationHide, navigationRefs: navigationRefs, navigationWidth: navigationWidth, toolsHide: toolsHide, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (navigationHide) return null;
    // Close the Navigation drawer on mobile when a user clicks a link inside.
    const onNavigationClick = (event)=>{
        const hasLink = (0, $38f6480185c49d6f$export$184ef262a758e3c4)(event.target, (node)=>node.tagName === "A" && !!node.href);
        if (hasLink && isMobile) handleNavigationClick(false);
    };
    const isUnfocusable = hasDrawerViewportOverlay && (!navigationOpen || isToolsOpen && !toolsHide);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
        in: navigationOpen
    }, (state, transitionEventsRef)=>{
        var _a, _b, _c;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["navigation-container"], {
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["disable-body-scroll"]]: disableBodyScroll,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: isUnfocusable,
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawer-closed"]]: !navigationOpen
            }),
            style: {
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).navigationWidth]: `${navigationWidth}px`
            }
        }, !isMobile && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
            "aria-hidden": isMobile || navigationOpen,
            "aria-label": (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigation) !== null && _a !== void 0 ? _a : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["show-navigation"], {
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).animating]: state === "exiting",
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["is-navigation-open"]]: navigationOpen
            }),
            ref: state === "exiting" ? transitionEventsRef : undefined
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a3757dc95ec4d39$export$2e2bcd8739ae039), {
            ariaLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigationToggle,
            ariaExpanded: navigationOpen ? undefined : false,
            iconName: "menu",
            className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["navigation-toggle"],
            onClick: ()=>handleNavigationClick(true),
            ref: navigationRefs.toggle,
            highContrastHeader: headerVariant === "high-contrast"
        })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
            "aria-label": (_b = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigation) !== null && _b !== void 0 ? _b : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).navigation, {
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).animating]: state === "entering",
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["is-navigation-open"]]: navigationOpen
            }, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).navigation),
            ref: state !== "exiting" ? transitionEventsRef : undefined,
            "aria-hidden": !navigationOpen,
            onClick: (event)=>{
                onNavigationClick && onNavigationClick(event);
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["animated-content"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["hide-navigation"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            ariaLabel: (_c = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigationClose) !== null && _c !== void 0 ? _c : undefined,
            iconName: isMobile ? "close" : "angle-left",
            onClick: ()=>handleNavigationClick(false),
            variant: "icon",
            formAction: "none",
            className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["navigation-close"],
            ref: navigationRefs.close
        })), navigation)));
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






function $af1f8915f0887b4c$export$2e2bcd8739ae039() {
    const { notifications: notifications } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    if (!notifications) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($af1f8915f0887b4c$var$NotificationsImplementation, null);
}
function $af1f8915f0887b4c$var$NotificationsImplementation() {
    var _a;
    const { ariaLabels: ariaLabels, hasDrawerViewportOverlay: hasDrawerViewportOverlay, notifications: notifications, setNotificationsHeight: setNotificationsHeight, stickyNotifications: stickyNotifications, headerVariant: headerVariant, hasNotificationsContent: hasNotificationsContent } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const ref = (0, $acw62.useRef)(null);
    (0, $444535e54951fdea$export$683480f191c0e3ea)(ref, (entry)=>setNotificationsHeight(entry.contentBoxHeight));
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            setNotificationsHeight(0);
        };
    // unmount effect only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
     * The notificationsElement ref is assigned to an inner div to prevent internal bottom margin
     * from affecting the calculated height, which is used for sticky elements below.
     */ return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "region",
        "aria-label": (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.notifications) !== null && _a !== void 0 ? _a : undefined,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).notifications, {
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["sticky-notifications"]]: stickyNotifications,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-notification-content"]]: hasNotificationsContent,
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: hasDrawerViewportOverlay,
            [(0, $9c98cc94ae829c40$export$ebd33a9e3a891abd)]: headerVariant === "high-contrast",
            [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["high-contrast"]]: headerVariant === "high-contrast"
        }, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).notifications)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref
    }, notifications));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");









function $139860afa4ff28b8$export$2e2bcd8739ae039({ children: children }) {
    const { ariaLabels: ariaLabels, disableBodyScroll: disableBodyScroll, drawers: drawers, handleSplitPanelClick: handleSplitPanelClick, handleToolsClick: handleToolsClick, hasDrawerViewportOverlay: hasDrawerViewportOverlay, isMobile: isMobile, isSplitPanelOpen: isSplitPanelOpen, isToolsOpen: isToolsOpen, loseToolsFocus: loseToolsFocus, splitPanel: splitPanel, splitPanelControlId: splitPanelControlId, splitPanelDisplayed: splitPanelDisplayed, splitPanelPosition: splitPanelPosition, splitPanelRefs: splitPanelRefs, splitPanelToggle: splitPanelToggle, tools: tools, toolsControlId: toolsControlId, toolsHide: toolsHide, toolsRefs: toolsRefs, toolsWidth: toolsWidth, headerVariant: headerVariant } = (0, $6e9ace527e915055$export$8790094283eeada6)();
    const hasSplitPanel = !!splitPanel && splitPanelPosition === "side";
    const hasToolsForm = $139860afa4ff28b8$var$getToolsFormStatus(hasSplitPanel && splitPanelDisplayed, isMobile, isSplitPanelOpen, isToolsOpen, toolsHide);
    const hasToolsFormPersistence = $139860afa4ff28b8$var$getToolsFormPersistence(hasSplitPanel, isSplitPanelOpen, isToolsOpen, toolsHide);
    const isUnfocusable = hasDrawerViewportOverlay && !isToolsOpen;
    /**
     * If the drawers property is defined the SplitPanel will be mounted and rendered
     * by the Drawers component.
     */ if (toolsHide && !hasSplitPanel || drawers) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
        in: isToolsOpen !== null && isToolsOpen !== void 0 ? isToolsOpen : false
    }, (state, transitionEventsRef)=>{
        var _a, _b, _c;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["tools-container"], {
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["disable-body-scroll"]]: disableBodyScroll,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).unfocusable]: isUnfocusable,
                [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawer-closed"]]: !isToolsOpen
            }),
            style: {
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).toolsAnimationStartingOpacity]: `${hasSplitPanel && isSplitPanelOpen ? 1 : 0}`,
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).toolsWidth]: `${toolsWidth}px`
            },
            onBlur: (e)=>{
                if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) loseToolsFocus();
            }
        }, children, !toolsHide && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
            id: toolsControlId,
            "aria-hidden": !isToolsOpen ? true : false,
            "aria-label": (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools) !== null && _a !== void 0 ? _a : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039).tools, {
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).animating]: state === "entering",
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-tools-form-persistence"]]: hasToolsFormPersistence,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["is-tools-open"]]: isToolsOpen
            }, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).tools),
            ref: state !== "exiting" ? transitionEventsRef : undefined
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["animated-content"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["hide-tools"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            ariaLabel: (_b = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsClose) !== null && _b !== void 0 ? _b : undefined,
            iconName: isMobile ? "close" : "angle-right",
            onClick: ()=>handleToolsClick(false),
            variant: "icon",
            formAction: "none",
            className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-close"],
            ref: toolsRefs.close
        })), tools)), !isMobile && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
            "aria-hidden": !hasToolsForm ? true : false,
            "aria-label": (_c = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools) !== null && _c !== void 0 ? _c : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["show-tools"], {
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039).animating]: state === "exiting",
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-tools-form"]]: hasToolsForm,
                [(0, $7419c94a5186c7f4$export$2e2bcd8739ae039)["has-tools-form-persistence"]]: hasToolsFormPersistence
            }),
            ref: state === "exiting" ? transitionEventsRef : undefined,
            "data-testid": "side-split-panel-drawer"
        }, !toolsHide && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a3757dc95ec4d39$export$2e2bcd8739ae039), {
            ariaLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsToggle,
            ariaControls: toolsControlId,
            ariaExpanded: isToolsOpen,
            iconName: "status-info",
            onClick: ()=>handleToolsClick(!isToolsOpen),
            selected: hasSplitPanel && isToolsOpen,
            className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-toggle"],
            ref: toolsRefs.toggle,
            highContrastHeader: headerVariant === "high-contrast"
        }), hasSplitPanel && splitPanelToggle.displayed && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a3757dc95ec4d39$export$2e2bcd8739ae039), {
            ariaLabel: splitPanelToggle.ariaLabel,
            ariaControls: splitPanelControlId,
            ariaExpanded: !!isSplitPanelOpen,
            iconName: "view-vertical",
            onClick: ()=>handleSplitPanelClick(),
            selected: hasSplitPanel && isSplitPanelOpen,
            className: (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)["open-button"],
            ref: splitPanelRefs.toggle,
            highContrastHeader: headerVariant === "high-contrast"
        })));
    });
}
/**
 * By default the Tools form is styled as display: none; This behavior should
 * be unchanged in mobile viewports where the Tools form is always suppressed.
 * In large viewports, however the Tools form and its corresponding buttons
 * should be present in the UI under the below circumstances.
 */ function $139860afa4ff28b8$var$getToolsFormStatus(hasSplitPanel, isMobile, isSplitPanelOpen, isToolsOpen, toolsHide) {
    let hasToolsForm = false;
    if (!isMobile) {
        // Both the Split Panel and Tools button are needed
        if (hasSplitPanel && !toolsHide) hasToolsForm = true;
        // The Split Panel button is needed
        if (hasSplitPanel && !isSplitPanelOpen && toolsHide) hasToolsForm = true;
        // The Tools button is needed
        if (!hasSplitPanel && !toolsHide && !isToolsOpen) hasToolsForm = true;
    }
    return hasToolsForm;
}
/**
 * Under two scenarios the Tools form that contains the triggers
 * for the Tools content and the Split Panel may be persistent
 * in the UI (as opposed to disappearing when one of the drawers
 * is open). This will also add a white background as opposed to the
 * default transparent background. The buttons will present and in a
 * selected / not selected state.
 */ function $139860afa4ff28b8$var$getToolsFormPersistence(hasSplitPanel, isSplitPanelOpen, isToolsOpen, toolsHide) {
    let hasToolsFormPersistence = false;
    // Both Tools and Split Panel exist and one or both is open
    if (hasSplitPanel && !toolsHide && (isSplitPanelOpen || isToolsOpen)) hasToolsFormPersistence = true;
    return hasToolsFormPersistence;
}


const $18dc6142312830db$var$AppLayoutWithRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function AppLayout(props, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6e9ace527e915055$export$56942bf202ca3905), Object.assign({}, props, {
        ref: ref
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eda04021d4548892$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $52c91a8fefd6ceb2$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e6b9304cc8ecd5f8$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $949807764b15a199$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a4506ba612c715bc$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $af1f8915f0887b4c$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $870116fec74b536c$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $267aa9df9137ec77$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $face838852c85adc$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eda04021d4548892$export$2e2bcd8739ae039).Bottom, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $139860afa4ff28b8$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eda04021d4548892$export$2e2bcd8739ae039).Side, null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $80840cb1e803926f$export$2e2bcd8739ae039), null))));
});
var $18dc6142312830db$export$2e2bcd8739ae039 = $18dc6142312830db$var$AppLayoutWithRef;




var $acw62 = parcelRequire("acw62");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $ff079cc12921495d$export$847d464b8c579b64({ navigationOpen: navigationOpen, navigationWidth: navigationWidth, placement: placement, minContentWidth: minContentWidth, activeDrawerSize: activeDrawerSize, splitPanelOpen: splitPanelOpen, splitPanelPosition: splitPanelPosition, splitPanelSize: splitPanelSize }) {
    const contentPadding = 48; // space-xl
    const activeNavigationWidth = navigationOpen ? navigationWidth : 0;
    const resizableSpaceAvailable = Math.max(0, placement.inlineSize - minContentWidth - contentPadding - activeNavigationWidth);
    const splitPanelForcedPosition = resizableSpaceAvailable - activeDrawerSize < (0, $346c1f4e54c7d4ae$export$c1bd455843613e23);
    const resolvedSplitPanelPosition = splitPanelForcedPosition ? "bottom" : splitPanelPosition !== null && splitPanelPosition !== void 0 ? splitPanelPosition : "bottom";
    const sideSplitPanelSize = resolvedSplitPanelPosition === "side" && splitPanelOpen ? splitPanelSize !== null && splitPanelSize !== void 0 ? splitPanelSize : 0 : 0;
    const maxSplitPanelSize = resizableSpaceAvailable - activeDrawerSize;
    const maxDrawerSize = resizableSpaceAvailable - sideSplitPanelSize;
    return {
        splitPanelPosition: resolvedSplitPanelPosition,
        splitPanelForcedPosition: splitPanelForcedPosition,
        sideSplitPanelSize: sideSplitPanelSize,
        maxSplitPanelSize: maxSplitPanelSize,
        maxDrawerSize: maxDrawerSize
    };
}
function $ff079cc12921495d$export$88f2788934d642c4({ topOffset: topOffset, hasToolbar: hasToolbar, toolbarHeight: toolbarHeight, stickyNotifications: stickyNotifications, notificationsHeight: notificationsHeight }) {
    const toolbar = topOffset;
    let notifications = topOffset;
    if (hasToolbar) notifications += toolbarHeight;
    let header = notifications;
    if (stickyNotifications) header += notificationsHeight;
    return {
        toolbar: toolbar,
        notifications: notifications,
        header: header
    };
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $89ac1508ddb88f9a$export$2e2bcd8739ae039 = {
    "root": "awsui_root_7nfqu_1qo46_101",
    "has-adaptive-widths-default": "awsui_has-adaptive-widths-default_7nfqu_1qo46_150",
    "has-adaptive-widths-dashboard": "awsui_has-adaptive-widths-dashboard_7nfqu_1qo46_165",
    "navigation": "awsui_navigation_7nfqu_1qo46_180",
    "tools": "awsui_tools_7nfqu_1qo46_181",
    "split-panel-side": "awsui_split-panel-side_7nfqu_1qo46_205",
    "split-panel-bottom": "awsui_split-panel-bottom_7nfqu_1qo46_211",
    "panel-hidden": "awsui_panel-hidden_7nfqu_1qo46_224",
    "toolbar-container": "awsui_toolbar-container_7nfqu_1qo46_228",
    "notifications-container": "awsui_notifications-container_7nfqu_1qo46_234",
    "main-landmark": "awsui_main-landmark_7nfqu_1qo46_241",
    "main": "awsui_main_7nfqu_1qo46_241",
    "main-disable-paddings": "awsui_main-disable-paddings_7nfqu_1qo46_250",
    "content-header": "awsui_content-header_7nfqu_1qo46_260",
    "content": "awsui_content_7nfqu_1qo46_260",
    "unfocusable-mobile": "awsui_unfocusable-mobile_7nfqu_1qo46_269"
};


const $032e239c9545babc$var$contentTypeCustomWidths = [
    "dashboard",
    "cards",
    "table"
];
function $032e239c9545babc$export$af3ba02ef74c9bdf({ style: style, notifications: notifications, contentHeader: contentHeader, content: content, navigation: navigation, navigationOpen: navigationOpen, navigationWidth: navigationWidth, tools: tools, toolsOpen: toolsOpen, toolsWidth: toolsWidth, toolbar: toolbar, sideSplitPanel: sideSplitPanel, bottomSplitPanel: bottomSplitPanel, splitPanelOpen: splitPanelOpen, placement: placement, contentType: contentType, maxContentWidth: maxContentWidth, disableContentPaddings: disableContentPaddings }) {
    const isMaxWidth = maxContentWidth === Number.MAX_VALUE || maxContentWidth === Number.MAX_SAFE_INTEGER;
    const anyPanelOpen = navigationOpen || toolsOpen;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).root, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).root, {
            [(0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["has-adaptive-widths-default"]]: !$032e239c9545babc$var$contentTypeCustomWidths.includes(contentType),
            [(0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["has-adaptive-widths-dashboard"]]: contentType === "dashboard"
        }),
        style: {
            minBlockSize: `calc(100vh - ${placement.insetBlockStart}px - ${placement.insetBlockEnd}px)`,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).maxContentWidth]: isMaxWidth ? "100%" : maxContentWidth ? `${maxContentWidth}px` : "",
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).navigationWidth]: `${navigationWidth}px`,
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).toolsWidth]: `${toolsWidth}px`
        }
    }, navigation && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).navigation, !navigationOpen && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["panel-hidden"], toolsOpen && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["unfocusable-mobile"])
    }, navigation), toolbar, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("main", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["main-landmark"], anyPanelOpen && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["unfocusable-mobile"])
    }, notifications, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).main, {
            [(0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["main-disable-paddings"]]: disableContentPaddings
        }),
        style: style
    }, contentHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["content-header"]
    }, contentHeader), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).content, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).content)
    }, content)), bottomSplitPanel && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["split-panel-bottom"], !splitPanelOpen && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["split-panel-hidden"]),
        style: {
            insetBlockEnd: placement.insetBlockEnd
        }
    }, bottomSplitPanel)), sideSplitPanel && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["split-panel-side"], !splitPanelOpen && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["panel-hidden"])
    }, sideSplitPanel), tools && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039).tools, !toolsOpen && (0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["panel-hidden"])
    }, tools));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $ed46c0bdd69f76cb$export$2e2bcd8739ae039 = {
    "drawer": "awsui_drawer_12i0j_c2clt_101",
    "drawer-content-container": "awsui_drawer-content-container_12i0j_c2clt_114",
    "drawer-close-button": "awsui_drawer-close-button_12i0j_c2clt_122",
    "drawer-content": "awsui_drawer-content_12i0j_c2clt_114",
    "drawer-content-hidden": "awsui_drawer-content-hidden_12i0j_c2clt_131",
    "drawer-slider": "awsui_drawer-slider_12i0j_c2clt_134"
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a1afd02c366f84c0$export$e586d5217e8bc2d3 = Symbol.for("awsui-global-flags");
const $a1afd02c366f84c0$export$104ac743431a5ed3 = ()=>{
    return window.top;
};
function $a1afd02c366f84c0$var$getGlobal() {
    return typeof window !== "undefined" ? window : globalThis;
}
function $a1afd02c366f84c0$var$readFlag(window1, flagName) {
    var _a;
    const holder = window1;
    return (_a = holder === null || holder === void 0 ? void 0 : holder[$a1afd02c366f84c0$export$e586d5217e8bc2d3]) === null || _a === void 0 ? void 0 : _a[flagName];
}
const $a1afd02c366f84c0$export$cdbb7c478433ee77 = (flagName)=>{
    try {
        const ownFlag = $a1afd02c366f84c0$var$readFlag($a1afd02c366f84c0$var$getGlobal(), flagName);
        if (ownFlag !== undefined) return ownFlag;
        return $a1afd02c366f84c0$var$readFlag($a1afd02c366f84c0$export$104ac743431a5ed3(), flagName);
    } catch (e) {
        return undefined;
    }
};



function $2b25eacde88e3edd$export$61fae46ccdc4563e(Implementation) {
    return (Loader)=>{
        return (props)=>{
            const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
            if (isRefresh && (0, $a1afd02c366f84c0$export$cdbb7c478433ee77)("appLayoutWidget") && Loader) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Loader, Object.assign({}, props));
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Implementation, Object.assign({}, props));
        };
    };
}
function $2b25eacde88e3edd$export$ade51c185567c090(Implementation) {
    return (Loader)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
            const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
            if (isRefresh && (0, $a1afd02c366f84c0$export$cdbb7c478433ee77)("appLayoutWidget") && Loader) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Loader, Object.assign({
                ref: ref
            }, props));
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Implementation, Object.assign({
                ref: ref
            }, props));
        });
    };
}





function $e7f76d3277b180ed$export$e8b771555dc4a003({ currentWidth: currentWidth, minWidth: minWidth, maxWidth: maxWidth, panelRef: panelRef, handleRef: handleRef, onResize: onResize }) {
    const onResizeHandler = (newWidth)=>{
        const size = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minWidth, newWidth, maxWidth);
        if (maxWidth >= minWidth) onResize(size);
    };
    const sizeControlProps = {
        position: "side",
        panelRef: panelRef,
        handleRef: handleRef,
        onResize: onResizeHandler
    };
    const clampedWidth = (0, $582c00c3ff10d4e2$export$2e85165fee4e4eeb)(minWidth, currentWidth, maxWidth);
    const relativeSize = (clampedWidth - minWidth) / (maxWidth - minWidth) * 100;
    const onPointerDown = (0, $0d7a0c5aa5b38dc9$export$69c48c1cbbd6dc69)(sizeControlProps);
    const onKeyDown = (0, $f3562f2817c11205$export$2ba6c1a0edf6483a)(sizeControlProps);
    return {
        onKeyDown: onKeyDown,
        onPointerDown: onPointerDown,
        relativeSize: relativeSize
    };
}


function $c2eafb2a8775c8fb$export$bf7efb8fc3f7ac58({ appLayoutInternals: appLayoutInternals }) {
    var _a, _b, _c, _d;
    const { activeDrawer: activeDrawer, minDrawerSize: minDrawerSize, activeDrawerSize: activeDrawerSize, maxDrawerSize: maxDrawerSize, ariaLabels: ariaLabels, drawers: drawers, drawersFocusControl: drawersFocusControl, isMobile: isMobile, placement: placement, onActiveDrawerChange: onActiveDrawerChange, onActiveDrawerResize: onActiveDrawerResize } = appLayoutInternals;
    const drawerRef = (0, $acw62.useRef)(null);
    const activeDrawerId = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id;
    const computedAriaLabels = {
        closeButton: activeDrawer ? (_a = activeDrawer.ariaLabels) === null || _a === void 0 ? void 0 : _a.closeButton : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.toolsClose,
        content: activeDrawer ? (_b = activeDrawer.ariaLabels) === null || _b === void 0 ? void 0 : _b.drawerName : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tools
    };
    const isToolsDrawer = (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id) === (0, $892ef2b582c4882d$export$329f249760e831ae);
    const toolsOnlyMode = drawers.length === 1 && drawers[0].id === (0, $892ef2b582c4882d$export$329f249760e831ae);
    const toolsContent = (_c = drawers === null || drawers === void 0 ? void 0 : drawers.find((drawer)=>drawer.id === (0, $892ef2b582c4882d$export$329f249760e831ae))) === null || _c === void 0 ? void 0 : _c.content;
    const resizeProps = (0, $e7f76d3277b180ed$export$e8b771555dc4a003)({
        currentWidth: activeDrawerSize,
        minWidth: minDrawerSize,
        maxWidth: maxDrawerSize,
        panelRef: drawerRef,
        handleRef: drawersFocusControl.refs.slider,
        onResize: (size)=>onActiveDrawerResize({
                id: activeDrawerId,
                size: size
            })
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        id: activeDrawerId,
        "aria-hidden": !activeDrawer,
        "aria-label": computedAriaLabels.content,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039).drawer, (0, $1e16b5b5cece95db$export$2e2bcd8739ae039)["with-motion"], {
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["active-drawer"]]: !toolsOnlyMode && activeDrawerId,
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).tools]: isToolsDrawer
        }),
        ref: drawerRef,
        onBlur: (e)=>{
            if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) drawersFocusControl.loseFocus();
        },
        style: {
            blockSize: `calc(100vh - ${placement.insetBlockStart}px - ${placement.insetBlockEnd}px)`,
            insetBlockStart: placement.insetBlockStart
        }
    }, !isMobile && (activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.resizable) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)["drawer-slider"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df0c014177452109$export$2e2bcd8739ae039), {
        ref: drawersFocusControl.refs.slider,
        position: "side",
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawers-slider"],
        ariaLabel: (_d = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.ariaLabels) === null || _d === void 0 ? void 0 : _d.resizeHandle,
        ariaValuenow: resizeProps.relativeSize,
        onKeyDown: resizeProps.onKeyDown,
        onPointerDown: resizeProps.onPointerDown
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)["drawer-content-container"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)["drawer-close-button"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ariaLabel: computedAriaLabels.closeButton,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["active-drawer-close-button"]]: !isToolsDrawer && activeDrawerId,
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-close"]]: isToolsDrawer
        }),
        formAction: "none",
        iconName: isMobile ? "close" : "angle-right",
        onClick: ()=>onActiveDrawerChange(null),
        ref: drawersFocusControl.refs.close,
        variant: "icon"
    })), toolsContent && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)["drawer-content"], activeDrawerId !== (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)["drawer-content-hidden"])
    }, toolsContent), activeDrawerId !== (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $ed46c0bdd69f76cb$export$2e2bcd8739ae039)["drawer-content"]
    }, activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.content)));
}
const $c2eafb2a8775c8fb$export$90e7459525ff108b = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($c2eafb2a8775c8fb$export$bf7efb8fc3f7ac58);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $16819fd9ec850dac$export$2e2bcd8739ae039 = {
    "navigation": "awsui_navigation_2p2ab_23w7n_97",
    "is-navigation-open": "awsui_is-navigation-open_2p2ab_23w7n_125",
    "animating": "awsui_animating_2p2ab_23w7n_129",
    "openNavigation": "awsui_openNavigation_2p2ab_23w7n_1",
    "animated-content": "awsui_animated-content_2p2ab_23w7n_142",
    "hide-navigation": "awsui_hide-navigation_2p2ab_23w7n_151"
};




function $2aecf53b3be154f5$export$e315be948ceba4c9({ appLayoutInternals: appLayoutInternals }) {
    var _a, _b;
    const { ariaLabels: ariaLabels, onNavigationToggle: onNavigationToggle, isMobile: isMobile, navigationOpen: navigationOpen, navigation: navigation, navigationFocusControl: navigationFocusControl, placement: placement } = appLayoutInternals;
    // Close the Navigation drawer on mobile when a user clicks a link inside.
    const onNavigationClick = (event)=>{
        const hasLink = (0, $38f6480185c49d6f$export$184ef262a758e3c4)(event.target, (node)=>node.tagName === "A" && !!node.href);
        if (hasLink && isMobile) onNavigationToggle(false);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        "aria-label": (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigation) !== null && _a !== void 0 ? _a : undefined,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $16819fd9ec850dac$export$2e2bcd8739ae039).navigation, {
            [(0, $16819fd9ec850dac$export$2e2bcd8739ae039)["is-navigation-open"]]: navigationOpen
        }, (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).navigation),
        "aria-hidden": !navigationOpen,
        onClick: onNavigationClick,
        style: {
            blockSize: `calc(100vh - ${placement.insetBlockStart}px - ${placement.insetBlockEnd}px)`,
            insetBlockStart: placement.insetBlockStart
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $16819fd9ec850dac$export$2e2bcd8739ae039)["animated-content"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $16819fd9ec850dac$export$2e2bcd8739ae039)["hide-navigation"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ariaLabel: (_b = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigationClose) !== null && _b !== void 0 ? _b : undefined,
        iconName: isMobile ? "close" : "angle-left",
        onClick: ()=>onNavigationToggle(false),
        variant: "icon",
        formAction: "none",
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["navigation-close"],
        ref: navigationFocusControl.refs.close
    })), navigation));
}
const $2aecf53b3be154f5$export$bd26f4d57340acfc = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($2aecf53b3be154f5$export$e315be948ceba4c9);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


const $4c3c84a40e2b2c6e$export$69aed1e8e248d0c2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, style: style, children: children }, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["toolbar-container"], className),
        style: style
    }, children));
const $4c3c84a40e2b2c6e$export$afc7f76de8adf7d1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, style: style, children: children }, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $89ac1508ddb88f9a$export$2e2bcd8739ae039)["notifications-container"], className),
        style: style
    }, children));




var $7742510d1afc0efb$export$2e2bcd8739ae039 = {
    "sticky-notifications": "awsui_sticky-notifications_154bi_1h0wm_5"
};



function $2ea73f4bcc2e791e$export$14bceeeb14a3fc9a({ appLayoutInternals: appLayoutInternals, children: children }) {
    const { ariaLabels: ariaLabels, stickyNotifications: stickyNotifications, setNotificationsHeight: setNotificationsHeight, verticalOffsets: verticalOffsets } = appLayoutInternals;
    const ref = (0, $acw62.useRef)(null);
    (0, $444535e54951fdea$export$683480f191c0e3ea)(ref, (entry)=>setNotificationsHeight(entry.borderBoxHeight));
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            setNotificationsHeight(0);
        };
    // unmount effect only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c3c84a40e2b2c6e$export$afc7f76de8adf7d1), {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(stickyNotifications && (0, $7742510d1afc0efb$export$2e2bcd8739ae039)["sticky-notifications"]),
        style: {
            insetBlockStart: stickyNotifications ? verticalOffsets.notifications : undefined
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).notifications,
        role: "region",
        "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.notifications
    }, children));
}
const $2ea73f4bcc2e791e$export$d34d5dec9e3e5d62 = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($2ea73f4bcc2e791e$export$14bceeeb14a3fc9a);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $d610b54fba123b07$export$2e2bcd8739ae039 = {
    "split-panel-side": "awsui_split-panel-side_j4v3w_woacl_97"
};


function $78b6bd93db866585$export$bf635d59bdc70f27({ children: children, appLayoutInternals: appLayoutInternals, splitPanelInternals: splitPanelInternals }) {
    const { splitPanelControlId: splitPanelControlId, placement: placement } = appLayoutInternals;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $846ec670e2f21dff$export$fe6de1726a5559a), Object.assign({}, splitPanelInternals), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        id: splitPanelControlId,
        className: (0, $d610b54fba123b07$export$2e2bcd8739ae039)["split-panel-side"],
        style: {
            blockSize: `calc(100vh - ${placement.insetBlockStart}px - ${placement.insetBlockEnd}px)`,
            insetBlockStart: placement.insetBlockStart
        }
    }, children));
}
function $78b6bd93db866585$export$16518e502b491282({ children: children, splitPanelInternals: splitPanelInternals }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $846ec670e2f21dff$export$fe6de1726a5559a), Object.assign({}, splitPanelInternals), children);
}
const $78b6bd93db866585$export$7ec7afa0fb3241f7 = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($78b6bd93db866585$export$bf635d59bdc70f27);
const $78b6bd93db866585$export$103da99725a921a0 = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($78b6bd93db866585$export$16518e502b491282);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $fac2a988aee55765$export$2e2bcd8739ae039 = {
    "universal-toolbar": "awsui_universal-toolbar_1kzri_18urq_97",
    "disable-body-scroll": "awsui_disable-body-scroll_1kzri_18urq_118",
    "toolbar-hidden": "awsui_toolbar-hidden_1kzri_18urq_121",
    "toolbar-container": "awsui_toolbar-container_1kzri_18urq_124",
    "universal-toolbar-nav": "awsui_universal-toolbar-nav_1kzri_18urq_133",
    "universal-toolbar-breadcrumbs": "awsui_universal-toolbar-breadcrumbs_1kzri_18urq_137",
    "universal-toolbar-drawers": "awsui_universal-toolbar-drawers_1kzri_18urq_142",
    "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_1kzri_18urq_149",
    "drawers-trigger-content": "awsui_drawers-trigger-content_1kzri_18urq_193",
    "has-multiple-triggers": "awsui_has-multiple-triggers_1kzri_18urq_200",
    "has-open-drawer": "awsui_has-open-drawer_1kzri_18urq_200",
    "drawers-trigger": "awsui_drawers-trigger_1kzri_18urq_193"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $650283c079eee3f2$export$2e2bcd8739ae039 = {
    "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_lpshu_1878d_97",
    "trigger": "awsui_trigger_lpshu_1878d_97",
    "selected": "awsui_selected_lpshu_1878d_192",
    "badge": "awsui_badge_lpshu_1878d_220",
    "trigger-wrapper": "awsui_trigger-wrapper_lpshu_1878d_224",
    "dot": "awsui_dot_lpshu_1878d_232"
};


function $ceee44cf910cdea1$var$TriggerButton({ ariaLabel: ariaLabel, className: className, iconName: iconName, iconSvg: iconSvg, ariaExpanded: ariaExpanded, ariaControls: ariaControls, onClick: onClick, testId: testId, badge: badge, selected: selected, disabled: disabled }, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $650283c079eee3f2$export$2e2bcd8739ae039)["trigger-wrapper"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-expanded": ariaExpanded,
        "aria-controls": ariaControls,
        "aria-haspopup": true,
        "aria-label": ariaLabel,
        "aria-disabled": disabled,
        disabled: disabled,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $650283c079eee3f2$export$2e2bcd8739ae039).trigger, {
            [(0, $650283c079eee3f2$export$2e2bcd8739ae039).selected]: selected,
            [(0, $650283c079eee3f2$export$2e2bcd8739ae039).badge]: badge
        }, className),
        onClick: onClick,
        ref: ref,
        type: "button",
        "data-testid": testId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(badge && (0, $650283c079eee3f2$export$2e2bcd8739ae039)["trigger-badge-wrapper"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: iconName,
        svg: iconSvg
    }))), badge && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $650283c079eee3f2$export$2e2bcd8739ae039).dot
    }));
}
var $ceee44cf910cdea1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($ceee44cf910cdea1$var$TriggerButton);




function $1f0a10ce5025b27d$export$f2a14c3cc682bac7({ ariaLabels: ariaLabels, activeDrawerId: activeDrawerId, drawers: drawers, drawersFocusRef: drawersFocusRef, onActiveDrawerChange: onActiveDrawerChange, splitPanelFocusRef: splitPanelFocusRef, splitPanelToggleProps: splitPanelToggleProps, onSplitPanelToggle: onSplitPanelToggle }) {
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const hasMultipleTriggers = drawers.length > 1;
    const previousActiveDrawerId = (0, $acw62.useRef)(activeDrawerId);
    const [containerWidth, triggersContainerRef] = (0, $6e052e2d296ab854$export$2e2bcd8739ae039)((rect)=>rect.contentBoxWidth);
    if (!drawers && !splitPanelToggleProps) return null;
    if (activeDrawerId) previousActiveDrawerId.current = activeDrawerId;
    const getIndexOfOverflowItem = ()=>{
        if (isMobile) return 2;
        if (containerWidth) {
            const ITEM_WIDTH = 50; // Roughly 34px + padding = 42px but added extra for safety
            const overflowSpot = containerWidth;
            const index = Math.floor(overflowSpot / ITEM_WIDTH);
            let splitPanelItem = 0;
            if (splitPanelToggleProps) splitPanelItem = 1;
            return index - splitPanelItem;
        }
        return 0;
    };
    const { visibleItems: visibleItems, overflowItems: overflowItems } = (0, $cd10a1d6e571a030$export$855cafbbae95d7a8)(drawers, getIndexOfOverflowItem(), activeDrawerId !== null && activeDrawerId !== void 0 ? activeDrawerId : null);
    const overflowMenuHasBadge = !!overflowItems.find((item)=>item.badge);
    const toolsOnlyMode = drawers.length === 1 && drawers[0].id === (0, $892ef2b582c4882d$export$329f249760e831ae);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("aside", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)["drawers-desktop-triggers-container"], {
            [(0, $fac2a988aee55765$export$2e2bcd8739ae039)["has-multiple-triggers"]]: hasMultipleTriggers,
            [(0, $fac2a988aee55765$export$2e2bcd8739ae039)["has-open-drawer"]]: activeDrawerId
        }),
        "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawers,
        ref: triggersContainerRef,
        role: "region"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)["drawers-trigger-content"], {
            [(0, $fac2a988aee55765$export$2e2bcd8739ae039)["has-multiple-triggers"]]: hasMultipleTriggers,
            [(0, $fac2a988aee55765$export$2e2bcd8739ae039)["has-open-drawer"]]: activeDrawerId
        }),
        role: "toolbar",
        "aria-orientation": "horizontal"
    }, splitPanelToggleProps && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ceee44cf910cdea1$export$2e2bcd8739ae039), {
        ariaLabel: splitPanelToggleProps.ariaLabel,
        ariaControls: splitPanelToggleProps.controlId,
        ariaExpanded: splitPanelToggleProps.active,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)["drawers-trigger"], (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)["open-button"]),
        iconName: splitPanelToggleProps.position === "side" ? "view-vertical" : "view-horizontal",
        onClick: ()=>onSplitPanelToggle(),
        selected: splitPanelToggleProps.active,
        ref: splitPanelFocusRef
    }), visibleItems.map((item)=>{
        var _a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ceee44cf910cdea1$export$2e2bcd8739ae039), {
            ariaLabel: (_a = item.ariaLabels) === null || _a === void 0 ? void 0 : _a.triggerButton,
            ariaExpanded: item.id === activeDrawerId,
            ariaControls: activeDrawerId === item.id ? item.id : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)["drawers-trigger"], !toolsOnlyMode && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawers-trigger"], item.id === (0, $892ef2b582c4882d$export$329f249760e831ae) && (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["tools-toggle"]),
            iconName: item.trigger.iconName,
            iconSvg: item.trigger.iconSvg,
            key: item.id,
            onClick: ()=>onActiveDrawerChange(activeDrawerId !== item.id ? item.id : null),
            ref: item.id === previousActiveDrawerId.current ? drawersFocusRef : undefined,
            selected: item.id === activeDrawerId,
            badge: item.badge,
            testId: `awsui-app-layout-trigger-${item.id}`
        });
    }), overflowItems.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $68640640380c1033$export$2e2bcd8739ae039), {
        items: overflowItems,
        ariaLabel: overflowMenuHasBadge ? ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawersOverflowWithBadge : ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.drawersOverflow,
        customTriggerBuilder: ({ onClick: onClick, triggerRef: triggerRef, ariaLabel: ariaLabel, ariaExpanded: ariaExpanded, testUtilsClass: testUtilsClass })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ceee44cf910cdea1$export$2e2bcd8739ae039), {
                ref: triggerRef,
                ariaLabel: ariaLabel,
                ariaExpanded: ariaExpanded,
                badge: overflowMenuHasBadge,
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)["drawers-trigger"], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawers-trigger"], testUtilsClass),
                iconName: "ellipsis",
                onClick: onClick
            }),
        onItemClick: (event)=>onActiveDrawerChange(event.detail.id)
    })));
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");

var $72deb0d8205d26fb$export$2e2bcd8739ae039 = {
    "breadcrumb-group": "awsui_breadcrumb-group_d19fg_1yed3_97",
    "item": "awsui_item_d19fg_1yed3_135",
    "breadcrumb-group-list": "awsui_breadcrumb-group-list_d19fg_1yed3_170",
    "ellipsis": "awsui_ellipsis_d19fg_1yed3_182",
    "icon": "awsui_icon_d19fg_1yed3_192",
    "mobile": "awsui_mobile_d19fg_1yed3_197",
    "mobile-short": "awsui_mobile-short_d19fg_1yed3_210"
};








var $acw62 = parcelRequire("acw62");


var $412480e10a479e0b$export$2e2bcd8739ae039 = {
    "link": "awsui_link_1kosq_101th_97",
    "breadcrumb": "awsui_breadcrumb_1kosq_101th_101",
    "icon": "awsui_icon_1kosq_101th_104",
    "anchor": "awsui_anchor_1kosq_101th_109",
    "last": "awsui_last_1kosq_101th_155",
    "compressed": "awsui_compressed_1kosq_101th_165",
    "text": "awsui_text_1kosq_101th_169",
    "virtual-item": "awsui_virtual-item_1kosq_101th_176",
    "text-hidden": "awsui_text-hidden_1kosq_101th_183"
};





const $021a19cabcc050c9$export$6b055ee0b245db25 = (item)=>({
        item: item,
        text: item.text,
        href: item.href
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



const $7703d4e092fe9854$export$8a09f20323abaf01 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ text: text, hidden: hidden, last: last }, ref)=>{
    const funnelAttributes = {};
    if (last) funnelAttributes[0, $285a09b860d2bebc$export$22b484224f7ab69a] = (0, $285a09b860d2bebc$export$f707bfc38f5d283);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, funnelAttributes, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $412480e10a479e0b$export$2e2bcd8739ae039).text, hidden && (0, $412480e10a479e0b$export$2e2bcd8739ae039)["text-hidden"]),
        ref: ref
    }), text);
});


const $a94b06600eabeb7d$var$BreadcrumbItemWithPopover = (_a)=>{
    var { item: item, isLast: isLast, anchorAttributes: anchorAttributes } = _a, itemAttributes = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "item",
        "isLast",
        "anchorAttributes"
    ]);
    const [showPopover, setShowPopover] = (0, $acw62.useState)(false);
    const textRef = (0, $acw62.useRef)(null);
    const virtualTextRef = (0, $acw62.useRef)(null);
    const isTruncated = (textRef, virtualTextRef)=>{
        if (!textRef || !virtualTextRef || !textRef.current || !virtualTextRef.current) return false;
        const virtualTextWidth = virtualTextRef.current.getBoundingClientRect().width;
        const textWidth = textRef.current.getBoundingClientRect().width;
        if (virtualTextWidth > textWidth) return true;
        return false;
    };
    const popoverContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $76f4c84fd1bac364$export$2e2bcd8739ae039), {
        trackRef: textRef,
        value: item.text
    });
    (0, $acw62.useEffect)(()=>{
        const onKeyDown = (event)=>{
            if (event.key === "Escape") setShowPopover(false);
        };
        if (showPopover) document.addEventListener("keydown", onKeyDown);
        return ()=>{
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [
        showPopover
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a94b06600eabeb7d$var$Item, Object.assign({
        isLast: isLast
    }, itemAttributes, {
        onFocus: ()=>{
            isTruncated(textRef, virtualTextRef) && setShowPopover(true);
        },
        onBlur: ()=>setShowPopover(false),
        onMouseEnter: ()=>{
            isTruncated(textRef, virtualTextRef) && setShowPopover(true);
        },
        onMouseLeave: ()=>setShowPopover(false),
        anchorAttributes: anchorAttributes
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7703d4e092fe9854$export$8a09f20323abaf01), {
        ref: textRef,
        text: item.text,
        last: isLast
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $412480e10a479e0b$export$2e2bcd8739ae039)["virtual-item"],
        ref: virtualTextRef
    }, item.text)), showPopover && popoverContent);
};
const $a94b06600eabeb7d$var$Item = (_a)=>{
    var { anchorAttributes: anchorAttributes, children: children, isLast: isLast } = _a, itemAttributes = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "anchorAttributes",
        "children",
        "isLast"
    ]);
    return isLast ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, itemAttributes), children) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({}, itemAttributes, anchorAttributes), children);
};
function $a94b06600eabeb7d$export$c13f210c706eb549({ item: item, onClick: onClick, onFollow: onFollow, isDisplayed: isDisplayed, isLast: isLast = false, isCompressed: isCompressed = false }) {
    const preventDefault = (event)=>event.preventDefault();
    const onClickHandler = (event)=>{
        if ((0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) (0, $fc537b925f715587$export$d7e1721720edbb03)(onFollow, (0, $021a19cabcc050c9$export$6b055ee0b245db25)(item), event);
        (0, $fc537b925f715587$export$d7e1721720edbb03)(onClick, (0, $021a19cabcc050c9$export$6b055ee0b245db25)(item), event);
    };
    const itemAttributes = {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $412480e10a479e0b$export$2e2bcd8739ae039).anchor, {
            [(0, $412480e10a479e0b$export$2e2bcd8739ae039).compressed]: isCompressed
        })
    };
    const anchorAttributes = {
        href: item.href || "#",
        onClick: isLast ? preventDefault : onClickHandler
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $412480e10a479e0b$export$2e2bcd8739ae039).breadcrumb, isLast && (0, $412480e10a479e0b$export$2e2bcd8739ae039).last)
    }, isDisplayed && isCompressed ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a94b06600eabeb7d$var$BreadcrumbItemWithPopover, Object.assign({
        item: item,
        isLast: isLast,
        anchorAttributes: anchorAttributes
    }, itemAttributes)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a94b06600eabeb7d$var$Item, Object.assign({
        isLast: isLast,
        anchorAttributes: anchorAttributes
    }, itemAttributes), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7703d4e092fe9854$export$8a09f20323abaf01), {
        text: item.text,
        last: isLast
    })), !isLast ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $412480e10a479e0b$export$2e2bcd8739ae039).icon
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "angle-right"
    })) : null);
}









/**
 * Provided for backwards compatibility
 */ const $3a72f05b8b6b5b62$var$DEFAULT_EXPAND_ARIA_LABEL = "Show path";
const $3a72f05b8b6b5b62$var$getDropdownTrigger = ({ ariaLabel: ariaLabel, triggerRef: triggerRef, disabled: disabled, testUtilsClass: testUtilsClass, isOpen: isOpen, onClick: onClick })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ref: triggerRef,
        className: testUtilsClass,
        disabled: disabled,
        onClick: (event)=>{
            event.preventDefault();
            onClick();
        },
        ariaExpanded: isOpen,
        "aria-haspopup": true,
        ariaLabel: ariaLabel,
        variant: "breadcrumb-group",
        formAction: "none"
    }, "...");
};
const $3a72f05b8b6b5b62$var$EllipsisDropdown = ({ ariaLabel: ariaLabel, dropdownItems: dropdownItems, onDropdownItemClick: onDropdownItemClick, onDropdownItemFollow: onDropdownItemFollow })=>{
    var _a;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("breadcrumb-group");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $72deb0d8205d26fb$export$2e2bcd8739ae039).ellipsis
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eed8d7153e9df678$export$2e2bcd8739ae039), {
        ariaLabel: (_a = i18n("expandAriaLabel", ariaLabel)) !== null && _a !== void 0 ? _a : $3a72f05b8b6b5b62$var$DEFAULT_EXPAND_ARIA_LABEL,
        items: dropdownItems,
        onItemClick: onDropdownItemClick,
        onItemFollow: onDropdownItemFollow,
        customTriggerBuilder: $3a72f05b8b6b5b62$var$getDropdownTrigger
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $72deb0d8205d26fb$export$2e2bcd8739ae039).icon
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "angle-right"
    })));
};
function $3a72f05b8b6b5b62$export$cc0e5b36fb9a70bc(_a) {
    var { items: items = [], ariaLabel: ariaLabel, expandAriaLabel: expandAriaLabel, onClick: onClick, onFollow: onFollow, __internalRootRef: __internalRootRef } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "items",
        "ariaLabel",
        "expandAriaLabel",
        "onClick",
        "onFollow",
        "__internalRootRef"
    ]);
    for (const item of items)(0, $3de0f29144bb4e85$export$6661f6891a200a5f)("BreadcrumbGroup", item.href);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    let breadcrumbItems = items.map((item, index)=>{
        const isLast = index === items.length - 1;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            className: (0, $72deb0d8205d26fb$export$2e2bcd8739ae039).item,
            key: index
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a94b06600eabeb7d$export$c13f210c706eb549), {
            item: item,
            onClick: onClick,
            onFollow: onFollow,
            isCompressed: isMobile,
            isLast: isLast,
            isDisplayed: !isMobile || isLast || index === 0
        }));
    });
    const getEventItem = (e)=>{
        const { id: id } = e.detail;
        return items[parseInt(id)];
    };
    // Add ellipsis
    if (breadcrumbItems.length >= 2) {
        const dropdownItems = items.slice(1, items.length - 1).map((item, index)=>({
                id: (index + 1).toString(),
                text: item.text,
                href: item.href || "#"
            }));
        breadcrumbItems = [
            breadcrumbItems[0],
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3a72f05b8b6b5b62$var$EllipsisDropdown, {
                key: "ellipsis",
                ariaLabel: expandAriaLabel,
                dropdownItems: dropdownItems,
                onDropdownItemClick: (e)=>(0, $fc537b925f715587$export$d7e1721720edbb03)(onClick, (0, $021a19cabcc050c9$export$6b055ee0b245db25)(getEventItem(e)), e),
                onDropdownItemFollow: (e)=>(0, $fc537b925f715587$export$d7e1721720edbb03)(onFollow, (0, $021a19cabcc050c9$export$6b055ee0b245db25)(getEventItem(e)), e)
            }),
            ...breadcrumbItems.slice(1)
        ];
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $72deb0d8205d26fb$export$2e2bcd8739ae039)["breadcrumb-group"], isMobile && (0, $72deb0d8205d26fb$export$2e2bcd8739ae039).mobile, items.length <= 2 && (0, $72deb0d8205d26fb$export$2e2bcd8739ae039)["mobile-short"], baseProps.className),
        "aria-label": ariaLabel || undefined,
        ref: __internalRootRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ol", {
        className: (0, $72deb0d8205d26fb$export$2e2bcd8739ae039)["breadcrumb-group-list"]
    }, breadcrumbItems));
}
const $3a72f05b8b6b5b62$export$a040bee6da3a27ec = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($3a72f05b8b6b5b62$export$cc0e5b36fb9a70bc);


const $49b9235a4c953816$export$ae9694a2d3d44ee1 = (0, $3a72f05b8b6b5b62$export$a040bee6da3a27ec)();


function $0a70221a38f0197f$export$a28be8b8dbc0fb74({ appLayoutInternals: appLayoutInternals }) {
    var _a, _b;
    const { ariaLabels: ariaLabels, breadcrumbs: breadcrumbs, discoveredBreadcrumbs: discoveredBreadcrumbs, activeDrawer: activeDrawer, drawers: drawers, drawersFocusControl: drawersFocusControl, setToolbarHeight: setToolbarHeight, verticalOffsets: verticalOffsets, onNavigationToggle: onNavigationToggle, isMobile: isMobile, toolbarState: toolbarState, setToolbarState: setToolbarState, navigationOpen: navigationOpen, navigation: navigation, navigationFocusControl: navigationFocusControl, splitPanelControlId: splitPanelControlId, splitPanelPosition: splitPanelPosition, splitPanelToggleConfig: splitPanelToggleConfig, splitPanelFocusControl: splitPanelFocusControl, onSplitPanelToggle: onSplitPanelToggle, splitPanelOpen: splitPanelOpen, onActiveDrawerChange: onActiveDrawerChange } = appLayoutInternals;
    // TODO: expose configuration property
    const pinnedToolbar = true;
    const ref = (0, $acw62.useRef)(null);
    (0, $444535e54951fdea$export$683480f191c0e3ea)(ref, (entry)=>setToolbarHeight(entry.borderBoxHeight));
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            setToolbarHeight(0);
        };
    // unmount effect only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $acw62.useEffect)(()=>{
        let lastScrollY = window.scrollY;
        /* istanbul ignore next not testable in JSDOM */ const updateScrollDirection = ()=>{
            if (pinnedToolbar) {
                setToolbarState("show");
                return;
            }
            const scrollY = window.scrollY;
            // 80 is an arbitrary number to have a pause before the toolbar scrolls out of view at the top of the page
            const direction = scrollY > lastScrollY && scrollY > 80 ? "hide" : "show";
            // 2 as a buffer to avoid mistaking minor accidental mouse moves as scroll
            if (direction !== toolbarState && (scrollY - lastScrollY > 2 || scrollY - lastScrollY < -2)) setToolbarState(direction);
            lastScrollY = scrollY > 0 ? scrollY : 0;
        };
        window.addEventListener("scroll", updateScrollDirection);
        return ()=>{
            window.removeEventListener("scroll", updateScrollDirection);
        };
    }, [
        pinnedToolbar,
        setToolbarState,
        toolbarState
    ]);
    const toolbarHidden = toolbarState === "hide" && !pinnedToolbar;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c3c84a40e2b2c6e$export$69aed1e8e248d0c2), {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)["universal-toolbar"], {
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["mobile-bar"]]: isMobile,
            [(0, $fac2a988aee55765$export$2e2bcd8739ae039)["toolbar-hidden"]]: toolbarHidden
        }),
        style: {
            insetBlockStart: toolbarHidden ? "-60px" : verticalOffsets.toolbar
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $fac2a988aee55765$export$2e2bcd8739ae039)["toolbar-container"]
    }, navigation && !navigationOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        "aria-hidden": navigationOpen,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)["universal-toolbar-nav"], {
            [(0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["drawer-closed"]]: !navigationOpen
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ceee44cf910cdea1$export$2e2bcd8739ae039), {
        ariaLabel: (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.navigationToggle) !== null && _a !== void 0 ? _a : undefined,
        ariaExpanded: navigationOpen ? undefined : false,
        iconName: "menu",
        className: (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039)["navigation-toggle"],
        onClick: ()=>onNavigationToggle(!navigationOpen),
        ref: navigationFocusControl.refs.toggle,
        selected: navigationOpen
    })), (breadcrumbs || discoveredBreadcrumbs) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)["universal-toolbar-breadcrumbs"], (0, $8cdb2ab5bd9c7b8c$export$2e2bcd8739ae039).breadcrumbs)
    }, breadcrumbs, discoveredBreadcrumbs && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $49b9235a4c953816$export$ae9694a2d3d44ee1), Object.assign({}, discoveredBreadcrumbs))), (drawers.length > 0 || splitPanelToggleConfig.displayed) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fac2a988aee55765$export$2e2bcd8739ae039)["universal-toolbar-drawers"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1f0a10ce5025b27d$export$f2a14c3cc682bac7), {
        ariaLabels: ariaLabels,
        activeDrawerId: (_b = activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id) !== null && _b !== void 0 ? _b : null,
        drawers: drawers,
        drawersFocusRef: drawersFocusControl.refs.toggle,
        onActiveDrawerChange: onActiveDrawerChange,
        splitPanelToggleProps: splitPanelToggleConfig.displayed ? Object.assign(Object.assign({}, splitPanelToggleConfig), {
            controlId: splitPanelControlId,
            active: splitPanelOpen,
            position: splitPanelPosition
        }) : undefined,
        splitPanelFocusRef: splitPanelFocusControl.refs.toggle,
        onSplitPanelToggle: onSplitPanelToggle
    }))));
}
const $0a70221a38f0197f$export$b85e67bbf00da1f = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($0a70221a38f0197f$export$a28be8b8dbc0fb74);


const $4e005140358e61f0$export$2475651a3952be0 = (0, $2aecf53b3be154f5$export$bd26f4d57340acfc)();
const $4e005140358e61f0$export$3cfd08e6c77a9620 = (0, $c2eafb2a8775c8fb$export$90e7459525ff108b)();
const $4e005140358e61f0$export$aa3145d0b7761fca = (0, $2ea73f4bcc2e791e$export$d34d5dec9e3e5d62)();
const $4e005140358e61f0$export$3c92a11bdbcfb575 = (0, $0a70221a38f0197f$export$b85e67bbf00da1f)();
const $4e005140358e61f0$export$21a1c4a35e46103 = (0, $78b6bd93db866585$export$103da99725a921a0)();
const $4e005140358e61f0$export$af59b18527774d45 = (0, $78b6bd93db866585$export$7ec7afa0fb3241f7)();


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $e77086e9f518407b$var$useSetGlobalBreadcrumbsImplementation(props) {
    const registrationRef = (0, $acw62.useRef)();
    const [registered, setRegistered] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const registration = (0, $2ec6e52915a41fcf$export$90753eb139627d74).breadcrumbs.registerBreadcrumbs(props, ()=>setRegistered(true));
        registrationRef.current = registration;
        return ()=>{
            registration.cleanup();
        };
    // subsequent prop changes are handled by another effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $acw62.useLayoutEffect)(()=>{
        var _a;
        (_a = registrationRef.current) === null || _a === void 0 || _a.update(props);
    });
    return registered;
}
function $e77086e9f518407b$export$f84a01a588f76472(props) {
    // avoid additional side effects when this feature is not active
    if (!(0, $a1afd02c366f84c0$export$cdbb7c478433ee77)("appLayoutWidget")) return false;
    // getGlobalFlag() value does not change without full page reload
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $e77086e9f518407b$var$useSetGlobalBreadcrumbsImplementation(props);
}
function $e77086e9f518407b$export$eaa9c9bd163bd73d() {
    const [discoveredBreadcrumbs, setDiscoveredBreadcrumbs] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        return (0, $2ec6e52915a41fcf$export$90753eb139627d74).breadcrumbs.registerAppLayout((breadcrumbs)=>{
            setDiscoveredBreadcrumbs(breadcrumbs);
        });
    }, []);
    return discoveredBreadcrumbs;
}


const $1cb9e3746b46916d$var$AppLayoutVisualRefreshToolbar = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, forwardRef)=>{
    var _b;
    var { ariaLabels: ariaLabels, contentHeader: contentHeader, content: content, navigationOpen: navigationOpen, navigationWidth: navigationWidth, navigation: navigation, navigationHide: navigationHide, onNavigationChange: onNavigationChange, tools: tools, toolsOpen: controlledToolsOpen, onToolsChange: onToolsChange, toolsHide: toolsHide, toolsWidth: toolsWidth, contentType: contentType, headerVariant: headerVariant, breadcrumbs: breadcrumbs, notifications: notifications, stickyNotifications: stickyNotifications, splitPanelPreferences: controlledSplitPanelPreferences, splitPanelOpen: controlledSplitPanelOpen, splitPanel: splitPanel, splitPanelSize: controlledSplitPanelSize, onSplitPanelToggle: onSplitPanelToggle, onSplitPanelResize: onSplitPanelResize, onSplitPanelPreferencesChange: onSplitPanelPreferencesChange, disableContentPaddings: disableContentPaddings, minContentWidth: minContentWidth, maxContentWidth: maxContentWidth, placement: placement } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "ariaLabels",
        "contentHeader",
        "content",
        "navigationOpen",
        "navigationWidth",
        "navigation",
        "navigationHide",
        "onNavigationChange",
        "tools",
        "toolsOpen",
        "onToolsChange",
        "toolsHide",
        "toolsWidth",
        "contentType",
        "headerVariant",
        "breadcrumbs",
        "notifications",
        "stickyNotifications",
        "splitPanelPreferences",
        "splitPanelOpen",
        "splitPanel",
        "splitPanelSize",
        "onSplitPanelToggle",
        "onSplitPanelResize",
        "onSplitPanelPreferencesChange",
        "disableContentPaddings",
        "minContentWidth",
        "maxContentWidth",
        "placement"
    ]);
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const embeddedViewMode = rest.__embeddedViewMode;
    const splitPanelControlId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("split-panel");
    const [toolbarState, setToolbarState] = (0, $acw62.useState)("show");
    const [toolbarHeight, setToolbarHeight] = (0, $acw62.useState)(0);
    const [notificationsHeight, setNotificationsHeight] = (0, $acw62.useState)(0);
    const onNavigationToggle = (open)=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onNavigationChange, {
            open: open
        });
    };
    const [toolsOpen = false, setToolsOpen] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledToolsOpen, onToolsChange, false, {
        componentName: "AppLayout",
        controlledProp: "toolsOpen",
        changeHandler: "onToolsChange"
    });
    const onToolsToggle = (open)=>{
        setToolsOpen(open);
        drawersFocusControl.setFocus();
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onToolsChange, {
            open: open
        });
    };
    const { drawers: drawers, activeDrawer: activeDrawer, minDrawerSize: minDrawerSize, activeDrawerSize: activeDrawerSize, ariaLabelsWithDrawers: ariaLabelsWithDrawers, onActiveDrawerChange: onActiveDrawerChange, onActiveDrawerResize: onActiveDrawerResize } = (0, $892ef2b582c4882d$export$468f52f962f49bf5)(rest, ariaLabels, {
        ariaLabels: ariaLabels,
        toolsHide: toolsHide,
        toolsOpen: toolsOpen,
        tools: tools,
        toolsWidth: toolsWidth,
        onToolsToggle: onToolsToggle
    });
    const [splitPanelOpen = false, setSplitPanelOpen] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledSplitPanelOpen, onSplitPanelToggle, false, {
        componentName: "AppLayout",
        controlledProp: "splitPanelOpen",
        changeHandler: "onSplitPanelToggle"
    });
    const onSplitPanelToggleHandler = ()=>{
        setSplitPanelOpen(!splitPanelOpen);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSplitPanelToggle, {
            open: !splitPanelOpen
        });
    };
    const [splitPanelPreferences, setSplitPanelPreferences] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledSplitPanelPreferences, onSplitPanelPreferencesChange, undefined, {
        componentName: "AppLayout",
        controlledProp: "splitPanelPreferences",
        changeHandler: "onSplitPanelPreferencesChange"
    });
    const onSplitPanelPreferencesChangeHandler = (detail)=>{
        setSplitPanelPreferences(detail);
        splitPanelFocusControl.setLastInteraction({
            type: "position"
        });
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSplitPanelPreferencesChange, detail);
    };
    const [splitPanelSize = 0, setSplitPanelSize] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledSplitPanelSize, onSplitPanelResize, (0, $582c00c3ff10d4e2$export$9d9d5fcac617b082)((_b = splitPanelPreferences === null || splitPanelPreferences === void 0 ? void 0 : splitPanelPreferences.position) !== null && _b !== void 0 ? _b : "bottom"), {
        componentName: "AppLayout",
        controlledProp: "splitPanelSize",
        changeHandler: "onSplitPanelResize"
    });
    const [splitPanelReportedSize, setSplitPanelReportedSize] = (0, $acw62.useState)(0);
    const onSplitPanelResizeHandler = (size)=>{
        setSplitPanelSize(size);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSplitPanelResize, {
            size: size
        });
    };
    const [splitPanelToggleConfig, setSplitPanelToggleConfig] = (0, $acw62.useState)({
        ariaLabel: undefined,
        displayed: false
    });
    const drawersFocusControl = (0, $84d3a2bbe2557e44$export$817e5b4536f33d83)(!!(activeDrawer === null || activeDrawer === void 0 ? void 0 : activeDrawer.id));
    const navigationFocusControl = (0, $84d3a2bbe2557e44$export$817e5b4536f33d83)(navigationOpen);
    const splitPanelFocusControl = (0, $d19d77c31ea1086e$export$ba7387b5ce3f72be)([
        splitPanelPreferences,
        splitPanelOpen
    ]);
    (0, $acw62.useImperativeHandle)(forwardRef, ()=>({
            closeNavigationIfNecessary: ()=>isMobile && onNavigationToggle(false),
            openTools: ()=>onToolsToggle(true),
            focusToolsClose: ()=>drawersFocusControl.setFocus(true),
            focusActiveDrawer: ()=>drawersFocusControl.setFocus(true),
            focusSplitPanel: ()=>{
                var _a;
                return (_a = splitPanelFocusControl.refs.slider.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }));
    const resolvedNavigation = navigationHide ? null : navigation !== null && navigation !== void 0 ? navigation : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    const { maxDrawerSize: maxDrawerSize, maxSplitPanelSize: maxSplitPanelSize, splitPanelForcedPosition: splitPanelForcedPosition, splitPanelPosition: splitPanelPosition } = (0, $ff079cc12921495d$export$847d464b8c579b64)({
        activeDrawerSize: activeDrawerSize,
        splitPanelSize: splitPanelSize,
        minContentWidth: minContentWidth,
        navigationOpen: !!resolvedNavigation && navigationOpen,
        navigationWidth: navigationWidth,
        placement: placement,
        splitPanelOpen: splitPanelOpen,
        splitPanelPosition: splitPanelPreferences === null || splitPanelPreferences === void 0 ? void 0 : splitPanelPreferences.position
    });
    const discoveredBreadcrumbs = (0, $e77086e9f518407b$export$eaa9c9bd163bd73d)();
    const hasToolbar = Boolean(!embeddedViewMode && (resolvedNavigation || breadcrumbs || discoveredBreadcrumbs || splitPanelToggleConfig.displayed || drawers.length > 0));
    const verticalOffsets = (0, $ff079cc12921495d$export$88f2788934d642c4)({
        topOffset: placement.insetBlockStart,
        hasToolbar: hasToolbar && toolbarState !== "hide",
        notificationsHeight: notificationsHeight !== null && notificationsHeight !== void 0 ? notificationsHeight : 0,
        toolbarHeight: toolbarHeight !== null && toolbarHeight !== void 0 ? toolbarHeight : 0,
        stickyNotifications: !!stickyNotifications
    });
    const appLayoutInternals = {
        ariaLabels: ariaLabelsWithDrawers,
        headerVariant: headerVariant,
        isMobile: isMobile,
        breadcrumbs: breadcrumbs,
        discoveredBreadcrumbs: discoveredBreadcrumbs,
        stickyNotifications: stickyNotifications,
        navigationOpen: navigationOpen,
        navigation: resolvedNavigation,
        navigationFocusControl: navigationFocusControl,
        activeDrawer: activeDrawer,
        activeDrawerSize: activeDrawerSize,
        minDrawerSize: minDrawerSize,
        maxDrawerSize: maxDrawerSize,
        drawers: drawers,
        drawersFocusControl: drawersFocusControl,
        splitPanelPosition: splitPanelPosition,
        splitPanelToggleConfig: splitPanelToggleConfig,
        splitPanelOpen: splitPanelOpen,
        splitPanelControlId: splitPanelControlId,
        splitPanelFocusControl: splitPanelFocusControl,
        placement: placement,
        toolbarState: toolbarState,
        setToolbarState: setToolbarState,
        verticalOffsets: verticalOffsets,
        setToolbarHeight: setToolbarHeight,
        setNotificationsHeight: setNotificationsHeight,
        onSplitPanelToggle: onSplitPanelToggleHandler,
        onNavigationToggle: onNavigationToggle,
        onActiveDrawerChange: onActiveDrawerChange,
        onActiveDrawerResize: onActiveDrawerResize
    };
    const splitPanelInternals = {
        bottomOffset: 0,
        getMaxHeight: ()=>{
            const availableHeight = document.documentElement.clientHeight - placement.insetBlockStart - placement.insetBlockEnd;
            // If the page is likely zoomed in at 200%, allow the split panel to fill the content area.
            return availableHeight < 400 ? availableHeight - 40 : availableHeight - 250;
        },
        maxWidth: maxSplitPanelSize,
        isForcedPosition: splitPanelForcedPosition,
        isOpen: splitPanelOpen,
        leftOffset: 0,
        onPreferencesChange: onSplitPanelPreferencesChangeHandler,
        onResize: onSplitPanelResizeHandler,
        onToggle: onSplitPanelToggleHandler,
        position: splitPanelPosition,
        reportSize: (size)=>setSplitPanelReportedSize(size),
        reportHeaderHeight: ()=>{
        /*unused in this design*/ },
        rightOffset: 0,
        size: splitPanelSize,
        topOffset: 0,
        setSplitPanelToggle: setSplitPanelToggleConfig,
        refs: splitPanelFocusControl.refs
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $032e239c9545babc$export$af3ba02ef74c9bdf), {
        style: {
            [(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalTopOffset]: `${verticalOffsets.header}px`,
            [(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalBottomOffset]: `${placement.insetBlockEnd}px`,
            paddingBlockEnd: splitPanelOpen ? splitPanelReportedSize : ""
        },
        toolbar: hasToolbar && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e005140358e61f0$export$3c92a11bdbcfb575), {
            appLayoutInternals: appLayoutInternals
        }),
        notifications: notifications && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e005140358e61f0$export$aa3145d0b7761fca), {
            appLayoutInternals: appLayoutInternals
        }, notifications),
        contentHeader: contentHeader,
        content: content,
        navigation: resolvedNavigation && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e005140358e61f0$export$2475651a3952be0), {
            appLayoutInternals: appLayoutInternals
        }),
        navigationOpen: navigationOpen,
        navigationWidth: navigationWidth,
        tools: activeDrawer && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e005140358e61f0$export$3cfd08e6c77a9620), {
            appLayoutInternals: appLayoutInternals
        }),
        toolsOpen: !!activeDrawer,
        toolsWidth: activeDrawerSize,
        sideSplitPanel: splitPanelPosition === "side" && splitPanel && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e005140358e61f0$export$af59b18527774d45), {
            appLayoutInternals: appLayoutInternals,
            splitPanelInternals: splitPanelInternals
        }, splitPanel),
        bottomSplitPanel: splitPanelPosition === "bottom" && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e005140358e61f0$export$21a1c4a35e46103), {
            appLayoutInternals: appLayoutInternals,
            splitPanelInternals: splitPanelInternals
        }, splitPanel),
        splitPanelOpen: splitPanelOpen,
        placement: placement,
        contentType: contentType,
        maxContentWidth: maxContentWidth,
        disableContentPaddings: disableContentPaddings
    });
});
var $1cb9e3746b46916d$export$2e2bcd8739ae039 = $1cb9e3746b46916d$var$AppLayoutVisualRefreshToolbar;



const $ea8590cb86272801$export$e7b09cbd23d3aff = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    if (isRefresh) {
        if ((0, $a1afd02c366f84c0$export$cdbb7c478433ee77)("appLayoutWidget")) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1cb9e3746b46916d$export$2e2bcd8739ae039), Object.assign({
            ref: ref
        }, props));
        else return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18dc6142312830db$export$2e2bcd8739ae039), Object.assign({
            ref: ref
        }, props));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ad7a06c5c5b5cb1$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, props));
});


const $bfbfeb434025eacd$var$defaultContentTypeState = {
    navigationOpen: true,
    minContentWidth: 280,
    maxContentWidth: undefined
};
const $bfbfeb434025eacd$var$defaults = {
    default: Object.assign({}, $bfbfeb434025eacd$var$defaultContentTypeState),
    dashboard: Object.assign({}, $bfbfeb434025eacd$var$defaultContentTypeState),
    cards: {
        navigationOpen: true,
        minContentWidth: 280,
        maxContentWidth: undefined
    },
    form: {
        navigationOpen: false,
        minContentWidth: 280,
        maxContentWidth: 800
    },
    table: {
        navigationOpen: true,
        minContentWidth: 280,
        maxContentWidth: undefined
    },
    wizard: {
        navigationOpen: false,
        minContentWidth: 280,
        maxContentWidth: 1080
    }
};
function $bfbfeb434025eacd$export$981532776ab2217e(contentType, stateFromProps, isRefresh) {
    var _a, _b, _c;
    const contentTypeDefaults = isRefresh ? Object.assign(Object.assign({}, $bfbfeb434025eacd$var$defaults[contentType]), {
        maxContentWidth: undefined
    }) : $bfbfeb434025eacd$var$defaults[contentType];
    return {
        maxContentWidth: (_a = stateFromProps.maxContentWidth) !== null && _a !== void 0 ? _a : contentTypeDefaults.maxContentWidth,
        minContentWidth: (_b = stateFromProps.minContentWidth) !== null && _b !== void 0 ? _b : contentTypeDefaults.minContentWidth,
        navigationOpen: (_c = stateFromProps.navigationOpen) !== null && _c !== void 0 ? _c : contentTypeDefaults.navigationOpen
    };
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");
function $fe475dd0b21a124b$export$f22a61189702bd57(selector) {
    const getElement = (0, $acw62.useCallback)(()=>{
        return document.querySelector(selector);
    }, [
        selector
    ]);
    const [height, setHeight] = (0, $acw62.useState)(0);
    (0, $444535e54951fdea$export$683480f191c0e3ea)(getElement, (entry)=>setHeight(entry.borderBoxHeight));
    return height;
}



function $9bd7f949256e7f39$export$15e0126286aabec3(headerSelector, footerSelector) {
    const mainElementRef = (0, $acw62.useRef)(null);
    const headerHeight = (0, $fe475dd0b21a124b$export$f22a61189702bd57)(headerSelector);
    const footerHeight = (0, $fe475dd0b21a124b$export$f22a61189702bd57)(footerSelector);
    const [offsets, setOffsets] = (0, $acw62.useState)({
        insetInlineStart: 0,
        insetInlineEnd: 0,
        inlineSize: Number.POSITIVE_INFINITY
    });
    const updatePosition = (0, $acw62.useCallback)(()=>{
        if (!mainElementRef.current) return;
        const { insetInlineStart: insetInlineStart, insetInlineEnd: insetInlineEnd, inlineSize: inlineSize } = (0, $558545a5feadf817$export$322fb6cc2f904670)(mainElementRef.current);
        // skip reading sizes in JSDOM
        if (inlineSize === 0) return;
        setOffsets({
            insetInlineStart: insetInlineStart,
            insetInlineEnd: inlineSize - insetInlineEnd,
            inlineSize: inlineSize
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener("resize", updatePosition);
        return ()=>window.removeEventListener("resize", updatePosition);
    }, [
        updatePosition
    ]);
    (0, $444535e54951fdea$export$683480f191c0e3ea)(mainElementRef, updatePosition);
    return [
        mainElementRef,
        Object.assign(Object.assign({}, offsets), {
            insetBlockStart: headerHeight,
            insetBlockEnd: footerHeight
        })
    ];
}



const $12de04d549d06eb2$var$AppLayout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var { contentType: contentType = "default", headerSelector: headerSelector = "#b #h", footerSelector: footerSelector = "#b #f", navigationWidth: navigationWidth = 280, toolsWidth: toolsWidth = 290, maxContentWidth: maxContentWidth, minContentWidth: minContentWidth, navigationOpen: controlledNavigationOpen, onNavigationChange: controlledOnNavigationChange } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "contentType",
        "headerSelector",
        "footerSelector",
        "navigationWidth",
        "toolsWidth",
        "maxContentWidth",
        "minContentWidth",
        "navigationOpen",
        "onNavigationChange"
    ]);
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        if (rest.toolsOpen && rest.toolsHide) (0, $dd646455762bc7b9$export$5b28268982f175ba)("AppLayout", `You have enabled both the \`toolsOpen\` prop and the \`toolsHide\` prop. This is not supported. Set \`toolsOpen\` to \`false\` when you set \`toolsHide\` to \`true\`.`);
    }
    const { __internalRootRef: __internalRootRef } = (0, $970c67f83063979b$export$2e2bcd8739ae039)("AppLayout", {
        props: {
            contentType: contentType,
            disableContentPaddings: rest.disableContentPaddings,
            disableBodyScroll: rest.disableBodyScroll,
            navigationWidth: navigationWidth,
            navigationHide: rest.navigationHide,
            toolsHide: rest.toolsHide,
            toolsWidth: toolsWidth,
            maxContentWidth: maxContentWidth,
            minContentWidth: minContentWidth,
            stickyNotifications: rest.stickyNotifications,
            disableContentHeaderOverlap: rest.disableContentHeaderOverlap
        },
        metadata: {
            drawersCount: (_c = (_b = rest.drawers) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : null,
            hasContentHeader: !!rest.contentHeader
        }
    });
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("app-layout");
    const ariaLabels = {
        navigation: i18n("ariaLabels.navigation", (_d = rest.ariaLabels) === null || _d === void 0 ? void 0 : _d.navigation),
        navigationClose: i18n("ariaLabels.navigationClose", (_e = rest.ariaLabels) === null || _e === void 0 ? void 0 : _e.navigationClose),
        navigationToggle: i18n("ariaLabels.navigationToggle", (_f = rest.ariaLabels) === null || _f === void 0 ? void 0 : _f.navigationToggle),
        notifications: i18n("ariaLabels.notifications", (_g = rest.ariaLabels) === null || _g === void 0 ? void 0 : _g.notifications),
        tools: i18n("ariaLabels.tools", (_h = rest.ariaLabels) === null || _h === void 0 ? void 0 : _h.tools),
        toolsClose: i18n("ariaLabels.toolsClose", (_j = rest.ariaLabels) === null || _j === void 0 ? void 0 : _j.toolsClose),
        toolsToggle: i18n("ariaLabels.toolsToggle", (_k = rest.ariaLabels) === null || _k === void 0 ? void 0 : _k.toolsToggle),
        drawers: i18n("ariaLabels.drawers", (_l = rest.ariaLabels) === null || _l === void 0 ? void 0 : _l.drawers),
        drawersOverflow: i18n("ariaLabels.drawersOverflow", (_m = rest.ariaLabels) === null || _m === void 0 ? void 0 : _m.drawersOverflow),
        drawersOverflowWithBadge: i18n("ariaLabels.drawersOverflowWithBadge", (_o = rest.ariaLabels) === null || _o === void 0 ? void 0 : _o.drawersOverflowWithBadge)
    };
    const _p = (0, $bfbfeb434025eacd$export$981532776ab2217e)(contentType, {
        maxContentWidth: maxContentWidth,
        minContentWidth: minContentWidth
    }, isRefresh), { navigationOpen: defaultNavigationOpen } = _p, restDefaults = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_p, [
        "navigationOpen"
    ]);
    const [navigationOpen = false, setNavigationOpen] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledNavigationOpen, controlledOnNavigationChange, isMobile ? false : defaultNavigationOpen, {
        componentName: "AppLayout",
        controlledProp: "navigationOpen",
        changeHandler: "onNavigationChange"
    });
    const onNavigationChange = (event)=>{
        setNavigationOpen(event.detail.open);
        controlledOnNavigationChange === null || controlledOnNavigationChange === void 0 || controlledOnNavigationChange(event);
    };
    const [rootRef, placement] = (0, $9bd7f949256e7f39$export$15e0126286aabec3)(headerSelector, footerSelector);
    // This re-builds the props including the default values
    const props = Object.assign(Object.assign(Object.assign({
        contentType: contentType,
        navigationWidth: navigationWidth,
        toolsWidth: toolsWidth,
        navigationOpen: navigationOpen,
        onNavigationChange: onNavigationChange
    }, restDefaults), rest), {
        ariaLabels: ariaLabels,
        placement: placement
    });
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: (0, $adb603d9351d0211$export$74665b213cb5c4cf)(__internalRootRef, rootRef)
    }, baseProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ea8590cb86272801$export$e7b09cbd23d3aff), Object.assign({
        ref: ref
    }, props)));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($12de04d549d06eb2$var$AppLayout, "AppLayout");
var $12de04d549d06eb2$export$2e2bcd8739ae039 = $12de04d549d06eb2$var$AppLayout;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




var $22172a45fa7d5ae9$export$2e2bcd8739ae039 = {
    "flash-with-motion": "awsui_flash-with-motion_1q84n_1mepa_97",
    "enter": "awsui_enter_1q84n_1mepa_97",
    "flash-body": "awsui_flash-body_1q84n_1mepa_111",
    "flash-message": "awsui_flash-message_1q84n_1mepa_111",
    "flash-header": "awsui_flash-header_1q84n_1mepa_111",
    "flash-content": "awsui_flash-content_1q84n_1mepa_112",
    "action-button-wrapper": "awsui_action-button-wrapper_1q84n_1mepa_113",
    "dismiss-button-wrapper": "awsui_dismiss-button-wrapper_1q84n_1mepa_114",
    "flash-icon": "awsui_flash-icon_1q84n_1mepa_137",
    "entering": "awsui_entering_1q84n_1mepa_150",
    "entered": "awsui_entered_1q84n_1mepa_171",
    "exiting": "awsui_exiting_1q84n_1mepa_276",
    "stack": "awsui_stack_1q84n_1mepa_298",
    "animation-running": "awsui_animation-running_1q84n_1mepa_298",
    "item": "awsui_item_1q84n_1mepa_298",
    "flash-list-item": "awsui_flash-list-item_1q84n_1mepa_299",
    "notification-bar": "awsui_notification-bar_1q84n_1mepa_300",
    "collapsed": "awsui_collapsed_1q84n_1mepa_320",
    "animation-ready": "awsui_animation-ready_1q84n_1mepa_320",
    "expanded-only": "awsui_expanded-only_1q84n_1mepa_320",
    "expanded": "awsui_expanded_1q84n_1mepa_320",
    "flash": "awsui_flash_1q84n_1mepa_97",
    "collapsible": "awsui_collapsible_1q84n_1mepa_384",
    "short-list": "awsui_short-list_1q84n_1mepa_390",
    "visual-refresh": "awsui_visual-refresh_1q84n_1mepa_390",
    "status": "awsui_status_1q84n_1mepa_597",
    "header": "awsui_header_1q84n_1mepa_597",
    "item-count": "awsui_item-count_1q84n_1mepa_598",
    "button": "awsui_button_1q84n_1mepa_599",
    "type-count": "awsui_type-count_1q84n_1mepa_632",
    "count-number": "awsui_count-number_1q84n_1mepa_632",
    "icon": "awsui_icon_1q84n_1mepa_666",
    "floating": "awsui_floating_1q84n_1mepa_707",
    "flashbar": "awsui_flashbar_1q84n_1mepa_715",
    "flash-refresh": "awsui_flash-refresh_1q84n_1mepa_790",
    "flash-list": "awsui_flash-list_1q84n_1mepa_299",
    "flash-focus-container": "awsui_flash-focus-container_1q84n_1mepa_811",
    "flash-text": "awsui_flash-text_1q84n_1mepa_841",
    "dismiss-button": "awsui_dismiss-button_1q84n_1mepa_114",
    "breakpoint-default": "awsui_breakpoint-default_1q84n_1mepa_883",
    "action-button": "awsui_action-button_1q84n_1mepa_113",
    "action-slot": "awsui_action-slot_1q84n_1mepa_893",
    "flash-type-success": "awsui_flash-type-success_1q84n_1mepa_897",
    "flash-type-error": "awsui_flash-type-error_1q84n_1mepa_901",
    "flash-type-info": "awsui_flash-type-info_1q84n_1mepa_905",
    "flash-type-in-progress": "awsui_flash-type-in-progress_1q84n_1mepa_906",
    "flash-type-warning": "awsui_flash-type-warning_1q84n_1mepa_910"
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $3d33451aaae58ddb$export$de363e709c412c8a(func, delay, { trailing: trailing = true } = {}) {
    let pending = null;
    let lastInvokeTime = null;
    let timerId = null;
    // Runs on every animation frame until timer stopped.
    function pendingFunc() {
        if (pending === null || lastInvokeTime === null) return;
        const invokeTime = Date.now();
        const shouldInvoke = invokeTime - lastInvokeTime >= delay;
        if (shouldInvoke) {
            func.apply(pending.this, pending.args);
            lastInvokeTime = invokeTime;
            pending = null;
            timerId = null;
        } else if (trailing) startTimer();
    }
    function startTimer() {
        if (timerId) cancelAnimationFrame(timerId);
        timerId = requestAnimationFrame(pendingFunc);
    }
    // Decorated client function with delay mechanism.
    function throttled(...args) {
        if (lastInvokeTime === null) {
            lastInvokeTime = Date.now();
            func.apply(this, args);
        } else {
            pending = {
                this: this,
                args: args
            };
            startTimer();
        }
    }
    // Prevents delayed function from execution when no longer needed.
    throttled.cancel = ()=>{
        if (timerId) cancelAnimationFrame(timerId);
        pending = null;
        lastInvokeTime = null;
        timerId = null;
    };
    return throttled;
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


const $f3ef1b762a556220$export$7413227fe8c16f88 = 2000;
const $f3ef1b762a556220$var$typesToColors = {
    error: "red",
    info: "blue",
    "in-progress": "blue",
    success: "green",
    warning: "yellow"
};
function $f3ef1b762a556220$var$getColorFromType(type) {
    const defaultColor = "blue";
    return type ? $f3ef1b762a556220$var$typesToColors[type] || defaultColor : defaultColor;
}
function $f3ef1b762a556220$export$28b75a4bedf6475d(item) {
    if (item.loading) return "in-progress";
    else return item.type || "info";
}
function $f3ef1b762a556220$export$5bbd879b67a2454e(item) {
    return $f3ef1b762a556220$var$getColorFromType($f3ef1b762a556220$export$28b75a4bedf6475d(item));
}
function $f3ef1b762a556220$export$46bbf6b048090d82(items, desiredLength) {
    // First `desiredLength` items in the original array,
    // together with `isColorRepeated` to tell if they can be subject to be replaced later on if necessary
    const itemsOnTop = [];
    // Items that fall outside `desiredIndexLength` but need to be "promoted" if possible
    // because they are of a different color which otherwise wouldn't be represented
    const itemsToPromote = [];
    const addedColors = new Set();
    const allPossibleColors = Object.keys($f3ef1b762a556220$var$typesToColors).length;
    const finalLength = Math.min(items.length, desiredLength);
    for(let i = 0; i < items.length; i++){
        const item = items[i];
        const color = $f3ef1b762a556220$export$5bbd879b67a2454e(item);
        const isColorRepeated = addedColors.has(color);
        if (i < finalLength) itemsOnTop.push({
            item: Object.assign(Object.assign({}, item), {
                expandedIndex: i
            }),
            isColorRepeated: isColorRepeated
        });
        else {
            if (addedColors.size === allPossibleColors) break;
            else if (!isColorRepeated) itemsToPromote.push(Object.assign(Object.assign({}, item), {
                expandedIndex: i
            }));
        }
        addedColors.add(color);
    }
    // Generate the new array with the selected items, by picking from both arrays.
    // First, from the non-repeated items within the desired length...
    // We loop `itemsOnTop` starting from the end because we prefer to preserve the first ones rather than the old ones
    const reversedInitialSelection = [];
    let slotsReservedForPromotions = 0;
    for(let j = itemsOnTop.length - 1; j >= 0; j--){
        const item = itemsOnTop[j];
        if (item.isColorRepeated && slotsReservedForPromotions < itemsToPromote.length) slotsReservedForPromotions += 1;
        else reversedInitialSelection.push(item.item);
    }
    const selectedItems = reversedInitialSelection.reverse();
    // ...and then complete the selection with as many promotable items as we can fit in the rest of the array
    for(let k = 0; selectedItems.length < desiredLength; k++)selectedItems.push(itemsToPromote[k]);
    return selectedItems;
}
function $f3ef1b762a556220$export$bc904e7e06b11e99(items) {
    const count = {
        error: 0,
        info: 0,
        "in-progress": 0,
        success: 0,
        warning: 0
    };
    for (const item of items){
        const type = $f3ef1b762a556220$export$28b75a4bedf6475d(item);
        count[type] += 1;
    }
    return count;
}
const $f3ef1b762a556220$export$7256f2f4a100fd7 = [
    {
        type: "error",
        labelName: "errorIconAriaLabel",
        iconName: "status-negative"
    },
    {
        type: "warning",
        labelName: "warningIconAriaLabel",
        iconName: "status-warning"
    },
    {
        type: "success",
        labelName: "successIconAriaLabel",
        iconName: "status-positive"
    },
    {
        type: "info",
        labelName: "infoIconAriaLabel",
        iconName: "status-info"
    },
    {
        type: "in-progress",
        labelName: "inProgressIconAriaLabel",
        iconName: "status-in-progress"
    }
];


const $eb2ddab92622d9d1$var$metrics = new (0, $27492222c394d7f3$export$ed9166ec0f465b5e)((0, $93d122f201f7d1ff$export$e264257b4e6b5774), (0, $93d122f201f7d1ff$export$4a03ffab3315ee34));
const $eb2ddab92622d9d1$var$eventContext = "csa_flashbar";
const $eb2ddab92622d9d1$export$4942f0af3099fea8 = (items)=>{
    const countByType = (0, $f3ef1b762a556220$export$bc904e7e06b11e99)(items);
    $eb2ddab92622d9d1$var$metrics.sendPanoramaMetric({
        eventContext: $eb2ddab92622d9d1$var$eventContext,
        eventType: "render",
        eventValue: items.length.toString(),
        eventDetail: countByType
    });
};
const $eb2ddab92622d9d1$export$1d2f8519cf7a1bde = (itemsCount, expanded)=>{
    $eb2ddab92622d9d1$var$metrics.sendPanoramaMetric({
        eventContext: $eb2ddab92622d9d1$var$eventContext,
        eventType: expanded ? "expand" : "collapse",
        eventValue: itemsCount.toString()
    });
};
const $eb2ddab92622d9d1$export$b8df5493d04942d8 = (itemType)=>{
    $eb2ddab92622d9d1$var$metrics.sendPanoramaMetric({
        eventContext: $eb2ddab92622d9d1$var$eventContext,
        eventType: "dismiss",
        eventValue: itemType
    });
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $a773f3a2497f02b1$var$convertRuntimeAction(action, context) {
    if (!action) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e5302bcc569601f$export$4943976e4fdbb0cd), {
        key: action.id + "-" + context.type,
        mountContent: (container)=>action.mountContent(container, context),
        unmountContent: (container)=>action.unmountContent(container)
    });
}
function $a773f3a2497f02b1$export$43997369e47eb864(onActionRegistered) {
    return function useDiscoveredAction(type) {
        const [discoveredActions, setDiscoveredActions] = (0, $acw62.useState)([]);
        const headerRef = (0, $acw62.useRef)(null);
        const contentRef = (0, $acw62.useRef)(null);
        (0, $acw62.useEffect)(()=>{
            return onActionRegistered((actions)=>{
                setDiscoveredActions(actions.map((action)=>$a773f3a2497f02b1$var$convertRuntimeAction(action, {
                        type: type,
                        headerRef: headerRef,
                        contentRef: contentRef
                    })));
            });
        }, [
            type
        ]);
        return {
            discoveredActions: discoveredActions,
            headerRef: headerRef,
            contentRef: contentRef
        };
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");

var $0856f1407cdf9bef$export$2e2bcd8739ae039 = {
    "root": "awsui_root_37gf8_14wux_9"
};



function $d276899a8d82cf05$var$createActionButton(testUtilClasses, action, buttonText, onButtonClick) {
    if (!action && buttonText) action = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        className: testUtilClasses.actionButton,
        onClick: onButtonClick,
        formAction: "none"
    }, buttonText);
    return action ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: testUtilClasses.actionSlot
    }, action) : null;
}
function $d276899a8d82cf05$export$c8223871eecc8f3a({ className: className, testUtilClasses: testUtilClasses, action: action, discoveredActions: discoveredActions, buttonText: buttonText, onButtonClick: onButtonClick }) {
    const actionButton = $d276899a8d82cf05$var$createActionButton(testUtilClasses, action, buttonText, onButtonClick);
    if (!actionButton && discoveredActions.length === 0) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $0856f1407cdf9bef$export$2e2bcd8739ae039).root, className)
    }, actionButton, discoveredActions);
}





const $7ea138ef7d1e02a7$var$ICON_TYPES = {
    success: "status-positive",
    warning: "status-warning",
    info: "status-info",
    error: "status-negative",
    "in-progress": "status-in-progress"
};
const $7ea138ef7d1e02a7$var$useDiscoveredAction = (0, $a773f3a2497f02b1$export$43997369e47eb864)((0, $2ec6e52915a41fcf$export$90753eb139627d74).flashbar.onActionRegistered);
function $7ea138ef7d1e02a7$var$dismissButton(dismissLabel, onDismiss) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["dismiss-button-wrapper"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        onClick: onDismiss,
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["dismiss-button"],
        variant: "flashbar-icon",
        iconName: "close",
        formAction: "none",
        ariaLabel: dismissLabel
    }));
}
const $7ea138ef7d1e02a7$export$c30a2af81d342722 = (0, $3d33451aaae58ddb$export$de363e709c412c8a)((element, itemId)=>{
    var _a;
    const selector = `[data-itemid="${CSS.escape(itemId)}"] .${(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-focus-container"]}`;
    (_a = element === null || element === void 0 ? void 0 : element.querySelector(selector)) === null || _a === void 0 || _a.focus();
}, (0, $f3ef1b762a556220$export$7413227fe8c16f88), {
    trailing: false
});
const $7ea138ef7d1e02a7$export$d02c4befa38bdff8 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { id: id, header: header, content: content, dismissible: dismissible, dismissLabel: dismissLabel, loading: loading, action: action, buttonText: buttonText, onButtonClick: onButtonClick, onDismiss: onDismiss, className: className, transitionState: transitionState, ariaRole: ariaRole, i18nStrings: i18nStrings, type: type = "info" } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "id",
        "header",
        "content",
        "dismissible",
        "dismissLabel",
        "loading",
        "action",
        "buttonText",
        "onButtonClick",
        "onDismiss",
        "className",
        "transitionState",
        "ariaRole",
        "i18nStrings",
        "type"
    ]);
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        if (buttonText && !onButtonClick) (0, $dd646455762bc7b9$export$5b28268982f175ba)("Flashbar", `You provided a \`buttonText\` prop without an \`onButtonClick\` handler. This will render a non-interactive action button.`);
        if (dismissible && !onDismiss) (0, $dd646455762bc7b9$export$5b28268982f175ba)("Flashbar", `You have set the \`dismissible\` prop without an \`onDismiss\` handler. This will render a non-interactive dismiss button.`);
    }
    const analyticsMetadata = (0, $75a0355e989dd450$export$dba32c398c4b8fa1)(props);
    const elementRef = (0, $ccdf93292345e76e$export$9e6be7bb393f4fdd)("Flash", (0, $93d122f201f7d1ff$export$4a03ffab3315ee34), Object.assign({}, analyticsMetadata));
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(ref, elementRef);
    const { discoveredActions: discoveredActions, headerRef: headerRef, contentRef: contentRef } = $7ea138ef7d1e02a7$var$useDiscoveredAction(type);
    const iconType = $7ea138ef7d1e02a7$var$ICON_TYPES[type];
    const icon = loading ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1101525b84777b8e$export$2e2bcd8739ae039), null) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: iconType
    });
    const effectiveType = loading ? "info" : type;
    const handleDismiss = (event)=>{
        (0, $eb2ddab92622d9d1$export$b8df5493d04942d8)(effectiveType);
        onDismiss && onDismiss(event);
    };
    const analyticsAttributes = {
        [(0, $285a09b860d2bebc$export$5acc5b69fd3e0afc)]: effectiveType
    };
    const statusIconAriaLabel = props.statusIconAriaLabel || (i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings[`${loading || type === "in-progress" ? "inProgress" : type}IconAriaLabel`]);
    return(// We're not using "polite" or "assertive" here, just turning default behavior off.
    // eslint-disable-next-line @cloudscape-design/prefer-live-region
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: mergedRef,
        role: ariaRole,
        "aria-live": ariaRole ? "off" : undefined,
        "data-itemid": id,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).flash, (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)[`flash-type-${effectiveType}`], className, transitionState && {
            [(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).enter]: transitionState === "enter",
            [(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).entering]: transitionState === "entering",
            [(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).entered]: transitionState === "entered",
            [(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).exit]: transitionState === "exit",
            [(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).exiting]: transitionState === "exiting",
            [(0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).exited]: transitionState === "exited"
        }, (0, $8856d0c7df08fd8d$export$6c7ba3d6c6708d3)(type === "warning" && !loading ? "flashbar-warning" : "flashbar"))
    }, analyticsAttributes), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-body"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-focus-container"],
        tabIndex: -1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-icon"], (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-text"]),
        role: "img",
        "aria-label": statusIconAriaLabel
    }, icon), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-message"], (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-text"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-header"],
        ref: headerRef
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-content"],
        ref: contentRef
    }, content))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d276899a8d82cf05$export$c8223871eecc8f3a), {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["action-button-wrapper"],
        testUtilClasses: {
            actionSlot: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["action-slot"],
            actionButton: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["action-button"]
        },
        action: action,
        discoveredActions: discoveredActions,
        buttonText: buttonText,
        onButtonClick: onButtonClick
    })), dismissible && $7ea138ef7d1e02a7$var$dismissButton(dismissLabel, handleDismiss), ariaRole === "status" && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), {
        source: [
            statusIconAriaLabel,
            headerRef,
            contentRef
        ]
    })));
});




function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}


function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, "appear", props),
            enter: $04540450bf60efa1$var$getProp(child, "enter", props),
            exit: $04540450bf60efa1$var$getProp(child, "exit", props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, "exit", nextProps),
            enter: $04540450bf60efa1$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, "exit", nextProps),
            enter: $04540450bf60efa1$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $04540450bf60efa1$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $04540450bf60efa1$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $04540450bf60efa1$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $3598f7c3986914de$export$2c8afa89e423ed39(elements) {
    const rects = {};
    for(const id in elements){
        const element = elements[id];
        if (element) rects[id] = element.getBoundingClientRect();
    }
    return rects;
}
function $3598f7c3986914de$export$e3607ec2d7a891c4({ oldState: oldState, elements: elements, onTransitionsEnd: onTransitionsEnd, newElementInitialState: newElementInitialState }) {
    // First, apply the transform that will make the elements "look like" in the start position
    for(const id in elements){
        const element = elements[id];
        const oldRect = oldState[id];
        if (element) {
            const newRect = element.getBoundingClientRect();
            const noOpTransform = {
                scale: 1,
                x: 0,
                y: 0
            };
            // Calculate initial position.
            // If the element didn't exist previously, use the newElementInitialState function if provided.
            // If not, default to no transitions (scale: 1, y: 0)
            const calculatedInverseTransform = oldRect ? {
                scale: oldRect.width / newRect.width,
                x: (oldRect.left + oldRect.right) / 2 - (newRect.left + newRect.right) / 2,
                y: (oldRect.top + oldRect.bottom) / 2 - (newRect.top + newRect.bottom) / 2
            } : newElementInitialState ? newElementInitialState(newRect) : {};
            const inverseTransform = Object.assign(Object.assign({}, noOpTransform), calculatedInverseTransform);
            // Apply this initial change, without animating
            element.style.transitionProperty = "none";
            element.style.transform = `scale(${inverseTransform.scale}) translate(${inverseTransform.x}px, ${inverseTransform.y}px)`;
            if (!oldRect) // If the element didn't exist, then fade it in
            // (besides any other possibly defined transitions based on `newElementInitialState`)
            element.style.opacity = "0";
        }
    }
    // Animate from the initial state to the end state
    requestAnimationFrame(()=>{
        const ongoingAnimations = new Set();
        for(const id in elements){
            const element = elements[id];
            if (element) {
                const oldRect = oldState[id];
                if (oldRect) {
                    // Animate from here on
                    element.style.transitionProperty = `transform`;
                    // Unset inline CSS transforms so that the final state is applied
                    element.style.transform = "";
                } else {
                    // If the element didn't exist previously, fade in as well
                    element.style.transitionProperty = `transform, opacity`;
                    element.style.transform = "";
                    element.style.opacity = "";
                }
                const onTransitionStart = (event)=>{
                    if (event.target === element) {
                        ongoingAnimations.add(id);
                        element.removeEventListener("transitionstart", onTransitionStart);
                    }
                };
                const onTransitionEnd = (event)=>{
                    if (event.target === element) {
                        // Clean up remaining inline styles
                        element.style.transitionProperty = "";
                        element.removeEventListener("transitionstart", onTransitionEnd);
                        if (onTransitionsEnd) {
                            ongoingAnimations.delete(id);
                            if (ongoingAnimations.size === 0) onTransitionsEnd();
                        }
                    }
                };
                element.addEventListener("transitionstart", onTransitionStart);
                element.addEventListener("transitionend", onTransitionEnd);
            }
        }
    });
}








var $acw62 = parcelRequire("acw62");


function $921c3f4037759790$export$2aa1887afbd6d218(triggers) {
    // triggers.join() gives us a stable value to use for the dependencies argument
    const triggersDep = triggers === null || triggers === void 0 ? void 0 : triggers.join();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $6e052e2d296ab854$export$2e2bcd8739ae039)((rect)=>(0, $1be283cfa47851a8$export$21bc4262e291071d)(rect.contentBoxWidth, triggers), [
        triggersDep
    ]);
}







function $be55b1acbb6c5660$export$7552e9d189822810(_a) {
    var { items: items, onItemsAdded: onItemsAdded, onItemsChanged: onItemsChanged, onItemsRemoved: onItemsRemoved } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "items",
        "onItemsAdded",
        "onItemsChanged",
        "onItemsRemoved"
    ]);
    const { __internalRootRef: __internalRootRef } = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Flashbar", {
        props: {
            stackItems: restProps.stackItems
        }
    });
    const allItemsHaveId = (0, $acw62.useMemo)(()=>items.every((item)=>"id" in item), [
        items
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const ref = (0, $acw62.useRef)(null);
    const [breakpoint, breakpointRef] = (0, $921c3f4037759790$export$2aa1887afbd6d218)([
        "xs"
    ]);
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(ref, breakpointRef, __internalRootRef);
    const isReducedMotion = (0, $020c722843a7a503$export$6a42007cf1e7b6f8)(ref);
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const [previousItems, setPreviousItems] = (0, $acw62.useState)(items);
    const [nextFocusId, setNextFocusId] = (0, $acw62.useState)(null);
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        if (items === null || items === void 0 ? void 0 : items.some((item)=>item.ariaRole === "alert" && !item.id)) (0, $dd646455762bc7b9$export$5b28268982f175ba)("Flashbar", `You provided \`ariaRole="alert"\` for a flashbar item without providing an \`id\`. Focus will not be moved to the newly added flash message.`);
    }
    // Track new or removed item IDs in state to only trigger focus changes for newly added items.
    // https://reactjs.org/docs/hooks-faq.html#how-do-i-implement-getderivedstatefromprops
    if (items) {
        const newItems = items.filter(({ id: id })=>id && !previousItems.some((item)=>item.id === id));
        const removedItems = previousItems.filter(({ id: id })=>id && !items.some((item)=>item.id === id));
        if (newItems.length > 0 || removedItems.length > 0) {
            setPreviousItems(items);
            onItemsAdded === null || onItemsAdded === void 0 || onItemsAdded(newItems);
            onItemsRemoved === null || onItemsRemoved === void 0 || onItemsRemoved(removedItems);
            onItemsChanged === null || onItemsChanged === void 0 || onItemsChanged({
                allItemsHaveId: allItemsHaveId,
                isReducedMotion: isReducedMotion
            });
            const newFocusItems = newItems.filter(({ ariaRole: ariaRole })=>ariaRole === "alert");
            if (newFocusItems.length > 0) setNextFocusId(newFocusItems[0].id);
        }
    }
    (0, $acw62.useEffect)(()=>{
        if (nextFocusId) (0, $7ea138ef7d1e02a7$export$c30a2af81d342722)(ref.current, nextFocusId);
    }, [
        nextFocusId,
        ref
    ]);
    return {
        allItemsHaveId: allItemsHaveId,
        baseProps: baseProps,
        breakpoint: breakpoint,
        isReducedMotion: isReducedMotion,
        isVisualRefresh: isVisualRefresh,
        mergedRef: mergedRef,
        ref: ref
    };
}








// If the number of items is equal or less than this value,
// the toggle element will not be displayed and the Flashbar will look like a regular single-item Flashbar.
const $6c57dec6dcc18848$var$maxNonCollapsibleItems = 1;
const $6c57dec6dcc18848$var$resizeListenerThrottleDelay = 100;
function $6c57dec6dcc18848$export$2e2bcd8739ae039(_a) {
    var { items: items } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "items"
    ]);
    const [enteringItems, setEnteringItems] = (0, $acw62.useState)([]);
    const [exitingItems, setExitingItems] = (0, $acw62.useState)([]);
    const [isFlashbarStackExpanded, setIsFlashbarStackExpanded] = (0, $acw62.useState)(false);
    const getElementsToAnimate = (0, $acw62.useCallback)(()=>{
        const flashElements = isFlashbarStackExpanded ? expandedItemRefs.current : collapsedItemRefs.current;
        return Object.assign(Object.assign({}, flashElements), {
            notificationBar: notificationBarRef.current
        });
    }, [
        isFlashbarStackExpanded
    ]);
    const prepareAnimations = (0, $acw62.useCallback)(()=>{
        const rects = (0, $3598f7c3986914de$export$2c8afa89e423ed39)(getElementsToAnimate());
        setInitialAnimationState(rects);
    }, [
        getElementsToAnimate
    ]);
    const { baseProps: baseProps, breakpoint: breakpoint, isReducedMotion: isReducedMotion, isVisualRefresh: isVisualRefresh, mergedRef: mergedRef, ref: ref } = (0, $be55b1acbb6c5660$export$7552e9d189822810)(Object.assign(Object.assign({
        items: items
    }, restProps), {
        onItemsAdded: (newItems)=>{
            setEnteringItems([
                ...enteringItems,
                ...newItems
            ]);
        },
        onItemsChanged: (options)=>{
            // If not all items have ID, we can still animate collapse/expand transitions
            // because we can rely on each item's index in the original array,
            // but we can't do that when elements are added or removed, since the index changes.
            if ((options === null || options === void 0 ? void 0 : options.allItemsHaveId) && !(options === null || options === void 0 ? void 0 : options.isReducedMotion)) prepareAnimations();
        },
        onItemsRemoved: (removedItems)=>{
            setExitingItems([
                ...exitingItems,
                ...removedItems
            ]);
        }
    }));
    const collapsedItemRefs = (0, $acw62.useRef)({});
    const expandedItemRefs = (0, $acw62.useRef)({});
    const [initialAnimationState, setInitialAnimationState] = (0, $acw62.useState)(null);
    const listElementRef = (0, $acw62.useRef)(null);
    const notificationBarRef = (0, $acw62.useRef)(null);
    const [transitioning, setTransitioning] = (0, $acw62.useState)(false);
    const flashbarElementId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("flashbar");
    const itemCountElementId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("item-count");
    if (items.length <= $6c57dec6dcc18848$var$maxNonCollapsibleItems && isFlashbarStackExpanded) setIsFlashbarStackExpanded(false);
    const animateFlash = !isReducedMotion;
    function toggleCollapseExpand() {
        (0, $eb2ddab92622d9d1$export$1d2f8519cf7a1bde)(items.length, !isFlashbarStackExpanded);
        if (!isReducedMotion) prepareAnimations();
        setIsFlashbarStackExpanded((prev)=>!prev);
    }
    (0, $acw62.useLayoutEffect)(()=>{
        if (isFlashbarStackExpanded && (items === null || items === void 0 ? void 0 : items.length)) {
            const mostRecentItem = items[0];
            if (mostRecentItem.id !== undefined) (0, $7ea138ef7d1e02a7$export$c30a2af81d342722)(ref.current, mostRecentItem.id);
        }
    // Run this after expanding, but not every time the items change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFlashbarStackExpanded
    ]);
    // When collapsing, scroll up if necessary to avoid losing track of the focused button
    (0, $134bbee1801695be$export$21dfe79102a9caab)(()=>{
        if (!isFlashbarStackExpanded && notificationBarRef.current) (0, $24d40242cc6554ee$export$a904af9c1628c179)(notificationBarRef.current);
    }, [
        isFlashbarStackExpanded
    ]);
    const updateBottomSpacing = (0, $acw62.useMemo)(()=>(0, $3d33451aaae58ddb$export$de363e709c412c8a)(()=>{
            // Allow vertical space between Flashbar and page bottom only when the Flashbar is reaching the end of the page,
            // otherwise avoid spacing with eventual sticky elements below.
            const listElement = listElementRef === null || listElementRef === void 0 ? void 0 : listElementRef.current;
            const flashbar = listElement === null || listElement === void 0 ? void 0 : listElement.parentElement;
            if (listElement && flashbar) {
                // Make sure the bottom padding is present when we make the calculations,
                // then we might decide to remove it or not.
                flashbar.classList.remove((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).floating);
                const windowHeight = window.innerHeight;
                // Take the parent region into account if using the App Layout, because it might have additional margins.
                // Otherwise we use the Flashbar component for this calculation.
                const outerElement = (0, $38f6480185c49d6f$export$184ef262a758e3c4)(flashbar, (element)=>element.getAttribute("role") === "region") || flashbar;
                const applySpacing = isFlashbarStackExpanded && Math.ceil(outerElement.getBoundingClientRect().bottom) >= windowHeight;
                if (!applySpacing) flashbar.classList.add((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).floating);
            }
        }, $6c57dec6dcc18848$var$resizeListenerThrottleDelay), [
        isFlashbarStackExpanded
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        window.addEventListener("resize", updateBottomSpacing);
        return ()=>{
            window.removeEventListener("resize", updateBottomSpacing);
            updateBottomSpacing.cancel();
        };
    }, [
        updateBottomSpacing
    ]);
    const { i18nStrings: i18nStrings } = restProps;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("flashbar");
    const ariaLabel = i18n("i18nStrings.ariaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.ariaLabel);
    const notificationBarText = i18n("i18nStrings.notificationBarText", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.notificationBarText);
    const notificationBarAriaLabel = i18n("i18nStrings.notificationBarAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.notificationBarAriaLabel);
    const iconAriaLabels = {
        errorIconAriaLabel: i18n("i18nStrings.errorIconAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.errorIconAriaLabel),
        inProgressIconAriaLabel: i18n("i18nStrings.inProgressIconAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.inProgressIconAriaLabel),
        infoIconAriaLabel: i18n("i18nStrings.infoIconAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.infoIconAriaLabel),
        successIconAriaLabel: i18n("i18nStrings.successIconAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.successIconAriaLabel),
        warningIconAriaLabel: i18n("i18nStrings.warningIconAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.warningIconAriaLabel)
    };
    (0, $acw62.useLayoutEffect)(()=>{
        // When `useLayoutEffect` is called, the DOM is updated but has not been painted yet,
        // so it's a good moment to trigger animations that will make calculations based on old and new DOM state.
        // The old state is kept in `initialAnimationState`
        // and the new state can be retrieved from the current DOM elements.
        if (initialAnimationState) {
            updateBottomSpacing();
            (0, $3598f7c3986914de$export$e3607ec2d7a891c4)({
                elements: getElementsToAnimate(),
                oldState: initialAnimationState,
                newElementInitialState: ({ top: top })=>({
                        scale: 0.9,
                        y: -0.2 * top
                    }),
                onTransitionsEnd: ()=>setTransitioning(false)
            });
            setTransitioning(true);
            setInitialAnimationState(null);
        }
    }, [
        updateBottomSpacing,
        getElementsToAnimate,
        initialAnimationState,
        isFlashbarStackExpanded
    ]);
    const isCollapsible = items.length > $6c57dec6dcc18848$var$maxNonCollapsibleItems;
    const countByType = (0, $f3ef1b762a556220$export$bc904e7e06b11e99)(items);
    const numberOfColorsInStack = new Set(items.map((0, $f3ef1b762a556220$export$5bbd879b67a2454e))).size;
    const maxSlots = Math.max(numberOfColorsInStack, 3);
    const stackDepth = Math.min(maxSlots, items.length);
    const itemsToShow = isFlashbarStackExpanded ? items.map((item, index)=>Object.assign(Object.assign({}, item), {
            expandedIndex: index
        })) : (0, $f3ef1b762a556220$export$46bbf6b048090d82)(items, stackDepth).map((item, index)=>Object.assign(Object.assign({}, item), {
            collapsedIndex: index
        }));
    const getItemId = (item)=>{
        var _a, _b;
        return (_b = (_a = item.id) !== null && _a !== void 0 ? _a : item.expandedIndex) !== null && _b !== void 0 ? _b : 0;
    };
    // This check allows us to use the standard "enter" Transition only when the notification was not existing before.
    // If instead it was moved to the top of the stack but was already present in the array
    // (e.g, after dismissing another notification),
    // we need to use different, more custom and more controlled animations.
    const hasEntered = (item)=>enteringItems.some((_item)=>_item.id && _item.id === item.id);
    const hasLeft = (item)=>!("expandedIndex" in item);
    const hasEnteredOrLeft = (item)=>hasEntered(item) || hasLeft(item);
    const showInnerContent = (item)=>isFlashbarStackExpanded || hasLeft(item) || "expandedIndex" in item && item.expandedIndex === 0;
    const shouldUseStandardAnimation = (item, index)=>index === 0 && hasEnteredOrLeft(item);
    const getAnimationElementId = (item)=>`flash-${getItemId(item)}`;
    const renderList = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            ref: listElementRef,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-list"], isFlashbarStackExpanded ? (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).expanded : (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).collapsed, transitioning && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["animation-running"], initialAnimationState && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["animation-ready"], isVisualRefresh && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["visual-refresh"]),
            id: flashbarElementId,
            "aria-label": ariaLabel,
            "aria-describedby": isCollapsible ? itemCountElementId : undefined,
            style: !isFlashbarStackExpanded || transitioning ? {
                [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).flashbarStackDepth]: stackDepth
            } : undefined
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6c57dec6dcc18848$var$ListWrapper, {
            withMotion: !isReducedMotion
        }, itemsToShow.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
                key: getItemId(item),
                in: !hasLeft(item),
                onStatusChange: (status)=>{
                    if (status === "entered") setEnteringItems([]);
                    else if (status === "exited") setExitingItems([]);
                }
            }, (state, transitionRootElement)=>{
                var _a, _b, _c;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                    "aria-hidden": !showInnerContent(item),
                    className: showInnerContent(item) ? (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-list-item"], !isFlashbarStackExpanded && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).item, !collapsedItemRefs.current[getAnimationElementId(item)] && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["expanded-only"]) : (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).flash, (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)[`flash-type-${(_a = item.type) !== null && _a !== void 0 ? _a : "info"}`], (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).item),
                    ref: (element)=>{
                        if (isFlashbarStackExpanded) expandedItemRefs.current[getAnimationElementId(item)] = element;
                        else collapsedItemRefs.current[getAnimationElementId(item)] = element;
                    },
                    style: !isFlashbarStackExpanded || transitioning ? {
                        [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).flashbarStackIndex]: (_c = (_b = item.collapsedIndex) !== null && _b !== void 0 ? _b : item.expandedIndex) !== null && _c !== void 0 ? _c : index
                    } : undefined,
                    key: getItemId(item)
                }, showInnerContent(item) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ea138ef7d1e02a7$export$d02c4befa38bdff8), Object.assign({
                    // eslint-disable-next-line react/forbid-component-props
                    className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(animateFlash && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-with-motion"], isVisualRefresh && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-refresh"]),
                    key: getItemId(item),
                    ref: shouldUseStandardAnimation(item, index) ? transitionRootElement : undefined,
                    transitionState: shouldUseStandardAnimation(item, index) ? state : undefined,
                    i18nStrings: iconAriaLabels
                }, item)));
            }))));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).flashbar, (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)[`breakpoint-${breakpoint}`], (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).stack, isCollapsible && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).collapsible, items.length === 2 && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["short-list"], isFlashbarStackExpanded && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).expanded, isVisualRefresh && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["visual-refresh"]),
        ref: mergedRef
    }), isFlashbarStackExpanded && renderList(), isCollapsible && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["notification-bar"], isVisualRefresh && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["visual-refresh"], isFlashbarStackExpanded ? (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).expanded : (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).collapsed, transitioning && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["animation-running"], items.length === 2 && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["short-list"], (0, $8856d0c7df08fd8d$export$6c7ba3d6c6708d3)("flashbar") // Visual context is needed for focus ring to be white
        ),
        onClick: toggleCollapseExpand,
        ref: notificationBarRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-live": "polite",
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).status,
        role: "status",
        id: itemCountElementId
    }, notificationBarText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).header
    }, notificationBarText), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["item-count"]
    }, (0, $f3ef1b762a556220$export$7256f2f4a100fd7).map(({ type: type, labelName: labelName, iconName: iconName })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6c57dec6dcc18848$var$NotificationTypeCount, {
            key: type,
            iconName: iconName,
            label: iconAriaLabels[labelName],
            count: countByType[type]
        })))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-controls": flashbarElementId,
        "aria-describedby": itemCountElementId,
        "aria-expanded": isFlashbarStackExpanded,
        "aria-label": notificationBarAriaLabel,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).button, isFlashbarStackExpanded && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).expanded)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).icon,
        size: "normal",
        name: "angle-down"
    }))), !isFlashbarStackExpanded && renderList());
}
const $6c57dec6dcc18848$var$NotificationTypeCount = ({ iconName: iconName, label: label, count: count })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["type-count"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-label": label,
        role: "img"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        title: label,
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: iconName
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["count-number"]
    }, count));
};
const $6c57dec6dcc18848$var$ListWrapper = ({ children: children, withMotion: withMotion })=>withMotion ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
        component: null
    }, children) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);





var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This is a delay that delays the `entering` transition state
 * for the flashbar to be executed, this is useful for:
 * - If a flashbar is exiting and another is entering at the same time we'd want to delay the entering to
 * prevent the jumping in the layout
 * The current animation time for the exiting can be found in motion.scss which is equivilant to 115ms,
 * if in the future this value is changed for the exiting animation we'll have to change this as well to match it
 */ const $5d1964865bfeee82$export$a1a178fbad7f15f6 = 115;







function $1928fa3d1e93457e$export$2e2bcd8739ae039(_a) {
    var { items: items, i18nStrings: i18nStrings } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "items",
        "i18nStrings"
    ]);
    const { allItemsHaveId: allItemsHaveId, baseProps: baseProps, breakpoint: breakpoint, isReducedMotion: isReducedMotion, isVisualRefresh: isVisualRefresh, mergedRef: mergedRef } = (0, $be55b1acbb6c5660$export$7552e9d189822810)(Object.assign({
        items: items
    }, restProps));
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("flashbar");
    const ariaLabel = i18n("i18nStrings.ariaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.ariaLabel);
    const iconAriaLabels = {
        errorIconAriaLabel: i18n("i18nStrings.errorIconAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.errorIconAriaLabel),
        inProgressIconAriaLabel: i18n("i18nStrings.inProgressIconAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.inProgressIconAriaLabel),
        infoIconAriaLabel: i18n("i18nStrings.infoIconAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.infoIconAriaLabel),
        successIconAriaLabel: i18n("i18nStrings.successIconAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.successIconAriaLabel),
        warningIconAriaLabel: i18n("i18nStrings.warningIconAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.warningIconAriaLabel)
    };
    /**
     * All the flash items should have ids so we can identify which DOM element is being
     * removed from the DOM to animate it. Motion will be disabled if any of the provided
     * flash messages does not contain an `id`.
     */ const motionDisabled = isReducedMotion || !isVisualRefresh || !allItemsHaveId;
    const animateFlash = !isReducedMotion && isVisualRefresh;
    /**
     * If the flashbar is flat and motion is `enabled` then the adding and removing of items
     * from the flashbar will render with visual transitions.
     */ function renderFlatItemsWithTransitions() {
        if (motionDisabled || !items) return;
        return(// This is a proxy for <ul>, so we're not applying a class to another actual component.
        // eslint-disable-next-line react/forbid-component-props
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
            component: "ul",
            className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-list"],
            "aria-label": ariaLabel
        }, items.map((item, index)=>{
            var _a;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
                transitionChangeDelay: {
                    entering: (0, $5d1964865bfeee82$export$a1a178fbad7f15f6)
                },
                key: (_a = item.id) !== null && _a !== void 0 ? _a : index,
                in: true
            }, (state, transitionRootElement)=>{
                var _a;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                    className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-list-item"]
                }, renderItem(item, (_a = item.id) !== null && _a !== void 0 ? _a : index, transitionRootElement, state));
            });
        })));
    }
    /**
     * If the flashbar is flat and motion is `disabled` then the adding and removing of items
     * from the flashbar will render without visual transitions.
     */ function renderFlatItemsWithoutTransitions() {
        if (!motionDisabled || !items) return;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-list"],
            "aria-label": ariaLabel
        }, items.map((item, index)=>{
            var _a, _b;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                key: (_a = item.id) !== null && _a !== void 0 ? _a : index,
                className: (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-list-item"]
            }, renderItem(item, (_b = item.id) !== null && _b !== void 0 ? _b : index));
        }));
    }
    /**
     * This is a shared render function for a single flashbar item to be used
     * by the stacking, motion, and non-motion item group render functions.
     */ function renderItem(item, key, transitionRootElement, transitionState) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ea138ef7d1e02a7$export$d02c4befa38bdff8), Object.assign({
            // eslint-disable-next-line react/forbid-component-props
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(animateFlash && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-with-motion"], isVisualRefresh && (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)["flash-refresh"]),
            key: key,
            ref: transitionRootElement,
            transitionState: transitionState,
            i18nStrings: iconAriaLabels
        }, item));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039).flashbar, (0, $22172a45fa7d5ae9$export$2e2bcd8739ae039)[`breakpoint-${breakpoint}`]),
        ref: mergedRef
    }), renderFlatItemsWithTransitions(), renderFlatItemsWithoutTransitions());
}



function $295a537205c57cb7$export$2e2bcd8739ae039(props) {
    (0, $acw62.useEffect)(()=>{
        if (props.items.length > 0) (0, $eb2ddab92622d9d1$export$4942f0af3099fea8)(props.items);
    }, [
        props.items
    ]);
    if (props.stackItems) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6c57dec6dcc18848$export$2e2bcd8739ae039), Object.assign({}, props));
    else return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1928fa3d1e93457e$export$2e2bcd8739ae039), Object.assign({}, props));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($295a537205c57cb7$export$2e2bcd8739ae039, "Flashbar");



var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}


function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



var $acw62 = parcelRequire("acw62");



var $ee2e736fe07a2c40$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $620ffe1c3bcccf8e$export$2e2bcd8739ae039)(node, c);
    });
};
var $ee2e736fe07a2c40$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $c22b31c675df16bf$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $ee2e736fe07a2c40$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $ee2e736fe07a2c40$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $ee2e736fe07a2c40$var$removeClass(node, baseClassName);
        if (activeClassName) $ee2e736fe07a2c40$var$removeClass(node, activeClassName);
        if (doneClassName) $ee2e736fe07a2c40$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0fef977f04119bf5$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ee2e736fe07a2c40$var$CSSTransition.defaultProps = {
    classNames: ""
};
$ee2e736fe07a2c40$var$CSSTransition.propTypes = {};
var $ee2e736fe07a2c40$export$2e2bcd8739ae039 = $ee2e736fe07a2c40$var$CSSTransition;









var $8ec66faffacc81ba$export$2e2bcd8739ae039 = {
    "content-enter": "awsui_content-enter_gwq0h_8rjzz_101",
    "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_8rjzz_1",
    "trigger-expanded": "awsui_trigger-expanded_gwq0h_8rjzz_123",
    "icon": "awsui_icon_gwq0h_8rjzz_137",
    "root": "awsui_root_gwq0h_8rjzz_155",
    "expand-button": "awsui_expand-button_gwq0h_8rjzz_193",
    "expanded": "awsui_expanded_gwq0h_8rjzz_201",
    "icon-container": "awsui_icon-container_gwq0h_8rjzz_211",
    "icon-container-container": "awsui_icon-container-container_gwq0h_8rjzz_215",
    "wrapper": "awsui_wrapper_gwq0h_8rjzz_219",
    "wrapper-default": "awsui_wrapper-default_gwq0h_8rjzz_227",
    "wrapper-footer": "awsui_wrapper-footer_gwq0h_8rjzz_227",
    "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_8rjzz_231",
    "wrapper-container": "awsui_wrapper-container_gwq0h_8rjzz_234",
    "wrapper-compact": "awsui_wrapper-compact_gwq0h_8rjzz_238",
    "header-deprecated": "awsui_header-deprecated_gwq0h_8rjzz_251",
    "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_8rjzz_273",
    "header": "awsui_header_gwq0h_8rjzz_251",
    "header-wrapper": "awsui_header-wrapper_gwq0h_8rjzz_293",
    "header-actions-wrapper": "awsui_header-actions-wrapper_gwq0h_8rjzz_305",
    "header-button": "awsui_header-button_gwq0h_8rjzz_310",
    "header-container-button": "awsui_header-container-button_gwq0h_8rjzz_310",
    "header-container": "awsui_header-container_gwq0h_8rjzz_310",
    "header-navigation": "awsui_header-navigation_gwq0h_8rjzz_345",
    "header-text": "awsui_header-text_gwq0h_8rjzz_382",
    "content": "awsui_content_gwq0h_8rjzz_101",
    "content-default": "awsui_content-default_gwq0h_8rjzz_389",
    "content-footer": "awsui_content-footer_gwq0h_8rjzz_393",
    "content-expanded": "awsui_content-expanded_gwq0h_8rjzz_397",
    "content-compact": "awsui_content-compact_gwq0h_8rjzz_400",
    "focusable": "awsui_focusable_gwq0h_8rjzz_404",
    "click-target": "awsui_click-target_gwq0h_8rjzz_419"
};






var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





function $6ffd179a45e998fe$export$e9684832087ed7c6({ isMobile: isMobile, __stickyOffset: __stickyOffset, __mobileStickyOffset: __mobileStickyOffset, hasInnerOverflowParents: hasInnerOverflowParents, __additionalOffset: __additionalOffset }) {
    const localOffset = isMobile ? (__stickyOffset !== null && __stickyOffset !== void 0 ? __stickyOffset : 0) - (__mobileStickyOffset !== null && __mobileStickyOffset !== void 0 ? __mobileStickyOffset : 0) : __stickyOffset !== null && __stickyOffset !== void 0 ? __stickyOffset : 0;
    if (hasInnerOverflowParents || __stickyOffset !== undefined) return `${localOffset}px`;
    const globalOffset = `var(${(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalTopOffset}, 0px)`;
    return `calc(${globalOffset} + ${localOffset}px + ${__additionalOffset ? $17a6dd8285442c36$export$3af9271f55a32e1a : "0px"})`;
}
const $6ffd179a45e998fe$export$277266c55937e104 = (0, $acw62.createContext)({
    isStuck: false
});
const $6ffd179a45e998fe$export$3a5ae2edeb8648ad = (rootRef, headerRef, __stickyHeader, __stickyOffset, __mobileStickyOffset, __disableMobile, __additionalOffset = false)=>{
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const disableSticky = isMobile && __disableMobile;
    const isSticky = !disableSticky && !!__stickyHeader;
    // If it has overflow parents inside the app layout, we shouldn't apply a sticky offset.
    const [hasInnerOverflowParents, setHasInnerOverflowParents] = (0, $acw62.useState)(false);
    const [isStuck, setIsStuck] = (0, $acw62.useState)(false);
    (0, $acw62.useLayoutEffect)(()=>{
        if (rootRef.current) {
            const overflowParents = (0, $24d40242cc6554ee$export$f32edd573b1049e6)(rootRef.current);
            const mainElement = (0, $38f6480185c49d6f$export$184ef262a758e3c4)(rootRef.current, (elem)=>elem.tagName === "MAIN");
            // In both versions of the app layout, the scrolling element for disableBodyScroll
            // is the <main>. If the closest overflow parent is also the closest <main> and we have
            // offset values, it's safe to assume that it's the app layout scroll root and we
            // should stop there.
            setHasInnerOverflowParents(overflowParents.length > 0 && overflowParents[0] !== mainElement);
        }
    }, [
        rootRef
    ]);
    const computedOffset = $6ffd179a45e998fe$export$e9684832087ed7c6({
        isMobile: isMobile,
        __stickyOffset: __stickyOffset,
        __mobileStickyOffset: __mobileStickyOffset,
        hasInnerOverflowParents: hasInnerOverflowParents,
        __additionalOffset: __additionalOffset
    });
    const stickyStyles = isSticky ? {
        style: {
            top: computedOffset
        }
    } : {};
    // "stuck" state, when the header has moved from its original posititon has a
    // box-shadow, applied here by a "header-stuck" className
    const checkIfStuck = (0, $acw62.useCallback)(()=>{
        if (rootRef.current && headerRef.current) {
            const rootTopBorderWidth = parseFloat(getComputedStyle(rootRef.current).borderTopWidth) || 0;
            const rootTop = rootRef.current.getBoundingClientRect().top + rootTopBorderWidth;
            const headerTop = headerRef.current.getBoundingClientRect().top;
            if (rootTop < headerTop) setIsStuck(true);
            else setIsStuck(false);
        }
    }, [
        rootRef,
        headerRef
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isSticky) {
            window.addEventListener("scroll", checkIfStuck, true);
            window.addEventListener("resize", checkIfStuck);
            return ()=>{
                window.removeEventListener("scroll", checkIfStuck, true);
                window.removeEventListener("resize", checkIfStuck);
            };
        }
    }, [
        isSticky,
        checkIfStuck
    ]);
    return {
        isSticky: isSticky,
        isStuck: isStuck,
        stickyStyles: stickyStyles
    };
};






var $a1d2e03e856f50ac$export$2e2bcd8739ae039 = {
    "root": "awsui_root_14iqq_1vekq_101",
    "fit-height": "awsui_fit-height_14iqq_1vekq_137",
    "with-side-media": "awsui_with-side-media_14iqq_1vekq_142",
    "variant-default": "awsui_variant-default_14iqq_1vekq_145",
    "variant-stacked": "awsui_variant-stacked_14iqq_1vekq_145",
    "refresh": "awsui_refresh_14iqq_1vekq_153",
    "sticky-enabled": "awsui_sticky-enabled_14iqq_1vekq_203",
    "with-top-media": "awsui_with-top-media_14iqq_1vekq_215",
    "content-wrapper": "awsui_content-wrapper_14iqq_1vekq_220",
    "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_1vekq_225",
    "media": "awsui_media_14iqq_1vekq_232",
    "media-top": "awsui_media-top_14iqq_1vekq_250",
    "media-side": "awsui_media-side_14iqq_1vekq_255",
    "header": "awsui_header_14iqq_1vekq_261",
    "header-full-page": "awsui_header-full-page_14iqq_1vekq_266",
    "header-with-media": "awsui_header-with-media_14iqq_1vekq_269",
    "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_1vekq_275",
    "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_1vekq_279",
    "header-stuck": "awsui_header-stuck_14iqq_1vekq_285",
    "header-variant-cards": "awsui_header-variant-cards_14iqq_1vekq_295",
    "header-dynamic-height": "awsui_header-dynamic-height_14iqq_1vekq_298",
    "with-paddings": "awsui_with-paddings_14iqq_1vekq_304",
    "with-hidden-content": "awsui_with-hidden-content_14iqq_1vekq_313",
    "header-variant-full-page": "awsui_header-variant-full-page_14iqq_1vekq_371",
    "header-cover": "awsui_header-cover_14iqq_1vekq_374",
    "content": "awsui_content_14iqq_1vekq_220",
    "content-fit-height": "awsui_content-fit-height_14iqq_1vekq_402",
    "content-with-media": "awsui_content-with-media_14iqq_1vekq_412",
    "footer": "awsui_footer_14iqq_1vekq_416",
    "with-divider": "awsui_with-divider_14iqq_1vekq_420"
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $ae03e50ad9979830$var$ContainerHeaderContext = (0, $acw62.createContext)({
    isInContainer: false
});
const $ae03e50ad9979830$export$6a1f6653605d906d = ({ children: children })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ae03e50ad9979830$var$ContainerHeaderContext.Provider, {
        value: {
            isInContainer: true
        }
    }, children);
};
const $ae03e50ad9979830$export$a1df13ec57f8d1e3 = ()=>{
    const { isInContainer: isInContainer } = (0, $acw62.useContext)($ae03e50ad9979830$var$ContainerHeaderContext);
    return isInContainer;
};


function $cc8a25d23ca8ebd0$export$79c16a58b85ba6af(props) {
    const { subStepRef: subStepRef, funnelSubStepProps: funnelSubStepProps } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    const modalContext = (0, $584c4a19f0ba0537$export$4cc1699d46f42cae)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cc8a25d23ca8ebd0$export$2e2bcd8739ae039, Object.assign({}, props, {
        __subStepRef: (modalContext === null || modalContext === void 0 ? void 0 : modalContext.isInModal) ? {
            current: null
        } : subStepRef,
        __funnelSubStepProps: (modalContext === null || modalContext === void 0 ? void 0 : modalContext.isInModal) ? {} : funnelSubStepProps
    }));
}
function $cc8a25d23ca8ebd0$export$2e2bcd8739ae039(_a) {
    var _b;
    var { header: header, footer: footer, children: children, variant: variant = "default", disableHeaderPaddings: disableHeaderPaddings = false, disableContentPaddings: disableContentPaddings = false, fitHeight: fitHeight, media: media, __stickyOffset: __stickyOffset, __mobileStickyOffset: __mobileStickyOffset, __stickyHeader: __stickyHeader = false, __internalRootRef: __internalRootRef = null, __disableFooterDivider: __disableFooterDivider = false, __disableFooterPaddings: __disableFooterPaddings = false, __hiddenContent: __hiddenContent = false, __headerRef: __headerRef, __fullPage: __fullPage = false, __disableStickyMobile: __disableStickyMobile = true, __funnelSubStepProps: __funnelSubStepProps, __subStepRef: __subStepRef } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "header",
        "footer",
        "children",
        "variant",
        "disableHeaderPaddings",
        "disableContentPaddings",
        "fitHeight",
        "media",
        "__stickyOffset",
        "__mobileStickyOffset",
        "__stickyHeader",
        "__internalRootRef",
        "__disableFooterDivider",
        "__disableFooterPaddings",
        "__hiddenContent",
        "__headerRef",
        "__fullPage",
        "__disableStickyMobile",
        "__funnelSubStepProps",
        "__subStepRef"
    ]);
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const rootRef = (0, $acw62.useRef)(null);
    const headerRef = (0, $acw62.useRef)(null);
    const { isSticky: isSticky, isStuck: isStuck, stickyStyles: stickyStyles } = (0, $6ffd179a45e998fe$export$3a5ae2edeb8648ad)(rootRef, headerRef, __stickyHeader, __stickyOffset, __mobileStickyOffset, __disableStickyMobile, __fullPage && isRefresh && !isMobile);
    const contentId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)();
    const hasDynamicHeight = isRefresh && variant === "full-page";
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(rootRef, __internalRootRef);
    const headerMergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(headerRef, __headerRef);
    // The container is only sticky on mobile if it is the header for the table.
    // In this case we don't want the container to have sticky styles, as only the table header row will show as stuck on scroll.
    const shouldHaveStickyStyles = isSticky && !isMobile;
    const hasMedia = !!(media === null || media === void 0 ? void 0 : media.content);
    const mediaPosition = (_b = media === null || media === void 0 ? void 0 : media.position) !== null && _b !== void 0 ? _b : "top";
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, __funnelSubStepProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039).root, (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)[`variant-${variant}`], fitHeight && (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["fit-height"], hasMedia && (mediaPosition === "side" ? (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["with-side-media"] : (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["with-top-media"]), shouldHaveStickyStyles && [
            (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["sticky-enabled"]
        ], isRefresh && (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039).refresh),
        ref: mergedRef
    }), hasMedia && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)[`media-${mediaPosition === "side" ? "side" : "top"}`], (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039).media),
        style: mediaPosition === "top" ? {
            height: (media === null || media === void 0 ? void 0 : media.height) || ""
        } : {
            width: (media === null || media === void 0 ? void 0 : media.width) || ""
        }
    }, media.content), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: contentId,
        ref: __subStepRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["content-wrapper"], fitHeight && (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["content-wrapper-fit-height"])
    }, header && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ae03e50ad9979830$export$6a1f6653605d906d), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ffd179a45e998fe$export$277266c55937e104).Provider, {
        value: {
            isStuck: isStuck
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(isRefresh && (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039).refresh, (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039).header, (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)[`header-variant-${variant}`], {
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["header-sticky-disabled"]]: __stickyHeader && !isSticky,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["header-sticky-enabled"]]: isSticky,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["header-dynamic-height"]]: hasDynamicHeight,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["header-stuck"]]: isStuck,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["with-paddings"]]: !disableHeaderPaddings,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["with-hidden-content"]]: !children || __hiddenContent,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["header-with-media"]]: hasMedia,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["header-full-page"]]: __fullPage && isRefresh
        })
    }, stickyStyles, {
        ref: headerMergedRef
    }), isStuck && !isMobile && isRefresh && __fullPage && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["header-cover"]
    }), header))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a1d2e03e856f50ac$export$2e2bcd8739ae039).content, fitHeight && (0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["content-fit-height"], {
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["with-paddings"]]: !disableContentPaddings
        })
    }, children), footer && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a1d2e03e856f50ac$export$2e2bcd8739ae039).footer, {
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["with-divider"]]: !__disableFooterDivider,
            [(0, $a1d2e03e856f50ac$export$2e2bcd8739ae039)["with-paddings"]]: !__disableFooterPaddings
        })
    }, footer)));
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $2f667510820517ed$export$40ae01be0011c1e6(callback, delay) {
    const callbackRef = (0, $acw62.useRef)();
    callbackRef.current = callback;
    // ESLint rule requires an inline function which we cannot provide here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $acw62.useCallback)((0, $3f63db4ba00e1128$export$2e2bcd8739ae039)((...args)=>{
        if (callbackRef.current) callbackRef.current(...args);
    }, delay), []);
}



const $515d52eb9df17853$export$fd7e9115cb117833 = "1.4";
const $515d52eb9df17853$export$467468afd0d320b9 = (props)=>{
    const { isInFunnel: isInFunnel } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    /*
     If the current funnel component is a Form (i.e. single-page funnel), it should
     defer its funnel-handling to a parent Form element, if present.
     Wizards (i.e. multi-page funnels) always take highest precedence for handling funnels,
     and do not defer to any other element.
    */ if (isInFunnel && props.funnelType === "single-page") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($515d52eb9df17853$var$InnerAnalyticsFunnel, Object.assign({}, props));
};
const $515d52eb9df17853$export$73b97833b52f451a = "awsui-creation-edit-flow-done";
const $515d52eb9df17853$var$dispatchCreateEditFlowDoneEvent = ()=>{
    var _a;
    try {
        (_a = window.top) === null || _a === void 0 || _a.document.dispatchEvent(new Event($515d52eb9df17853$export$73b97833b52f451a));
    } catch (_b) {
    // probably because of cross-origin error, then do not dispatch the event
    }
};
const $515d52eb9df17853$var$onFunnelCancelled = ({ funnelInteractionId: funnelInteractionId, funnelIdentifier: funnelIdentifier })=>{
    (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelCancelled({
        funnelInteractionId: funnelInteractionId,
        funnelIdentifier: funnelIdentifier
    });
};
const $515d52eb9df17853$var$onFunnelComplete = ({ funnelInteractionId: funnelInteractionId, funnelIdentifier: funnelIdentifier })=>{
    (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelComplete({
        funnelInteractionId: funnelInteractionId,
        funnelIdentifier: funnelIdentifier
    });
    $515d52eb9df17853$var$dispatchCreateEditFlowDoneEvent();
};
function $515d52eb9df17853$var$evaluateSelectors(selectors, defaultSelector) {
    for (const selector of selectors){
        const element = document.querySelector(selector);
        if (element) return selector;
    }
    return defaultSelector;
}
const $515d52eb9df17853$var$InnerAnalyticsFunnel = (_a)=>{
    var { children: children, stepConfiguration: stepConfiguration } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "children",
        "stepConfiguration"
    ]);
    const [funnelInteractionId, setFunnelInteractionId] = (0, $acw62.useState)("");
    const [submissionAttempt, setSubmissionAttempt] = (0, $acw62.useState)(0);
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const funnelState = (0, $acw62.useRef)("default");
    const funnelNameSelector = (0, $acw62.useRef)((0, $285a09b860d2bebc$export$3e712eeacbba81a0)());
    const errorCount = (0, $acw62.useRef)(0);
    const loadingButtonCount = (0, $acw62.useRef)(0);
    const wizardCount = (0, $acw62.useRef)(0);
    const latestFocusCleanupFunction = (0, $acw62.useRef)(undefined);
    // This useEffect hook is run once on component mount to initiate the funnel analytics.
    // It first calls the 'funnelStart' method from FunnelMetrics, providing all necessary details
    // about the funnel, and receives a unique interaction id.
    // This unique interaction id is then stored in the state for further use.
    //
    // On component unmount, it checks whether the funnel was successfully completed.
    // Based on this, it either calls 'funnelComplete' or 'funnelCancelled' method from FunnelMetrics.
    //
    // The eslint-disable is required as we deliberately want this effect to run only once on mount and unmount,
    // hence we do not provide any dependencies.
    (0, $acw62.useEffect)(()=>{
        /*
          We run this effect with a delay, in order to detect whether this funnel contains a Wizard.
          If it does contain a Wizard, that Wizard should take precedence for handling the funnel, and
          this current funnel component should do nothing.
        */ let funnelInteractionId;
        const handle = setTimeout(()=>{
            var _a;
            funnelNameSelector.current = $515d52eb9df17853$var$evaluateSelectors(props.funnelNameSelectors || [], (0, $285a09b860d2bebc$export$3e712eeacbba81a0)());
            if (props.funnelType === "single-page" && wizardCount.current > 0) return;
            // Reset the state, in case the component was re-mounted.
            funnelState.current = "default";
            const singleStepFlowStepConfiguration = [
                {
                    number: 1,
                    isOptional: false,
                    name: (_a = (0, $285a09b860d2bebc$export$ad08a5942dca04f8)(funnelNameSelector.current)) !== null && _a !== void 0 ? _a : "",
                    stepIdentifier: props.funnelIdentifier
                }
            ];
            funnelInteractionId = (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelStart({
                funnelIdentifier: props.funnelIdentifier,
                flowType: props.funnelFlowType,
                funnelNameSelector: funnelNameSelector.current,
                optionalStepNumbers: props.optionalStepNumbers,
                funnelType: props.funnelType,
                totalFunnelSteps: props.totalFunnelSteps,
                componentVersion: (0, $93d122f201f7d1ff$export$4a03ffab3315ee34),
                componentTheme: isVisualRefresh ? "vr" : "classic",
                funnelVersion: $515d52eb9df17853$export$fd7e9115cb117833,
                stepConfiguration: stepConfiguration !== null && stepConfiguration !== void 0 ? stepConfiguration : singleStepFlowStepConfiguration
            });
            setFunnelInteractionId(funnelInteractionId);
        }, 1);
        /*
          A funnel counts as "successful" if it is unmounted after being "complete".
        */ /* eslint-disable react-hooks/exhaustive-deps */ return ()=>{
            clearTimeout(handle);
            if (props.funnelType === "single-page" && wizardCount.current > 0) return;
            if (funnelState.current === "validating") {
                // Finish the validation phase early.
                $515d52eb9df17853$var$onFunnelComplete({
                    funnelInteractionId: funnelInteractionId,
                    funnelIdentifier: props.funnelIdentifier
                });
                funnelState.current = "complete";
            }
            if (funnelState.current === "complete") (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelSuccessful({
                funnelInteractionId: funnelInteractionId,
                funnelIdentifier: props.funnelIdentifier
            });
            else {
                $515d52eb9df17853$var$onFunnelCancelled({
                    funnelInteractionId: funnelInteractionId,
                    funnelIdentifier: props.funnelIdentifier
                });
                funnelState.current = "cancelled";
            }
        };
    }, []);
    /* eslint-enable react-hooks/exhaustive-deps */ const funnelSubmit = ()=>{
        funnelState.current = "validating";
        /*
          When the user attempts to submit the form, we wait for 50 milliseconds before checking
          if any form validation errors are present. This value was chosen to give enough time
          for validation and rerendering to occur, but be low enough that the user will not
          be able to take further action in the meantime.
        */ const VALIDATION_WAIT_DELAY = 50;
        /*
         Loading is expected to take longer than validation, so we can keep the pressure on the CPU low.
         */ const LOADING_WAIT_DELAY = 100;
        const checkForCompleteness = ()=>{
            if (funnelState.current === "complete") return;
            if (loadingButtonCount.current > 0) {
                setTimeout(checkForCompleteness, LOADING_WAIT_DELAY);
                return;
            }
            if (errorCount.current === 0) {
                /*
                  If no validation errors are rendered, we treat the funnel as complete.
                */ $515d52eb9df17853$var$onFunnelComplete({
                    funnelInteractionId: funnelInteractionId
                });
                funnelState.current = "complete";
            } else funnelState.current = "default";
        };
        setTimeout(checkForCompleteness, VALIDATION_WAIT_DELAY);
    };
    const funnelNextOrSubmitAttempt = ()=>setSubmissionAttempt((i)=>i + 1);
    const funnelCancel = ()=>{};
    const funnelContextValue = {
        funnelInteractionId: funnelInteractionId,
        funnelIdentifier: props.funnelIdentifier,
        funnelFlowType: props.funnelFlowType,
        funnelErrorContext: props.funnelErrorContext,
        setFunnelInteractionId: setFunnelInteractionId,
        funnelType: props.funnelType,
        optionalStepNumbers: props.optionalStepNumbers,
        totalFunnelSteps: props.totalFunnelSteps,
        funnelNameSelector: funnelNameSelector.current,
        funnelSubmit: funnelSubmit,
        funnelCancel: funnelCancel,
        submissionAttempt: submissionAttempt,
        funnelNextOrSubmitAttempt: funnelNextOrSubmitAttempt,
        funnelState: funnelState,
        errorCount: errorCount,
        loadingButtonCount: loadingButtonCount,
        latestFocusCleanupFunction: latestFocusCleanupFunction,
        isInFunnel: true,
        wizardCount: wizardCount
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c7360a12f6b0b92$export$7a5dd0cfd3639f1b).Provider, {
        value: funnelContextValue
    }, children);
};
const $515d52eb9df17853$export$3fa82ebb4c38684d = (props)=>{
    /*
     This wrapper is used to apply a `key` property to the actual (inner) AnalyticsFunnelStep
     element. This allows us to keep the state and effects separate per step.
     */ return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($515d52eb9df17853$var$InnerAnalyticsFunnelStep, Object.assign({}, props, {
        key: props.stepNumber
    }));
};
function $515d52eb9df17853$var$getSubStepConfiguration() {
    const subSteps = Array.from(document.querySelectorAll((0, $285a09b860d2bebc$export$57dc544ae10998c7)()));
    const subStepConfiguration = subSteps.map((substep, index)=>{
        var _a, _b, _c, _d, _e;
        const subStepIdentifier = (_b = (_a = substep === null || substep === void 0 ? void 0 : substep.__awsuiMetadata__) === null || _a === void 0 ? void 0 : _a.analytics) === null || _b === void 0 ? void 0 : _b.instanceIdentifier;
        const name = (_e = (_d = (_c = substep.querySelector((0, $285a09b860d2bebc$export$d82de5788b5a2d19)())) === null || _c === void 0 ? void 0 : _c.innerText) === null || _d === void 0 ? void 0 : _d.trim()) !== null && _e !== void 0 ? _e : "";
        return {
            name: name,
            number: index + 1,
            subStepIdentifier: subStepIdentifier
        };
    });
    return subStepConfiguration;
}
function $515d52eb9df17853$var$useStepChangeListener(stepNumber, handler) {
    const subStepConfiguration = (0, $acw62.useRef)(new Map());
    /*
     Chosen so that it's hopefully shorter than a user interaction, but gives enough time for the
     amount of containers to stabilise.
    */ const SUBSTEP_CHANGE_DEBOUNCE = 50;
    const listenForSubStepChanges = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        // We prevent emitting the event on the first render.
        const handle = setTimeout(()=>listenForSubStepChanges.current = true, SUBSTEP_CHANGE_DEBOUNCE);
        return ()=>{
            clearTimeout(handle);
            listenForSubStepChanges.current = false;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const handle = setTimeout(()=>subStepConfiguration.current.set(stepNumber, $515d52eb9df17853$var$getSubStepConfiguration()), SUBSTEP_CHANGE_DEBOUNCE);
        return ()=>{
            clearTimeout(handle);
        };
    }, [
        stepNumber
    ]);
    /* We debounce this handler, so that multiple containers can change at once without causing
    too many events. */ const stepChangeCallback = (0, $2f667510820517ed$export$40ae01be0011c1e6)(()=>{
        // We don't want to emit the event after the component has been unmounted.
        if (!listenForSubStepChanges.current) return;
        subStepConfiguration.current.set(stepNumber, $515d52eb9df17853$var$getSubStepConfiguration());
        handler(subStepConfiguration.current.get(stepNumber));
    }, SUBSTEP_CHANGE_DEBOUNCE);
    return {
        onStepChange: stepChangeCallback,
        subStepConfiguration: subStepConfiguration
    };
}
const $515d52eb9df17853$var$InnerAnalyticsFunnelStep = (_a)=>{
    var { children: children, stepNumber: stepNumber, stepIdentifier: stepIdentifier, stepErrorContext: stepErrorContext } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "children",
        "stepNumber",
        "stepIdentifier",
        "stepErrorContext"
    ]);
    const { funnelInteractionId: funnelInteractionId, funnelIdentifier: funnelIdentifier, funnelNameSelector: funnelNameSelector, funnelState: funnelState, funnelType: funnelType } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const parentStep = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const parentStepExists = parentStep.isInStep;
    const parentStepFunnelInteractionId = parentStep.funnelInteractionId;
    const funnelStepProps = {
        [(0, $285a09b860d2bebc$export$35cc9e5d8841ad00)]: stepNumber
    };
    const subStepCount = (0, $acw62.useRef)(0);
    const stepNameSelector = rest.stepNameSelector || funnelNameSelector;
    const { onStepChange: onStepChange, subStepConfiguration: subStepConfiguration } = $515d52eb9df17853$var$useStepChangeListener(stepNumber, (subStepConfiguration)=>{
        if (!funnelInteractionId) return;
        (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelStepChange({
            stepIdentifier: stepIdentifier,
            funnelIdentifier: funnelIdentifier,
            funnelInteractionId: funnelInteractionId,
            stepNumber: stepNumber,
            stepNameSelector: stepNameSelector,
            subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)(),
            totalSubSteps: subStepCount.current,
            subStepConfiguration: subStepConfiguration
        });
    });
    // This useEffect hook is used to track the start and completion of interaction with the step.
    // On mount, if there is a valid funnel interaction id, it calls the 'funnelStepStart' method from FunnelMetrics
    // to record the beginning of the interaction with the current step.
    // On unmount, it does a similar thing but this time calling 'funnelStepComplete' to record the completion of the interaction.
    (0, $acw62.useEffect)(()=>{
        if (!funnelInteractionId) // This step is not inside an active funnel.
        return;
        if (parentStepExists && parentStepFunnelInteractionId) /*
             This step is inside another step, which already reports events as
             part of an active funnel (i.e. that step is not a parent of a Wizard).
             Thus, this current step does not need to report any events.
             */ return;
        const stepName = (0, $285a09b860d2bebc$export$ad08a5942dca04f8)(stepNameSelector);
        if (funnelState.current === "default") (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelStepStart({
            stepIdentifier: stepIdentifier,
            funnelIdentifier: funnelIdentifier,
            funnelInteractionId: funnelInteractionId,
            stepNumber: stepNumber,
            stepName: stepName,
            stepNameSelector: stepNameSelector,
            subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)(),
            totalSubSteps: subStepCount.current,
            subStepConfiguration: $515d52eb9df17853$var$getSubStepConfiguration()
        });
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            if (funnelState.current !== "cancelled") (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelStepComplete({
                funnelIdentifier: funnelIdentifier,
                funnelInteractionId: funnelInteractionId,
                stepIdentifier: stepIdentifier,
                stepNumber: stepNumber,
                stepName: stepName,
                stepNameSelector: stepNameSelector,
                subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)(),
                // eslint-disable-next-line react-hooks/exhaustive-deps
                totalSubSteps: subStepCount.current
            });
        };
    }, [
        stepIdentifier,
        funnelIdentifier,
        funnelInteractionId,
        stepNumber,
        stepNameSelector,
        funnelState,
        parentStepExists,
        funnelType,
        parentStepFunnelInteractionId
    ]);
    const contextValue = {
        stepIdentifier: stepIdentifier,
        stepNumber: stepNumber,
        stepNameSelector: stepNameSelector,
        funnelStepProps: funnelStepProps,
        subStepCount: subStepCount,
        isInStep: true,
        funnelInteractionId: funnelInteractionId,
        onStepChange: onStepChange,
        subStepConfiguration: subStepConfiguration,
        stepErrorContext: stepErrorContext
    };
    /*
      If this step is inside another step which already reports events as part of an active
      funnel (i.e. that step is not a parent of a Wizard), the current step becomes invisible
      in the hierarchy by passing the context of its parent through.
    */ const effectiveContextValue = parentStepExists && parentStepFunnelInteractionId ? parentStep : contextValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c7360a12f6b0b92$export$8b0d9233e68df2ee).Provider, {
        value: effectiveContextValue
    }, typeof children === "function" ? children(effectiveContextValue) : children);
};
const $515d52eb9df17853$export$b1325661caf9fa0 = ({ children: children, subStepIdentifier: subStepIdentifier, subStepErrorContext: subStepErrorContext })=>{
    const subStepId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("substep");
    const subStepSelector = (0, $285a09b860d2bebc$export$ee83c691e298510a)(subStepId);
    const subStepNameSelector = (0, $285a09b860d2bebc$export$d82de5788b5a2d19)(subStepId);
    const subStepRef = (0, $acw62.useRef)(null);
    const { subStepCount: subStepCount, onStepChange: onStepChange } = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const mousePressed = (0, $acw62.useRef)(false);
    const isFocusedSubStep = (0, $acw62.useRef)(false);
    const focusCleanupFunction = (0, $acw62.useRef)(undefined);
    const { funnelState: funnelState, funnelInteractionId: funnelInteractionId } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const { stepNumber: stepNumber, stepNameSelector: stepNameSelector } = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const newContext = {
        subStepIdentifier: subStepIdentifier,
        subStepErrorContext: subStepErrorContext,
        subStepSelector: subStepSelector,
        subStepNameSelector: subStepNameSelector,
        subStepId: subStepId,
        subStepRef: subStepRef,
        mousePressed: mousePressed,
        isFocusedSubStep: isFocusedSubStep,
        focusCleanupFunction: focusCleanupFunction,
        isNestedSubStep: false
    };
    const inheritedContext = Object.assign(Object.assign({}, (0, $acw62.useContext)((0, $2c7360a12f6b0b92$export$3030a14ef22dab15))), {
        isNestedSubStep: true
    });
    const isNested = Boolean(inheritedContext.subStepId);
    (0, $acw62.useEffect)(()=>{
        if (!isNested) {
            subStepCount.current++;
            onStepChange();
            return ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                subStepCount.current--;
                onStepChange();
            };
        }
    }, [
        isNested,
        subStepCount,
        onStepChange
    ]);
    const context = isNested ? inheritedContext : newContext;
    (0, $acw62.useEffect)(()=>{
        if (isNested || !subStepRef.current) return;
        const onMouseDown = ()=>mousePressed.current = true;
        const onMouseUp = ()=>(0, $5c96a02c592fcff1$export$1050f835b63b671e)(void 0, void 0, void 0, function*() {
                var _a;
                mousePressed.current = false;
                if (!isFocusedSubStep.current) return;
                /*
              Some mouse events result in an element being focused. However,
              this happens only _after_ the onMouseUp event. We yield the
              event loop here, so that `document.activeElement` has the
              correct new value.
            */ yield new Promise((r)=>setTimeout(r, 1));
                if (!subStepRef.current || !document.activeElement || !(0, $4c778684f125e678$export$57d4cb221e1d1857)(subStepRef.current, document.activeElement)) {
                    isFocusedSubStep.current = false;
                    /*
                 Run this substep's own focus cleanup function if another substep
                 hasn't already done it for us.
                 */ (_a = focusCleanupFunction.current) === null || _a === void 0 || _a.call(focusCleanupFunction);
                }
            });
        window.addEventListener("mousedown", onMouseDown);
        window.addEventListener("mouseup", onMouseUp);
        return ()=>{
            window.removeEventListener("mousedown", onMouseDown);
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, [
        funnelInteractionId,
        funnelState,
        stepNameSelector,
        stepNumber,
        subStepNameSelector,
        subStepSelector,
        focusCleanupFunction,
        isNested,
        subStepRef
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c7360a12f6b0b92$export$3030a14ef22dab15).Provider, {
        value: context
    }, typeof children === "function" ? children(context) : children);
};


const $051fdcf4200bfadb$export$6a1cf8e8d6294858 = (_a)=>{
    var { className: className, children: children, header: header, variant: variant, expanded: expanded, disableContentPaddings: disableContentPaddings, __internalRootRef: __internalRootRef } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "className",
        "children",
        "header",
        "variant",
        "expanded",
        "disableContentPaddings",
        "__internalRootRef"
    ]);
    if (variant === "container" || variant === "stacked") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $515d52eb9df17853$export$b1325661caf9fa0), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc8a25d23ca8ebd0$export$79c16a58b85ba6af), Object.assign({}, rest, {
        className: className,
        header: header,
        variant: variant === "stacked" ? "stacked" : "default",
        disableContentPaddings: disableContentPaddings || !expanded,
        disableHeaderPaddings: true,
        __hiddenContent: !expanded,
        __internalRootRef: __internalRootRef
    }), children));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: className
    }, rest, {
        ref: __internalRootRef
    }), header, children);
};



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");




var $962e3f40ddca05f8$export$2e2bcd8739ae039 = {
    "root": "awsui_root_2qdw9_12abv_97",
    "refresh": "awsui_refresh_2qdw9_12abv_136",
    "root-no-actions": "awsui_root-no-actions_2qdw9_12abv_136",
    "root-variant-h2": "awsui_root-variant-h2_2qdw9_12abv_139",
    "root-variant-h3": "awsui_root-variant-h3_2qdw9_12abv_139",
    "root-has-description": "awsui_root-has-description_2qdw9_12abv_139",
    "root-variant-h1": "awsui_root-variant-h1_2qdw9_12abv_148",
    "main": "awsui_main_2qdw9_12abv_158",
    "no-wrap": "awsui_no-wrap_2qdw9_12abv_168",
    "main-variant-h1": "awsui_main-variant-h1_2qdw9_12abv_174",
    "actions": "awsui_actions_2qdw9_12abv_182",
    "actions-centered": "awsui_actions-centered_2qdw9_12abv_187",
    "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_12abv_190",
    "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_12abv_194",
    "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_12abv_198",
    "title": "awsui_title_2qdw9_12abv_214",
    "title-variant-h1": "awsui_title-variant-h1_2qdw9_12abv_219",
    "title-variant-h2": "awsui_title-variant-h2_2qdw9_12abv_226",
    "title-variant-h3": "awsui_title-variant-h3_2qdw9_12abv_232",
    "virtual-space": "awsui_virtual-space_2qdw9_12abv_253",
    "info": "awsui_info_2qdw9_12abv_259",
    "description": "awsui_description_2qdw9_12abv_263",
    "description-variant-h1": "awsui_description-variant-h1_2qdw9_12abv_270",
    "description-variant-h2": "awsui_description-variant-h2_2qdw9_12abv_274",
    "description-variant-h3": "awsui_description-variant-h3_2qdw9_12abv_281",
    "heading": "awsui_heading_2qdw9_12abv_290",
    "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_12abv_301",
    "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_12abv_306",
    "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_12abv_311",
    "heading-text": "awsui_heading-text_2qdw9_12abv_317",
    "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_12abv_320",
    "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_12abv_328",
    "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_12abv_336",
    "counter": "awsui_counter_2qdw9_12abv_345"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $edb6222f981e45e4$export$8ffd2daeac4a0391 = (0, $acw62.createContext)(undefined);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $7e52d1d829dbf9fa$export$85b6faccd4f04314 = (0, $acw62.createContext)({});





function $a2f4d445a38721ba$export$2e2bcd8739ae039(_a) {
    var { variant: variant, headingTagOverride: headingTagOverride, children: children, actions: actions, counter: counter, description: description, info: info, __internalRootRef: __internalRootRef = null, __disableActionsWrapping: __disableActionsWrapping } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "variant",
        "headingTagOverride",
        "children",
        "actions",
        "counter",
        "description",
        "info",
        "__internalRootRef",
        "__disableActionsWrapping"
    ]);
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const HeadingTag = headingTagOverride !== null && headingTagOverride !== void 0 ? headingTagOverride : variant === "awsui-h1-sticky" ? "h1" : variant;
    const { isStuck: isStuck } = (0, $acw62.useContext)((0, $6ffd179a45e998fe$export$277266c55937e104));
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const assignHeaderId = (0, $acw62.useContext)((0, $7e52d1d829dbf9fa$export$85b6faccd4f04314)).assignId;
    const isInContainer = (0, $ae03e50ad9979830$export$a1df13ec57f8d1e3)();
    const headingId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("heading");
    if (assignHeaderId !== undefined) assignHeaderId(headingId);
    // If is mobile there is no need to have the dynamic variant because it's scrolled out of view
    const dynamicVariant = !isMobile && isStuck ? "h2" : "h1";
    const variantOverride = variant === "awsui-h1-sticky" ? isRefresh ? dynamicVariant : "h2" : variant;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $962e3f40ddca05f8$export$2e2bcd8739ae039).root, baseProps.className, (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`root-variant-${variantOverride}`], isRefresh && (0, $962e3f40ddca05f8$export$2e2bcd8739ae039).refresh, !actions && [
            (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`root-no-actions`]
        ], description && [
            (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`root-has-description`]
        ]),
        ref: __internalRootRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $962e3f40ddca05f8$export$2e2bcd8739ae039).main, (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`main-variant-${variantOverride}`], isRefresh && (0, $962e3f40ddca05f8$export$2e2bcd8739ae039).refresh, __disableActionsWrapping && [
            (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)["no-wrap"]
        ])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $962e3f40ddca05f8$export$2e2bcd8739ae039).title, (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`title-variant-${variantOverride}`], isRefresh && (0, $962e3f40ddca05f8$export$2e2bcd8739ae039).refresh)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(HeadingTag, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $962e3f40ddca05f8$export$2e2bcd8739ae039).heading, (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`heading-variant-${variantOverride}`])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, isInContainer ? {
        [(0, $285a09b860d2bebc$export$22b484224f7ab69a)]: (0, $285a09b860d2bebc$export$7eef17de8ae91f78)
    } : {}, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $962e3f40ddca05f8$export$2e2bcd8739ae039)["heading-text"], (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`heading-text-variant-${variantOverride}`]),
        id: headingId
    }), children), counter !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $962e3f40ddca05f8$export$2e2bcd8739ae039).counter
    }, " ", counter)), info && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $edb6222f981e45e4$export$8ffd2daeac4a0391).Provider, {
        value: headingId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)["virtual-space"]
    }, " \xa0"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $962e3f40ddca05f8$export$2e2bcd8739ae039).info
    }, info))), actions && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $962e3f40ddca05f8$export$2e2bcd8739ae039).actions, (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`actions-variant-${variantOverride}`], isRefresh && (0, $962e3f40ddca05f8$export$2e2bcd8739ae039).refresh, !__disableActionsWrapping && [
            (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)["actions-centered"]
        ])
    }, actions)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a2f4d445a38721ba$export$393edc798c47379d, {
        variantOverride: variantOverride
    }, description));
}
function $a2f4d445a38721ba$export$393edc798c47379d({ children: children, variantOverride: variantOverride }) {
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    return children && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $962e3f40ddca05f8$export$2e2bcd8739ae039).description, (0, $962e3f40ddca05f8$export$2e2bcd8739ae039)[`description-variant-${variantOverride}`], isRefresh && (0, $962e3f40ddca05f8$export$2e2bcd8739ae039).refresh)
    }, children) || null;
}




function $03e0cab07f1da727$export$943a7be7ee5dd72e(variant) {
    return [
        "container",
        "default",
        "footer"
    ].includes(variant);
}
function $03e0cab07f1da727$export$edb4b4cd3ba42b0c(variant) {
    return [
        "container",
        "compact"
    ].includes(variant);
}


const $9264c5b706725159$export$fc8305a20c88b9a5 = "ExpandableSection";
const $9264c5b706725159$var$ExpandableDeprecatedHeader = ({ id: id, className: className, onClick: onClick, ariaLabel: ariaLabel, ariaControls: ariaControls, expanded: expanded, children: children, icon: icon, onKeyUp: onKeyUp, onKeyDown: onKeyDown, variant: variant })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        role: "button",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["expand-button"], (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["click-target"], (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["header-deprecated"]),
        tabIndex: 0,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onClick: onClick,
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": expanded
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["icon-container"], (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)[`icon-container-${variant}`])
    }, icon), children);
};
const $9264c5b706725159$var$ExpandableNavigationHeader = ({ id: id, className: className, onClick: onClick, ariaLabelledBy: ariaLabelledBy, ariaLabel: ariaLabel, ariaControls: ariaControls, expanded: expanded, children: children, icon: icon })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["click-target"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["icon-container"], (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["expand-button"]),
        "aria-labelledby": ariaLabelledBy,
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": expanded,
        type: "button",
        onClick: onClick
    }, icon), children);
};
const $9264c5b706725159$var$ExpandableHeaderTextWrapper = ({ id: id, descriptionId: descriptionId, className: className, onClick: onClick, ariaLabel: ariaLabel, ariaControls: ariaControls, expanded: expanded, children: children, icon: icon, headerDescription: headerDescription, headerCounter: headerCounter, headerInfo: headerInfo, headerActions: headerActions, variant: variant, headingTagOverride: headingTagOverride, onKeyUp: onKeyUp, onKeyDown: onKeyDown })=>{
    const isContainer = variant === "container";
    const HeadingTag = headingTagOverride || "div";
    const supportsInteractiveElements = (0, $03e0cab07f1da727$export$edb4b4cd3ba42b0c)(variant);
    const restrictClickableArea = supportsInteractiveElements && (headerInfo || headerActions);
    const actions = supportsInteractiveElements && headerActions;
    const description = (0, $03e0cab07f1da727$export$943a7be7ee5dd72e)(variant) && headerDescription && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: descriptionId,
        className: (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)[`description-${variant}`]
    }, headerDescription);
    const listeners = {
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    };
    // If interactive elements are present, constrain the clickable area to only the icon and the header text
    // to prevent nesting interactive elements.
    const headerButtonListeners = restrictClickableArea ? listeners : undefined;
    // For the default and footer variants with description,
    // include also the immediate wrapper around it to include the entire row for backwards compatibility,
    // but exclude the description.
    const headingTagListeners = !headerButtonListeners && !isContainer && description ? listeners : undefined;
    // For all other cases, make the entire header clickable for backwards compatibility.
    const wrapperListeners = !headerButtonListeners && !headingTagListeners ? listeners : undefined;
    const headerButton = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["expand-button"], isContainer ? (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["header-container-button"] : (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["header-button"], headerButtonListeners && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["click-target"]),
        role: "button",
        tabIndex: 0,
        "aria-label": ariaLabel,
        "aria-labelledby": !ariaLabel && description ? id : undefined,
        "aria-describedby": description ? descriptionId : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": expanded
    }, headerButtonListeners), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["icon-container"], (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)[`icon-container-${variant}`])
    }, icon), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: id,
        className: (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["header-text"]
    }, children));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, wrapperListeners && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["click-target"])
    }, wrapperListeners), isContainer ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a2f4d445a38721ba$export$2e2bcd8739ae039), {
        variant: "h2",
        description: description,
        counter: headerCounter,
        info: headerInfo,
        actions: actions,
        headingTagOverride: headingTagOverride
    }, headerButton) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(actions && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["header-actions-wrapper"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(HeadingTag, Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["header-wrapper"], headingTagListeners && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["click-target"])
    }, headingTagListeners), headerButton), actions), description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a2f4d445a38721ba$export$393edc798c47379d), {
        variantOverride: "h3"
    }, description)));
};
const $9264c5b706725159$export$c7e168399ebe47d9 = ({ id: id, descriptionId: descriptionId, className: className, variant: variant, header: header, headerText: headerText, headerDescription: headerDescription, headerCounter: headerCounter, headerInfo: headerInfo, headerActions: headerActions, headingTagOverride: headingTagOverride, expanded: expanded, ariaControls: ariaControls, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, onKeyUp: onKeyUp, onKeyDown: onKeyDown, onClick: onClick })=>{
    const icon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        size: variant === "container" ? "medium" : "normal",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039).icon, expanded && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039).expanded),
        name: "caret-down-filled"
    });
    const defaultHeaderProps = {
        id: id,
        icon: icon,
        expanded: expanded,
        ariaControls: ariaControls,
        ariaLabel: ariaLabel,
        onClick: onClick,
        variant: variant
    };
    if ((headerCounter || headerInfo || headerActions) && !(0, $03e0cab07f1da727$export$edb4b4cd3ba42b0c)(variant) && (0, $bf737c197e11d40f$export$df77466336fe5355)) (0, $dd646455762bc7b9$export$5b28268982f175ba)($9264c5b706725159$export$fc8305a20c88b9a5, 'The `headerCounter`, `headerInfo` and `headerActions` props are only supported for the "container" variant.');
    if (headerDescription && !(0, $03e0cab07f1da727$export$943a7be7ee5dd72e)(variant) && (0, $bf737c197e11d40f$export$df77466336fe5355)) (0, $dd646455762bc7b9$export$5b28268982f175ba)($9264c5b706725159$export$fc8305a20c88b9a5, `The \`headerDescription\` prop is not supported for the ${variant} variant.`);
    const wrapperClassName = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039).wrapper, (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)[`wrapper-${variant}`], expanded && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["wrapper-expanded"]);
    if (variant === "navigation") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9264c5b706725159$var$ExpandableNavigationHeader, Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, wrapperClassName),
        ariaLabelledBy: ariaLabelledBy
    }, defaultHeaderProps), headerText !== null && headerText !== void 0 ? headerText : header);
    if (headerText) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9264c5b706725159$var$ExpandableHeaderTextWrapper, Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, wrapperClassName, expanded && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039).expanded),
        descriptionId: descriptionId,
        headerDescription: headerDescription,
        headerCounter: headerCounter,
        headerInfo: headerInfo,
        headerActions: headerActions,
        headingTagOverride: headingTagOverride,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown
    }, defaultHeaderProps), headerText);
    if (variant === "container" && header && (0, $bf737c197e11d40f$export$df77466336fe5355)) (0, $dd646455762bc7b9$export$5b28268982f175ba)($9264c5b706725159$export$fc8305a20c88b9a5, "Use `headerText` instead of `header` to provide the button within the heading for a11y.");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9264c5b706725159$var$ExpandableDeprecatedHeader, Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, wrapperClassName, (0, $8ec66faffacc81ba$export$2e2bcd8739ae039).focusable, expanded && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039).expanded),
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown
    }, defaultHeaderProps), header);
};



function $558ed5ac4f872148$export$2e2bcd8739ae039(_a) {
    var { expanded: controlledExpanded, defaultExpanded: defaultExpanded, onChange: onChange, variant: variant = "default", children: children, header: header, headerText: headerText, headerCounter: headerCounter, headerDescription: headerDescription, headerInfo: headerInfo, headerActions: headerActions, headingTagOverride: headingTagOverride, disableContentPaddings: disableContentPaddings, headerAriaLabel: headerAriaLabel, __internalRootRef: __internalRootRef } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "expanded",
        "defaultExpanded",
        "onChange",
        "variant",
        "children",
        "header",
        "headerText",
        "headerCounter",
        "headerDescription",
        "headerInfo",
        "headerActions",
        "headingTagOverride",
        "disableContentPaddings",
        "headerAriaLabel",
        "__internalRootRef"
    ]);
    const ref = (0, $acw62.useRef)(null);
    const controlId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)();
    const triggerControlId = `${controlId}-trigger`;
    const descriptionId = `${controlId}-description`;
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const [expanded, setExpanded] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledExpanded, onChange, defaultExpanded, {
        componentName: "ExpandableSection",
        controlledProp: "expanded",
        changeHandler: "onChange"
    });
    const onExpandChange = (0, $acw62.useCallback)((expanded)=>{
        setExpanded(expanded);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            expanded: expanded
        });
    }, [
        onChange,
        setExpanded
    ]);
    const onClick = (0, $acw62.useCallback)(()=>{
        onExpandChange(!expanded);
    }, [
        onExpandChange,
        expanded
    ]);
    const onKeyUp = (0, $acw62.useCallback)((event)=>{
        const interactionKeys = [
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space
        ];
        if (interactionKeys.indexOf(event.keyCode) !== -1) onExpandChange(!expanded);
    }, [
        onExpandChange,
        expanded
    ]);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space) // Prevent the page from scrolling when toggling the component with the space bar.
        event.preventDefault();
    }, []);
    const triggerProps = {
        ariaControls: controlId,
        ariaLabel: headerAriaLabel,
        ariaLabelledBy: headerAriaLabel ? undefined : triggerControlId,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onClick: onClick
    };
    // Map stacked variant to container to avoid code duplication
    const baseVariant = variant === "stacked" ? "container" : variant;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $051fdcf4200bfadb$export$6a1cf8e8d6294858), Object.assign({}, baseProps, {
        expanded: expanded,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $8ec66faffacc81ba$export$2e2bcd8739ae039).root),
        variant: variant,
        disableContentPaddings: disableContentPaddings,
        header: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9264c5b706725159$export$c7e168399ebe47d9), Object.assign({
            id: triggerControlId,
            descriptionId: descriptionId,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039).header, (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)[`header-${baseVariant}`]),
            variant: baseVariant,
            expanded: !!expanded,
            header: header,
            headerText: headerText,
            headerDescription: headerDescription,
            headerCounter: headerCounter,
            headerInfo: headerInfo,
            headerActions: headerActions,
            headingTagOverride: headingTagOverride
        }, triggerProps)),
        __internalRootRef: __internalRootRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ee2e736fe07a2c40$export$2e2bcd8739ae039), {
        in: expanded,
        timeout: 30,
        classNames: {
            enter: (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["content-enter"]
        },
        nodeRef: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: controlId,
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8ec66faffacc81ba$export$2e2bcd8739ae039).content, (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)[`content-${baseVariant}`], expanded && (0, $8ec66faffacc81ba$export$2e2bcd8739ae039)["content-expanded"]),
        role: "group",
        "aria-label": triggerProps.ariaLabel,
        "aria-labelledby": triggerProps.ariaLabelledBy,
        "aria-describedby": (0, $03e0cab07f1da727$export$943a7be7ee5dd72e)(baseVariant) && headerDescription ? descriptionId : undefined
    }, children)));
}





var $09faa395f06fdc03$export$2e2bcd8739ae039 = {
    "root": "awsui_root_l0dv0_1s9d7_97",
    "header": "awsui_header_l0dv0_1s9d7_134",
    "header-link": "awsui_header-link_l0dv0_1s9d7_147",
    "header-link--has-logo": "awsui_header-link--has-logo_l0dv0_1s9d7_157",
    "header-link-text": "awsui_header-link-text_l0dv0_1s9d7_157",
    "header-logo": "awsui_header-logo_l0dv0_1s9d7_162",
    "header-logo--stretched": "awsui_header-logo--stretched_l0dv0_1s9d7_168",
    "list-container": "awsui_list-container_l0dv0_1s9d7_173",
    "list": "awsui_list_l0dv0_1s9d7_173",
    "list-variant-root": "awsui_list-variant-root_l0dv0_1s9d7_185",
    "list-variant-root--last": "awsui_list-variant-root--last_l0dv0_1s9d7_192",
    "list-variant-expandable-link-group": "awsui_list-variant-expandable-link-group_l0dv0_1s9d7_196",
    "list-item": "awsui_list-item_l0dv0_1s9d7_200",
    "section": "awsui_section_l0dv0_1s9d7_208",
    "expandable-link-group": "awsui_expandable-link-group_l0dv0_1s9d7_209",
    "section--no-ident": "awsui_section--no-ident_l0dv0_1s9d7_212",
    "expandable-link-group--no-ident": "awsui_expandable-link-group--no-ident_l0dv0_1s9d7_213",
    "refresh": "awsui_refresh_l0dv0_1s9d7_221",
    "list-variant-section-group": "awsui_list-variant-section-group_l0dv0_1s9d7_229",
    "section-group": "awsui_section-group_l0dv0_1s9d7_236",
    "section-group-title": "awsui_section-group-title_l0dv0_1s9d7_247",
    "link": "awsui_link_l0dv0_1s9d7_251",
    "link-active": "awsui_link-active_l0dv0_1s9d7_260",
    "info": "awsui_info_l0dv0_1s9d7_297",
    "external-icon": "awsui_external-icon_l0dv0_1s9d7_301",
    "divider": "awsui_divider_l0dv0_1s9d7_305",
    "divider-default": "awsui_divider-default_l0dv0_1s9d7_310",
    "divider-header": "awsui_divider-header_l0dv0_1s9d7_316"
};




function $e08d731147a73b24$export$35f2025888793fe1(items, activeHref) {
    for (const item of items){
        if ((item.type === "link" || item.type === "link-group" || item.type === "expandable-link-group") && item.href === activeHref) return true;
        if ((item.type === "section" || item.type === "link-group" || item.type === "expandable-link-group") && $e08d731147a73b24$export$35f2025888793fe1(item.items, activeHref)) return true;
    }
    return false;
}
function $e08d731147a73b24$export$9620f8797d1dcd73(items, mapping = new WeakMap(), expandableParents = []) {
    items.forEach((item)=>{
        const nextLevelParents = expandableParents.slice();
        if (item.type === "section" || item.type === "expandable-link-group") {
            mapping.set(item, expandableParents);
            nextLevelParents.unshift(item);
        }
        if (item.type === "section" || item.type === "link-group" || item.type === "expandable-link-group") $e08d731147a73b24$export$9620f8797d1dcd73(item.items, mapping, nextLevelParents);
    });
    return mapping;
}
function $e08d731147a73b24$export$a9b81fc69bcc1c83(items) {
    const hrefs = new Set();
    const queue = items.slice();
    while(queue.length > 0){
        // We just checked that there's items in the queue.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const item = queue.shift();
        // Check duplicated hrefs
        if ("href" in item) {
            if (hrefs.has(item.href)) (0, $dd646455762bc7b9$export$5b28268982f175ba)("SideNavigation", `duplicate href in "${item.text}": ${item.href}`);
            hrefs.add(item.href);
        }
        if ("items" in item) queue.push(...item.items);
    }
}




function $fbeadf0ec275905f$export$8b251419efc915eb({ definition: definition, activeHref: activeHref, fireFollow: fireFollow }) {
    (0, $3de0f29144bb4e85$export$6661f6891a200a5f)("SideNavigation", definition.href);
    const onClick = (0, $acw62.useCallback)((event)=>{
        if ((0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) fireFollow(definition, event);
    }, [
        fireFollow,
        definition
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", {
        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039).header
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: definition.href,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039)["header-link"], {
            [(0, $09faa395f06fdc03$export$2e2bcd8739ae039)["header-link--has-logo"]]: !!definition.logo
        }),
        "aria-current": definition.href === activeHref ? "page" : undefined,
        onClick: onClick
    }, definition.logo && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039)["header-logo"], {
            [(0, $09faa395f06fdc03$export$2e2bcd8739ae039)["header-logo--stretched"]]: !definition.text
        })
    }, definition.logo)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)["header-link-text"]
    }, definition.text))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$Divider, {
        isPresentational: true,
        variant: "header"
    }));
}
function $fbeadf0ec275905f$export$47e2c5415bb5aa12({ items: items, variant: variant, activeHref: activeHref, fireChange: fireChange, fireFollow: fireFollow }) {
    const lists = [];
    let currentListIndex = 0;
    lists[currentListIndex] = {
        listVariant: variant,
        items: []
    };
    items.forEach((item, index)=>{
        var _a, _b, _c, _d, _e;
        const itemid = index + 1;
        switch(item.type){
            case "divider":
                {
                    const dividerIndex = lists.length;
                    lists[dividerIndex] = {
                        element: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                            "data-itemid": `item-${itemid}`
                        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$Divider, {
                            variant: "default"
                        }))
                    };
                    currentListIndex = lists.length;
                    lists[currentListIndex] = {
                        listVariant: variant,
                        items: []
                    };
                    return;
                }
            case "link":
                (_a = lists[currentListIndex].items) === null || _a === void 0 || _a.push({
                    element: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        key: index,
                        "data-itemid": `item-${itemid}`,
                        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)["list-item"]
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$Link, {
                        definition: item,
                        activeHref: activeHref,
                        fireChange: fireChange,
                        fireFollow: fireFollow
                    }))
                });
                return;
            case "section":
                (_b = lists[currentListIndex].items) === null || _b === void 0 || _b.push({
                    element: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        key: index,
                        "data-itemid": `item-${itemid}`,
                        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)["list-item"]
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$Section, {
                        definition: item,
                        activeHref: activeHref,
                        variant: variant,
                        fireChange: fireChange,
                        fireFollow: fireFollow
                    }))
                });
                return;
            case "section-group":
                (_c = lists[currentListIndex].items) === null || _c === void 0 || _c.push({
                    element: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        key: index,
                        "data-itemid": `item-${itemid}`,
                        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)["list-item"]
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$SectionGroup, {
                        definition: item,
                        activeHref: activeHref,
                        fireChange: fireChange,
                        fireFollow: fireFollow
                    }))
                });
                return;
            case "link-group":
                (_d = lists[currentListIndex].items) === null || _d === void 0 || _d.push({
                    element: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        key: index,
                        "data-itemid": `item-${itemid}`,
                        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)["list-item"]
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$LinkGroup, {
                        definition: item,
                        activeHref: activeHref,
                        fireChange: fireChange,
                        fireFollow: fireFollow
                    }))
                });
                return;
            case "expandable-link-group":
                (_e = lists[currentListIndex].items) === null || _e === void 0 || _e.push({
                    element: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        key: index,
                        "data-itemid": `item-${itemid}`,
                        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)["list-item"]
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$ExpandableLinkGroup, {
                        definition: item,
                        activeHref: activeHref,
                        fireChange: fireChange,
                        fireFollow: fireFollow,
                        variant: variant
                    }))
                });
                return;
        }
    });
    const lastListIndex = lists.length - 1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, lists.map((list, index)=>{
        if (!list.items || list.items.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: `hr-${index}`,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039).list, (0, $09faa395f06fdc03$export$2e2bcd8739ae039)[`list-variant-${variant}`], {
                [(0, $09faa395f06fdc03$export$2e2bcd8739ae039)["list-variant-root--last"]]: list.listVariant === "root" && index === lastListIndex
            })
        }, list.element);
        else return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            key: `list-${index}`,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039).list, (0, $09faa395f06fdc03$export$2e2bcd8739ae039)[`list-variant-${list.listVariant}`], {
                [(0, $09faa395f06fdc03$export$2e2bcd8739ae039)["list-variant-root--last"]]: list.listVariant === "root" && index === lastListIndex
            })
        }, list.items.map((item)=>item.element));
    }));
}
function $fbeadf0ec275905f$var$Divider({ variant: variant = "default", isPresentational: isPresentational = false }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("hr", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039).divider, (0, $09faa395f06fdc03$export$2e2bcd8739ae039)[`divider-${variant}`]),
        role: isPresentational ? "presentation" : undefined
    });
}
function $fbeadf0ec275905f$var$Link({ definition: definition, expanded: expanded, activeHref: activeHref, fireFollow: fireFollow }) {
    (0, $3de0f29144bb4e85$export$6661f6891a200a5f)("SideNavigation", definition.href);
    const isActive = definition.href === activeHref;
    const onClick = (0, $acw62.useCallback)((event)=>{
        if ((0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) fireFollow(definition, event);
    }, [
        fireFollow,
        definition
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: definition.href,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039).link, {
            [(0, $09faa395f06fdc03$export$2e2bcd8739ae039)["link-active"]]: isActive
        }),
        target: definition.external ? "_blank" : undefined,
        rel: definition.external ? "noopener noreferrer" : undefined,
        "aria-expanded": expanded,
        "aria-current": definition.href === activeHref ? "page" : undefined,
        onClick: onClick
    }, definition.text, definition.external && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-label": definition.externalIconAriaLabel,
        role: definition.externalIconAriaLabel ? "img" : undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "external",
        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)["external-icon"]
    }))), definition.info && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039).info
    }, definition.info));
}
function $fbeadf0ec275905f$var$Section({ definition: definition, activeHref: activeHref, fireFollow: fireFollow, fireChange: fireChange, variant: variant }) {
    var _a;
    const [expanded, setExpanded] = (0, $acw62.useState)((_a = definition.defaultExpanded) !== null && _a !== void 0 ? _a : true);
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const onExpandedChange = (0, $acw62.useCallback)((e)=>{
        fireChange(definition, e.detail.expanded);
        setExpanded(e.detail.expanded);
    }, [
        definition,
        fireChange
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        setExpanded((_a = definition.defaultExpanded) !== null && _a !== void 0 ? _a : true);
    }, [
        definition
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $558ed5ac4f872148$export$2e2bcd8739ae039), {
        variant: "footer",
        expanded: expanded,
        onChange: onExpandedChange,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039).section, variant === "section-group" && (0, $09faa395f06fdc03$export$2e2bcd8739ae039)["section--no-ident"], isVisualRefresh && (0, $09faa395f06fdc03$export$2e2bcd8739ae039).refresh),
        headerText: definition.text
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$export$47e2c5415bb5aa12, {
        variant: "section",
        items: definition.items,
        fireFollow: fireFollow,
        fireChange: fireChange,
        activeHref: activeHref
    }));
}
function $fbeadf0ec275905f$var$SectionGroup({ definition: definition, activeHref: activeHref, fireFollow: fireFollow, fireChange: fireChange }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)["section-group"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)["section-group-title"],
        variant: "h3"
    }, definition.title), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$export$47e2c5415bb5aa12, {
        variant: "section-group",
        items: definition.items,
        fireFollow: fireFollow,
        fireChange: fireChange,
        activeHref: activeHref
    }));
}
function $fbeadf0ec275905f$var$LinkGroup({ definition: definition, activeHref: activeHref, fireFollow: fireFollow, fireChange: fireChange }) {
    (0, $3de0f29144bb4e85$export$6661f6891a200a5f)("SideNavigation", definition.href);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$Link, {
        definition: {
            type: "link",
            href: definition.href,
            text: definition.text,
            info: definition.info
        },
        fireFollow: (_, event)=>fireFollow(definition, event),
        fireChange: fireChange,
        activeHref: activeHref
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$export$47e2c5415bb5aa12, {
        variant: "link-group",
        items: definition.items,
        fireFollow: fireFollow,
        fireChange: fireChange,
        activeHref: activeHref
    }));
}
function $fbeadf0ec275905f$var$ExpandableLinkGroup({ definition: definition, fireFollow: fireFollow, fireChange: fireChange, activeHref: activeHref, variant: variant }) {
    // Check whether the definition contains an active link and memoize it to avoid
    // rechecking every time.
    const containsActiveLink = (0, $acw62.useMemo)(()=>{
        return activeHref ? (0, $e08d731147a73b24$export$35f2025888793fe1)(definition.items, activeHref) : false;
    }, [
        activeHref,
        definition.items
    ]);
    const [expanded, setExpanded] = (0, $acw62.useState)(()=>{
        var _a;
        return (_a = definition.defaultExpanded) !== null && _a !== void 0 ? _a : definition.href === activeHref || containsActiveLink;
    });
    const [userExpanded, setUserExpanded] = (0, $acw62.useState)();
    // Reset user expansion status when the items property is updated.
    (0, $acw62.useEffect)(()=>setUserExpanded(undefined), [
        definition
    ]);
    // By default, the expandable section is open when there's an active link inside.
    (0, $acw62.useEffect)(()=>{
        setExpanded(definition.href === activeHref || containsActiveLink);
    }, [
        definition.href,
        containsActiveLink,
        activeHref
    ]);
    // If the definition object itself is updated, reset the expansion state to default.
    (0, $acw62.useEffect)(()=>{
        if (definition.defaultExpanded !== undefined) setExpanded(definition.defaultExpanded);
    }, [
        definition
    ]);
    const onExpandedChange = (0, $acw62.useCallback)((e)=>{
        fireChange(definition, e.detail.expanded);
        setUserExpanded(e.detail.expanded);
    }, [
        definition,
        fireChange
    ]);
    const onHeaderFollow = (_, event)=>{
        fireFollow(definition, event);
        setUserExpanded(true);
        if (!expanded) fireChange(definition, true);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $558ed5ac4f872148$export$2e2bcd8739ae039), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039)["expandable-link-group"], variant === "section-group" && (0, $09faa395f06fdc03$export$2e2bcd8739ae039)["expandable-link-group--no-ident"]),
        variant: "navigation",
        expanded: userExpanded !== null && userExpanded !== void 0 ? userExpanded : expanded,
        onChange: onExpandedChange,
        headerText: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$var$Link, {
            definition: {
                type: "link",
                href: definition.href,
                text: definition.text
            },
            expanded: userExpanded !== null && userExpanded !== void 0 ? userExpanded : expanded,
            fireFollow: onHeaderFollow,
            fireChange: fireChange,
            activeHref: activeHref
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fbeadf0ec275905f$export$47e2c5415bb5aa12, {
        variant: "expandable-link-group",
        items: definition.items,
        fireFollow: fireFollow,
        fireChange: fireChange,
        activeHref: activeHref
    }));
}






function $97ca3a14b9e1fad1$export$5a83c1b4c43ae3e8(_a) {
    var { header: header, activeHref: activeHref, items: items = [], onFollow: onFollow, onChange: onChange, __internalRootRef: __internalRootRef } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "header",
        "activeHref",
        "items",
        "onFollow",
        "onChange",
        "__internalRootRef"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const parentMap = (0, $acw62.useMemo)(()=>(0, $e08d731147a73b24$export$9620f8797d1dcd73)(items), [
        items
    ]);
    if (0, $bf737c197e11d40f$export$df77466336fe5355) // This code should be wiped in production anyway.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acw62.useEffect)(()=>(0, $e08d731147a73b24$export$a9b81fc69bcc1c83)(items), [
        items
    ]);
    const onChangeHandler = (0, $acw62.useCallback)((item, expanded)=>{
        // generateExpandableItemsMapping walks through the entire tree, so we're certain about getting a value.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            item: item,
            expanded: expanded,
            expandableParents: parentMap.get(item)
        });
    }, [
        onChange,
        parentMap
    ]);
    const onFollowHandler = (0, $acw62.useCallback)((item, sourceEvent)=>{
        (0, $fc537b925f715587$export$d7e1721720edbb03)(onFollow, item, sourceEvent);
    }, [
        onFollow
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $09faa395f06fdc03$export$2e2bcd8739ae039).root, baseProps.className),
        ref: __internalRootRef
    }), header && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fbeadf0ec275905f$export$8b251419efc915eb), {
        definition: header,
        activeHref: activeHref,
        fireChange: onChangeHandler,
        fireFollow: onFollowHandler
    }), items && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $09faa395f06fdc03$export$2e2bcd8739ae039)["list-container"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fbeadf0ec275905f$export$47e2c5415bb5aa12), {
        variant: "root",
        items: items,
        fireFollow: onFollowHandler,
        fireChange: onChangeHandler,
        activeHref: activeHref
    })));
}
const $97ca3a14b9e1fad1$export$19dbb901354d5f3b = (0, $2b25eacde88e3edd$export$61fae46ccdc4563e)($97ca3a14b9e1fad1$export$5a83c1b4c43ae3e8);


const $8d070a3bd5b52efb$export$b5418ddf09afa424 = (0, $97ca3a14b9e1fad1$export$19dbb901354d5f3b)();


function $ea79e02d828b2693$export$2e2bcd8739ae039(_a) {
    var { items: items = [] } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "items"
    ]);
    const internalProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("SideNavigation");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8d070a3bd5b52efb$export$b5418ddf09afa424), Object.assign({}, props, internalProps, {
        items: items
    }));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($ea79e02d828b2693$export$2e2bcd8739ae039, "SideNavigation");



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $86c82fd4ab0a7351$export$2e2bcd8739ae039 = {
    "icon": "awsui_icon_k5dlb_1q1vg_97",
    "top-navigation": "awsui_top-navigation_k5dlb_1q1vg_115",
    "padding-box": "awsui_padding-box_k5dlb_1q1vg_150",
    "medium": "awsui_medium_k5dlb_1q1vg_160",
    "narrow": "awsui_narrow_k5dlb_1q1vg_160",
    "virtual": "awsui_virtual_k5dlb_1q1vg_171",
    "hidden": "awsui_hidden_k5dlb_1q1vg_175",
    "	": "awsui_	_k5dlb_1q1vg_1",
    "identity": "awsui_identity_k5dlb_1q1vg_187",
    "identity-link": "awsui_identity-link_k5dlb_1q1vg_190",
    "no-logo": "awsui_no-logo_k5dlb_1q1vg_210",
    "logo": "awsui_logo_k5dlb_1q1vg_214",
    "title": "awsui_title_k5dlb_1q1vg_226",
    "inputs": "awsui_inputs_k5dlb_1q1vg_241",
    "search": "awsui_search_k5dlb_1q1vg_249",
    "search-expanded": "awsui_search-expanded_k5dlb_1q1vg_253",
    "utilities": "awsui_utilities_k5dlb_1q1vg_257",
    "utility-wrapper": "awsui_utility-wrapper_k5dlb_1q1vg_268",
    "utility-type-button-link": "awsui_utility-type-button-link_k5dlb_1q1vg_289",
    "utility-type-menu-dropdown": "awsui_utility-type-menu-dropdown_k5dlb_1q1vg_294",
    "utility-type-button-primary-button": "awsui_utility-type-button-primary-button_k5dlb_1q1vg_303",
    "utility-link-icon": "awsui_utility-link-icon_k5dlb_1q1vg_311",
    "utility-button-external-icon": "awsui_utility-button-external-icon_k5dlb_1q1vg_315",
    "offset-right-none": "awsui_offset-right-none_k5dlb_1q1vg_319",
    "offset-right-l": "awsui_offset-right-l_k5dlb_1q1vg_323",
    "offset-right-xxl": "awsui_offset-right-xxl_k5dlb_1q1vg_327",
    "overflow-menu-drawer": "awsui_overflow-menu-drawer_k5dlb_1q1vg_332",
    "overflow-menu": "awsui_overflow-menu_k5dlb_1q1vg_332",
    "overflow-menu-header": "awsui_overflow-menu-header_k5dlb_1q1vg_376",
    "overflow-menu-header-text": "awsui_overflow-menu-header-text_k5dlb_1q1vg_384",
    "overflow-menu-header-text--secondary": "awsui_overflow-menu-header-text--secondary_k5dlb_1q1vg_396",
    "overflow-menu-header-text--title": "awsui_overflow-menu-header-text--title_k5dlb_1q1vg_402",
    "overflow-menu-back-button": "awsui_overflow-menu-back-button_k5dlb_1q1vg_406",
    "overflow-menu-dismiss-button": "awsui_overflow-menu-dismiss-button_k5dlb_1q1vg_410",
    "overflow-menu-control": "awsui_overflow-menu-control_k5dlb_1q1vg_414",
    "overflow-menu-list-item-utility": "awsui_overflow-menu-list-item-utility_k5dlb_1q1vg_455",
    "overflow-menu-control-link": "awsui_overflow-menu-control-link_k5dlb_1q1vg_463",
    "overflow-menu-control-expandable-menu-trigger": "awsui_overflow-menu-control-expandable-menu-trigger_k5dlb_1q1vg_466",
    "overflow-menu-list": "awsui_overflow-menu-list_k5dlb_1q1vg_455",
    "overflow-menu-list-submenu": "awsui_overflow-menu-list-submenu_k5dlb_1q1vg_502",
    "overflow-menu-list-item": "awsui_overflow-menu-list-item_k5dlb_1q1vg_455",
    "overflow-menu-list-item-icon": "awsui_overflow-menu-list-item-icon_k5dlb_1q1vg_511",
    "overflow-menu-list-item-text": "awsui_overflow-menu-list-item-text_k5dlb_1q1vg_514",
    "overflow-menu-list-item-submenu": "awsui_overflow-menu-list-item-submenu_k5dlb_1q1vg_523",
    "overflow-menu-list-item-dropdown-menu": "awsui_overflow-menu-list-item-dropdown-menu_k5dlb_1q1vg_529",
    "overflow-menu-list-item-expandable": "awsui_overflow-menu-list-item-expandable_k5dlb_1q1vg_533",
    "expanded": "awsui_expanded_k5dlb_1q1vg_541"
};



// A small buffer to make calculations more lenient against browser lag or padding adjustments.
const $08ca12ced8309980$var$RESPONSIVENESS_BUFFER = 20;
function $08ca12ced8309980$export$1452fd78386de60a({ identity: identity, search: search, utilities: utilities }) {
    // Refs and breakpoints
    const mainRef = (0, $acw62.useRef)(null);
    const virtualRef = (0, $acw62.useRef)(null);
    const [breakpoint, breakpointRef] = (0, $921c3f4037759790$export$2aa1887afbd6d218)([
        "xxs",
        "s"
    ]);
    // Responsiveness state
    // The component works by calculating the possible resize states that it can
    // be in, and having a state variable to track which state we're currently in.
    const hasSearch = !!search;
    const hasTitleWithLogo = identity && !!identity.logo && !!identity.title;
    const responsiveStates = (0, $acw62.useMemo)(()=>{
        return $08ca12ced8309980$export$ebce2383234760ce(utilities, hasSearch, hasTitleWithLogo);
    }, [
        utilities,
        hasSearch,
        hasTitleWithLogo
    ]);
    // To hide/show elements dynamically, we need to know how much space they take up,
    // even if they're not being rendered. The top navigation elements are hidden/resized
    // based on the available size or if a search bar is open, and they need to be available
    // for calculations so we know where to toggle them. So we render a second, more stable
    // top-nav off screen to do these calculations against.
    //
    // We can't "affix" these values to pixels because they can depend on spacing tokens.
    // It's easier to render all of these utilities separately rather than figuring out
    // spacing token values, icon sizes, text widths, etc.
    const [responsiveState, setResponsiveState] = (0, $acw62.useState)();
    const recalculateFit = (0, $acw62.useCallback)(()=>{
        var _a, _b, _c, _d;
        if (!(mainRef === null || mainRef === void 0 ? void 0 : mainRef.current) || !virtualRef.current) {
            setResponsiveState(responsiveStates[0]);
            return;
        }
        // Get available width from the visible top navigation.
        const availableWidth = $08ca12ced8309980$var$getContentBoxWidth(mainRef.current.querySelector(`.${(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["padding-box"]}`));
        if (availableWidth === 0) {
            // Likely in an SSR or Jest situation.
            setResponsiveState(responsiveStates[0]);
            return;
        }
        const sizeConfiguration = {
            hasSearch: hasSearch,
            availableWidth: availableWidth,
            // Get widths from the hidden top navigation
            fullIdentityWidth: virtualRef.current.querySelector(`.${(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).identity}`).getBoundingClientRect().width,
            titleWidth: (_b = (_a = virtualRef.current.querySelector(`.${(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).title}`)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 0,
            searchSlotWidth: (_d = (_c = virtualRef.current.querySelector(`.${(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).search}`)) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().width) !== null && _d !== void 0 ? _d : 0,
            searchUtilityWidth: virtualRef.current.querySelector('[data-utility-special="search"]').getBoundingClientRect().width,
            utilitiesLeftPadding: parseFloat(getComputedStyle(virtualRef.current.querySelector(`.${(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).utilities}`)).paddingLeft || "0px"),
            utilityWithLabelWidths: Array.prototype.slice.call(virtualRef.current.querySelectorAll(`[data-utility-hide="false"]`)).map((element)=>element.getBoundingClientRect().width),
            utilityWithoutLabelWidths: Array.prototype.slice.call(virtualRef.current.querySelectorAll(`[data-utility-hide="true"]`)).map((element)=>element.getBoundingClientRect().width),
            menuTriggerUtilityWidth: virtualRef.current.querySelector('[data-utility-special="menu-trigger"]').getBoundingClientRect().width
        };
        setResponsiveState($08ca12ced8309980$export$4d42314861d0d60c(responsiveStates, sizeConfiguration));
    }, [
        responsiveStates,
        hasSearch
    ]);
    const [, containerQueryRef] = (0, $6e052e2d296ab854$export$2e2bcd8739ae039)(()=>{
        recalculateFit();
    }, [
        recalculateFit
    ]);
    // Due to being rendered in a portal, the virtual navigation isn't rendered
    // at the same time as the main one.
    const onVirtualMount = (0, $acw62.useCallback)((element)=>{
        virtualRef.current = element;
        recalculateFit();
    }, [
        recalculateFit
    ]);
    // Search slot expansion on small screens
    const [isSearchMinimized, setSearchMinimized] = (0, $acw62.useState)(true);
    const isSearchExpanded = !isSearchMinimized && hasSearch && (responsiveState === null || responsiveState === void 0 ? void 0 : responsiveState.hideSearch);
    // If the search was expanded, and then the screen resized so that the
    // expansion is no longer necessary. So we implicitly minimize it.
    (0, $acw62.useEffect)(()=>{
        if (!(responsiveState === null || responsiveState === void 0 ? void 0 : responsiveState.hideSearch)) setSearchMinimized(true);
    }, [
        responsiveState
    ]);
    // If the search is expanded after clicking on the search utility, move
    // the focus to the input. Since this is a user-controlled slot, we're just
    // assuming that it contains an input, though it's a pretty safe guess.
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        if (isSearchExpanded) (_b = (_a = mainRef === null || mainRef === void 0 ? void 0 : mainRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`.${(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).search} input`)) === null || _b === void 0 || _b.focus();
    }, [
        isSearchExpanded,
        mainRef
    ]);
    const mergedMainRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(mainRef, containerQueryRef, breakpointRef);
    return {
        mainRef: mergedMainRef,
        virtualRef: onVirtualMount,
        responsiveState: responsiveState !== null && responsiveState !== void 0 ? responsiveState : responsiveStates[0],
        breakpoint: breakpoint !== null && breakpoint !== void 0 ? breakpoint : "default",
        isSearchExpanded: !!isSearchExpanded,
        onSearchUtilityClick: ()=>setSearchMinimized((isSearchMinimized)=>!isSearchMinimized)
    };
}
/**
 * Get the width of the content box (assuming the element's box-sizing is border-box).
 */ function $08ca12ced8309980$var$getContentBoxWidth(element) {
    const style = getComputedStyle(element);
    return parseFloat(style.width || "0px") - parseFloat(style.paddingLeft || "0px") - parseFloat(style.paddingRight || "0px");
}
function $08ca12ced8309980$export$ebce2383234760ce(utilities, canHideSearch, canHideTitle) {
    const states = [
        {}
    ];
    if (utilities.some((utility)=>utility.text)) states.push({
        hideUtilityText: true
    });
    if (canHideSearch) states.push({
        hideUtilityText: true,
        hideSearch: true
    });
    const hiddenUtilties = [];
    for(let i = 0; i < utilities.length; i++)if (!utilities[i].disableUtilityCollapse) {
        hiddenUtilties.push(i);
        states.push({
            hideUtilityText: true,
            hideSearch: canHideSearch || undefined,
            hideUtilities: hiddenUtilties.length > 0 ? hiddenUtilties.slice() : undefined
        });
    }
    if (canHideTitle) states.push({
        hideUtilityText: true,
        hideSearch: canHideSearch || undefined,
        hideUtilities: hiddenUtilties.length > 0 ? hiddenUtilties.slice() : undefined,
        hideTitle: true
    });
    return states;
}
function $08ca12ced8309980$export$4d42314861d0d60c(possibleStates, sizes) {
    const { hasSearch: hasSearch, availableWidth: availableWidth, utilitiesLeftPadding: utilitiesLeftPadding, fullIdentityWidth: fullIdentityWidth, titleWidth: titleWidth, searchSlotWidth: searchSlotWidth, searchUtilityWidth: searchUtilityWidth, utilityWithLabelWidths: utilityWithLabelWidths, utilityWithoutLabelWidths: utilityWithoutLabelWidths, menuTriggerUtilityWidth: menuTriggerUtilityWidth } = sizes;
    // Iterate through each state and calculate its expected required width.
    for (const state of possibleStates){
        const searchWidth = hasSearch ? state.hideSearch ? searchUtilityWidth : searchSlotWidth : 0;
        const utilitiesWidth = (state.hideUtilityText ? utilityWithoutLabelWidths : utilityWithLabelWidths).filter((_width, i)=>!state.hideUtilities || state.hideUtilities.indexOf(i) === -1).reduce((sum, width)=>sum + width, 0);
        const menuTriggerWidth = state.hideUtilities ? menuTriggerUtilityWidth : 0;
        const identityWidth = state.hideTitle ? fullIdentityWidth - titleWidth : fullIdentityWidth;
        const expectedInnerWidth = identityWidth + searchWidth + utilitiesLeftPadding + utilitiesWidth + menuTriggerWidth;
        if (expectedInnerWidth <= availableWidth - $08ca12ced8309980$var$RESPONSIVENESS_BUFFER) return state;
    }
    // If nothing matches, pick the smallest possible state.
    return possibleStates[possibleStates.length - 1];
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



var $1f0dcdb6a7d564f1$export$2e2bcd8739ae039 = {
    "link": "awsui_link_4c84z_1nv4c_97",
    "variant-secondary": "awsui_variant-secondary_4c84z_1nv4c_166",
    "variant-primary": "awsui_variant-primary_4c84z_1nv4c_201",
    "variant-info": "awsui_variant-info_4c84z_1nv4c_234",
    "variant-value-large": "awsui_variant-value-large_4c84z_1nv4c_269",
    "variant-top-navigation": "awsui_variant-top-navigation_4c84z_1nv4c_301",
    "variant-recovery": "awsui_variant-recovery_4c84z_1nv4c_334",
    "button": "awsui_button_4c84z_1nv4c_367",
    "color-inverted": "awsui_color-inverted_4c84z_1nv4c_402",
    "font-size-body-s": "awsui_font-size-body-s_4c84z_1nv4c_423",
    "font-size-body-m": "awsui_font-size-body-m_4c84z_1nv4c_430",
    "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_1nv4c_436",
    "font-size-heading-s": "awsui_font-size-heading-s_4c84z_1nv4c_442",
    "font-size-heading-m": "awsui_font-size-heading-m_4c84z_1nv4c_449",
    "font-size-heading-l": "awsui_font-size-heading-l_4c84z_1nv4c_456",
    "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_1nv4c_463",
    "font-size-display-l": "awsui_font-size-display-l_4c84z_1nv4c_470",
    "font-size-inherit": "awsui_font-size-inherit_4c84z_1nv4c_477",
    "icon-wrapper": "awsui_icon-wrapper_4c84z_1nv4c_485",
    "icon": "awsui_icon_4c84z_1nv4c_485"
};















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $9699df5a060a9c12$export$1a01ae0705bafd37 = {
    defaultVariant: "secondary"
};
const $9699df5a060a9c12$export$366cdc6257b696ef = (0, $acw62.createContext)($9699df5a060a9c12$export$1a01ae0705bafd37);



const $01503a290f20b804$var$InternalLink = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { variant: providedVariant, fontSize: fontSize = "body-m", color: color = "normal", external: external = false, target: target, href: href, rel: rel, ariaLabel: ariaLabel, externalIconAriaLabel: externalIconAriaLabel, onFollow: onFollow, onClick: onClick, children: children, __internalRootRef: __internalRootRef = null } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "variant",
        "fontSize",
        "color",
        "external",
        "target",
        "href",
        "rel",
        "ariaLabel",
        "externalIconAriaLabel",
        "onFollow",
        "onClick",
        "children",
        "__internalRootRef"
    ]);
    (0, $3de0f29144bb4e85$export$6661f6891a200a5f)("Link", href);
    const isButton = !href;
    const { defaultVariant: defaultVariant } = (0, $acw62.useContext)((0, $9699df5a060a9c12$export$366cdc6257b696ef));
    const variant = providedVariant || defaultVariant;
    const specialStyles = [
        "top-navigation",
        "link",
        "recovery"
    ];
    const hasSpecialStyle = specialStyles.indexOf(variant) > -1;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("link");
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const anchorTarget = target !== null && target !== void 0 ? target : external ? "_blank" : undefined;
    const anchorRel = rel !== null && rel !== void 0 ? rel : anchorTarget === "_blank" ? "noopener noreferrer" : undefined;
    const uniqueId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("link");
    const linkId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("link-self");
    const infoId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("link-info");
    const infoLinkLabelFromContext = (0, $acw62.useContext)((0, $edb6222f981e45e4$export$8ffd2daeac4a0391));
    const { funnelIdentifier: funnelIdentifier, funnelInteractionId: funnelInteractionId } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const { stepIdentifier: stepIdentifier, stepNumber: stepNumber, stepNameSelector: stepNameSelector } = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const { subStepIdentifier: subStepIdentifier, subStepSelector: subStepSelector, subStepNameSelector: subStepNameSelector } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    const fireFunnelEvent = (funnelInteractionId)=>{
        if (variant === "info") {
            const stepName = (0, $285a09b860d2bebc$export$ad08a5942dca04f8)(stepNameSelector);
            const subStepName = (0, $285a09b860d2bebc$export$ad08a5942dca04f8)(subStepNameSelector);
            (0, $54d511b0978bc73c$export$300ddd9f131af3a).helpPanelInteracted({
                funnelIdentifier: funnelIdentifier,
                funnelInteractionId: funnelInteractionId,
                stepIdentifier: stepIdentifier,
                stepNumber: stepNumber,
                stepName: stepName,
                subStepIdentifier: subStepIdentifier,
                stepNameSelector: stepNameSelector,
                subStepSelector: subStepSelector,
                subStepName: subStepName,
                subStepNameSelector: subStepNameSelector,
                elementSelector: (0, $285a09b860d2bebc$export$c0773214960ddccc)(uniqueId),
                subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)()
            });
        } else if (external) {
            const stepName = (0, $285a09b860d2bebc$export$ad08a5942dca04f8)(stepNameSelector);
            const subStepName = (0, $285a09b860d2bebc$export$ad08a5942dca04f8)(subStepNameSelector);
            (0, $54d511b0978bc73c$export$300ddd9f131af3a).externalLinkInteracted({
                funnelIdentifier: funnelIdentifier,
                funnelInteractionId: funnelInteractionId,
                stepIdentifier: stepIdentifier,
                stepNumber: stepNumber,
                stepName: stepName,
                stepNameSelector: stepNameSelector,
                subStepIdentifier: subStepIdentifier,
                subStepSelector: subStepSelector,
                subStepName: subStepName,
                subStepNameSelector: subStepNameSelector,
                elementSelector: (0, $285a09b860d2bebc$export$c0773214960ddccc)(uniqueId),
                subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)()
            });
        }
    };
    const fireFollowEvent = (event)=>{
        if (funnelInteractionId) fireFunnelEvent(funnelInteractionId);
        (0, $fc537b925f715587$export$d7e1721720edbb03)(onFollow, {
            href: href,
            external: external,
            target: anchorTarget
        }, event);
    };
    const fireClickEvent = (event)=>{
        const { altKey: altKey, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = event;
        const button = "button" in event ? event.button : 0;
        // make onClick non-cancelable to prevent it from being used to block full page reload
        // for navigation use `onFollow` event instead
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onClick, {
            altKey: altKey,
            button: button,
            ctrlKey: ctrlKey,
            metaKey: metaKey,
            shiftKey: shiftKey
        });
    };
    const handleLinkClick = (event)=>{
        if ((0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) fireFollowEvent(event);
        fireClickEvent(event);
    };
    const handleButtonClick = (event)=>{
        fireFollowEvent(event);
        fireClickEvent(event);
    };
    const handleButtonKeyDown = (event)=>{
        if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space || event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter) {
            event.preventDefault();
            fireFollowEvent(event);
            fireClickEvent(event);
        }
    };
    const linkRef = (0, $acw62.useRef)(null);
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, linkRef);
    // Visual refresh should only add styles to buttons that don't already have unique styles (e.g. primary/secondary variants)
    const applyButtonStyles = isButton && isVisualRefresh && !hasSpecialStyle;
    const sharedProps = Object.assign(Object.assign({
        id: linkId
    }, baseProps), {
        // https://github.com/microsoft/TypeScript/issues/36659
        ref: (0, $adb603d9351d0211$export$74665b213cb5c4cf)(linkRef, __internalRootRef),
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1f0dcdb6a7d564f1$export$2e2bcd8739ae039).link, baseProps.className, applyButtonStyles ? (0, $1f0dcdb6a7d564f1$export$2e2bcd8739ae039).button : null, (0, $1f0dcdb6a7d564f1$export$2e2bcd8739ae039)[$01503a290f20b804$var$getVariantStyle(variant)], (0, $1f0dcdb6a7d564f1$export$2e2bcd8739ae039)[$01503a290f20b804$var$getFontSizeStyle(variant, fontSize)], (0, $1f0dcdb6a7d564f1$export$2e2bcd8739ae039)[$01503a290f20b804$var$getColorStyle(variant, color)]),
        "aria-label": ariaLabel,
        "aria-labelledby": "",
        [(0, $285a09b860d2bebc$export$39e42cde97dfcad)]: uniqueId
    });
    if (variant === "info" && infoLinkLabelFromContext && !ariaLabel) sharedProps["aria-labelledby"] = `${sharedProps.id} ${infoId} ${infoLinkLabelFromContext}`;
    const renderedExternalIconAriaLabel = i18n("externalIconAriaLabel", externalIconAriaLabel);
    const content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children, external && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $1f0dcdb6a7d564f1$export$2e2bcd8739ae039)["icon-wrapper"]
    }, "\xa0", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $1f0dcdb6a7d564f1$export$2e2bcd8739ae039).icon,
        "aria-label": renderedExternalIconAriaLabel,
        role: renderedExternalIconAriaLabel ? "img" : undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "external",
        size: "inherit"
    }))), variant === "info" && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        hidden: true,
        id: infoId
    }, ":"));
    const { tabIndex: tabIndex } = (0, $7f9661e47bcc5460$export$4cf30df7bba16ac9)(linkRef, {
        tabIndex: isButton ? 0 : undefined
    });
    if (isButton) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({}, sharedProps, {
        role: "button",
        tabIndex: tabIndex,
        onKeyDown: handleButtonKeyDown,
        onClick: handleButtonClick
    }), content);
    return(// we dynamically set proper rel in the code above
    // eslint-disable-next-line react/jsx-no-target-blank
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({}, sharedProps, {
        tabIndex: tabIndex,
        target: anchorTarget,
        rel: anchorRel,
        href: href,
        onClick: handleLinkClick
    }), content));
});
function $01503a290f20b804$var$getVariantStyle(variant) {
    return `variant-${variant.replace(/^awsui-/, "")}`;
}
function $01503a290f20b804$var$getFontSizeStyle(variant, fontSize) {
    switch(variant){
        case "info":
            return "font-size-body-s";
        case "awsui-value-large":
            return "font-size-display-l";
        default:
            return `font-size-${fontSize}`;
    }
}
function $01503a290f20b804$var$getColorStyle(variant, color) {
    return `color-${variant === "info" ? "normal" : color}`;
}
var $01503a290f20b804$export$2e2bcd8739ae039 = $01503a290f20b804$var$InternalLink;






var $acw62 = parcelRequire("acw62");






var $e1c8c8de42f23af5$export$2e2bcd8739ae039 = {
    "button": "awsui_button_m5h9f_vvkqp_97",
    "expanded": "awsui_expanded_m5h9f_vvkqp_152",
    "offset-right-none": "awsui_offset-right-none_m5h9f_vvkqp_163",
    "offset-right-l": "awsui_offset-right-l_m5h9f_vvkqp_166",
    "offset-right-xxl": "awsui_offset-right-xxl_m5h9f_vvkqp_169",
    "text": "awsui_text_m5h9f_vvkqp_194",
    "icon": "awsui_icon_m5h9f_vvkqp_198"
};


const $f839ee348a1a366f$export$e0f8f8cab7ecda00 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ testUtilsClass: testUtilsClass, iconName: iconName, iconUrl: iconUrl, iconAlt: iconAlt, iconSvg: iconSvg, badge: badge, ariaLabel: ariaLabel, offsetRight: offsetRight, disabled: disabled, expanded: expanded, children: children, onClick: onClick }, ref)=>{
    const hasIcon = iconName || iconUrl || iconSvg;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: ref,
        type: "button",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $e1c8c8de42f23af5$export$2e2bcd8739ae039).button, (0, $e1c8c8de42f23af5$export$2e2bcd8739ae039)[`offset-right-${offsetRight}`], testUtilsClass, {
            [(0, $e1c8c8de42f23af5$export$2e2bcd8739ae039).expanded]: expanded
        }),
        "aria-label": ariaLabel,
        "aria-expanded": !!expanded,
        "aria-haspopup": true,
        disabled: disabled,
        onClick: (event)=>{
            event.preventDefault();
            onClick && onClick();
        }
    }, hasIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        className: (0, $e1c8c8de42f23af5$export$2e2bcd8739ae039).icon,
        name: iconName,
        url: iconUrl,
        alt: iconAlt,
        svg: iconSvg,
        badge: badge
    }), children && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $e1c8c8de42f23af5$export$2e2bcd8739ae039).text
    }, children), children && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "caret-down-filled",
        className: expanded ? (0, $ad928a6240f442f3$export$2e2bcd8739ae039)["rotate-up"] : (0, $ad928a6240f442f3$export$2e2bcd8739ae039)["rotate-down"]
    }));
});
const $f839ee348a1a366f$var$MenuDropdown = (_a)=>{
    var { iconName: iconName, iconUrl: iconUrl, iconAlt: iconAlt, iconSvg: iconSvg, badge: badge, offsetRight: offsetRight, children: children } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "iconName",
        "iconUrl",
        "iconAlt",
        "iconSvg",
        "badge",
        "offsetRight",
        "children"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const dropdownTrigger = ({ triggerRef: triggerRef, ariaLabel: ariaLabel, isOpen: isOpen, testUtilsClass: testUtilsClass, disabled: disabled, onClick: onClick })=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f839ee348a1a366f$export$e0f8f8cab7ecda00, {
            testUtilsClass: testUtilsClass,
            ref: triggerRef,
            disabled: disabled,
            expanded: isOpen,
            iconName: iconName,
            iconUrl: iconUrl,
            iconAlt: iconAlt,
            iconSvg: iconSvg,
            badge: badge,
            ariaLabel: ariaLabel,
            offsetRight: offsetRight,
            onClick: onClick
        }, children);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eed8d7153e9df678$export$2e2bcd8739ae039), Object.assign({}, baseProps, props, {
        variant: "navigation",
        customTriggerBuilder: dropdownTrigger,
        preferCenter: true
    }));
};
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($f839ee348a1a366f$var$MenuDropdown, "MenuDropdown");
var $f839ee348a1a366f$export$2e2bcd8739ae039 = $f839ee348a1a366f$var$MenuDropdown;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Joins strings with a whitespace, discarding empty strings. Useful to combine multiple aria-labels.
 */ function $49fa9e74c692ea64$export$b933cda3796739ed(...strings) {
    return strings.filter(Boolean).join(" ") || undefined;
}




function $4c089e0b33219dfd$export$2e2bcd8739ae039({ hideText: hideText, definition: definition, offsetRight: offsetRight }) {
    var _a;
    const hasIcon = !!definition.iconName || !!definition.iconUrl || !!definition.iconAlt || !!definition.iconSvg;
    const shouldHideText = hideText && !definition.disableTextCollapse && hasIcon;
    let ariaLabel = (_a = definition.ariaLabel) !== null && _a !== void 0 ? _a : definition.text;
    if (definition.type === "button") {
        ariaLabel = definition.ariaLabel ? definition.ariaLabel : (0, $49fa9e74c692ea64$export$b933cda3796739ed)(definition.text, definition.externalIconAriaLabel);
        (0, $3de0f29144bb4e85$export$6661f6891a200a5f)("TopNavigation", definition.href);
        if (definition.variant === "primary-button") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`offset-right-${offsetRight}`]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            variant: "primary",
            href: definition.href,
            target: definition.external ? "_blank" : undefined,
            onClick: definition.onClick,
            onFollow: definition.onFollow,
            ariaLabel: ariaLabel,
            iconName: definition.iconName,
            iconUrl: definition.iconUrl,
            iconAlt: definition.iconAlt,
            iconSvg: definition.iconSvg
        }, shouldHideText ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, definition.text, definition.external && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, " ", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["utility-button-external-icon"], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`offset-right-${offsetRight}`]),
            "aria-label": definition.externalIconAriaLabel,
            role: definition.externalIconAriaLabel ? "img" : undefined
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "external"
        }))))));
        else // Link
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`offset-right-${offsetRight}`]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $01503a290f20b804$export$2e2bcd8739ae039), {
            variant: "top-navigation",
            href: definition.href,
            target: definition.target,
            rel: definition.rel,
            external: definition.external,
            onFollow: (evt)=>{
                (0, $fc537b925f715587$export$d7e1721720edbb03)(definition.onFollow, {
                    href: definition.href,
                    target: definition.target,
                    external: definition.external
                }, evt);
                (0, $fc537b925f715587$export$d7e1721720edbb03)(definition.onClick, {
                    href: definition.href,
                    target: definition.target,
                    external: definition.external
                }, evt);
            },
            ariaLabel: ariaLabel
        }, hasIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: definition.iconName,
            url: definition.iconUrl,
            alt: definition.iconAlt,
            svg: definition.iconSvg,
            badge: definition.badge
        }), !shouldHideText && definition.text && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: hasIcon ? (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["utility-link-icon"] : undefined
        }, definition.text)));
    } else if (definition.type === "menu-dropdown") {
        const title = definition.title || definition.text;
        const shouldShowTitle = shouldHideText || !definition.text;
        const items = $4c089e0b33219dfd$var$excludeCheckboxes(definition.items);
        $4c089e0b33219dfd$var$checkSafeUrlRecursively(definition.items);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f839ee348a1a366f$export$2e2bcd8739ae039), Object.assign({}, definition, {
            items: items,
            title: shouldShowTitle ? title : "",
            ariaLabel: ariaLabel,
            offsetRight: offsetRight
        }), !shouldHideText && definition.text);
    }
    return null;
}
function $4c089e0b33219dfd$var$checkSafeUrlRecursively(itemOrGroup) {
    for (const item of itemOrGroup){
        if ((0, $36113732f360ff28$export$211c15450d7814f3)(item)) (0, $3de0f29144bb4e85$export$6661f6891a200a5f)("TopNavigation", item.href);
        if ("items" in item) $4c089e0b33219dfd$var$checkSafeUrlRecursively(item.items);
    }
}
function $4c089e0b33219dfd$var$excludeCheckboxes(items) {
    return items.map((item)=>{
        if (item.itemType === "checkbox") return null;
        if ("items" in item) return Object.assign(Object.assign({}, item), {
            items: $4c089e0b33219dfd$var$excludeCheckboxes(item.items)
        });
        return item;
    }).filter((item)=>item !== null);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $d6887b82092c9af8$var$defaultCtx = {
    state: {
        view: "utilities",
        data: null
    },
    setState: ()=>{}
};
const $d6887b82092c9af8$export$c3ad42ebfc49b96d = (0, $acw62.createContext)($d6887b82092c9af8$var$defaultCtx);
const $d6887b82092c9af8$export$9770f232ac06a008 = ()=>{
    const { setState: setState } = (0, $acw62.useContext)($d6887b82092c9af8$export$c3ad42ebfc49b96d);
    const navigate = (view, data)=>{
        setState({
            view: view,
            data: data
        });
    };
    return navigate;
};
const $d6887b82092c9af8$export$e7b0ac011bb776c6 = ({ view: view, element: element })=>{
    const { state: state } = (0, $acw62.useContext)($d6887b82092c9af8$export$c3ad42ebfc49b96d);
    if (view === state.view) {
        if (typeof element === "function") return element(state.data);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, element);
    }
    return null;
};
const $d6887b82092c9af8$var$Router = ({ children: children })=>{
    const [state, setState] = (0, $acw62.useState)({
        view: "utilities",
        data: null
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d6887b82092c9af8$export$c3ad42ebfc49b96d.Provider, {
        value: {
            state: state,
            setState: setState
        }
    }, children);
};
var $d6887b82092c9af8$export$2e2bcd8739ae039 = $d6887b82092c9af8$var$Router;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


const $a1a7b8ef02d5746f$var$Header = ({ children: children, secondaryText: secondaryText, backIconAriaLabel: backIconAriaLabel, dismissIconAriaLabel: dismissIconAriaLabel, onBack: onBack, onClose: onClose })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-header"]
    }, onBack && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        // Used for test-utils, which require the selectable element to have a classname.
        // eslint-disable-next-line react/forbid-component-props
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-back-button"],
        ariaLabel: backIconAriaLabel,
        iconName: "angle-left",
        variant: "icon",
        onClick: ()=>onBack()
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-header-text"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-header-text--title"]
    }, children), secondaryText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-header-text--secondary"]
    }, secondaryText)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        // eslint-disable-next-line react/forbid-component-props
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-dismiss-button"],
        ariaLabel: dismissIconAriaLabel,
        iconName: "close",
        variant: "icon",
        onClick: ()=>onClose && onClose()
    }));
};
var $a1a7b8ef02d5746f$export$2e2bcd8739ae039 = $a1a7b8ef02d5746f$var$Header;




var $acw62 = parcelRequire("acw62");







const $ee8af3c74c2e73d8$var$ListItem = ({ children: children, startIcon: startIcon, endIcon: endIcon })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, startIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-list-item-icon"]
    }, startIcon), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-list-item-text"]
    }, children), endIcon && endIcon);
};
const $ee8af3c74c2e73d8$var$LinkItem = (0, $acw62.forwardRef)(({ children: children, external: external, href: href, target: target, rel: rel, startIcon: startIcon, endIcon: endIcon, onClick: onClick, context: context, testId: testId }, ref)=>{
    const anchorTarget = target !== null && target !== void 0 ? target : external ? "_blank" : undefined;
    const anchorRel = rel !== null && rel !== void 0 ? rel : anchorTarget === "_blank" ? "noopener noreferrer" : undefined;
    const role = !href ? "button" : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
        ref: ref,
        onClick: onClick,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-control"], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-control-link"], context && (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-control-${context}`]),
        role: role,
        tabIndex: 0,
        href: href,
        target: anchorTarget,
        rel: anchorRel
    }, testId ? {
        "data-testid": testId
    } : {}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$ListItem, {
        startIcon: startIcon,
        endIcon: endIcon
    }, children));
});
const $ee8af3c74c2e73d8$var$ButtonItem = (0, $acw62.forwardRef)(({ children: children, startIcon: startIcon, endIcon: endIcon, onClick: onClick, testId: testId }, ref)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        ref: ref,
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-control"],
        onClick: onClick
    }, typeof testId === "string" ? {
        "data-testid": testId
    } : {}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$ListItem, {
        startIcon: startIcon,
        endIcon: endIcon
    }, children));
});
const $ee8af3c74c2e73d8$var$NavigationItem = (0, $acw62.forwardRef)((_a, ref)=>{
    var { startIcon: startIcon, children: children, index: index, testId: testId } = _a, definition = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "startIcon",
        "children",
        "index",
        "testId"
    ]);
    const navigate = (0, $d6887b82092c9af8$export$9770f232ac06a008)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$ButtonItem, {
        ref: ref,
        startIcon: startIcon,
        endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "angle-right"
        }),
        testId: testId,
        onClick: ()=>navigate("dropdown-menu", {
                definition: definition,
                headerText: definition.text || definition.title,
                headerSecondaryText: definition.description,
                utilityIndex: index
            })
    }, children);
});
const $ee8af3c74c2e73d8$var$ExpandableItem = (_a)=>{
    var { children: children, onItemClick: onItemClick } = _a, definition = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "children",
        "onItemClick"
    ]);
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const headerId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("overflow-menu-item");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-control"], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-control-expandable-menu-trigger"]),
        onClick: ()=>setExpanded((value)=>!value),
        "aria-expanded": expanded
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$ListItem, {
        endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).icon, expanded && (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).expanded)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "caret-up-filled"
        }))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: headerId
    }, children))), expanded && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-list"], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-list-submenu"]),
        "aria-labelledby": headerId
    }, definition.items.map((item, index)=>{
        const isGroup = typeof item.items !== "undefined";
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: index,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-list-item`], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-list-item-dropdown-menu`])
        }, $ee8af3c74c2e73d8$var$dropdownComponentFactory(item, isGroup, onItemClick));
    })));
};
function $ee8af3c74c2e73d8$var$utilityComponentFactory(utility, index, ref) {
    const label = utility.text || utility.title;
    const hasIcon = !!utility.iconName || !!utility.iconUrl || !!utility.iconAlt || !!utility.iconSvg;
    const startIcon = hasIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: utility.iconName,
        url: utility.iconUrl,
        alt: utility.iconAlt,
        svg: utility.iconSvg
    });
    switch(utility.type){
        case "button":
            {
                const handleClick = (event)=>{
                    var _a;
                    if (Boolean(utility.href) && (0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) (0, $fc537b925f715587$export$d7e1721720edbb03)(utility.onFollow, {
                        href: utility.href,
                        target: utility.target
                    }, event);
                    (0, $fc537b925f715587$export$d7e1721720edbb03)(utility.onClick, {}, event);
                    (_a = utility.onClose) === null || _a === void 0 || _a.call(utility);
                };
                const content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, label, utility.external && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, " ", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    "aria-label": utility.externalIconAriaLabel,
                    role: utility.externalIconAriaLabel ? "img" : undefined
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
                    name: "external",
                    size: "normal"
                }))));
                if (!utility.href) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$ButtonItem, {
                    ref: ref,
                    startIcon: startIcon,
                    onClick: handleClick,
                    testId: `__${index}`
                }, content);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$LinkItem, {
                    ref: ref,
                    startIcon: startIcon,
                    href: utility.href,
                    external: utility.external,
                    target: utility.target,
                    rel: utility.rel,
                    testId: `__${index}`,
                    onClick: handleClick
                }, content);
            }
        case "menu-dropdown":
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$NavigationItem, Object.assign({
                ref: ref,
                startIcon: startIcon,
                index: index
            }, utility, {
                testId: `__${index}`
            }), label);
    }
}
function $ee8af3c74c2e73d8$var$dropdownComponentFactory(item, expandable, onItemClick) {
    const label = item.text;
    const hasIcon = !!item.iconName || !!item.iconUrl || !!item.iconAlt || !!item.iconSvg;
    const isLink = (0, $36113732f360ff28$export$211c15450d7814f3)(item);
    const startIcon = hasIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: item.iconName,
        url: item.iconUrl,
        alt: item.iconAlt,
        svg: item.iconSvg
    });
    if (expandable) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$ExpandableItem, Object.assign({}, item, {
        onItemClick: onItemClick
    }), label);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ee8af3c74c2e73d8$var$LinkItem, {
        startIcon: startIcon,
        href: isLink ? item.href : undefined,
        external: isLink ? item.external : undefined,
        context: "dropdown-menu",
        testId: item.id,
        onClick: (event)=>onItemClick(event, item)
    }, label, isLink && item.external && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, " ", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-label": item.externalIconAriaLabel,
        role: item.externalIconAriaLabel ? "img" : undefined
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "external",
        size: "normal"
    }))));
}
const $ee8af3c74c2e73d8$export$654fec7a6e91b021 = (0, $acw62.forwardRef)((_a, ref)=>{
    var { index: index } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "index"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-list-item`], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-list-item-utility`])
    }, $ee8af3c74c2e73d8$var$utilityComponentFactory(props, index, ref));
});
const $ee8af3c74c2e73d8$export$9bfb1e302b1192e9 = (props)=>{
    const expandable = typeof props.items !== "undefined";
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-list-item`], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-list-item-submenu`], expandable && (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`overflow-menu-list-item-expandable`])
    }, $ee8af3c74c2e73d8$var$dropdownComponentFactory(props, expandable, props.onClick));
};




const $a78e2c3b6dd21636$var$UtilitiesView = ({ headerText: headerText, dismissIconAriaLabel: dismissIconAriaLabel, onClose: onClose, items: items = [], focusIndex: focusIndex })=>{
    const headerId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("overflow-menu-header");
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        var _a;
        // A focus index is used to set the focus back to the submenu trigger
        // returning from a submenu.
        if (typeof focusIndex === "number") (_a = ref.current) === null || _a === void 0 || _a.focus();
    }, [
        focusIndex
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48646398710f9406$export$2e2bcd8739ae039), {
        autoFocus: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1a7b8ef02d5746f$export$2e2bcd8739ae039), {
        dismissIconAriaLabel: dismissIconAriaLabel,
        onClose: onClose
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: headerId
    }, headerText)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-list"],
        "aria-labelledby": headerId
    }, items.map((utility, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ee8af3c74c2e73d8$export$654fec7a6e91b021), Object.assign({
            key: index,
            index: index,
            ref: index === focusIndex ? ref : undefined,
            onClose: onClose
        }, utility)))));
};
var $a78e2c3b6dd21636$export$2e2bcd8739ae039 = $a78e2c3b6dd21636$var$UtilitiesView;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");








const $631f73cba7eaef88$var$SubmenuView = ({ onClose: onClose, utilityIndex: utilityIndex, headerText: headerText, headerSecondaryText: headerSecondaryText, dismissIconAriaLabel: dismissIconAriaLabel, backIconAriaLabel: backIconAriaLabel, definition: definition })=>{
    const navigate = (0, $d6887b82092c9af8$export$9770f232ac06a008)();
    const headerId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("overflow-menu-header");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48646398710f9406$export$2e2bcd8739ae039), {
        autoFocus: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1a7b8ef02d5746f$export$2e2bcd8739ae039), {
        secondaryText: headerSecondaryText,
        dismissIconAriaLabel: dismissIconAriaLabel,
        backIconAriaLabel: backIconAriaLabel,
        onClose: onClose,
        onBack: ()=>navigate("utilities", {
                utilityIndex: utilityIndex
            })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: headerId
    }, headerText)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-list"], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-list-submenu"]),
        "aria-labelledby": headerId
    }, definition.items.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ee8af3c74c2e73d8$export$9bfb1e302b1192e9), Object.assign({
            key: index
        }, item, {
            onClick: (event, item)=>{
                if (item.href && (0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) (0, $fc537b925f715587$export$d7e1721720edbb03)(definition.onItemFollow, {
                    id: item.id,
                    href: item.href,
                    external: item.external
                }, event);
                (0, $fc537b925f715587$export$d7e1721720edbb03)(definition.onItemClick, {
                    id: item.id,
                    href: item.href,
                    external: item.external
                }, event);
                onClose === null || onClose === void 0 || onClose();
            }
        })))));
};
var $631f73cba7eaef88$export$2e2bcd8739ae039 = $631f73cba7eaef88$var$SubmenuView;




const $d12922b6dc43cbfb$var$OverflowMenu = ({ headerText: headerText, dismissIconAriaLabel: dismissIconAriaLabel, backIconAriaLabel: backIconAriaLabel, items: items = [], onClose: onClose })=>{
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("top-navigation");
    const renderedDismissIconAriaLabel = i18n("i18nStrings.overflowMenuDismissIconAriaLabel", dismissIconAriaLabel);
    const renderedBackIconAriaLabel = i18n("i18nStrings.overflowMenuBackIconAriaLabel", backIconAriaLabel);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu"],
        onKeyUp: (event)=>{
            if (event.key === "Escape") onClose === null || onClose === void 0 || onClose();
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6887b82092c9af8$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6887b82092c9af8$export$e7b0ac011bb776c6), {
        view: "utilities",
        element: (data)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a78e2c3b6dd21636$export$2e2bcd8739ae039), {
                headerText: i18n("i18nStrings.overflowMenuTitleText", headerText),
                items: items,
                focusIndex: data === null || data === void 0 ? void 0 : data.utilityIndex,
                dismissIconAriaLabel: renderedDismissIconAriaLabel,
                backIconAriaLabel: renderedBackIconAriaLabel,
                onClose: onClose
            })
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d6887b82092c9af8$export$e7b0ac011bb776c6), {
        view: "dropdown-menu",
        element: (data)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $631f73cba7eaef88$export$2e2bcd8739ae039), {
                headerText: data === null || data === void 0 ? void 0 : data.headerText,
                headerSecondaryText: data === null || data === void 0 ? void 0 : data.headerSecondaryText,
                dismissIconAriaLabel: renderedDismissIconAriaLabel,
                backIconAriaLabel: renderedBackIconAriaLabel,
                definition: data === null || data === void 0 ? void 0 : data.definition,
                utilityIndex: data === null || data === void 0 ? void 0 : data.utilityIndex,
                onClose: onClose
            })
    })));
};
var $d12922b6dc43cbfb$export$2e2bcd8739ae039 = $d12922b6dc43cbfb$var$OverflowMenu;








function $3a7cb2c90d1e72da$export$2e2bcd8739ae039(_a) {
    var { __internalRootRef: __internalRootRef, identity: identity, i18nStrings: i18nStrings, utilities: utilities, search: search } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "__internalRootRef",
        "identity",
        "i18nStrings",
        "utilities",
        "search"
    ]);
    (0, $3de0f29144bb4e85$export$6661f6891a200a5f)("TopNavigation", identity.href);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const { mainRef: mainRef, virtualRef: virtualRef, breakpoint: breakpoint, responsiveState: responsiveState, isSearchExpanded: isSearchExpanded, onSearchUtilityClick: onSearchUtilityClick } = (0, $08ca12ced8309980$export$1452fd78386de60a)({
        identity: identity,
        search: search,
        utilities: utilities
    });
    const [overflowMenuOpen, setOverflowMenuOpen] = (0, $acw62.useState)(false);
    const overflowMenuTriggerRef = (0, $acw62.useRef)(null);
    const isNarrowViewport = breakpoint === "default";
    const isMediumViewport = breakpoint === "xxs";
    const isLargeViewport = breakpoint === "s";
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("top-navigation");
    // ButtonDropdown supports checkbox items but we don't support these in TopNavigation. Shown an error in development mode
    // to alert users of this and that it might change in the future.
    if (0, $ea769919060d7f5c$export$df77466336fe5355) {
        if (utilities.some((item)=>item.type === "menu-dropdown" && (0, $36113732f360ff28$export$31764348ecae41a2)(item.items))) (0, $dd646455762bc7b9$export$5b28268982f175ba)("TopNavigation", "The TopNavigation component does not support menu-dropdown items with `itemType` equal to `checkbox`.");
    }
    const onIdentityClick = (event)=>{
        if ((0, $fc537b925f715587$export$aaf9a36dd84c3909)(event)) (0, $fc537b925f715587$export$d7e1721720edbb03)(identity.onFollow, {}, event);
    };
    const toggleOverflowMenu = ()=>{
        setOverflowMenuOpen((overflowMenuOpen)=>!overflowMenuOpen);
    };
    const menuTriggerVisible = !isSearchExpanded && responsiveState.hideUtilities;
    (0, $acw62.useEffect)(()=>{
        setOverflowMenuOpen(false);
    }, [
        menuTriggerVisible
    ]);
    (0, $134bbee1801695be$export$21dfe79102a9caab)(()=>{
        var _a;
        if (!overflowMenuOpen) (_a = overflowMenuTriggerRef.current) === null || _a === void 0 || _a.focus();
    }, [
        overflowMenuOpen
    ]);
    // Render the top nav twice; once as the top nav that users can see, and another
    // "virtual" top nav used just for calculations. The virtual top nav doesn't react to
    // layout changes and renders two sets of utilities: one with labels and one without.
    const content = (isVirtual)=>{
        var _a, _b;
        const Wrapper = isVirtual ? "div" : "header";
        const showIdentity = isVirtual || !isSearchExpanded;
        const showTitle = isVirtual || !responsiveState.hideTitle;
        const showSearchSlot = search && (isVirtual || !responsiveState.hideSearch || isSearchExpanded);
        const showSearchUtility = isVirtual || search && responsiveState.hideSearch;
        const showUtilities = isVirtual || !isSearchExpanded;
        const showMenuTrigger = isVirtual || menuTriggerVisible;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Wrapper, {
            ref: isVirtual ? virtualRef : mainRef,
            "aria-hidden": isVirtual ? true : undefined,
            // Wrapper is an alias for "div" or "header".
            // eslint-disable-next-line react/forbid-component-props
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["top-navigation"], {
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).virtual]: isVirtual,
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).hidden]: isVirtual,
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).narrow]: isNarrowViewport,
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).medium]: isMediumViewport
            })
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["padding-box"]
        }, showIdentity && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).identity, !identity.logo && (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["no-logo"])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
            className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["identity-link"],
            href: identity.href,
            onClick: onIdentityClick
        }, identity.logo && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
            role: "img",
            src: (_a = identity.logo) === null || _a === void 0 ? void 0 : _a.src,
            alt: (_b = identity.logo) === null || _b === void 0 ? void 0 : _b.alt,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).logo, {
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).narrow]: isNarrowViewport
            })
        }), showTitle && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).title
        }, identity.title))), showSearchSlot && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).inputs
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).search, !isVirtual && isSearchExpanded && (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["search-expanded"])
        }, search)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).utilities
        }, showSearchUtility && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["utility-wrapper"], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["utility-type-button"], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["utility-type-button-link"], {
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).narrow]: isNarrowViewport,
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).medium]: isMediumViewport
            }),
            "data-utility-special": "search"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c089e0b33219dfd$export$2e2bcd8739ae039), {
            hideText: true,
            definition: {
                type: "button",
                iconName: isSearchExpanded ? "close" : "search",
                ariaLabel: isSearchExpanded ? i18n("i18nStrings.searchDismissIconAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.searchDismissIconAriaLabel) : i18n("i18nStrings.searchIconAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.searchIconAriaLabel),
                onClick: onSearchUtilityClick
            }
        })), showUtilities && utilities.filter((_utility, i)=>isVirtual || !responsiveState.hideUtilities || responsiveState.hideUtilities.indexOf(i) === -1).map((utility, i)=>{
            var _a;
            const hideText = !!responsiveState.hideUtilityText;
            const isLast = (isVirtual || !showMenuTrigger) && i === utilities.length - 1;
            const offsetRight = isLast && isLargeViewport ? "xxl" : isLast ? "l" : undefined;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: i,
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["utility-wrapper"], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`utility-type-${utility.type}`], utility.type === "button" && (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`utility-type-button-${(_a = utility.variant) !== null && _a !== void 0 ? _a : "link"}`], {
                    [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).narrow]: isNarrowViewport,
                    [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).medium]: isMediumViewport
                }),
                "data-utility-index": i,
                "data-utility-hide": `${hideText}`
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c089e0b33219dfd$export$2e2bcd8739ae039), {
                hideText: hideText,
                definition: utility,
                offsetRight: offsetRight
            }));
        }), isVirtual && utilities.map((utility, i)=>{
            var _a;
            const hideText = !responsiveState.hideUtilityText;
            const isLast = !showMenuTrigger && i === utilities.length - 1;
            const offsetRight = isLast && isLargeViewport ? "xxl" : isLast ? "l" : undefined;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: i,
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["utility-wrapper"], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`utility-type-${utility.type}`], utility.type === "button" && (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)[`utility-type-button-${(_a = utility.variant) !== null && _a !== void 0 ? _a : "link"}`], {
                    [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).narrow]: isNarrowViewport,
                    [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).medium]: isMediumViewport
                }),
                "data-utility-index": i,
                "data-utility-hide": `${hideText}`
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c089e0b33219dfd$export$2e2bcd8739ae039), {
                hideText: hideText,
                definition: utility,
                offsetRight: offsetRight
            }));
        }), showMenuTrigger && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["utility-wrapper"], (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["utility-type-menu-dropdown"], {
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).narrow]: isNarrowViewport,
                [(0, $86c82fd4ab0a7351$export$2e2bcd8739ae039).medium]: isMediumViewport
            }),
            "data-utility-special": "menu-trigger"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f839ee348a1a366f$export$e0f8f8cab7ecda00), {
            expanded: overflowMenuOpen,
            onClick: toggleOverflowMenu,
            offsetRight: "l",
            ref: !isVirtual ? overflowMenuTriggerRef : undefined
        }, i18n("i18nStrings.overflowMenuTriggerText", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.overflowMenuTriggerText))))));
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        ref: __internalRootRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8856d0c7df08fd8d$export$2e2bcd8739ae039), {
        contextName: "top-navigation"
    }, content(true), content(false), menuTriggerVisible && overflowMenuOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $86c82fd4ab0a7351$export$2e2bcd8739ae039)["overflow-menu-drawer"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d12922b6dc43cbfb$export$2e2bcd8739ae039), {
        headerText: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.overflowMenuTitleText,
        dismissIconAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.overflowMenuDismissIconAriaLabel,
        backIconAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.overflowMenuBackIconAriaLabel,
        items: utilities.filter((utility, i)=>(!responsiveState.hideUtilities || responsiveState.hideUtilities.indexOf(i) !== -1) && !utility.disableUtilityCollapse),
        onClose: toggleOverflowMenu
    }))));
}


function $a6eb6096d647f226$export$2e2bcd8739ae039(_a) {
    var { utilities: utilities = [] } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "utilities"
    ]);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("TopNavigation");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3a7cb2c90d1e72da$export$2e2bcd8739ae039), Object.assign({}, baseComponentProps, {
        utilities: utilities
    }, restProps));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($a6eb6096d647f226$export$2e2bcd8739ae039, "TopNavigation");



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $d8475b95fcbdc3b7$export$24a86ef7798177e4 = "v1";
const $d8475b95fcbdc3b7$var$scheme = window.location.protocol;
let $d8475b95fcbdc3b7$var$_url = $d8475b95fcbdc3b7$var$scheme + "//" + window.location.host + window.location.pathname;
if (!$d8475b95fcbdc3b7$var$_url.endsWith("/")) $d8475b95fcbdc3b7$var$_url += "/";
const $d8475b95fcbdc3b7$export$ca6dda5263526f75 = $d8475b95fcbdc3b7$var$_url;
const $d8475b95fcbdc3b7$export$923ea8233b386e99 = `${$d8475b95fcbdc3b7$var$_url}api/${$d8475b95fcbdc3b7$export$24a86ef7798177e4}/`;


// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $5f9e38360d79f95a$var$__defProp = Object.defineProperty;
var $5f9e38360d79f95a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5f9e38360d79f95a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5f9e38360d79f95a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5f9e38360d79f95a$var$__defNormalProp = (obj, key, value)=>key in obj ? $5f9e38360d79f95a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5f9e38360d79f95a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5f9e38360d79f95a$var$__hasOwnProp.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    if ($5f9e38360d79f95a$var$__getOwnPropSymbols) {
        for (var prop of $5f9e38360d79f95a$var$__getOwnPropSymbols(b))if ($5f9e38360d79f95a$var$__propIsEnum.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $5f9e38360d79f95a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $5f9e38360d79f95a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $5f9e38360d79f95a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $5f9e38360d79f95a$var$errors = [];
function $5f9e38360d79f95a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $5f9e38360d79f95a$var$getPrototypeOf = Object.getPrototypeOf;
function $5f9e38360d79f95a$export$541ac630993a4c84(value) {
    return !!value && !!value[$5f9e38360d79f95a$var$DRAFT_STATE];
}
function $5f9e38360d79f95a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $5f9e38360d79f95a$var$isPlainObject(value) || Array.isArray(value) || !!value[$5f9e38360d79f95a$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$5f9e38360d79f95a$export$6ee2082928bcb0ee]) || $5f9e38360d79f95a$var$isMap(value) || $5f9e38360d79f95a$var$isSet(value);
}
var $5f9e38360d79f95a$var$objectCtorString = Object.prototype.constructor.toString();
function $5f9e38360d79f95a$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $5f9e38360d79f95a$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $5f9e38360d79f95a$var$objectCtorString;
}
function $5f9e38360d79f95a$export$22e8af3f75a010e3(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(15, value);
    return value[$5f9e38360d79f95a$var$DRAFT_STATE].base_;
}
function $5f9e38360d79f95a$var$each(obj, iter) {
    if ($5f9e38360d79f95a$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $5f9e38360d79f95a$var$getArchtype(thing) {
    const state = thing[$5f9e38360d79f95a$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $5f9e38360d79f95a$var$isMap(thing) ? 2 /* Map */  : $5f9e38360d79f95a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $5f9e38360d79f95a$var$has(thing, prop) {
    return $5f9e38360d79f95a$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $5f9e38360d79f95a$var$get(thing, prop) {
    return $5f9e38360d79f95a$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $5f9e38360d79f95a$var$set(thing, propOrOldValue, value) {
    const t = $5f9e38360d79f95a$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $5f9e38360d79f95a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5f9e38360d79f95a$var$isMap(target) {
    return target instanceof Map;
}
function $5f9e38360d79f95a$var$isSet(target) {
    return target instanceof Set;
}
function $5f9e38360d79f95a$var$latest(state) {
    return state.copy_ || state.base_;
}
function $5f9e38360d79f95a$var$shallowCopy(base, strict) {
    if ($5f9e38360d79f95a$var$isMap(base)) return new Map(base);
    if ($5f9e38360d79f95a$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $5f9e38360d79f95a$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$5f9e38360d79f95a$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($5f9e38360d79f95a$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $5f9e38360d79f95a$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $5f9e38360d79f95a$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $5f9e38360d79f95a$export$792f3d81ea979f55(obj, deep = false) {
    if ($5f9e38360d79f95a$var$isFrozen(obj) || $5f9e38360d79f95a$export$541ac630993a4c84(obj) || !$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
    if ($5f9e38360d79f95a$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $5f9e38360d79f95a$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$5f9e38360d79f95a$export$792f3d81ea979f55(value, true));
    return obj;
}
function $5f9e38360d79f95a$var$dontMutateFrozenCollections() {
    $5f9e38360d79f95a$var$die(2);
}
function $5f9e38360d79f95a$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $5f9e38360d79f95a$var$plugins = {};
function $5f9e38360d79f95a$var$getPlugin(pluginKey) {
    const plugin = $5f9e38360d79f95a$var$plugins[pluginKey];
    if (!plugin) $5f9e38360d79f95a$var$die(0, pluginKey);
    return plugin;
}
function $5f9e38360d79f95a$var$loadPlugin(pluginKey, implementation) {
    if (!$5f9e38360d79f95a$var$plugins[pluginKey]) $5f9e38360d79f95a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $5f9e38360d79f95a$var$currentScope;
function $5f9e38360d79f95a$var$getCurrentScope() {
    return $5f9e38360d79f95a$var$currentScope;
}
function $5f9e38360d79f95a$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $5f9e38360d79f95a$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $5f9e38360d79f95a$var$revokeScope(scope) {
    $5f9e38360d79f95a$var$leaveScope(scope);
    scope.drafts_.forEach($5f9e38360d79f95a$var$revokeDraft);
    scope.drafts_ = null;
}
function $5f9e38360d79f95a$var$leaveScope(scope) {
    if (scope === $5f9e38360d79f95a$var$currentScope) $5f9e38360d79f95a$var$currentScope = scope.parent_;
}
function $5f9e38360d79f95a$var$enterScope(immer2) {
    return $5f9e38360d79f95a$var$currentScope = $5f9e38360d79f95a$var$createScope($5f9e38360d79f95a$var$currentScope, immer2);
}
function $5f9e38360d79f95a$var$revokeDraft(draft) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $5f9e38360d79f95a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].modified_) {
            $5f9e38360d79f95a$var$revokeScope(scope);
            $5f9e38360d79f95a$var$die(4);
        }
        if ($5f9e38360d79f95a$export$16e3aed3edb85946(result)) {
            result = $5f9e38360d79f95a$var$finalize(scope, result);
            if (!scope.parent_) $5f9e38360d79f95a$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $5f9e38360d79f95a$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $5f9e38360d79f95a$var$finalize(scope, baseDraft, []);
    $5f9e38360d79f95a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $5f9e38360d79f95a$export$45b790e32b2810ee ? result : void 0;
}
function $5f9e38360d79f95a$var$finalize(rootScope, value, path) {
    if ($5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (!state) {
        $5f9e38360d79f95a$var$each(value, (key, childValue)=>$5f9e38360d79f95a$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $5f9e38360d79f95a$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $5f9e38360d79f95a$var$each(resultEach, (key, childValue)=>$5f9e38360d79f95a$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $5f9e38360d79f95a$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $5f9e38360d79f95a$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $5f9e38360d79f95a$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($5f9e38360d79f95a$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$5f9e38360d79f95a$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $5f9e38360d79f95a$var$finalize(rootScope, childValue, path);
        $5f9e38360d79f95a$var$set(targetObject, prop, res);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($5f9e38360d79f95a$export$16e3aed3edb85946(childValue) && !$5f9e38360d79f95a$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $5f9e38360d79f95a$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $5f9e38360d79f95a$var$maybeFreeze(rootScope, childValue);
    }
}
function $5f9e38360d79f95a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $5f9e38360d79f95a$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $5f9e38360d79f95a$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $5f9e38360d79f95a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $5f9e38360d79f95a$var$objectTraps = {
    get (state, prop) {
        if (prop === $5f9e38360d79f95a$var$DRAFT_STATE) return state;
        const source = $5f9e38360d79f95a$var$latest(state);
        if (!$5f9e38360d79f95a$var$has(source, prop)) return $5f9e38360d79f95a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
        if (value === $5f9e38360d79f95a$var$peek(state.base_, prop)) {
            $5f9e38360d79f95a$var$prepareCopy(state);
            return state.copy_[prop] = $5f9e38360d79f95a$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $5f9e38360d79f95a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($5f9e38360d79f95a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $5f9e38360d79f95a$var$getDescriptorFromProto($5f9e38360d79f95a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $5f9e38360d79f95a$var$peek($5f9e38360d79f95a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$5f9e38360d79f95a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($5f9e38360d79f95a$var$is(value, current2) && (value !== void 0 || $5f9e38360d79f95a$var$has(state.base_, prop))) return true;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($5f9e38360d79f95a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $5f9e38360d79f95a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $5f9e38360d79f95a$var$die(11);
    },
    getPrototypeOf (state) {
        return $5f9e38360d79f95a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $5f9e38360d79f95a$var$die(12);
    }
};
var $5f9e38360d79f95a$var$arrayTraps = {};
$5f9e38360d79f95a$var$each($5f9e38360d79f95a$var$objectTraps, (key, fn)=>{
    $5f9e38360d79f95a$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$5f9e38360d79f95a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $5f9e38360d79f95a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$5f9e38360d79f95a$var$arrayTraps.set = function(state, prop, value) {
    return $5f9e38360d79f95a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $5f9e38360d79f95a$var$peek(draft, prop) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    const source = state ? $5f9e38360d79f95a$var$latest(state) : draft;
    return source[prop];
}
function $5f9e38360d79f95a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $5f9e38360d79f95a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $5f9e38360d79f95a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $5f9e38360d79f95a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $5f9e38360d79f95a$var$markChanged(state.parent_);
    }
}
function $5f9e38360d79f95a$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $5f9e38360d79f95a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $5f9e38360d79f95a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $5f9e38360d79f95a$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $5f9e38360d79f95a$var$die(7);
            let result;
            if ($5f9e38360d79f95a$export$16e3aed3edb85946(base)) {
                const scope = $5f9e38360d79f95a$var$enterScope(this);
                const proxy = $5f9e38360d79f95a$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $5f9e38360d79f95a$var$revokeScope(scope);
                    else $5f9e38360d79f95a$var$leaveScope(scope);
                }
                $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
                return $5f9e38360d79f95a$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $5f9e38360d79f95a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $5f9e38360d79f95a$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $5f9e38360d79f95a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(base)) $5f9e38360d79f95a$var$die(8);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) base = $5f9e38360d79f95a$export$97aac956da55dae9(base);
        const scope = $5f9e38360d79f95a$var$enterScope(this);
        const proxy = $5f9e38360d79f95a$var$createProxy(base, void 0);
        proxy[$5f9e38360d79f95a$var$DRAFT_STATE].isManual_ = true;
        $5f9e38360d79f95a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$5f9e38360d79f95a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $5f9e38360d79f95a$var$die(9);
        const { scope_: scope } = state;
        $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
        return $5f9e38360d79f95a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $5f9e38360d79f95a$var$getPlugin("Patches").applyPatches_;
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $5f9e38360d79f95a$var$createProxy(value, parent) {
    const draft = $5f9e38360d79f95a$var$isMap(value) ? $5f9e38360d79f95a$var$getPlugin("MapSet").proxyMap_(value, parent) : $5f9e38360d79f95a$var$isSet(value) ? $5f9e38360d79f95a$var$getPlugin("MapSet").proxySet_(value, parent) : $5f9e38360d79f95a$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $5f9e38360d79f95a$export$97aac956da55dae9(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(10, value);
    return $5f9e38360d79f95a$var$currentImpl(value);
}
function $5f9e38360d79f95a$var$currentImpl(value) {
    if (!$5f9e38360d79f95a$export$16e3aed3edb85946(value) || $5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $5f9e38360d79f95a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $5f9e38360d79f95a$var$shallowCopy(value, true);
    $5f9e38360d79f95a$var$each(copy, (key, childValue)=>{
        $5f9e38360d79f95a$var$set(copy, key, $5f9e38360d79f95a$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $5f9e38360d79f95a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $5f9e38360d79f95a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $5f9e38360d79f95a$var$get(base_, key);
            const value = $5f9e38360d79f95a$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $5f9e38360d79f95a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $5f9e38360d79f95a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $5f9e38360d79f95a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $5f9e38360d79f95a$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $5f9e38360d79f95a$var$die(errorOffset + 3);
                base = $5f9e38360d79f95a$var$get(base, p);
                if (typeof base !== "object") $5f9e38360d79f95a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $5f9e38360d79f95a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $5f9e38360d79f95a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $5f9e38360d79f95a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($5f9e38360d79f95a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($5f9e38360d79f95a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($5f9e38360d79f95a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($5f9e38360d79f95a$var$has(obj, $5f9e38360d79f95a$export$6ee2082928bcb0ee)) cloned[$5f9e38360d79f95a$export$6ee2082928bcb0ee] = obj[$5f9e38360d79f95a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($5f9e38360d79f95a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $5f9e38360d79f95a$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $5f9e38360d79f95a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$5f9e38360d79f95a$var$latest(state).has(key) || $5f9e38360d79f95a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $5f9e38360d79f95a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            $5f9e38360d79f95a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $5f9e38360d79f95a$var$latest(state).get(key);
            if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $5f9e38360d79f95a$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) {
                    const draft = $5f9e38360d79f95a$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $5f9e38360d79f95a$var$die(3, JSON.stringify($5f9e38360d79f95a$var$latest(state)));
    }
    $5f9e38360d79f95a$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $5f9e38360d79f95a$var$immer = new $5f9e38360d79f95a$export$aaadc6ff0f822719();
var $5f9e38360d79f95a$export$b46cabe22e78bc00 = $5f9e38360d79f95a$var$immer.produce;
var $5f9e38360d79f95a$export$4da66d41c9492c78 = $5f9e38360d79f95a$var$immer.produceWithPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$573f26f60825c493 = $5f9e38360d79f95a$var$immer.setAutoFreeze.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$333ce65961cbe047 = $5f9e38360d79f95a$var$immer.setUseStrictShallowCopy.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$a8b8e03e6bbe5473 = $5f9e38360d79f95a$var$immer.applyPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$3c3214997190395f = $5f9e38360d79f95a$var$immer.createDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c60f5e69c521b528 = $5f9e38360d79f95a$var$immer.finishDraft.bind($5f9e38360d79f95a$var$immer);
function $5f9e38360d79f95a$export$c05b21e3257751e5(value) {
    return value;
}
function $5f9e38360d79f95a$export$20f911b3f8cf0b74(value) {
    return value;
}


var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $375276bea32f9eda$var$__publicField = (obj, key, value)=>{
    $375276bea32f9eda$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $375276bea32f9eda$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, $375276bea32f9eda$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $375276bea32f9eda$var$$REVISION = 0;
var $375276bea32f9eda$var$CURRENT_TRACKER = null;
var $375276bea32f9eda$var$Cell = class {
    constructor(initialValue, isEqual = $375276bea32f9eda$var$tripleEq){
        $375276bea32f9eda$var$__publicField(this, "revision", $375276bea32f9eda$var$$REVISION);
        $375276bea32f9eda$var$__publicField(this, "_value");
        $375276bea32f9eda$var$__publicField(this, "_lastValue");
        $375276bea32f9eda$var$__publicField(this, "_isEqual", $375276bea32f9eda$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$375276bea32f9eda$var$$REVISION;
    }
};
function $375276bea32f9eda$var$tripleEq(a, b) {
    return a === b;
}
var $375276bea32f9eda$var$TrackingCache = class {
    constructor(fn){
        $375276bea32f9eda$var$__publicField(this, "_cachedValue");
        $375276bea32f9eda$var$__publicField(this, "_cachedRevision", -1);
        $375276bea32f9eda$var$__publicField(this, "_deps", []);
        $375276bea32f9eda$var$__publicField(this, "hits", 0);
        $375276bea32f9eda$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $375276bea32f9eda$var$CURRENT_TRACKER;
            $375276bea32f9eda$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $375276bea32f9eda$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $375276bea32f9eda$var$getValue(cell) {
    if (!(cell instanceof $375276bea32f9eda$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $375276bea32f9eda$var$setValue(storage, value) {
    if (!(storage instanceof $375276bea32f9eda$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $375276bea32f9eda$var$createCell(initialValue, isEqual = $375276bea32f9eda$var$tripleEq) {
    return new $375276bea32f9eda$var$Cell(initialValue, isEqual);
}
function $375276bea32f9eda$var$createCache(fn) {
    $375276bea32f9eda$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $375276bea32f9eda$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $375276bea32f9eda$var$neverEq = (a, b)=>false;
function $375276bea32f9eda$var$createTag() {
    return $375276bea32f9eda$var$createCell(null, $375276bea32f9eda$var$neverEq);
}
function $375276bea32f9eda$var$dirtyTag(tag, value) {
    $375276bea32f9eda$var$setValue(tag, value);
}
var $375276bea32f9eda$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $375276bea32f9eda$var$createTag();
    $375276bea32f9eda$var$getValue(tag);
};
var $375276bea32f9eda$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $375276bea32f9eda$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $375276bea32f9eda$var$REDUX_PROXY_LABEL = Symbol();
var $375276bea32f9eda$var$nextId = 0;
var $375276bea32f9eda$var$proto = Object.getPrototypeOf({});
var $375276bea32f9eda$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy(this, $375276bea32f9eda$var$objectProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $375276bea32f9eda$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $375276bea32f9eda$var$createNode(childValue);
                if (childNode.tag) $375276bea32f9eda$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $375276bea32f9eda$var$createTag();
                    tag.value = childValue;
                }
                $375276bea32f9eda$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $375276bea32f9eda$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $375276bea32f9eda$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy([
            this
        ], $375276bea32f9eda$var$arrayProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $375276bea32f9eda$var$consumeCollection(node);
        return $375276bea32f9eda$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $375276bea32f9eda$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.has(node, prop);
    }
};
function $375276bea32f9eda$var$createNode(value) {
    if (Array.isArray(value)) return new $375276bea32f9eda$var$ArrayTreeNode(value);
    return new $375276bea32f9eda$var$ObjectTreeNode(value);
}
function $375276bea32f9eda$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $375276bea32f9eda$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $375276bea32f9eda$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $375276bea32f9eda$var$dirtyCollection(node);
            $375276bea32f9eda$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $375276bea32f9eda$var$updateNode(childNode, newChildValue);
        else {
            $375276bea32f9eda$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $375276bea32f9eda$var$deleteNode(node) {
    if (node.tag) $375276bea32f9eda$var$dirtyTag(node.tag, null);
    $375276bea32f9eda$var$dirtyCollection(node);
    for(const key in node.tags)$375276bea32f9eda$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$375276bea32f9eda$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $375276bea32f9eda$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $375276bea32f9eda$export$c8f9cf88d9fdee55(func) {
    const node = $375276bea32f9eda$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $375276bea32f9eda$var$createCacheKeyComparator($375276bea32f9eda$export$3f025202a230c6dd);
    const cache = $375276bea32f9eda$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $375276bea32f9eda$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $375276bea32f9eda$var$StrongRef;
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $375276bea32f9eda$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $375276bea32f9eda$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$375276bea32f9eda$export$75979cfcd91bf38f
});


// src/index.ts
function $44400fc0fe63e7bd$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $44400fc0fe63e7bd$export$dd164f5517779f15 = $44400fc0fe63e7bd$var$createThunkMiddleware();
var $44400fc0fe63e7bd$export$16d06542a1949d9e = $44400fc0fe63e7bd$var$createThunkMiddleware;


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


var $d91034f47eb948f2$var$__defProp = Object.defineProperty;
var $d91034f47eb948f2$var$__defProps = Object.defineProperties;
var $d91034f47eb948f2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d91034f47eb948f2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d91034f47eb948f2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d91034f47eb948f2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d91034f47eb948f2$var$__defNormalProp = (obj, key, value)=>key in obj ? $d91034f47eb948f2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d91034f47eb948f2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d91034f47eb948f2$var$__hasOwnProp.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    if ($d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(b))if ($d91034f47eb948f2$var$__propIsEnum.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d91034f47eb948f2$var$__spreadProps = (a, b)=>$d91034f47eb948f2$var$__defProps(a, $d91034f47eb948f2$var$__getOwnPropDescs(b));
var $d91034f47eb948f2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d91034f47eb948f2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d91034f47eb948f2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $d91034f47eb948f2$var$__publicField = (obj, key, value)=>{
    $d91034f47eb948f2$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
var $d91034f47eb948f2$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $375276bea32f9eda$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $d91034f47eb948f2$export$a5d3c27355e35910 = $d91034f47eb948f2$export$aab6de9e3dbb1473((0, $375276bea32f9eda$export$8402dc26d96f6902));
var $d91034f47eb948f2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $d2bed10dff9b4968$export$f672e0b6f7222cd7;
    return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $d91034f47eb948f2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $d91034f47eb948f2$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(0));
            return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $d91034f47eb948f2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $d91034f47eb948f2$var$hasMatchFunction(action);
}
function $d91034f47eb948f2$export$ebd532f9034651f3(action) {
    return (0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && Object.keys(action).every($d91034f47eb948f2$var$isValidKey);
}
function $d91034f47eb948f2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $d91034f47eb948f2$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $d91034f47eb948f2$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $d91034f47eb948f2$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $d91034f47eb948f2$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $d91034f47eb948f2$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $d91034f47eb948f2$var$freezeDraftable(val) {
    return (0, $5f9e38360d79f95a$export$16e3aed3edb85946)(val) ? (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $d91034f47eb948f2$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d91034f47eb948f2$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $d91034f47eb948f2$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $d91034f47eb948f2$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $d91034f47eb948f2$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $d91034f47eb948f2$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $d91034f47eb948f2$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $d91034f47eb948f2$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(val);
}
function $d91034f47eb948f2$export$ada5dca0b571bc7(value, path = "", isSerializable = $d91034f47eb948f2$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d91034f47eb948f2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $d91034f47eb948f2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d91034f47eb948f2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d91034f47eb948f2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d91034f47eb948f2$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $d91034f47eb948f2$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $d91034f47eb948f2$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $d91034f47eb948f2$export$1908877435b1d5e9();
        if (thunk) {
            if ($d91034f47eb948f2$var$isBoolean(thunk)) middlewareArray.push((0, $44400fc0fe63e7bd$export$dd164f5517779f15));
            else middlewareArray.push((0, $44400fc0fe63e7bd$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $d91034f47eb948f2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $d91034f47eb948f2$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$d91034f47eb948f2$export$8fb31c0f05df007b]: true
            }
        });
var $d91034f47eb948f2$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $d91034f47eb948f2$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $d91034f47eb948f2$var$createQueueWithTimer(10);
var $d91034f47eb948f2$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $d91034f47eb948f2$var$rAF : options.type === "callback" ? options.queueNotification : $d91034f47eb948f2$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$d91034f47eb948f2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $d91034f47eb948f2$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $d91034f47eb948f2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($d91034f47eb948f2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
var $d91034f47eb948f2$var$IS_PRODUCTION = true;
function $d91034f47eb948f2$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $d91034f47eb948f2$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducer);
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(1));
    if (!$d91034f47eb948f2$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(2));
    let finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$d91034f47eb948f2$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$d91034f47eb948f2$var$IS_PRODUCTION && finalMiddleware.some((item)=>typeof item !== "function")) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(4));
    let finalCompose = (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $d91034f47eb948f2$var$composeWithDevTools($d91034f47eb948f2$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$d91034f47eb948f2$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $d2bed10dff9b4968$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $d91034f47eb948f2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$d91034f47eb948f2$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(5));
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$d91034f47eb948f2$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(6));
    if (!$d91034f47eb948f2$var$IS_PRODUCTION && storeEnhancers.some((item)=>typeof item !== "function")) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(7));
    if (!$d91034f47eb948f2$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $d2bed10dff9b4968$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $d91034f47eb948f2$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $d91034f47eb948f2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $d91034f47eb948f2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $d91034f47eb948f2$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($d91034f47eb948f2$var$isStateFunction(initialState)) getInitialState = ()=>$d91034f47eb948f2$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $d91034f47eb948f2$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $5f9e38360d79f95a$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $5f9e38360d79f95a$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($d91034f47eb948f2$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $d91034f47eb948f2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $d91034f47eb948f2$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $d91034f47eb948f2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $d91034f47eb948f2$var$matches = (matcher, action)=>{
    if ($d91034f47eb948f2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d91034f47eb948f2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d91034f47eb948f2$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$872dec21e9a69476()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $d91034f47eb948f2$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$fcc3388fb56de601()(asyncThunks[0]);
    return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $d91034f47eb948f2$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$1da80a6ef1307441()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $d91034f47eb948f2$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/createAsyncThunk.ts
var $d91034f47eb948f2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d91034f47eb948f2$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $d91034f47eb948f2$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $d91034f47eb948f2$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $d91034f47eb948f2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d91034f47eb948f2$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($d91034f47eb948f2$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $d91034f47eb948f2$var$RejectWithValue) throw result;
                                if (result instanceof $d91034f47eb948f2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $d91034f47eb948f2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($d91034f47eb948f2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $d91034f47eb948f2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $d91034f47eb948f2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d91034f47eb948f2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $d91034f47eb948f2$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $d91034f47eb948f2$export$343355ed40c51c46 = {
    [$d91034f47eb948f2$var$asyncThunkSymbol]: $d91034f47eb948f2$export$6abd22dc03e5063f
};
var $d91034f47eb948f2$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($d91034f47eb948f2$export$23a094319a4b586 || {});
function $d91034f47eb948f2$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $d91034f47eb948f2$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$d91034f47eb948f2$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(11));
        typeof $cfae44f0dfdf62c0$exports;
        const reducers = (typeof options.reducers === "function" ? options.reducers($d91034f47eb948f2$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $d91034f47eb948f2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $d91034f47eb948f2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $d91034f47eb948f2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $d91034f47eb948f2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $d91034f47eb948f2$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $d91034f47eb948f2$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $d91034f47eb948f2$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        var _a2;
                        const map = {};
                        for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $d91034f47eb948f2$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $d91034f47eb948f2$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $d91034f47eb948f2$export$affdea4146de9cf5();
function $d91034f47eb948f2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $d91034f47eb948f2$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $d91034f47eb948f2$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareCallback) : $d91034f47eb948f2$export$309c7a02b0b0bc62(type));
}
function $d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $d91034f47eb948f2$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $d91034f47eb948f2$var$noop,
        pending: pending || $d91034f47eb948f2$var$noop,
        rejected: rejected || $d91034f47eb948f2$var$noop,
        settled: settled || $d91034f47eb948f2$var$noop
    });
}
function $d91034f47eb948f2$var$noop() {}
// src/entities/entity_state.ts
function $d91034f47eb948f2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($d91034f47eb948f2$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $d91034f47eb948f2$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $d91034f47eb948f2$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $d91034f47eb948f2$var$isDraftTyped = (0, $5f9e38360d79f95a$export$541ac630993a4c84);
function $d91034f47eb948f2$var$createSingleArgumentStateOperator(mutator) {
    const operator = $d91034f47eb948f2$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d91034f47eb948f2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $d91034f47eb948f2$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($d91034f47eb948f2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(state, runMutator);
    };
}
function $d91034f47eb948f2$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $d91034f47eb948f2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d91034f47eb948f2$var$getCurrent(value) {
    return (0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value;
}
function $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $d91034f47eb948f2$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $d91034f47eb948f2$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$d91034f47eb948f2$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $d91034f47eb948f2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably),
        removeOne: $d91034f47eb948f2$var$createStateOperator(removeOneMutably),
        removeMany: $d91034f47eb948f2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $d91034f47eb948f2$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $d91034f47eb948f2$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $d91034f47eb948f2$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($d91034f47eb948f2$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $d91034f47eb948f2$var$getCurrent(state.entities);
        const currentIds = $d91034f47eb948f2$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $d91034f47eb948f2$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $d91034f47eb948f2$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $d91034f47eb948f2$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $d91034f47eb948f2$var$createSortedStateAdapter(selectId, sortComparer) : $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $d91034f47eb948f2$var$createSelectorsFactory();
    return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $d91034f47eb948f2$var$task = "task";
var $d91034f47eb948f2$var$listener = "listener";
var $d91034f47eb948f2$var$completed = "completed";
var $d91034f47eb948f2$var$cancelled = "cancelled";
var $d91034f47eb948f2$var$taskCancelled = `task-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$taskCompleted = `task-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$var$listenerCancelled = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$listenerCompleted = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $d91034f47eb948f2$var$__publicField(this, "name", "TaskAbortError");
        $d91034f47eb948f2$var$__publicField(this, "message");
        this.message = `${$d91034f47eb948f2$var$task} ${$d91034f47eb948f2$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $d91034f47eb948f2$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(32));
};
var $d91034f47eb948f2$var$noop2 = ()=>{};
var $d91034f47eb948f2$var$catchRejection = (promise, onError = $d91034f47eb948f2$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $d91034f47eb948f2$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $d91034f47eb948f2$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $d91034f47eb948f2$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $d91034f47eb948f2$export$cb1bdac908fed7f(reason);
    }
};
function $d91034f47eb948f2$var$raceWithSignal(signal, promise) {
    let cleanup = $d91034f47eb948f2$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d91034f47eb948f2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $d91034f47eb948f2$var$noop2;
    });
}
var $d91034f47eb948f2$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $d91034f47eb948f2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $d91034f47eb948f2$var$createPause = (signal)=>{
    return (promise)=>{
        return $d91034f47eb948f2$var$catchRejection($d91034f47eb948f2$var$raceWithSignal(signal, promise).then((output)=>{
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        }));
    };
};
var $d91034f47eb948f2$var$createDelay = (signal)=>{
    const pause = $d91034f47eb948f2$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $d91034f47eb948f2$var$assign } = Object;
var $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN = {};
var $d91034f47eb948f2$var$alm = "listenerMiddleware";
var $d91034f47eb948f2$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$d91034f47eb948f2$var$addAbortSignalListener(parentAbortSignal, ()=>$d91034f47eb948f2$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $d91034f47eb948f2$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $d91034f47eb948f2$var$runTask(async ()=>{
            $d91034f47eb948f2$var$validateActive(parentAbortSignal);
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $d91034f47eb948f2$var$createPause(childAbortController.signal),
                delay: $d91034f47eb948f2$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$d91034f47eb948f2$var$abortControllerWithReason(childAbortController, $d91034f47eb948f2$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($d91034f47eb948f2$var$noop2));
        return {
            result: $d91034f47eb948f2$var$createPause(parentAbortSignal)(result),
            cancel () {
                $d91034f47eb948f2$var$abortControllerWithReason(childAbortController, $d91034f47eb948f2$var$taskCancelled);
            }
        };
    };
};
var $d91034f47eb948f2$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $d91034f47eb948f2$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $d91034f47eb948f2$var$raceWithSignal(signal, Promise.race(promises));
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$d91034f47eb948f2$var$catchRejection(take(predicate, timeout));
};
var $d91034f47eb948f2$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $d91034f47eb948f2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(21));
    $d91034f47eb948f2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $d91034f47eb948f2$var$createListenerEntry = Object.assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    const id = $d91034f47eb948f2$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($d91034f47eb948f2$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$d91034f47eb948f2$var$createListenerEntry
});
var $d91034f47eb948f2$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $d91034f47eb948f2$var$abortControllerWithReason(controller, $d91034f47eb948f2$var$listenerCancelled);
    });
};
var $d91034f47eb948f2$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($d91034f47eb948f2$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $d91034f47eb948f2$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $d91034f47eb948f2$export$f03a6b845d3fb58b = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/add`), {
    withTypes: ()=>$d91034f47eb948f2$export$f03a6b845d3fb58b
});
var $d91034f47eb948f2$export$b1b8022855fb2b71 = $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/removeAll`);
var $d91034f47eb948f2$export$b03e9483f936dccb = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/remove`), {
    withTypes: ()=>$d91034f47eb948f2$export$b03e9483f936dccb
});
var $d91034f47eb948f2$var$defaultErrorHandler = (...args)=>{
    console.error(`${$d91034f47eb948f2$var$alm}/error`, ...args);
};
var $d91034f47eb948f2$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $d91034f47eb948f2$var$defaultErrorHandler } = middlewareOptions;
    $d91034f47eb948f2$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $d91034f47eb948f2$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $d91034f47eb948f2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
        const entry = $d91034f47eb948f2$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $d91034f47eb948f2$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $d91034f47eb948f2$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $d91034f47eb948f2$var$createDelay(internalTaskController.signal),
                pause: $d91034f47eb948f2$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $d91034f47eb948f2$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $d91034f47eb948f2$var$abortControllerWithReason(controller, $d91034f47eb948f2$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $d91034f47eb948f2$var$abortControllerWithReason(internalTaskController, $d91034f47eb948f2$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $d91034f47eb948f2$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $d91034f47eb948f2$export$cb1bdac908fed7f)) $d91034f47eb948f2$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $d91034f47eb948f2$var$abortControllerWithReason(internalTaskController, $d91034f47eb948f2$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $d91034f47eb948f2$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $d2bed10dff9b4968$export$b956e38827fca970)(action)) return next(action);
                if ($d91034f47eb948f2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d91034f47eb948f2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d91034f47eb948f2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d91034f47eb948f2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $d91034f47eb948f2$var$createMiddlewareEntry = (middleware)=>({
        id: $d91034f47eb948f2$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $d91034f47eb948f2$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $d91034f47eb948f2$export$4bb1606a79445586 = ()=>{
    const instanceId = $d91034f47eb948f2$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $d91034f47eb948f2$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $d91034f47eb948f2$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$d91034f47eb948f2$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $d91034f47eb948f2$export$9dd1fb32974da385(withMiddleware, $d91034f47eb948f2$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $d91034f47eb948f2$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $d91034f47eb948f2$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$d91034f47eb948f2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $d91034f47eb948f2$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $d91034f47eb948f2$var$isStateProxy = (value)=>!!value && !!value[$d91034f47eb948f2$var$ORIGINAL_STATE];
var $d91034f47eb948f2$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $d91034f47eb948f2$var$createStateProxy = (state, reducerMap)=>$d91034f47eb948f2$var$emplace($d91034f47eb948f2$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $d91034f47eb948f2$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $d91034f47eb948f2$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $d91034f47eb948f2$var$original = (state)=>{
    if (!$d91034f47eb948f2$var$isStateProxy(state)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(25));
    return state[$d91034f47eb948f2$var$ORIGINAL_STATE];
};
var $d91034f47eb948f2$var$noopReducer = (state = {})=>state;
function $d91034f47eb948f2$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($d91034f47eb948f2$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducerMap) : $d91034f47eb948f2$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $cfae44f0dfdf62c0$exports;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($d91034f47eb948f2$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $d91034f47eb948f2$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $d91034f47eb948f2$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


var $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $568f4ee4022ba00e$var$getRandomValues;
var $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1d0137947e8554ce$var$byteToHex = [];
for(var $1d0137947e8554ce$var$i = 0; $1d0137947e8554ce$var$i < 256; ++$1d0137947e8554ce$var$i)$1d0137947e8554ce$var$byteToHex.push(($1d0137947e8554ce$var$i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    var uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;


// Define the initial state using that type
const $e94319ab67c021b4$var$initialState = {
    messages: []
};
const $e94319ab67c021b4$export$77bb0165c25c314f = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: "error",
    initialState: // `createSlice` will infer the state type from the `initialState` argument
    $e94319ab67c021b4$var$initialState,
    reducers: {
        addMessage: (state, action)=>{
            const id = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
            const newPayload = {
                ...action.payload,
                id: id,
                dismissible: true,
                dismissLabel: "Dismiss message"
            };
            state.messages = [
                ...state.messages,
                newPayload
            ];
        },
        removeMessage: (state, action)=>{
            state.messages = state.messages.filter((message)=>message.id !== action.payload);
        }
    }
});
const { addMessage: $e94319ab67c021b4$export$16fdb433d434f08, removeMessage: $e94319ab67c021b4$export$f9a3c275d8ffdac0 } = $e94319ab67c021b4$export$77bb0165c25c314f.actions;
const $e94319ab67c021b4$export$31ff3874607c5ef8 = (state)=>state.messages;
var $e94319ab67c021b4$export$2e2bcd8739ae039 = $e94319ab67c021b4$export$77bb0165c25c314f.reducer;




const $b38651f901ccdd09$export$6f57813fe9f31bf9 = (0, $d91034f47eb948f2$export$7d8a5b498da695ac)({
    reducer: {
        messages: (0, $e94319ab67c021b4$export$2e2bcd8739ae039)
    }
});






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");






var $6c011c101cc9f6f9$export$2e2bcd8739ae039 = {
    "alert": "awsui_alert_mx3cw_obq0g_97",
    "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_obq0g_1",
    "root": "awsui_root_mx3cw_obq0g_123",
    "hidden": "awsui_hidden_mx3cw_obq0g_161",
    "with-dismiss": "awsui_with-dismiss_mx3cw_obq0g_211",
    "with-action": "awsui_with-action_mx3cw_obq0g_211",
    "breakpoint-default": "awsui_breakpoint-default_mx3cw_obq0g_217",
    "header": "awsui_header_mx3cw_obq0g_224",
    "action": "awsui_action_mx3cw_obq0g_228",
    "action-slot": "awsui_action-slot_mx3cw_obq0g_233",
    "action-button": "awsui_action-button_mx3cw_obq0g_234",
    "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_obq0g_238",
    "text": "awsui_text_mx3cw_obq0g_267",
    "icon": "awsui_icon_mx3cw_obq0g_274",
    "message": "awsui_message_mx3cw_obq0g_277",
    "icon-size-medium": "awsui_icon-size-medium_mx3cw_obq0g_285",
    "icon-size-big": "awsui_icon-size-big_mx3cw_obq0g_288",
    "icon-size-normal": "awsui_icon-size-normal_mx3cw_obq0g_291",
    "content": "awsui_content_mx3cw_obq0g_295",
    "dismiss": "awsui_dismiss_mx3cw_obq0g_299",
    "dismiss-button": "awsui_dismiss-button_mx3cw_obq0g_304",
    "type-error": "awsui_type-error_mx3cw_obq0g_308",
    "type-warning": "awsui_type-warning_mx3cw_obq0g_316",
    "type-success": "awsui_type-success_mx3cw_obq0g_324",
    "type-info": "awsui_type-info_mx3cw_obq0g_332"
};













const $0572c3fe95cef167$var$typeToIcon = {
    error: "status-negative",
    warning: "status-warning",
    success: "status-positive",
    info: "status-info"
};
const $0572c3fe95cef167$var$useDiscoveredAction = (0, $a773f3a2497f02b1$export$43997369e47eb864)((0, $2ec6e52915a41fcf$export$90753eb139627d74).alert.onActionRegistered);
const $0572c3fe95cef167$var$InternalAlert = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { type: type, statusIconAriaLabel: statusIconAriaLabel, visible: visible = true, dismissible: dismissible, dismissAriaLabel: dismissAriaLabel, children: children, header: header, buttonText: buttonText, action: action, onDismiss: onDismiss, onButtonClick: onButtonClick, __internalRootRef: __internalRootRef = null } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "type",
        "statusIconAriaLabel",
        "visible",
        "dismissible",
        "dismissAriaLabel",
        "children",
        "header",
        "buttonText",
        "action",
        "onDismiss",
        "onButtonClick",
        "__internalRootRef"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("alert");
    const focusRef = (0, $acw62.useRef)(null);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, focusRef);
    const [breakpoint, breakpointRef] = (0, $921c3f4037759790$export$2aa1887afbd6d218)([
        "xs"
    ]);
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(breakpointRef, __internalRootRef);
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const size = isRefresh ? "normal" : header && children ? "big" : "normal";
    const { discoveredActions: discoveredActions, headerRef: headerRef, contentRef: contentRef } = $0572c3fe95cef167$var$useDiscoveredAction(type);
    const hasAction = Boolean(action || buttonText || discoveredActions.length);
    const analyticsAttributes = {
        [(0, $285a09b860d2bebc$export$886c79e627389031)]: type
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, analyticsAttributes, {
        "aria-hidden": !visible,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).root, {
            [(0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).hidden]: !visible
        }, baseProps.className),
        ref: mergedRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9699df5a060a9c12$export$366cdc6257b696ef).Provider, {
        value: {
            defaultVariant: "primary"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8856d0c7df08fd8d$export$2e2bcd8739ae039), {
        contextName: "alert"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).alert, (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)[`type-${type}`], (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)[`icon-size-${size}`], hasAction && (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)["with-action"], dismissible && (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)["with-dismiss"], (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)[`breakpoint-${breakpoint}`])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)["alert-focus-wrapper"],
        tabIndex: -1,
        ref: focusRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).icon, (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).text),
        role: "img",
        "aria-label": statusIconAriaLabel
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: $0572c3fe95cef167$var$typeToIcon[type],
        size: size
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).message, (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).text)
    }, header && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).header,
        ref: headerRef
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).content,
        ref: contentRef
    }, children))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d276899a8d82cf05$export$c8223871eecc8f3a), {
        className: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).action,
        testUtilClasses: {
            actionSlot: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)["action-slot"],
            actionButton: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)["action-button"]
        },
        action: action,
        discoveredActions: discoveredActions,
        buttonText: buttonText,
        onButtonClick: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onButtonClick)
    }), dismissible && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039).dismiss
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        className: (0, $6c011c101cc9f6f9$export$2e2bcd8739ae039)["dismiss-button"],
        variant: "icon",
        iconName: "close",
        formAction: "none",
        ariaLabel: i18n("dismissAriaLabel", dismissAriaLabel),
        onClick: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDismiss)
    }))))));
});
var $0572c3fe95cef167$export$2e2bcd8739ae039 = $0572c3fe95cef167$var$InternalAlert;







const $1a8b0110371552e0$var$Alert = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { type: type = "info", visible: visible = true } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "type",
        "visible"
    ]);
    const analyticsMetadata = (0, $75a0355e989dd450$export$dba32c398c4b8fa1)(props);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Alert", {
        props: {
            type: type,
            visible: visible,
            dismissible: props.dismissible
        }
    }, analyticsMetadata);
    const { funnelIdentifier: funnelIdentifier, funnelInteractionId: funnelInteractionId, funnelErrorContext: funnelErrorContext, submissionAttempt: submissionAttempt, funnelState: funnelState, errorCount: errorCount } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const { stepNumber: stepNumber, stepNameSelector: stepNameSelector, stepIdentifier: stepIdentifier } = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const { subStepSelector: subStepSelector, subStepNameSelector: subStepNameSelector, subStepIdentifier: subStepIdentifier, subStepErrorContext: subStepErrorContext } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    (0, $acw62.useEffect)(()=>{
        var _a, _b, _c;
        if (funnelInteractionId && visible && type === "error" && funnelState.current !== "complete") {
            const stepName = (0, $285a09b860d2bebc$export$ad08a5942dca04f8)(stepNameSelector);
            const subStepName = (0, $285a09b860d2bebc$export$ad08a5942dca04f8)(subStepNameSelector);
            errorCount.current++;
            // We don't want to report an error if it is hidden, e.g. inside an Expandable Section.
            const errorIsVisible = ((_c = (_b = (_a = baseComponentProps.__internalRootRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : 0) > 0;
            if (errorIsVisible) {
                if (subStepSelector) (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelSubStepError({
                    funnelInteractionId: funnelInteractionId,
                    funnelIdentifier: funnelIdentifier,
                    stepIdentifier: stepIdentifier,
                    subStepSelector: subStepSelector,
                    subStepName: subStepName,
                    subStepNameSelector: subStepNameSelector,
                    stepNumber: stepNumber,
                    stepName: stepName,
                    stepNameSelector: stepNameSelector,
                    subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)(),
                    subStepIdentifier: subStepIdentifier,
                    subStepErrorContext: subStepErrorContext
                });
                else (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelError({
                    funnelIdentifier: funnelIdentifier,
                    funnelInteractionId: funnelInteractionId,
                    funnelErrorContext: funnelErrorContext
                });
            }
            return ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                errorCount.current--;
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        funnelInteractionId,
        visible,
        submissionAttempt,
        errorCount
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0572c3fe95cef167$export$2e2bcd8739ae039), Object.assign({
        type: type,
        visible: visible
    }, props, baseComponentProps, {
        ref: ref
    }));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($1a8b0110371552e0$var$Alert, "Alert");
var $1a8b0110371552e0$export$2e2bcd8739ae039 = $1a8b0110371552e0$var$Alert;



var $acw62 = parcelRequire("acw62");




const $9cee4eab59be790b$var$Button = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { children: children, iconName: iconName, iconAlign: iconAlign = "left", iconUrl: iconUrl, iconSvg: iconSvg, iconAlt: iconAlt, variant: variant = "normal", loading: loading = false, loadingText: loadingText, disabled: disabled = false, disabledReason: disabledReason, wrapText: wrapText = true, href: href, target: target, rel: rel, download: download, formAction: formAction = "submit", ariaLabel: ariaLabel, ariaDescribedby: ariaDescribedby, onClick: onClick, onFollow: onFollow, ariaExpanded: ariaExpanded, ariaControls: ariaControls, fullWidth: fullWidth, form: form } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "children",
        "iconName",
        "iconAlign",
        "iconUrl",
        "iconSvg",
        "iconAlt",
        "variant",
        "loading",
        "loadingText",
        "disabled",
        "disabledReason",
        "wrapText",
        "href",
        "target",
        "rel",
        "download",
        "formAction",
        "ariaLabel",
        "ariaDescribedby",
        "onClick",
        "onFollow",
        "ariaExpanded",
        "ariaControls",
        "fullWidth",
        "form"
    ]);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Button", {
        props: {
            formAction: formAction,
            fullWidth: fullWidth,
            iconAlign: iconAlign,
            iconName: iconName,
            rel: rel,
            target: target,
            variant: variant,
            wrapText: wrapText
        }
    });
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), Object.assign({}, baseProps, baseComponentProps, {
        ref: ref,
        iconName: iconName,
        iconAlign: iconAlign,
        iconUrl: iconUrl,
        iconSvg: iconSvg,
        iconAlt: iconAlt,
        variant: variant,
        loading: loading,
        loadingText: loadingText,
        disabled: disabled,
        disabledReason: disabledReason,
        wrapText: wrapText,
        href: href,
        target: target,
        rel: rel,
        download: download,
        formAction: formAction,
        ariaLabel: ariaLabel,
        ariaDescribedby: ariaDescribedby,
        onClick: onClick,
        onFollow: onFollow,
        ariaExpanded: ariaExpanded,
        ariaControls: ariaControls,
        fullWidth: fullWidth,
        form: form
    }), children);
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($9cee4eab59be790b$var$Button, "Button");
var $9cee4eab59be790b$export$2e2bcd8739ae039 = $9cee4eab59be790b$var$Button;



var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Method to filter out internal properties prefixed by "__"
 */ const $3833f34df478664f$export$21af416108db3048 = (props)=>{
    const externalPropNames = Object.keys(props).filter((propName)=>propName.indexOf("__") !== 0);
    return externalPropNames.reduce((acc, propName)=>{
        acc[propName] = props[propName];
        return acc;
    }, {});
};






function $60822fbe2c08caa5$export$2e2bcd8739ae039(_a) {
    var { variant: variant = "default", disableHeaderPaddings: disableHeaderPaddings = false, disableContentPaddings: disableContentPaddings = false, fitHeight: fitHeight = false } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "variant",
        "disableHeaderPaddings",
        "disableContentPaddings",
        "fitHeight"
    ]);
    const analyticsMetadata = (0, $75a0355e989dd450$export$dba32c398c4b8fa1)(props);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Container", {
        props: {
            disableContentPaddings: disableContentPaddings,
            disableHeaderPaddings: disableHeaderPaddings,
            fitHeight: fitHeight,
            variant: variant
        }
    }, analyticsMetadata);
    const externalProps = (0, $3833f34df478664f$export$21af416108db3048)(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $515d52eb9df17853$export$b1325661caf9fa0), {
        subStepIdentifier: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier,
        subStepErrorContext: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.errorContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc8a25d23ca8ebd0$export$79c16a58b85ba6af), Object.assign({
        variant: variant,
        disableContentPaddings: disableContentPaddings,
        disableHeaderPaddings: disableHeaderPaddings,
        fitHeight: fitHeight
    }, props, externalProps, baseComponentProps)));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($60822fbe2c08caa5$export$2e2bcd8739ae039, "Container");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $26604b8e35e1a00b$export$fd4f28634267f02(props) {
    var _a;
    const disabled = (_a = props === null || props === void 0 ? void 0 : props.disabled) !== null && _a !== void 0 ? _a : false;
    const setDynamicOverlapHeight = (0, $acw62.useContext)((0, $011bca9bf46093da$export$70fcc38162d125af));
    const overlapElementRef = (0, $acw62.useRef)(null);
    const getElement = (0, $acw62.useCallback)(()=>overlapElementRef.current, [
        overlapElementRef
    ]);
    const updateState = (0, $acw62.useCallback)((entry)=>{
        if (!disabled) setDynamicOverlapHeight(entry.contentBoxHeight);
    }, [
        disabled,
        setDynamicOverlapHeight
    ]);
    (0, $444535e54951fdea$export$683480f191c0e3ea)(getElement, updateState);
    (0, $acw62.useLayoutEffect)(function handleDynamicOverlapHeight() {
        // Set overlap height back to 0 when unmounting
        return ()=>{
            if (!disabled) setDynamicOverlapHeight(0);
        };
    }, [
        disabled,
        setDynamicOverlapHeight
    ]);
    return overlapElementRef;
}







var $f6419952c58a2c60$export$2e2bcd8739ae039 = {
    "layout": "awsui_layout_5gtk3_1hkx1_97",
    "background": "awsui_background_5gtk3_1hkx1_111",
    "is-overlap-disabled": "awsui_is-overlap-disabled_5gtk3_1hkx1_116",
    "header-background": "awsui_header-background_5gtk3_1hkx1_119",
    "notifications": "awsui_notifications_5gtk3_1hkx1_123",
    "breadcrumbs": "awsui_breadcrumbs_5gtk3_1hkx1_128",
    "default-padding": "awsui_default-padding_5gtk3_1hkx1_133",
    "header-wrapper": "awsui_header-wrapper_5gtk3_1hkx1_137",
    "with-divider": "awsui_with-divider_5gtk3_1hkx1_142",
    "content": "awsui_content_5gtk3_1hkx1_145",
    "has-header": "awsui_has-header_5gtk3_1hkx1_149",
    "is-visual-refresh": "awsui_is-visual-refresh_5gtk3_1hkx1_156",
    "has-default-background": "awsui_has-default-background_5gtk3_1hkx1_156",
    "has-notifications": "awsui_has-notifications_5gtk3_1hkx1_160"
};



var $998cfd68a29f6d17$export$2e2bcd8739ae039 = {
    "header": "awsui_header_64tge_1scxg_5",
    "secondary-header": "awsui_secondary-header_64tge_1scxg_9",
    "notifications": "awsui_notifications_64tge_1scxg_13",
    "breadcrumbs": "awsui_breadcrumbs_64tge_1scxg_17"
};




var $acw62 = parcelRequire("acw62");

var $dc835a13f4d26607$exports = {};
"use strict";
Object.defineProperty($dc835a13f4d26607$exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


function $dc835a13f4d26607$var$flattenChildren(children, depth, keys) {
    if (depth === void 0) depth = 0;
    if (keys === void 0) keys = [];
    return $acw62.Children.toArray(children).reduce(function(acc, node, nodeIndex) {
        if ($3251146683c5d714$exports.isFragment(node)) acc.push.apply(acc, $dc835a13f4d26607$var$flattenChildren(node.props.children, depth + 1, keys.concat(node.key || nodeIndex)));
        else {
            if ($acw62.isValidElement(node)) acc.push($acw62.cloneElement(node, {
                key: keys.concat(String(node.key)).join(".")
            }));
            else if (typeof node === "string" || typeof node === "number") acc.push(node);
        }
        return acc;
    }, []);
}
$dc835a13f4d26607$exports.default = $dc835a13f4d26607$var$flattenChildren;







var $fd157c50f7b7577d$export$2e2bcd8739ae039 = {
    "grid": "awsui_grid_14yj0_xuaq6_97",
    "no-gutters": "awsui_no-gutters_14yj0_xuaq6_136",
    "grid-column": "awsui_grid-column_14yj0_xuaq6_141",
    "colspan-1": "awsui_colspan-1_14yj0_xuaq6_152",
    "push-1": "awsui_push-1_14yj0_xuaq6_156",
    "pull-1": "awsui_pull-1_14yj0_xuaq6_159",
    "colspan-2": "awsui_colspan-2_14yj0_xuaq6_162",
    "push-2": "awsui_push-2_14yj0_xuaq6_166",
    "pull-2": "awsui_pull-2_14yj0_xuaq6_169",
    "colspan-3": "awsui_colspan-3_14yj0_xuaq6_172",
    "push-3": "awsui_push-3_14yj0_xuaq6_176",
    "pull-3": "awsui_pull-3_14yj0_xuaq6_179",
    "colspan-4": "awsui_colspan-4_14yj0_xuaq6_182",
    "push-4": "awsui_push-4_14yj0_xuaq6_186",
    "pull-4": "awsui_pull-4_14yj0_xuaq6_189",
    "colspan-5": "awsui_colspan-5_14yj0_xuaq6_192",
    "push-5": "awsui_push-5_14yj0_xuaq6_196",
    "pull-5": "awsui_pull-5_14yj0_xuaq6_199",
    "colspan-6": "awsui_colspan-6_14yj0_xuaq6_202",
    "push-6": "awsui_push-6_14yj0_xuaq6_206",
    "pull-6": "awsui_pull-6_14yj0_xuaq6_209",
    "colspan-7": "awsui_colspan-7_14yj0_xuaq6_212",
    "push-7": "awsui_push-7_14yj0_xuaq6_216",
    "pull-7": "awsui_pull-7_14yj0_xuaq6_219",
    "colspan-8": "awsui_colspan-8_14yj0_xuaq6_222",
    "push-8": "awsui_push-8_14yj0_xuaq6_226",
    "pull-8": "awsui_pull-8_14yj0_xuaq6_229",
    "colspan-9": "awsui_colspan-9_14yj0_xuaq6_232",
    "push-9": "awsui_push-9_14yj0_xuaq6_236",
    "pull-9": "awsui_pull-9_14yj0_xuaq6_239",
    "colspan-10": "awsui_colspan-10_14yj0_xuaq6_242",
    "push-10": "awsui_push-10_14yj0_xuaq6_246",
    "pull-10": "awsui_pull-10_14yj0_xuaq6_249",
    "colspan-11": "awsui_colspan-11_14yj0_xuaq6_252",
    "push-11": "awsui_push-11_14yj0_xuaq6_256",
    "pull-11": "awsui_pull-11_14yj0_xuaq6_259",
    "colspan-12": "awsui_colspan-12_14yj0_xuaq6_262",
    "push-12": "awsui_push-12_14yj0_xuaq6_266",
    "pull-12": "awsui_pull-12_14yj0_xuaq6_269",
    "push-0": "awsui_push-0_14yj0_xuaq6_272",
    "pull-0": "awsui_pull-0_14yj0_xuaq6_275",
    "offset-1": "awsui_offset-1_14yj0_xuaq6_278",
    "offset-2": "awsui_offset-2_14yj0_xuaq6_281",
    "offset-3": "awsui_offset-3_14yj0_xuaq6_284",
    "offset-4": "awsui_offset-4_14yj0_xuaq6_287",
    "offset-5": "awsui_offset-5_14yj0_xuaq6_290",
    "offset-6": "awsui_offset-6_14yj0_xuaq6_293",
    "offset-7": "awsui_offset-7_14yj0_xuaq6_296",
    "offset-8": "awsui_offset-8_14yj0_xuaq6_299",
    "offset-9": "awsui_offset-9_14yj0_xuaq6_302",
    "offset-10": "awsui_offset-10_14yj0_xuaq6_305",
    "offset-11": "awsui_offset-11_14yj0_xuaq6_308",
    "restore-pointer-events": "awsui_restore-pointer-events_14yj0_xuaq6_312"
};




const $533fd63a0264232f$var$InternalGrid = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { __breakpoint: __breakpoint, gridDefinition: gridDefinition = [], disableGutters: disableGutters = false, children: children, __tagOverride: __tagOverride, __responsiveClassName: __responsiveClassName, __internalRootRef: __internalRootRef = null } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "__breakpoint",
        "gridDefinition",
        "disableGutters",
        "children",
        "__tagOverride",
        "__responsiveClassName",
        "__internalRootRef"
    ]);
    let [defaultBreakpoint, defaultRef] = (0, $921c3f4037759790$export$2aa1887afbd6d218)(undefined);
    if (__breakpoint !== undefined) {
        defaultBreakpoint = __breakpoint;
        defaultRef = ref;
    }
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    /*
   Flattening the children allows us to "see through" React Fragments and nested arrays.
   */ const flattenedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($dc835a13f4d26607$exports)))(children);
    const Tag = __tagOverride !== null && __tagOverride !== void 0 ? __tagOverride : "div";
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        const columnCount = gridDefinition.length;
        const childCount = flattenedChildren.length;
        if (columnCount !== childCount) (0, $dd646455762bc7b9$export$5b28268982f175ba)("Grid", `The number of children (${childCount}) does not match the number of columns defined (${columnCount}).`);
    }
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(defaultRef, __internalRootRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fd157c50f7b7577d$export$2e2bcd8739ae039).grid, baseProps.className, {
            [(0, $fd157c50f7b7577d$export$2e2bcd8739ae039)["no-gutters"]]: disableGutters
        }, __responsiveClassName ? __responsiveClassName(defaultBreakpoint) : null),
        ref: mergedRef
    }), flattenedChildren.map((child, i)=>{
        var _a, _b, _c, _d;
        // If this react child is a primitive value, the key will be undefined
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const key = child.key;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key ? String(key) : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fd157c50f7b7577d$export$2e2bcd8739ae039)["grid-column"], $533fd63a0264232f$var$getColumnClassNames("colspan", (_a = gridDefinition[i]) === null || _a === void 0 ? void 0 : _a.colspan, defaultBreakpoint), $533fd63a0264232f$var$getColumnClassNames("offset", (_b = gridDefinition[i]) === null || _b === void 0 ? void 0 : _b.offset, defaultBreakpoint), $533fd63a0264232f$var$getColumnClassNames("pull", (_c = gridDefinition[i]) === null || _c === void 0 ? void 0 : _c.pull, defaultBreakpoint), $533fd63a0264232f$var$getColumnClassNames("push", (_d = gridDefinition[i]) === null || _d === void 0 ? void 0 : _d.push, defaultBreakpoint))
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $fd157c50f7b7577d$export$2e2bcd8739ae039)["restore-pointer-events"]
        }, child));
    }));
});
function $533fd63a0264232f$var$getColumnClassNames(prop, mapping, breakpoint) {
    if (typeof mapping === "number") return (0, $fd157c50f7b7577d$export$2e2bcd8739ae039)[`${prop}-${mapping}`];
    if (breakpoint === null || mapping === undefined) return null;
    return (0, $fd157c50f7b7577d$export$2e2bcd8739ae039)[`${prop}-${(0, $1be283cfa47851a8$export$1decca26c2f3798f)(mapping, breakpoint)}`];
}
var $533fd63a0264232f$export$2e2bcd8739ae039 = $533fd63a0264232f$var$InternalGrid;


const $64e035e8b8dcf6cb$var$halfGeckoMaxCssLength = (1073741824 - 1) / 120;
function $64e035e8b8dcf6cb$export$2e2bcd8739ae039(_a) {
    var { children: children, disableOverlap: disableOverlap, header: header, headerVariant: headerVariant = "default", headerBackgroundStyle: headerBackgroundStyle, __internalRootRef: __internalRootRef, maxContentWidth: maxContentWidth = Number.MAX_VALUE, breadcrumbs: breadcrumbs, notifications: notifications, defaultPadding: defaultPadding, secondaryHeader: secondaryHeader } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "children",
        "disableOverlap",
        "header",
        "headerVariant",
        "headerBackgroundStyle",
        "__internalRootRef",
        "maxContentWidth",
        "breadcrumbs",
        "notifications",
        "defaultPadding",
        "secondaryHeader"
    ]);
    const mainRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(mainRef, __internalRootRef);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const mode = (0, $020c722843a7a503$export$8eda93b51c73aab)(mainRef);
    const overlapElement = (0, $26604b8e35e1a00b$export$fd4f28634267f02)();
    const isOverlapDisabled = !children || disableOverlap;
    const contentHeaderClassName = headerVariant === "high-contrast" && isVisualRefresh ? (0, $9c98cc94ae829c40$export$ebd33a9e3a891abd) : "";
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $f6419952c58a2c60$export$2e2bcd8739ae039).layout, {
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)["is-overlap-disabled"]]: isOverlapDisabled,
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)["is-visual-refresh"]]: isVisualRefresh,
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)["has-header"]]: !!header,
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)["default-padding"]]: !!defaultPadding,
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)["has-notifications"]]: !!notifications
        }),
        style: {
            [(0, $7c3a34cd41432ad1$export$2e2bcd8739ae039).contentLayoutMaxContentWidth]: maxContentWidth < Number.MAX_VALUE ? `${maxContentWidth}px` : `${$64e035e8b8dcf6cb$var$halfGeckoMaxCssLength}px`
        },
        ref: mergedRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f6419952c58a2c60$export$2e2bcd8739ae039).background, {
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)["has-default-background"]]: !headerBackgroundStyle
        }, contentHeaderClassName),
        ref: overlapElement
    }, headerBackgroundStyle && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $f6419952c58a2c60$export$2e2bcd8739ae039)["header-background"],
        style: {
            background: typeof headerBackgroundStyle === "function" ? headerBackgroundStyle(mode) : headerBackgroundStyle
        }
    })), notifications && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f6419952c58a2c60$export$2e2bcd8739ae039).notifications, (0, $998cfd68a29f6d17$export$2e2bcd8739ae039).notifications, contentHeaderClassName)
    }, notifications), breadcrumbs && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f6419952c58a2c60$export$2e2bcd8739ae039).breadcrumbs, (0, $998cfd68a29f6d17$export$2e2bcd8739ae039).breadcrumbs, contentHeaderClassName)
    }, breadcrumbs), header && !secondaryHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f6419952c58a2c60$export$2e2bcd8739ae039)["header-wrapper"], (0, $998cfd68a29f6d17$export$2e2bcd8739ae039).header, contentHeaderClassName, {
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)["with-divider"]]: headerVariant === "divider"
        })
    }, header), header && secondaryHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f6419952c58a2c60$export$2e2bcd8739ae039)["header-wrapper"], {
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)["with-divider"]]: headerVariant === "divider"
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $533fd63a0264232f$export$2e2bcd8739ae039), {
        gridDefinition: [
            {
                colspan: {
                    default: 12,
                    xs: 9
                }
            },
            {
                colspan: {
                    default: 12,
                    xs: 3
                }
            }
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $998cfd68a29f6d17$export$2e2bcd8739ae039).header, contentHeaderClassName)
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $998cfd68a29f6d17$export$2e2bcd8739ae039)["secondary-header"]
    }, secondaryHeader))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f6419952c58a2c60$export$2e2bcd8739ae039).content, {
            [(0, $f6419952c58a2c60$export$2e2bcd8739ae039)["with-divider"]]: headerVariant === "divider"
        })
    }, children));
}



function $1c3c7a1fd2ca4107$export$2e2bcd8739ae039(props) {
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("ContentLayout", {
        props: {
            disableOverlap: props.disableOverlap
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $64e035e8b8dcf6cb$export$2e2bcd8739ae039), Object.assign({}, props, baseComponentProps));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($1c3c7a1fd2ca4107$export$2e2bcd8739ae039, "ContentLayout");



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





var $a8ac619624564433$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1i0s3_12tgd_97",
    "header": "awsui_header_1i0s3_12tgd_132",
    "content": "awsui_content_1i0s3_12tgd_136",
    "error": "awsui_error_1i0s3_12tgd_140",
    "footer": "awsui_footer_1i0s3_12tgd_144",
    "actions-section": "awsui_actions-section_1i0s3_12tgd_148",
    "secondary-actions": "awsui_secondary-actions_1i0s3_12tgd_157",
    "actions": "awsui_actions_1i0s3_12tgd_148"
};




function $a0d286337a97b9da$export$2e2bcd8739ae039(_a) {
    var { children: children, header: header, errorText: errorText, errorIconAriaLabel: errorIconAriaLabelOverride, actions: actions, secondaryActions: secondaryActions, __internalRootRef: __internalRootRef } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "children",
        "header",
        "errorText",
        "errorIconAriaLabel",
        "actions",
        "secondaryActions",
        "__internalRootRef"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("form");
    const errorIconAriaLabel = i18n("errorIconAriaLabel", errorIconAriaLabelOverride);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        ref: __internalRootRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a8ac619624564433$export$2e2bcd8739ae039).root, baseProps.className)
    }), header && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a8ac619624564433$export$2e2bcd8739ae039).header
    }, header), children && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a8ac619624564433$export$2e2bcd8739ae039).content
    }, children), errorText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        margin: {
            top: "l"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0572c3fe95cef167$export$2e2bcd8739ae039), {
        type: "error",
        statusIconAriaLabel: errorIconAriaLabel
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a8ac619624564433$export$2e2bcd8739ae039).error
    }, errorText))), (actions || secondaryActions) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a8ac619624564433$export$2e2bcd8739ae039).footer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a8ac619624564433$export$2e2bcd8739ae039)["actions-section"]
    }, actions && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a8ac619624564433$export$2e2bcd8739ae039).actions
    }, actions), secondaryActions && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a8ac619624564433$export$2e2bcd8739ae039)["secondary-actions"]
    }, secondaryActions))), errorText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), {
        assertive: true
    }, errorIconAriaLabel, ", ", errorText));
}










const $3128a80b6a88093c$var$FormWithAnalytics = (_a)=>{
    var { variant: variant = "full-page", actions: actions, errorText: errorText } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "variant",
        "actions",
        "errorText"
    ]);
    const { funnelIdentifier: funnelIdentifier, funnelInteractionId: funnelInteractionId, funnelProps: funnelProps, funnelSubmit: funnelSubmit, funnelNextOrSubmitAttempt: funnelNextOrSubmitAttempt, errorCount: errorCount, submissionAttempt: submissionAttempt, funnelErrorContext: funnelErrorContext } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const { funnelStepProps: funnelStepProps } = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const handleActionButtonClick = ({ variant: variant })=>{
        if (variant === "primary") {
            funnelNextOrSubmitAttempt();
            funnelSubmit();
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (funnelInteractionId && errorText) {
            errorCount.current++;
            (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelError({
                funnelInteractionId: funnelInteractionId,
                funnelIdentifier: funnelIdentifier,
                funnelErrorContext: funnelErrorContext
            });
            return ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                errorCount.current--;
            };
        }
    }, [
        funnelInteractionId,
        funnelIdentifier,
        errorText,
        submissionAttempt,
        errorCount,
        funnelErrorContext
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $edea5ac281b34b48$export$24d547caef80ccd1).Provider, {
        value: {
            onClick: handleActionButtonClick
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a0d286337a97b9da$export$2e2bcd8739ae039), Object.assign({
        variant: variant,
        actions: actions,
        errorText: errorText
    }, props, funnelProps, funnelStepProps)));
};
function $3128a80b6a88093c$export$2e2bcd8739ae039(_a) {
    var { variant: variant = "full-page" } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "variant"
    ]);
    const analyticsMetadata = (0, $75a0355e989dd450$export$dba32c398c4b8fa1)(props);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Form", {
        props: {
            variant: variant
        }
    }, analyticsMetadata);
    const inheritedFunnelNameSelector = (0, $777318d005be2fce$export$330d990b59bc48da)();
    const funnelNameSelector = inheritedFunnelNameSelector || `.${(0, $962e3f40ddca05f8$export$2e2bcd8739ae039)["heading-text"]}`;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $515d52eb9df17853$export$467468afd0d320b9), {
        funnelIdentifier: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier,
        funnelFlowType: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.flowType,
        funnelErrorContext: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.errorContext,
        funnelType: "single-page",
        optionalStepNumbers: [],
        totalFunnelSteps: 1,
        funnelNameSelectors: [
            funnelNameSelector,
            `.${(0, $a8ac619624564433$export$2e2bcd8739ae039).header}`
        ]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $515d52eb9df17853$export$3fa82ebb4c38684d), {
        stepIdentifier: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier,
        stepErrorContext: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.errorContext,
        stepNumber: 1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3128a80b6a88093c$var$FormWithAnalytics, Object.assign({
        variant: variant
    }, props, baseComponentProps))));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($3128a80b6a88093c$export$2e2bcd8739ae039, "Form");



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $4a30639b463663e4$export$8af1424ebe35bf26 = (0, $acw62.createContext)({});
function $4a30639b463663e4$var$applyDefault(fields, defaults, keys) {
    const result = {};
    keys.forEach((key)=>{
        result[key] = fields[key] === undefined ? defaults[key] : fields[key];
    });
    return result;
}
function $4a30639b463663e4$export$824c400da192ca1b(props) {
    const context = (0, $acw62.useContext)($4a30639b463663e4$export$8af1424ebe35bf26);
    return $4a30639b463663e4$var$applyDefault(props, context, [
        "invalid",
        "warning",
        "controlId",
        "ariaLabelledby",
        "ariaDescribedby"
    ]);
}







function $31fd7deea6fab642$var$makeSlotId(prop, formFieldId, propName) {
    if (!prop) return undefined;
    return `${formFieldId}-${propName}`;
}
function $31fd7deea6fab642$export$c24c1edd02a696d0(formFieldId, label, description, constraintText, errorText, warningText) {
    const ids = {
        label: $31fd7deea6fab642$var$makeSlotId(label, formFieldId, "label"),
        description: $31fd7deea6fab642$var$makeSlotId(description, formFieldId, "description"),
        constraint: $31fd7deea6fab642$var$makeSlotId(constraintText, formFieldId, "constraint"),
        error: $31fd7deea6fab642$var$makeSlotId(errorText, formFieldId, "error"),
        warning: $31fd7deea6fab642$var$makeSlotId(warningText, formFieldId, "warning")
    };
    return ids;
}
function $31fd7deea6fab642$export$65ef0a02533e7bf7({ error: error, warning: warning, description: description, constraint: constraint }) {
    const describedByAttributes = [
        error,
        warning,
        description,
        constraint
    ].filter((e)=>!!e);
    const describedBy = describedByAttributes.length ? describedByAttributes.join(" ") : undefined;
    return describedBy;
}
function $31fd7deea6fab642$export$8192ce047e6259ae(stretch, secondaryControlPresent, isRefresh) {
    let columns;
    if (stretch) columns = [
        {
            colspan: 12
        },
        {
            colspan: 12
        }
    ];
    else if (isRefresh) columns = [
        {
            colspan: {
                default: 12,
                xs: 8
            }
        },
        {
            colspan: {
                default: 12,
                xs: 4
            }
        }
    ];
    else columns = [
        {
            colspan: {
                default: 12,
                xs: 9
            }
        },
        {
            colspan: {
                default: 12,
                xs: 3
            }
        }
    ];
    if (!secondaryControlPresent) return [
        columns[0]
    ];
    return columns;
}



var $a106f54d44afb8cf$export$2e2bcd8739ae039 = {
    "error-icon-shake-wrapper": "awsui_error-icon-shake-wrapper_14mhv_1rcjl_101",
    "warning-icon-shake-wrapper": "awsui_warning-icon-shake-wrapper_14mhv_1rcjl_102",
    "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_14mhv_1rcjl_1",
    "error-icon-scale-wrapper": "awsui_error-icon-scale-wrapper_14mhv_1rcjl_132",
    "warning-icon-scale-wrapper": "awsui_warning-icon-scale-wrapper_14mhv_1rcjl_133",
    "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_14mhv_1rcjl_1",
    "warning": "awsui_warning_14mhv_1rcjl_102",
    "error": "awsui_error_14mhv_1rcjl_101",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_14mhv_1rcjl_1",
    "root": "awsui_root_14mhv_1rcjl_184",
    "label": "awsui_label_14mhv_1rcjl_220",
    "info": "awsui_info_14mhv_1rcjl_234",
    "description": "awsui_description_14mhv_1rcjl_240",
    "constraint": "awsui_constraint_14mhv_1rcjl_241",
    "hints": "awsui_hints_14mhv_1rcjl_248",
    "constraint-has-validation-text": "awsui_constraint-has-validation-text_14mhv_1rcjl_249",
    "secondary-control": "awsui_secondary-control_14mhv_1rcjl_253",
    "controls": "awsui_controls_14mhv_1rcjl_257",
    "label-hidden": "awsui_label-hidden_14mhv_1rcjl_257",
    "label-wrapper": "awsui_label-wrapper_14mhv_1rcjl_260",
    "control": "awsui_control_14mhv_1rcjl_257",
    "error__message": "awsui_error__message_14mhv_1rcjl_287",
    "warning__message": "awsui_warning__message_14mhv_1rcjl_288",
    "visually-hidden": "awsui_visually-hidden_14mhv_1rcjl_292"
};









function $7e58f0606af63724$export$4852ecce5ecf6bcb({ id: id, children: children, errorIconAriaLabel: errorIconAriaLabel }) {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("form-field");
    const contentRef = (0, $acw62.useRef)(null);
    const i18nErrorIconAriaLabel = i18n("i18nStrings.errorIconAriaLabel", errorIconAriaLabel);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).error
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)["error-icon-shake-wrapper"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "img",
        "aria-label": i18nErrorIconAriaLabel,
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)["error-icon-scale-wrapper"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "status-negative",
        size: "small"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).error__message,
        ref: contentRef
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), {
        assertive: true,
        source: [
            i18nErrorIconAriaLabel,
            contentRef
        ]
    }));
}
function $7e58f0606af63724$export$7f93a80d0cfdba0c({ id: id, children: children, warningIconAriaLabel: warningIconAriaLabel }) {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("form-field");
    const contentRef = (0, $acw62.useRef)(null);
    const i18nWarningIconAriaLabel = i18n("i18nStrings.warningIconAriaLabel", warningIconAriaLabel);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).warning
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)["warning-icon-shake-wrapper"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "img",
        "aria-label": i18nWarningIconAriaLabel,
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)["warning-icon-scale-wrapper"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "status-warning",
        size: "small"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).warning__message,
        ref: contentRef
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), {
        assertive: true,
        source: [
            i18nWarningIconAriaLabel,
            contentRef
        ]
    }));
}
function $7e58f0606af63724$export$d907c2d8d9ae85b4({ id: id, hasValidationText: hasValidationText, children: children }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a106f54d44afb8cf$export$2e2bcd8739ae039).constraint, hasValidationText && (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)["constraint-has-validation-text"])
    }, children);
}
function $7e58f0606af63724$export$2e2bcd8739ae039(_a) {
    var { controlId: controlId, stretch: stretch = false, label: label, info: info, i18nStrings: i18nStrings, children: children, secondaryControl: secondaryControl, description: description, constraintText: constraintText, errorText: errorText, warningText: warningText, __hideLabel: __hideLabel, __internalRootRef: __internalRootRef = null, __disableGutters: __disableGutters = false, __analyticsMetadata: __analyticsMetadata } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "controlId",
        "stretch",
        "label",
        "info",
        "i18nStrings",
        "children",
        "secondaryControl",
        "description",
        "constraintText",
        "errorText",
        "warningText",
        "__hideLabel",
        "__internalRootRef",
        "__disableGutters",
        "__analyticsMetadata"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const instanceUniqueId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("formField");
    const generatedControlId = controlId || instanceUniqueId;
    const formFieldId = controlId || generatedControlId;
    const { funnelIdentifier: funnelIdentifier, funnelInteractionId: funnelInteractionId, submissionAttempt: submissionAttempt, funnelState: funnelState, errorCount: errorCount } = (0, $777318d005be2fce$export$88e1f0f171a7843e)();
    const { stepIdentifier: stepIdentifier, stepNumber: stepNumber, stepNameSelector: stepNameSelector } = (0, $777318d005be2fce$export$77e0136e4218bd7f)();
    const { subStepErrorContext: subStepErrorContext, subStepIdentifier: subStepIdentifier, subStepSelector: subStepSelector, subStepNameSelector: subStepNameSelector } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    const showWarning = warningText && !errorText;
    if (warningText && errorText) (0, $dd646455762bc7b9$export$5b28268982f175ba)("FileUpload", "Both `errorText` and `warningText` exist. `warningText` will not be shown.");
    const slotIds = (0, $31fd7deea6fab642$export$c24c1edd02a696d0)(formFieldId, label, description, constraintText, errorText, showWarning ? warningText : undefined);
    const ariaDescribedBy = (0, $31fd7deea6fab642$export$65ef0a02533e7bf7)(slotIds);
    const gridDefinition = (0, $31fd7deea6fab642$export$8192ce047e6259ae)(stretch, !!secondaryControl, isRefresh);
    const { ariaLabelledby: parentAriaLabelledby, ariaDescribedby: parentAriaDescribedby, invalid: parentInvalid, warning: parentWarning } = (0, $4a30639b463663e4$export$824c400da192ca1b)({});
    const contextValuesWithoutControlId = {
        ariaLabelledby: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(parentAriaLabelledby, slotIds.label) || undefined,
        ariaDescribedby: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(parentAriaDescribedby, ariaDescribedBy) || undefined,
        invalid: !!errorText || !!parentInvalid,
        warning: !!warningText && !errorText || !!parentWarning && !parentInvalid
    };
    const analyticsAttributes = {
        [(0, $285a09b860d2bebc$export$7f7018c0ba6d811a)]: slotIds.label ? (0, $285a09b860d2bebc$export$9b7aa6f73a756b51)(slotIds.label) : undefined,
        [(0, $285a09b860d2bebc$export$374a078abad6179f)]: slotIds.error ? (0, $285a09b860d2bebc$export$9b7aa6f73a756b51)(slotIds.error) : undefined
    };
    (0, $acw62.useEffect)(()=>{
        var _a, _b, _c;
        if (funnelInteractionId && errorText && funnelState.current !== "complete") {
            const stepName = (0, $285a09b860d2bebc$export$ad08a5942dca04f8)(stepNameSelector);
            const subStepName = (0, $285a09b860d2bebc$export$ad08a5942dca04f8)(subStepNameSelector);
            errorCount.current++;
            // We don't want to report an error if it is hidden, e.g. inside an Expandable Section.
            const errorIsVisible = ((_c = (_b = (_a = __internalRootRef === null || __internalRootRef === void 0 ? void 0 : __internalRootRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : 0) > 0;
            if (errorIsVisible) (0, $54d511b0978bc73c$export$300ddd9f131af3a).funnelSubStepError({
                funnelInteractionId: funnelInteractionId,
                funnelIdentifier: funnelIdentifier,
                subStepSelector: subStepSelector,
                subStepName: subStepName,
                subStepNameSelector: subStepNameSelector,
                subStepIdentifier: subStepIdentifier,
                stepNumber: stepNumber,
                stepName: stepName,
                stepNameSelector: stepNameSelector,
                stepIdentifier: stepIdentifier,
                subStepErrorContext: subStepErrorContext,
                fieldErrorSelector: `${(0, $285a09b860d2bebc$export$9b7aa6f73a756b51)(slotIds.error)} .${(0, $a106f54d44afb8cf$export$2e2bcd8739ae039).error__message}`,
                fieldLabelSelector: (0, $285a09b860d2bebc$export$9b7aa6f73a756b51)(slotIds.label),
                subStepAllSelector: (0, $285a09b860d2bebc$export$57dc544ae10998c7)(),
                fieldIdentifier: __analyticsMetadata === null || __analyticsMetadata === void 0 ? void 0 : __analyticsMetadata.instanceIdentifier,
                fieldErrorContext: __analyticsMetadata === null || __analyticsMetadata === void 0 ? void 0 : __analyticsMetadata.errorContext
            });
            return ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                errorCount.current--;
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        funnelInteractionId,
        errorText,
        submissionAttempt,
        errorCount
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).root),
        ref: __internalRootRef
    }, analyticsAttributes), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a106f54d44afb8cf$export$2e2bcd8739ae039)["label-wrapper"], __hideLabel && (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)["visually-hidden"])
    }, label && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).label,
        id: slotIds.label,
        htmlFor: generatedControlId
    }, label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $edb6222f981e45e4$export$8ffd2daeac4a0391).Provider, {
        value: slotIds.label
    }, !__hideLabel && info && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).info
    }, info))), description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).description,
        id: slotIds.description
    }, description), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a106f54d44afb8cf$export$2e2bcd8739ae039).controls, __hideLabel && (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)["label-hidden"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $533fd63a0264232f$export$2e2bcd8739ae039), {
        gridDefinition: gridDefinition,
        disableGutters: __disableGutters
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a30639b463663e4$export$8af1424ebe35bf26).Provider, {
        value: Object.assign({
            controlId: generatedControlId
        }, contextValuesWithoutControlId)
    }, children && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).control
    }, children)), secondaryControl && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a30639b463663e4$export$8af1424ebe35bf26).Provider, {
        value: contextValuesWithoutControlId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039)["secondary-control"]
    }, secondaryControl)))), (constraintText || errorText || warningText) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a106f54d44afb8cf$export$2e2bcd8739ae039).hints
    }, errorText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7e58f0606af63724$export$4852ecce5ecf6bcb, {
        id: slotIds.error,
        errorIconAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.errorIconAriaLabel
    }, errorText), showWarning && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7e58f0606af63724$export$7f93a80d0cfdba0c, {
        id: slotIds.warning,
        warningIconAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.warningIconAriaLabel
    }, warningText), constraintText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7e58f0606af63724$export$d907c2d8d9ae85b4, {
        id: slotIds.constraint,
        hasValidationText: !!errorText || !!warningText
    }, constraintText)));
}





function $d07d035b542ec3e4$export$2e2bcd8739ae039(_a) {
    var { stretch: stretch = false } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "stretch"
    ]);
    const analyticsMetadata = (0, $75a0355e989dd450$export$dba32c398c4b8fa1)(props);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("FormField", {
        props: {
            stretch: stretch
        }
    }, analyticsMetadata);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$2e2bcd8739ae039), Object.assign({
        stretch: stretch
    }, props, {
        __hideLabel: false,
        __analyticsMetadata: analyticsMetadata
    }, baseComponentProps));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($d07d035b542ec3e4$export$2e2bcd8739ae039, "FormField");



var $acw62 = parcelRequire("acw62");



function $417cbce8ab3dcc04$export$2e2bcd8739ae039(_a) {
    var { variant: variant = "h2" } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "variant"
    ]);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Header", {
        props: {
            headingTagOverride: props.headingTagOverride,
            variant: variant
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a2f4d445a38721ba$export$2e2bcd8739ae039), Object.assign({
        variant: variant
    }, props, baseComponentProps));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($417cbce8ab3dcc04$export$2e2bcd8739ae039, "Header");




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $b4592d5eb2ab5ee3$export$f3b00687d1185fd5 = (type, disabled, readOnly, value, inputRef, onChange)=>{
    const searchProps = {};
    const handleIconClick = (0, $acw62.useCallback)(()=>{
        var _a;
        (_a = inputRef.current) === null || _a === void 0 || _a.focus();
        onChange("");
    }, [
        inputRef,
        onChange
    ]);
    if (type === "search" || type === "visualSearch") {
        searchProps.__leftIcon = "search";
        if (!disabled && !readOnly && value) {
            searchProps.__rightIcon = "close";
            searchProps.__onRightIconClick = handleIconClick;
        }
    }
    return searchProps;
};
const $b4592d5eb2ab5ee3$export$d0b21904efc6680a = (propertyValue = false)=>{
    if (propertyValue === true) return "on";
    return propertyValue || "off";
};





var $3b18faa9c4faa28d$export$2e2bcd8739ae039 = {
    "root": "awsui_root_2rhyz_4n5z9_97",
    "input": "awsui_input_2rhyz_4n5z9_101",
    "input-readonly": "awsui_input-readonly_2rhyz_4n5z9_151",
    "input-invalid": "awsui_input-invalid_2rhyz_4n5z9_218",
    "input-has-icon-left": "awsui_input-has-icon-left_2rhyz_4n5z9_229",
    "input-warning": "awsui_input-warning_2rhyz_4n5z9_234",
    "input-type-search": "awsui_input-type-search_2rhyz_4n5z9_250",
    "input-has-icon-right": "awsui_input-has-icon-right_2rhyz_4n5z9_263",
    "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_4n5z9_266",
    "input-container": "awsui_input-container_2rhyz_4n5z9_273",
    "input-icon-left": "awsui_input-icon-left_2rhyz_4n5z9_278",
    "input-icon-right": "awsui_input-icon-right_2rhyz_4n5z9_285",
    "input-button-right": "awsui_input-button-right_2rhyz_4n5z9_291"
};



function $fadf349311229145$var$InternalInput(_a, ref) {
    var { type: type = "text", step: step, inputMode: inputMode, autoComplete: autoComplete = true, ariaLabel: ariaLabel, clearAriaLabel: clearAriaLabelOverride, name: name, value: value, placeholder: placeholder, autoFocus: autoFocus, disabled: disabled, readOnly: readOnly, disableBrowserAutocorrect: disableBrowserAutocorrect, spellcheck: spellcheck, __noBorderRadius: __noBorderRadius, __leftIcon: __leftIcon, __leftIconVariant: __leftIconVariant = "subtle", __onLeftIconClick: __onLeftIconClick, ariaRequired: ariaRequired, __rightIcon: __rightIcon, __onRightIconClick: __onRightIconClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onChange: onChange, __onDelayedInput: __onDelayedInput, __onBlurWithDetail: __onBlurWithDetail, onBlur: onBlur, onFocus: onFocus, __nativeAttributes: __nativeAttributes, __internalRootRef: __internalRootRef, __inheritFormFieldProps: __inheritFormFieldProps } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "type",
        "step",
        "inputMode",
        "autoComplete",
        "ariaLabel",
        "clearAriaLabel",
        "name",
        "value",
        "placeholder",
        "autoFocus",
        "disabled",
        "readOnly",
        "disableBrowserAutocorrect",
        "spellcheck",
        "__noBorderRadius",
        "__leftIcon",
        "__leftIconVariant",
        "__onLeftIconClick",
        "ariaRequired",
        "__rightIcon",
        "__onRightIconClick",
        "onKeyDown",
        "onKeyUp",
        "onChange",
        "__onDelayedInput",
        "__onBlurWithDetail",
        "onBlur",
        "onFocus",
        "__nativeAttributes",
        "__internalRootRef",
        "__inheritFormFieldProps"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("input");
    const fireDelayedInput = (0, $2f667510820517ed$export$40ae01be0011c1e6)((value)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(__onDelayedInput, {
            value: value
        }));
    const handleChange = (value)=>{
        fireDelayedInput(value);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            value: value
        });
    };
    const inputRef = (0, $acw62.useRef)(null);
    const searchProps = (0, $b4592d5eb2ab5ee3$export$f3b00687d1185fd5)(type, disabled, readOnly, value, inputRef, handleChange);
    __leftIcon = __leftIcon !== null && __leftIcon !== void 0 ? __leftIcon : searchProps.__leftIcon;
    __rightIcon = __rightIcon !== null && __rightIcon !== void 0 ? __rightIcon : searchProps.__rightIcon;
    __onRightIconClick = __onRightIconClick !== null && __onRightIconClick !== void 0 ? __onRightIconClick : searchProps.__onRightIconClick;
    const formFieldContext = (0, $4a30639b463663e4$export$824c400da192ca1b)(rest);
    const { ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, controlId: controlId, invalid: invalid, warning: warning } = __inheritFormFieldProps ? formFieldContext : rest;
    const attributes = Object.assign({
        "aria-label": ariaLabel,
        // aria-labelledby has precedence over aria-label in accessible name calculation.
        // When aria-label is provided for Input, it should override aria-labelledBy from form-field context.
        // If both aria-label and aria-labelledby come from Input props, aria-labelledby will be used in accessible name
        "aria-labelledby": ariaLabel && !rest.ariaLabelledby ? undefined : ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        name: name,
        placeholder: placeholder,
        autoFocus: autoFocus,
        id: controlId,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b18faa9c4faa28d$export$2e2bcd8739ae039).input, type && (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)[`input-type-${type}`], __rightIcon && (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)["input-has-icon-right"], __leftIcon && (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)["input-has-icon-left"], __noBorderRadius && (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)["input-has-no-border-radius"], {
            [(0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)["input-readonly"]]: readOnly,
            [(0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)["input-invalid"]]: invalid,
            [(0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)["input-warning"]]: warning && !invalid
        }),
        autoComplete: (0, $b4592d5eb2ab5ee3$export$d0b21904efc6680a)(autoComplete),
        disabled: disabled,
        readOnly: readOnly,
        type: type,
        step: step,
        inputMode: inputMode,
        spellCheck: spellcheck,
        onKeyDown: onKeyDown && ((event)=>(0, $fc537b925f715587$export$d23d807e6c464ee0)(onKeyDown, event)),
        onKeyUp: onKeyUp && ((event)=>(0, $fc537b925f715587$export$d23d807e6c464ee0)(onKeyUp, event)),
        // We set a default value on the component in order to force it into the controlled mode.
        value: value !== null && value !== void 0 ? value : "",
        onChange: onChange && ((event)=>handleChange(event.target.value)),
        onBlur: (e)=>{
            onBlur && (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur);
            __onBlurWithDetail && (0, $fc537b925f715587$export$e36a47fa496fb0d2)(__onBlurWithDetail, {
                relatedTarget: e.relatedTarget
            });
        },
        onFocus: onFocus && (()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus))
    }, __nativeAttributes);
    if (type === "number") // Chrome and Safari have a weird built-in behavior of letting focused
    // number inputs be controlled by scrolling on them. However, they don't
    // lock the browser's scroll, so it's very easy to accidentally increment
    // the input while scrolling down the page.
    attributes.onWheel = (event)=>event.currentTarget.blur();
    if (disableBrowserAutocorrect) {
        attributes.autoCorrect = "off";
        attributes.autoCapitalize = "off";
    }
    // ensure aria properties are string literal "true"
    if (ariaRequired) attributes["aria-required"] = "true";
    if (invalid) attributes["aria-invalid"] = "true";
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(ref, inputRef);
    // type = "visualSearch" renders a type="text' input
    if (attributes.type === "visualSearch") attributes.type = "text";
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)["input-container"]),
        ref: __internalRootRef,
        dir: type === "email" ? "ltr" : undefined
    }), __leftIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        onClick: __onLeftIconClick,
        className: (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)["input-icon-left"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: __leftIcon,
        variant: disabled || readOnly ? "disabled" : __leftIconVariant
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", Object.assign({
        ref: mergedRef
    }, attributes)), __rightIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)["input-icon-right"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        // Used for test utils
        // eslint-disable-next-line react/forbid-component-props
        className: (0, $3b18faa9c4faa28d$export$2e2bcd8739ae039)["input-button-right"],
        variant: "inline-icon",
        formAction: "none",
        iconName: __rightIcon,
        onClick: __onRightIconClick,
        ariaLabel: i18n("clearAriaLabel", clearAriaLabelOverride),
        disabled: disabled
    })));
}
var $fadf349311229145$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($fadf349311229145$var$InternalInput);





const $cc0ce5a84f6f2813$var$Input = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { value: value, type: type = "text", step: step, inputMode: inputMode, autoComplete: autoComplete = true, spellcheck: spellcheck, disabled: disabled, readOnly: readOnly, disableBrowserAutocorrect: disableBrowserAutocorrect, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onChange: onChange, onBlur: onBlur, onFocus: onFocus, ariaRequired: ariaRequired, name: name, placeholder: placeholder, autoFocus: autoFocus, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, invalid: invalid, warning: warning, controlId: controlId, clearAriaLabel: clearAriaLabel } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "value",
        "type",
        "step",
        "inputMode",
        "autoComplete",
        "spellcheck",
        "disabled",
        "readOnly",
        "disableBrowserAutocorrect",
        "onKeyDown",
        "onKeyUp",
        "onChange",
        "onBlur",
        "onFocus",
        "ariaRequired",
        "name",
        "placeholder",
        "autoFocus",
        "ariaLabel",
        "ariaLabelledby",
        "ariaDescribedby",
        "invalid",
        "warning",
        "controlId",
        "clearAriaLabel"
    ]);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Input", {
        props: {
            autoComplete: autoComplete,
            autoFocus: autoFocus,
            disableBrowserAutocorrect: disableBrowserAutocorrect,
            inputMode: inputMode,
            readOnly: readOnly,
            spellcheck: spellcheck,
            type: type
        }
    });
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const inputRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            focus (...args) {
                var _a;
                (_a = inputRef.current) === null || _a === void 0 || _a.focus(...args);
            },
            select () {
                var _a;
                (_a = inputRef.current) === null || _a === void 0 || _a.select();
            }
        }), [
        inputRef
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fadf349311229145$export$2e2bcd8739ae039), Object.assign({
        ref: inputRef
    }, Object.assign(Object.assign(Object.assign({}, baseProps), baseComponentProps), {
        autoComplete: autoComplete,
        ariaLabel: ariaLabel,
        ariaRequired: ariaRequired,
        autoFocus: autoFocus,
        disabled: disabled,
        disableBrowserAutocorrect: disableBrowserAutocorrect,
        name: name,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        placeholder: placeholder,
        readOnly: readOnly,
        type: type,
        step: step,
        inputMode: inputMode,
        spellcheck: spellcheck,
        value: value,
        ariaDescribedby: ariaDescribedby,
        ariaLabelledby: ariaLabelledby,
        invalid: invalid,
        warning: warning,
        controlId: controlId,
        clearAriaLabel: clearAriaLabel
    }), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b18faa9c4faa28d$export$2e2bcd8739ae039).root, baseProps.className),
        __inheritFormFieldProps: true
    }));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($cc0ce5a84f6f2813$var$Input, "Input");
var $cc0ce5a84f6f2813$export$2e2bcd8739ae039 = $cc0ce5a84f6f2813$var$Input;



var $acw62 = parcelRequire("acw62");



const $3baf384ab7fe8d32$var$Link = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { fontSize: fontSize = "body-m", color: color = "normal", external: external = false } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "fontSize",
        "color",
        "external"
    ]);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Link", {
        props: {
            color: color,
            external: external,
            fontSize: fontSize,
            rel: props.rel,
            target: props.target,
            variant: props.variant
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $01503a290f20b804$export$2e2bcd8739ae039), Object.assign({
        fontSize: fontSize,
        color: color,
        external: external
    }, props, baseComponentProps, {
        ref: ref
    }));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($3baf384ab7fe8d32$var$Link, "Link");
var $3baf384ab7fe8d32$export$2e2bcd8739ae039 = $3baf384ab7fe8d32$var$Link;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $c6c0a833d340e863$export$2e2bcd8739ae039 = {
    "root": "awsui_root_18582_jftqg_97",
    "child": "awsui_child_18582_jftqg_101",
    "horizontal": "awsui_horizontal_18582_jftqg_112",
    "horizontal-xxxs": "awsui_horizontal-xxxs_18582_jftqg_116",
    "horizontal-xxs": "awsui_horizontal-xxs_18582_jftqg_119",
    "horizontal-xs": "awsui_horizontal-xs_18582_jftqg_122",
    "horizontal-s": "awsui_horizontal-s_18582_jftqg_125",
    "horizontal-m": "awsui_horizontal-m_18582_jftqg_128",
    "horizontal-l": "awsui_horizontal-l_18582_jftqg_131",
    "horizontal-xl": "awsui_horizontal-xl_18582_jftqg_134",
    "horizontal-xxl": "awsui_horizontal-xxl_18582_jftqg_137",
    "vertical": "awsui_vertical_18582_jftqg_144",
    "vertical-xxxs": "awsui_vertical-xxxs_18582_jftqg_147",
    "vertical-xxs": "awsui_vertical-xxs_18582_jftqg_150",
    "vertical-xs": "awsui_vertical-xs_18582_jftqg_153",
    "vertical-s": "awsui_vertical-s_18582_jftqg_156",
    "vertical-m": "awsui_vertical-m_18582_jftqg_159",
    "vertical-l": "awsui_vertical-l_18582_jftqg_162",
    "vertical-xl": "awsui_vertical-xl_18582_jftqg_165",
    "vertical-xxl": "awsui_vertical-xxl_18582_jftqg_168",
    "align-center": "awsui_align-center_18582_jftqg_172",
    "align-start": "awsui_align-start_18582_jftqg_176",
    "align-end": "awsui_align-end_18582_jftqg_180"
};



function $dbf1224d55e2b5c5$export$2e2bcd8739ae039(_a) {
    var { direction: direction = "vertical", size: size, children: children, alignItems: alignItems, __internalRootRef: __internalRootRef } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "direction",
        "size",
        "children",
        "alignItems",
        "__internalRootRef"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    /*
     Flattening the children allows us to "see through" React Fragments and nested arrays.
     */ const flattenedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($dc835a13f4d26607$exports)))(children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $c6c0a833d340e863$export$2e2bcd8739ae039).root, (0, $c6c0a833d340e863$export$2e2bcd8739ae039)[direction], (0, $c6c0a833d340e863$export$2e2bcd8739ae039)[`${direction}-${size}`], alignItems && (0, $c6c0a833d340e863$export$2e2bcd8739ae039)[`align-${alignItems}`]),
        ref: __internalRootRef
    }), flattenedChildren.map((child)=>{
        const key = typeof child === "object" ? child.key : undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            className: (0, $c6c0a833d340e863$export$2e2bcd8739ae039).child
        }, child);
    }));
}



function $74ee220a592e3066$export$2e2bcd8739ae039(_a) {
    var { direction: direction = "vertical" } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "direction"
    ]);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("SpaceBetween", {
        props: {
            alignItems: props.alignItems,
            direction: direction,
            size: props.size
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), Object.assign({
        direction: direction
    }, props, baseComponentProps));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($74ee220a592e3066$export$2e2bcd8739ae039, "SpaceBetween");



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



function $09d4a5bf5140299c$export$2e2bcd8739ae039(_a) {
    var { variant: variant = "div", margin: margin = {}, padding: padding = {} } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "variant",
        "margin",
        "padding"
    ]);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Box", {
        props: {
            color: props.color,
            display: props.display,
            float: props.float,
            fontSize: props.fontSize,
            fontWeight: props.fontWeight,
            textAlign: props.textAlign,
            variant: variant
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), Object.assign({
        variant: variant,
        margin: margin,
        padding: padding
    }, props, baseComponentProps));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($09d4a5bf5140299c$export$2e2bcd8739ae039, "Box");



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $914111a054c2e0da$export$2e2bcd8739ae039 = {
    "dialog": "awsui_dialog_1d2i7_xpcku_109",
    "modal-slide-up": "awsui_modal-slide-up_1d2i7_xpcku_1",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1d2i7_xpcku_1",
    "refresh": "awsui_refresh_1d2i7_xpcku_132",
    "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_1d2i7_xpcku_1",
    "root": "awsui_root_1d2i7_xpcku_165",
    "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_1d2i7_xpcku_1",
    "hidden": "awsui_hidden_1d2i7_xpcku_249",
    "focus-lock": "awsui_focus-lock_1d2i7_xpcku_253",
    "small": "awsui_small_1d2i7_xpcku_273",
    "medium": "awsui_medium_1d2i7_xpcku_276",
    "large": "awsui_large_1d2i7_xpcku_279",
    "max": "awsui_max_1d2i7_xpcku_282",
    "breakpoint-xs": "awsui_breakpoint-xs_1d2i7_xpcku_282",
    "container": "awsui_container_1d2i7_xpcku_288",
    "content": "awsui_content_1d2i7_xpcku_332",
    "no-paddings": "awsui_no-paddings_1d2i7_xpcku_337",
    "header": "awsui_header_1d2i7_xpcku_342",
    "header--text": "awsui_header--text_1d2i7_xpcku_354",
    "footer": "awsui_footer_1d2i7_xpcku_358",
    "footer--stuck": "awsui_footer--stuck_1d2i7_xpcku_367",
    "dismiss-control": "awsui_dismiss-control_1d2i7_xpcku_379",
    "modal-open": "awsui_modal-open_1d2i7_xpcku_383"
};


/*
 * ** Detect scrollbar width (blog post); version N/A -- https://davidwalsh.name/detect-scrollbar-width
 *
 * MIT License
 *
 * Copyright (c) 2007-2021 David Walsh
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /* eslint-disable header/header */ // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $7ba862503e02b551$export$9d90a68566e6aa6f(callback) {
    let result = undefined;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


const $7b99d3a86137a2e2$export$bbb9ce125c89ccb4 = (0, $7ba862503e02b551$export$9d90a68566e6aa6f)(()=>{
    if (typeof document === "undefined") return {
        width: 0,
        height: 0
    };
    const scrollDiv = document.createElement("div");
    scrollDiv.style.overflow = "scroll";
    scrollDiv.style.height = "100px";
    scrollDiv.style.width = "100px";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.left = "-9999px";
    document.body.appendChild(scrollDiv);
    const width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    const height = scrollDiv.offsetHeight - scrollDiv.clientHeight;
    document.body.removeChild(scrollDiv);
    return {
        width: width,
        height: height
    };
});


// Read this before making changes to the code below.
//
// When a modal is used from an iframe the body scrolling utils take no effect because they need to be applied to another document.
// The customers replicate this behavior by running the same code on the correct document instance, see AWSUI-41915.
// Hence, we should avoid making changes to the component that break the body scrolling logic in its current form.
let $16c9734086b05737$var$initialBodyPaddingRightStyle = undefined;
function $16c9734086b05737$export$b90142434781d71c() {
    $16c9734086b05737$var$setBodyScrollbarPadding();
    document.body.classList.add((0, $914111a054c2e0da$export$2e2bcd8739ae039)["modal-open"]);
}
function $16c9734086b05737$export$28b514218137a105() {
    document.body.classList.remove((0, $914111a054c2e0da$export$2e2bcd8739ae039)["modal-open"]);
    $16c9734086b05737$var$restoreBodyScrollbarPadding();
}
function $16c9734086b05737$var$setBodyScrollbarPadding() {
    if ($16c9734086b05737$var$bodyHasScrollbar()) {
        $16c9734086b05737$var$initialBodyPaddingRightStyle = document.body.style.paddingRight;
        const initialBodyPaddingRight = $16c9734086b05737$var$computedBodyPaddingRightPixels();
        const scrollbarWidth = (0, $7b99d3a86137a2e2$export$bbb9ce125c89ccb4)().width;
        const newBodyPaddingRight = initialBodyPaddingRight + scrollbarWidth;
        document.body.style.paddingRight = newBodyPaddingRight + "px";
    }
}
function $16c9734086b05737$var$computedBodyPaddingRightPixels() {
    return parseInt(window.getComputedStyle(document.body).paddingRight, 10);
}
function $16c9734086b05737$var$restoreBodyScrollbarPadding() {
    if ($16c9734086b05737$var$initialBodyPaddingRightStyle) document.body.style.setProperty("padding-right", $16c9734086b05737$var$initialBodyPaddingRightStyle);
    else document.body.style.removeProperty("padding-right");
    $16c9734086b05737$var$initialBodyPaddingRightStyle = undefined;
}
function $16c9734086b05737$var$bodyHasScrollbar() {
    // Unfortunately this difference doesn't appear to match the scrollbar width during testing,
    // otherwise we could remove browserScrollbarSize().  Bootstrap also doesn't use this difference
    // directly.
    return document.body.clientWidth < window.innerWidth;
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $cff975c73fa800c5$export$a7395f9832c00176() {
    const observerRef = (0, $acw62.useRef)(null);
    const [isIntersecting, setIsIntersecting] = (0, $acw62.useState)(false);
    const ref = (0, $acw62.useCallback)((targetElement)=>{
        if (typeof IntersectionObserver === "undefined") // Do nothing in environments like JSDOM
        return;
        if (observerRef.current) // Dismiss previous observer because the target changed
        observerRef.current.disconnect();
        // Create a new observer with the target element
        if (targetElement) {
            observerRef.current = new IntersectionObserver(([entry])=>setIsIntersecting(entry.isIntersecting));
            observerRef.current.observe(targetElement);
        }
    }, []);
    return {
        ref: ref,
        isIntersecting: isIntersecting
    };
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");






/*
 Use this context-resetter when creating a new modal-type context where typically the contents
 of the modal should not be affected by the surrounding components/DOM.
 */ const $08fba30ddb2cfd8a$var$ResetContextsForModal = ({ children: children })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $edea5ac281b34b48$export$24d547caef80ccd1).Provider, {
        value: {
            onClick: ()=>{}
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e52d1d829dbf9fa$export$85b6faccd4f04314).Provider, {
        value: {
            assignId: ()=>{}
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a30639b463663e4$export$8af1424ebe35bf26).Provider, {
        value: {}
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $edb6222f981e45e4$export$8ffd2daeac4a0391).Provider, {
        value: ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9699df5a060a9c12$export$366cdc6257b696ef).Provider, {
        value: (0, $9699df5a060a9c12$export$1a01ae0705bafd37)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7f9661e47bcc5460$export$d883ceba1e571843).Provider, {
        value: (0, $7f9661e47bcc5460$export$1a01ae0705bafd37)
    }, children))))));
var $08fba30ddb2cfd8a$export$2e2bcd8739ae039 = $08fba30ddb2cfd8a$var$ResetContextsForModal;


function $7a5bb8d240e2baab$export$2e2bcd8739ae039(_a) {
    var { modalRoot: modalRoot, getModalRoot: getModalRoot, removeModalRoot: removeModalRoot } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "modalRoot",
        "getModalRoot",
        "removeModalRoot"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $014cec8599be1408$export$2e2bcd8739ae039), {
        container: modalRoot,
        getContainer: getModalRoot,
        removeContainer: removeModalRoot
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7a5bb8d240e2baab$var$PortaledModal, Object.assign({}, rest)));
}
// Separate component to prevent the Portal from getting in the way of refs, as it needs extra cycles to render the inner components.
// useContainerQuery needs its targeted element to exist on the first render in order to work properly.
function $7a5bb8d240e2baab$var$PortaledModal(_a) {
    var _b;
    var { size: size, visible: visible, header: header, children: children, footer: footer, disableContentPaddings: disableContentPaddings, onDismiss: onDismiss, __internalRootRef: __internalRootRef = null } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "size",
        "visible",
        "header",
        "children",
        "footer",
        "disableContentPaddings",
        "onDismiss",
        "__internalRootRef"
    ]);
    const instanceUniqueId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)();
    const headerId = `${rest.id || instanceUniqueId}-header`;
    const lastMouseDownElementRef = (0, $acw62.useRef)(null);
    const [breakpoint, breakpointsRef] = (0, $921c3f4037759790$export$2aa1887afbd6d218)([
        "xs"
    ]);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("modal");
    const closeAriaLabel = i18n("closeAriaLabel", rest.closeAriaLabel);
    const refObject = (0, $acw62.useRef)(null);
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(breakpointsRef, refObject, __internalRootRef);
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    // enable body scroll and restore focus if unmounting while visible
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            (0, $16c9734086b05737$export$28b514218137a105)();
        };
    }, []);
    // enable / disable body scroll
    (0, $acw62.useEffect)(()=>{
        if (visible) (0, $16c9734086b05737$export$b90142434781d71c)();
        else (0, $16c9734086b05737$export$28b514218137a105)();
    }, [
        visible
    ]);
    // Because we hide the element with styles (and not actually detach it from DOM), we need to scroll to top
    (0, $acw62.useEffect)(()=>{
        if (visible && refObject.current) refObject.current.scrollTop = 0;
    }, [
        visible
    ]);
    const dismiss = (reason)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDismiss, {
            reason: reason
        });
    const onOverlayMouseDown = (event)=>{
        lastMouseDownElementRef.current = event.target;
    };
    const onOverlayClick = (event)=>{
        const overlay = refObject.current;
        const lastClicked = lastMouseDownElementRef.current;
        if (event.target === overlay && lastClicked === overlay) dismiss("overlay");
    };
    const onCloseButtonClick = ()=>dismiss("closeButton");
    const escKeyHandler = (event)=>{
        if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).escape) dismiss("keyboard");
    };
    // We use an empty div element at the end of the content slot as a sentinel
    // to detect when the user has scrolled to the bottom.
    const { ref: stickySentinelRef, isIntersecting: footerStuck } = (0, $cff975c73fa800c5$export$a7395f9832c00176)();
    // Add extra scroll padding to account for the height of the sticky footer,
    // to prevent it from covering focused elements.
    const [footerHeight, footerRef] = (0, $6e052e2d296ab854$export$2e2bcd8739ae039)((rect)=>rect.borderBoxHeight);
    const { subStepRef: subStepRef } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2c7360a12f6b0b92$export$6763bc96d4aa4bf8).Provider, {
        value: `.${(0, $914111a054c2e0da$export$2e2bcd8739ae039)["header--text"]}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08fba30ddb2cfd8a$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $584c4a19f0ba0537$export$ab57792b9b6974a6).Provider, {
        value: {
            isInModal: true
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $914111a054c2e0da$export$2e2bcd8739ae039).root, {
            [(0, $914111a054c2e0da$export$2e2bcd8739ae039).hidden]: !visible
        }, baseProps.className, isRefresh && (0, $914111a054c2e0da$export$2e2bcd8739ae039).refresh),
        role: "dialog",
        "aria-modal": true,
        "aria-labelledby": headerId,
        onMouseDown: onOverlayMouseDown,
        onClick: onOverlayClick,
        ref: mergedRef,
        style: footerHeight ? {
            scrollPaddingBottom: footerHeight
        } : undefined,
        "data-awsui-referrer-id": (_b = subStepRef.current) === null || _b === void 0 ? void 0 : _b.id
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48646398710f9406$export$2e2bcd8739ae039), {
        disabled: !visible,
        autoFocus: true,
        restoreFocus: true,
        className: (0, $914111a054c2e0da$export$2e2bcd8739ae039)["focus-lock"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $914111a054c2e0da$export$2e2bcd8739ae039).dialog, (0, $914111a054c2e0da$export$2e2bcd8739ae039)[size], (0, $914111a054c2e0da$export$2e2bcd8739ae039)[`breakpoint-${breakpoint}`], isRefresh && (0, $914111a054c2e0da$export$2e2bcd8739ae039).refresh),
        onKeyDown: escKeyHandler
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $914111a054c2e0da$export$2e2bcd8739ae039).container
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $914111a054c2e0da$export$2e2bcd8739ae039).header
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a2f4d445a38721ba$export$2e2bcd8739ae039), {
        variant: "h2",
        __disableActionsWrapping: true,
        actions: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            ariaLabel: closeAriaLabel,
            className: (0, $914111a054c2e0da$export$2e2bcd8739ae039)["dismiss-control"],
            variant: "modal-dismiss",
            iconName: "close",
            formAction: "none",
            onClick: onCloseButtonClick
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: headerId,
        className: (0, $914111a054c2e0da$export$2e2bcd8739ae039)["header--text"]
    }, header))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $914111a054c2e0da$export$2e2bcd8739ae039).content, {
            [(0, $914111a054c2e0da$export$2e2bcd8739ae039)["no-paddings"]]: disableContentPaddings
        })
    }, children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: stickySentinelRef
    })), footer && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: footerRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $914111a054c2e0da$export$2e2bcd8739ae039).footer, footerStuck && (0, $914111a054c2e0da$export$2e2bcd8739ae039)["footer--stuck"])
    }, footer))))))));
}



function $104eee66f5fcddce$export$2e2bcd8739ae039(_a) {
    var { size: size = "medium" } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "size"
    ]);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Modal", {
        props: {
            size: size,
            disableContentPaddings: props.disableContentPaddings
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a5bb8d240e2baab$export$2e2bcd8739ae039), Object.assign({
        size: size
    }, props, baseComponentProps));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($104eee66f5fcddce$export$2e2bcd8739ae039, "Modal");



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


const $fe9e7bfbce151564$var$AuthContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
let $fe9e7bfbce151564$var$accessToken = "";
let $fe9e7bfbce151564$var$refreshToken = "";
const $fe9e7bfbce151564$export$87091915187a1a85 = ({ children: children })=>{
    const [lastRefreshDate, setLastRefreshDate] = (0, $acw62.useState)(new Date());
    const [user, setUser] = (0, $acw62.useState)(null);
    const [isReady, setIsReady] = (0, $acw62.useState)(false);
    const [isAuthenticated, setIsAuthenticated] = (0, $acw62.useState)(false);
    const { appName: appName, appVersion: appVersion, isReady: mainAppIsReady, showComponent: showComponent } = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    //const navigate = useNavigate();
    const getName = (name)=>{
        return appName + "_" + name;
    };
    (0, $acw62.useEffect)(()=>{
        if (mainAppIsReady === true) initializeAuth();
    }, [
        mainAppIsReady
    ]);
    const getAccessToken = ()=>{
        return $fe9e7bfbce151564$var$accessToken;
    };
    const getRefreshToken = ()=>{
        return $fe9e7bfbce151564$var$refreshToken;
    };
    const performTokenRefresh = async ()=>{
        // const data = new FormData();
        // data.append("grant_type", "refresh_token");
        // data.append("refresh_token", refreshToken);
        // data.append("client_id", appName);
        const data = new URLSearchParams();
        data.append("grant_type", "refresh_token");
        data.append("refresh_token", $fe9e7bfbce151564$var$refreshToken);
        data.append("client_id", appName);
        const urlToCall = `${(0, $d8475b95fcbdc3b7$export$923ea8233b386e99)}token?v=${appVersion}`;
        // make API call
        try {
            const fetchOptions = {
                method: "POST"
            };
            fetchOptions.body = data;
            const loginResponse = await fetch(urlToCall, fetchOptions);
            if (loginResponse.ok === true) {
                const json = await loginResponse.json();
                $fe9e7bfbce151564$var$accessToken = json.access_token;
                $fe9e7bfbce151564$var$refreshToken = json.refresh_token;
                setLastRefreshDate(new Date());
                localStorage.setItem(getName("accessToken"), json.access_token);
                localStorage.setItem(getName("refreshToken"), json.refresh_token);
                localStorage.setItem(getName("lastRefreshDate"), JSON.stringify(new Date()));
                setIsAuthenticated(true);
                return Promise.resolve();
            }
            return Promise.reject("could not update refresh token");
        } catch (err) {
            console.error(err);
        }
    };
    const validateRefreshToken = async ()=>{
        // check when last the refresh token was obtained
        const refreshDate = localStorage.getItem(getName("lastRefreshDate"));
        let lastRefreshDateString = refreshDate || "";
        if (lastRefreshDateString == null || lastRefreshDateString.length == 0) // this defaults it to right now, so it won't try and refresh the token
        // The next API call will fail with 401 and force the login dialog
        lastRefreshDateString = JSON.stringify(new Date());
        const savedLastRefreshDate = new Date(JSON.parse(lastRefreshDateString));
        setLastRefreshDate(savedLastRefreshDate);
        // see if refresh token needs to be refreshed again
        var today = new Date();
        if (savedLastRefreshDate.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0)) {
            try {
                await performTokenRefresh();
            } catch (err) {
                console.log("error performing token refresh");
                console.log(err);
            }
            setIsReady(true);
            onReadyFunction();
        } else {
            setIsReady(true);
            onReadyFunction();
        }
    };
    const initializeAuth = async ()=>{
        // get auth tokens from local storage
        $fe9e7bfbce151564$var$accessToken = localStorage.getItem(getName("accessToken"));
        $fe9e7bfbce151564$var$refreshToken = localStorage.getItem(getName("refreshToken"));
        //validateRefreshToken();
        await onReadyFunction();
        setIsReady(true);
    };
    const performLogin = async (username, password)=>{
        const data = new URLSearchParams();
        data.append("grant_type", "password");
        data.append("username", username);
        data.append("password", password);
        data.append("client_id", appName);
        const urlToCall = `${(0, $d8475b95fcbdc3b7$export$923ea8233b386e99)}token?v=${appVersion}`;
        // make API call
        try {
            const fetchOptions = {
                method: "POST"
            };
            fetchOptions.body = data;
            const loginResponse = await fetch(urlToCall, fetchOptions);
            if (loginResponse.ok === true) {
                const json = await loginResponse.json();
                localStorage.setItem(getName("accessToken"), json.access_token);
                localStorage.setItem(getName("refreshToken"), json.refresh_token);
                localStorage.setItem(getName("lastRefreshDate"), JSON.stringify(new Date()));
                setTimeout(()=>{
                    window.location.reload();
                }, 10); // make sure this happens after navigate !?!
                //navigate("/");
                showComponent({
                    menu: null,
                    type: "home"
                });
                return;
            }
            const responseText = await loginResponse.text();
            return Promise.reject(responseText);
        } catch (err) {
            console.log(err);
        }
    };
    const resetPassword = async (username)=>{
        const urlToCall = `${(0, $d8475b95fcbdc3b7$export$923ea8233b386e99)}menu/RequestPasswordReset?v=${appVersion}`;
        // make API call
        try {
            const fetchOptions = {
                method: "POST",
                body: JSON.stringify({
                    usernameOrEmail: username
                })
            };
            const apiResponse = await fetch(urlToCall, fetchOptions);
            if (apiResponse.ok === true) return await apiResponse.text();
            const responseText = await apiResponse.text();
            return Promise.reject(responseText);
        } catch (err) {
            console.log(err);
        }
    };
    const doLogin = async (username, password)=>{
        await performLogin(username, password);
    };
    const logout = ()=>{
        localStorage.removeItem(getName("accessToken"));
        localStorage.removeItem(getName("refreshToken"));
        localStorage.removeItem(getName("lastRefreshDate"));
        setIsAuthenticated(false);
        //navigate("/login");
        showComponent({
            menu: null,
            type: "login"
        });
    };
    async function onReadyFunction(allow401 = true) {
        // call initialize (basically checks if user is authenticated, and returns user name and id)
        if (window.location.search.includes("anonAction")) return;
        // make API call
        try {
            const fetchOptions = {
                method: "GET",
                headers: {
                    Authorization: "Bearer " + $fe9e7bfbce151564$var$accessToken
                }
            };
            const urlToCall = `${(0, $d8475b95fcbdc3b7$export$923ea8233b386e99)}initialize?v=${appVersion}`;
            const apiResponse = await fetch(urlToCall, fetchOptions);
            if (apiResponse.ok === true) {
                const json = await apiResponse.json();
                const userInfo = json;
                setUser(userInfo);
                setIsAuthenticated(true);
            } else if (apiResponse.status == 401) {
                if (allow401) {
                    await performTokenRefresh();
                    await onReadyFunction(false);
                } else //navigate("/login");
                showComponent({
                    menu: null,
                    type: "login"
                });
            }
        //return Promise.reject(responseText);
        } catch (err) {
            console.log("caught error trying to initialize");
            console.log(err);
            //navigate("/login");
            showComponent({
                menu: null,
                type: "login"
            });
        }
    }
    const value = {
        getAccessToken: getAccessToken,
        performTokenRefresh: performTokenRefresh,
        isReady: isReady,
        doLogin: doLogin,
        logout: logout,
        isAuthenticated: isAuthenticated,
        setIsAuthenticated: setIsAuthenticated,
        resetPassword: resetPassword,
        user: user
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fe9e7bfbce151564$var$AuthContext.Provider, {
        value: value,
        children: children
    });
};
const $fe9e7bfbce151564$export$1d39dc5b47e56ff0 = ()=>{
    const context = (0, $acw62.useContext)($fe9e7bfbce151564$var$AuthContext);
    if (!context) throw new Error("useAuth must be used within an AuthProvider");
    return context;
};


function $9004343119f79a76$var$validateField(field, value) {
    switch(field){
        case "username":
            return value ? null : "Username is required";
        default:
            return null;
    }
}
function $9004343119f79a76$var$validateFormData(data) {
    const fields = Object.keys(data);
    const errors = fields.reduce((errors, field)=>{
        const error = $9004343119f79a76$var$validateField(field, data[field]);
        if (error) errors[field] = error;
        return errors;
    }, {});
    return Object.keys(errors).length > 0 ? errors : undefined;
}
const $9004343119f79a76$var$initialValues = {
    username: ""
};
const $9004343119f79a76$export$b597ee422a3143dc = ({ visible: visible = false, onDismiss: onDismiss })=>{
    const [values, setValues] = (0, $acw62.useState)($9004343119f79a76$var$initialValues);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [errors, setErrors] = (0, $acw62.useState)({});
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    const [successMessage, setSuccessMessage] = (0, $acw62.useState)("");
    const auth = (0, $fe9e7bfbce151564$export$1d39dc5b47e56ff0)();
    const onChange = (field, value)=>{
        console.log("on change");
        setValues((prevValues)=>({
                ...prevValues,
                [field]: value
            }));
        const error = $9004343119f79a76$var$validateField(field, value);
        setErrors((prevErrors)=>({
                ...prevErrors,
                [field]: error
            }));
    };
    const submitForm = async ()=>{
        const errors = $9004343119f79a76$var$validateFormData(values);
        if (errors) setErrors(errors);
        else {
            // todo
            setLoading(true);
            const result = await auth.resetPassword(values.username);
            if (result.includes("No user")) setErrorMessage(result);
            else setSuccessMessage(result);
            setLoading(false);
        }
    };
    const dismissAndClear = ()=>{
        setErrorMessage("");
        setSuccessMessage("");
        setValues($9004343119f79a76$var$initialValues);
        onDismiss();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $104eee66f5fcddce$export$2e2bcd8739ae039), {
        header: "Forgot password",
        visible: visible,
        onDismiss: dismissAndClear,
        footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
            float: "left",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                direction: "horizontal",
                size: "xs",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
                        variant: "primary",
                        onClick: submitForm,
                        loading: loading,
                        loadingText: "Resetting password",
                        children: "Reset Password"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
                        variant: "link",
                        onClick: dismissAndClear,
                        children: "Cancel"
                    })
                ]
            })
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
            direction: "vertical",
            size: "l",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d07d035b542ec3e4$export$2e2bcd8739ae039), {
                    label: "Username",
                    errorText: errors?.username,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc0ce5a84f6f2813$export$2e2bcd8739ae039), {
                        onChange: ({ detail: { value: value } })=>onChange("username", value),
                        placeholder: "Enter username",
                        value: values.username
                    })
                }),
                errorMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a8b0110371552e0$export$2e2bcd8739ae039), {
                    statusIconAriaLabel: "Error",
                    type: "error",
                    header: `Error resetting password`,
                    dismissible: true,
                    onDismiss: ()=>setErrorMessage(""),
                    children: errorMessage
                }, "alert-item") : null,
                successMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a8b0110371552e0$export$2e2bcd8739ae039), {
                    statusIconAriaLabel: "Success",
                    type: "success",
                    header: `Success`,
                    dismissible: true,
                    onDismiss: ()=>setSuccessMessage(""),
                    children: successMessage
                }, "alert-item") : null
            ]
        })
    });
};




function $bed6b8339cc09029$var$validateField(field, value) {
    switch(field){
        case "username":
            return value ? null : "Username is required";
        case "password":
            return value ? null : "Password is required";
        default:
            return null;
    }
}
function $bed6b8339cc09029$var$validateFormData(data) {
    const fields = Object.keys(data);
    const errors = fields.reduce((errors, field)=>{
        const error = $bed6b8339cc09029$var$validateField(field, data[field]);
        if (error) errors[field] = error;
        return errors;
    }, {});
    return Object.keys(errors).length > 0 ? errors : undefined;
}
const $bed6b8339cc09029$export$21a94553ffa41578 = ()=>{
    const [values, setValues] = (0, $acw62.useState)({
        username: "",
        password: ""
    });
    const [errors, setErrors] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    const [showForgotPassword, setShowForgotPassword] = (0, $acw62.useState)(false);
    const auth = (0, $fe9e7bfbce151564$export$1d39dc5b47e56ff0)();
    const { showComponent: showComponent } = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    (0, $acw62.useEffect)(()=>{
        if (auth.isAuthenticated == true) showComponent({
            menu: null,
            type: "home"
        });
    }, [
        auth.isAuthenticated
    ]);
    const onChange = (field, value)=>{
        setValues((prevValues)=>({
                ...prevValues,
                [field]: value
            }));
        const error = $bed6b8339cc09029$var$validateField(field, value);
        setErrors((prevErrors)=>({
                ...prevErrors,
                [field]: error
            }));
    };
    const submitForm = async (e)=>{
        e.preventDefault();
        const errors = $bed6b8339cc09029$var$validateFormData(values);
        if (errors) setErrors(errors);
        else {
            setLoading(true);
            try {
                await auth.doLogin(values.username, values.password);
            } catch (err) {
                setErrorMessage(err);
            } finally{
                setLoading(false);
            }
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c3c7a1fd2ca4107$export$2e2bcd8739ae039), {
        header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
            size: "m",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $417cbce8ab3dcc04$export$2e2bcd8739ae039), {
                variant: "h1"
            })
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9004343119f79a76$export$b597ee422a3143dc), {
                    visible: showForgotPassword,
                    onDismiss: ()=>setShowForgotPassword(false)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60822fbe2c08caa5$export$2e2bcd8739ae039), {
                    header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $417cbce8ab3dcc04$export$2e2bcd8739ae039), {
                        variant: "h2",
                        children: "Login"
                    }),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                        onSubmit: submitForm,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3128a80b6a88093c$export$2e2bcd8739ae039), {
                            variant: "embedded",
                            actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                                alignItems: "center",
                                direction: "horizontal",
                                size: "xs",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    loading: loading,
                                    children: "Login"
                                })
                            }),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                                direction: "vertical",
                                size: "l",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d07d035b542ec3e4$export$2e2bcd8739ae039), {
                                        label: "Username",
                                        errorText: errors?.username,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc0ce5a84f6f2813$export$2e2bcd8739ae039), {
                                            onChange: ({ detail: { value: value } })=>onChange("username", value),
                                            placeholder: "Enter username",
                                            value: values.username
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d07d035b542ec3e4$export$2e2bcd8739ae039), {
                                        label: "Password",
                                        errorText: errors?.password,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc0ce5a84f6f2813$export$2e2bcd8739ae039), {
                                            type: "password",
                                            onChange: ({ detail: { value: value } })=>onChange("password", value),
                                            placeholder: "Enter password",
                                            value: values.password
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d07d035b542ec3e4$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3baf384ab7fe8d32$export$2e2bcd8739ae039), {
                                            onFollow: ()=>setShowForgotPassword(true),
                                            children: "Forgot password?"
                                        })
                                    }),
                                    errorMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a8b0110371552e0$export$2e2bcd8739ae039), {
                                        statusIconAriaLabel: "Error",
                                        type: "error",
                                        header: `Unable to login`,
                                        dismissible: true,
                                        onDismiss: ()=>setErrorMessage(""),
                                        children: errorMessage
                                    }, "alert-item") : null
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


var $1e6aa07928915cff$export$2e2bcd8739ae039 = {
    "content": "awsui_content_1wepg_s8qpr_97",
    "description": "awsui_description_1wepg_s8qpr_98",
    "label": "awsui_label_1wepg_s8qpr_99",
    "outline": "awsui_outline_1wepg_s8qpr_107",
    "show-outline": "awsui_show-outline_1wepg_s8qpr_110",
    "native-input": "awsui_native-input_1wepg_s8qpr_114",
    "wrapper": "awsui_wrapper_1wepg_s8qpr_118",
    "label-wrapper": "awsui_label-wrapper_1wepg_s8qpr_124",
    "empty-content": "awsui_empty-content_1wepg_s8qpr_135",
    "description-bottom-padding": "awsui_description-bottom-padding_1wepg_s8qpr_145",
    "label-disabled": "awsui_label-disabled_1wepg_s8qpr_153",
    "description-disabled": "awsui_description-disabled_1wepg_s8qpr_154",
    "control": "awsui_control_1wepg_s8qpr_158"
};



function $f9358073d64ebb29$var$joinString(values) {
    return values.filter((value)=>!!value).join(" ");
}
function $f9358073d64ebb29$export$2e2bcd8739ae039(_a) {
    var { controlId: controlId, controlClassName: controlClassName, outlineClassName: outlineClassName, showOutline: showOutline, disabled: disabled, readOnly: readOnly, nativeControl: nativeControl, styledControl: styledControl, label: label, description: description, descriptionBottomPadding: descriptionBottomPadding, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, ariaControls: ariaControls, onClick: onClick, __internalRootRef: __internalRootRef } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "controlId",
        "controlClassName",
        "outlineClassName",
        "showOutline",
        "disabled",
        "readOnly",
        "nativeControl",
        "styledControl",
        "label",
        "description",
        "descriptionBottomPadding",
        "ariaLabel",
        "ariaLabelledby",
        "ariaDescribedby",
        "ariaControls",
        "onClick",
        "__internalRootRef"
    ]);
    const uniqueId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)();
    const id = controlId || uniqueId;
    const labelId = `${id}-label`;
    const descriptionId = `${id}-description`;
    const ariaLabelledByIds = [];
    if (label && !ariaLabel) ariaLabelledByIds.push(labelId);
    if (ariaLabelledby) ariaLabelledByIds.push(ariaLabelledby);
    const ariaDescriptions = [];
    if (ariaDescribedby) ariaDescriptions.push(ariaDescribedby);
    if (description) ariaDescriptions.push(descriptionId);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, rest, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e6aa07928915cff$export$2e2bcd8739ae039).wrapper, rest.className),
        ref: __internalRootRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $1e6aa07928915cff$export$2e2bcd8739ae039)["label-wrapper"],
        "aria-disabled": disabled ? "true" : undefined,
        onClick: disabled || readOnly ? undefined : onClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e6aa07928915cff$export$2e2bcd8739ae039).control, controlClassName)
    }, styledControl, nativeControl({
        id: id,
        disabled: disabled,
        className: (0, $1e6aa07928915cff$export$2e2bcd8739ae039)["native-input"],
        "aria-describedby": ariaDescriptions.length ? $f9358073d64ebb29$var$joinString(ariaDescriptions) : undefined,
        "aria-labelledby": ariaLabelledByIds.length ? $f9358073d64ebb29$var$joinString(ariaLabelledByIds) : undefined,
        "aria-label": ariaLabel,
        "aria-controls": ariaControls
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e6aa07928915cff$export$2e2bcd8739ae039).outline, outlineClassName, showOutline && (0, $1e6aa07928915cff$export$2e2bcd8739ae039)["show-outline"])
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e6aa07928915cff$export$2e2bcd8739ae039).content, !label && !description && (0, $1e6aa07928915cff$export$2e2bcd8739ae039)["empty-content"])
    }, label && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: labelId,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e6aa07928915cff$export$2e2bcd8739ae039).label, {
            [(0, $1e6aa07928915cff$export$2e2bcd8739ae039)["label-disabled"]]: disabled
        })
    }, label), description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: descriptionId,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $1e6aa07928915cff$export$2e2bcd8739ae039).description, {
            [(0, $1e6aa07928915cff$export$2e2bcd8739ae039)["description-disabled"]]: disabled,
            [(0, $1e6aa07928915cff$export$2e2bcd8739ae039)["description-bottom-padding"]]: descriptionBottomPadding
        })
    }, description))));
}



var $0fe4000c413c450b$export$2e2bcd8739ae039 = {
    "root": "awsui_root_k2y2q_1wk1c_97",
    "checkbox-control": "awsui_checkbox-control_k2y2q_1wk1c_133",
    "outline": "awsui_outline_k2y2q_1wk1c_141"
};





var $acw62 = parcelRequire("acw62");



var $7e68b67ced01b463$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1fn7j_1yjhw_97",
    "styled-box": "awsui_styled-box_1fn7j_1yjhw_104",
    "styled-box-checked": "awsui_styled-box-checked_1fn7j_1yjhw_110",
    "styled-box-indeterminate": "awsui_styled-box-indeterminate_1fn7j_1yjhw_110",
    "styled-box-disabled": "awsui_styled-box-disabled_1fn7j_1yjhw_114",
    "styled-box-readonly": "awsui_styled-box-readonly_1fn7j_1yjhw_114",
    "styled-line": "awsui_styled-line_1fn7j_1yjhw_128",
    "styled-line-disabled": "awsui_styled-line-disabled_1fn7j_1yjhw_133",
    "styled-line-readonly": "awsui_styled-line-readonly_1fn7j_1yjhw_136"
};


const $c90f2424593277d9$export$947b27ffce1cc2a2 = {
    default: {
        viewBox: "0 0 14 14",
        indeterminate: "2.5,7 11.5,7",
        checked: "2.5,7 6,10 11,3",
        xy: 0.5,
        r: 1.5,
        size: 13
    },
    refresh: {
        viewBox: "0 0 16 16",
        indeterminate: "3.5,8 12.5,8",
        checked: "3.5,8 7,11 12,4",
        xy: 1,
        r: 2,
        size: 14
    }
};
const $c90f2424593277d9$var$CheckboxIcon = (_a)=>{
    var { checked: checked, indeterminate: indeterminate, disabled: disabled = false, readOnly: readOnly = false } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "checked",
        "indeterminate",
        "disabled",
        "readOnly"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const theme = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)() ? "refresh" : "default";
    const dimensions = $c90f2424593277d9$export$947b27ffce1cc2a2[theme];
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", Object.assign({
        className: (0, $7e68b67ced01b463$export$2e2bcd8739ae039).root,
        viewBox: dimensions.viewBox,
        "aria-hidden": "true",
        focusable: "false"
    }, baseProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7e68b67ced01b463$export$2e2bcd8739ae039)["styled-box"], {
            [(0, $7e68b67ced01b463$export$2e2bcd8739ae039)["styled-box-checked"]]: checked,
            [(0, $7e68b67ced01b463$export$2e2bcd8739ae039)["styled-box-indeterminate"]]: indeterminate,
            [(0, $7e68b67ced01b463$export$2e2bcd8739ae039)["styled-box-disabled"]]: disabled,
            [(0, $7e68b67ced01b463$export$2e2bcd8739ae039)["styled-box-readonly"]]: readOnly
        }),
        x: dimensions.xy,
        y: dimensions.xy,
        rx: dimensions.r,
        ry: dimensions.r,
        width: dimensions.size,
        height: dimensions.size
    }), checked || indeterminate ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7e68b67ced01b463$export$2e2bcd8739ae039)["styled-line"], {
            [(0, $7e68b67ced01b463$export$2e2bcd8739ae039)["styled-line-disabled"]]: disabled,
            [(0, $7e68b67ced01b463$export$2e2bcd8739ae039)["styled-line-readonly"]]: readOnly
        }),
        points: indeterminate ? dimensions.indeterminate : dimensions.checked
    }) : null);
};
var $c90f2424593277d9$export$2e2bcd8739ae039 = $c90f2424593277d9$var$CheckboxIcon;




const $81def5553f1b8381$var$InternalCheckbox = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { controlId: controlId, name: name, checked: checked, disabled: disabled, readOnly: readOnly, ariaRequired: ariaRequired, indeterminate: indeterminate, children: children, description: description, ariaLabel: ariaLabel, onFocus: onFocus, onBlur: onBlur, onChange: onChange, tabIndex: explicitTabIndex, showOutline: showOutline, ariaControls: ariaControls, __internalRootRef: __internalRootRef } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "controlId",
        "name",
        "checked",
        "disabled",
        "readOnly",
        "ariaRequired",
        "indeterminate",
        "children",
        "description",
        "ariaLabel",
        "onFocus",
        "onBlur",
        "onChange",
        "tabIndex",
        "showOutline",
        "ariaControls",
        "__internalRootRef"
    ]);
    const { ariaDescribedby: ariaDescribedby, ariaLabelledby: ariaLabelledby } = (0, $4a30639b463663e4$export$824c400da192ca1b)(rest);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const checkboxRef = (0, $acw62.useRef)(null);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, checkboxRef);
    (0, $acw62.useEffect)(()=>{
        if (checkboxRef.current) checkboxRef.current.indeterminate = Boolean(indeterminate);
    });
    const { tabIndex: tabIndex } = (0, $7f9661e47bcc5460$export$4cf30df7bba16ac9)(checkboxRef, {
        tabIndex: explicitTabIndex
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9358073d64ebb29$export$2e2bcd8739ae039), Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $0fe4000c413c450b$export$2e2bcd8739ae039).root, baseProps.className),
        controlClassName: (0, $0fe4000c413c450b$export$2e2bcd8739ae039)["checkbox-control"],
        outlineClassName: (0, $0fe4000c413c450b$export$2e2bcd8739ae039).outline,
        controlId: controlId,
        disabled: disabled,
        readOnly: readOnly,
        label: children,
        description: description,
        descriptionBottomPadding: true,
        ariaLabel: ariaLabel,
        ariaLabelledby: ariaLabelledby,
        ariaDescribedby: ariaDescribedby,
        ariaControls: ariaControls,
        showOutline: showOutline,
        nativeControl: (nativeControlProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", Object.assign({}, nativeControlProps, {
                ref: checkboxRef,
                type: "checkbox",
                checked: checked,
                name: name,
                "aria-required": ariaRequired ? "true" : undefined,
                "aria-disabled": readOnly && !disabled ? "true" : undefined,
                tabIndex: tabIndex,
                onFocus: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus),
                onBlur: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur),
                // empty handler to suppress React controllability warning
                onChange: ()=>{}
            })),
        onClick: ()=>{
            var _a;
            (_a = checkboxRef.current) === null || _a === void 0 || _a.focus();
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, // for deterministic transitions "indeterminate" -> "checked" -> "unchecked"
            indeterminate ? {
                checked: true,
                indeterminate: false
            } : {
                checked: !checked,
                indeterminate: false
            });
        },
        styledControl: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90f2424593277d9$export$2e2bcd8739ae039), {
            checked: checked,
            indeterminate: indeterminate,
            disabled: disabled,
            readOnly: readOnly
        }),
        __internalRootRef: __internalRootRef
    }));
});
var $81def5553f1b8381$export$2e2bcd8739ae039 = $81def5553f1b8381$var$InternalCheckbox;




const $f975e47fe9face4d$var$Checkbox = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, []);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Checkbox");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81def5553f1b8381$export$2e2bcd8739ae039), Object.assign({}, props, baseComponentProps, {
        ref: ref
    }));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($f975e47fe9face4d$var$Checkbox, "Checkbox");
var $f975e47fe9face4d$export$2e2bcd8739ae039 = $f975e47fe9face4d$var$Checkbox;




var $acw62 = parcelRequire("acw62");

var $e439776d2d025878$export$2e2bcd8739ae039 = {
    "root": "awsui_root_145pa_6roki_97",
    "focus-lock": "awsui_focus-lock_145pa_6roki_132",
    "calendar": "awsui_calendar_145pa_6roki_136",
    "date-picker-container": "awsui_date-picker-container_145pa_6roki_152",
    "date-picker-trigger": "awsui_date-picker-trigger_145pa_6roki_157",
    "date-picker-input": "awsui_date-picker-input_145pa_6roki_161",
    "open-calendar-button": "awsui_open-calendar-button_145pa_6roki_166"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");
function $a874c42e2166676d$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}


function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}


function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $a8211859f65764ad$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}




function $eb237db400049a40$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $a8211859f65764ad$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}



function $9445ecc5e7cfb647$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $c9ad0c9b51445ea3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}



function $8085a298e92e1718$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}



function $09f87854553a6255$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}



var $b10423781dc3537f$export$2e2bcd8739ae039 = {
    "calendar": "awsui_calendar_1ykar_tn512_97",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1ykar_tn512_1",
    "root": "awsui_root_1ykar_tn512_128",
    "calendar-inner": "awsui_calendar-inner_1ykar_tn512_169",
    "calendar-header": "awsui_calendar-header_1ykar_tn512_173",
    "calendar-header-title": "awsui_calendar-header-title_1ykar_tn512_178",
    "calendar-next-btn": "awsui_calendar-next-btn_1ykar_tn512_186",
    "calendar-prev-btn": "awsui_calendar-prev-btn_1ykar_tn512_189",
    "calendar-grid": "awsui_calendar-grid_1ykar_tn512_192",
    "calendar-grid-dense": "awsui_calendar-grid-dense_1ykar_tn512_196",
    "calendar-grid-cell": "awsui_calendar-grid-cell_1ykar_tn512_204",
    "calendar-date-header": "awsui_calendar-date-header_1ykar_tn512_209",
    "calendar-date": "awsui_calendar-date_1ykar_tn512_209",
    "calendar-date-enabled": "awsui_calendar-date-enabled_1ykar_tn512_229",
    "calendar-date-current-page": "awsui_calendar-date-current-page_1ykar_tn512_239",
    "calendar-date-selected": "awsui_calendar-date-selected_1ykar_tn512_250",
    "calendar-date-current": "awsui_calendar-date-current_1ykar_tn512_239",
    "calendar-date-dense": "awsui_calendar-date-dense_1ykar_tn512_271",
    "date-inner": "awsui_date-inner_1ykar_tn512_279",
    "calendar-row": "awsui_calendar-row_1ykar_tn512_354",
    "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_1ykar_tn512_358"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $b70eab54f49c2e79$export$4e2c663d01cf9786({ ariaLabel: ariaLabel, onChange: onChange }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        iconName: "angle-left",
        ariaLabel: ariaLabel,
        variant: "icon",
        onClick: ()=>onChange(-1),
        formAction: "none",
        className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-prev-btn"]
    });
}
function $b70eab54f49c2e79$export$b62bfe3a46d1d8c8({ ariaLabel: ariaLabel, onChange: onChange }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        iconName: "angle-right",
        ariaLabel: ariaLabel,
        variant: "icon",
        onClick: ()=>onChange(1),
        formAction: "none",
        className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-next-btn"]
    });
}


const $c58214b95df0f907$var$CalendarHeader = ({ formattedDate: formattedDate, onChange: onChange, previousLabel: previousLabel, nextLabel: nextLabel, headingId: headingId })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-header"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b70eab54f49c2e79$export$4e2c663d01cf9786), {
        ariaLabel: previousLabel,
        onChange: onChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", {
        className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-header-title"],
        id: headingId
    }, formattedDate), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b70eab54f49c2e79$export$b62bfe3a46d1d8c8), {
        ariaLabel: nextLabel,
        onChange: onChange
    }));
};
var $c58214b95df0f907$export$2e2bcd8739ae039 = $c58214b95df0f907$var$CalendarHeader;




var $acw62 = parcelRequire("acw62");








const $b0a3f0e4ff8ed2c9$var$GridCell = (0, $acw62.forwardRef)((props, focusedDateRef)=>{
    const { disabledReason: disabledReason } = props, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "disabledReason"
    ]);
    const isDisabledWithReason = !!disabledReason;
    const { targetProps: targetProps, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(disabledReason);
    const ref = (0, $acw62.useRef)(null);
    const [showTooltip, setShowTooltip] = (0, $acw62.useState)(false);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", Object.assign({
        ref: (0, $adb603d9351d0211$export$74665b213cb5c4cf)(focusedDateRef, ref)
    }, isDisabledWithReason ? targetProps : {}, rest, {
        onFocus: ()=>isDisabledWithReason ? setShowTooltip(true) : undefined,
        onBlur: ()=>isDisabledWithReason ? setShowTooltip(false) : undefined,
        onMouseEnter: ()=>isDisabledWithReason ? setShowTooltip(true) : undefined,
        onMouseLeave: ()=>isDisabledWithReason ? setShowTooltip(false) : undefined
    }), props.children, isDisabledWithReason && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, descriptionEl, showTooltip && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $76f4c84fd1bac364$export$2e2bcd8739ae039), {
        className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)["disabled-reason-tooltip"],
        trackRef: ref,
        value: disabledReason
    })));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($b0a3f0e4ff8ed2c9$var$GridCell, "GridCell");
function $b0a3f0e4ff8ed2c9$export$2e2bcd8739ae039({ isDateEnabled: isDateEnabled, dateDisabledReason: dateDisabledReason, focusedDate: focusedDate, focusableDate: focusableDate, onSelectDate: onSelectDate, selectedDate: selectedDate, ariaLabelledby: ariaLabelledby, header: header, rows: rows, isCurrentPage: isCurrentPage, renderDate: renderDate, renderDateAnnouncement: renderDateAnnouncement, isSameDate: isSameDate, onGridKeyDownHandler: onGridKeyDownHandler }) {
    const focusedDateRef = (0, $acw62.useRef)(null);
    // The focused date changes as a feedback to keyboard navigation in the grid.
    // Once changed, the corresponding date button needs to receive the actual focus.
    (0, $134bbee1801695be$export$21dfe79102a9caab)(()=>{
        if (focusedDate && focusedDateRef.current) focusedDateRef.current.focus();
    }, [
        focusedDate
    ]);
    const rowLength = rows[0].length;
    const denseGrid = rowLength > 3;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        role: "grid",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-grid"], denseGrid && (0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-grid-dense"]),
        "aria-labelledby": ariaLabelledby
    }, header, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", {
        onKeyDown: onGridKeyDownHandler
    }, rows.map((row, rowIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: rowIndex,
            className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-row"]
        }, row.map((date, dateIndex)=>{
            const isFocusable = !!focusableDate && isSameDate(date, focusableDate);
            const isSelected = !!selectedDate && isSameDate(date, selectedDate);
            const isEnabled = !isDateEnabled || isDateEnabled(date);
            const disabledReason = dateDisabledReason(date);
            const isDisabledWithReason = !isEnabled && !!disabledReason;
            const isCurrentDate = isSameDate(date, new Date());
            // Can't be focused.
            let tabIndex = undefined;
            if (isFocusable && (isEnabled || isDisabledWithReason)) // Next focus target.
            tabIndex = 0;
            else if (isEnabled || isDisabledWithReason) // Can be focused programmatically.
            tabIndex = -1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b0a3f0e4ff8ed2c9$var$GridCell, {
                key: `${rowIndex}:${dateIndex}`,
                ref: tabIndex === 0 ? focusedDateRef : undefined,
                tabIndex: tabIndex,
                "aria-current": isCurrentDate ? "date" : undefined,
                "aria-selected": isEnabled ? isSelected : undefined,
                "aria-disabled": !isEnabled,
                // Do not attach click event when the date is disabled, otherwise VO+safari announces clickable
                onClick: isEnabled ? ()=>onSelectDate(date) : undefined,
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-grid-cell"], (0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-date"], {
                    [(0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-date-current-page"]]: isCurrentPage(date),
                    [(0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-date-enabled"]]: isEnabled,
                    [(0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-date-selected"]]: isSelected,
                    [(0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-date-current"]]: isCurrentDate,
                    [(0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-date-dense"]]: denseGrid
                }),
                disabledReason: isDisabledWithReason ? disabledReason : undefined
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)["date-inner"],
                "aria-hidden": "true"
            }, renderDate(date)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b8469ab82402f2dd$export$2e2bcd8739ae039), null, renderDateAnnouncement(date, isCurrentDate)));
        })))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $1a5a86f8a8149138$export$f0064b1835777f8e(locale, fullLocale) {
    const isShort = locale.length === 2;
    if (isShort && fullLocale.indexOf(locale) === 0) return fullLocale;
    return locale;
}


function $d3f825eb41b88093$export$dca0327c9b9c6498(component, locale) {
    var _a;
    locale = $d3f825eb41b88093$var$checkLocale(component, locale);
    const browserLocale = $d3f825eb41b88093$var$getBrowserLocale();
    if (locale) return (0, $1a5a86f8a8149138$export$f0064b1835777f8e)(locale, browserLocale);
    const htmlLocale = $d3f825eb41b88093$var$checkLocale(component, (_a = $d3f825eb41b88093$var$getHtmlElement()) === null || _a === void 0 ? void 0 : _a.getAttribute("lang"));
    if (htmlLocale) return (0, $1a5a86f8a8149138$export$f0064b1835777f8e)(htmlLocale, browserLocale);
    return browserLocale;
}
function $d3f825eb41b88093$var$checkLocale(component, locale) {
    if (!locale || locale === "") return "";
    // Support underscore-delimited locales
    locale = locale && locale.replace(/^([a-z]{2})_/, "$1-");
    // Check that the value matches aa-BB pattern
    // TODO: support full BCP 47 spec?
    if (locale && !locale.match(/^[a-z]{2}(-[A-Z]{2})?$/)) {
        (0, $dd646455762bc7b9$export$5b28268982f175ba)(component, `Invalid locale provided: ${locale}. Falling back to default`);
        locale = "";
    }
    return locale;
}
function $d3f825eb41b88093$var$getHtmlElement() {
    return typeof document !== "undefined" ? document.querySelector("html") : null;
}
function $d3f825eb41b88093$var$getBrowserLocale() {
    return new Intl.DateTimeFormat().resolvedOptions().locale;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Prefixes given text with zeros until it reaches the target length.
 */ function $338478df0d3aeeab$export$2da9fd1f854a2a4b(text, length) {
    while(text.length < length)text = `0${text}`;
    return text;
}


function $b7857ad8c9833aee$export$3ae94a2503e890a1(value, granularity = "day") {
    const year = value.getFullYear();
    const month = (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(`${value.getMonth() + 1}`, 2);
    if (granularity === "month") return `${year}-${month}`;
    const date = (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(`${value.getDate()}`, 2);
    return `${year}-${month}-${date}`;
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $baa585fc493d6e9d$export$6b862160d295c8e(value, strict = false) {
    const [yearString, monthString, dayString] = value.split("-");
    const year = Number(yearString);
    const month = Number(monthString);
    const day = Number(dayString);
    if (strict) {
        if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
    }
    return new Date(year, (month || 1) - 1, day || 1);
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $6175122c42c548ad$export$2e2bcd8739ae039(componentName, propertyName, propertyValue, handlerName, handlerValue) {
    if (propertyValue !== undefined && handlerValue === undefined && (0, $bf737c197e11d40f$export$df77466336fe5355)) (0, $dd646455762bc7b9$export$5b28268982f175ba)(componentName, `You provided \`${propertyName}\` prop without an \`${handlerName}\` handler. This will render a read-only component. If the component should be mutable, set an \`${handlerName}\` handler.`);
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



function $4f754377033842c6$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}




function $e66021df2494c23e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}




function $8a0cd77776020c49$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}



function $3ff7ac235dc3be01$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $8a0cd77776020c49$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $e66021df2494c23e$export$2e2bcd8739ae039)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $8a0cd77776020c49$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}



function $41c3cc0836893904$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $48a662f07bb27222$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var cleanDate = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


function $6eabafb796ac4871$export$752403752bc16d94(startDate, isDateFocusable) {
    return $6eabafb796ac4871$var$moveDay(startDate, isDateFocusable, 1);
}
function $6eabafb796ac4871$export$20e3431fd4d21d70(startDate, isDateFocusable) {
    return $6eabafb796ac4871$var$moveDay(startDate, isDateFocusable, -1);
}
function $6eabafb796ac4871$export$12e8132dee1e1cb5(startDate, isDateFocusable) {
    return $6eabafb796ac4871$var$moveDay(startDate, isDateFocusable, 7);
}
function $6eabafb796ac4871$export$d83a6ab9969f2147(startDate, isDateFocusable) {
    return $6eabafb796ac4871$var$moveDay(startDate, isDateFocusable, -7);
}
function $6eabafb796ac4871$export$b3c242a863a88095(startDate, isDateFocusable) {
    return $6eabafb796ac4871$var$moveMonth(startDate, isDateFocusable, 1);
}
function $6eabafb796ac4871$export$2940ccdf63d4cab1(startDate, isDateFocusable) {
    return $6eabafb796ac4871$var$moveMonth(startDate, isDateFocusable, -1);
}
function $6eabafb796ac4871$export$1f32bc6c1f421808(startDate, isDateFocusable) {
    return $6eabafb796ac4871$var$moveMonth(startDate, isDateFocusable, 3);
}
function $6eabafb796ac4871$export$10ac36d8097361a0(startDate, isDateFocusable) {
    return $6eabafb796ac4871$var$moveMonth(startDate, isDateFocusable, -3);
}
function $6eabafb796ac4871$export$1fa92dcbdf32fb44(date, isDateFocusable) {
    return $6eabafb796ac4871$var$getBaseDate({
        date: date,
        isDateFocusable: isDateFocusable,
        granularity: "day"
    });
}
function $6eabafb796ac4871$export$126ba571a8444064(date, isDateFocusable) {
    return $6eabafb796ac4871$var$getBaseDate({
        date: date,
        isDateFocusable: isDateFocusable,
        granularity: "month"
    });
}
function $6eabafb796ac4871$var$getBaseDate({ date: date, granularity: granularity, isDateFocusable: isDateFocusable }) {
    const isMonthGranularity = granularity === "month";
    const getStartDate = isMonthGranularity ? (0, $48a662f07bb27222$export$2e2bcd8739ae039) : (0, $41c3cc0836893904$export$2e2bcd8739ae039);
    const moveDate = isMonthGranularity ? $6eabafb796ac4871$var$moveMonth : $6eabafb796ac4871$var$moveDay;
    const isSamePage = isMonthGranularity ? (0, $09f87854553a6255$export$2e2bcd8739ae039) : (0, $8085a298e92e1718$export$2e2bcd8739ae039);
    const startDate = getStartDate(date);
    if (isDateFocusable(startDate)) return startDate;
    const firstEnabledDate = moveDate(startDate, isDateFocusable, 1);
    return isSamePage(startDate, firstEnabledDate) ? firstEnabledDate : startDate;
}
// Iterates days forwards or backwards until the next active day is found.
// If there is no active day in a year range, the start day is returned.
function $6eabafb796ac4871$var$moveDay(startDate, isDateFocusable, step) {
    return $6eabafb796ac4871$var$moveDate({
        startDate: startDate,
        granularity: "day",
        isDateFocusable: isDateFocusable,
        step: step
    });
}
// Iterates months forwards or backwards until the next active month is found.
// If there is no active month in a 10 year range, the start month is returned.
function $6eabafb796ac4871$var$moveMonth(startDate, isDateFocusable, step) {
    return $6eabafb796ac4871$var$moveDate({
        startDate: startDate,
        granularity: "month",
        isDateFocusable: isDateFocusable,
        step: step
    });
}
function $6eabafb796ac4871$var$moveDate({ startDate: startDate, granularity: granularity, isDateFocusable: isDateFocusable, step: step }) {
    const isMonthGranularity = granularity === "month";
    const addSteps = isMonthGranularity ? (0, $a8211859f65764ad$export$2e2bcd8739ae039) : (0, $4f754377033842c6$export$2e2bcd8739ae039);
    const limitYears = isMonthGranularity ? 1 : 10;
    let current = addSteps(startDate, step);
    while(!isDateFocusable(current)){
        if (Math.abs((0, $3ff7ac235dc3be01$export$2e2bcd8739ae039)(startDate, current)) > limitYears) return startDate;
        current = addSteps(current, step);
    }
    return current;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $341652d1a063d149$export$56ec8876a3c0f013() {
    const cacheRef = (0, $acw62.useRef)(new Map());
    return (date)=>{
        const current = cacheRef.current.get(date.getTime());
        if (current) return current;
        cacheRef.current.set(date.getTime(), date);
        return date;
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $a12d66404868ccd6$var$setDayIndex(date, dayIndex) {
    const diff = dayIndex - date.getDay();
    date.setDate(date.getDate() + diff);
}
function $a12d66404868ccd6$export$3383afc3cadfb678(locale, dayIndex, mode) {
    const tempDate = new Date();
    $a12d66404868ccd6$var$setDayIndex(tempDate, dayIndex);
    return tempDate.toLocaleDateString(locale, {
        weekday: mode
    });
}
function $a12d66404868ccd6$export$ac27097ce4a1899f(locale, baseDate) {
    const result = baseDate.toLocaleDateString(locale, {
        year: "numeric",
        month: "long"
    });
    return result;
}
function $a12d66404868ccd6$export$64ba10e8616b702f(locale, date) {
    return date.toLocaleDateString(locale, {
        year: "numeric"
    });
}
const $a12d66404868ccd6$var$dayLabelCache = new Map();
function $a12d66404868ccd6$export$51d68b748655e933(locale, date, mode = "full") {
    const cacheKey = locale + date.getTime() + mode;
    const cachedValue = $a12d66404868ccd6$var$dayLabelCache.get(cacheKey);
    if (cachedValue) return cachedValue;
    const value = date.toLocaleDateString(locale, {
        weekday: mode === "full" ? "long" : undefined,
        month: "long",
        day: "numeric",
        year: "numeric"
    });
    $a12d66404868ccd6$var$dayLabelCache.set(cacheKey, value);
    return value;
}
function $a12d66404868ccd6$export$450ec533fd4eb9e4(locale, date, format) {
    let options = {};
    if (format === "hh") options = {
        hour: "2-digit"
    };
    if (format === "hh:mm") options = {
        hour: "2-digit",
        minute: "2-digit"
    };
    const value = date.toLocaleTimeString(locale, options);
    return value;
}


function $0c8f1e892bb01470$export$2e2bcd8739ae039({ granularity: granularity, locale: locale, i18nStrings: i18nStrings, previousMonthAriaLabel: previousMonthAriaLabel, nextMonthAriaLabel: nextMonthAriaLabel, todayAriaLabel: todayAriaLabel }) {
    var _a, _b, _c;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("calendar");
    const isMonthPicker = granularity === "month";
    const previousButtonLabel = isMonthPicker ? i18n("i18nStrings.previousYearAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.previousYearAriaLabel) : i18n("previousMonthAriaLabel", (_a = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.previousMonthAriaLabel) !== null && _a !== void 0 ? _a : previousMonthAriaLabel);
    const nextButtonLabel = isMonthPicker ? i18n("i18nStrings.nextYearAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.nextYearAriaLabel) : i18n("nextMonthAriaLabel", (_b = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.nextMonthAriaLabel) !== null && _b !== void 0 ? _b : nextMonthAriaLabel);
    const currentDateLabel = isMonthPicker ? i18n("i18nStrings.currentMonthAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.currentMonthAriaLabel) : i18n("todayAriaLabel", (_c = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.todayAriaLabel) !== null && _c !== void 0 ? _c : todayAriaLabel);
    const renderDate = (date)=>isMonthPicker ? date.toLocaleString(locale, {
            month: "short"
        }) : date.getDate().toString();
    const renderDateAnnouncement = (date, isCurrentDate)=>{
        const formattedDate = isMonthPicker ? (0, $a12d66404868ccd6$export$ac27097ce4a1899f)(locale, date) : (0, $a12d66404868ccd6$export$51d68b748655e933)(locale, date, "short");
        if (isCurrentDate && currentDateLabel) return formattedDate + ". " + currentDateLabel;
        return formattedDate;
    };
    const renderHeaderText = (date)=>isMonthPicker ? date.getFullYear().toString() : (0, $a12d66404868ccd6$export$ac27097ce4a1899f)(locale, date);
    return {
        previousButtonLabel: previousButtonLabel,
        nextButtonLabel: nextButtonLabel,
        renderDate: renderDate,
        renderDateAnnouncement: renderDateAnnouncement,
        renderHeaderText: renderHeaderText
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $ed2afbcacc9e5a85$export$31e6abbf76343621(regionCode, regionDayMap) {
    var code = regionDayMap[typeof regionCode === "string" ? regionCode.toUpperCase() : regionCode];
    return typeof code === "number" ? code : 1;
}
function $ed2afbcacc9e5a85$export$ea33a5988b1820a3(locale, langRegionMap, regionDayMap) {
    if (locale) {
        var data = locale.toLowerCase().split(/[-_]/);
        var language = data[0];
        var country;
        if (data[1] && data[1].length === 4) {
            language += "_" + data[1];
            country = data[2];
        } else country = data[1];
        if (!country) country = langRegionMap[language];
        if (country) return $ed2afbcacc9e5a85$export$31e6abbf76343621(country.match(/^\d+$/) ? Number(country) : country, regionDayMap);
    }
    return 1;
}


var $40d21ee6d3ef8dc5$var$langRegionMap = {
    en: "US",
    zh: "CN",
    zh_hans: "CN",
    hans: "CN",
    wuu: "CN",
    hsn: "CN",
    hak: "CN",
    nan: "CN",
    gan: "CN",
    hi: "IN",
    te: "IN",
    mr: "IN",
    ta: "IN",
    gu: "IN",
    kn: "IN",
    or: "IN",
    ml: "IN",
    pa_guru: "IN",
    bho: "IN",
    awa: "IN",
    as: "IN",
    mwr: "IN",
    mai: "IN",
    mag: "IN",
    bgc: "IN",
    hne: "IN",
    dcc: "IN",
    dz: "BT",
    tn: "BW",
    am: "ET",
    om: "ET",
    quc: "GT",
    id: "ID",
    jv: "ID",
    su: "ID",
    mad: "ID",
    ms_arab: "ID",
    ga: "IE",
    he: "IL",
    jam: "JM",
    ja: "JP",
    km: "KH",
    ko: "KR",
    lo: "LA",
    mh: "MH",
    my: "MM",
    mt: "MT",
    ne: "NP",
    fil: "PH",
    ceb: "PH",
    ilo: "PH",
    ur: "PK",
    pa: "PK",
    pa_arab: "PK",
    arab: "PK",
    lah: "PK",
    ps: "PK",
    sd: "PK",
    sd_arab: "PK",
    skr: "PK",
    gn: "PY",
    th: "TH",
    tts: "TH",
    aeb: "TN",
    zh_hant: "TW",
    hant: "TW",
    sm: "WS",
    zu: "ZA",
    sn: "ZW",
    arq: "DZ",
    ar: "EG",
    arz: "EG",
    fa: "IR",
    az_arab: "IR",
    ary: "MA",
    bn: "BD",
    rkt: "BD",
    dv: "MV"
};
var $40d21ee6d3ef8dc5$export$2e2bcd8739ae039 = $40d21ee6d3ef8dc5$var$langRegionMap;


var $3f551231987c5e40$var$regionDayMap = {
    AG: 0,
    ATG: 0,
    28: 0,
    AR: 0,
    ARG: 0,
    32: 0,
    AS: 0,
    ASM: 0,
    16: 0,
    AU: 0,
    AUS: 0,
    36: 0,
    BR: 0,
    BRA: 0,
    76: 0,
    BS: 0,
    BHS: 0,
    44: 0,
    BT: 0,
    BTN: 0,
    64: 0,
    BW: 0,
    BWA: 0,
    72: 0,
    BZ: 0,
    BLZ: 0,
    84: 0,
    CA: 0,
    CAN: 0,
    124: 0,
    CN: 0,
    CHN: 0,
    156: 0,
    CO: 0,
    COL: 0,
    170: 0,
    DM: 0,
    DMA: 0,
    212: 0,
    DO: 0,
    DOM: 0,
    214: 0,
    ET: 0,
    ETH: 0,
    231: 0,
    GT: 0,
    GTM: 0,
    320: 0,
    GU: 0,
    GUM: 0,
    316: 0,
    HK: 0,
    HKG: 0,
    344: 0,
    HN: 0,
    HND: 0,
    340: 0,
    ID: 0,
    IDN: 0,
    360: 0,
    IE: 0,
    IRL: 0,
    372: 0,
    IL: 0,
    ISR: 0,
    376: 0,
    IN: 0,
    IND: 0,
    356: 0,
    JM: 0,
    JAM: 0,
    388: 0,
    JP: 0,
    JPN: 0,
    392: 0,
    KE: 0,
    KEN: 0,
    404: 0,
    KH: 0,
    KHM: 0,
    116: 0,
    KR: 0,
    KOR: 0,
    410: 0,
    LA: 0,
    LA0: 0,
    418: 0,
    MH: 0,
    MHL: 0,
    584: 0,
    MM: 0,
    MMR: 0,
    104: 0,
    MO: 0,
    MAC: 0,
    446: 0,
    MT: 0,
    MLT: 0,
    470: 0,
    MX: 0,
    MEX: 0,
    484: 0,
    MZ: 0,
    MOZ: 0,
    508: 0,
    NI: 0,
    NIC: 0,
    558: 0,
    NP: 0,
    NPL: 0,
    524: 0,
    NZ: 0,
    NZL: 0,
    554: 0,
    PA: 0,
    PAN: 0,
    591: 0,
    PE: 0,
    PER: 0,
    604: 0,
    PH: 0,
    PHL: 0,
    608: 0,
    PK: 0,
    PAK: 0,
    586: 0,
    PR: 0,
    PRI: 0,
    630: 0,
    PY: 0,
    PRY: 0,
    600: 0,
    SA: 0,
    SAU: 0,
    682: 0,
    SG: 0,
    SGP: 0,
    702: 0,
    SV: 0,
    SLV: 0,
    222: 0,
    TH: 0,
    THA: 0,
    764: 0,
    TN: 0,
    TUN: 0,
    788: 0,
    TT: 0,
    TTO: 0,
    780: 0,
    TW: 0,
    TWN: 0,
    158: 0,
    UM: 0,
    UMI: 0,
    581: 0,
    US: 0,
    USA: 0,
    840: 0,
    VE: 0,
    VEN: 0,
    862: 0,
    VI: 0,
    VIR: 0,
    850: 0,
    WS: 0,
    WSM: 0,
    882: 0,
    YE: 0,
    YEM: 0,
    887: 0,
    ZA: 0,
    ZAF: 0,
    710: 0,
    ZW: 0,
    ZWE: 0,
    716: 0,
    AE: 6,
    ARE: 6,
    784: 6,
    AF: 6,
    AFG: 6,
    4: 6,
    BH: 6,
    BHR: 6,
    48: 6,
    DJ: 6,
    DJI: 6,
    262: 6,
    DZ: 6,
    DZA: 6,
    12: 6,
    EG: 6,
    EGY: 6,
    818: 6,
    IQ: 6,
    IRQ: 6,
    368: 6,
    IR: 6,
    IRN: 6,
    364: 6,
    JO: 6,
    JOR: 6,
    400: 6,
    KW: 6,
    KWT: 6,
    414: 6,
    LY: 6,
    LBY: 6,
    434: 6,
    MA: 6,
    MAR: 6,
    504: 6,
    OM: 6,
    OMN: 6,
    512: 6,
    QA: 6,
    QAT: 6,
    634: 6,
    SD: 6,
    SDN: 6,
    729: 6,
    SY: 6,
    SYR: 6,
    760: 6,
    BD: 5,
    BGD: 5,
    50: 5,
    MV: 5,
    MDV: 5,
    462: 5
};
var $3f551231987c5e40$export$2e2bcd8739ae039 = $3f551231987c5e40$var$regionDayMap;


function $f56c42fe50147334$export$31e6abbf76343621(regionCode) {
    return (0, $ed2afbcacc9e5a85$export$31e6abbf76343621)(regionCode, (0, $3f551231987c5e40$export$2e2bcd8739ae039));
}
function $f56c42fe50147334$export$ea33a5988b1820a3(locale) {
    return (0, $ed2afbcacc9e5a85$export$ea33a5988b1820a3)(locale, (0, $40d21ee6d3ef8dc5$export$2e2bcd8739ae039), (0, $3f551231987c5e40$export$2e2bcd8739ae039));
}


function $22a87fd332ba377b$export$7beb97a13d59670f(startOfWeek, locale) {
    return typeof startOfWeek === "number" ? startOfWeek % 7 : (0, $f56c42fe50147334$export$ea33a5988b1820a3)(locale);
}




function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


var $a0be1d3cff8ac270$export$dd412b56f1e4d8aa = function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};


var $d3721cd57b171c74$export$566174fa40823587 = function setDate(date, day) {
    var result = new Date(date);
    result.setDate(day);
    return result;
};


function $b70e16aabf990ae1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b70e16aabf990ae1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b70e16aabf990ae1$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b70e16aabf990ae1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $b70e16aabf990ae1$var$DAYS_IN_WEEK = 7;
var $b70e16aabf990ae1$export$8f3e2263a6d57311 = function getCalendarMonth(date, options) {
    var _firstDayOfWeek$optio = $b70e16aabf990ae1$var$_objectSpread({
        firstDayOfWeek: 1
    }, options), firstDayOfWeek = _firstDayOfWeek$optio.firstDayOfWeek;
    var firstDateOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDateOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    var firstWeekdayOfMonth = firstDateOfMonth.getDay();
    var lastWeekdayOfMonth = lastDateOfMonth.getDay();
    var daysInMonth = lastDateOfMonth.getDate();
    var daysToPrepend = (firstWeekdayOfMonth - firstDayOfWeek + $b70e16aabf990ae1$var$DAYS_IN_WEEK) % $b70e16aabf990ae1$var$DAYS_IN_WEEK;
    var daysToAppend = ($b70e16aabf990ae1$var$DAYS_IN_WEEK - 1 - lastWeekdayOfMonth + firstDayOfWeek) % $b70e16aabf990ae1$var$DAYS_IN_WEEK;
    var month = [];
    var week = [];
    for(var i = 1 - daysToPrepend; i <= daysInMonth + daysToAppend + 1; i++){
        if (i <= 0) week.push((0, $a0be1d3cff8ac270$export$dd412b56f1e4d8aa)(firstDateOfMonth, i - 1));
        else if (i > daysInMonth) week.push((0, $a0be1d3cff8ac270$export$dd412b56f1e4d8aa)(lastDateOfMonth, i - daysInMonth));
        else week.push((0, $d3721cd57b171c74$export$566174fa40823587)(date, i));
        if (week.length === 7) {
            month.push(week);
            week = [];
        }
    }
    return month;
};


function $53e2d2a976979c1b$export$2e2bcd8739ae039({ baseDate: baseDate, granularity: granularity, locale: locale, startOfWeek: startOfWeek }) {
    const isMonthPicker = granularity === "month";
    const rows = (0, $acw62.useMemo)(()=>isMonthPicker ? $53e2d2a976979c1b$var$getCalendarYear(baseDate) : (0, $b70e16aabf990ae1$export$8f3e2263a6d57311)(baseDate, {
            firstDayOfWeek: (0, $22a87fd332ba377b$export$7beb97a13d59670f)(startOfWeek, locale)
        }), [
        baseDate,
        isMonthPicker,
        startOfWeek,
        locale
    ]);
    return rows;
}
// Returns a 3-by-4 matrix with dates corresponding to the initial date-time of each month of the year for a given date.
function $53e2d2a976979c1b$var$getCalendarYear(date) {
    const year = date.getFullYear();
    return new Array(4).fill(0).map((_, i)=>new Array(3).fill(0).map((_, j)=>new Date(year, i * 3 + j)));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




function $c9a1e01e2f915c47$export$2e2bcd8739ae039({ baseDate: baseDate, focusableDate: focusableDate, granularity: granularity, isDateEnabled: isDateEnabled, isDateFocusable: isDateFocusable, onChangePage: onChangePage, onFocusDate: onFocusDate, onSelectDate: onSelectDate }) {
    const isMonthPicker = granularity === "month";
    const moveDown = isMonthPicker ? (0, $6eabafb796ac4871$export$1f32bc6c1f421808) : (0, $6eabafb796ac4871$export$12e8132dee1e1cb5);
    const moveLeft = isMonthPicker ? (0, $6eabafb796ac4871$export$2940ccdf63d4cab1) : (0, $6eabafb796ac4871$export$20e3431fd4d21d70);
    const moveRight = isMonthPicker ? (0, $6eabafb796ac4871$export$b3c242a863a88095) : (0, $6eabafb796ac4871$export$752403752bc16d94);
    const moveUp = isMonthPicker ? (0, $6eabafb796ac4871$export$10ac36d8097361a0) : (0, $6eabafb796ac4871$export$d83a6ab9969f2147);
    const isSamePage = isMonthPicker ? (0, $09f87854553a6255$export$2e2bcd8739ae039) : (0, $8085a298e92e1718$export$2e2bcd8739ae039);
    const onGridKeyDownHandler = (event)=>{
        let updatedFocusDate;
        const keys = [
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).left,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter
        ];
        if (focusableDate === null || keys.indexOf(event.keyCode) === -1) return;
        event.preventDefault();
        (0, $d790fc2d8f354fdb$export$2e2bcd8739ae039)(event, {
            onActivate: ()=>{
                if (!isDateEnabled(focusableDate)) return;
                onFocusDate(null);
                onSelectDate(focusableDate);
            },
            onBlockEnd: ()=>updatedFocusDate = moveDown(focusableDate, isDateFocusable),
            onBlockStart: ()=>updatedFocusDate = moveUp(focusableDate, isDateFocusable),
            onInlineStart: ()=>updatedFocusDate = moveLeft(focusableDate, isDateFocusable),
            onInlineEnd: ()=>updatedFocusDate = moveRight(focusableDate, isDateFocusable)
        });
        if (!updatedFocusDate) return;
        if (!isSamePage(updatedFocusDate, baseDate)) onChangePage(updatedFocusDate);
        onFocusDate(updatedFocusDate);
    };
    return onGridKeyDownHandler;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




function $a4f6cc9bbab9bd77$export$2e2bcd8739ae039({ locale: locale, rows: rows }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, rows[0].map((date)=>date.getDay()).map((dayIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            key: dayIndex,
            scope: "col",
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-grid-cell"], (0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-date-header"])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": "true"
        }, (0, $a12d66404868ccd6$export$3383afc3cadfb678)(locale, dayIndex, "short")), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b8469ab82402f2dd$export$2e2bcd8739ae039), null, (0, $a12d66404868ccd6$export$3383afc3cadfb678)(locale, dayIndex, "long"))))));
}


function $e4c1f8123712086f$export$2e2bcd8739ae039(_a) {
    var { value: value, locale: locale = "", startOfWeek: startOfWeek, isDateEnabled: isDateEnabled = ()=>true, dateDisabledReason: dateDisabledReason = ()=>"", ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, onChange: onChange, __internalRootRef: __internalRootRef, i18nStrings: i18nStrings, granularity: granularity = "day", previousMonthAriaLabel: previousMonthAriaLabel, nextMonthAriaLabel: nextMonthAriaLabel, todayAriaLabel: todayAriaLabel } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "value",
        "locale",
        "startOfWeek",
        "isDateEnabled",
        "dateDisabledReason",
        "ariaLabel",
        "ariaLabelledby",
        "ariaDescribedby",
        "onChange",
        "__internalRootRef",
        "i18nStrings",
        "granularity",
        "previousMonthAriaLabel",
        "nextMonthAriaLabel",
        "todayAriaLabel"
    ]);
    (0, $6175122c42c548ad$export$2e2bcd8739ae039)("Calendar", "value", value, "onChange", onChange);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const normalizedLocale = (0, $d3f825eb41b88093$export$dca0327c9b9c6498)("Calendar", locale);
    const gridWrapperRef = (0, $acw62.useRef)(null);
    const [focusedDate, setFocusedDate] = (0, $acw62.useState)(null);
    const valueDateCache = (0, $341652d1a063d149$export$56ec8876a3c0f013)();
    const focusedDateCache = (0, $341652d1a063d149$export$56ec8876a3c0f013)();
    // Set displayed date to value if defined or to current date otherwise.
    const parsedValue = value && value.length >= 4 ? (0, $baa585fc493d6e9d$export$6b862160d295c8e)(value) : null;
    const memoizedValue = parsedValue ? valueDateCache(parsedValue) : null;
    const defaultDisplayedDate = memoizedValue !== null && memoizedValue !== void 0 ? memoizedValue : new Date();
    const [displayedDate, setDisplayedDate] = (0, $acw62.useState)(defaultDisplayedDate);
    const headingId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("calendar-heading");
    const isMonthPicker = granularity === "month";
    const isDateFocusable = (date)=>isDateEnabled(date) || !isDateEnabled(date) && !!dateDisabledReason(date);
    const baseDate = isMonthPicker ? (0, $6eabafb796ac4871$export$126ba571a8444064)(displayedDate, isDateEnabled) : (0, $6eabafb796ac4871$export$1fa92dcbdf32fb44)(displayedDate, isDateEnabled);
    const isSameDate = isMonthPicker ? (0, $8085a298e92e1718$export$2e2bcd8739ae039) : (0, $c9ad0c9b51445ea3$export$2e2bcd8739ae039);
    const isSamePage = isMonthPicker ? (0, $09f87854553a6255$export$2e2bcd8739ae039) : (0, $8085a298e92e1718$export$2e2bcd8739ae039);
    const isCurrentPage = (date)=>isMonthPicker || (0, $8085a298e92e1718$export$2e2bcd8739ae039)(date, baseDate);
    const { previousButtonLabel: previousButtonLabel, nextButtonLabel: nextButtonLabel, renderDate: renderDate, renderDateAnnouncement: renderDateAnnouncement, renderHeaderText: renderHeaderText } = (0, $0c8f1e892bb01470$export$2e2bcd8739ae039)({
        granularity: granularity,
        i18nStrings: i18nStrings,
        locale: normalizedLocale,
        previousMonthAriaLabel: previousMonthAriaLabel,
        nextMonthAriaLabel: nextMonthAriaLabel,
        todayAriaLabel: todayAriaLabel
    });
    const gridRows = (0, $53e2d2a976979c1b$export$2e2bcd8739ae039)({
        baseDate: baseDate,
        granularity: granularity,
        startOfWeek: startOfWeek,
        locale: normalizedLocale
    });
    // Update displayed date if value changes.
    (0, $acw62.useEffect)(()=>{
        memoizedValue && setDisplayedDate((prev)=>prev.getTime() !== memoizedValue.getTime() ? memoizedValue : prev);
    }, [
        memoizedValue
    ]);
    const selectFocusedDate = (selected, baseDate)=>{
        if (selected && isDateFocusable(selected) && isSamePage(selected, baseDate)) return selected;
        const today = new Date();
        if (isDateFocusable(today) && isSamePage(today, baseDate)) return today;
        if (isDateFocusable(baseDate)) return baseDate;
        return null;
    };
    const focusableDate = focusedDate || selectFocusedDate(memoizedValue, baseDate);
    const onHeaderChangePageHandler = (amount)=>{
        const movePage = isMonthPicker ? (0, $eb237db400049a40$export$2e2bcd8739ae039) : (0, $a8211859f65764ad$export$2e2bcd8739ae039);
        const newDate = movePage(baseDate, amount);
        onChangePageHandler(newDate);
    };
    const onChangePageHandler = (newDate)=>{
        setDisplayedDate(newDate);
        setFocusedDate(null);
    };
    const onGridFocusDateHandler = (date)=>{
        if (date) setFocusedDate(date ? focusedDateCache(date) : null);
    };
    const onGridSelectDateHandler = (date)=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            value: (0, $b7857ad8c9833aee$export$3ae94a2503e890a1)(date, granularity)
        });
        setFocusedDate(null);
    };
    const onGridBlur = (event)=>{
        var _a;
        const newFocusTargetIsInGrid = event.relatedTarget && ((_a = gridWrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget));
        if (!newFocusTargetIsInGrid) setFocusedDate(null);
    };
    const onGridKeyDownHandler = (0, $c9a1e01e2f915c47$export$2e2bcd8739ae039)({
        baseDate: baseDate,
        focusableDate: focusableDate,
        granularity: granularity,
        isDateEnabled: isDateEnabled,
        isDateFocusable: isDateFocusable,
        onChangePage: onChangePageHandler,
        onFocusDate: onGridFocusDateHandler,
        onSelectDate: onGridSelectDateHandler
    });
    const headerText = renderHeaderText(baseDate);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: __internalRootRef
    }, baseProps, {
        role: "group",
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b10423781dc3537f$export$2e2bcd8739ae039).root, (0, $b10423781dc3537f$export$2e2bcd8739ae039).calendar, baseProps.className)
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $b10423781dc3537f$export$2e2bcd8739ae039)["calendar-inner"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c58214b95df0f907$export$2e2bcd8739ae039), {
        formattedDate: headerText,
        onChange: onHeaderChangePageHandler,
        previousLabel: previousButtonLabel,
        nextLabel: nextButtonLabel,
        headingId: headingId
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        onBlur: onGridBlur,
        ref: gridWrapperRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b0a3f0e4ff8ed2c9$export$2e2bcd8739ae039), {
        isDateEnabled: isDateEnabled,
        dateDisabledReason: dateDisabledReason,
        focusedDate: focusedDate,
        focusableDate: focusableDate,
        onSelectDate: onGridSelectDateHandler,
        onFocusDate: onGridFocusDateHandler,
        onChangePage: onChangePageHandler,
        selectedDate: memoizedValue,
        ariaLabelledby: headingId,
        header: isMonthPicker ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a4f6cc9bbab9bd77$export$2e2bcd8739ae039), {
            locale: normalizedLocale,
            rows: gridRows
        }),
        rows: gridRows,
        isCurrentPage: isCurrentPage,
        renderDate: renderDate,
        renderDateAnnouncement: renderDateAnnouncement,
        isSameDate: isSameDate,
        onGridKeyDownHandler: onGridKeyDownHandler
    }))));
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




function $95706a37c0d7d1b0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}



var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts ISO date to display format, e.g. 2020-01-01 -> 2020/01/01.
 */ function $d58710628af8846a$export$aa53871afc5b25e6(value) {
    return value.replace(/-/g, "/");
}
function $d58710628af8846a$export$763ac7e5df87a34a(value) {
    return value.replace(/\//g, "-");
}




var $acw62 = parcelRequire("acw62");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $d19e2b7d7c7cc806$var$isSpecialCommand = (keyCode)=>{
    return keyCode > 7 && keyCode < 47 && keyCode !== (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space;
};
const $d19e2b7d7c7cc806$var$isClipboardCommand = (ctrlKey, metaKey)=>ctrlKey || metaKey;
const $d19e2b7d7c7cc806$export$43de6be2c393a8bd = (keyCode, ctrlKey, metaKey)=>$d19e2b7d7c7cc806$var$isSpecialCommand(keyCode) || $d19e2b7d7c7cc806$var$isClipboardCommand(ctrlKey, metaKey);
const $d19e2b7d7c7cc806$export$727d9dbc4fbb948f = (char)=>!isNaN(parseInt(char, 10));


/**
 * Handles character removal
 *
 * @param initialValue Current value of input
 * @param format MaskFormat object
 * @param selectionStart Starting index value of selection cursor
 * @param selectionEnd Ending Index value of selection cursor
 */ const $9bd94e88f6352be2$export$8245067361b70905 = (initialValue, format, selectionStart, selectionEnd)=>{
    const multiCharDelete = selectionStart !== selectionEnd;
    if (multiCharDelete) {
        const isCursorAtEnd = selectionEnd === initialValue.length;
        if (!isCursorAtEnd) return format.replaceDigitsWithZeroes(initialValue, selectionStart, selectionEnd);
        return {
            value: initialValue.slice(0, selectionStart),
            position: selectionStart
        };
    }
    const isSeparator = format.isSegmentStart(selectionStart);
    const atEnd = selectionStart === initialValue.length;
    if (!atEnd) {
        if (isSeparator) return format.deleteSeparator(initialValue, selectionStart);
        else return format.deleteDigit(initialValue, selectionStart);
    }
    if (isSeparator) return {
        value: initialValue.slice(0, selectionStart - 2),
        position: selectionStart - 2
    };
    return {
        value: initialValue.slice(0, selectionStart - 1),
        position: selectionStart - 1
    };
};
const $9bd94e88f6352be2$export$53be3f01be2e49ac = (initialValue, key, format, selectionStart, selectionEnd)=>{
    let value = initialValue;
    const position = selectionStart;
    // return if no more digits can be added at the end
    if (selectionStart === value.length && value.length === format.getMaxLength()) return {
        value: value,
        position: position
    };
    // if range is selected to the end, remove all of that selection first
    if (selectionStart !== value.length && selectionEnd === value.length) {
        const sliceEnd = format.isCursorAtSeparator(selectionStart) ? selectionStart + 1 : selectionStart;
        value = initialValue.slice(0, sliceEnd);
    }
    if (format.isCursorAtSeparator(position)) return {
        value: value,
        position: position + 1
    };
    return format.processKey(value, key, position);
};
const $9bd94e88f6352be2$export$606c1792086c85f2 = (value, format)=>{
    // Do not autocomplete if input is empty
    if (!value) return {
        value: "",
        position: 0
    };
    const autoCompletedValue = format.autoComplete(value);
    const position = autoCompletedValue.length;
    return {
        value: autoCompletedValue,
        position: position
    };
};


const $056b1715a7436e30$var$onAutoComplete = (value, onChange, maskFormat)=>{
    // Do not autocomplete if input is empty
    if (!value) return;
    const autoCompletedValue = maskFormat.autoComplete(value);
    if (autoCompletedValue !== value) onChange(autoCompletedValue);
};
const $056b1715a7436e30$var$preventDefault = (event, result)=>result && event.preventDefault();
const $056b1715a7436e30$var$useMask = ({ value: value = "", onBlur: onBlur, onChange: onChange, onKeyDown: onKeyDown, format: format, inputRef: inputRef, autofix: autofix = false, disableAutocompleteOnBlur: disableAutocompleteOnBlur = false, setPosition: setPosition })=>{
    if (!format.isValid(value)) (0, $dd646455762bc7b9$export$5b28268982f175ba)("useMask", `Invalid string "${value}" provided`);
    const onMaskChange = (updatedValue)=>{
        const autofixedUpdatedValue = autofix ? format.correctMinMaxValues(updatedValue) : updatedValue;
        if (autofixedUpdatedValue === value || !format.isValid(autofixedUpdatedValue)) return;
        onChange(autofixedUpdatedValue);
    };
    const initialValue = autofix ? format.correctMinMaxValues(value) : value;
    const maskedValue = format.getValidValue(initialValue);
    return {
        value: maskedValue,
        onKeyDown: (event)=>{
            var _a, _b;
            const selectionStart = ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.selectionStart) || 0;
            const selectionEnd = ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.selectionEnd) || 0;
            let result;
            const { keyCode: keyCode, key: key, ctrlKey: ctrlKey, metaKey: metaKey } = event.detail;
            if ((0, $d19e2b7d7c7cc806$export$727d9dbc4fbb948f)(key) || format.isSeparator(key)) {
                result = (0, $9bd94e88f6352be2$export$53be3f01be2e49ac)(maskedValue, key, format, selectionStart, selectionEnd);
                $056b1715a7436e30$var$preventDefault(event, result);
            } else if (keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).backspace) {
                result = (0, $9bd94e88f6352be2$export$8245067361b70905)(maskedValue, format, selectionStart, selectionEnd);
                $056b1715a7436e30$var$preventDefault(event, result);
            } else if (keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter) result = (0, $9bd94e88f6352be2$export$606c1792086c85f2)(maskedValue, format);
            else if (!(0, $d19e2b7d7c7cc806$export$43de6be2c393a8bd)(keyCode, ctrlKey, metaKey)) event.preventDefault();
            if (result) {
                const { value: value, position: position } = result;
                onMaskChange(value);
                setPosition(position);
            }
            // Proxy original event
            onKeyDown && onKeyDown(event);
        },
        onChange: ({ detail: detail })=>onMaskChange(detail.value),
        onBlur: ()=>{
            if (!disableAutocompleteOnBlur) $056b1715a7436e30$var$onAutoComplete(maskedValue, onChange, format);
            onBlur && onBlur();
        },
        onPaste: (event)=>{
            var _a, _b;
            const text = (event.clipboardData || window.clipboardData).getData("text");
            const selectionStart = ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.selectionStart) || 0;
            const selectionEnd = ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.selectionEnd) || 0;
            const formattedText = format.formatPastedText(text, maskedValue, selectionStart, selectionEnd);
            onMaskChange(formattedText);
        }
    };
};
var $056b1715a7436e30$export$2e2bcd8739ae039 = $056b1715a7436e30$var$useMask;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $96cd96a8ce7962d6$export$9f200c4466975173 = (text, toInsert, start, end = start)=>text.slice(0, start) + toInsert + text.slice(end);


class $1277ba0d73502361$var$MaskFormat {
    constructor({ separator: separator, inputSeparators: inputSeparators = [], segments: segments }){
        this.positionFormats = new Map();
        this.segments = [];
        this.separator = separator;
        this.inputSeparators = [
            ...inputSeparators,
            separator
        ];
        this.enrichSegmentDefinitions(segments);
    }
    tryAppendSeparator(value) {
        const withSeparator = `${value}${this.separator}`;
        return this.isValid(withSeparator) ? withSeparator : value;
    }
    isSeparator(key) {
        return this.inputSeparators.indexOf(key) !== -1;
    }
    isValid(value) {
        const inputSegments = value.split(this.separator);
        if (inputSegments.length > this.segments.length) return false;
        return inputSegments.every((segmentValue, i)=>{
            const segment = this.segments[i];
            // disallow empty segments
            if (segmentValue === "") {
                // except empty last segment (e.g. trailing separator "12:")
                if (i === inputSegments.length - 1) return true;
                else return false;
            }
            // only allow numerals
            if (!segmentValue.match(/^\d+$/)) return false;
            // disallow incomplete segments, except at end
            if (segmentValue.length < segment.length && i !== inputSegments.length - 1) return false;
            // limit numerical value
            const intValue = parseInt(segmentValue, 10);
            // Handles values padded with 0s that are lost during parsing
            if (segmentValue.length > segment.length) return false;
            if (intValue < segment.min || intValue > segment.max(value)) {
                // allow incomplete segments in final position
                if (i === inputSegments.length - 1 && segmentValue.length < segment.length) return true;
                return false;
            }
            return true;
        });
    }
    getValidValue(value) {
        let validValue = value;
        do {
            if (this.isValid(validValue)) return this.tryAppendSeparator(validValue);
            validValue = validValue.substring(0, validValue.length - 1);
        }while (validValue.length > 0);
        return "";
    }
    autoComplete(value) {
        // aka [...completeSegments, lastSegment] = value.split(':')
        // but that's not valid :/
        const [lastSegmentValue, ...completeSegmentValues] = value.split(this.separator).reverse();
        const lastSegment = this.segments[completeSegmentValues.length];
        // if the last segment isn't complete, pad it with a preceding 0
        // e.g. 10:1 -> 10:01
        const paddedLastSegmentValue = this.padWithDefaultValue(lastSegmentValue, lastSegment);
        // recombine, and pad with extra segments for the full format
        const partial = [
            ...completeSegmentValues.reverse(),
            paddedLastSegmentValue
        ];
        while(partial.length < this.segments.length){
            const nextSegment = this.segments[partial.length];
            const segmentValue = this.padWithDefaultValue("", nextSegment);
            partial.push(segmentValue);
        }
        value = partial.join(this.separator);
        value = this.correctMinMaxValues(value);
        return value;
    }
    getSegmentValueWithAddition(position, value, enteredDigit) {
        const segment = this.positionFormats.get(position);
        const segmentValue = value.substr(segment.start, segment.length);
        const segmentPosition = position - segment.start;
        const newValue = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(segmentValue, enteredDigit, segmentPosition, segmentPosition + 1);
        return parseInt(newValue, 10);
    }
    replaceDigitsWithZeroes(value, cursorStart, cursorEnd) {
        const position = this.isCursorAtSeparator(cursorStart) ? cursorStart + 1 : cursorStart;
        // move selection forwards if it starts with a separator
        if (this.isCursorAtSeparator(cursorStart)) cursorStart++;
        // first, insert zeros in a partial segment at beginning of selection
        if (!this.isSegmentStart(cursorStart)) {
            const segment = this.positionFormats.get(cursorStart);
            value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)("", segment.end - cursorStart), cursorStart, segment.end);
            cursorStart = segment.end + 1;
        }
        // then loop through remaining segments, filling with zeros
        let currentSegment;
        while(cursorStart < cursorEnd && (currentSegment = this.positionFormats.get(cursorStart + 1))){
            const insertionEnd = Math.min(cursorEnd, currentSegment.end);
            value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)("", insertionEnd - currentSegment.start), currentSegment.start, insertionEnd);
            cursorStart = insertionEnd + 1;
        }
        value = this.correctMinMaxValues(value);
        return {
            value: value,
            position: position
        };
    }
    handleSeparatorInput(value, position) {
        if (position === value.length && !this.isSegmentStart(position)) {
            const segment = this.positionFormats.get(position);
            let segmentValue = value.substr(segment.start, segment.length);
            segmentValue = this.padWithDefaultValue(segmentValue, segment);
            value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, segmentValue, segment.start, segment.end);
            value = this.correctMinMaxValues(value);
            return {
                value: value,
                position: value.length
            };
        }
    }
    isCursorAtSeparator(position) {
        return 0 < position && position < this.getMaxLength() && this.positionFormats.get(position) === undefined;
    }
    isSegmentStart(position) {
        return position === 0 || this.isCursorAtSeparator(position - 1);
    }
    getSegmentMaxValue(value, position) {
        return this.positionFormats.get(position).max(value);
    }
    getSegmentMinValue(value, position) {
        return this.positionFormats.get(position).min;
    }
    getMaxLength() {
        const last = this.segments[this.segments.length - 1];
        return last.start + last.length;
    }
    deleteSeparator(value, position) {
        value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, "0", position - 2, position - 1);
        return {
            value: this.correctMinMaxValues(value),
            position: position - 2
        };
    }
    deleteDigit(value, position) {
        value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, "0", position - 1, position);
        // 23:59|: => backspace => 23:5|
        const length = value.length;
        if (value.slice(length - 2) === "0:") value = value.slice(0, length - 2);
        return {
            value: this.correctMinMaxValues(value),
            position: position - 1
        };
    }
    correctMinMaxValues(value) {
        let segment = this.positionFormats.get(0);
        while(segment && value.length >= segment.end){
            const segmentValue = parseInt(value.substr(segment.start, segment.length), 10);
            const segmentMax = segment.max(value);
            if (segmentValue < segment.min) {
                let toInsert = segment.min.toFixed();
                toInsert = (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(toInsert, segment.length);
                value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, toInsert, segment.start, segment.end);
            }
            if (segmentValue > segmentMax) value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, segmentMax.toFixed(), segment.start, segment.end);
            segment = this.positionFormats.get(segment.end + 1);
        }
        return value.substr(0, this.segments[this.segments.length - 1].end);
    }
    formatPastedText(text, value, cursorStart, cursorEnd) {
        const keyArr = text.trim().split("");
        let position = cursorStart;
        let formattedValue = value;
        // if a selection range captures the end of the current value
        // we replace it with the value in buffer even if the value in buffer is shorter
        if (cursorEnd > cursorStart && cursorEnd === value.length) formattedValue = value.slice(0, cursorStart);
        for (const key of keyArr){
            if (position >= this.getMaxLength()) break;
            const result = this.processKey(formattedValue, key, position);
            formattedValue = result.value;
            position = result.position;
        }
        return this.tryAppendSeparator(formattedValue);
    }
    processKey(initialValue, key, initialPosition) {
        let value = initialValue;
        let position = initialPosition;
        if (this.isSeparator(key)) {
            const result = this.handleSeparatorInput(value, position);
            if (result) {
                value = result.value;
                position = result.position;
            }
        } else {
            const isCursorAtEnd = position === value.length;
            const segmentValue = this.getSegmentValueWithAddition(position, value, key);
            const segmentMaxValue = this.getSegmentMaxValue(value, position);
            const segmentMinValue = this.getSegmentMinValue(value, position);
            const firstDigitGreater = parseInt(key, 10) > parseInt(segmentMaxValue.toFixed()[0], 10);
            const isValidPosition = isCursorAtEnd || segmentValue.toFixed().length === 1;
            const exceedsMaxAtSegmentStart = this.isSegmentStart(position) && isValidPosition && firstDigitGreater;
            if (exceedsMaxAtSegmentStart) {
                // 22:| => Enter '9' => 22:09|
                // |1 => Enter '9' => 09|
                value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, `0${key}`, position, position + 2);
                position += 2;
            } else if (segmentValue > segmentMaxValue && this.isSegmentStart(position)) {
                // 22:|22 => Enter '9' => 22:59|
                value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, segmentMaxValue.toFixed(), position, position + segmentMaxValue.toFixed().length);
                position += segmentMaxValue.toFixed().length;
            } else if (segmentValue > segmentMaxValue) {
                // 2|2:22 => Enter '9' => 23:|22
                value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, segmentMaxValue.toFixed(), position - 1, position + 1);
                position += 1;
            } else if (segmentValue < segmentMinValue && !this.isSegmentStart(position)) {
                // 0| => enter '0' => 01:
                value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, segmentMinValue.toFixed(), position, position + 1);
                position += 1;
            } else {
                // 22:| => Enter '5' => 23:5|
                value = (0, $96cd96a8ce7962d6$export$9f200c4466975173)(value, key, position, position + 1);
                position += 1;
            }
        }
        value = this.tryAppendSeparator(value);
        // Move cursor in front of separator if behind after overwriting a character
        if (this.isCursorAtSeparator(position)) position++;
        return {
            value: value,
            position: position
        };
    }
    padWithDefaultValue(segmentValue, segment) {
        let defaultValue = (segment.default || segment.min).toFixed();
        defaultValue = (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(defaultValue, segment.length);
        return (0, $96cd96a8ce7962d6$export$9f200c4466975173)(defaultValue, segmentValue, segment.length - segmentValue.length, segment.length);
    }
    enrichSegmentDefinitions(segments) {
        this.positionFormats = new Map();
        this.segments = [];
        let position = 0;
        for (const segment of segments){
            const max = segment.max;
            const fullSegment = Object.assign(Object.assign({}, segment), {
                max: typeof max === "number" ? ()=>max : max,
                start: position,
                end: position + segment.length
            });
            this.segments.push(fullSegment);
            // insert this format segment for every char in the max value
            for(let j = 0; j < fullSegment.length; j++)this.positionFormats.set(position++, fullSegment);
            // skip a position for separator
            position++;
        }
    }
}
var $1277ba0d73502361$export$2e2bcd8739ae039 = $1277ba0d73502361$var$MaskFormat;


const $f7cca821612459be$var$MaskedInput = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { value: value, onBlur: onBlur, onChange: onChange, onKeyDown: onKeyDown, mask: mask, autofix: autofix = false, disableAutocompleteOnBlur: disableAutocompleteOnBlur = false } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "value",
        "onBlur",
        "onChange",
        "onKeyDown",
        "mask",
        "autofix",
        "disableAutocompleteOnBlur"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const formFieldContext = (0, $4a30639b463663e4$export$824c400da192ca1b)(rest);
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [cursorPosition, setCursorPosition] = (0, $acw62.useState)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        var _a;
        if (cursorPosition !== null) (_a = inputRef.current) === null || _a === void 0 || _a.setSelectionRange(cursorPosition, cursorPosition);
    }, [
        cursorPosition,
        inputRef
    ]);
    const _b = (0, $056b1715a7436e30$export$2e2bcd8739ae039)({
        format: new (0, $1277ba0d73502361$export$2e2bcd8739ae039)(mask),
        value: value,
        inputRef: inputRef,
        autofix: autofix,
        disableAutocompleteOnBlur: disableAutocompleteOnBlur,
        onChange: (value)=>!rest.readOnly && (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                value: value
            }),
        onKeyDown: (event)=>!rest.readOnly && onKeyDown && (0, $fc537b925f715587$export$d7e1721720edbb03)(onKeyDown, event.detail, event),
        onBlur: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur),
        setPosition: setCursorPosition
    }), { onPaste: onPaste } = _b, maskProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_b, [
        "onPaste"
    ]);
    const inputProps = Object.assign(Object.assign(Object.assign(Object.assign({}, rest), baseProps), formFieldContext), maskProps);
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(ref, inputRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fadf349311229145$export$2e2bcd8739ae039), Object.assign({}, inputProps, {
        ref: mergedRef,
        __nativeAttributes: {
            onPaste: onPaste
        }
    }));
});
var $f7cca821612459be$export$2e2bcd8739ae039 = $f7cca821612459be$var$MaskedInput;



var $5f022994dab408bc$export$2e2bcd8739ae039 = {
    "root": "awsui_root_yodkx_im8v7_5"
};


function $5054cd724d97a7f8$var$daysMax(value) {
    // force to first day in month, as new Date('2018-02-30') -> March 2nd 2018
    const baseDate = (0, $d58710628af8846a$export$763ac7e5df87a34a)(value).substring(0, 7);
    return (0, $95706a37c0d7d1b0$export$2e2bcd8739ae039)((0, $baa585fc493d6e9d$export$6b862160d295c8e)(baseDate));
}
const $5054cd724d97a7f8$var$yearMask = {
    min: 0,
    max: 9999,
    default: 2000,
    length: 4
};
const $5054cd724d97a7f8$var$monthMask = {
    min: 1,
    max: 12,
    length: 2
};
const $5054cd724d97a7f8$var$dayMask = {
    min: 1,
    max: $5054cd724d97a7f8$var$daysMax,
    length: 2
};
const $5054cd724d97a7f8$var$InternalDateInput = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { value: value, onChange: onChange, granularity: granularity, __internalRootRef: __internalRootRef = null } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "value",
        "onChange",
        "granularity",
        "__internalRootRef"
    ]);
    const maskArgs = {
        separator: "/",
        inputSeparators: [
            "-",
            ".",
            " "
        ],
        segments: granularity === "month" ? [
            $5054cd724d97a7f8$var$yearMask,
            $5054cd724d97a7f8$var$monthMask
        ] : [
            $5054cd724d97a7f8$var$yearMask,
            $5054cd724d97a7f8$var$monthMask,
            $5054cd724d97a7f8$var$dayMask
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f7cca821612459be$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, props, {
        value: (0, $d58710628af8846a$export$aa53871afc5b25e6)(value || ""),
        onChange: (event)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                value: (0, $d58710628af8846a$export$763ac7e5df87a34a)(event.detail.value)
            }),
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $5f022994dab408bc$export$2e2bcd8739ae039).root, props.className),
        mask: maskArgs,
        autofix: true,
        autoComplete: false,
        disableAutocompleteOnBlur: false,
        disableBrowserAutocorrect: true,
        __internalRootRef: __internalRootRef
    }));
});
var $5054cd724d97a7f8$export$2e2bcd8739ae039 = $5054cd724d97a7f8$var$InternalDateInput;





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

class $fc4c3d7c11f51903$export$2e2bcd8739ae039 {
    constructor(node, { onFocusEnter: onFocusEnter, onFocusLeave: onFocusLeave }){
        this.node = node;
        this.currentlyFocused = false;
        this.focusInListener = (event)=>{
            const focusIsInside = (0, $4c778684f125e678$export$57d4cb221e1d1857)(this.node, event.target);
            if (!this.currentlyFocused && focusIsInside) this.triggerFocus();
        };
        this.focusOutListener = (event)=>{
            const nextFocused = event.relatedTarget;
            const isNextFocusedInParent = !(0, $4c778684f125e678$export$57d4cb221e1d1857)(this.node, nextFocused);
            if (this.currentlyFocused && (nextFocused === null || isNextFocusedInParent)) this.triggerBlur();
        };
        this.onFocusEnter = onFocusEnter;
        this.onFocusLeave = onFocusLeave;
    }
    initialize() {
        this.currentlyFocused = (0, $4c778684f125e678$export$57d4cb221e1d1857)(this.node, document.activeElement);
        document.addEventListener("focusin", this.focusInListener);
        document.addEventListener("focusout", this.focusOutListener);
    }
    destroy() {
        document.removeEventListener("focusin", this.focusInListener);
        document.removeEventListener("focusout", this.focusOutListener);
    }
    triggerBlur() {
        this.currentlyFocused = false;
        this.onFocusLeave();
    }
    triggerFocus() {
        this.currentlyFocused = true;
        this.onFocusEnter();
    }
}


const $51561f9ae227347c$export$3369c53c6e376592 = ({ rootRef: rootRef, onBlur: onBlur, onFocus: onFocus })=>{
    const focusTracker = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!rootRef.current) return;
        focusTracker.current = new (0, $fc4c3d7c11f51903$export$2e2bcd8739ae039)(rootRef.current, {
            onFocusLeave: ()=>{
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur);
            },
            onFocusEnter: ()=>{
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus);
            }
        });
        focusTracker.current.initialize();
        return ()=>{
            var _a;
            (_a = focusTracker.current) === null || _a === void 0 || _a.destroy();
        };
    }, [
        rootRef,
        onBlur,
        onFocus
    ]);
};












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $2a75c3368373dbfd$export$a02eb350a92cd69({ date: date, granularity: granularity }) {
    const regex = granularity === "month" ? /^\d{4}-\d{2}(-\d{2})?$/ : /^\d{4}-\d{2}-\d{2}$/;
    return !!date.match(regex);
}
function $2a75c3368373dbfd$export$fbaf8bc37fede21({ date: date, granularity: granularity, locale: locale }) {
    return granularity === "month" ? (0, $a12d66404868ccd6$export$ac27097ce4a1899f)(locale, date) : (0, $a12d66404868ccd6$export$51d68b748655e933)(locale, date);
}
function $2a75c3368373dbfd$export$a3a70c8ff09af2eb({ date: date, granularity: granularity, locale: locale }) {
    return granularity === "month" ? (0, $a12d66404868ccd6$export$64ba10e8616b702f)(locale, date) : (0, $a12d66404868ccd6$export$ac27097ce4a1899f)(locale, date);
}


const $0fddd550297817b9$var$DatePicker = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var _b, _c, _d;
    var { locale: locale = "", startOfWeek: startOfWeek, isDateEnabled: isDateEnabled, dateDisabledReason: dateDisabledReason, nextMonthAriaLabel: nextMonthAriaLabel, previousMonthAriaLabel: previousMonthAriaLabel, todayAriaLabel: todayAriaLabel, i18nStrings: i18nStrings, placeholder: placeholder = "", value: value = "", readOnly: readOnly = false, disabled: disabled = false, onBlur: onBlur, autoFocus: autoFocus = false, onChange: onChange, onFocus: onFocus, name: name, ariaLabel: ariaLabel, ariaRequired: ariaRequired, controlId: controlId, invalid: invalid, warning: warning, openCalendarAriaLabel: openCalendarAriaLabel, expandToViewport: expandToViewport, granularity: granularity = "day" } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "locale",
        "startOfWeek",
        "isDateEnabled",
        "dateDisabledReason",
        "nextMonthAriaLabel",
        "previousMonthAriaLabel",
        "todayAriaLabel",
        "i18nStrings",
        "placeholder",
        "value",
        "readOnly",
        "disabled",
        "onBlur",
        "autoFocus",
        "onChange",
        "onFocus",
        "name",
        "ariaLabel",
        "ariaRequired",
        "controlId",
        "invalid",
        "warning",
        "openCalendarAriaLabel",
        "expandToViewport",
        "granularity"
    ]);
    const { __internalRootRef: __internalRootRef } = (0, $970c67f83063979b$export$2e2bcd8739ae039)("DatePicker", {
        props: {
            autoFocus: autoFocus,
            expandToViewport: expandToViewport,
            granularity: granularity,
            readOnly: readOnly
        }
    });
    (0, $6175122c42c548ad$export$2e2bcd8739ae039)("DatePicker", "value", value, "onChange", onChange);
    const contextLocale = (0, $4d65e7166b5544ac$export$43bb16f9c6d9e3f7)();
    const normalizedLocale = (0, $d3f825eb41b88093$export$dca0327c9b9c6498)("DatePicker", locale || contextLocale);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const [isDropDownOpen, setIsDropDownOpen] = (0, $acw62.useState)(false);
    const { ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby } = (0, $4a30639b463663e4$export$824c400da192ca1b)(restProps);
    const internalInputRef = (0, $acw62.useRef)(null);
    const buttonRef = (0, $acw62.useRef)(null);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, internalInputRef);
    const rootRef = (0, $acw62.useRef)(null);
    const dropdownId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("calender");
    const calendarDescriptionId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("calendar-description-");
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(rootRef, __internalRootRef);
    (0, $51561f9ae227347c$export$3369c53c6e376592)({
        rootRef: rootRef,
        onBlur: onBlur,
        onFocus: onFocus
    });
    const onDropdownCloseHandler = (0, $acw62.useCallback)(()=>setIsDropDownOpen(false), [
        setIsDropDownOpen
    ]);
    const onButtonClickHandler = ()=>{
        if (!isDropDownOpen) setIsDropDownOpen(true);
    };
    const onWrapperKeyDownHandler = (event)=>{
        var _a;
        if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).escape && isDropDownOpen) {
            event.stopPropagation();
            (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
            setIsDropDownOpen(false);
        }
    };
    const onInputChangeHandler = (event)=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            value: event.detail.value
        });
    };
    const onInputBlurHandler = ()=>{
        if (!isDropDownOpen) setIsDropDownOpen(false);
    };
    // Set displayed date to value if defined or to current date otherwise.
    const parsedValue = value && value.length >= 4 ? (0, $baa585fc493d6e9d$export$6b862160d295c8e)(value) : null;
    const baseDate = parsedValue || new Date();
    const hasFullValue = (0, $2a75c3368373dbfd$export$a02eb350a92cd69)({
        date: value,
        granularity: granularity
    });
    const buttonAriaLabel = openCalendarAriaLabel && openCalendarAriaLabel(hasFullValue && parsedValue ? (0, $2a75c3368373dbfd$export$fbaf8bc37fede21)({
        date: parsedValue,
        granularity: granularity,
        locale: normalizedLocale
    }) : null);
    const trigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $e439776d2d025878$export$2e2bcd8739ae039)["date-picker-trigger"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $e439776d2d025878$export$2e2bcd8739ae039)["date-picker-input"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5054cd724d97a7f8$export$2e2bcd8739ae039), {
        name: name,
        invalid: invalid,
        warning: warning,
        controlId: controlId,
        ariaLabelledby: ariaLabelledby,
        ariaDescribedby: ariaDescribedby,
        ariaLabel: ariaLabel,
        ariaRequired: ariaRequired,
        value: value,
        disabled: disabled,
        readOnly: readOnly,
        onChange: onInputChangeHandler,
        onBlur: onInputBlurHandler,
        placeholder: placeholder,
        ref: internalInputRef,
        autoFocus: autoFocus,
        onFocus: onDropdownCloseHandler,
        granularity: granularity
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        iconName: "calendar",
        className: (0, $e439776d2d025878$export$2e2bcd8739ae039)["open-calendar-button"],
        onClick: onButtonClickHandler,
        ref: buttonRef,
        ariaLabel: buttonAriaLabel,
        disabled: disabled || readOnly,
        formAction: "none"
    })));
    baseProps.className = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $e439776d2d025878$export$2e2bcd8739ae039).root, (0, $e439776d2d025878$export$2e2bcd8739ae039)["date-picker-container"]);
    const handleMouseDown = (event)=>{
        // prevent currently focused element from losing it
        event.preventDefault();
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        ref: mergedRef,
        onKeyDown: !disabled && !readOnly ? onWrapperKeyDownHandler : undefined
    }), disabled || readOnly ? trigger : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1fd689c8894b21bd$export$2e2bcd8739ae039), {
        stretchWidth: true,
        stretchHeight: true,
        open: isDropDownOpen,
        onDropdownClose: onDropdownCloseHandler,
        onMouseDown: handleMouseDown,
        trigger: trigger,
        expandToViewport: expandToViewport,
        scrollable: false,
        dropdownId: dropdownId
    }, isDropDownOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48646398710f9406$export$2e2bcd8739ae039), {
        className: (0, $e439776d2d025878$export$2e2bcd8739ae039)["focus-lock"],
        autoFocus: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        tabIndex: 0,
        className: (0, $e439776d2d025878$export$2e2bcd8739ae039).calendar,
        role: "dialog",
        "aria-modal": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e4c1f8123712086f$export$2e2bcd8739ae039), {
        value: value,
        onChange: (e)=>{
            var _a;
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, e.detail);
            (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 || _a.focus();
            setIsDropDownOpen(false);
        },
        locale: normalizedLocale,
        startOfWeek: startOfWeek,
        ariaDescribedby: calendarDescriptionId,
        ariaLabel: ariaLabel,
        ariaLabelledby: ariaLabelledby,
        granularity: granularity,
        isDateEnabled: isDateEnabled,
        dateDisabledReason: dateDisabledReason,
        i18nStrings: Object.assign(Object.assign({}, i18nStrings), {
            todayAriaLabel: (_b = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.todayAriaLabel) !== null && _b !== void 0 ? _b : todayAriaLabel,
            nextMonthAriaLabel: (_c = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.nextMonthAriaLabel) !== null && _c !== void 0 ? _c : nextMonthAriaLabel,
            previousMonthAriaLabel: (_d = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.previousMonthAriaLabel) !== null && _d !== void 0 ? _d : previousMonthAriaLabel
        })
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), {
        id: calendarDescriptionId
    }, (0, $2a75c3368373dbfd$export$a3a70c8ff09af2eb)({
        date: baseDate,
        granularity: granularity,
        locale: normalizedLocale
    }))))));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($0fddd550297817b9$var$DatePicker, "DatePicker");
var $0fddd550297817b9$export$2e2bcd8739ae039 = $0fddd550297817b9$var$DatePicker;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $2f4919411abbde65$export$2e2bcd8739ae039 = {
    "file-option-name": "awsui_file-option-name_ezgb4_136jz_9",
    "file-option-size": "awsui_file-option-size_ezgb4_136jz_10",
    "file-option-last-modified": "awsui_file-option-last-modified_ezgb4_136jz_11",
    "file-option-thumbnail": "awsui_file-option-thumbnail_ezgb4_136jz_12",
    "file-option": "awsui_file-option_ezgb4_136jz_9",
    "file-option-thumbnail-image": "awsui_file-option-thumbnail-image_ezgb4_136jz_28",
    "file-option-metadata": "awsui_file-option-metadata_ezgb4_136jz_33"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $a09d76d059fef380$export$3203edd9e5edd663 = (value)=>{
    const hours = (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(`${value.getHours()}`, 2);
    const minutes = (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(`${value.getMinutes()}`, 2);
    const seconds = (0, $338478df0d3aeeab$export$2da9fd1f854a2a4b)(`${value.getSeconds()}`, 2);
    return `${hours}:${minutes}:${seconds}`;
};


function $8c712b40a21c0439$export$8b492ed8828f789c(date) {
    return (0, $b7857ad8c9833aee$export$3ae94a2503e890a1)(date) + "T" + (0, $a09d76d059fef380$export$3203edd9e5edd663)(date);
}


const $d9356d78b20e7175$var$KB = 1000;
const $d9356d78b20e7175$var$MB = Math.pow(1000, 2);
const $d9356d78b20e7175$var$GB = Math.pow(1000, 3);
const $d9356d78b20e7175$var$TB = Math.pow(1000, 4);
function $d9356d78b20e7175$export$a55dc7d9a051abe5(size) {
    if (size < $d9356d78b20e7175$var$MB) return `${(size / $d9356d78b20e7175$var$KB).toFixed(2)} KB`;
    if (size < $d9356d78b20e7175$var$GB) return `${(size / $d9356d78b20e7175$var$MB).toFixed(2)} MB`;
    if (size < $d9356d78b20e7175$var$TB) return `${(size / $d9356d78b20e7175$var$GB).toFixed(2)} GB`;
    return `${(size / $d9356d78b20e7175$var$TB).toFixed(2)} TB`;
}
function $d9356d78b20e7175$export$f20360301b72d45f(date) {
    return (0, $8c712b40a21c0439$export$8b492ed8828f789c)(date);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $7a7835f38a1d2414$export$d65da67560512fde({ file: file }) {
    const [imageSrc, setImageSrc] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        // The URL.createObjectURL is not available in jsdom.
        if (URL.createObjectURL) {
            const src = URL.createObjectURL(file);
            setImageSrc(src);
            return ()=>{
                URL.revokeObjectURL(src);
            };
        }
    }, [
        file
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $2f4919411abbde65$export$2e2bcd8739ae039)["file-option-thumbnail"],
        "aria-hidden": true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        className: (0, $2f4919411abbde65$export$2e2bcd8739ae039)["file-option-thumbnail-image"],
        alt: file.name,
        src: imageSrc
    }));
}


function $4f8811903aa9878e$export$9c7b13df4d1e0eeb({ file: file, metadata: metadata, i18nStrings: i18nStrings }) {
    var _a, _b;
    const isImage = file.type.startsWith("image/");
    const formatFileSize = (_a = i18nStrings.formatFileSize) !== null && _a !== void 0 ? _a : $d9356d78b20e7175$export$a55dc7d9a051abe5;
    const formatFileLastModified = (_b = i18nStrings.formatFileLastModified) !== null && _b !== void 0 ? _b : $d9356d78b20e7175$export$f20360301b72d45f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        className: (0, $2f4919411abbde65$export$2e2bcd8739ae039)["file-option"]
    }, metadata.showFileThumbnail && isImage && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a7835f38a1d2414$export$d65da67560512fde), {
        file: file
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $2f4919411abbde65$export$2e2bcd8739ae039)["file-option-metadata"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
        direction: "vertical",
        size: "xxxs"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        className: (0, $2f4919411abbde65$export$2e2bcd8739ae039)["file-option-name"]
    }, file.name), metadata.showFileSize && file.size ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        fontSize: "body-s",
        color: "text-body-secondary",
        className: (0, $2f4919411abbde65$export$2e2bcd8739ae039)["file-option-size"]
    }, formatFileSize(file.size)) : null, metadata.showFileLastModified && file.lastModified ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
        fontSize: "body-s",
        color: "text-body-secondary",
        className: (0, $2f4919411abbde65$export$2e2bcd8739ae039)["file-option-last-modified"]
    }, formatFileLastModified(new Date(file.lastModified))) : null)));
}




var $b9661ba9f59df7b7$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1ubbm_1iir1_9",
    "hints": "awsui_hints_1ubbm_1iir1_10"
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $04d116de8a513a7a$export$2e2bcd8739ae039 = {
    "dropzone": "awsui_dropzone_1fham_1q0g7_97",
    "dropzone-hovered": "awsui_dropzone-hovered_1fham_1q0g7_113"
};




function $7d28de5fdabb3ace$export$fc080c215a415119(multiple) {
    const [isDropzoneVisible, setDropzoneVisible] = (0, $acw62.useState)(false);
    // Registering global drag events listeners.
    (0, $acw62.useEffect)(()=>{
        // The timer helps avoiding dropzone blinking.
        let dragTimer = null;
        // The file-upload dropzone is shown when the user drags files over to the browser.
        const onDocumentDragOver = (event)=>{
            var _a, _b;
            event.preventDefault();
            let files = 0;
            for(let item = 0; item < (((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.types.length) || 0); item++)if (((_b = event.dataTransfer) === null || _b === void 0 ? void 0 : _b.types[item]) === "Files") files++;
            if (files > 0 && (multiple || files === 1)) {
                setDropzoneVisible(true);
                dragTimer && clearTimeout(dragTimer);
            }
        };
        // When the files are no longer dragged over the browser the state must be reset.
        const onDocumentDragLeave = (event)=>{
            event.preventDefault();
            dragTimer = setTimeout(()=>setDropzoneVisible(false), 25);
        };
        // If the files were dropped the state must be reset.
        const onDocumentDrop = (event)=>{
            event.preventDefault();
            dragTimer = setTimeout(()=>setDropzoneVisible(false), 25);
        };
        document.addEventListener("dragover", onDocumentDragOver, false);
        document.addEventListener("dragleave", onDocumentDragLeave, false);
        document.addEventListener("drop", onDocumentDrop, false);
        return ()=>{
            dragTimer && clearTimeout(dragTimer);
            document.removeEventListener("dragover", onDocumentDragOver);
            document.removeEventListener("dragleave", onDocumentDragLeave);
            document.removeEventListener("drop", onDocumentDrop);
        };
    }, [
        multiple
    ]);
    return isDropzoneVisible;
}
function $7d28de5fdabb3ace$export$47d4850b9fdf5af1({ onChange: onChange, children: children }) {
    const [isDropzoneHovered, setDropzoneHovered] = (0, $acw62.useState)(false);
    const onDragOver = (event)=>{
        event.preventDefault();
        if (event.dataTransfer) {
            setDropzoneHovered(true);
            event.dataTransfer.dropEffect = "copy";
        }
    };
    const onDragLeave = (event)=>{
        event.preventDefault();
        setDropzoneHovered(false);
        if (event.dataTransfer) event.dataTransfer.dropEffect = "none";
    };
    const onDrop = (event)=>{
        event.preventDefault();
        setDropzoneHovered(false);
        onChange(Array.from(event.dataTransfer.files));
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $04d116de8a513a7a$export$2e2bcd8739ae039).dropzone, isDropzoneHovered && (0, $04d116de8a513a7a$export$2e2bcd8739ae039)["dropzone-hovered"]),
        onDragOver: onDragOver,
        onDragLeave: onDragLeave,
        onDrop: onDrop
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "upload"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, children));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");


var $643a0ef0e5039139$export$2e2bcd8739ae039 = {
    "upload-button": "awsui_upload-button_4xu1k_wwhzj_97",
    "upload-input": "awsui_upload-input_4xu1k_wwhzj_98",
    "file-input-container": "awsui_file-input-container_4xu1k_wwhzj_102",
    "force-focus-outline": "awsui_force-focus-outline_4xu1k_wwhzj_111"
};








var $b2b32be85b0968b5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($b2b32be85b0968b5$var$FileInput);
function $b2b32be85b0968b5$var$FileInput(_a, ref) {
    var _b;
    var { accept: accept, ariaRequired: ariaRequired, multiple: multiple, value: value, onChange: onChange, children: children } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "accept",
        "ariaRequired",
        "multiple",
        "value",
        "onChange",
        "children"
    ]);
    const uploadInputRef = (0, $acw62.useRef)(null);
    const uploadButtonLabelId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("upload-button-label");
    const formFieldContext = (0, $4a30639b463663e4$export$824c400da192ca1b)(restProps);
    const selfControlId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("upload-input");
    const controlId = (_b = formFieldContext.controlId) !== null && _b !== void 0 ? _b : selfControlId;
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, uploadInputRef);
    const [isFocused, setIsFocused] = (0, $acw62.useState)(false);
    const onUploadButtonClick = ()=>{
        var _a;
        return (_a = uploadInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    const onUploadInputFocus = ()=>setIsFocused(true);
    const onUploadInputBlur = ()=>setIsFocused(false);
    const onUploadInputChange = ({ target: target })=>{
        onChange(target.files ? Array.from(target.files) : []);
    };
    const nativeAttributes = {
        "aria-labelledby": (0, $49fa9e74c692ea64$export$b933cda3796739ed)(formFieldContext.ariaLabelledby, uploadButtonLabelId),
        "aria-describedby": formFieldContext.ariaDescribedby
    };
    if (formFieldContext.invalid) nativeAttributes["aria-invalid"] = true;
    if (ariaRequired) nativeAttributes["aria-required"] = true;
    // Synchronizing component's value with the native file input state.
    (0, $acw62.useEffect)(()=>{
        // The DataTransfer is not available in jsdom.
        if (window.DataTransfer) {
            const dataTransfer = new DataTransfer();
            for (const file of value)dataTransfer.items.add(file);
            uploadInputRef.current.files = dataTransfer.files;
        }
        if (uploadInputRef.current) uploadInputRef.current.value = ""; // reset value to allow calling onChange when the same file is uploaded again
    }, [
        value
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $643a0ef0e5039139$export$2e2bcd8739ae039)["file-input-container"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", Object.assign({
        id: controlId,
        ref: uploadInputRef,
        type: "file",
        hidden: false,
        multiple: multiple,
        accept: accept,
        onChange: onUploadInputChange,
        onFocus: onUploadInputFocus,
        onBlur: onUploadInputBlur,
        className: (0, $643a0ef0e5039139$export$2e2bcd8739ae039)["upload-input"]
    }, nativeAttributes)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        iconName: "upload",
        formAction: "none",
        onClick: onUploadButtonClick,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $643a0ef0e5039139$export$2e2bcd8739ae039)["upload-button"], isFocused && (0, $643a0ef0e5039139$export$2e2bcd8739ae039)["force-focus-outline"]),
        __nativeAttributes: {
            tabIndex: -1,
            "aria-hidden": true
        }
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b8469ab82402f2dd$export$2e2bcd8739ae039), {
        id: uploadButtonLabelId
    }, children));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $d2fb1ae7ca5a8786$export$2e2bcd8739ae039 = {
    "root": "awsui_root_gfwv3_1gn2o_97",
    "horizontal": "awsui_horizontal_gfwv3_1gn2o_102",
    "vertical": "awsui_vertical_gfwv3_1gn2o_106",
    "list": "awsui_list_gfwv3_1gn2o_110",
    "list-item": "awsui_list-item_gfwv3_1gn2o_130",
    "toggle-container-inline": "awsui_toggle-container-inline_gfwv3_1gn2o_137",
    "toggle": "awsui_toggle_gfwv3_1gn2o_137",
    "description": "awsui_description_gfwv3_1gn2o_232",
    "separator": "awsui_separator_gfwv3_1gn2o_236"
};



function $32c25cc8bcb71de1$export$2e2bcd8739ae039({ controlId: controlId, allHidden: allHidden, expanded: expanded, numberOfHiddenOptions: numberOfHiddenOptions, onClick: onClick, i18nStrings: i18nStrings = {}, limitShowFewerAriaLabel: limitShowFewerAriaLabel, limitShowMoreAriaLabel: limitShowMoreAriaLabel }) {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("token-group");
    const numberOfHiddenOptionLabel = allHidden ? numberOfHiddenOptions : `+${numberOfHiddenOptions}`;
    const description = expanded ? i18n("i18nStrings.limitShowFewer", i18nStrings.limitShowFewer) : `${i18n("i18nStrings.limitShowMore", i18nStrings.limitShowMore) || ""} (${numberOfHiddenOptionLabel})`;
    const ariaLabel = expanded ? limitShowFewerAriaLabel : limitShowMoreAriaLabel;
    const handleClick = (0, $acw62.useCallback)(()=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onClick, null);
    }, [
        onClick
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        className: (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).toggle,
        onClick: handleClick,
        "aria-controls": controlId,
        "aria-expanded": expanded,
        "aria-label": ariaLabel
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: expanded ? "treeview-collapse" : "treeview-expand"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).description
    }, description));
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


const $9e88e8cfee9def2e$var$tokenSelector = `.${(0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039)["list-item"]}`;
const $9e88e8cfee9def2e$var$toggleButtonSelector = `.${(0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).toggle}`;
function $9e88e8cfee9def2e$export$360e20be3d219ccd({ moveFocusNextToIndex: moveFocusNextToIndex }) {
    const tokenListRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        if (moveFocusNextToIndex === undefined || moveFocusNextToIndex === null || tokenListRef.current === null) return;
        const tokenElements = tokenListRef.current.querySelectorAll($9e88e8cfee9def2e$var$tokenSelector);
        const toggleButton = tokenListRef.current.querySelector($9e88e8cfee9def2e$var$toggleButtonSelector);
        let closestPrevIndex = Number.NEGATIVE_INFINITY;
        let closestNextIndex = Number.POSITIVE_INFINITY;
        for(let activeIndex = 0; activeIndex < tokenElements.length; activeIndex++)if (activeIndex < moveFocusNextToIndex) closestPrevIndex = moveFocusNextToIndex - activeIndex < moveFocusNextToIndex - closestPrevIndex ? activeIndex : closestPrevIndex;
        else closestNextIndex = activeIndex - moveFocusNextToIndex < closestNextIndex - moveFocusNextToIndex ? activeIndex : closestNextIndex;
        const nextElement = tokenElements[closestNextIndex];
        const prevElement = tokenElements[closestPrevIndex];
        if (nextElement instanceof HTMLElement) (_a = (0, $eaddf2de854ee801$export$748138f04a69bf21)(nextElement)) === null || _a === void 0 || _a.focus();
        else if (prevElement instanceof HTMLElement) (_b = (0, $eaddf2de854ee801$export$748138f04a69bf21)(prevElement)) === null || _b === void 0 || _b.focus();
        else if (toggleButton instanceof HTMLElement) toggleButton.focus();
    }, [
        moveFocusNextToIndex
    ]);
    return tokenListRef;
}


function $1e34c3ccd4808258$export$2e2bcd8739ae039({ items: items, alignment: alignment, renderItem: renderItem, limit: limit, after: after, i18nStrings: i18nStrings, limitShowFewerAriaLabel: limitShowFewerAriaLabel, limitShowMoreAriaLabel: limitShowMoreAriaLabel, moveFocusNextToIndex: moveFocusNextToIndex, onExpandedClick: onExpandedClick = ()=>undefined }) {
    const tokenListRef = (0, $9e88e8cfee9def2e$export$360e20be3d219ccd)({
        moveFocusNextToIndex: moveFocusNextToIndex
    });
    const controlId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)();
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const hasItems = items.length > 0;
    const hasHiddenItems = hasItems && limit !== undefined && items.length > limit;
    const visibleItems = hasHiddenItems && !expanded ? items.slice(0, limit) : items;
    const hasVisibleItems = visibleItems.length > 0;
    const toggle = hasHiddenItems ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039)[`toggle-container-${alignment}`]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $32c25cc8bcb71de1$export$2e2bcd8739ae039), {
        controlId: hasVisibleItems ? controlId : undefined,
        allHidden: limit === 0,
        expanded: expanded,
        numberOfHiddenOptions: items.length - visibleItems.length,
        i18nStrings: i18nStrings,
        limitShowFewerAriaLabel: limitShowFewerAriaLabel,
        limitShowMoreAriaLabel: limitShowMoreAriaLabel,
        onClick: ()=>{
            const isExpanded = !expanded;
            setExpanded(isExpanded);
            onExpandedClick(isExpanded);
        }
    })) : null;
    if (alignment === "inline") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: tokenListRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).root, (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).horizontal)
    }, hasItems && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        id: controlId,
        className: (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).list
    }, visibleItems.map((item, itemIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: itemIndex,
            className: (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039)["list-item"],
            "aria-setsize": items.length,
            "aria-posinset": itemIndex + 1
        }, renderItem(item, itemIndex)))), toggle, after && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).separator
    }), after);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: tokenListRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).root, (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).vertical)
    }, hasVisibleItems && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        id: controlId,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039).list, (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039)[alignment])
    }, visibleItems.map((item, itemIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: itemIndex,
            className: (0, $d2fb1ae7ca5a8786$export$2e2bcd8739ae039)["list-item"],
            "aria-setsize": items.length,
            "aria-posinset": itemIndex + 1
        }, renderItem(item, itemIndex)))), toggle, after);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $c8fe48aa6495c25f$export$2e2bcd8739ae039 = {
    "root": "awsui_root_dm8gx_r6wxu_101",
    "has-items": "awsui_has-items_dm8gx_r6wxu_135",
    "no-padding": "awsui_no-padding_dm8gx_r6wxu_135",
    "dismiss-button": "awsui_dismiss-button_dm8gx_r6wxu_139",
    "token": "awsui_token_dm8gx_r6wxu_181",
    "token-box": "awsui_token-box_dm8gx_r6wxu_188",
    "token-box-error": "awsui_token-box-error_dm8gx_r6wxu_207",
    "token-box-warning": "awsui_token-box-warning_dm8gx_r6wxu_218",
    "token-box-readonly": "awsui_token-box-readonly_dm8gx_r6wxu_229",
    "token-box-disabled": "awsui_token-box-disabled_dm8gx_r6wxu_243"
};



var $0c38a39f20f6e38f$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)($0c38a39f20f6e38f$var$DismissButton);
function $0c38a39f20f6e38f$var$DismissButton({ disabled: disabled, dismissLabel: dismissLabel, onDismiss: onDismiss, readOnly: readOnly }, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: ref,
        type: "button",
        className: (0, $c8fe48aa6495c25f$export$2e2bcd8739ae039)["dismiss-button"],
        "aria-disabled": disabled || readOnly ? true : undefined,
        onClick: ()=>{
            if (disabled || readOnly || !onDismiss) return;
            onDismiss();
        },
        "aria-label": dismissLabel
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "close"
    }));
}






function $dc476979934495de$export$50792b0e93539fde(_a) {
    var { ariaLabel: ariaLabel, disabled: disabled, readOnly: readOnly, dismissLabel: dismissLabel, onDismiss: onDismiss, children: children, errorText: errorText, warningText: warningText, errorIconAriaLabel: errorIconAriaLabel, warningIconAriaLabel: warningIconAriaLabel } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "ariaLabel",
        "disabled",
        "readOnly",
        "dismissLabel",
        "onDismiss",
        "children",
        "errorText",
        "warningText",
        "errorIconAriaLabel",
        "warningIconAriaLabel"
    ]);
    const errorId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("error");
    const warningId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("warning");
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const showWarning = warningText && !errorText;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c8fe48aa6495c25f$export$2e2bcd8739ae039).token, baseProps.className),
        role: "group",
        "aria-label": ariaLabel,
        "aria-describedby": errorText ? errorId : warningText ? warningId : undefined,
        "aria-disabled": disabled
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c8fe48aa6495c25f$export$2e2bcd8739ae039)["token-box"], disabled && (0, $c8fe48aa6495c25f$export$2e2bcd8739ae039)["token-box-disabled"], readOnly && (0, $c8fe48aa6495c25f$export$2e2bcd8739ae039)["token-box-readonly"], errorText && (0, $c8fe48aa6495c25f$export$2e2bcd8739ae039)["token-box-error"], showWarning && (0, $c8fe48aa6495c25f$export$2e2bcd8739ae039)["token-box-warning"])
    }, children, onDismiss && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0c38a39f20f6e38f$export$2e2bcd8739ae039), {
        disabled: disabled,
        dismissLabel: dismissLabel,
        onDismiss: onDismiss,
        readOnly: readOnly
    })), errorText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$4852ecce5ecf6bcb), {
        id: errorId,
        errorIconAriaLabel: errorIconAriaLabel
    }, errorText), showWarning && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$7f93a80d0cfdba0c), {
        id: warningId,
        warningIconAriaLabel: warningIconAriaLabel
    }, warningText));
}








var $8bc91695888761ff$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($8bc91695888761ff$var$InternalFileUpload);
function $8bc91695888761ff$var$InternalFileUpload(_a, externalRef) {
    var _b;
    var { accept: accept, ariaRequired: ariaRequired, multiple: multiple = false, onChange: onChange, value: value, tokenLimit: tokenLimit, showFileSize: showFileSize, showFileLastModified: showFileLastModified, showFileThumbnail: showFileThumbnail, i18nStrings: i18nStrings, __internalRootRef: __internalRootRef = null, constraintText: constraintText, errorText: errorText, warningText: warningText, fileErrors: fileErrors, fileWarnings: fileWarnings } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "accept",
        "ariaRequired",
        "multiple",
        "onChange",
        "value",
        "tokenLimit",
        "showFileSize",
        "showFileLastModified",
        "showFileThumbnail",
        "i18nStrings",
        "__internalRootRef",
        "constraintText",
        "errorText",
        "warningText",
        "fileErrors",
        "fileWarnings"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const metadata = {
        showFileSize: showFileSize,
        showFileLastModified: showFileLastModified,
        showFileThumbnail: showFileThumbnail
    };
    const errorId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("error-");
    const warningId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("warning-");
    const constraintTextId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("constraint-text-");
    const fileInputRef = (0, $acw62.useRef)(null);
    const ref = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(fileInputRef, externalRef);
    const [removedFileIndex, setRemovedFileIndex] = (0, $acw62.useState)(null);
    (0, $6175122c42c548ad$export$2e2bcd8739ae039)("FileUpload", "value", value, "onChange", onChange);
    if (!multiple && value.length > 1) (0, $dd646455762bc7b9$export$5b28268982f175ba)("FileUpload", "Value must be an array of size 0 or 1 when `multiple=false`.");
    const handleFilesChange = (newFiles)=>{
        const newValue = multiple ? [
            ...value,
            ...newFiles
        ] : newFiles[0] ? newFiles : [
            ...value
        ];
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            value: newValue
        });
    };
    const onFileRemove = (removeFileIndex)=>{
        var _a;
        const newValue = value.filter((_, fileIndex)=>fileIndex !== removeFileIndex);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            value: newValue
        });
        setRemovedFileIndex(removeFileIndex);
        if (value.length === 1) (_a = fileInputRef.current) === null || _a === void 0 || _a.focus();
    };
    const isDropzoneVisible = (0, $7d28de5fdabb3ace$export$fc080c215a415119)(multiple);
    const showWarning = warningText && !errorText;
    if (warningText && errorText) (0, $dd646455762bc7b9$export$5b28268982f175ba)("FileUpload", "Both `errorText` and `warningText` exist. `warningText` will not be shown.");
    const formFieldContext = (0, $4a30639b463663e4$export$824c400da192ca1b)(restProps);
    const ariaDescribedBy = (0, $49fa9e74c692ea64$export$b933cda3796739ed)((_b = restProps.ariaDescribedby) !== null && _b !== void 0 ? _b : formFieldContext.ariaDescribedby, errorText ? errorId : undefined, showWarning ? warningId : undefined, constraintText ? constraintTextId : undefined);
    const hasError = Boolean(errorText || (fileErrors === null || fileErrors === void 0 ? void 0 : fileErrors.filter(Boolean).length));
    const invalid = restProps.invalid || formFieldContext.invalid || hasError;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), Object.assign({}, baseProps, {
        size: "xs",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $b9661ba9f59df7b7$export$2e2bcd8739ae039).root),
        __internalRootRef: __internalRootRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), null, isDropzoneVisible ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7d28de5fdabb3ace$export$47d4850b9fdf5af1), {
        onChange: handleFilesChange
    }, i18nStrings.dropzoneText(multiple)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2b32be85b0968b5$export$2e2bcd8739ae039), Object.assign({
        ref: ref,
        accept: accept,
        ariaRequired: ariaRequired,
        multiple: multiple,
        onChange: handleFilesChange,
        value: value
    }, restProps, {
        ariaDescribedby: ariaDescribedBy,
        invalid: invalid
    }), i18nStrings.uploadButtonText(multiple)), (constraintText || errorText || warningText) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $b9661ba9f59df7b7$export$2e2bcd8739ae039).hints
    }, errorText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$4852ecce5ecf6bcb), {
        id: errorId,
        errorIconAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.errorIconAriaLabel
    }, errorText), showWarning && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$7f93a80d0cfdba0c), {
        id: warningId,
        warningIconAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.warningIconAriaLabel
    }, warningText), constraintText && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$d907c2d8d9ae85b4), {
        id: constraintTextId,
        hasValidationText: !!errorText || !!warningText
    }, constraintText))), !multiple && value.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc476979934495de$export$50792b0e93539fde), {
        ariaLabel: value[0].name,
        dismissLabel: i18nStrings.removeFileAriaLabel(0),
        onDismiss: ()=>onFileRemove(0),
        errorText: fileErrors === null || fileErrors === void 0 ? void 0 : fileErrors[0],
        warningText: fileWarnings === null || fileWarnings === void 0 ? void 0 : fileWarnings[0],
        errorIconAriaLabel: i18nStrings.errorIconAriaLabel,
        warningIconAriaLabel: i18nStrings.warningIconAriaLabel,
        "data-index": 0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f8811903aa9878e$export$9c7b13df4d1e0eeb), {
        file: value[0],
        metadata: metadata,
        i18nStrings: i18nStrings
    }))) : null, multiple && value.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1e34c3ccd4808258$export$2e2bcd8739ae039), {
        alignment: "vertical",
        items: value,
        renderItem: (file, fileIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc476979934495de$export$50792b0e93539fde), {
                ariaLabel: file.name,
                dismissLabel: i18nStrings.removeFileAriaLabel(fileIndex),
                onDismiss: ()=>onFileRemove(fileIndex),
                errorText: fileErrors === null || fileErrors === void 0 ? void 0 : fileErrors[fileIndex],
                warningText: fileWarnings === null || fileWarnings === void 0 ? void 0 : fileWarnings[fileIndex],
                errorIconAriaLabel: i18nStrings.errorIconAriaLabel,
                warningIconAriaLabel: i18nStrings.warningIconAriaLabel,
                "data-index": fileIndex
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f8811903aa9878e$export$9c7b13df4d1e0eeb), {
                file: file,
                metadata: metadata,
                i18nStrings: i18nStrings
            })),
        limit: tokenLimit,
        i18nStrings: {
            limitShowFewer: i18nStrings.limitShowFewer,
            limitShowMore: i18nStrings.limitShowMore
        },
        moveFocusNextToIndex: removedFileIndex
    })) : null);
}




const $0caa904d8e7106e8$var$FileUpload = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { multiple: multiple, showFileSize: showFileSize, showFileLastModified: showFileLastModified, showFileThumbnail: showFileThumbnail } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "multiple",
        "showFileSize",
        "showFileLastModified",
        "showFileThumbnail"
    ]);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("FileUpload", {
        props: {
            multiple: multiple,
            showFileLastModified: showFileLastModified,
            showFileSize: showFileSize,
            showFileThumbnail: showFileThumbnail,
            tokenLimit: restProps.tokenLimit
        }
    });
    const externalProps = (0, $3833f34df478664f$export$21af416108db3048)(restProps);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8bc91695888761ff$export$2e2bcd8739ae039), Object.assign({
        ref: ref,
        multiple: multiple,
        showFileSize: showFileSize,
        showFileLastModified: showFileLastModified,
        showFileThumbnail: showFileThumbnail
    }, externalProps, baseComponentProps));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($0caa904d8e7106e8$var$FileUpload, "FileUpload");
var $0caa904d8e7106e8$export$2e2bcd8739ae039 = $0caa904d8e7106e8$var$FileUpload;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");






const $a3e6bb5a1ebc1aee$var$searchableFields = [
    "value",
    "label",
    "description",
    "labelTag"
];
const $a3e6bb5a1ebc1aee$export$10ef3d2ac5f88595 = (value, searchText, strictMatching)=>{
    if (!value) return false;
    const index = value.toLowerCase().indexOf(searchText);
    return strictMatching ? index === 0 : index > -1;
};
const $a3e6bb5a1ebc1aee$var$matchesSingleOption = (dropdownOption, text, strictMatching)=>{
    const searchText = text.toLowerCase();
    const option = dropdownOption.option;
    const searchStrFields = (attr)=>$a3e6bb5a1ebc1aee$export$10ef3d2ac5f88595(option[attr], searchText, strictMatching);
    const searchTagsFields = (attr)=>{
        var _a;
        return (_a = option[attr]) === null || _a === void 0 ? void 0 : _a.some((value)=>$a3e6bb5a1ebc1aee$export$10ef3d2ac5f88595(value, searchText, strictMatching));
    };
    const searchableTagFields = [
        "tags"
    ];
    if (!strictMatching) searchableTagFields.push("filteringTags");
    return $a3e6bb5a1ebc1aee$var$searchableFields.some(searchStrFields) || searchableTagFields.some(searchTagsFields);
};
const $a3e6bb5a1ebc1aee$export$60d56ed3961c839c = (options, searchText, strictMatching = false)=>{
    if (searchText === "") return options;
    let currentGroup = null;
    let parentMatched = false;
    return options.reduce((acc, option)=>{
        if (option.type === "parent") {
            parentMatched = false;
            currentGroup = option;
            if ($a3e6bb5a1ebc1aee$var$matchesSingleOption(option, searchText, strictMatching)) {
                parentMatched = true;
                acc.push(currentGroup);
            }
            return acc;
        }
        if (option.type !== "child") {
            currentGroup = null;
            parentMatched = false;
        }
        if (parentMatched) acc.push(option);
        else if ($a3e6bb5a1ebc1aee$var$matchesSingleOption(option, searchText, strictMatching)) {
            if (currentGroup) {
                acc.push(currentGroup);
                currentGroup = null;
            }
            acc.push(option);
        }
        return acc;
    }, []);
};
const $a3e6bb5a1ebc1aee$export$6af67c5380a168e2 = (option)=>!!option && !option.disabled && option.type !== "parent";
const $a3e6bb5a1ebc1aee$export$8269a10a0c239702 = (option)=>!!option && !option.disabled;
const $a3e6bb5a1ebc1aee$export$d7976824e9f55785 = (option)=>!!option && "options" in option;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $3b310b443add1678$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1afi9_1aapr_97",
    "hidden": "awsui_hidden_1afi9_1aapr_131",
    "no-items": "awsui_no-items_1afi9_1aapr_134"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



var $929891dc2e9a9ff2$export$2e2bcd8739ae039 = {
    "icon-shake": "awsui_icon-shake_1cbgc_pjowk_101",
    "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_1cbgc_pjowk_1",
    "container-fade-in": "awsui_container-fade-in_1cbgc_pjowk_129",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1cbgc_pjowk_1",
    "root": "awsui_root_1cbgc_pjowk_151",
    "status-error": "awsui_status-error_1cbgc_pjowk_160",
    "status-warning": "awsui_status-warning_1cbgc_pjowk_163",
    "status-success": "awsui_status-success_1cbgc_pjowk_166",
    "status-info": "awsui_status-info_1cbgc_pjowk_169",
    "status-stopped": "awsui_status-stopped_1cbgc_pjowk_172",
    "status-pending": "awsui_status-pending_1cbgc_pjowk_175",
    "status-in-progress": "awsui_status-in-progress_1cbgc_pjowk_178",
    "status-loading": "awsui_status-loading_1cbgc_pjowk_181",
    "color-override-red": "awsui_color-override-red_1cbgc_pjowk_184",
    "color-override-grey": "awsui_color-override-grey_1cbgc_pjowk_187",
    "color-override-blue": "awsui_color-override-blue_1cbgc_pjowk_190",
    "color-override-green": "awsui_color-override-green_1cbgc_pjowk_193",
    "color-override-yellow": "awsui_color-override-yellow_1cbgc_pjowk_196",
    "container": "awsui_container_1cbgc_pjowk_129",
    "display-inline": "awsui_display-inline_1cbgc_pjowk_200",
    "icon": "awsui_icon_1cbgc_pjowk_101",
    "display-inline-block": "awsui_display-inline-block_1cbgc_pjowk_208",
    "overflow-ellipsis": "awsui_overflow-ellipsis_1cbgc_pjowk_217"
};




const $1ffdf6cc8746b93a$var$typeToIcon = (size)=>({
        error: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-negative",
            size: size
        }),
        warning: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-warning",
            size: size
        }),
        success: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-positive",
            size: size
        }),
        info: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-info",
            size: size
        }),
        stopped: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-stopped",
            size: size
        }),
        pending: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-pending",
            size: size
        }),
        "in-progress": (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
            name: "status-in-progress",
            size: size
        }),
        loading: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1101525b84777b8e$export$2e2bcd8739ae039), null)
    });
function $1ffdf6cc8746b93a$export$2e2bcd8739ae039(_a) {
    var { type: type, children: children, iconAriaLabel: iconAriaLabel, colorOverride: colorOverride, wrapText: wrapText = true, __animate: __animate = false, __internalRootRef: __internalRootRef, __size: __size = "normal", __display: __display = "inline-block" } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "type",
        "children",
        "iconAriaLabel",
        "colorOverride",
        "wrapText",
        "__animate",
        "__internalRootRef",
        "__size",
        "__display"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $929891dc2e9a9ff2$export$2e2bcd8739ae039).root, (0, $929891dc2e9a9ff2$export$2e2bcd8739ae039)[`status-${type}`], {
            [(0, $929891dc2e9a9ff2$export$2e2bcd8739ae039)[`color-override-${colorOverride}`]]: colorOverride
        }, baseProps.className),
        ref: __internalRootRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $929891dc2e9a9ff2$export$2e2bcd8739ae039).container, (0, $929891dc2e9a9ff2$export$2e2bcd8739ae039)[`display-${__display}`], wrapText === false && (0, $929891dc2e9a9ff2$export$2e2bcd8739ae039)["overflow-ellipsis"], __animate && (0, $929891dc2e9a9ff2$export$2e2bcd8739ae039)["container-fade-in"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $929891dc2e9a9ff2$export$2e2bcd8739ae039).icon, __animate && (0, $929891dc2e9a9ff2$export$2e2bcd8739ae039)["icon-shake"]),
        "aria-label": iconAriaLabel,
        role: iconAriaLabel ? "img" : undefined
    }, $1ffdf6cc8746b93a$var$typeToIcon(__size)[type], __display === "inline" && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, "\xa0")), children));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
const $adcc0ef515e81249$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};



var $18244bc9191d76b9$export$2e2bcd8739ae039 = {
    "root": "awsui_root_vrgzu_95md8_97",
    "recovery": "awsui_recovery_vrgzu_95md8_135"
};


function $41901c188ad0f2ad$var$DropdownStatus({ children: children }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $18244bc9191d76b9$export$2e2bcd8739ae039).root
    }, children);
}
const $41901c188ad0f2ad$export$5467db17117c3a32 = ({ statusType: statusType, empty: empty, loadingText: loadingText, finishedText: finishedText, filteringResultsText: filteringResultsText, errorText: errorText, recoveryText: recoveryText, isEmpty: isEmpty, isNoMatch: isNoMatch, isFiltered: isFiltered, noMatch: noMatch, onRecoveryClick: onRecoveryClick, hasRecoveryCallback: hasRecoveryCallback = false, errorIconAriaLabel: errorIconAriaLabel })=>{
    const previousStatusType = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(statusType);
    const statusResult = {
        isSticky: true,
        content: null
    };
    if (statusType === "loading") statusResult.content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ffdf6cc8746b93a$export$2e2bcd8739ae039), {
        type: "loading"
    }, loadingText);
    else if (statusType === "error") statusResult.content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ffdf6cc8746b93a$export$2e2bcd8739ae039), {
        type: "error",
        __display: "inline",
        __animate: previousStatusType !== "error",
        iconAriaLabel: errorIconAriaLabel
    }, errorText), " ", !!recoveryText && hasRecoveryCallback && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $01503a290f20b804$export$2e2bcd8739ae039), {
        onFollow: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onRecoveryClick),
        variant: "recovery",
        className: (0, $18244bc9191d76b9$export$2e2bcd8739ae039).recovery
    }, recoveryText));
    else if (isEmpty && empty) statusResult.content = empty;
    else if (isNoMatch && noMatch) statusResult.content = noMatch;
    else if (isFiltered && filteringResultsText) statusResult.content = filteringResultsText;
    else if (statusType === "finished" && finishedText) {
        statusResult.content = finishedText;
        statusResult.isSticky = false;
    }
    return statusResult;
};
var $41901c188ad0f2ad$export$2e2bcd8739ae039 = $41901c188ad0f2ad$var$DropdownStatus;



const $4d1a5dc327bab5f7$var$DropdownFooter = ({ content: content, id: id, hasItems: hasItems = true })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $3b310b443add1678$export$2e2bcd8739ae039).root, {
            [(0, $3b310b443add1678$export$2e2bcd8739ae039).hidden]: content === null,
            [(0, $3b310b443add1678$export$2e2bcd8739ae039)["no-items"]]: !hasItems
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), {
        visible: true,
        tagName: "div",
        id: id
    }, content && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $41901c188ad0f2ad$export$2e2bcd8739ae039), null, content)));
var $4d1a5dc327bab5f7$export$2e2bcd8739ae039 = $4d1a5dc327bab5f7$var$DropdownFooter;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $2c9d1cbc9ede1e89$export$7baa7c13b358b002 = (options)=>{
    const parentMap = new Map();
    const flatOptions = options.reduce((acc, option)=>{
        if ("options" in option) {
            const { options: options } = option, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(option, [
                "options"
            ]);
            const parentDropdownOption = {
                type: "parent",
                option: option
            };
            const allOptionsDisabled = options.every((option)=>option.disabled);
            if (option.disabled || allOptionsDisabled) parentDropdownOption.disabled = true;
            acc.push(parentDropdownOption);
            options.forEach((child)=>{
                const childDropdownOption = {
                    type: "child",
                    option: child
                };
                if (rest.disabled || child.disabled) childDropdownOption.disabled = true;
                acc.push(childDropdownOption);
                parentMap.set(childDropdownOption, parentDropdownOption);
            });
        } else {
            const dropdownOption = {
                option: option
            };
            if (option.disabled) dropdownOption.disabled = true;
            acc.push(dropdownOption);
        }
        return acc;
    }, []);
    return {
        flatOptions: flatOptions,
        parentMap: parentMap
    };
};



const $319ac672533f1934$var$testIndexMap = new WeakMap();
const $319ac672533f1934$export$7a93927e4b42a61f = (item)=>$319ac672533f1934$var$testIndexMap.get(item);
const $319ac672533f1934$export$d803820991dee08 = (filteredItems, getParentGroup)=>{
    let throughIndex = 1;
    let groupIndex = 0;
    let inGroupIndex = 1;
    let currentGroup = null;
    filteredItems.forEach((item)=>{
        const isGroup = item.type === "parent";
        const group = isGroup ? item : getParentGroup(item);
        if (group && group !== currentGroup) {
            currentGroup = group;
            groupIndex += 1;
            inGroupIndex = 1;
        }
        if (isGroup) $319ac672533f1934$var$testIndexMap.set(item, {
            groupIndex: groupIndex
        });
        else if (group && item.type === "child") $319ac672533f1934$var$testIndexMap.set(item, {
            throughIndex: throughIndex++,
            groupIndex: groupIndex,
            inGroupIndex: inGroupIndex++
        });
        else if (item.type === "child" || !item.type) $319ac672533f1934$var$testIndexMap.set(item, {
            throughIndex: throughIndex++
        });
    });
};


function $842e88ad945f2818$export$3b43bf09494a926b(options, filteringType, filteringText) {
    const { flatOptions: flatOptions, parentMap: parentMap } = (0, $2c9d1cbc9ede1e89$export$7baa7c13b358b002)(options);
    const filteredOptions = filteringType !== "auto" ? flatOptions : (0, $a3e6bb5a1ebc1aee$export$60d56ed3961c839c)(flatOptions, filteringText);
    (0, $319ac672533f1934$export$d803820991dee08)(filteredOptions, parentMap.get.bind(parentMap));
    return {
        filteredOptions: filteredOptions,
        parentMap: parentMap,
        totalCount: flatOptions.length,
        matchesCount: filteredOptions.length
    };
}






var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
class $984ac970450c0ae3$export$7874144f5bc63567 {
    constructor(type, moveFocus = type === "keyboard"){
        this.type = type;
        this.moveFocus = moveFocus;
    }
}
function $984ac970450c0ae3$export$160d4638fe61b58a({ options: options, isHighlightable: isHighlightable }) {
    const [highlightedIndex, setHighlightedIndexState] = (0, $acw62.useState)(-1);
    const [highlightType, setHighlightType] = (0, $acw62.useState)(new $984ac970450c0ae3$export$7874144f5bc63567("keyboard"));
    const setHighlightedIndex = (0, $acw62.useCallback)((index, highlightType)=>{
        setHighlightedIndexState(index);
        setHighlightType(highlightType);
    }, []);
    const highlightedOption = options[highlightedIndex] && isHighlightable(options[highlightedIndex]) ? options[highlightedIndex] : undefined;
    const moveHighlightFrom = (direction, startIndex = highlightedIndex, highlightType)=>{
        const fromBottomEnd = startIndex === -1 && direction === -1;
        let newIndex = fromBottomEnd ? options.length : startIndex;
        do newIndex += direction;
        while (options[newIndex] && !isHighlightable(options[newIndex]));
        if (options[newIndex]) setHighlightedIndex(newIndex, highlightType);
    };
    const moveHighlight = (direction, highlightType)=>moveHighlightFrom(direction, highlightedIndex, highlightType);
    const highlightOption = (0, $acw62.useCallback)((option, highlightType)=>{
        const index = options.indexOf(option);
        setHighlightedIndex(index, highlightType);
    }, [
        options,
        setHighlightedIndex
    ]);
    return [
        {
            highlightType: highlightType,
            highlightedIndex: highlightedIndex,
            highlightedOption: highlightedOption
        },
        {
            setHighlightedIndexWithMouse: (index, moveFocus = false)=>setHighlightedIndex(index, new $984ac970450c0ae3$export$7874144f5bc63567("mouse", moveFocus)),
            moveHighlightWithKeyboard: (direction)=>moveHighlight(direction, new $984ac970450c0ae3$export$7874144f5bc63567("keyboard")),
            highlightOptionWithKeyboard: (option)=>highlightOption(option, new $984ac970450c0ae3$export$7874144f5bc63567("keyboard")),
            resetHighlightWithKeyboard: ()=>setHighlightedIndex(-1, new $984ac970450c0ae3$export$7874144f5bc63567("keyboard")),
            goHomeWithKeyboard: ()=>moveHighlightFrom(1, -1, new $984ac970450c0ae3$export$7874144f5bc63567("keyboard")),
            goEndWithKeyboard: ()=>moveHighlightFrom(-1, options.length, new $984ac970450c0ae3$export$7874144f5bc63567("keyboard"))
        }
    ];
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

const $39379ec6775359b3$var$HOME = 36;
const $39379ec6775359b3$var$END = 35;
const $39379ec6775359b3$export$7994f81da2f6972c = ({ goUp: goUp, goDown: goDown, selectOption: selectOption, goHome: goHome, goEnd: goEnd, closeDropdown: closeDropdown, preventNativeSpace: preventNativeSpace = false })=>{
    return (0, $acw62.useCallback)((e)=>{
        switch(e.detail.keyCode){
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up:
                e.preventDefault();
                goUp();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down:
                e.preventDefault();
                goDown();
                break;
            case $39379ec6775359b3$var$HOME:
                goHome();
                break;
            case $39379ec6775359b3$var$END:
                goEnd();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).escape:
                e.stopPropagation();
                closeDropdown();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter:
                e.preventDefault();
                selectOption();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space:
                if (preventNativeSpace) {
                    e.preventDefault();
                    selectOption();
                }
        }
    }, [
        selectOption,
        goHome,
        goEnd,
        closeDropdown,
        preventNativeSpace,
        goUp,
        goDown
    ]);
};
const $39379ec6775359b3$export$212c9ac9ac4f6242 = ({ openDropdown: openDropdown, goHome: goHome })=>{
    return (0, $acw62.useCallback)((e)=>{
        switch(e.detail.keyCode){
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up:
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down:
                e.preventDefault();
                goHome();
                openDropdown();
                break;
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space:
            case (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter:
                e.preventDefault();
                openDropdown();
                break;
        }
    }, [
        openDropdown,
        goHome
    ]);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $771626752877e74e$export$a53dab9d69563a9d = (menuId, index)=>{
    if (index < 0) return undefined;
    return `${menuId}-option-${index}`;
};


const $80c0308d36c0fca6$export$c85ed1874bcf2a02 = (options, selectedOptions)=>{
    return (selectedOptions || []).map((selectedOption)=>{
        for (const dropdownOption of options){
            if (dropdownOption.type !== "parent" && dropdownOption.option.value === selectedOption.value) return dropdownOption;
        }
        return {
            option: selectedOption
        };
    });
};
const $80c0308d36c0fca6$export$333e23643ef496e4 = (options, option)=>{
    for(let index = 0; index < options.length; index++){
        const __option = options[index];
        if (__option === option || __option.value === option.value) return index;
    }
    return -1;
};






function $6b2e7bdae89bf6e1$export$e64b2f635402ca43({ selectedOptions: selectedOptions, updateSelectedOption: updateSelectedOption, options: options, filteringType: filteringType, onBlur: onBlur, onFocus: onFocus, externalRef: externalRef, keepOpen: keepOpen, fireLoadItems: fireLoadItems, setFilteringValue: setFilteringValue, useInteractiveGroups: useInteractiveGroups = false, statusType: statusType }) {
    const interactivityCheck = useInteractiveGroups ? (0, $a3e6bb5a1ebc1aee$export$8269a10a0c239702) : (0, $a3e6bb5a1ebc1aee$export$6af67c5380a168e2);
    const isHighlightable = (option)=>!!option && (useInteractiveGroups || option.type !== "parent");
    const filterRef = (0, $acw62.useRef)(null);
    const triggerRef = (0, $acw62.useRef)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const hasFilter = filteringType !== "none";
    const activeRef = hasFilter ? filterRef : menuRef;
    const __selectedOptions = (0, $80c0308d36c0fca6$export$c85ed1874bcf2a02)(options, selectedOptions);
    const __selectedValuesSet = selectedOptions.reduce((selectedValuesSet, item)=>{
        if (item.value) selectedValuesSet.add(item.value);
        return selectedValuesSet;
    }, new Set());
    const [{ highlightType: highlightType, highlightedOption: highlightedOption, highlightedIndex: highlightedIndex }, { moveHighlightWithKeyboard: moveHighlightWithKeyboard, resetHighlightWithKeyboard: resetHighlightWithKeyboard, setHighlightedIndexWithMouse: setHighlightedIndexWithMouse, highlightOptionWithKeyboard: highlightOptionWithKeyboard, goHomeWithKeyboard: goHomeWithKeyboard, goEndWithKeyboard: goEndWithKeyboard }] = (0, $984ac970450c0ae3$export$160d4638fe61b58a)({
        options: options,
        isHighlightable: isHighlightable
    });
    const { isOpen: isOpen, openDropdown: openDropdown, closeDropdown: closeDropdown, toggleDropdown: toggleDropdown, openedWithKeyboard: openedWithKeyboard } = (0, $aff605ad4173beb7$export$7d3a09d5141ab1f4)({
        onOpen: ()=>fireLoadItems(""),
        onClose: ()=>{
            resetHighlightWithKeyboard();
            setFilteringValue("");
        }
    });
    const handleFocus = ()=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus, {});
    };
    const handleBlur = ()=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur, {});
        closeDropdown();
    };
    const hasSelectedOption = __selectedOptions.length > 0;
    const menuId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("option-list");
    const dialogId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("dialog");
    const highlightedOptionId = (0, $771626752877e74e$export$a53dab9d69563a9d)(menuId, highlightedIndex);
    const selectOption = (option)=>{
        var _a;
        const optionToSelect = option || highlightedOption;
        if (!optionToSelect || !interactivityCheck(optionToSelect)) return;
        updateSelectedOption(optionToSelect.option);
        if (!keepOpen) {
            (_a = triggerRef.current) === null || _a === void 0 || _a.focus();
            closeDropdown();
        }
    };
    const activeKeyDownHandler = (0, $39379ec6775359b3$export$7994f81da2f6972c)({
        goUp: ()=>{
            if (!useInteractiveGroups && (highlightedOption === null || highlightedOption === void 0 ? void 0 : highlightedOption.type) === "child" && highlightedIndex === 1 || highlightedIndex === 0) {
                goEndWithKeyboard();
                return;
            }
            moveHighlightWithKeyboard(-1);
        },
        goDown: ()=>{
            if (highlightedIndex === options.length - 1) {
                goHomeWithKeyboard();
                return;
            }
            moveHighlightWithKeyboard(1);
        },
        selectOption: selectOption,
        goHome: goHomeWithKeyboard,
        goEnd: goEndWithKeyboard,
        closeDropdown: ()=>{
            var _a;
            (_a = triggerRef.current) === null || _a === void 0 || _a.focus();
            closeDropdown();
        },
        preventNativeSpace: !hasFilter
    });
    const triggerKeyDownHandler = (0, $39379ec6775359b3$export$212c9ac9ac4f6242)({
        openDropdown: ()=>openDropdown(true),
        goHome: goHomeWithKeyboard
    });
    const getDropdownProps = ()=>({
            onFocus: handleFocus,
            onBlur: handleBlur,
            dropdownContentId: dialogId,
            dropdownContentRole: hasFilter ? "dialog" : undefined
        });
    const getTriggerProps = (disabled = false, autoFocus = false)=>{
        const triggerProps = {
            ref: triggerRef,
            onFocus: ()=>closeDropdown(),
            autoFocus: autoFocus,
            ariaHasPopup: hasFilter ? "dialog" : "listbox",
            ariaControls: isOpen ? hasFilter ? dialogId : menuId : undefined
        };
        if (!disabled) {
            triggerProps.onMouseDown = (event)=>{
                var _a;
                event.preventDefault(); // prevent current focus from blurring as it immediately closes the dropdown
                if (isOpen) (_a = triggerRef.current) === null || _a === void 0 || _a.focus();
                toggleDropdown();
            };
            triggerProps.onKeyDown = triggerKeyDownHandler;
        }
        return triggerProps;
    };
    const getFilterProps = ()=>{
        if (!hasFilter) return {};
        return {
            ref: filterRef,
            onKeyDown: activeKeyDownHandler,
            onChange: (event)=>{
                setFilteringValue(event.detail.value);
                resetHighlightWithKeyboard();
            },
            __onDelayedInput: (event)=>{
                fireLoadItems(event.detail.value);
            },
            __nativeAttributes: {
                "aria-activedescendant": highlightedOptionId,
                ["aria-owns"]: menuId,
                ["aria-controls"]: menuId
            }
        };
    };
    const getMenuProps = ()=>{
        const menuProps = {
            id: menuId,
            ref: menuRef,
            open: isOpen,
            onMouseUp: (itemIndex)=>{
                if (itemIndex > -1) selectOption(options[itemIndex]);
            },
            onMouseMove: (itemIndex)=>{
                if (itemIndex > -1) setHighlightedIndexWithMouse(itemIndex);
            },
            statusType: statusType
        };
        if (!hasFilter) {
            menuProps.onKeyDown = activeKeyDownHandler;
            menuProps.nativeAttributes = {
                "aria-activedescendant": highlightedOptionId
            };
        }
        return menuProps;
    };
    const getGroupState = (option)=>{
        const totalSelected = option.options.filter((item)=>!!item.value && __selectedValuesSet.has(item.value)).length;
        const hasSelected = totalSelected > 0;
        const allSelected = totalSelected === option.options.length;
        return {
            selected: hasSelected && allSelected,
            indeterminate: hasSelected && !allSelected
        };
    };
    const getOptionProps = (option, index)=>{
        var _a;
        const highlighted = option === highlightedOption;
        const groupState = (0, $a3e6bb5a1ebc1aee$export$d7976824e9f55785)(option.option) ? getGroupState(option.option) : undefined;
        const selected = __selectedOptions.indexOf(option) > -1 || !!(groupState === null || groupState === void 0 ? void 0 : groupState.selected);
        const nextOption = (_a = options[index + 1]) === null || _a === void 0 ? void 0 : _a.option;
        const isNextSelected = !!nextOption && (0, $a3e6bb5a1ebc1aee$export$d7976824e9f55785)(nextOption) ? getGroupState(nextOption).selected : __selectedOptions.indexOf(options[index + 1]) > -1;
        const optionProps = {
            key: index,
            option: option,
            highlighted: highlighted,
            selected: selected,
            isNextSelected: isNextSelected,
            indeterminate: !!(groupState === null || groupState === void 0 ? void 0 : groupState.indeterminate),
            ["data-mouse-target"]: isHighlightable(option) ? index : -1,
            id: (0, $771626752877e74e$export$a53dab9d69563a9d)(menuId, index)
        };
        return optionProps;
    };
    const prevOpen = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(isOpen);
    (0, $acw62.useEffect)(()=>{
        // highlight the first selected option, when opening the Select component without filter input
        // keep the focus in the filter input when opening, so that screenreader can recognize the combobox
        if (isOpen && !prevOpen && hasSelectedOption && !hasFilter) {
            if (openedWithKeyboard) highlightOptionWithKeyboard(__selectedOptions[0]);
            else setHighlightedIndexWithMouse(options.indexOf(__selectedOptions[0]), true);
        }
    }, [
        isOpen,
        __selectedOptions,
        hasSelectedOption,
        setHighlightedIndexWithMouse,
        highlightOptionWithKeyboard,
        openedWithKeyboard,
        options,
        prevOpen,
        hasFilter
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (isOpen) // dropdown-fit calculations ensure that the dropdown will fit inside the current
        // viewport, so prevent the browser from trying to scroll it into view (e.g. if
        // scroll-padding-top is set on a parent)
        (_a = activeRef.current) === null || _a === void 0 || _a.focus({
            preventScroll: true
        });
    }, [
        isOpen,
        activeRef
    ]);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(externalRef, triggerRef);
    const highlightedGroupSelected = !!highlightedOption && (0, $a3e6bb5a1ebc1aee$export$d7976824e9f55785)(highlightedOption.option) && getGroupState(highlightedOption.option).selected;
    const announceSelected = !!highlightedOption && (__selectedOptions.indexOf(highlightedOption) > -1 || highlightedGroupSelected);
    return {
        isOpen: isOpen,
        highlightedOption: highlightedOption,
        highlightedIndex: highlightedIndex,
        highlightType: highlightType,
        getTriggerProps: getTriggerProps,
        getDropdownProps: getDropdownProps,
        getMenuProps: getMenuProps,
        getFilterProps: getFilterProps,
        getOptionProps: getOptionProps,
        highlightOption: highlightOptionWithKeyboard,
        selectOption: selectOption,
        announceSelected: announceSelected,
        dialogId: dialogId
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


const $3e842f82042c98b4$export$8f326184ceca2483 = (str)=>str.split("").every((c)=>c === str[0]);
function $3e842f82042c98b4$var$findMatchingOption(options, searchText, currentHighlight, useInteractiveGroups) {
    const interactivityCheck = useInteractiveGroups ? (0, $a3e6bb5a1ebc1aee$export$8269a10a0c239702) : (0, $a3e6bb5a1ebc1aee$export$6af67c5380a168e2);
    const filter = (searchText)=>(0, $a3e6bb5a1ebc1aee$export$60d56ed3961c839c)(options, searchText, true).filter((option)=>interactivityCheck(option));
    const matchingOptions = filter(searchText);
    if (matchingOptions.length === 1) return matchingOptions[0];
    // Hit the same char over and over, we assume they want to cycle through
    if (currentHighlight && searchText.length > 1 && $3e842f82042c98b4$export$8f326184ceca2483(searchText)) {
        const matchingOptions = filter(searchText[0]);
        if (matchingOptions.length > 0) {
            //handling OptionGroups when useInteractiveGroups is set
            let active = (0, $a3e6bb5a1ebc1aee$export$d7976824e9f55785)(currentHighlight) ? matchingOptions.map(({ option: option })=>option).indexOf(currentHighlight) : matchingOptions.map(({ option: option })=>option.value).indexOf(currentHighlight.value);
            // Pick the next thing (if something with this prefix wasn't selected
            // we'll end up with the first option)
            active += 1;
            active = active % matchingOptions.length;
            return matchingOptions[active];
        }
    }
    // We have multiple things that start with this prefix.  Based on the
    // behavior of native select, this is considered after the repeated case
    if (matchingOptions.length > 0) return matchingOptions[0];
    return null;
}
function $3e842f82042c98b4$export$1fd459f1bf9b474a({ isEnabled: isEnabled, options: options, highlightOption: highlightOption, highlightedOption: highlightedOption, useInteractiveGroups: useInteractiveGroups }) {
    const value = (0, $acw62.useRef)("");
    const delayedResetValue = (0, $2f667510820517ed$export$40ae01be0011c1e6)(()=>value.current = "", 500);
    return (event)=>{
        if (!isEnabled) return;
        const { key: key } = event;
        if (!key || key.length !== 1) return;
        delayedResetValue();
        const newValue = value.current + key;
        value.current = newValue;
        const nextHighlight = $3e842f82042c98b4$var$findMatchingOption(options, newValue, highlightedOption, useInteractiveGroups);
        if (nextHighlight) highlightOption(nextHighlight);
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

const $6e841f6ba081dbe4$export$36f5628e43bc3fcd = ({ onLoadItems: onLoadItems, options: options, statusType: statusType })=>{
    const prevFilteringText = (0, $acw62.useRef)(undefined);
    const fireLoadItems = (filteringText)=>{
        if (prevFilteringText.current === filteringText) return;
        prevFilteringText.current = filteringText;
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onLoadItems, {
            filteringText: filteringText,
            firstPage: true,
            samePage: false
        });
    };
    const handleLoadMore = ()=>{
        const firstPage = options.length === 0;
        statusType === "pending" && (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onLoadItems, {
            firstPage: firstPage,
            samePage: false,
            filteringText: prevFilteringText.current || ""
        });
    };
    const handleRecoveryClick = ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onLoadItems, {
            firstPage: false,
            samePage: true,
            filteringText: prevFilteringText.current || ""
        });
    return {
        fireLoadItems: fireLoadItems,
        handleLoadMore: handleLoadMore,
        handleRecoveryClick: handleRecoveryClick
    };
};



var $acw62 = parcelRequire("acw62");
function $46b116ae1da6db28$var$defaultOptionDescription(option, parentGroup) {
    return [
        parentGroup && parentGroup.label,
        option.__labelPrefix,
        option.label || option.value,
        option.description,
        option.labelTag
    ].concat(option.tags).filter((el)=>!!el).join(" ");
}
var $46b116ae1da6db28$export$2e2bcd8739ae039 = $46b116ae1da6db28$var$defaultOptionDescription;


function $b7f1c9ed858d2e1a$export$97d78af8d95ca8bd({ announceSelected: announceSelected, highlightedOption: highlightedOption, getParent: getParent, selectedAriaLabel: selectedAriaLabel, renderHighlightedAriaLive: renderHighlightedAriaLive }) {
    const prevAnnouncedGroup = (0, $acw62.useRef)(undefined);
    // Record previously announced group with a delay to account for possible re-renders of the hook.
    (0, $acw62.useEffect)(()=>{
        if (highlightedOption) {
            const frameId = requestAnimationFrame(()=>{
                prevAnnouncedGroup.current = getParent(highlightedOption);
            });
            return ()=>cancelAnimationFrame(frameId);
        }
    });
    if (!highlightedOption) return "";
    const option = highlightedOption.option;
    const parent = getParent(highlightedOption);
    // Only announce parent group if it wasn't announced with previous option.
    const group = parent && parent !== prevAnnouncedGroup.current ? parent : undefined;
    // Use custom renderer if provided.
    if (renderHighlightedAriaLive) return renderHighlightedAriaLive(option, group);
    // Use default renderer with selected ARIA label if defined and relevant.
    const selectedAnnouncement = announceSelected && selectedAriaLabel ? selectedAriaLabel : "";
    const defaultDescription = (0, $46b116ae1da6db28$export$2e2bcd8739ae039)(option, group);
    return [
        selectedAnnouncement,
        defaultDescription
    ].filter(Boolean).join(" ");
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $598d44f77c0b7cbc$export$2e2bcd8739ae039 = {
    "placeholder": "awsui_placeholder_dwuol_1bifm_97",
    "item": "awsui_item_dwuol_1bifm_102",
    "checkbox": "awsui_checkbox_dwuol_1bifm_106",
    "filter": "awsui_filter_dwuol_1bifm_115",
    "trigger": "awsui_trigger_dwuol_1bifm_120",
    "layout-strut": "awsui_layout-strut_dwuol_1bifm_126",
    "list-bottom": "awsui_list-bottom_dwuol_1bifm_132",
    "selected-icon": "awsui_selected-icon_dwuol_1bifm_136",
    "show-label-tag": "awsui_show-label-tag_dwuol_1bifm_140",
    "inline-token-trigger": "awsui_inline-token-trigger_dwuol_1bifm_144",
    "inline-token-list": "awsui_inline-token-list_dwuol_1bifm_151",
    "inline-token": "awsui_inline-token_dwuol_1bifm_144",
    "visual-refresh": "awsui_visual-refresh_dwuol_1bifm_181",
    "inline-token-hidden-placeholder": "awsui_inline-token-hidden-placeholder_dwuol_1bifm_188",
    "inline-token-counter": "awsui_inline-token-counter_dwuol_1bifm_194",
    "inline-token-trigger--disabled": "awsui_inline-token-trigger--disabled_dwuol_1bifm_198",
    "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_dwuol_1bifm_204"
};




var $acw62 = parcelRequire("acw62");


var $c352e6ab47e4b381$export$2e2bcd8739ae039 = {
    "option": "awsui_option_1p2cx_1lo2r_101",
    "disabled": "awsui_disabled_1p2cx_1lo2r_141",
    "parent": "awsui_parent_1p2cx_1lo2r_144",
    "highlighted": "awsui_highlighted_1p2cx_1lo2r_147",
    "content": "awsui_content_1p2cx_1lo2r_151",
    "label-content": "awsui_label-content_1p2cx_1lo2r_158",
    "label": "awsui_label_1p2cx_1lo2r_158",
    "tag": "awsui_tag_1p2cx_1lo2r_165",
    "label-tag": "awsui_label-tag_1p2cx_1lo2r_166",
    "label-prefix": "awsui_label-prefix_1p2cx_1lo2r_176",
    "tags": "awsui_tags_1p2cx_1lo2r_189",
    "description": "awsui_description_1p2cx_1lo2r_190",
    "selected": "awsui_selected_1p2cx_1lo2r_201",
    "icon": "awsui_icon_1p2cx_1lo2r_215",
    "icon-size-big": "awsui_icon-size-big_1p2cx_1lo2r_222",
    "filtering-match-highlight": "awsui_filtering-match-highlight_1p2cx_1lo2r_226",
    "trigger-variant": "awsui_trigger-variant_1p2cx_1lo2r_241"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

const $30b43541cf6c2d4d$var$splitOnFiltering = (str, highlightText)=>{
    // We match by creating a regex using user-provided strings, so we skip
    // highlighting if the generated regex would be too memory intensive.
    if (highlightText.length > 100000) return {
        noMatches: [
            str
        ],
        matches: null
    };
    // Filtering needs to be case insensitive
    const filteringPattern = highlightText.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
    const regexp = new RegExp(filteringPattern, "gi");
    const noMatches = str.split(regexp);
    const matches = str.match(regexp);
    return {
        noMatches: noMatches,
        matches: matches
    };
};
const $30b43541cf6c2d4d$var$Highlight = ({ str: str })=>str ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)["filtering-match-highlight"]
    }, str) : null;
function $30b43541cf6c2d4d$export$2e2bcd8739ae039({ str: str, highlightText: highlightText }) {
    if (!str || !highlightText) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, str);
    if (str === highlightText) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($30b43541cf6c2d4d$var$Highlight, {
        str: str
    });
    const { noMatches: noMatches, matches: matches } = $30b43541cf6c2d4d$var$splitOnFiltering(str, highlightText);
    const highlighted = [];
    noMatches.forEach((noMatch, idx)=>{
        highlighted.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: `noMatch-${idx}`
        }, noMatch));
        if (matches && idx < matches.length) highlighted.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($30b43541cf6c2d4d$var$Highlight, {
            key: `match-${idx}`,
            str: matches[idx]
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, highlighted);
}


const $37c16ef5b2efceb2$export$b04be29aa201d4f5 = ({ label: label, prefix: prefix, highlightText: highlightText, triggerVariant: triggerVariant })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).label, triggerVariant && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)["trigger-variant"])
    }, prefix && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039)["label-prefix"], triggerVariant && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)["trigger-variant"])
    }, prefix, " "), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30b43541cf6c2d4d$export$2e2bcd8739ae039), {
        str: label,
        highlightText: highlightText
    }));
const $37c16ef5b2efceb2$export$9dacaafb9baa8abc = ({ labelTag: labelTag, highlightText: highlightText, triggerVariant: triggerVariant })=>labelTag ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039)["label-tag"], triggerVariant && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)["trigger-variant"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30b43541cf6c2d4d$export$2e2bcd8739ae039), {
        str: labelTag,
        highlightText: highlightText
    })) : null;
const $37c16ef5b2efceb2$export$393edc798c47379d = ({ description: description, highlightedOption: highlightedOption, highlightText: highlightText, selectedOption: selectedOption, triggerVariant: triggerVariant })=>description ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).description, {
            [(0, $c352e6ab47e4b381$export$2e2bcd8739ae039)["trigger-variant"]]: triggerVariant,
            [(0, $c352e6ab47e4b381$export$2e2bcd8739ae039).highlighted]: highlightedOption,
            [(0, $c352e6ab47e4b381$export$2e2bcd8739ae039).selected]: selectedOption
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30b43541cf6c2d4d$export$2e2bcd8739ae039), {
        str: description,
        highlightText: highlightText
    })) : null;
const $37c16ef5b2efceb2$export$b72686b556e29ca6 = ({ tags: tags, highlightedOption: highlightedOption, highlightText: highlightText, selectedOption: selectedOption, triggerVariant: triggerVariant })=>tags ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).tags, {
            [(0, $c352e6ab47e4b381$export$2e2bcd8739ae039).highlighted]: highlightedOption,
            [(0, $c352e6ab47e4b381$export$2e2bcd8739ae039).selected]: selectedOption
        })
    }, tags.map((tag, idx)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: idx,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).tag, triggerVariant && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)["trigger-variant"])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30b43541cf6c2d4d$export$2e2bcd8739ae039), {
            str: tag,
            highlightText: highlightText
        })))) : null;
const $37c16ef5b2efceb2$export$cd6b1b7fd0ae97c9 = ({ filteringTags: filteringTags, highlightedOption: highlightedOption, highlightText: highlightText, selectedOption: selectedOption, triggerVariant: triggerVariant })=>{
    if (!highlightText || !filteringTags) return null;
    const searchElement = highlightText.toLowerCase();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).tags, {
            [(0, $c352e6ab47e4b381$export$2e2bcd8739ae039).highlighted]: highlightedOption,
            [(0, $c352e6ab47e4b381$export$2e2bcd8739ae039).selected]: selectedOption
        })
    }, filteringTags.map((filteringTag, key)=>{
        const match = filteringTag.toLowerCase().indexOf(searchElement) !== -1;
        if (match) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).tag, triggerVariant && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)["trigger-variant"]),
            key: key,
            "aria-disabled": true
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30b43541cf6c2d4d$export$2e2bcd8739ae039), {
            str: filteringTag,
            highlightText: highlightText
        }));
        return null;
    }));
};
const $37c16ef5b2efceb2$export$cbe66ba5a24d87ce = (props)=>{
    if (!props.name && !props.url && !props.svg) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).icon, props.size === "big" && [
            (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)[`icon-size-big`]
        ])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), Object.assign({}, props)));
};





function $8c692c1c1c803c55$var$validateStringValue(value, propertyName) {
    if (typeof value !== "undefined" && typeof value !== "string") (0, $dd646455762bc7b9$export$5b28268982f175ba)("DropdownOption", `This component only supports string values, but "option.${propertyName}" has ${typeof value} type. The component may work incorrectly.`);
}
const $8c692c1c1c803c55$var$Option = (_a)=>{
    var _b, _c, _d, _e;
    var { option: option, highlightText: highlightText, triggerVariant: triggerVariant = false, isGroupOption: isGroupOption = false, isGenericGroup: isGenericGroup = true, highlightedOption: highlightedOption = false, selectedOption: selectedOption = false } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "option",
        "highlightText",
        "triggerVariant",
        "isGroupOption",
        "isGenericGroup",
        "highlightedOption",
        "selectedOption"
    ]);
    if (!option) return null;
    const { disabled: disabled } = option;
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        $8c692c1c1c803c55$var$validateStringValue(option.label, "label");
        $8c692c1c1c803c55$var$validateStringValue(option.description, "description");
        $8c692c1c1c803c55$var$validateStringValue(option.labelTag, "labelTag");
        (_b = option.tags) === null || _b === void 0 || _b.forEach((tag, index)=>{
            $8c692c1c1c803c55$var$validateStringValue(tag, `tags[${index}]`);
        });
        (_c = option.filteringTags) === null || _c === void 0 || _c.forEach((tag, index)=>{
            $8c692c1c1c803c55$var$validateStringValue(tag, `filteringTags[${index}]`);
        });
    }
    const className = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $c352e6ab47e4b381$export$2e2bcd8739ae039).option, disabled && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039).disabled, isGroupOption && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039).parent, highlightedOption && (0, $c352e6ab47e4b381$export$2e2bcd8739ae039).highlighted);
    const icon = option.__customIcon || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37c16ef5b2efceb2$export$cbe66ba5a24d87ce), {
        name: option.iconName,
        url: option.iconUrl,
        svg: option.iconSvg,
        alt: option.iconAlt,
        size: option.description || option.tags ? "big" : "normal"
    });
    // The option is conditionally assigned 'title' and 'aria-disabled' attributes to ensure it is viewed as a (generic) group  by assistive technology only when necessary.
    // Omitting the props might be necessary if they are provided on the parent element to avoid nested groups.
    // See https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/generic_role
    const genericGroupProps = isGenericGroup ? {
        title: (_d = option.label) !== null && _d !== void 0 ? _d : option.value,
        "aria-disabled": disabled
    } : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        "data-value": option.value,
        className: className,
        lang: option.lang
    }, genericGroupProps, baseProps), icon, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $c352e6ab47e4b381$export$2e2bcd8739ae039).content
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $c352e6ab47e4b381$export$2e2bcd8739ae039)["label-content"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37c16ef5b2efceb2$export$b04be29aa201d4f5), {
        label: (_e = option.label) !== null && _e !== void 0 ? _e : option.value,
        prefix: option.__labelPrefix,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37c16ef5b2efceb2$export$9dacaafb9baa8abc), {
        labelTag: option.labelTag,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37c16ef5b2efceb2$export$393edc798c47379d), {
        description: option.description,
        highlightedOption: highlightedOption,
        selectedOption: selectedOption,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37c16ef5b2efceb2$export$b72686b556e29ca6), {
        tags: option.tags,
        highlightedOption: highlightedOption,
        selectedOption: selectedOption,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37c16ef5b2efceb2$export$cd6b1b7fd0ae97c9), {
        filteringTags: option.filteringTags,
        highlightedOption: highlightedOption,
        selectedOption: selectedOption,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    })));
};
var $8c692c1c1c803c55$export$2e2bcd8739ae039 = $8c692c1c1c803c55$var$Option;




var $acw62 = parcelRequire("acw62");


var $889a465928992b9e$export$2e2bcd8739ae039 = {
    "selectable-item": "awsui_selectable-item_15o6u_1nwbb_97",
    "pad-bottom": "awsui_pad-bottom_15o6u_1nwbb_121",
    "has-background": "awsui_has-background_15o6u_1nwbb_130",
    "highlighted": "awsui_highlighted_15o6u_1nwbb_133",
    "selected": "awsui_selected_15o6u_1nwbb_133",
    "disabled": "awsui_disabled_15o6u_1nwbb_151",
    "next-item-selected": "awsui_next-item-selected_15o6u_1nwbb_161",
    "is-keyboard": "awsui_is-keyboard_15o6u_1nwbb_173",
    "parent": "awsui_parent_15o6u_1nwbb_177",
    "interactiveGroups": "awsui_interactiveGroups_15o6u_1nwbb_181",
    "child": "awsui_child_15o6u_1nwbb_199",
    "virtual": "awsui_virtual_15o6u_1nwbb_214",
    "measure-strut": "awsui_measure-strut_15o6u_1nwbb_225",
    "measure-strut-first": "awsui_measure-strut-first_15o6u_1nwbb_234",
    "screenreader-content": "awsui_screenreader-content_15o6u_1nwbb_238",
    "option-content": "awsui_option-content_15o6u_1nwbb_244"
};



const $76c8d22f7e2aa462$var$SelectableItem = (_a, ref)=>{
    var { children: content, ariaSelected: ariaSelected, ariaChecked: ariaChecked, selected: selected, highlighted: highlighted, disabled: disabled, hasBackground: hasBackground, isParent: isParent, isChild: isChild, virtualPosition: virtualPosition, padBottom: padBottom, isNextSelected: isNextSelected, useInteractiveGroups: useInteractiveGroups, screenReaderContent: screenReaderContent, ariaPosinset: ariaPosinset, ariaSetsize: ariaSetsize, highlightType: highlightType } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "children",
        "ariaSelected",
        "ariaChecked",
        "selected",
        "highlighted",
        "disabled",
        "hasBackground",
        "isParent",
        "isChild",
        "virtualPosition",
        "padBottom",
        "isNextSelected",
        "useInteractiveGroups",
        "screenReaderContent",
        "ariaPosinset",
        "ariaSetsize",
        "highlightType"
    ]);
    const _b = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps), { className: className } = _b, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_b, [
        "className"
    ]);
    const classNames = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $889a465928992b9e$export$2e2bcd8739ae039)["selectable-item"], {
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).selected]: selected,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).highlighted]: highlighted,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039)["has-background"]]: hasBackground,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).parent]: isParent,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).child]: isChild,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039)["is-keyboard"]]: highlightType === "keyboard",
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).disabled]: disabled,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).virtual]: virtualPosition !== undefined,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039)["pad-bottom"]]: padBottom,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039)["next-item-selected"]]: isNextSelected,
        [(0, $889a465928992b9e$export$2e2bcd8739ae039).interactiveGroups]: useInteractiveGroups
    });
    const contentRef = (0, $acw62.useRef)(null);
    const screenReaderContentRef = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        // the state of aria-hidden and announcement is not set back because NVDA+Firefox would announce
        // the item which lost highlight
        // set aria-hidden true when there is announcement content, so that screen reader still announce
        // meaningful content when navigate with screen reader cursor
        // imperatively update to avoid announcement made multiple times when content updates
        if (highlighted && screenReaderContent) {
            if (contentRef.current) contentRef.current.setAttribute("aria-hidden", "true");
            if (screenReaderContentRef.current) screenReaderContentRef.current.textContent = screenReaderContent;
        }
    }, [
        highlighted,
        screenReaderContent,
        contentRef,
        screenReaderContentRef
    ]);
    const style = virtualPosition !== undefined ? {
        transform: `translateY(${virtualPosition}px)`
    } : undefined;
    const a11yProperties = {
        "aria-disabled": disabled
    };
    if (isParent && !useInteractiveGroups) a11yProperties["aria-hidden"] = true;
    if (ariaSelected !== undefined) a11yProperties["aria-selected"] = ariaSelected;
    // Safari+VO needs aria-checked for multi-selection. Otherwise it only announces selected option even though another option is highlighted.
    if (ariaChecked !== undefined) a11yProperties["aria-checked"] = ariaChecked;
    if (ariaPosinset && ariaSetsize) {
        a11yProperties["aria-posinset"] = ariaPosinset;
        a11yProperties["aria-setsize"] = ariaSetsize;
    }
    if (restProps.ariaDescribedby) a11yProperties["aria-describedby"] = restProps.ariaDescribedby;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", Object.assign({
        role: "option",
        className: classNames,
        style: style
    }, a11yProperties, rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $889a465928992b9e$export$2e2bcd8739ae039)["option-content"],
        ref: contentRef
    }, content), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $889a465928992b9e$export$2e2bcd8739ae039)["measure-strut"],
        ref: ref
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $889a465928992b9e$export$2e2bcd8739ae039)["screenreader-content"],
        ref: screenReaderContentRef
    }));
};
var $76c8d22f7e2aa462$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($76c8d22f7e2aa462$var$SelectableItem);








const $41275999010a0acf$var$Item = (_a, ref)=>{
    var { option: option, highlighted: highlighted, selected: selected, filteringValue: filteringValue, hasCheckbox: hasCheckbox, virtualPosition: virtualPosition, padBottom: padBottom, isNextSelected: isNextSelected, screenReaderContent: screenReaderContent, ariaPosinset: ariaPosinset, ariaSetsize: ariaSetsize, highlightType: highlightType } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "option",
        "highlighted",
        "selected",
        "filteringValue",
        "hasCheckbox",
        "virtualPosition",
        "padBottom",
        "isNextSelected",
        "screenReaderContent",
        "ariaPosinset",
        "ariaSetsize",
        "highlightType"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const isParent = option.type === "parent";
    const isChild = option.type === "child";
    const wrappedOption = option.option;
    const disabled = option.disabled || wrappedOption.disabled;
    const disabledReason = disabled && wrappedOption.disabledReason ? wrappedOption.disabledReason : "";
    const isDisabledWithReason = !!disabledReason;
    const internalRef = (0, $acw62.useRef)(null);
    const { descriptionEl: descriptionEl, descriptionId: descriptionId } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(disabledReason);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $76c8d22f7e2aa462$export$2e2bcd8739ae039), Object.assign({
        ariaSelected: Boolean(selected),
        selected: selected,
        isNextSelected: isNextSelected,
        highlighted: highlighted,
        disabled: option.disabled,
        isParent: isParent,
        isChild: isChild,
        ref: (0, $adb603d9351d0211$export$74665b213cb5c4cf)(ref, internalRef),
        virtualPosition: virtualPosition,
        padBottom: padBottom,
        screenReaderContent: screenReaderContent,
        ariaPosinset: ariaPosinset,
        ariaSetsize: ariaSetsize,
        highlightType: highlightType,
        ariaDescribedby: isDisabledWithReason ? descriptionId : ""
    }, baseProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).item, !isParent && wrappedOption.labelTag && (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["show-label-tag"])
    }, hasCheckbox && !isParent && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).checkbox
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90f2424593277d9$export$2e2bcd8739ae039), {
        checked: selected || false,
        disabled: option.disabled
    })), isParent ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, wrappedOption.label || wrappedOption.value) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8c692c1c1c803c55$export$2e2bcd8739ae039), {
        option: Object.assign(Object.assign({}, wrappedOption), {
            disabled: disabled
        }),
        highlightedOption: highlighted,
        selectedOption: selected,
        highlightText: filteringValue
    }), !hasCheckbox && !isParent && selected && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["selected-icon"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "check"
    })), isDisabledWithReason && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, descriptionEl, highlighted && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $76f4c84fd1bac364$export$2e2bcd8739ae039), {
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["disabled-reason-tooltip"],
        trackRef: internalRef,
        value: disabledReason,
        position: "right"
    }))));
};
var $41275999010a0acf$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($41275999010a0acf$var$Item));




var $acw62 = parcelRequire("acw62");









const $e079fe59697fd5d8$var$MultiSelectItem = (_a, ref)=>{
    var { option: option, highlighted: highlighted, selected: selected, filteringValue: filteringValue, hasCheckbox: hasCheckbox, virtualPosition: virtualPosition, padBottom: padBottom, isNextSelected: isNextSelected, indeterminate: indeterminate, screenReaderContent: screenReaderContent, ariaPosinset: ariaPosinset, ariaSetsize: ariaSetsize, highlightType: highlightType } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "option",
        "highlighted",
        "selected",
        "filteringValue",
        "hasCheckbox",
        "virtualPosition",
        "padBottom",
        "isNextSelected",
        "indeterminate",
        "screenReaderContent",
        "ariaPosinset",
        "ariaSetsize",
        "highlightType"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const isParent = option.type === "parent";
    const isChild = option.type === "child";
    const wrappedOption = option.option;
    const disabled = option.disabled || wrappedOption.disabled;
    const disabledReason = disabled && (option.disabledReason || wrappedOption.disabledReason) ? option.disabledReason || wrappedOption.disabledReason : "";
    const isDisabledWithReason = !!disabledReason;
    const internalRef = (0, $acw62.useRef)(null);
    const className = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).item, {
        [(0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).disabled]: disabled
    });
    const { descriptionId: descriptionId, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(disabledReason);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $76c8d22f7e2aa462$export$2e2bcd8739ae039), Object.assign({
        ariaChecked: isParent && indeterminate ? "mixed" : Boolean(selected),
        selected: selected,
        isNextSelected: isNextSelected,
        highlighted: highlighted,
        disabled: disabled,
        isParent: isParent,
        isChild: isChild,
        highlightType: highlightType,
        ref: (0, $adb603d9351d0211$export$74665b213cb5c4cf)(ref, internalRef),
        virtualPosition: virtualPosition,
        padBottom: padBottom,
        useInteractiveGroups: true,
        screenReaderContent: screenReaderContent,
        ariaPosinset: ariaPosinset,
        ariaSetsize: ariaSetsize,
        ariaDescribedby: isDisabledWithReason ? descriptionId : ""
    }, baseProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className
    }, hasCheckbox && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).checkbox
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90f2424593277d9$export$2e2bcd8739ae039), {
        checked: selected,
        indeterminate: isParent && indeterminate,
        disabled: option.disabled
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8c692c1c1c803c55$export$2e2bcd8739ae039), {
        option: Object.assign(Object.assign({}, wrappedOption), {
            disabled: disabled
        }),
        highlightedOption: highlighted,
        selectedOption: selected,
        highlightText: filteringValue,
        isGroupOption: isParent
    })), isDisabledWithReason && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, descriptionEl, highlighted && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $76f4c84fd1bac364$export$2e2bcd8739ae039), {
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["disabled-reason-tooltip"],
        trackRef: internalRef,
        value: disabledReason,
        position: "right"
    })));
};
var $e079fe59697fd5d8$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($e079fe59697fd5d8$var$MultiSelectItem));



const $cbdf3adf00550b27$export$f075439baf9a4095 = ({ option: option, index: index, getOptionProps: getOptionProps, filteringValue: filteringValue, checkboxes: checkboxes = false })=>{
    const optionProps = getOptionProps(option, index);
    optionProps.filteringValue = filteringValue;
    const { inGroupIndex: inGroupIndex, groupIndex: groupIndex, throughIndex: throughIndex } = (0, $319ac672533f1934$export$7a93927e4b42a61f)(option) || {};
    return Object.assign(Object.assign({}, optionProps), {
        hasCheckbox: checkboxes,
        ["data-group-index"]: groupIndex,
        ["data-child-index"]: inGroupIndex,
        ["data-test-index"]: throughIndex
    });
};


const $9b39d1324e4300f1$export$edde41d128e72035 = ({ options: options, getOptionProps: getOptionProps, filteringValue: filteringValue, highlightType: highlightType, checkboxes: checkboxes = false, hasDropdownStatus: hasDropdownStatus, virtualItems: virtualItems, useInteractiveGroups: useInteractiveGroups, screenReaderContent: screenReaderContent, ariaSetsize: ariaSetsize })=>{
    return options.map((option, index)=>{
        const virtualItem = virtualItems && virtualItems[index];
        const globalIndex = virtualItem ? virtualItem.index : index;
        const props = (0, $cbdf3adf00550b27$export$f075439baf9a4095)({
            option: option,
            index: globalIndex,
            getOptionProps: getOptionProps,
            filteringValue: filteringValue,
            checkboxes: checkboxes
        });
        const isLastItem = index === options.length - 1;
        const padBottom = !hasDropdownStatus && isLastItem;
        const ListItem = useInteractiveGroups ? (0, $e079fe59697fd5d8$export$2e2bcd8739ae039) : (0, $41275999010a0acf$export$2e2bcd8739ae039);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ListItem, Object.assign({
            key: globalIndex
        }, props, {
            virtualPosition: virtualItem && virtualItem.start,
            ref: virtualItem && virtualItem.measureRef,
            padBottom: padBottom,
            screenReaderContent: screenReaderContent,
            ariaPosinset: globalIndex + 1,
            ariaSetsize: ariaSetsize,
            highlightType: highlightType.type
        }));
    });
};




const $e3f3b61849c4e04a$var$PlainList = ({ menuProps: menuProps, getOptionProps: getOptionProps, filteredOptions: filteredOptions, filteringValue: filteringValue, highlightType: highlightType, checkboxes: checkboxes, hasDropdownStatus: hasDropdownStatus, listBottom: listBottom, useInteractiveGroups: useInteractiveGroups, screenReaderContent: screenReaderContent }, ref)=>{
    const menuRef = menuProps.ref;
    (0, $acw62.useImperativeHandle)(ref, ()=>(index)=>{
            var _a;
            const item = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`[data-mouse-target="${index}"]`);
            if (highlightType.moveFocus && item) (0, $24d40242cc6554ee$export$a904af9c1628c179)(item);
        }, [
        highlightType,
        menuRef
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b0a4cb0aaef194c$export$2e2bcd8739ae039), Object.assign({}, menuProps), (0, $9b39d1324e4300f1$export$edde41d128e72035)({
        options: filteredOptions,
        getOptionProps: getOptionProps,
        filteringValue: filteringValue,
        highlightType: highlightType,
        checkboxes: checkboxes,
        hasDropdownStatus: hasDropdownStatus,
        useInteractiveGroups: useInteractiveGroups,
        screenReaderContent: screenReaderContent
    }), listBottom ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "option",
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["list-bottom"]
    }, listBottom) : null);
};
var $e3f3b61849c4e04a$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)($e3f3b61849c4e04a$var$PlainList);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
/**
 * Name: react-virtual
 * Version: 2.10.4
 * License: MIT
 * Private: false
 * Description: Hooks for virtualizing scrollable elements in React
 * Repository: undefined
 * Homepage: https://github.com/tannerlinsley/react-virtual#readme
 * Author: tannerlinsley
 * License Copyright:
 * ===
 *
 * MIT License
 *
 * Copyright (c) 2019 Tanner Linsley
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
var $acw62 = parcelRequire("acw62");
function $7944ff2e8f91c451$var$_extends() {
    $7944ff2e8f91c451$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7944ff2e8f91c451$var$_extends.apply(this, arguments);
}
function $7944ff2e8f91c451$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $7944ff2e8f91c451$var$props = [
    "bottom",
    "height",
    "left",
    "right",
    "top",
    "width"
];
var $7944ff2e8f91c451$var$rectChanged = function rectChanged(a, b) {
    if (a === void 0) a = {};
    if (b === void 0) b = {};
    return $7944ff2e8f91c451$var$props.some(function(prop) {
        return a[prop] !== b[prop];
    });
};
var $7944ff2e8f91c451$var$observedNodes = /*#__PURE__*/ new Map();
var $7944ff2e8f91c451$var$rafId;
var $7944ff2e8f91c451$var$run = function run() {
    var changedStates = [];
    $7944ff2e8f91c451$var$observedNodes.forEach(function(state, node) {
        var newRect = node.getBoundingClientRect();
        if ($7944ff2e8f91c451$var$rectChanged(newRect, state.rect)) {
            state.rect = newRect;
            changedStates.push(state);
        }
    });
    changedStates.forEach(function(state) {
        state.callbacks.forEach(function(cb) {
            return cb(state.rect);
        });
    });
    $7944ff2e8f91c451$var$rafId = window.requestAnimationFrame(run);
};
function $7944ff2e8f91c451$var$observeRect(node, cb) {
    return {
        observe: function observe() {
            var wasEmpty = $7944ff2e8f91c451$var$observedNodes.size === 0;
            if ($7944ff2e8f91c451$var$observedNodes.has(node)) $7944ff2e8f91c451$var$observedNodes.get(node).callbacks.push(cb);
            else $7944ff2e8f91c451$var$observedNodes.set(node, {
                rect: undefined,
                hasRectChanged: false,
                callbacks: [
                    cb
                ]
            });
            if (wasEmpty) $7944ff2e8f91c451$var$run();
        },
        unobserve: function unobserve() {
            var state = $7944ff2e8f91c451$var$observedNodes.get(node);
            if (state) {
                // Remove the callback
                var index = state.callbacks.indexOf(cb);
                if (index >= 0) state.callbacks.splice(index, 1); // Remove the node reference
                if (!state.callbacks.length) $7944ff2e8f91c451$var$observedNodes["delete"](node); // Stop the loop
                if (!$7944ff2e8f91c451$var$observedNodes.size) cancelAnimationFrame($7944ff2e8f91c451$var$rafId);
            }
        }
    };
}
var $7944ff2e8f91c451$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect;
function $7944ff2e8f91c451$var$useRect(nodeRef, initialRect) {
    if (initialRect === void 0) initialRect = {
        width: 0,
        height: 0
    };
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(nodeRef.current), element = _React$useState[0], setElement = _React$useState[1];
    var _React$useReducer = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useReducer($7944ff2e8f91c451$var$rectReducer, initialRect), rect = _React$useReducer[0], dispatch = _React$useReducer[1];
    var initialRectSet = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    $7944ff2e8f91c451$var$useIsomorphicLayoutEffect(function() {
        if (nodeRef.current !== element) setElement(nodeRef.current);
    });
    $7944ff2e8f91c451$var$useIsomorphicLayoutEffect(function() {
        if (element && !initialRectSet.current) {
            initialRectSet.current = true;
            var _rect = element.getBoundingClientRect();
            dispatch({
                rect: _rect
            });
        }
    }, [
        element
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (!element) return;
        var observer = $7944ff2e8f91c451$var$observeRect(element, function(rect) {
            dispatch({
                rect: rect
            });
        });
        observer.observe();
        return function() {
            observer.unobserve();
        };
    }, [
        element
    ]);
    return rect;
}
function $7944ff2e8f91c451$var$rectReducer(state, action) {
    var rect = action.rect;
    if (state.height !== rect.height || state.width !== rect.width) return rect;
    return state;
}
var $7944ff2e8f91c451$var$defaultEstimateSize = function defaultEstimateSize() {
    return 50;
};
var $7944ff2e8f91c451$var$defaultKeyExtractor = function defaultKeyExtractor(index) {
    return index;
};
var $7944ff2e8f91c451$var$defaultMeasureSize = function defaultMeasureSize(el, horizontal) {
    var key = horizontal ? "offsetWidth" : "offsetHeight";
    return el[key];
};
var $7944ff2e8f91c451$var$defaultRangeExtractor = function defaultRangeExtractor(range) {
    var start = Math.max(range.start - range.overscan, 0);
    var end = Math.min(range.end + range.overscan, range.size - 1);
    var arr = [];
    for(var i = start; i <= end; i++)arr.push(i);
    return arr;
};
function $7944ff2e8f91c451$export$ebc1863da693699a(_ref) {
    var _measurements;
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 0 : _ref$size, _ref$estimateSize = _ref.estimateSize, estimateSize = _ref$estimateSize === void 0 ? $7944ff2e8f91c451$var$defaultEstimateSize : _ref$estimateSize, _ref$overscan = _ref.overscan, overscan = _ref$overscan === void 0 ? 1 : _ref$overscan, _ref$paddingStart = _ref.paddingStart, paddingStart = _ref$paddingStart === void 0 ? 0 : _ref$paddingStart, _ref$paddingEnd = _ref.paddingEnd, paddingEnd = _ref$paddingEnd === void 0 ? 0 : _ref$paddingEnd, parentRef = _ref.parentRef, horizontal = _ref.horizontal, scrollToFn = _ref.scrollToFn, useObserver = _ref.useObserver, initialRect = _ref.initialRect, onScrollElement = _ref.onScrollElement, scrollOffsetFn = _ref.scrollOffsetFn, _ref$keyExtractor = _ref.keyExtractor, keyExtractor = _ref$keyExtractor === void 0 ? $7944ff2e8f91c451$var$defaultKeyExtractor : _ref$keyExtractor, _ref$measureSize = _ref.measureSize, measureSize = _ref$measureSize === void 0 ? $7944ff2e8f91c451$var$defaultMeasureSize : _ref$measureSize, _ref$rangeExtractor = _ref.rangeExtractor, rangeExtractor = _ref$rangeExtractor === void 0 ? $7944ff2e8f91c451$var$defaultRangeExtractor : _ref$rangeExtractor;
    var sizeKey = horizontal ? "width" : "height";
    var scrollKey = horizontal ? "scrollLeft" : "scrollTop";
    var latestRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        scrollOffset: 0,
        measurements: []
    });
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0), scrollOffset = _React$useState[0], setScrollOffset = _React$useState[1];
    latestRef.current.scrollOffset = scrollOffset;
    var useMeasureParent = useObserver || $7944ff2e8f91c451$var$useRect;
    var _useMeasureParent = useMeasureParent(parentRef, initialRect), outerSize = _useMeasureParent[sizeKey];
    latestRef.current.outerSize = outerSize;
    var defaultScrollToFn = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function(offset) {
        if (parentRef.current) parentRef.current[scrollKey] = offset;
    }, [
        parentRef,
        scrollKey
    ]);
    var resolvedScrollToFn = scrollToFn || defaultScrollToFn;
    scrollToFn = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function(offset) {
        resolvedScrollToFn(offset, defaultScrollToFn);
    }, [
        defaultScrollToFn,
        resolvedScrollToFn
    ]);
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({}), measuredCache = _React$useState2[0], setMeasuredCache = _React$useState2[1];
    var measure = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function() {
        return setMeasuredCache({});
    }, []);
    var pendingMeasuredCacheIndexesRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef([]);
    var measurements = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        var min = pendingMeasuredCacheIndexesRef.current.length > 0 ? Math.min.apply(Math, pendingMeasuredCacheIndexesRef.current) : 0;
        pendingMeasuredCacheIndexesRef.current = [];
        var measurements = latestRef.current.measurements.slice(0, min);
        for(var i = min; i < size; i++){
            var key = keyExtractor(i);
            var measuredSize = measuredCache[key];
            var _start = measurements[i - 1] ? measurements[i - 1].end : paddingStart;
            var _size = typeof measuredSize === "number" ? measuredSize : estimateSize(i);
            var _end = _start + _size;
            measurements[i] = {
                index: i,
                start: _start,
                size: _size,
                end: _end,
                key: key
            };
        }
        return measurements;
    }, [
        estimateSize,
        measuredCache,
        paddingStart,
        size,
        keyExtractor
    ]);
    var totalSize = (((_measurements = measurements[size - 1]) == null ? void 0 : _measurements.end) || paddingStart) + paddingEnd;
    latestRef.current.measurements = measurements;
    latestRef.current.totalSize = totalSize;
    var element = onScrollElement ? onScrollElement.current : parentRef.current;
    var scrollOffsetFnRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(scrollOffsetFn);
    scrollOffsetFnRef.current = scrollOffsetFn;
    $7944ff2e8f91c451$var$useIsomorphicLayoutEffect(function() {
        if (!element) {
            setScrollOffset(0);
            return;
        }
        var onScroll = function onScroll(event) {
            var offset = scrollOffsetFnRef.current ? scrollOffsetFnRef.current(event) : element[scrollKey];
            setScrollOffset(offset);
        };
        onScroll();
        element.addEventListener("scroll", onScroll, {
            capture: false,
            passive: true
        });
        return function() {
            element.removeEventListener("scroll", onScroll);
        };
    }, [
        element,
        scrollKey
    ]);
    var _calculateRange = $7944ff2e8f91c451$var$calculateRange(latestRef.current), start = _calculateRange.start, end = _calculateRange.end;
    var indexes = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return rangeExtractor({
            start: start,
            end: end,
            overscan: overscan,
            size: measurements.length
        });
    }, [
        start,
        end,
        overscan,
        measurements.length,
        rangeExtractor
    ]);
    var measureSizeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(measureSize);
    measureSizeRef.current = measureSize;
    var virtualItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        var virtualItems = [];
        var _loop = function _loop(k, len) {
            var i = indexes[k];
            var measurement = measurements[i];
            var item = $7944ff2e8f91c451$var$_extends($7944ff2e8f91c451$var$_extends({}, measurement), {}, {
                measureRef: function measureRef(el) {
                    if (el) {
                        var measuredSize = measureSizeRef.current(el, horizontal);
                        if (measuredSize !== item.size) {
                            var _scrollOffset = latestRef.current.scrollOffset;
                            if (item.start < _scrollOffset) defaultScrollToFn(_scrollOffset + (measuredSize - item.size));
                            pendingMeasuredCacheIndexesRef.current.push(i);
                            setMeasuredCache(function(old) {
                                var _extends2;
                                return $7944ff2e8f91c451$var$_extends($7944ff2e8f91c451$var$_extends({}, old), {}, (_extends2 = {}, _extends2[item.key] = measuredSize, _extends2));
                            });
                        }
                    }
                }
            });
            virtualItems.push(item);
        };
        for(var k = 0, len = indexes.length; k < len; k++)_loop(k);
        return virtualItems;
    }, [
        indexes,
        defaultScrollToFn,
        horizontal,
        measurements
    ]);
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    $7944ff2e8f91c451$var$useIsomorphicLayoutEffect(function() {
        if (mountedRef.current) setMeasuredCache({});
        mountedRef.current = true;
    }, [
        estimateSize
    ]);
    var scrollToOffset = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function(toOffset, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$align = _ref2.align, align = _ref2$align === void 0 ? "start" : _ref2$align;
        var _latestRef$current = latestRef.current, scrollOffset = _latestRef$current.scrollOffset, outerSize = _latestRef$current.outerSize;
        if (align === "auto") {
            if (toOffset <= scrollOffset) align = "start";
            else if (toOffset >= scrollOffset + outerSize) align = "end";
            else align = "start";
        }
        if (align === "start") scrollToFn(toOffset);
        else if (align === "end") scrollToFn(toOffset - outerSize);
        else if (align === "center") scrollToFn(toOffset - outerSize / 2);
    }, [
        scrollToFn
    ]);
    var tryScrollToIndex = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function(index, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$align = _ref3.align, align = _ref3$align === void 0 ? "auto" : _ref3$align, rest = $7944ff2e8f91c451$var$_objectWithoutPropertiesLoose(_ref3, [
            "align"
        ]);
        var _latestRef$current2 = latestRef.current, measurements = _latestRef$current2.measurements, scrollOffset = _latestRef$current2.scrollOffset, outerSize = _latestRef$current2.outerSize;
        var measurement = measurements[Math.max(0, Math.min(index, size - 1))];
        if (!measurement) return;
        if (align === "auto") {
            if (measurement.end >= scrollOffset + outerSize) align = "end";
            else if (measurement.start <= scrollOffset) align = "start";
            else return;
        }
        var toOffset = align === "center" ? measurement.start + measurement.size / 2 : align === "end" ? measurement.end : measurement.start;
        scrollToOffset(toOffset, $7944ff2e8f91c451$var$_extends({
            align: align
        }, rest));
    }, [
        scrollToOffset,
        size
    ]);
    var scrollToIndex = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // We do a double request here because of
        // dynamic sizes which can cause offset shift
        // and end up in the wrong spot. Unfortunately,
        // we can't know about those dynamic sizes until
        // we try and render them. So double down!
        tryScrollToIndex.apply(void 0, args);
        requestAnimationFrame(function() {
            tryScrollToIndex.apply(void 0, args);
        });
    }, [
        tryScrollToIndex
    ]);
    return {
        virtualItems: virtualItems,
        totalSize: totalSize,
        scrollToOffset: scrollToOffset,
        scrollToIndex: scrollToIndex,
        measure: measure
    };
}
var $7944ff2e8f91c451$var$findNearestBinarySearch = function findNearestBinarySearch(low, high, getCurrentValue, value) {
    while(low <= high){
        var middle = (low + high) / 2 | 0;
        var currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $7944ff2e8f91c451$var$calculateRange(_ref4) {
    var measurements = _ref4.measurements, outerSize = _ref4.outerSize, scrollOffset = _ref4.scrollOffset;
    var size = measurements.length - 1;
    var getOffset = function getOffset(index) {
        return measurements[index].start;
    };
    var start = $7944ff2e8f91c451$var$findNearestBinarySearch(0, size, getOffset, scrollOffset);
    var end = start;
    while(end < size && measurements[end].end < scrollOffset + outerSize)end++;
    return {
        start: start,
        end: end
    };
}


const $ff607ed83f96c87f$var$MAX_ITEM_MOUNTS = 100;
function $ff607ed83f96c87f$export$ebc1863da693699a({ items: items, parentRef: parentRef, estimateSize: estimateSize }) {
    const rowVirtualizer = (0, $7944ff2e8f91c451$export$ebc1863da693699a)({
        size: items.length,
        parentRef: parentRef,
        estimateSize: estimateSize,
        overscan: 5
    });
    // Cache virtual item mounts to limit the amount of mounts per item.
    const measuresCache = (0, $acw62.useRef)(new WeakMap());
    // Clear mounts cache every time indices, items, or size estimate change.
    const indicesKey = rowVirtualizer.virtualItems.map((item)=>`${item.index}`).join(":");
    (0, $acw62.useEffect)(()=>{
        measuresCache.current = new WeakMap();
    }, [
        indicesKey,
        items,
        estimateSize
    ]);
    const virtualItems = (0, $acw62.useMemo)(()=>rowVirtualizer.virtualItems.map((virtualItem)=>Object.assign(Object.assign({}, virtualItem), {
                measureRef: (node)=>{
                    var _a;
                    const mountedCount = (_a = measuresCache.current.get(items[virtualItem.index])) !== null && _a !== void 0 ? _a : 0;
                    if (mountedCount < $ff607ed83f96c87f$var$MAX_ITEM_MOUNTS) {
                        virtualItem.measureRef(node);
                        measuresCache.current.set(items[virtualItem.index], mountedCount + 1);
                    }
                }
            })), [
        items,
        rowVirtualizer.virtualItems
    ]);
    return {
        virtualItems: virtualItems,
        totalSize: rowVirtualizer.totalSize,
        scrollToIndex: rowVirtualizer.scrollToIndex
    };
}



const $ef788f2229336596$var$VirtualList = (props, ref)=>{
    return props.menuProps.open ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ef788f2229336596$var$VirtualListOpen, Object.assign({}, props, {
        ref: ref
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ef788f2229336596$var$VirtualListClosed, Object.assign({}, props, {
        ref: ref
    }));
};
const $ef788f2229336596$var$VirtualListOpen = (0, $acw62.forwardRef)(({ menuProps: menuProps, getOptionProps: getOptionProps, filteredOptions: filteredOptions, filteringValue: filteringValue, highlightType: highlightType, checkboxes: checkboxes, hasDropdownStatus: hasDropdownStatus, listBottom: listBottom, useInteractiveGroups: useInteractiveGroups, screenReaderContent: screenReaderContent }, ref)=>{
    // update component, when it gets wider or narrower to reposition items
    const [width, menuMeasureRef] = (0, $6e052e2d296ab854$export$2e2bcd8739ae039)((rect)=>rect.contentBoxWidth, []);
    const menuRefObject = (0, $acw62.useRef)(null);
    const menuRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(menuMeasureRef, menuRefObject, menuProps.ref);
    const { virtualItems: virtualItems, totalSize: totalSize, scrollToIndex: scrollToIndex } = (0, $ff607ed83f96c87f$export$ebc1863da693699a)({
        items: filteredOptions,
        parentRef: menuRefObject,
        // estimateSize is a dependency of measurements memo. We update it to force full recalculation
        // when the height of any option could have changed:
        // 1: because the component got resized (width property got updated)
        // 2: because the option changed its content (filteringValue property controls the highlight and the visibility of hidden tags)
        // eslint-disable-next-line react-hooks/exhaustive-deps
        estimateSize: (0, $acw62.useCallback)(()=>31, [
            width,
            filteringValue
        ])
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>(index)=>{
            if (highlightType.moveFocus) scrollToIndex(index);
        }, [
        highlightType,
        scrollToIndex
    ]);
    const finalOptions = (0, $9b39d1324e4300f1$export$edde41d128e72035)({
        options: virtualItems.map(({ index: index })=>filteredOptions[index]),
        getOptionProps: getOptionProps,
        filteringValue: filteringValue,
        highlightType: highlightType,
        checkboxes: checkboxes,
        hasDropdownStatus: hasDropdownStatus,
        virtualItems: virtualItems,
        useInteractiveGroups: useInteractiveGroups,
        screenReaderContent: screenReaderContent,
        ariaSetsize: filteredOptions.length
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b0a4cb0aaef194c$export$2e2bcd8739ae039), Object.assign({}, menuProps, {
        ref: menuRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        key: "total-size",
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["layout-strut"],
        style: {
            height: totalSize
        }
    }), finalOptions, listBottom ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "option",
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["list-bottom"]
    }, listBottom) : null);
});
const $ef788f2229336596$var$VirtualListClosed = (0, $acw62.forwardRef)(({ menuProps: menuProps, listBottom: listBottom }, ref)=>{
    (0, $acw62.useImperativeHandle)(ref, ()=>()=>{}, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b0a4cb0aaef194c$export$2e2bcd8739ae039), Object.assign({}, menuProps, {
        ref: menuProps.ref
    }), listBottom ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "option",
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["list-bottom"]
    }, listBottom) : null);
});
var $ef788f2229336596$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)($ef788f2229336596$var$VirtualList);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $1f218afa2afb7e05$export$a967962c200ab07c(componentName, propertyName, propertyValue) {
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        if (!propertyValue) return;
        const valuePropertyMissing = !propertyValue.every((element)=>{
            return "options" in element || "value" in element;
        });
        if (valuePropertyMissing) (0, $dd646455762bc7b9$export$5b28268982f175ba)(componentName, `You provided an \`${propertyName}\` prop where at least one non-group array element is missing the \`value\` field. This field is required for all options without sub-items.`);
    }
}




var $acw62 = parcelRequire("acw62");


const $3d59f5e64bb57d9d$var$Filter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { filteringType: filteringType } = _a, filterProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "filteringType"
    ]);
    if (filteringType === "none") return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fadf349311229145$export$2e2bcd8739ae039), Object.assign({
        ref: ref,
        type: "visualSearch",
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).filter,
        autoComplete: false,
        disableBrowserAutocorrect: true,
        invalid: false,
        __noBorderRadius: true
    }, filterProps, {
        __nativeAttributes: Object.assign({
            "aria-expanded": true,
            "aria-haspopup": true,
            role: "combobox",
            autoCorrect: "off",
            autoCapitalize: "off"
        }, filterProps.__nativeAttributes)
    }));
});
var $3d59f5e64bb57d9d$export$2e2bcd8739ae039 = $3d59f5e64bb57d9d$var$Filter;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");




var $d46ca2f87d30af25$export$2e2bcd8739ae039 = {
    "button-trigger": "awsui_button-trigger_18eso_m2fj5_101",
    "arrow": "awsui_arrow_18eso_m2fj5_101",
    "has-caret": "awsui_has-caret_18eso_m2fj5_168",
    "placeholder": "awsui_placeholder_18eso_m2fj5_171",
    "pressed": "awsui_pressed_18eso_m2fj5_184",
    "disabled": "awsui_disabled_18eso_m2fj5_187",
    "in-filtering-token": "awsui_in-filtering-token_18eso_m2fj5_197",
    "readonly": "awsui_readonly_18eso_m2fj5_203",
    "invalid": "awsui_invalid_18eso_m2fj5_225",
    "warning": "awsui_warning_18eso_m2fj5_236",
    "inline-tokens": "awsui_inline-tokens_18eso_m2fj5_274"
};



const $35d168f0b5e99e77$var$ButtonTrigger = (_a, ref)=>{
    var { children: children, pressed: pressed = false, hideCaret: hideCaret = false, disabled: disabled = false, readOnly: readOnly = false, invalid: invalid = false, warning: warning = false, inlineTokens: inlineTokens, inFilteringToken: inFilteringToken, ariaHasPopup: ariaHasPopup, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, ariaControls: ariaControls, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onClick: onClick, onFocus: onFocus, onBlur: onBlur, autoFocus: autoFocus } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "children",
        "pressed",
        "hideCaret",
        "disabled",
        "readOnly",
        "invalid",
        "warning",
        "inlineTokens",
        "inFilteringToken",
        "ariaHasPopup",
        "ariaLabel",
        "ariaLabelledby",
        "ariaDescribedby",
        "ariaControls",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onClick",
        "onFocus",
        "onBlur",
        "autoFocus"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    let attributes = Object.assign(Object.assign({}, baseProps), {
        type: "button",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $d46ca2f87d30af25$export$2e2bcd8739ae039)["button-trigger"], baseProps.className, pressed && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039).pressed, disabled && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039).disabled, invalid && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039).invalid, warning && !invalid && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039).warning, !hideCaret && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039)["has-caret"], readOnly && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039).readonly, inFilteringToken && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039)["in-filtering-token"], inlineTokens && (0, $d46ca2f87d30af25$export$2e2bcd8739ae039)["inline-tokens"]),
        disabled: disabled,
        "aria-expanded": pressed,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        "aria-haspopup": ariaHasPopup !== null && ariaHasPopup !== void 0 ? ariaHasPopup : "listbox",
        "aria-controls": ariaControls,
        "aria-disabled": readOnly && !disabled ? "true" : undefined,
        autoFocus: autoFocus
    });
    if (!readOnly) attributes = Object.assign(Object.assign({}, attributes), {
        onKeyDown: onKeyDown && ((event)=>(0, $fc537b925f715587$export$d23d807e6c464ee0)(onKeyDown, event)),
        onKeyUp: onKeyUp && ((event)=>(0, $fc537b925f715587$export$d23d807e6c464ee0)(onKeyUp, event)),
        onMouseDown: onMouseDown && ((event)=>(0, $fc537b925f715587$export$d7e1721720edbb03)(onMouseDown, {}, event)),
        onClick: onClick && ((event)=>(0, $fc537b925f715587$export$d7e1721720edbb03)(onClick, {}, event)),
        onFocus: onFocus && ((event)=>(0, $fc537b925f715587$export$d7e1721720edbb03)(onFocus, {}, event)),
        onBlur: onBlur && ((event)=>(0, $fc537b925f715587$export$d7e1721720edbb03)(onBlur, {
                relatedTarget: event.relatedTarget
            }, event))
    });
    if (invalid) attributes["aria-invalid"] = invalid;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        ref: ref
    }, attributes), children, !hideCaret && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $d46ca2f87d30af25$export$2e2bcd8739ae039).arrow
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "caret-down-filled",
        variant: disabled || readOnly ? "disabled" : "normal"
    })));
};
var $35d168f0b5e99e77$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($35d168f0b5e99e77$var$ButtonTrigger);







const $9c94b50b6f9902cf$var$Trigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, controlId: controlId, invalid: invalid, warning: warning, triggerProps: triggerProps, selectedOption: selectedOption, selectedOptions: selectedOptions, triggerVariant: triggerVariant, inFilteringToken: inFilteringToken, isOpen: isOpen, placeholder: placeholder, disabled: disabled, readOnly: readOnly }, ref)=>{
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const generatedId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)();
    const id = controlId !== null && controlId !== void 0 ? controlId : generatedId;
    const triggerContentId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("trigger-content-");
    let ariaLabelledbyIds = (0, $49fa9e74c692ea64$export$b933cda3796739ed)(ariaLabelledby, triggerContentId);
    let triggerContent = null;
    if (triggerVariant === "tokens") {
        if (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) {
            triggerContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["inline-token-trigger"], disabled && (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["inline-token-trigger--disabled"], isVisualRefresh && (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["visual-refresh"])
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["inline-token-list"]
            }, selectedOptions.map(({ label: label }, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    key: i,
                    className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["inline-token"]
                }, label))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["inline-token-counter"],
                id: triggerContentId
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039)["inline-token-hidden-placeholder"]
            }, placeholder), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "(", selectedOptions.length, ")")));
            ariaLabelledbyIds = ariaLabelledby;
        } else triggerContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-disabled": "true",
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).placeholder, (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).trigger),
            id: triggerContentId
        }, placeholder);
    } else if (!selectedOption) triggerContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-disabled": "true",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).placeholder, (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).trigger),
        id: triggerContentId
    }, placeholder);
    else if (triggerVariant === "option") triggerContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8c692c1c1c803c55$export$2e2bcd8739ae039), {
        id: triggerContentId,
        option: Object.assign(Object.assign({}, selectedOption), {
            disabled: disabled
        }),
        triggerVariant: true
    });
    else triggerContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: triggerContentId,
        className: (0, $598d44f77c0b7cbc$export$2e2bcd8739ae039).trigger
    }, selectedOption.label || selectedOption.value);
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(triggerProps.ref, ref);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35d168f0b5e99e77$export$2e2bcd8739ae039), Object.assign({}, triggerProps, {
        id: id,
        ref: mergedRef,
        pressed: isOpen,
        disabled: disabled,
        readOnly: readOnly,
        invalid: invalid,
        warning: warning && !invalid,
        inFilteringToken: inFilteringToken,
        inlineTokens: triggerVariant === "tokens",
        ariaDescribedby: ariaDescribedby,
        ariaLabelledby: ariaLabelledbyIds
    }), triggerContent);
});
var $9c94b50b6f9902cf$export$2e2bcd8739ae039 = $9c94b50b6f9902cf$var$Trigger;




var $acw62 = parcelRequire("acw62");








function $8f8026664024aac9$export$2e2bcd8739ae039(_a) {
    var { alignment: alignment, items: items, onDismiss: onDismiss, limit: limit, i18nStrings: i18nStrings, disableOuterPadding: disableOuterPadding, limitShowFewerAriaLabel: limitShowFewerAriaLabel, limitShowMoreAriaLabel: limitShowMoreAriaLabel, readOnly: readOnly, __internalRootRef: __internalRootRef } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "alignment",
        "items",
        "onDismiss",
        "limit",
        "i18nStrings",
        "disableOuterPadding",
        "limitShowFewerAriaLabel",
        "limitShowMoreAriaLabel",
        "readOnly",
        "__internalRootRef"
    ]);
    (0, $6175122c42c548ad$export$2e2bcd8739ae039)("TokenGroup", "items", items, "onDismiss", onDismiss);
    const [removedItemIndex, setRemovedItemIndex] = (0, $acw62.useState)(null);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const hasItems = items.length > 0;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $c8fe48aa6495c25f$export$2e2bcd8739ae039).root, hasItems && (0, $c8fe48aa6495c25f$export$2e2bcd8739ae039)["has-items"], disableOuterPadding && (0, $c8fe48aa6495c25f$export$2e2bcd8739ae039)["no-padding"]),
        ref: __internalRootRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1e34c3ccd4808258$export$2e2bcd8739ae039), {
        alignment: alignment,
        items: items,
        limit: limit,
        renderItem: (item, itemIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc476979934495de$export$50792b0e93539fde), {
                ariaLabel: item.label,
                dismissLabel: item.dismissLabel,
                onDismiss: ()=>{
                    (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDismiss, {
                        itemIndex: itemIndex
                    });
                    setRemovedItemIndex(itemIndex);
                },
                disabled: item.disabled,
                readOnly: readOnly
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8c692c1c1c803c55$export$2e2bcd8739ae039), {
                option: item,
                isGenericGroup: false
            })),
        i18nStrings: i18nStrings,
        limitShowFewerAriaLabel: limitShowFewerAriaLabel,
        limitShowMoreAriaLabel: limitShowMoreAriaLabel,
        moveFocusNextToIndex: removedItemIndex,
        onExpandedClick: (isExpanded)=>{
            if (isExpanded && limit) setRemovedItemIndex(limit);
            else setRemovedItemIndex(null);
        }
    }));
}



var $f0f1f7c75b4089a9$export$2e2bcd8739ae039 = {
    "root": "awsui_root_f8g6q_1i4ll_97",
    "tokens": "awsui_tokens_f8g6q_1i4ll_132"
};






const $274dd79cbacd4aac$var$InternalMultiselect = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, externalRef)=>{
    var _b;
    var { options: options = [], filteringType: filteringType = "none", filteringPlaceholder: filteringPlaceholder, filteringAriaLabel: filteringAriaLabel, filteringClearAriaLabel: filteringClearAriaLabel, filteringResultsText: filteringResultsText, ariaRequired: ariaRequired, placeholder: placeholder, disabled: disabled, readOnly: readOnly, ariaLabel: ariaLabel, statusType: statusType = "finished", empty: empty, loadingText: loadingText, finishedText: finishedText, errorText: errorText, noMatch: noMatch, renderHighlightedAriaLive: renderHighlightedAriaLive, selectedOptions: selectedOptions = [], deselectAriaLabel: deselectAriaLabel, keepOpen: keepOpen = true, tokenLimit: tokenLimit, i18nStrings: i18nStrings, onBlur: onBlur, onFocus: onFocus, onLoadItems: onLoadItems, onChange: onChange, virtualScroll: virtualScroll, inlineTokens: inlineTokens = false, hideTokens: hideTokens = false, expandToViewport: expandToViewport, tokenLimitShowFewerAriaLabel: tokenLimitShowFewerAriaLabel, tokenLimitShowMoreAriaLabel: tokenLimitShowMoreAriaLabel, __internalRootRef: __internalRootRef = null, autoFocus: autoFocus } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "options",
        "filteringType",
        "filteringPlaceholder",
        "filteringAriaLabel",
        "filteringClearAriaLabel",
        "filteringResultsText",
        "ariaRequired",
        "placeholder",
        "disabled",
        "readOnly",
        "ariaLabel",
        "statusType",
        "empty",
        "loadingText",
        "finishedText",
        "errorText",
        "noMatch",
        "renderHighlightedAriaLive",
        "selectedOptions",
        "deselectAriaLabel",
        "keepOpen",
        "tokenLimit",
        "i18nStrings",
        "onBlur",
        "onFocus",
        "onLoadItems",
        "onChange",
        "virtualScroll",
        "inlineTokens",
        "hideTokens",
        "expandToViewport",
        "tokenLimitShowFewerAriaLabel",
        "tokenLimitShowMoreAriaLabel",
        "__internalRootRef",
        "autoFocus"
    ]);
    (0, $1f218afa2afb7e05$export$a967962c200ab07c)("Multiselect", "options", options);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const formFieldContext = (0, $4a30639b463663e4$export$824c400da192ca1b)(restProps);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("multiselect");
    const i18nCommon = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("select");
    const recoveryText = i18nCommon("recoveryText", restProps.recoveryText);
    const errorIconAriaLabel = i18nCommon("errorIconAriaLabel", restProps.errorIconAriaLabel);
    const selectedAriaLabel = i18nCommon("selectedAriaLabel", restProps.selectedAriaLabel);
    if (restProps.recoveryText && !onLoadItems) (0, $dd646455762bc7b9$export$5b28268982f175ba)("Multiselect", "`onLoadItems` must be provided for `recoveryText` to be displayed.");
    const { handleLoadMore: handleLoadMore, handleRecoveryClick: handleRecoveryClick, fireLoadItems: fireLoadItems } = (0, $6e841f6ba081dbe4$export$36f5628e43bc3fcd)({
        onLoadItems: onLoadItems,
        options: options,
        statusType: statusType
    });
    const useInteractiveGroups = true;
    const [filteringValue, setFilteringValue] = (0, $acw62.useState)("");
    const { filteredOptions: filteredOptions, parentMap: parentMap, totalCount: totalCount, matchesCount: matchesCount } = (0, $842e88ad945f2818$export$3b43bf09494a926b)(options, filteringType, filteringValue);
    const updateSelectedOption = (0, $acw62.useCallback)((option)=>{
        const filtered = filteredOptions.filter((item)=>item.type !== "parent").map((item)=>item.option);
        // switch between selection and deselection behavior, ignores disabled options to prevent
        // getting stuck on one behavior when an option is disabled and its state cannot be changed
        const isAllChildrenSelected = (optionsArray)=>optionsArray.every((item)=>(0, $80c0308d36c0fca6$export$333e23643ef496e4)(selectedOptions, item) > -1 || item.disabled);
        const intersection = (visibleOptions, options)=>visibleOptions.filter((item)=>(0, $80c0308d36c0fca6$export$333e23643ef496e4)(options, item) > -1 && !item.disabled);
        const union = (visibleOptions, options)=>visibleOptions.filter((item)=>(0, $80c0308d36c0fca6$export$333e23643ef496e4)(options, item) === -1).concat(options);
        const select = (options, selectedOptions)=>{
            return union(selectedOptions, options);
        };
        const unselect = (options, selectedOptions)=>{
            return selectedOptions.filter((option)=>(0, $80c0308d36c0fca6$export$333e23643ef496e4)(options, option) === -1);
        };
        let newSelectedOptions = [
            ...selectedOptions
        ];
        if ((0, $a3e6bb5a1ebc1aee$export$d7976824e9f55785)(option)) {
            const visibleOptions = intersection([
                ...option.options
            ], filtered);
            newSelectedOptions = isAllChildrenSelected(visibleOptions) ? unselect(visibleOptions, newSelectedOptions) : select(visibleOptions, newSelectedOptions);
        } else newSelectedOptions = isAllChildrenSelected([
            option
        ]) ? unselect([
            option
        ], newSelectedOptions) : select([
            option
        ], newSelectedOptions);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            selectedOptions: newSelectedOptions
        });
    }, [
        onChange,
        selectedOptions,
        filteredOptions
    ]);
    const rootRef = (0, $acw62.useRef)(null);
    const selfControlId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("trigger");
    const controlId = (_b = formFieldContext.controlId) !== null && _b !== void 0 ? _b : selfControlId;
    const multiSelectAriaLabelId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("multiselect-arialabel-");
    const footerId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("footer");
    const scrollToIndex = (0, $acw62.useRef)(null);
    const { isOpen: isOpen, highlightType: highlightType, highlightedOption: highlightedOption, highlightedIndex: highlightedIndex, getTriggerProps: getTriggerProps, getDropdownProps: getDropdownProps, getFilterProps: getFilterProps, getMenuProps: getMenuProps, getOptionProps: getOptionProps, highlightOption: highlightOption, announceSelected: announceSelected } = (0, $6b2e7bdae89bf6e1$export$e64b2f635402ca43)({
        selectedOptions: selectedOptions,
        updateSelectedOption: updateSelectedOption,
        options: filteredOptions,
        filteringType: filteringType,
        onFocus: onFocus,
        onBlur: onBlur,
        externalRef: externalRef,
        keepOpen: keepOpen,
        fireLoadItems: fireLoadItems,
        setFilteringValue: setFilteringValue,
        useInteractiveGroups: useInteractiveGroups,
        statusType: statusType
    });
    const handleNativeSearch = (0, $3e842f82042c98b4$export$1fd459f1bf9b474a)({
        isEnabled: filteringType === "none" && isOpen,
        options: filteredOptions,
        highlightOption: highlightOption,
        highlightedOption: highlightedOption === null || highlightedOption === void 0 ? void 0 : highlightedOption.option,
        useInteractiveGroups: useInteractiveGroups
    });
    const isEmpty = !options || options.length === 0;
    const isNoMatch = filteredOptions && filteredOptions.length === 0;
    const isFiltered = filteringType !== "none" && filteringValue.length > 0 && filteredOptions && filteredOptions.length > 0;
    const filteredText = isFiltered ? filteringResultsText === null || filteringResultsText === void 0 ? void 0 : filteringResultsText(matchesCount, totalCount) : undefined;
    const dropdownStatus = (0, $41901c188ad0f2ad$export$5467db17117c3a32)({
        statusType: statusType,
        empty: empty,
        loadingText: loadingText,
        finishedText: finishedText,
        errorText: errorText,
        recoveryText: recoveryText,
        isEmpty: isEmpty,
        isNoMatch: isNoMatch,
        noMatch: noMatch,
        isFiltered: isFiltered,
        filteringResultsText: filteredText,
        onRecoveryClick: handleRecoveryClick,
        errorIconAriaLabel: errorIconAriaLabel,
        hasRecoveryCallback: !!onLoadItems
    });
    const filter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3d59f5e64bb57d9d$export$2e2bcd8739ae039), Object.assign({
        clearAriaLabel: filteringClearAriaLabel,
        filteringType: filteringType,
        placeholder: filteringPlaceholder,
        ariaLabel: filteringAriaLabel,
        ariaRequired: ariaRequired,
        value: filteringValue
    }, getFilterProps()));
    const trigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c94b50b6f9902cf$export$2e2bcd8739ae039), Object.assign({
        placeholder: placeholder,
        disabled: disabled,
        readOnly: readOnly,
        triggerProps: getTriggerProps(disabled, autoFocus),
        selectedOption: null,
        selectedOptions: selectedOptions,
        triggerVariant: inlineTokens ? "tokens" : "placeholder",
        isOpen: isOpen
    }, formFieldContext, {
        controlId: controlId,
        ariaLabelledby: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(formFieldContext.ariaLabelledby, multiSelectAriaLabelId)
    }));
    const menuProps = Object.assign(Object.assign({}, getMenuProps()), {
        onLoadMore: handleLoadMore,
        ariaLabelledby: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(multiSelectAriaLabelId, controlId),
        ariaDescribedby: dropdownStatus.content ? footerId : undefined
    });
    const announcement = (0, $b7f1c9ed858d2e1a$export$97d78af8d95ca8bd)({
        announceSelected: announceSelected,
        highlightedOption: highlightedOption,
        getParent: (option)=>{
            var _a;
            return (_a = parentMap.get(option)) === null || _a === void 0 ? void 0 : _a.option;
        },
        selectedAriaLabel: selectedAriaLabel,
        renderHighlightedAriaLive: renderHighlightedAriaLive
    });
    const tokens = selectedOptions.map((option)=>({
            label: option.label,
            disabled: disabled || option.disabled,
            labelTag: option.labelTag,
            description: option.description,
            iconAlt: option.iconAlt,
            iconName: option.iconName,
            iconUrl: option.iconUrl,
            iconSvg: option.iconSvg,
            tags: option.tags,
            dismissLabel: i18n("deselectAriaLabel", deselectAriaLabel === null || deselectAriaLabel === void 0 ? void 0 : deselectAriaLabel(option), (format)=>{
                var _a;
                return format({
                    option__label: (_a = option.label) !== null && _a !== void 0 ? _a : ""
                });
            })
        }));
    (0, $acw62.useEffect)(()=>{
        var _a;
        (_a = scrollToIndex.current) === null || _a === void 0 || _a.call(scrollToIndex, highlightedIndex);
    }, [
        highlightedIndex
    ]);
    const ListComponent = virtualScroll ? (0, $ef788f2229336596$export$2e2bcd8739ae039) : (0, $e3f3b61849c4e04a$export$2e2bcd8739ae039);
    const handleMouseDown = (event)=>{
        const target = event.target;
        if (target !== document.activeElement) // prevent currently focused element from losing it
        event.preventDefault();
    };
    const showTokens = !hideTokens && !inlineTokens && tokens.length > 0;
    const handleTokenDismiss = ({ detail: detail })=>{
        const optionToDeselect = selectedOptions[detail.itemIndex];
        updateSelectedOption(optionToDeselect);
        const targetRef = getTriggerProps().ref;
        if (targetRef.current) targetRef.current.focus();
    };
    const tokenGroupI18nStrings = {
        limitShowFewer: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.tokenLimitShowFewer,
        limitShowMore: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.tokenLimitShowMore
    };
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(rootRef, __internalRootRef);
    const dropdownProps = getDropdownProps();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        ref: mergedRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $f0f1f7c75b4089a9$export$2e2bcd8739ae039).root, baseProps.className),
        onKeyPress: handleNativeSearch
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1fd689c8894b21bd$export$2e2bcd8739ae039), Object.assign({}, dropdownProps, {
        ariaLabelledby: dropdownProps.dropdownContentRole ? (0, $49fa9e74c692ea64$export$b933cda3796739ed)(multiSelectAriaLabelId, controlId) : undefined,
        ariaDescribedby: dropdownProps.dropdownContentRole ? dropdownStatus.content ? footerId : undefined : undefined,
        open: isOpen,
        trigger: trigger,
        header: filter,
        onMouseDown: handleMouseDown,
        footer: dropdownStatus.isSticky ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4d1a5dc327bab5f7$export$2e2bcd8739ae039), {
            content: isOpen ? dropdownStatus.content : null,
            id: footerId
        }) : null,
        expandToViewport: expandToViewport,
        stretchBeyondTriggerWidth: true
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ListComponent, {
        listBottom: !dropdownStatus.isSticky ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4d1a5dc327bab5f7$export$2e2bcd8739ae039), {
            content: isOpen ? dropdownStatus.content : null,
            id: footerId
        }) : null,
        menuProps: menuProps,
        getOptionProps: getOptionProps,
        filteredOptions: filteredOptions,
        filteringValue: filteringValue,
        ref: scrollToIndex,
        hasDropdownStatus: dropdownStatus.content !== null,
        checkboxes: true,
        useInteractiveGroups: useInteractiveGroups,
        screenReaderContent: announcement,
        highlightType: highlightType
    })), showTokens && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8f8026664024aac9$export$2e2bcd8739ae039), {
        className: (0, $f0f1f7c75b4089a9$export$2e2bcd8739ae039).tokens,
        alignment: "horizontal",
        limit: tokenLimit,
        items: tokens,
        onDismiss: handleTokenDismiss,
        i18nStrings: tokenGroupI18nStrings,
        limitShowMoreAriaLabel: tokenLimitShowMoreAriaLabel,
        limitShowFewerAriaLabel: tokenLimitShowFewerAriaLabel,
        disableOuterPadding: true,
        readOnly: readOnly
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b8469ab82402f2dd$export$2e2bcd8739ae039), {
        id: multiSelectAriaLabelId
    }, ariaLabel));
});
var $274dd79cbacd4aac$export$2e2bcd8739ae039 = $274dd79cbacd4aac$var$InternalMultiselect;


const $8bb34a8468c146d7$var$Multiselect = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { options: options = [], filteringType: filteringType = "none", statusType: statusType = "finished", selectedOptions: selectedOptions = [], keepOpen: keepOpen = true, hideTokens: hideTokens = false } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "options",
        "filteringType",
        "statusType",
        "selectedOptions",
        "keepOpen",
        "hideTokens"
    ]);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Multiselect", {
        props: {
            autoFocus: restProps.autoFocus,
            expandToViewport: restProps.expandToViewport,
            filteringType: filteringType,
            hideTokens: hideTokens,
            keepOpen: keepOpen,
            tokenLimit: restProps.tokenLimit,
            virtualScroll: restProps.virtualScroll
        }
    });
    // Private API for inline tokens
    const inlineTokens = Boolean(restProps.inlineTokens);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $274dd79cbacd4aac$export$2e2bcd8739ae039), Object.assign({
        options: options,
        filteringType: filteringType,
        statusType: statusType,
        selectedOptions: selectedOptions,
        keepOpen: keepOpen,
        hideTokens: hideTokens,
        inlineTokens: inlineTokens
    }, restProps, baseComponentProps, {
        ref: ref
    }));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($8bb34a8468c146d7$var$Multiselect, "Multiselect");
var $8bb34a8468c146d7$export$2e2bcd8739ae039 = $8bb34a8468c146d7$var$Multiselect;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $bee7b2eb9022be82$export$2e2bcd8739ae039 = {
    "root": "awsui_root_r2vco_1byz9_97"
};

























const $70c5949ccf01312a$var$InternalSelect = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, externalRef)=>{
    var _b;
    var { options: options, filteringType: filteringType = "none", filteringPlaceholder: filteringPlaceholder, filteringAriaLabel: filteringAriaLabel, filteringClearAriaLabel: filteringClearAriaLabel, filteringResultsText: filteringResultsText, ariaRequired: ariaRequired, placeholder: placeholder, disabled: disabled, readOnly: readOnly, ariaLabel: ariaLabel, statusType: statusType = "finished", empty: empty, loadingText: loadingText, finishedText: finishedText, errorText: errorText, noMatch: noMatch, triggerVariant: triggerVariant = "label", renderHighlightedAriaLive: renderHighlightedAriaLive, selectedOption: selectedOption, onBlur: onBlur, onFocus: onFocus, onLoadItems: onLoadItems, onChange: onChange, virtualScroll: virtualScroll, expandToViewport: expandToViewport, autoFocus: autoFocus, __inFilteringToken: __inFilteringToken, __internalRootRef: __internalRootRef = null } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "options",
        "filteringType",
        "filteringPlaceholder",
        "filteringAriaLabel",
        "filteringClearAriaLabel",
        "filteringResultsText",
        "ariaRequired",
        "placeholder",
        "disabled",
        "readOnly",
        "ariaLabel",
        "statusType",
        "empty",
        "loadingText",
        "finishedText",
        "errorText",
        "noMatch",
        "triggerVariant",
        "renderHighlightedAriaLive",
        "selectedOption",
        "onBlur",
        "onFocus",
        "onLoadItems",
        "onChange",
        "virtualScroll",
        "expandToViewport",
        "autoFocus",
        "__inFilteringToken",
        "__internalRootRef"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const formFieldContext = (0, $4a30639b463663e4$export$824c400da192ca1b)(restProps);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("select");
    const errorIconAriaLabel = i18n("errorIconAriaLabel", restProps.errorIconAriaLabel);
    const selectedAriaLabel = i18n("selectedAriaLabel", restProps.selectedAriaLabel);
    const recoveryText = i18n("recoveryText", restProps.recoveryText);
    if (restProps.recoveryText && !onLoadItems) (0, $dd646455762bc7b9$export$5b28268982f175ba)("Select", "`onLoadItems` must be provided for `recoveryText` to be displayed.");
    const { handleLoadMore: handleLoadMore, handleRecoveryClick: handleRecoveryClick, fireLoadItems: fireLoadItems } = (0, $6e841f6ba081dbe4$export$36f5628e43bc3fcd)({
        onLoadItems: onLoadItems,
        options: options,
        statusType: statusType
    });
    (0, $6175122c42c548ad$export$2e2bcd8739ae039)("Select", "selectedOption", selectedOption, "onChange", onChange);
    (0, $1f218afa2afb7e05$export$a967962c200ab07c)("Select", "options", options);
    const [filteringValue, setFilteringValue] = (0, $acw62.useState)("");
    const { filteredOptions: filteredOptions, parentMap: parentMap, totalCount: totalCount, matchesCount: matchesCount } = (0, $842e88ad945f2818$export$3b43bf09494a926b)(options, filteringType, filteringValue);
    const rootRef = (0, $acw62.useRef)(null);
    const triggerRef = (0, $acw62.useRef)(null);
    const selfControlId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("trigger");
    const controlId = (_b = formFieldContext.controlId) !== null && _b !== void 0 ? _b : selfControlId;
    const scrollToIndex = (0, $acw62.useRef)(null);
    const { isOpen: isOpen, highlightType: highlightType, highlightedOption: highlightedOption, highlightedIndex: highlightedIndex, getTriggerProps: getTriggerProps, getDropdownProps: getDropdownProps, getFilterProps: getFilterProps, getMenuProps: getMenuProps, getOptionProps: getOptionProps, highlightOption: highlightOption, selectOption: selectOption, announceSelected: announceSelected } = (0, $6b2e7bdae89bf6e1$export$e64b2f635402ca43)({
        selectedOptions: selectedOption ? [
            selectedOption
        ] : [],
        updateSelectedOption: (option)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                selectedOption: option
            }),
        options: filteredOptions,
        filteringType: filteringType,
        onBlur: onBlur,
        onFocus: onFocus,
        externalRef: externalRef,
        fireLoadItems: fireLoadItems,
        setFilteringValue: setFilteringValue,
        statusType: statusType
    });
    const handleNativeSearch = (0, $3e842f82042c98b4$export$1fd459f1bf9b474a)({
        isEnabled: filteringType === "none",
        options: filteredOptions,
        highlightOption: !isOpen ? selectOption : highlightOption,
        highlightedOption: !isOpen ? selectedOption : highlightedOption === null || highlightedOption === void 0 ? void 0 : highlightedOption.option
    });
    const selectAriaLabelId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("select-arialabel-");
    const footerId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("footer");
    (0, $acw62.useEffect)(()=>{
        var _a;
        (_a = scrollToIndex.current) === null || _a === void 0 || _a.call(scrollToIndex, highlightedIndex);
    }, [
        highlightedIndex
    ]);
    const filter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3d59f5e64bb57d9d$export$2e2bcd8739ae039), Object.assign({
        clearAriaLabel: filteringClearAriaLabel,
        filteringType: filteringType,
        placeholder: filteringPlaceholder,
        ariaLabel: filteringAriaLabel,
        ariaRequired: ariaRequired,
        value: filteringValue
    }, getFilterProps()));
    const trigger = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c94b50b6f9902cf$export$2e2bcd8739ae039), Object.assign({
        ref: triggerRef,
        placeholder: placeholder,
        disabled: disabled,
        readOnly: readOnly,
        triggerVariant: triggerVariant,
        triggerProps: getTriggerProps(disabled, autoFocus),
        selectedOption: selectedOption,
        isOpen: isOpen,
        inFilteringToken: __inFilteringToken
    }, formFieldContext, {
        controlId: controlId,
        ariaLabelledby: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(formFieldContext.ariaLabelledby, selectAriaLabelId)
    }));
    const isEmpty = !options || options.length === 0;
    const isNoMatch = filteredOptions && filteredOptions.length === 0;
    const isFiltered = filteringType !== "none" && filteringValue.length > 0 && filteredOptions && filteredOptions.length > 0;
    const filteredText = isFiltered ? filteringResultsText === null || filteringResultsText === void 0 ? void 0 : filteringResultsText(matchesCount, totalCount) : undefined;
    const dropdownStatus = (0, $41901c188ad0f2ad$export$5467db17117c3a32)({
        statusType: statusType,
        empty: empty,
        loadingText: loadingText,
        finishedText: finishedText,
        errorText: errorText,
        recoveryText: recoveryText,
        isEmpty: isEmpty,
        isNoMatch: isNoMatch,
        noMatch: noMatch,
        isFiltered: isFiltered,
        filteringResultsText: filteredText,
        errorIconAriaLabel: errorIconAriaLabel,
        onRecoveryClick: handleRecoveryClick,
        hasRecoveryCallback: !!onLoadItems
    });
    const menuProps = Object.assign(Object.assign({}, getMenuProps()), {
        onLoadMore: handleLoadMore,
        ariaLabelledby: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(selectAriaLabelId, controlId),
        ariaDescribedby: dropdownStatus.content ? footerId : undefined
    });
    const announcement = (0, $b7f1c9ed858d2e1a$export$97d78af8d95ca8bd)({
        announceSelected: announceSelected,
        highlightedOption: highlightedOption,
        getParent: (option)=>{
            var _a;
            return (_a = parentMap.get(option)) === null || _a === void 0 ? void 0 : _a.option;
        },
        selectedAriaLabel: selectedAriaLabel,
        renderHighlightedAriaLive: renderHighlightedAriaLive
    });
    const ListComponent = virtualScroll ? (0, $ef788f2229336596$export$2e2bcd8739ae039) : (0, $e3f3b61849c4e04a$export$2e2bcd8739ae039);
    const handleMouseDown = (event)=>{
        const target = event.target;
        if (target !== document.activeElement) // prevent currently focused element from losing it
        event.preventDefault();
    };
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(rootRef, __internalRootRef);
    const dropdownProps = getDropdownProps();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        ref: mergedRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $bee7b2eb9022be82$export$2e2bcd8739ae039).root, baseProps.className),
        onKeyDown: handleNativeSearch
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1fd689c8894b21bd$export$2e2bcd8739ae039), Object.assign({}, dropdownProps, {
        ariaLabelledby: dropdownProps.dropdownContentRole ? (0, $49fa9e74c692ea64$export$b933cda3796739ed)(selectAriaLabelId, controlId) : undefined,
        ariaDescribedby: dropdownProps.dropdownContentRole ? dropdownStatus.content ? footerId : undefined : undefined,
        open: isOpen,
        stretchTriggerHeight: __inFilteringToken,
        stretchBeyondTriggerWidth: true,
        trigger: trigger,
        header: filter,
        onMouseDown: handleMouseDown,
        footer: dropdownStatus.isSticky ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4d1a5dc327bab5f7$export$2e2bcd8739ae039), {
            content: isOpen ? dropdownStatus.content : null,
            id: footerId
        }) : null,
        expandToViewport: expandToViewport
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ListComponent, {
        listBottom: !dropdownStatus.isSticky ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4d1a5dc327bab5f7$export$2e2bcd8739ae039), {
            content: isOpen ? dropdownStatus.content : null,
            id: footerId
        }) : null,
        menuProps: menuProps,
        getOptionProps: getOptionProps,
        filteredOptions: filteredOptions,
        filteringValue: filteringValue,
        ref: scrollToIndex,
        hasDropdownStatus: dropdownStatus.content !== null,
        screenReaderContent: announcement,
        highlightType: highlightType
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b8469ab82402f2dd$export$2e2bcd8739ae039), {
        id: selectAriaLabelId
    }, ariaLabel));
});
var $70c5949ccf01312a$export$2e2bcd8739ae039 = $70c5949ccf01312a$var$InternalSelect;





const $1a3c01a344cfcaf3$var$Select = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { options: options = [], filteringType: filteringType = "none", statusType: statusType = "finished", triggerVariant: triggerVariant = "label" } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "options",
        "filteringType",
        "statusType",
        "triggerVariant"
    ]);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Select", {
        props: {
            autoFocus: restProps.autoFocus,
            expandToViewport: restProps.expandToViewport,
            filteringType: filteringType,
            triggerVariant: triggerVariant,
            virtualScroll: restProps.virtualScroll
        }
    });
    const externalProps = (0, $3833f34df478664f$export$21af416108db3048)(restProps);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70c5949ccf01312a$export$2e2bcd8739ae039), Object.assign({
        options: options,
        filteringType: filteringType,
        statusType: statusType,
        triggerVariant: triggerVariant
    }, externalProps, baseComponentProps, {
        ref: ref
    }));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($1a3c01a344cfcaf3$var$Select, "Select");
var $1a3c01a344cfcaf3$export$2e2bcd8739ae039 = $1a3c01a344cfcaf3$var$Select;



var $acw62 = parcelRequire("acw62");





var $b98c12bd88d60794$export$2e2bcd8739ae039 = {
    "tabs-header": "awsui_tabs-header_14rmt_1kz54_194",
    "tabs-header-list": "awsui_tabs-header-list_14rmt_1kz54_202",
    "pagination-button": "awsui_pagination-button_14rmt_1kz54_219",
    "pagination-button-left": "awsui_pagination-button-left_14rmt_1kz54_226",
    "pagination-button-left-scrollable": "awsui_pagination-button-left-scrollable_14rmt_1kz54_229",
    "pagination-button-right": "awsui_pagination-button-right_14rmt_1kz54_233",
    "pagination-button-right-scrollable": "awsui_pagination-button-right-scrollable_14rmt_1kz54_236",
    "tabs-tab": "awsui_tabs-tab_14rmt_1kz54_241",
    "tabs-tab-label": "awsui_tabs-tab-label_14rmt_1kz54_250",
    "tabs-tab-dismiss": "awsui_tabs-tab-dismiss_14rmt_1kz54_261",
    "tabs-tab-action": "awsui_tabs-tab-action_14rmt_1kz54_262",
    "tabs-tab-header-container": "awsui_tabs-tab-header-container_14rmt_1kz54_266",
    "refresh": "awsui_refresh_14rmt_1kz54_281",
    "tabs-tab-disabled": "awsui_tabs-tab-disabled_14rmt_1kz54_285",
    "tabs-tab-link": "awsui_tabs-tab-link_14rmt_1kz54_327",
    "tabs-tab-active": "awsui_tabs-tab-active_14rmt_1kz54_403",
    "tabs-header-with-divider": "awsui_tabs-header-with-divider_14rmt_1kz54_410",
    "tabs-tab-focusable": "awsui_tabs-tab-focusable_14rmt_1kz54_414",
    "root": "awsui_root_14rmt_1kz54_418",
    "tabs": "awsui_tabs_14rmt_1kz54_194",
    "tabs-content": "awsui_tabs-content_14rmt_1kz54_459",
    "fit-height": "awsui_fit-height_14rmt_1kz54_463",
    "tabs-content-active": "awsui_tabs-content-active_14rmt_1kz54_469",
    "tabs-content-wrapper": "awsui_tabs-content-wrapper_14rmt_1kz54_483",
    "with-paddings": "awsui_with-paddings_14rmt_1kz54_483",
    "tabs-container-content-wrapper": "awsui_tabs-container-content-wrapper_14rmt_1kz54_494",
    "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_14rmt_1kz54_505",
    "tabs-tab-focused": "awsui_tabs-tab-focused_14rmt_1kz54_509"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// This function is in a separate file to allow for mocking in unit tests
function $c788c75c0d66b726$export$2e2bcd8739ae039() {
    return "scrollBehavior" in document.documentElement.style;
}


// The scroll speed depends on the scrolling distance. The equation below is an interpolation of measurements in Chrome.
const $b34d710081dd5986$var$getScrollSpeed = (pixels)=>0.0015 * Math.abs(pixels) + 0.558;
const $b34d710081dd5986$var$getScrollTime = (pixels)=>Math.round(Math.abs(pixels) / $b34d710081dd5986$var$getScrollSpeed(pixels));
const $b34d710081dd5986$var$now = ()=>window.performance ? window.performance.now() : Date.now();
const $b34d710081dd5986$var$ease = (k)=>{
    return 0.5 * (1 - Math.cos(Math.PI * k));
};
const $b34d710081dd5986$var$step = (context)=>{
    const time = $b34d710081dd5986$var$now();
    const elapsed = Math.min((time - context.startTime) / context.scrollTime, 1);
    const value = $b34d710081dd5986$var$ease(elapsed);
    const currentX = context.startX + (context.endX - context.startX) * value;
    context.scrollable.scrollLeft = currentX;
    // scroll more if we have not reached our destination
    if (currentX !== context.endX) requestAnimationFrame(()=>$b34d710081dd5986$var$step(context));
};
const $b34d710081dd5986$var$simulateSmoothScroll = (element, endX)=>{
    const startX = element.scrollLeft;
    $b34d710081dd5986$var$step({
        scrollable: element,
        startX: startX,
        endX: endX,
        startTime: $b34d710081dd5986$var$now(),
        scrollTime: $b34d710081dd5986$var$getScrollTime(endX - startX)
    });
};
const $b34d710081dd5986$var$smoothScroll = (element, to)=>{
    if ((0, $020c722843a7a503$export$399d33c9aa459b99)(element)) {
        element.scrollLeft = to;
        return;
    }
    if ((0, $c788c75c0d66b726$export$2e2bcd8739ae039)() && element.scrollTo) {
        element.scrollTo({
            left: to,
            behavior: "smooth"
        });
        return;
    }
    $b34d710081dd5986$var$simulateSmoothScroll(element, to);
};
var $b34d710081dd5986$export$2e2bcd8739ae039 = $b34d710081dd5986$var$smoothScroll;



const $ac20d4f6814ec953$export$e2980a73b22819de = (headerBarRef, direction)=>{
    if (!(headerBarRef === null || headerBarRef === void 0 ? void 0 : headerBarRef.current)) return;
    const element = headerBarRef.current;
    const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, offsetWidth: offsetWidth } = element;
    // Scroll each paginated section by 75% of what is already visible
    const paginatedSectionSize = Math.ceil(element.clientWidth * 0.75);
    const scrollDistance = direction === "forward" ? Math.min(Math.abs(scrollLeft) + paginatedSectionSize, scrollWidth - offsetWidth) : Math.max(Math.abs(scrollLeft) - paginatedSectionSize, 0);
    // scroll destination needs to be a negative number if the direction is RTL
    const scrollTo = (0, $558545a5feadf817$export$c3f2dc1a1afd265d)(element) ? scrollDistance * -1 : scrollDistance;
    (0, $b34d710081dd5986$export$2e2bcd8739ae039)(element, scrollTo);
};
const $ac20d4f6814ec953$export$6593e8d7c1045101 = (headerBar, inlineStartOverflowButton)=>{
    const { offsetWidth: offsetWidth, scrollWidth: scrollWidth } = headerBar;
    // Need to account for pagination button width when deciding if there would be overflow without them
    const paginationButtonsWidth = inlineStartOverflowButton.current && 2 * inlineStartOverflowButton.current.offsetWidth;
    return paginationButtonsWidth ? scrollWidth > offsetWidth + paginationButtonsWidth : scrollWidth > offsetWidth;
};
const $ac20d4f6814ec953$export$f68d63f3e53e9a7f = (headerBar)=>{
    return (0, $558545a5feadf817$export$2ba840c8e91736fd)(headerBar) > 0;
};
const $ac20d4f6814ec953$export$a741e8cb1f4eb366 = (headerBar)=>{
    return Math.ceil((0, $558545a5feadf817$export$2ba840c8e91736fd)(headerBar)) < headerBar.scrollWidth - headerBar.offsetWidth;
};
const $ac20d4f6814ec953$export$53a0910f038337bd = (tabHeader, headerBar, smooth = true)=>{
    if (!tabHeader || !headerBar) return;
    // Extra left and right margin to always make the focus ring visible
    const margin = 2;
    let updatedLeftScroll = headerBar.scrollLeft;
    // Anchor tab to left of scroll parent
    updatedLeftScroll = Math.min(updatedLeftScroll, tabHeader.offsetLeft - margin);
    // Anchor tab to right of scroll parent
    updatedLeftScroll = Math.max(updatedLeftScroll, tabHeader.offsetLeft + tabHeader.offsetWidth - headerBar.offsetWidth + margin);
    if (smooth) (0, $b34d710081dd5986$export$2e2bcd8739ae039)(headerBar, updatedLeftScroll);
    else headerBar.scrollLeft = updatedLeftScroll;
};












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Returns given index if it is in range or the opposite range boundary otherwise.
function $9cebea7438e8886d$export$548e06c1946bc4e(index, [from, to]) {
    if (index < from) return to;
    if (index > to) return from;
    return index;
}


const $2bc37773cc3b7003$var$tabSelector = `.${(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-link"]}`;
const $2bc37773cc3b7003$var$focusedTabSelector = `[role="tab"].${(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-focused"]}`;
const $2bc37773cc3b7003$var$focusableTabSelector = `.${(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-focusable"]}`;
function $2bc37773cc3b7003$var$dismissButton(dismissLabel, dismissDisabled, onDismiss) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        onClick: onDismiss,
        variant: "icon",
        iconName: "close",
        formAction: "none",
        ariaLabel: dismissLabel,
        disabled: dismissDisabled
    });
}
function $2bc37773cc3b7003$export$54e7b1d47a1cf43a({ onChange: onChange, activeTabId: activeTabId, tabs: tabs, variant: variant, idNamespace: idNamespace, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, i18nStrings: i18nStrings }) {
    const headerBarRef = (0, $acw62.useRef)(null);
    const activeTabHeaderRef = (0, $acw62.useRef)(null);
    const inlineStartOverflowButton = (0, $acw62.useRef)(null);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("tabs");
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const containerObjectRef = (0, $acw62.useRef)(null);
    const [widthChange, containerMeasureRef] = (0, $6e052e2d296ab854$export$2e2bcd8739ae039)((rect)=>rect.contentBoxWidth);
    const containerRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(containerObjectRef, containerMeasureRef);
    const tabRefs = (0, $acw62.useRef)(new Map());
    const [horizontalOverflow, setHorizontalOverflow] = (0, $acw62.useState)(false);
    const [inlineStartOverflow, setInlineStartOverflow] = (0, $acw62.useState)(false);
    const [inlineEndOverflow, setInlineEndOverflow] = (0, $acw62.useState)(false);
    const [focusedTabId, setFocusedTabId] = (0, $acw62.useState)(activeTabId);
    const [previousActiveTabId, setPreviousActiveTabId] = (0, $acw62.useState)(activeTabId);
    const hasActionOrDismissible = tabs.some((tab)=>tab.action || tab.dismissible);
    const tabActionAttributes = hasActionOrDismissible ? {
        role: "application",
        "aria-roledescription": i18n("i18nStrings.tabsWithActionsAriaRoleDescription", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.tabsWithActionsAriaRoleDescription)
    } : {
        role: "tablist"
    };
    (0, $acw62.useEffect)(()=>{
        if (headerBarRef.current) {
            setHorizontalOverflow((0, $ac20d4f6814ec953$export$6593e8d7c1045101)(headerBarRef.current, inlineStartOverflowButton));
            setInlineStartOverflow((0, $ac20d4f6814ec953$export$f68d63f3e53e9a7f)(headerBarRef.current));
            setInlineEndOverflow((0, $ac20d4f6814ec953$export$a741e8cb1f4eb366)(headerBarRef.current));
        }
    }, [
        widthChange,
        tabs
    ]);
    const scrollIntoViewIfPossible = (smooth)=>{
        if (!activeTabId) return;
        const activeTabRef = tabRefs.current.get(activeTabId);
        if (activeTabRef && headerBarRef.current) (0, $ac20d4f6814ec953$export$53a0910f038337bd)(activeTabRef, headerBarRef.current, smooth);
    };
    (0, $acw62.useEffect)(()=>{
        // Delay scrollIntoView as the position is depending on parent elements
        // (effects are called inside-out in the component tree).
        // Wait one frame to allow parents to complete it's calculation.
        requestAnimationFrame(()=>{
            scrollIntoViewIfPossible(false);
        });
    // Non-smooth scrolling should not be called upon activeId change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        horizontalOverflow,
        widthChange,
        tabs.length
    ]);
    (0, $acw62.useEffect)(()=>{
        scrollIntoViewIfPossible(true);
    // Smooth scrolling should only be called upon activeId change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activeTabId
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        /*
         When the selected tab changes and we are currently already focused on a tab,
         move the focus to the newly selected tab.
        */ if ((_a = headerBarRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement)) {
            if (document.activeElement !== activeTabHeaderRef.current) (_b = activeTabHeaderRef.current) === null || _b === void 0 || _b.focus({
                preventScroll: true
            });
        }
    }, [
        activeTabId
    ]);
    const onScroll = ()=>{
        if (headerBarRef.current) {
            setInlineStartOverflow((0, $ac20d4f6814ec953$export$f68d63f3e53e9a7f)(headerBarRef.current));
            setInlineEndOverflow((0, $ac20d4f6814ec953$export$a741e8cb1f4eb366)(headerBarRef.current));
        }
    };
    const classes = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-header"]]: true,
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-header-with-divider"]]: variant === "default" || isVisualRefresh
    });
    const leftButtonClasses = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["pagination-button"]]: true,
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["pagination-button-left"]]: true,
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["pagination-button-left-scrollable"]]: inlineStartOverflow
    });
    const rightButtonClasses = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["pagination-button"]]: true,
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["pagination-button-right"]]: true,
        [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["pagination-button-right-scrollable"]]: inlineEndOverflow
    });
    const navigationAPI = (0, $acw62.useRef)(null);
    function getNextFocusTarget() {
        var _a, _b;
        if (!containerObjectRef.current) return null;
        const tabElements = Array.from(containerObjectRef.current.querySelectorAll($2bc37773cc3b7003$var$tabSelector));
        return (_b = (_a = tabElements.find((tab)=>tab.matches($2bc37773cc3b7003$var$focusedTabSelector))) !== null && _a !== void 0 ? _a : tabElements.find((tab)=>!tab.disabled)) !== null && _b !== void 0 ? _b : null;
    }
    function onUnregisterFocusable(focusableElement) {
        const isUnregisteringFocusedNode = (0, $4c778684f125e678$export$57d4cb221e1d1857)(focusableElement, document.activeElement);
        const isFocusableActionOrDismissible = !focusableElement.classList.contains((0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-link"]);
        if (isUnregisteringFocusedNode && !isFocusableActionOrDismissible) // Wait for unmounted node to get removed from the DOM.
        requestAnimationFrame(()=>{
            var _a;
            const nextFocusTarget = (_a = navigationAPI.current) === null || _a === void 0 ? void 0 : _a.getFocusTarget();
            const tabLinkButton = nextFocusTarget === null || nextFocusTarget === void 0 ? void 0 : nextFocusTarget.querySelector(`.${(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-link"]}`);
            tabLinkButton === null || tabLinkButton === void 0 || tabLinkButton.focus();
        });
    }
    (0, $acw62.useEffect)(()=>{
        var _a;
        (_a = navigationAPI.current) === null || _a === void 0 || _a.updateFocusTarget();
    });
    function onFocus() {
        var _a;
        (_a = navigationAPI.current) === null || _a === void 0 || _a.updateFocusTarget();
    }
    function onBlur() {
        var _a;
        (_a = navigationAPI.current) === null || _a === void 0 || _a.updateFocusTarget();
    }
    function onKeyDown(event) {
        const focusTarget = document.activeElement;
        const specialKeys = [
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).left,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).end,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).home,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).pageUp,
            (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).pageDown
        ];
        const isActionOpen = document.querySelector(`.${(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-action"]} [aria-expanded="true"]`);
        const isDismissOrActionFocused = !(focusTarget === null || focusTarget === void 0 ? void 0 : focusTarget.classList.contains((0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-link"]));
        if (isActionOpen) return;
        if (event.key === "Tab" && !event.shiftKey && isDismissOrActionFocused) {
            event.preventDefault();
            const panelId = `${idNamespace}-${activeTabId}-panel`;
            const panel = document.getElementById(panelId);
            panel === null || panel === void 0 || panel.focus();
        }
        if ((0, $fc537b925f715587$export$17ddd23cbcfe5784)(event) || specialKeys.indexOf(event.keyCode) === -1) return;
        if (!containerObjectRef.current || !focusTarget) return;
        event.preventDefault();
        const focusables = getFocusablesFrom(containerObjectRef.current);
        const activeIndex = document.activeElement instanceof HTMLElement ? focusables.indexOf(document.activeElement) : -1;
        (0, $d790fc2d8f354fdb$export$2e2bcd8739ae039)(event, {
            onHome: ()=>focusElement(focusables[0]),
            onEnd: ()=>focusElement(focusables[focusables.length - 1]),
            onInlineStart: ()=>focusElement(focusables[(0, $9cebea7438e8886d$export$548e06c1946bc4e)(activeIndex - 1, [
                    0,
                    focusables.length - 1
                ])]),
            onInlineEnd: ()=>focusElement(focusables[(0, $9cebea7438e8886d$export$548e06c1946bc4e)(activeIndex + 1, [
                    0,
                    focusables.length - 1
                ])]),
            onPageDown: ()=>inlineEndOverflow && (0, $ac20d4f6814ec953$export$e2980a73b22819de)(headerBarRef, "forward"),
            onPageUp: ()=>inlineStartOverflow && (0, $ac20d4f6814ec953$export$e2980a73b22819de)(headerBarRef, "backward")
        });
    }
    function focusElement(element) {
        var _a, _b;
        element.focus();
        // If focusable element is a tab - fire the onChange for it.
        const tabsById = tabs.reduce((map, tab)=>map.set(tab.id, tab), new Map());
        for (const [tabId, focusTargetTabTriggerElement] of tabRefs.current.entries()){
            const focusTargetTabLabelElement = focusTargetTabTriggerElement === null || focusTargetTabTriggerElement === void 0 ? void 0 : focusTargetTabTriggerElement.querySelector(`.${(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-link"]}`);
            if (tabId !== activeTabId && focusTargetTabLabelElement === element) {
                setPreviousActiveTabId(tabId);
                setFocusedTabId(tabId);
                if (!((_a = tabsById.get(tabId)) === null || _a === void 0 ? void 0 : _a.disabled)) onChange({
                    activeTabId: tabId,
                    activeTabHref: (_b = tabsById.get(tabId)) === null || _b === void 0 ? void 0 : _b.href
                });
                break;
            }
        }
    }
    // List all non-disabled and registered focusables: those are eligible for keyboard navigation.
    function getFocusablesFrom(target) {
        function isElementRegistered(element) {
            var _a, _b;
            return (_b = (_a = navigationAPI.current) === null || _a === void 0 ? void 0 : _a.isRegistered(element)) !== null && _b !== void 0 ? _b : false;
        }
        function isElementFocusable(element) {
            if (element instanceof HTMLButtonElement) return !element.disabled || element.closest($2bc37773cc3b7003$var$focusableTabSelector);
            return element.matches($2bc37773cc3b7003$var$focusableTabSelector);
        }
        return (0, $eaddf2de854ee801$export$3fcce23e1e72b35b)(target).filter((el)=>isElementRegistered(el) && isElementFocusable(el));
    }
    const TabList = hasActionOrDismissible ? "div" : "ul";
    return(//converted span to div as list should not be a child of span for HTML validation
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes,
        ref: containerRef
    }, horizontalOverflow && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: inlineStartOverflowButton,
        className: leftButtonClasses
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        formAction: "none",
        variant: "icon",
        iconName: "angle-left",
        disabled: !inlineStartOverflow,
        __focusable: true,
        onClick: ()=>(0, $ac20d4f6814ec953$export$e2980a73b22819de)(headerBarRef, "backward"),
        ariaLabel: i18n("i18nStrings.scrollLeftAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.scrollLeftAriaLabel)
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7f9661e47bcc5460$export$44f87403d31a265f), {
        ref: navigationAPI,
        navigationActive: true,
        getNextFocusTarget: getNextFocusTarget,
        onUnregisterFocusable: onUnregisterFocusable
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TabList, Object.assign({}, tabActionAttributes, {
        className: (0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-header-list"],
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        ref: headerBarRef,
        onScroll: onScroll,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur
    }), tabs.map(renderTabHeader))), horizontalOverflow && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: rightButtonClasses
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        formAction: "none",
        variant: "icon",
        iconName: "angle-right",
        disabled: !inlineEndOverflow,
        __focusable: true,
        onClick: ()=>(0, $ac20d4f6814ec953$export$e2980a73b22819de)(headerBarRef, "forward"),
        ariaLabel: i18n("i18nStrings.scrollRightAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.scrollRightAriaLabel)
    }))));
    function renderTabHeader(tab) {
        const { dismissible: dismissible, dismissLabel: dismissLabel, dismissDisabled: dismissDisabled, action: action, onDismiss: onDismiss } = tab;
        const isActive = activeTabId === tab.id && !tab.disabled;
        const clickTab = (event)=>{
            if (tab.disabled) {
                event.preventDefault();
                return;
            }
            // if the primary mouse button is clicked with a modifier key, the browser will handle opening a new tab
            const specialKey = !(0, $fc537b925f715587$export$aaf9a36dd84c3909)(event);
            if (specialKey && tab.href) return;
            event.preventDefault();
            // for browsers that do not focus buttons on button click
            if (!tab.href) {
                const clickedTabRef = tabRefs.current.get(tab.id);
                if (clickedTabRef) {
                    if (clickedTabRef && clickedTabRef !== document.activeElement) clickedTabRef.focus({
                        preventScroll: true
                    });
                }
            }
            if (tab.id === activeTabId) return;
            setFocusedTabId(tab.id);
            setPreviousActiveTabId(tab.id);
            onChange({
                activeTabId: tab.id,
                activeTabHref: tab.href
            });
        };
        const classes = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-link"]]: true,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039).refresh]: isVisualRefresh,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-active"]]: activeTabId === tab.id && !tab.disabled,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-focused"]]: focusedTabId === tab.id,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-active"]]: isActive,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-disabled"]]: tab.disabled,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-focusable"]]: !tab.disabled || tab.disabled && !!tab.disabledReason
        });
        const tabHeaderContainerClasses = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-header-container"]]: true,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039).refresh]: isVisualRefresh,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-active"]]: isActive,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-disabled"]]: tab.disabled,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-focusable"]]: !tab.disabled || tab.disabled && !!tab.disabledReason
        });
        const tabActionClasses = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-action"]]: true,
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-active"]]: isActive
        });
        const commonProps = {
            className: classes,
            "aria-controls": `${idNamespace}-${tab.id}-panel`,
            "data-testid": tab.id,
            id: $2bc37773cc3b7003$export$9697735e7c51a21({
                namespace: idNamespace,
                tabId: tab.id
            }),
            onClick: clickTab
        };
        const tabHeaderContainerAriaProps = hasActionOrDismissible ? {
            role: "group",
            "aria-labelledby": commonProps.id
        } : {};
        if (!hasActionOrDismissible) {
            commonProps["aria-selected"] = activeTabId === tab.id;
            commonProps.role = "tab";
        } else commonProps["aria-expanded"] = activeTabId === tab.id;
        if (tab.disabled) commonProps["aria-disabled"] = "true";
        const setElement = (tabElement)=>{
            if (tab.id === activeTabId) activeTabHeaderRef.current = tabElement;
            tabRefs.current.set(tab.id, tabElement);
        };
        const handleDismiss = (event)=>{
            if (!containerObjectRef.current || !onDismiss) return;
            const tabElements = getFocusablesFrom(containerObjectRef.current).filter((el)=>el.classList.contains((0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-link"]));
            const activeTabIndex = tabElements.findIndex((el)=>el.dataset.testid === tab.id);
            tabElements.splice(activeTabIndex, 1);
            let nextActive;
            if (previousActiveTabId && previousActiveTabId !== tab.id) nextActive = tabElements.find((el)=>el.dataset.testid === previousActiveTabId);
            else nextActive = tabElements[Math.min(tabElements.length - 1, activeTabIndex)];
            if (nextActive && nextActive.dataset.testid) {
                onChange({
                    activeTabId: nextActive.dataset.testid
                });
                nextActive.focus();
            }
            onDismiss(event);
        };
        const TabItem = hasActionOrDismissible ? "div" : "li";
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TabItem, {
            ref: (element)=>tabRefs.current.set(tab.id, element),
            className: (0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab"],
            role: "presentation",
            key: tab.id
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
            className: tabHeaderContainerClasses
        }, tabHeaderContainerAriaProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2bc37773cc3b7003$var$TabTrigger, {
            ref: setElement,
            tab: tab,
            elementProps: commonProps
        }), action && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: tabActionClasses
        }, action), dismissible && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-dismiss"]
        }, $2bc37773cc3b7003$var$dismissButton(dismissLabel, dismissDisabled, handleDismiss))));
    }
}
const $2bc37773cc3b7003$var$TabTrigger = (0, $acw62.forwardRef)(({ tab: tab, elementProps: elementProps }, ref)=>{
    const refObject = (0, $acw62.useRef)(null);
    const tabLabelRefObject = (0, $acw62.useRef)(null);
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(refObject, ref);
    const { tabIndex: tabIndex } = (0, $7f9661e47bcc5460$export$4cf30df7bba16ac9)(refObject);
    const isDisabledWithReason = tab.disabled && !!tab.disabledReason;
    const [showTooltip, setShowTooltip] = (0, $acw62.useState)(false);
    const { targetProps: targetProps, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(tab.disabledReason);
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-tab-label"],
        ref: tabLabelRefObject
    }, tab.label), isDisabledWithReason && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, descriptionEl, showTooltip && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $76f4c84fd1bac364$export$2e2bcd8739ae039), {
        className: (0, $b98c12bd88d60794$export$2e2bcd8739ae039)["disabled-reason-tooltip"],
        trackRef: tabLabelRefObject,
        value: tab.disabledReason
    })));
    const handlers = {
        onFocus: ()=>setShowTooltip(true),
        onBlur: ()=>setShowTooltip(false),
        onMouseEnter: ()=>setShowTooltip(true),
        onMouseLeave: ()=>setShowTooltip(false)
    };
    const commonProps = Object.assign(Object.assign(Object.assign(Object.assign({}, elementProps), isDisabledWithReason ? targetProps : {}), isDisabledWithReason ? handlers : {}), {
        ref: mergedRef,
        tabIndex: tabIndex
    });
    return tab.href ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({}, commonProps, {
        href: tab.href
    }), children) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({}, commonProps, {
        type: "button",
        disabled: tab.disabled && !isDisabledWithReason
    }), children);
});
function $2bc37773cc3b7003$export$9697735e7c51a21({ namespace: namespace, tabId: tabId }) {
    return namespace + "-" + tabId;
}







function $e9b1a89cfa249459$var$firstEnabledTab(tabs) {
    const enabledTabs = tabs.filter((tab)=>!tab.disabled);
    if (enabledTabs.length > 0) return enabledTabs[0];
    return null;
}
function $e9b1a89cfa249459$export$2e2bcd8739ae039(_a) {
    var _b, _c;
    var { tabs: tabs, variant: variant = "default", onChange: onChange, activeTabId: controlledTabId, ariaLabel: ariaLabel, ariaLabelledby: ariaLabelledby, disableContentPaddings: disableContentPaddings = false, i18nStrings: i18nStrings, fitHeight: fitHeight } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "tabs",
        "variant",
        "onChange",
        "activeTabId",
        "ariaLabel",
        "ariaLabelledby",
        "disableContentPaddings",
        "i18nStrings",
        "fitHeight"
    ]);
    for (const tab of tabs)(0, $3de0f29144bb4e85$export$6661f6891a200a5f)("Tabs", tab.href);
    const { __internalRootRef: __internalRootRef } = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Tabs", {
        props: {
            disableContentPaddings: disableContentPaddings,
            variant: variant
        }
    });
    const idNamespace = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("awsui-tabs-");
    const [activeTabId, setActiveTabId] = (0, $7c41f87eb31b9657$export$454217e89aea72b)(controlledTabId, onChange, (_c = (_b = $e9b1a89cfa249459$var$firstEnabledTab(tabs)) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : "", {
        componentName: "Tabs",
        controlledProp: "activeTabId",
        changeHandler: "onChange"
    });
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const content = ()=>{
        const selectedTab = tabs.filter((tab)=>tab.id === activeTabId)[0];
        const renderContent = (tab)=>{
            const isTabSelected = tab === selectedTab;
            const classes = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
                [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-content"]]: true,
                [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-content-active"]]: isTabSelected
            });
            const contentAttributes = {
                className: classes,
                role: "tabpanel",
                id: `${idNamespace}-${tab.id}-panel`,
                key: `${idNamespace}-${tab.id}-panel`,
                tabIndex: 0,
                "aria-labelledby": (0, $2bc37773cc3b7003$export$9697735e7c51a21)({
                    namespace: idNamespace,
                    tabId: tab.id
                })
            };
            const isContentShown = isTabSelected && !selectedTab.disabled;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, contentAttributes), isContentShown && selectedTab.content);
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(variant === "container" || variant === "stacked" ? (0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-container-content-wrapper"] : (0, $b98c12bd88d60794$export$2e2bcd8739ae039)["tabs-content-wrapper"], {
                [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["with-paddings"]]: !disableContentPaddings
            })
        }, tabs.map(renderContent));
    };
    const header = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2bc37773cc3b7003$export$54e7b1d47a1cf43a), {
        activeTabId: activeTabId,
        variant: variant,
        idNamespace: idNamespace,
        ariaLabel: ariaLabel,
        ariaLabelledby: ariaLabelledby,
        tabs: tabs,
        onChange: (changeDetail)=>{
            setActiveTabId(changeDetail.activeTabId);
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, changeDetail);
        },
        i18nStrings: i18nStrings
    });
    if (variant === "container" || variant === "stacked") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc8a25d23ca8ebd0$export$2e2bcd8739ae039), Object.assign({
        header: header,
        disableHeaderPaddings: true
    }, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $b98c12bd88d60794$export$2e2bcd8739ae039).root),
        __internalRootRef: __internalRootRef,
        disableContentPaddings: true,
        variant: variant === "stacked" ? "stacked" : "default",
        fitHeight: fitHeight
    }), content());
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $b98c12bd88d60794$export$2e2bcd8739ae039).root, (0, $b98c12bd88d60794$export$2e2bcd8739ae039).tabs, {
            [(0, $b98c12bd88d60794$export$2e2bcd8739ae039)["fit-height"]]: fitHeight
        }),
        ref: __internalRootRef
    }), header, content());
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($e9b1a89cfa249459$export$2e2bcd8739ae039, "Tabs");



var $acw62 = parcelRequire("acw62");






var $77ecea69e11a09ba$export$2e2bcd8739ae039 = {
    "root": "awsui_root_qk1j1_1x14a_97",
    "textarea": "awsui_textarea_qk1j1_1x14a_101",
    "textarea-readonly": "awsui_textarea-readonly_qk1j1_1x14a_154",
    "textarea-invalid": "awsui_textarea-invalid_qk1j1_1x14a_196",
    "textarea-warning": "awsui_textarea-warning_qk1j1_1x14a_207"
};





const $def0f31f988660f4$var$Textarea = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { value: value, autoComplete: autoComplete = true, disabled: disabled, readOnly: readOnly, disableBrowserAutocorrect: disableBrowserAutocorrect, disableBrowserSpellcheck: disableBrowserSpellcheck, spellcheck: spellcheck, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onChange: onChange, onBlur: onBlur, onFocus: onFocus, ariaRequired: ariaRequired, name: name, rows: rows, placeholder: placeholder, autoFocus: autoFocus, ariaLabel: ariaLabel } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "value",
        "autoComplete",
        "disabled",
        "readOnly",
        "disableBrowserAutocorrect",
        "disableBrowserSpellcheck",
        "spellcheck",
        "onKeyDown",
        "onKeyUp",
        "onChange",
        "onBlur",
        "onFocus",
        "ariaRequired",
        "name",
        "rows",
        "placeholder",
        "autoFocus",
        "ariaLabel"
    ]);
    const { __internalRootRef: __internalRootRef } = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Textarea", {
        props: {
            autoComplete: autoComplete,
            autoFocus: autoFocus,
            disableBrowserAutocorrect: disableBrowserAutocorrect,
            disableBrowserSpellcheck: disableBrowserSpellcheck,
            readOnly: readOnly,
            spellcheck: spellcheck
        }
    });
    const { ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, controlId: controlId, invalid: invalid, warning: warning } = (0, $4a30639b463663e4$export$824c400da192ca1b)(rest);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const textareaRef = (0, $acw62.useRef)(null);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, textareaRef);
    const attributes = {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        "aria-required": ariaRequired ? "true" : undefined,
        "aria-invalid": invalid ? "true" : undefined,
        name: name,
        placeholder: placeholder,
        autoFocus: autoFocus,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $77ecea69e11a09ba$export$2e2bcd8739ae039).textarea, {
            [(0, $77ecea69e11a09ba$export$2e2bcd8739ae039)["textarea-readonly"]]: readOnly,
            [(0, $77ecea69e11a09ba$export$2e2bcd8739ae039)["textarea-invalid"]]: invalid,
            [(0, $77ecea69e11a09ba$export$2e2bcd8739ae039)["textarea-warning"]]: warning && !invalid
        }),
        autoComplete: (0, $b4592d5eb2ab5ee3$export$d0b21904efc6680a)(autoComplete),
        spellCheck: spellcheck,
        disabled: disabled,
        readOnly: readOnly ? true : undefined,
        rows: rows || 3,
        onKeyDown: onKeyDown && ((event)=>(0, $fc537b925f715587$export$d23d807e6c464ee0)(onKeyDown, event)),
        onKeyUp: onKeyUp && ((event)=>(0, $fc537b925f715587$export$d23d807e6c464ee0)(onKeyUp, event)),
        // We set a default value on the component in order to force it into the controlled mode.
        value: value || "",
        onChange: onChange && ((event)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                value: event.target.value
            })),
        onBlur: onBlur && (()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur)),
        onFocus: onFocus && (()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus))
    };
    if (disableBrowserAutocorrect) {
        attributes.autoCorrect = "off";
        attributes.autoCapitalize = "off";
    }
    if (disableBrowserSpellcheck) attributes.spellCheck = "false";
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $77ecea69e11a09ba$export$2e2bcd8739ae039).root, baseProps.className),
        ref: __internalRootRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", Object.assign({
        ref: textareaRef,
        id: controlId
    }, attributes)));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($def0f31f988660f4$var$Textarea, "Textarea");
var $def0f31f988660f4$export$2e2bcd8739ae039 = $def0f31f988660f4$var$Textarea;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $701b6c0516155145$exports = {};
"use strict";

$701b6c0516155145$exports = (parcelRequire("gbH6E"));


var $55388fc2f116d4d7$var$__defProp = Object.defineProperty;
var $55388fc2f116d4d7$var$__defProps = Object.defineProperties;
var $55388fc2f116d4d7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $55388fc2f116d4d7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $55388fc2f116d4d7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $55388fc2f116d4d7$var$__defNormalProp = (obj, key, value)=>key in obj ? $55388fc2f116d4d7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $55388fc2f116d4d7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($55388fc2f116d4d7$var$__hasOwnProp.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    if ($55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(b))if ($55388fc2f116d4d7$var$__propIsEnum.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $55388fc2f116d4d7$var$__spreadProps = (a, b)=>$55388fc2f116d4d7$var$__defProps(a, $55388fc2f116d4d7$var$__getOwnPropDescs(b));
var $55388fc2f116d4d7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($55388fc2f116d4d7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $55388fc2f116d4d7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $55388fc2f116d4d7$var$React = // prettier-ignore
// @ts-ignore
"default" in $acw62 ? $acw62["default"] : $acw62;
// src/components/Context.ts
var $55388fc2f116d4d7$var$ContextKey = Symbol.for(`react-redux-context`);
var $55388fc2f116d4d7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55388fc2f116d4d7$var$getContext() {
    var _a;
    if (!$55388fc2f116d4d7$var$React.createContext) return {};
    const contextMap = (_a = $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey]) != null ? _a : $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($55388fc2f116d4d7$var$React.createContext);
    if (!realContext) {
        realContext = $55388fc2f116d4d7$var$React.createContext(null);
        contextMap.set($55388fc2f116d4d7$var$React.createContext, realContext);
    }
    return realContext;
}
var $55388fc2f116d4d7$export$cc80c08dc91f1c00 = /* @__PURE__ */ $55388fc2f116d4d7$var$getContext();
// src/utils/useSyncExternalStore.ts
var $55388fc2f116d4d7$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $55388fc2f116d4d7$var$createReduxContextHook(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $55388fc2f116d4d7$var$React.useContext(context);
        return contextValue;
    };
}
var $55388fc2f116d4d7$var$useReduxContext = /* @__PURE__ */ $55388fc2f116d4d7$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $55388fc2f116d4d7$var$useSyncExternalStoreWithSelector = $55388fc2f116d4d7$var$notInitialized;
var $55388fc2f116d4d7$var$initializeUseSelector = (fn)=>{
    $55388fc2f116d4d7$var$useSyncExternalStoreWithSelector = fn;
};
var $55388fc2f116d4d7$var$refEquality = (a, b)=>a === b;
function $55388fc2f116d4d7$export$2b53f90d2bd1cbfb(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $55388fc2f116d4d7$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $55388fc2f116d4d7$var$React.useRef(true);
        const wrappedSelector = $55388fc2f116d4d7$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $55388fc2f116d4d7$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $55388fc2f116d4d7$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $55388fc2f116d4d7$export$2105062e25df4afe = /* @__PURE__ */ $55388fc2f116d4d7$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $55388fc2f116d4d7$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $55388fc2f116d4d7$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $55388fc2f116d4d7$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $55388fc2f116d4d7$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $55388fc2f116d4d7$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $55388fc2f116d4d7$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $55388fc2f116d4d7$var$ForwardRef = $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE;
var $55388fc2f116d4d7$var$Memo = $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
function $55388fc2f116d4d7$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE || type === $55388fc2f116d4d7$var$REACT_PROFILER_TYPE || type === $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE || type === $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $55388fc2f116d4d7$var$REACT_LAZY_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_MEMO_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_PROVIDER_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $55388fc2f116d4d7$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE:
                        case $55388fc2f116d4d7$var$REACT_PROFILER_TYPE:
                        case $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE:
                        case $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE:
                        case $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $55388fc2f116d4d7$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE:
                                    case $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE:
                                    case $55388fc2f116d4d7$var$REACT_LAZY_TYPE:
                                    case $55388fc2f116d4d7$var$REACT_MEMO_TYPE:
                                    case $55388fc2f116d4d7$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $55388fc2f116d4d7$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $55388fc2f116d4d7$var$isContextConsumer(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE;
}
function $55388fc2f116d4d7$var$isMemo(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $55388fc2f116d4d7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $55388fc2f116d4d7$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $55388fc2f116d4d7$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $55388fc2f116d4d7$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $55388fc2f116d4d7$var$verify(mapStateToProps, "mapStateToProps");
    $55388fc2f116d4d7$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $55388fc2f116d4d7$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $55388fc2f116d4d7$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $55388fc2f116d4d7$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $55388fc2f116d4d7$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $55388fc2f116d4d7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $55388fc2f116d4d7$var$verifyPlainObject(value, displayName, methodName) {
    if (!$55388fc2f116d4d7$var$isPlainObject(value)) $55388fc2f116d4d7$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $55388fc2f116d4d7$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $55388fc2f116d4d7$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $55388fc2f116d4d7$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $55388fc2f116d4d7$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $55388fc2f116d4d7$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$55388fc2f116d4d7$var$defaultMergeProps : typeof mergeProps === "function" ? $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) : $55388fc2f116d4d7$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $55388fc2f116d4d7$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $55388fc2f116d4d7$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $55388fc2f116d4d7$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $55388fc2f116d4d7$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $55388fc2f116d4d7$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $55388fc2f116d4d7$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $55388fc2f116d4d7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $55388fc2f116d4d7$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $55388fc2f116d4d7$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $55388fc2f116d4d7$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $55388fc2f116d4d7$var$useIsomorphicLayoutEffect = $55388fc2f116d4d7$var$canUseDOM || $55388fc2f116d4d7$var$isReactNative ? $55388fc2f116d4d7$var$React.useLayoutEffect : $55388fc2f116d4d7$var$React.useEffect;
// src/utils/shallowEqual.ts
function $55388fc2f116d4d7$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $55388fc2f116d4d7$export$d36bdfa510afb180(objA, objB) {
    if ($55388fc2f116d4d7$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$55388fc2f116d4d7$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $55388fc2f116d4d7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $55388fc2f116d4d7$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $55388fc2f116d4d7$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$TYPE_STATICS = {
    [$55388fc2f116d4d7$var$ForwardRef]: $55388fc2f116d4d7$var$FORWARD_REF_STATICS,
    [$55388fc2f116d4d7$var$Memo]: $55388fc2f116d4d7$var$MEMO_STATICS
};
function $55388fc2f116d4d7$var$getStatics(component) {
    if ($55388fc2f116d4d7$var$isMemo(component)) return $55388fc2f116d4d7$var$MEMO_STATICS;
    return $55388fc2f116d4d7$var$TYPE_STATICS[component["$$typeof"]] || $55388fc2f116d4d7$var$REACT_STATICS;
}
var $55388fc2f116d4d7$var$defineProperty = Object.defineProperty;
var $55388fc2f116d4d7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $55388fc2f116d4d7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $55388fc2f116d4d7$var$getPrototypeOf = Object.getPrototypeOf;
var $55388fc2f116d4d7$var$objectPrototype = Object.prototype;
function $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($55388fc2f116d4d7$var$objectPrototype) {
            const inheritedComponent = $55388fc2f116d4d7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $55388fc2f116d4d7$var$objectPrototype) $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $55388fc2f116d4d7$var$getOwnPropertyNames(sourceComponent);
        if ($55388fc2f116d4d7$var$getOwnPropertySymbols) keys = keys.concat($55388fc2f116d4d7$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $55388fc2f116d4d7$var$getStatics(targetComponent);
        const sourceStatics = $55388fc2f116d4d7$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$55388fc2f116d4d7$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $55388fc2f116d4d7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $55388fc2f116d4d7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $55388fc2f116d4d7$var$useSyncExternalStore = $55388fc2f116d4d7$var$notInitialized;
var $55388fc2f116d4d7$var$initializeConnect = (fn)=>{
    $55388fc2f116d4d7$var$useSyncExternalStore = fn;
};
var $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $55388fc2f116d4d7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $55388fc2f116d4d7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $55388fc2f116d4d7$var$strictEqual(a, b) {
    return a === b;
}
var $55388fc2f116d4d7$var$hasWarnedAboutDeprecatedPureOption = false;
function $55388fc2f116d4d7$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $55388fc2f116d4d7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $55388fc2f116d4d7$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $55388fc2f116d4d7$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $55388fc2f116d4d7$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $55388fc2f116d4d7$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $55388fc2f116d4d7$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $55388fc2f116d4d7$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $55388fc2f116d4d7$var$React.useMemo(()=>{
                return $55388fc2f116d4d7$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $55388fc2f116d4d7$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $55388fc2f116d4d7$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $55388fc2f116d4d7$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $55388fc2f116d4d7$var$React.useRef(void 0);
            const lastWrapperProps = $55388fc2f116d4d7$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $55388fc2f116d4d7$var$React.useRef(void 0);
            const renderIsScheduled = $55388fc2f116d4d7$var$React.useRef(false);
            const isMounted = $55388fc2f116d4d7$var$React.useRef(false);
            const latestSubscriptionCallbackError = $55388fc2f116d4d7$var$React.useRef(void 0);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $55388fc2f116d4d7$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $55388fc2f116d4d7$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs($55388fc2f116d4d7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $55388fc2f116d4d7$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $55388fc2f116d4d7$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $55388fc2f116d4d7$var$React.createElement(WrappedComponent, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $55388fc2f116d4d7$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $55388fc2f116d4d7$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $55388fc2f116d4d7$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $55388fc2f116d4d7$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $55388fc2f116d4d7$var$React.createElement(Connect, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $55388fc2f116d4d7$export$64605811ab45167f = $55388fc2f116d4d7$var$connect;
// src/components/Provider.tsx
function $55388fc2f116d4d7$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $55388fc2f116d4d7$var$React.useMemo(()=>{
        const subscription = $55388fc2f116d4d7$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $55388fc2f116d4d7$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $55388fc2f116d4d7$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $55388fc2f116d4d7$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $55388fc2f116d4d7$export$2881499e37b75b9a = $55388fc2f116d4d7$var$Provider;
// src/hooks/useStore.ts
function $55388fc2f116d4d7$export$671dba69185d0304(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : // @ts-ignore
    $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $55388fc2f116d4d7$export$6ccbb43953eebf8 = /* @__PURE__ */ $55388fc2f116d4d7$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $55388fc2f116d4d7$export$bc9b55530897c558(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useStore2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$export$6ccbb43953eebf8 : $55388fc2f116d4d7$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $55388fc2f116d4d7$export$8ad76b76a4c905f8 = /* @__PURE__ */ $55388fc2f116d4d7$export$bc9b55530897c558();
// src/exports.ts
var $55388fc2f116d4d7$export$712ea50be43a7858 = $55388fc2f116d4d7$var$defaultNoopBatch;
// src/index.ts
$55388fc2f116d4d7$var$initializeUseSelector((0, $701b6c0516155145$exports.useSyncExternalStoreWithSelector));
$55388fc2f116d4d7$var$initializeConnect($acw62.useSyncExternalStore);


const $c0aa018cd5ecdf0e$export$f51d452c10d5b956 = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8).withTypes();
const $c0aa018cd5ecdf0e$export$a7347740d65f620b = (0, $55388fc2f116d4d7$export$2105062e25df4afe).withTypes();








const $ef4677a056004d8e$var$AUTH_RETRY_ATTEMPTS = 5;
const $ef4677a056004d8e$export$eb2799109db70ffd = ()=>{
    const auth = (0, $fe9e7bfbce151564$export$1d39dc5b47e56ff0)();
    const { appVersion: appVersion } = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    const makeApiCall = async (url, method = "GET", data)=>{
        // Setup
        let cacheControl = `&_=${Date.now()}`; // don't cache stuff
        if (url.includes("html")) cacheControl = "";
        const urlToCall = `${(0, $d8475b95fcbdc3b7$export$923ea8233b386e99)}${url}?v=${appVersion}${cacheControl}`;
        // make API call
        const fetchOptions = {
            method: method,
            headers: {
                Authorization: "Bearer " + auth.getAccessToken()
            }
        };
        if (method == "POST") {
            if (data instanceof FormData) fetchOptions.body = data;
            else fetchOptions.body = JSON.stringify(data);
        }
        return await makeApiCallInternal(urlToCall, fetchOptions);
    };
    const initializeSystem = async ()=>{
        // let cacheControl = `&_=${Date.now()}`; // don't cache stuff
        // const urlToCall = `${appInfo.apiUrl}initializeSystem?v=${appInfo.appVersion}${cacheControl}`;
        // const fetchOptions: RequestInit = {
        //   method: "GET",
        // };
        const systemInfo = await makeApiCall("initializeSystem");
        if (systemInfo) {
            if (systemInfo.ConstructionError) {
                console.log("There was an error in the system initialization code:");
                console.log(systemInfo.ConstructionError);
                return null;
            }
            //appInfo.setAppVersion(systemInfo.Version);
            document.title = `${systemInfo.ApplicationName} ${systemInfo.Version}`;
        }
        return systemInfo;
    };
    const makeApiCallInternal = async (urlToCall, fetchOptions, raiseErrors = true, authRetryCount = 1)=>{
        // make API call
        try {
            const response = await fetch(urlToCall, fetchOptions);
            if (response.ok) {
                // success
                const json = await response.json();
                return Promise.resolve(json);
            } else if (response.status == 401) {
                if (authRetryCount > $ef4677a056004d8e$var$AUTH_RETRY_ATTEMPTS) {
                    // only try AUTH_RETRY_ATTEMPTS times
                    console.log(`auth retry count exceeded ${$ef4677a056004d8e$var$AUTH_RETRY_ATTEMPTS} attempts`);
                    (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                        type: "error",
                        content: `Unable to authenticate with server, ${$ef4677a056004d8e$var$AUTH_RETRY_ATTEMPTS} attempts were made`
                    }));
                    return Promise.reject("Unable to authenticate with server, multiple attempts were made");
                }
                return auth.performTokenRefresh().then((x)=>{
                    // try call again
                    fetchOptions.headers["Authorization"] = "Bearer " + auth.getAccessToken(); // update auth token
                    return makeApiCallInternal(urlToCall, fetchOptions, raiseErrors, authRetryCount + 1).then((x)=>{
                        return Promise.resolve(x);
                    });
                }).catch((err)=>{
                    console.error("error while getting refresh token");
                    console.log(err);
                    // TODO: show login dialog -> which should then essentially restart the application initialization stuff as it will have new tokens
                    // setShowLoginDialog -> or something like that
                    return Promise.resolve(null);
                });
            } else if (response.status == 400) {
                let message = await response.text();
                if (message.includes("invalid_grant")) message = "Incorrect username or password";
                else if (message.startsWith('"')) message = message.substring(1, message.length - 2);
                (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                    type: "error",
                    content: message
                }));
                return Promise.resolve(null);
            }
            const responseText = await response.text();
            const message = `Unhandled response status ${response.status} with content: ${responseText}`;
            (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                type: "error",
                content: message
            }));
            return Promise.reject(message);
        } catch (err) {
            console.log("error making api call to: " + urlToCall);
            console.log(err);
            if (raiseErrors == true) (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                type: "error",
                content: `Error making api call to: ${urlToCall}`
            }));
            else return null;
        // alert(
        //   "Error contacting the server. You might not have internet or our server is down"
        // );
        }
    };
    return {
        makeApiCall: makeApiCall,
        initializeSystem: initializeSystem
    };
};




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $5dbc399a9d723999$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $acw62.createContext)({});
const $5dbc399a9d723999$export$178405afcd8c5eb = ({ children: children })=>{
    const [isVisible, setIsVisible] = (0, $acw62.useState)(false);
    const [currentAction, setCurrentAction] = (0, $acw62.useState)("none");
    const [confirmationSettings, setConfirmationSettings] = (0, $acw62.useState)(null);
    const [mainProps, setMainProps] = (0, $acw62.useState)({
        onCloseAction: ()=>{
            return Promise.resolve();
        }
    });
    // TODO: maybe todo. keep stack of modals so that they can be closed incrementally using an internal id etc.
    const getUserConfirmation = (props, data)=>{
        setCurrentAction("user-confirmation");
        setConfirmationSettings(props);
        setIsVisible(true);
        return new Promise((resolve)=>{
            setMainProps({
                ...mainProps,
                onCloseAction: (result)=>{
                    setIsVisible(false);
                    resolve(result);
                }
            });
        });
    };
    const onDismiss = (result)=>{
        mainProps.onCloseAction(result);
    };
    const UserConfirmationDialog = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $104eee66f5fcddce$export$2e2bcd8739ae039), {
            onDismiss: (detail)=>onDismiss(null),
            visible: currentAction != "none" && isVisible,
            footer: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
                float: "right",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                    direction: "horizontal",
                    size: "xs",
                    children: [
                        confirmationSettings?.CancelButtonText?.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
                            variant: "link",
                            onClick: ()=>onDismiss(false),
                            children: confirmationSettings?.CancelButtonText
                        }) : null,
                        confirmationSettings?.ConfirmationButtonText?.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
                            variant: "primary",
                            onClick: ()=>onDismiss(true),
                            children: confirmationSettings?.ConfirmationButtonText
                        }) : null
                    ]
                })
            }),
            header: "Confirmation",
            children: confirmationSettings?.ConfirmationMessage
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($5dbc399a9d723999$export$ab57792b9b6974a6.Provider, {
        value: {
            getUserConfirmation: getUserConfirmation
        },
        children: [
            currentAction == "user-confirmation" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(UserConfirmationDialog, {}) : null,
            children
        ]
    });
};
const $5dbc399a9d723999$export$33ffd74ebf07f060 = ()=>{
    const context = (0, $acw62.useContext)($5dbc399a9d723999$export$ab57792b9b6974a6);
    if (!context) throw new Error("useModal must be used within an ModalProvider");
    return context;
};








const $ba30691687bb8563$var$ActionContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $ba30691687bb8563$export$9ba8495ab9fb7661 = ({ children: children })=>{
    //const navigate = useNavigate();
    const modal = (0, $5dbc399a9d723999$export$33ffd74ebf07f060)();
    const api = (0, $ef4677a056004d8e$export$eb2799109db70ffd)();
    const mainApp = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    const auth = (0, $fe9e7bfbce151564$export$1d39dc5b47e56ff0)();
    const encode = (str)=>{
        return btoa(str);
    // const result = btoa(
    //   encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    //     return String.fromCharCode(0 + p1);
    //   })
    // );
    // return result;
    };
    const downloadFile = async (url, requestData)=>{
        (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
            type: "info",
            content: "File download started..."
        }));
        let urlToCall = `${(0, $d8475b95fcbdc3b7$export$923ea8233b386e99)}${url}?v=${mainApp.appVersion}`;
        urlToCall = urlToCall.replaceAll("//", "/");
        // make API call
        const fetchOptions = {
            method: "POST",
            headers: {
                Authorization: "Bearer " + auth.getAccessToken()
            }
        };
        if (requestData && requestData.length > 0) fetchOptions.body = encode(requestData);
        try {
            const fetchUrl = new URL(urlToCall); // fails without this on some domains (it adds extra localhost when https://localhost/Odyssey/ for example)
            const response = await fetch(fetchUrl, fetchOptions);
            if (response.ok) {
                const blob = await response.blob();
                let filename = response.headers.get("filename");
                if (filename == null || filename.length == 0) filename = "unknown file.zip";
                const objUrl = URL.createObjectURL(new Blob([
                    blob
                ]));
                const link = document.createElement("a");
                link.href = objUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(objUrl);
                link.remove();
                (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                    type: "success",
                    content: "File download complete"
                }));
            }
        } catch (err) {
            console.log("error downloading file with url: " + urlToCall);
            console.log(err);
            (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                type: "error",
                content: `Error downloading file: ${err}`
            }));
        }
    };
    const handleAction = async (item)=>{
        switch(item.ActionType){
            case 0:
                // show a view
                mainApp.setCurrentContentType("table");
                mainApp.showComponent({
                    menu: item,
                    type: "view"
                });
                break;
            case 1:
                // get inputs
                mainApp.showComponent({
                    menu: item,
                    type: "form"
                });
                break;
            //case 2: // submenu  - // nothing, this is commented out in the old code
            //case 3: // do something - // nothing, this is commented out in the old code
            case 4:
                mainApp.showComponent(-1);
                break;
            case 5:
                // ShowMessage
                modal.getUserConfirmation(item, null).then((result)=>{
                    if (result === true && item.OnConfirmationUIAction > 0) return onMenuClick(item.OnConfirmationUIAction, null);
                    else if (result === false && item.OnCancelUIAction > 0) return onMenuClick(item.OnCancelUIAction, null);
                });
                break;
            case 6:
                await onMenuClick(item.EventNumber, item.ParametersToPass);
                break;
            //case 7: // input data view (ignore in old code)
            case 8:
            case 9:
                // update input view
                if (item.UpdateType == 0) {
                    // add or update
                    const json = JSON.parse(item.JsonDataToUpdate);
                    mainApp.setInputViewUpdateData(json);
                } else if (item.UpdateType == 1) mainApp.setInputViewUpdateData(-1);
                break;
            case 11:
                await downloadFile(item.DataUrl, item.RequestData);
                break;
            case 13:
                const url = new URL(window.location.href);
                url.searchParams.delete("anonAction");
                url.searchParams.delete("params");
                window.history.pushState(null, "", url.toString());
                auth.logout();
                break;
            default:
                console.warn("Unknown action type: " + item.ActionType);
        }
    };
    const onMenuClick = async (event, params = null)=>{
        const url = "executeUIAction/" + event;
        const data = {
            Data: params || ""
        };
        const menuDetails = await api.makeApiCall(url, "POST", data);
        if (menuDetails && menuDetails.length > 0) for(let i = 0; i < menuDetails?.length; i++)await handleAction(menuDetails[i]);
    };
    const value = {
        handleAction: handleAction,
        onMenuClick: onMenuClick
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ba30691687bb8563$var$ActionContext.Provider, {
        value: value,
        children: children
    });
};
const $ba30691687bb8563$export$bc923229a7fa61e7 = ()=>{
    const context = (0, $acw62.useContext)($ba30691687bb8563$var$ActionContext);
    if (!context) throw new Error("useActions must be used within an ActionProvider");
    return context;
};



var $45fvw = parcelRequire("45fvw");
// export const useDebounce_old = (callback, params = null, timeout = 250) => {
//   const ref = useRef(callback);
//   ref.current = callback;
//   const debouncedCallback = useMemo(() => {
//     const func = () => {
//       ref.current?.(params);
//     };
//     return debounce(func, timeout);
//   }, []);
//   return debouncedCallback;
// };
const $154d4ea6bbdaf516$var$timers = {};
const $154d4ea6bbdaf516$export$21805fee57372823 = (callback, name, timeout, ...params)=>{
    let timer = $154d4ea6bbdaf516$var$timers[name];
    if (timer) {
        clearTimeout(timer);
        $154d4ea6bbdaf516$var$timers[name] = null;
    }
    timer = setTimeout(()=>{
        callback(...params);
        clearTimeout(timer);
        $154d4ea6bbdaf516$var$timers[name] = null;
    }, timeout);
    $154d4ea6bbdaf516$var$timers[name] = timer;
};
// https://www.geeksforgeeks.org/how-to-get-the-javascript-function-parameter-names-values-dynamically/
// JavaScript program to get the function
// name/values dynamically
function $154d4ea6bbdaf516$var$getParams(func) {
    // String representation of the function code
    let str = func.toString();
    // Remove comments of the form /* ... */
    // Removing comments of the form //
    // Remove body of the function { ... }
    // removing '=>' if func is arrow function
    str = str.replace(/\/\*[\s\S]*?\*\//g, "").replace(/\/\/(.)*/g, "").replace(/{[\s\S]*}/, "").replace(/=>/g, "").trim();
    // Start parameter names after first '('
    let start = str.indexOf("(") + 1;
    // End parameter names is just before last ')'
    let end = str.length - 1;
    let result = str.substring(start, end).split(", ");
    let params = [];
    result.forEach((element)=>{
        // Removing any default value
        element = element.replace(/=[\s\S]*/g, "").trim();
        if (element.length > 0) params.push(element);
    });
    return params;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");




var $279d8c8b10ff543c$export$2e2bcd8739ae039 = {
    "root": "awsui_root_fvjdu_ki6j9_97",
    "button": "awsui_button_fvjdu_ki6j9_140",
    "dots": "awsui_dots_fvjdu_ki6j9_141",
    "button-disabled": "awsui_button-disabled_fvjdu_ki6j9_169",
    "arrow": "awsui_arrow_fvjdu_ki6j9_174",
    "page-number": "awsui_page-number_fvjdu_ki6j9_184",
    "button-current": "awsui_button-current_fvjdu_ki6j9_190",
    "page-item": "awsui_page-item_fvjdu_ki6j9_207",
    "root-disabled": "awsui_root-disabled_fvjdu_ki6j9_225"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO [mjawors] _.range
function $eb66e6aa0a7b025e$export$d02631cccf789723(from, to) {
    const result = [];
    for(let i = from; i <= to; i++)result.push(i);
    return result;
}
function $eb66e6aa0a7b025e$export$bc4b74228f8b7ec8(currentPageIndex, totalPagesCount, isOpenEnd) {
    // Total number of elements handled here
    const numberOfControls = 7;
    // Max number of controls that can be displayed on the left and right hand side of the current page.
    // Works only for odd numbers
    const leftDelta = Math.floor(numberOfControls / 2);
    let rightDelta = leftDelta;
    // upper and lower limits for pages range
    const lowerLimit = 2;
    let upperLimit = totalPagesCount - 1;
    if (isOpenEnd) {
        rightDelta++;
        upperLimit = totalPagesCount + 1;
    }
    // Left and right indices based on delta calculation
    let leftIndex = currentPageIndex - leftDelta;
    let rightIndex = currentPageIndex + rightDelta;
    // adjust page indexes if page index is too small
    if (leftIndex < lowerLimit) {
        rightIndex += lowerLimit - leftIndex;
        leftIndex = lowerLimit;
    }
    // adjust page indexes if page index is to big
    if (rightIndex > upperLimit) {
        leftIndex -= rightIndex - upperLimit;
        rightIndex = upperLimit;
    }
    // adjust indexes one more time to avoid out of range errors
    leftIndex = Math.max(leftIndex, 2);
    rightIndex = Math.min(rightIndex, upperLimit);
    // consider adding dots
    const leftDots = leftIndex > 2;
    const rightDots = isOpenEnd || rightIndex < upperLimit;
    if (leftDots) leftIndex++;
    if (rightDots) rightIndex--;
    return {
        leftDots: leftDots,
        rightDots: rightDots,
        leftIndex: leftIndex,
        rightIndex: rightIndex
    };
}



const $32dda691ea069b7d$var$defaultAriaLabels = {
    nextPageLabel: "",
    paginationLabel: "",
    previousPageLabel: "",
    pageLabel: (pageNumber)=>`${pageNumber}`
};
function $32dda691ea069b7d$var$PageButton({ className: className, ariaLabel: ariaLabel, disabled: disabled, pageIndex: pageIndex, isCurrent: isCurrent = false, children: children, onClick: onClick }) {
    function handleClick(event) {
        event.preventDefault();
        onClick(pageIndex);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $279d8c8b10ff543c$export$2e2bcd8739ae039)["page-item"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $279d8c8b10ff543c$export$2e2bcd8739ae039).button, disabled && (0, $279d8c8b10ff543c$export$2e2bcd8739ae039)["button-disabled"], isCurrent && (0, $279d8c8b10ff543c$export$2e2bcd8739ae039)["button-current"]),
        type: "button",
        "aria-label": ariaLabel,
        disabled: disabled,
        onClick: handleClick,
        "aria-current": isCurrent
    }, children));
}
function $32dda691ea069b7d$var$PageNumber(_a) {
    var { pageIndex: pageIndex } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "pageIndex"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($32dda691ea069b7d$var$PageButton, Object.assign({
        className: (0, $279d8c8b10ff543c$export$2e2bcd8739ae039)["page-number"],
        pageIndex: pageIndex
    }, rest), pageIndex);
}
function $32dda691ea069b7d$export$2e2bcd8739ae039(_a) {
    var _b, _c, _d;
    var { openEnd: openEnd, currentPageIndex: currentPageIndex, ariaLabels: ariaLabels, pagesCount: pagesCount, disabled: disabled, onChange: onChange, onNextPageClick: onNextPageClick, onPreviousPageClick: onPreviousPageClick, __internalRootRef: __internalRootRef = null } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "openEnd",
        "currentPageIndex",
        "ariaLabels",
        "pagesCount",
        "disabled",
        "onChange",
        "onNextPageClick",
        "onPreviousPageClick",
        "__internalRootRef"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const { leftDots: leftDots, leftIndex: leftIndex, rightIndex: rightIndex, rightDots: rightDots } = (0, $eb66e6aa0a7b025e$export$bc4b74228f8b7ec8)(currentPageIndex, pagesCount, openEnd);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("pagination");
    const paginationLabel = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.paginationLabel;
    const nextPageLabel = (_b = i18n("ariaLabels.nextPageLabel", ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.nextPageLabel)) !== null && _b !== void 0 ? _b : $32dda691ea069b7d$var$defaultAriaLabels.nextPageLabel;
    const previousPageLabel = (_c = i18n("ariaLabels.previousPageLabel", ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.previousPageLabel)) !== null && _c !== void 0 ? _c : $32dda691ea069b7d$var$defaultAriaLabels.previousPageLabel;
    const pageNumberLabelFn = (_d = i18n("ariaLabels.pageLabel", ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.pageLabel, (format)=>(pageNumber)=>format({
                pageNumber: pageNumber
            }))) !== null && _d !== void 0 ? _d : $32dda691ea069b7d$var$defaultAriaLabels.pageLabel;
    function handlePrevPageClick(requestedPageIndex) {
        handlePageClick(requestedPageIndex);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onPreviousPageClick, {
            requestedPageAvailable: true,
            requestedPageIndex: requestedPageIndex
        });
    }
    function handleNextPageClick(requestedPageIndex) {
        handlePageClick(requestedPageIndex);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onNextPageClick, {
            requestedPageAvailable: currentPageIndex < pagesCount,
            requestedPageIndex: requestedPageIndex
        });
    }
    function handlePageClick(requestedPageIndex) {
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
            currentPageIndex: requestedPageIndex
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", Object.assign({
        "aria-label": paginationLabel
    }, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $279d8c8b10ff543c$export$2e2bcd8739ae039).root, disabled && (0, $279d8c8b10ff543c$export$2e2bcd8739ae039)["root-disabled"]),
        ref: __internalRootRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($32dda691ea069b7d$var$PageButton, {
        className: (0, $279d8c8b10ff543c$export$2e2bcd8739ae039).arrow,
        pageIndex: currentPageIndex - 1,
        ariaLabel: previousPageLabel !== null && previousPageLabel !== void 0 ? previousPageLabel : $32dda691ea069b7d$var$defaultAriaLabels.nextPageLabel,
        disabled: disabled || currentPageIndex === 1,
        onClick: handlePrevPageClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "angle-left",
        variant: disabled ? "disabled" : "normal"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($32dda691ea069b7d$var$PageNumber, {
        pageIndex: 1,
        isCurrent: currentPageIndex === 1,
        disabled: disabled,
        ariaLabel: pageNumberLabelFn(1),
        onClick: handlePageClick
    }), leftDots && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $279d8c8b10ff543c$export$2e2bcd8739ae039).dots
    }, "..."), (0, $eb66e6aa0a7b025e$export$d02631cccf789723)(leftIndex, rightIndex).map((pageIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($32dda691ea069b7d$var$PageNumber, {
            key: pageIndex,
            isCurrent: currentPageIndex === pageIndex,
            pageIndex: pageIndex,
            disabled: disabled,
            ariaLabel: pageNumberLabelFn(pageIndex),
            onClick: handlePageClick
        })), rightDots && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $279d8c8b10ff543c$export$2e2bcd8739ae039).dots
    }, "..."), !openEnd && pagesCount > 1 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($32dda691ea069b7d$var$PageNumber, {
        isCurrent: currentPageIndex === pagesCount,
        pageIndex: pagesCount,
        disabled: disabled,
        ariaLabel: pageNumberLabelFn(pagesCount),
        onClick: handlePageClick
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($32dda691ea069b7d$var$PageButton, {
        className: (0, $279d8c8b10ff543c$export$2e2bcd8739ae039).arrow,
        pageIndex: currentPageIndex + 1,
        ariaLabel: nextPageLabel !== null && nextPageLabel !== void 0 ? nextPageLabel : $32dda691ea069b7d$var$defaultAriaLabels.nextPageLabel,
        disabled: disabled || !openEnd && (pagesCount === 0 || currentPageIndex === pagesCount),
        onClick: handleNextPageClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "angle-right",
        variant: disabled ? "disabled" : "normal"
    })));
}


function $ede657b6d0ca61ed$export$2e2bcd8739ae039(props) {
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Pagination", {
        props: {
            openEnd: props.openEnd
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $32dda691ea069b7d$export$2e2bcd8739ae039), Object.assign({}, props, baseComponentProps));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($ede657b6d0ca61ed$export$2e2bcd8739ae039, "Pagination");



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");


var $7ded81c543f72294$export$2e2bcd8739ae039 = {
    "root": "awsui_root_wih1l_rg19l_101",
    "tools": "awsui_tools_wih1l_rg19l_112",
    "tools-filtering": "awsui_tools-filtering_wih1l_rg19l_120",
    "tools-align-right": "awsui_tools-align-right_wih1l_rg19l_134",
    "tools-pagination": "awsui_tools-pagination_wih1l_rg19l_138",
    "tools-preferences": "awsui_tools-preferences_wih1l_rg19l_138",
    "tools-small": "awsui_tools-small_wih1l_rg19l_144",
    "table": "awsui_table_wih1l_rg19l_150",
    "table-layout-fixed": "awsui_table-layout-fixed_wih1l_rg19l_156",
    "wrapper": "awsui_wrapper_wih1l_rg19l_160",
    "variant-stacked": "awsui_variant-stacked_wih1l_rg19l_167",
    "wrapper-content-measure": "awsui_wrapper-content-measure_wih1l_rg19l_167",
    "variant-container": "awsui_variant-container_wih1l_rg19l_167",
    "has-footer": "awsui_has-footer_wih1l_rg19l_170",
    "has-header": "awsui_has-header_wih1l_rg19l_173",
    "cell-merged": "awsui_cell-merged_wih1l_rg19l_190",
    "cell-merged-content": "awsui_cell-merged-content_wih1l_rg19l_202",
    "empty": "awsui_empty_wih1l_rg19l_218",
    "loading": "awsui_loading_wih1l_rg19l_222",
    "selection-control": "awsui_selection-control_wih1l_rg19l_231",
    "selection-control-header": "awsui_selection-control-header_wih1l_rg19l_238",
    "header-secondary": "awsui_header-secondary_wih1l_rg19l_244",
    "variant-full-page": "awsui_variant-full-page_wih1l_rg19l_256",
    "table-has-header": "awsui_table-has-header_wih1l_rg19l_265",
    "header-controls": "awsui_header-controls_wih1l_rg19l_269",
    "variant-embedded": "awsui_variant-embedded_wih1l_rg19l_278",
    "variant-borderless": "awsui_variant-borderless_wih1l_rg19l_278",
    "footer-wrapper": "awsui_footer-wrapper_wih1l_rg19l_283",
    "footer": "awsui_footer_wih1l_rg19l_283",
    "footer-with-pagination": "awsui_footer-with-pagination_wih1l_rg19l_291",
    "footer-pagination": "awsui_footer-pagination_wih1l_rg19l_299",
    "thead-active": "awsui_thead-active_wih1l_rg19l_303",
    "row": "awsui_row_wih1l_rg19l_304",
    "row-selected": "awsui_row-selected_wih1l_rg19l_305"
};




function $d7e99db5d46311b5$export$2e2bcd8739ae039({ header: header, filter: filter, pagination: pagination, preferences: preferences, setLastUserAction: setLastUserAction }) {
    const [breakpoint, ref] = (0, $921c3f4037759790$export$2aa1887afbd6d218)([
        "xs"
    ]);
    const isHeaderString = typeof header === "string";
    const assignHeaderId = (0, $acw62.useContext)((0, $7e52d1d829dbf9fa$export$85b6faccd4f04314)).assignId;
    const headingId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("heading");
    if (assignHeaderId !== undefined && isHeaderString) assignHeaderId(headingId);
    const isSmall = breakpoint === "default";
    const hasTools = filter || pagination || preferences;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, isHeaderString ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: headingId
    }, header) : header, hasTools && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039).tools, isSmall && (0, $7ded81c543f72294$export$2e2bcd8739ae039)["tools-small"])
    }, filter && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)["tools-filtering"],
        onClickCapture: ()=>setLastUserAction === null || setLastUserAction === void 0 ? void 0 : setLastUserAction("filter"),
        onKeyDownCapture: ()=>setLastUserAction === null || setLastUserAction === void 0 ? void 0 : setLastUserAction("filter")
    }, filter), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)["tools-align-right"]
    }, pagination && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)["tools-pagination"],
        onClickCapture: ()=>setLastUserAction === null || setLastUserAction === void 0 ? void 0 : setLastUserAction("pagination")
    }, pagination), preferences && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)["tools-preferences"],
        onClickCapture: ()=>setLastUserAction === null || setLastUserAction === void 0 ? void 0 : setLastUserAction("preferences")
    }, preferences))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $d5e9c22659308d3d$export$d4f0c8fa4d4f6c97 = (trackBy, item)=>{
    if (typeof trackBy === "function") return trackBy(item);
    return item[trackBy];
};
const $d5e9c22659308d3d$export$424834ba1b0663bc = (trackBy, item, index)=>{
    if (!trackBy) return index;
    return $d5e9c22659308d3d$export$d4f0c8fa4d4f6c97(trackBy, item);
};
const $d5e9c22659308d3d$export$de1681509165dcfe = (trackBy, item)=>{
    if (!trackBy) return item;
    return $d5e9c22659308d3d$export$d4f0c8fa4d4f6c97(trackBy, item);
};
const $d5e9c22659308d3d$export$480219a02f196e72 = (column, index)=>{
    return column.id || index;
};
const $d5e9c22659308d3d$export$9704772993b3cb14 = (variant)=>{
    const isDefaultVariant = !variant || variant === "container";
    return isDefaultVariant ? "default" : variant === "borderless" ? "embedded" : variant;
};
function $d5e9c22659308d3d$export$8490691ec4e40f0d(columnDefinitions, sortingComparator) {
    const matchedColumn = columnDefinitions.filter((column)=>column.sortingComparator === sortingComparator)[0];
    if (!matchedColumn) (0, $dd646455762bc7b9$export$5b28268982f175ba)("Table", "Currently active sorting comparator was not found in any columns. Make sure to provide the same comparator function instance on each render.");
}
function $d5e9c22659308d3d$export$814232dd3a440b46({ columnDisplay: columnDisplay, visibleColumns: visibleColumns, columnDefinitions: columnDefinitions }) {
    // columnsDisplay has a precedence over visibleColumns.
    if (columnDisplay) return $d5e9c22659308d3d$var$getVisibleColumnDefinitionsFromColumnDisplay({
        columnDisplay: columnDisplay,
        columnDefinitions: columnDefinitions
    });
    else if (visibleColumns) return $d5e9c22659308d3d$var$getVisibleColumnDefinitionsFromVisibleColumns({
        visibleColumns: visibleColumns,
        columnDefinitions: columnDefinitions
    });
    else return columnDefinitions;
}
function $d5e9c22659308d3d$var$getVisibleColumnDefinitionsFromColumnDisplay({ columnDisplay: columnDisplay, columnDefinitions: columnDefinitions }) {
    const columnDefinitionsById = columnDefinitions.reduce((accumulator, item)=>item.id === undefined ? accumulator : Object.assign(Object.assign({}, accumulator), {
            [item.id]: item
        }), {});
    return columnDisplay.filter((item)=>item.visible).map((item)=>columnDefinitionsById[item.id]).filter(Boolean);
}
function $d5e9c22659308d3d$var$getVisibleColumnDefinitionsFromVisibleColumns({ visibleColumns: visibleColumns, columnDefinitions: columnDefinitions }) {
    const ids = new Set(visibleColumns);
    return columnDefinitions.filter(({ id: id })=>id !== undefined && ids.has(id));
}
function $d5e9c22659308d3d$export$8343e8fa60fc2e2f(styles, props) {
    return {
        [styles["sticky-cell"]]: !!props,
        [styles["sticky-cell-pad-inline-start"]]: !!(props === null || props === void 0 ? void 0 : props.padInlineStart),
        [styles["sticky-cell-last-inline-start"]]: !!(props === null || props === void 0 ? void 0 : props.lastInsetInlineStart),
        [styles["sticky-cell-last-inline-end"]]: !!(props === null || props === void 0 ? void 0 : props.lastInsetInlineEnd)
    };
}


const $30c09cf06b060b34$export$988c58523d43232b = "selection-item";
const $30c09cf06b060b34$export$df7a8150b7b31338 = "selection-root";
class $30c09cf06b060b34$export$685bf180035d2cea {
    constructor(trackBy, items){
        this.map = new Map();
        this.put = (item)=>this.map.set.call(this.map, (0, $d5e9c22659308d3d$export$de1681509165dcfe)(this.trackBy, item), item);
        this.has = (item)=>this.map.has.call(this.map, (0, $d5e9c22659308d3d$export$de1681509165dcfe)(this.trackBy, item));
        this.forEach = this.map.forEach.bind(this.map);
        this.trackBy = trackBy;
        items.forEach(this.put);
    }
}
const $30c09cf06b060b34$export$abdbebe48aa0774a = {
    item: {
        ["data-" + $30c09cf06b060b34$export$988c58523d43232b]: "item"
    },
    all: {
        ["data-" + $30c09cf06b060b34$export$988c58523d43232b]: "all"
    },
    root: {
        ["data-" + $30c09cf06b060b34$export$df7a8150b7b31338]: "true"
    }
};




var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");





var $a5be326d08ef0873$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1mabk_fodq7_97",
    "radio": "awsui_radio_1mabk_fodq7_133",
    "radio--has-description": "awsui_radio--has-description_1mabk_fodq7_141",
    "radio-control": "awsui_radio-control_1mabk_fodq7_145",
    "outline": "awsui_outline_1mabk_fodq7_153",
    "styled-circle-border": "awsui_styled-circle-border_1mabk_fodq7_175",
    "styled-circle-disabled": "awsui_styled-circle-disabled_1mabk_fodq7_179",
    "styled-circle-readonly": "awsui_styled-circle-readonly_1mabk_fodq7_179",
    "styled-circle-fill": "awsui_styled-circle-fill_1mabk_fodq7_184",
    "styled-circle-checked": "awsui_styled-circle-checked_1mabk_fodq7_190"
};



var $0d348656d0a64072$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function RadioButton({ name: name, label: label, value: value, checked: checked, description: description, disabled: disabled, controlId: controlId, onChange: onChange, readOnly: readOnly }, ref) {
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const radioButtonRef = (0, $acw62.useRef)(null);
    const mergedRefs = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(radioButtonRef, ref);
    const { tabIndex: tabIndex } = (0, $7f9661e47bcc5460$export$4cf30df7bba16ac9)(radioButtonRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9358073d64ebb29$export$2e2bcd8739ae039), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a5be326d08ef0873$export$2e2bcd8739ae039).radio, description && (0, $a5be326d08ef0873$export$2e2bcd8739ae039)["radio--has-description"]),
        controlClassName: (0, $a5be326d08ef0873$export$2e2bcd8739ae039)["radio-control"],
        outlineClassName: (0, $a5be326d08ef0873$export$2e2bcd8739ae039).outline,
        label: label,
        description: description,
        disabled: disabled,
        readOnly: readOnly,
        controlId: controlId,
        nativeControl: (nativeControlProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", Object.assign({}, nativeControlProps, {
                tabIndex: tabIndex,
                type: "radio",
                ref: mergedRefs,
                name: name,
                value: value,
                checked: checked,
                "aria-disabled": readOnly && !disabled ? "true" : undefined,
                // empty handler to suppress React controllability warning
                onChange: ()=>{}
            })),
        onClick: ()=>{
            var _a;
            (_a = radioButtonRef.current) === null || _a === void 0 || _a.focus();
            if (checked) return;
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                value: value
            });
        },
        styledControl: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
            viewBox: "0 0 100 100",
            focusable: "false",
            "aria-hidden": "true"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a5be326d08ef0873$export$2e2bcd8739ae039)["styled-circle-border"], {
                [(0, $a5be326d08ef0873$export$2e2bcd8739ae039)["styled-circle-disabled"]]: disabled,
                [(0, $a5be326d08ef0873$export$2e2bcd8739ae039)["styled-circle-readonly"]]: readOnly
            }),
            strokeWidth: isVisualRefresh ? 12 : 8,
            cx: 50,
            cy: 50,
            r: isVisualRefresh ? 44 : 46
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $a5be326d08ef0873$export$2e2bcd8739ae039)["styled-circle-fill"], {
                [(0, $a5be326d08ef0873$export$2e2bcd8739ae039)["styled-circle-disabled"]]: disabled,
                [(0, $a5be326d08ef0873$export$2e2bcd8739ae039)["styled-circle-checked"]]: checked,
                [(0, $a5be326d08ef0873$export$2e2bcd8739ae039)["styled-circle-readonly"]]: readOnly
            }),
            strokeWidth: 30,
            cx: 50,
            cy: 50,
            r: 35
        }))
    });
});



var $6c95fef02beb4257$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1s55x_svuwr_97",
    "label": "awsui_label_1s55x_svuwr_101",
    "stud": "awsui_stud_1s55x_svuwr_115"
};



function $51374b608ac485d9$export$c5dcec1959129451(_a) {
    var { selectionType: selectionType, indeterminate: indeterminate = false, onShiftToggle: onShiftToggle, onFocusUp: onFocusUp, onFocusDown: onFocusDown, name: name, ariaLabel: ariaLabel, focusedComponent: focusedComponent } = _a, sharedProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "selectionType",
        "indeterminate",
        "onShiftToggle",
        "onFocusUp",
        "onFocusDown",
        "name",
        "ariaLabel",
        "focusedComponent"
    ]);
    const controlId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)();
    const isMultiSelection = selectionType === "multi";
    const { navigationActive: navigationActive } = (0, $acw62.useContext)((0, $7f9661e47bcc5460$export$d883ceba1e571843));
    const setShiftState = (event)=>{
        if (isMultiSelection) onShiftToggle && onShiftToggle(event.shiftKey);
    };
    const onMouseDownHandler = (event)=>{
        setShiftState(event);
        if (isMultiSelection) // To overcome an issue
        // If you shift+click or ctrl+click on a label for a checkbox, checkbox is not checked.
        // https://bugzilla.mozilla.org/show_bug.cgi?id=559506
        event.preventDefault();
    };
    // native checkboxes do not have focus move via keyboard, we implement it here programmatically
    const handleKeyDown = (event)=>{
        setShiftState(event);
        if (isMultiSelection && !navigationActive) {
            if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up) {
                event.preventDefault();
                onFocusUp && onFocusUp(event);
            }
            if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down) {
                event.preventDefault();
                onFocusDown && onFocusDown(event);
            }
        }
    };
    const handleClick = (event)=>{
        const target = event.currentTarget;
        const nativeInput = target.tagName === "INPUT" ? target : target.querySelector("input");
        // Clicking on input, does not focus it on Firefox (AWSUI-11345)
        nativeInput === null || nativeInput === void 0 || nativeInput.focus();
    };
    const selector = isMultiSelection ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81def5553f1b8381$export$2e2bcd8739ae039), Object.assign({}, sharedProps, {
        showOutline: focusedComponent === "selection-control",
        controlId: controlId,
        "data-focus-id": "selection-control",
        indeterminate: indeterminate
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0d348656d0a64072$export$2e2bcd8739ae039), Object.assign({}, sharedProps, {
        controlId: controlId,
        name: name,
        value: "",
        label: ""
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        onKeyDown: handleKeyDown,
        onKeyUp: setShiftState,
        onMouseDown: onMouseDownHandler,
        onMouseUp: setShiftState,
        onClick: handleClick,
        htmlFor: controlId,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $6c95fef02beb4257$export$2e2bcd8739ae039).label, (0, $6c95fef02beb4257$export$2e2bcd8739ae039).root),
        "aria-label": ariaLabel,
        title: ariaLabel
    }, selector), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $6c95fef02beb4257$export$2e2bcd8739ae039).stud,
        "aria-hidden": true
    }, "\xa0"));
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");


const $18fb5778d4dc41bf$var$stateToIcon = {
    sortable: "caret-down",
    ascending: "caret-up-filled",
    descending: "caret-down-filled"
};
const $18fb5778d4dc41bf$export$522d1547ed3f4c02 = (sortable, sorted, descending, disabled)=>{
    if (sorted) {
        if (descending) return "descending";
        return "ascending";
    }
    if (sortable && !disabled) return "sortable";
    return undefined;
};
const $18fb5778d4dc41bf$export$f3a117936eca5c61 = (sortingState)=>$18fb5778d4dc41bf$var$stateToIcon[sortingState];
const $18fb5778d4dc41bf$export$efa610630f9e181 = (column, sortingColumn)=>column === sortingColumn || column.sortingField !== undefined && column.sortingField === sortingColumn.sortingField || column.sortingComparator !== undefined && column.sortingComparator === sortingColumn.sortingComparator;



var $93211f0fff30af11$export$2e2bcd8739ae039 = {
    "header-cell": "awsui_header-cell_1spae_geicw_97",
    "header-cell-fake-focus": "awsui_header-cell-fake-focus_1spae_geicw_131",
    "header-cell-sticky": "awsui_header-cell-sticky_1spae_geicw_152",
    "header-cell-stuck": "awsui_header-cell-stuck_1spae_geicw_155",
    "header-cell-variant-full-page": "awsui_header-cell-variant-full-page_1spae_geicw_155",
    "header-cell-hidden": "awsui_header-cell-hidden_1spae_geicw_161",
    "header-cell-sortable": "awsui_header-cell-sortable_1spae_geicw_164",
    "sticky-cell": "awsui_sticky-cell_1spae_geicw_167",
    "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_1spae_geicw_175",
    "has-selection": "awsui_has-selection_1spae_geicw_175",
    "sticky-cell-last-inline-start": "awsui_sticky-cell-last-inline-start_1spae_geicw_178",
    "resize-divider": "awsui_resize-divider_1spae_geicw_183",
    "sticky-cell-last-inline-end": "awsui_sticky-cell-last-inline-end_1spae_geicw_190",
    "sorting-icon": "awsui_sorting-icon_1spae_geicw_210",
    "edit-icon": "awsui_edit-icon_1spae_geicw_218",
    "header-cell-content": "awsui_header-cell-content_1spae_geicw_224",
    "header-cell-content-expandable": "awsui_header-cell-content-expandable_1spae_geicw_230",
    "header-cell-disabled": "awsui_header-cell-disabled_1spae_geicw_282",
    "header-cell-sorted": "awsui_header-cell-sorted_1spae_geicw_282",
    "header-cell-text": "awsui_header-cell-text_1spae_geicw_296",
    "header-cell-text-wrap": "awsui_header-cell-text-wrap_1spae_geicw_300",
    "header-cell-ascending": "awsui_header-cell-ascending_1spae_geicw_306",
    "header-cell-descending": "awsui_header-cell-descending_1spae_geicw_307",
    "is-visual-refresh": "awsui_is-visual-refresh_1spae_geicw_317",
    "has-striped-rows": "awsui_has-striped-rows_1spae_geicw_421",
    "sticky-cell-pad-inline-start": "awsui_sticky-cell-pad-inline-start_1spae_geicw_427"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");

var $0ceb98ce36b03157$export$2e2bcd8739ae039 = {
    "resize-active": "awsui_resize-active_x7peu_179a9_97",
    "resize-active-with-focus": "awsui_resize-active-with-focus_x7peu_179a9_97",
    "divider": "awsui_divider_x7peu_179a9_102",
    "divider-disabled": "awsui_divider-disabled_x7peu_179a9_116",
    "divider-active": "awsui_divider-active_x7peu_179a9_119",
    "resizer": "awsui_resizer_x7peu_179a9_123",
    "has-focus": "awsui_has-focus_x7peu_179a9_180",
    "tracker": "awsui_tracker_x7peu_179a9_203"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $6208ed25859b543f$export$9ef7e4997c031fc0(columnDefinitions) {
    for (const column of columnDefinitions){
        $6208ed25859b543f$var$checkProperty(column, "minWidth");
        $6208ed25859b543f$var$checkProperty(column, "width");
    }
}
function $6208ed25859b543f$export$fc3aed6ced179058(element, styles) {
    function setProperty(property) {
        const value = styles[property];
        let widthCssValue = "";
        if (typeof value === "number") widthCssValue = value + "px";
        if (typeof value === "string") widthCssValue = value;
        if (element.style[property] !== widthCssValue) element.style[property] = widthCssValue;
    }
    setProperty("width");
    setProperty("minWidth");
    setProperty("maxWidth");
}
function $6208ed25859b543f$var$checkProperty(column, name) {
    const value = column[name];
    if (typeof value !== "number" && typeof value !== "undefined") (0, $dd646455762bc7b9$export$5b28268982f175ba)("Table", `resizableColumns feature requires ${name} property to be a number, got ${value}. The component may work incorrectly.`);
}


const $52cd48af6d6570d7$export$7c3f559e2ca95fa = 120;
function $52cd48af6d6570d7$var$readWidths(getCell, visibleColumns) {
    const result = new Map();
    for(let index = 0; index < visibleColumns.length; index++){
        const column = visibleColumns[index];
        let width = column.width || 0;
        const minWidth = column.minWidth || width || $52cd48af6d6570d7$export$7c3f559e2ca95fa;
        if (!width && // read width from the DOM if it is missing in the config
        index !== visibleColumns.length - 1 // skip reading for the last column, because it expands to fully fit the container
        ) {
            const colEl = getCell(column.id);
            width = colEl ? (0, $558545a5feadf817$export$322fb6cc2f904670)(colEl).inlineSize : $52cd48af6d6570d7$export$7c3f559e2ca95fa;
        }
        result.set(column.id, Math.max(width, minWidth));
    }
    return result;
}
function $52cd48af6d6570d7$var$updateWidths(visibleColumns, oldWidths, newWidth, columnId) {
    const column = visibleColumns.find((column)=>column.id === columnId);
    const minWidth = typeof (column === null || column === void 0 ? void 0 : column.minWidth) === "number" ? column.minWidth : $52cd48af6d6570d7$export$7c3f559e2ca95fa;
    newWidth = Math.max(newWidth, minWidth);
    if (oldWidths.get(columnId) === newWidth) return oldWidths;
    const newWidths = new Map(oldWidths);
    newWidths.set(columnId, newWidth);
    return newWidths;
}
const $52cd48af6d6570d7$var$WidthsContext = (0, $acw62.createContext)({
    getColumnStyles: ()=>({}),
    columnWidths: new Map(),
    updateColumn: ()=>{},
    setCell: ()=>{}
});
function $52cd48af6d6570d7$export$9b0658a77dfa159c({ visibleColumns: visibleColumns, resizableColumns: resizableColumns, containerRef: containerRef, children: children }) {
    const visibleColumnsRef = (0, $acw62.useRef)(null);
    const containerWidthRef = (0, $acw62.useRef)(0);
    const [columnWidths, setColumnWidths] = (0, $acw62.useState)(null);
    const cellsRef = (0, $acw62.useRef)(new Map());
    const stickyCellsRef = (0, $acw62.useRef)(new Map());
    const getCell = (columnId)=>{
        var _a;
        return (_a = cellsRef.current.get(columnId)) !== null && _a !== void 0 ? _a : null;
    };
    const setCell = (sticky, columnId, node)=>{
        const ref = sticky ? stickyCellsRef : cellsRef;
        if (node) ref.current.set(columnId, node);
        else ref.current.delete(columnId);
    };
    const getColumnStyles = (sticky, columnId)=>{
        var _a, _b, _c;
        const column = visibleColumns.find((column)=>column.id === columnId);
        if (!column) return {};
        if (sticky) return {
            width: ((_a = cellsRef.current.get(column.id)) === null || _a === void 0 ? void 0 : _a.offsetWidth) || ((_b = columnWidths === null || columnWidths === void 0 ? void 0 : columnWidths.get(column.id)) !== null && _b !== void 0 ? _b : column.width)
        };
        if (resizableColumns && columnWidths) {
            const isLastColumn = column.id === ((_c = visibleColumns[visibleColumns.length - 1]) === null || _c === void 0 ? void 0 : _c.id);
            const totalWidth = visibleColumns.reduce((sum, { id: id })=>sum + (columnWidths.get(id) || $52cd48af6d6570d7$export$7c3f559e2ca95fa), 0);
            if (isLastColumn && containerWidthRef.current > totalWidth) return {
                width: "auto",
                minWidth: column === null || column === void 0 ? void 0 : column.minWidth
            };
            else return {
                width: columnWidths.get(column.id),
                minWidth: column === null || column === void 0 ? void 0 : column.minWidth
            };
        }
        return {
            width: column.width,
            minWidth: column.minWidth,
            maxWidth: !resizableColumns ? column.maxWidth : undefined
        };
    };
    // Imperatively sets width style for a cell avoiding React state.
    // This allows setting the style as soon container's size change is observed.
    const updateColumnWidths = (0, $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0)(()=>{
        for (const { id: id } of visibleColumns){
            const element = cellsRef.current.get(id);
            if (element) (0, $6208ed25859b543f$export$fc3aed6ced179058)(element, getColumnStyles(false, id));
        }
        // Sticky column widths must be synchronized once all real column widths are assigned.
        for (const { id: id } of visibleColumns){
            const element = stickyCellsRef.current.get(id);
            if (element) (0, $6208ed25859b543f$export$fc3aed6ced179058)(element, getColumnStyles(true, id));
        }
    });
    // Observes container size and requests an update to the last cell width as it depends on the container's width.
    (0, $444535e54951fdea$export$683480f191c0e3ea)(containerRef, ({ contentBoxWidth: containerWidth })=>{
        containerWidthRef.current = containerWidth;
        updateColumnWidths();
    });
    // The widths of the dynamically added columns (after the first render) if not set explicitly
    // will default to the DEFAULT_COLUMN_WIDTH.
    (0, $acw62.useEffect)(()=>{
        updateColumnWidths();
        if (!resizableColumns) return;
        let updated = false;
        const newColumnWidths = new Map(columnWidths);
        const lastVisible = visibleColumnsRef.current;
        if (lastVisible) {
            for(let index = 0; index < visibleColumns.length; index++){
                const column = visibleColumns[index];
                if (!(columnWidths === null || columnWidths === void 0 ? void 0 : columnWidths.get(column.id)) && lastVisible.indexOf(column.id) === -1) {
                    updated = true;
                    newColumnWidths.set(column.id, column.width || $52cd48af6d6570d7$export$7c3f559e2ca95fa);
                }
            }
            if (updated) setColumnWidths(newColumnWidths);
        }
        visibleColumnsRef.current = visibleColumns.map((column)=>column.id);
    }, [
        columnWidths,
        resizableColumns,
        visibleColumns,
        updateColumnWidths
    ]);
    // Read the actual column widths after the first render to employ the browser defaults for
    // those columns without explicit width.
    (0, $acw62.useEffect)(()=>{
        if (!resizableColumns) return;
        setColumnWidths(()=>$52cd48af6d6570d7$var$readWidths(getCell, visibleColumns));
    // This code is intended to run only at the first render and should not re-run when table props change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    function updateColumn(columnId, newWidth) {
        setColumnWidths((columnWidths)=>$52cd48af6d6570d7$var$updateWidths(visibleColumns, columnWidths !== null && columnWidths !== void 0 ? columnWidths : new Map(), newWidth, columnId));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($52cd48af6d6570d7$var$WidthsContext.Provider, {
        value: {
            getColumnStyles: getColumnStyles,
            columnWidths: columnWidths !== null && columnWidths !== void 0 ? columnWidths : new Map(),
            updateColumn: updateColumn,
            setCell: setCell
        }
    }, children);
}
function $52cd48af6d6570d7$export$d598237875812773() {
    return (0, $acw62.useContext)($52cd48af6d6570d7$var$WidthsContext);
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





function $15e7516183277033$export$357cd0922346413d(resizerElement) {
    if (!resizerElement) return null;
    const header = (0, $b679de281b3ba268$export$2e2bcd8739ae039)(resizerElement, (element)=>element.tagName.toLowerCase() === "th");
    if (!header) return null;
    const tableRoot = (0, $b679de281b3ba268$export$2e2bcd8739ae039)(header, (element)=>element.className.indexOf((0, $7ded81c543f72294$export$2e2bcd8739ae039).root) > -1);
    if (!tableRoot) return null;
    const table = tableRoot.querySelector(`table`);
    if (!table) return null;
    // tracker is rendered inside table wrapper to align with its size
    const tracker = tableRoot.querySelector(`.${(0, $0ceb98ce36b03157$export$2e2bcd8739ae039).tracker}`);
    if (!tracker) return null;
    const scrollParent = (0, $24d40242cc6554ee$export$f32edd573b1049e6)(header)[0];
    if (!scrollParent) return null;
    return {
        header: header,
        table: table,
        tracker: tracker,
        scrollParent: scrollParent
    };
}
function $15e7516183277033$export$134d8f4885c418ba(resizerElement) {
    const header = resizerElement && (0, $b679de281b3ba268$export$2e2bcd8739ae039)(resizerElement, (element)=>element.tagName.toLowerCase() === "th");
    return header ? (0, $558545a5feadf817$export$322fb6cc2f904670)(header).inlineSize : 0;
}




const $ba2285bfc0275a61$var$AUTO_GROW_START_TIME = 10;
const $ba2285bfc0275a61$var$AUTO_GROW_INTERVAL = 10;
const $ba2285bfc0275a61$var$AUTO_GROW_INCREMENT = 5;
function $ba2285bfc0275a61$export$2e0a83ec2e27ecbb({ className: className }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $0ceb98ce36b03157$export$2e2bcd8739ae039).divider, (0, $0ceb98ce36b03157$export$2e2bcd8739ae039)["divider-disabled"], className)
    });
}
function $ba2285bfc0275a61$export$48a76196cafe3b93({ onWidthUpdate: onWidthUpdate, onWidthUpdateCommit: onWidthUpdateCommit, ariaLabelledby: ariaLabelledby, minWidth: minWidth = (0, $52cd48af6d6570d7$export$7c3f559e2ca95fa), tabIndex: tabIndex, showFocusRing: showFocusRing, focusId: focusId, roleDescription: roleDescription }) {
    onWidthUpdate = (0, $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0)(onWidthUpdate);
    onWidthUpdateCommit = (0, $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0)(onWidthUpdateCommit);
    const separatorId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)();
    const resizerToggleRef = (0, $acw62.useRef)(null);
    const resizerSeparatorRef = (0, $acw62.useRef)(null);
    const [isDragging, setIsDragging] = (0, $acw62.useState)(false);
    const [isKeyboardDragging, setIsKeyboardDragging] = (0, $acw62.useState)(false);
    const autoGrowTimeout = (0, $acw62.useRef)();
    const [resizerHasFocus, setResizerHasFocus] = (0, $acw62.useState)(false);
    const [headerCellWidth, setHeaderCellWidth] = (0, $acw62.useState)(0);
    // Read header width after mounting for it to be available in the element's ARIA label before it gets focused.
    (0, $acw62.useEffect)(()=>{
        setHeaderCellWidth((0, $15e7516183277033$export$134d8f4885c418ba)(resizerToggleRef.current));
    }, []);
    (0, $acw62.useEffect)(()=>{
        const elements = (0, $15e7516183277033$export$357cd0922346413d)(resizerToggleRef.current);
        if (!isDragging && !resizerHasFocus || !elements) return;
        const { insetInlineStart: inlineStartEdge, insetInlineEnd: inlineEndEdge } = (0, $558545a5feadf817$export$322fb6cc2f904670)(elements.scrollParent);
        const updateTrackerPosition = (newOffset)=>{
            const { insetInlineStart: scrollParentInsetInlineStart } = (0, $558545a5feadf817$export$322fb6cc2f904670)(elements.table);
            elements.tracker.style.insetBlockStart = (0, $558545a5feadf817$export$322fb6cc2f904670)(elements.header).blockSize + "px";
            // minus one pixel to offset the cell border
            elements.tracker.style.insetInlineStart = newOffset - scrollParentInsetInlineStart - 1 + "px";
        };
        const updateColumnWidth = (newWidth)=>{
            const { insetInlineEnd: insetInlineEnd, inlineSize: inlineSize } = (0, $558545a5feadf817$export$322fb6cc2f904670)(elements.header);
            const updatedWidth = newWidth < minWidth ? minWidth : newWidth;
            updateTrackerPosition(insetInlineEnd + updatedWidth - inlineSize);
            if (newWidth >= minWidth) setHeaderCellWidth(newWidth);
            // callbacks must be the last calls in the handler, because they may cause an extra update
            onWidthUpdate(newWidth);
        };
        const resizeColumn = (offset)=>{
            if (offset > inlineStartEdge) {
                const cellLeft = (0, $558545a5feadf817$export$322fb6cc2f904670)(elements.header).insetInlineStart;
                const newWidth = offset - cellLeft;
                // callbacks must be the last calls in the handler, because they may cause an extra update
                updateColumnWidth(newWidth);
            }
        };
        const onAutoGrow = ()=>{
            const inlineSize = (0, $558545a5feadf817$export$322fb6cc2f904670)(elements.header).inlineSize;
            autoGrowTimeout.current = setTimeout(onAutoGrow, $ba2285bfc0275a61$var$AUTO_GROW_INTERVAL);
            // callbacks must be the last calls in the handler, because they may cause an extra update
            updateColumnWidth(inlineSize + $ba2285bfc0275a61$var$AUTO_GROW_INCREMENT);
            elements.scrollParent.scrollLeft += $ba2285bfc0275a61$var$AUTO_GROW_INCREMENT * ((0, $558545a5feadf817$export$c3f2dc1a1afd265d)(elements.scrollParent) ? -1 : 1);
        };
        const onMouseMove = (event)=>{
            clearTimeout(autoGrowTimeout.current);
            const offset = (0, $558545a5feadf817$export$62e2497973acfa99)(event);
            if (offset > inlineEndEdge) autoGrowTimeout.current = setTimeout(onAutoGrow, $ba2285bfc0275a61$var$AUTO_GROW_START_TIME);
            else resizeColumn(offset);
        };
        const onMouseUp = (event)=>{
            resizeColumn((0, $558545a5feadf817$export$62e2497973acfa99)(event));
            setIsDragging(false);
            onWidthUpdateCommit();
            clearTimeout(autoGrowTimeout.current);
        };
        const onKeyDown = (event)=>{
            if (isKeyboardDragging) {
                const keys = [
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).left,
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right,
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter,
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right,
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space,
                    (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).escape
                ];
                if (keys.indexOf(event.keyCode) !== -1) {
                    event.preventDefault();
                    (0, $d790fc2d8f354fdb$export$f11fd8c04cad088d)(event) && (0, $d790fc2d8f354fdb$export$2e2bcd8739ae039)(event, {
                        onActivate: ()=>{
                            var _a;
                            setIsKeyboardDragging(false);
                            (_a = resizerToggleRef.current) === null || _a === void 0 || _a.focus();
                        },
                        onEscape: ()=>{
                            var _a;
                            setIsKeyboardDragging(false);
                            (_a = resizerToggleRef.current) === null || _a === void 0 || _a.focus();
                        },
                        onInlineStart: ()=>updateColumnWidth((0, $558545a5feadf817$export$322fb6cc2f904670)(elements.header).inlineSize - 10),
                        onInlineEnd: ()=>updateColumnWidth((0, $558545a5feadf817$export$322fb6cc2f904670)(elements.header).inlineSize + 10)
                    });
                }
            } else if (event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter || event.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space) {
                event.preventDefault();
                (0, $d790fc2d8f354fdb$export$f11fd8c04cad088d)(event) && (0, $d790fc2d8f354fdb$export$2e2bcd8739ae039)(event, {
                    onActivate: ()=>{
                        var _a;
                        setIsKeyboardDragging(true);
                        (_a = resizerSeparatorRef.current) === null || _a === void 0 || _a.focus();
                    }
                });
            }
        };
        updateTrackerPosition((0, $558545a5feadf817$export$322fb6cc2f904670)(elements.header).insetInlineEnd);
        if (isDragging) {
            document.body.classList.add((0, $0ceb98ce36b03157$export$2e2bcd8739ae039)["resize-active"]);
            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", onMouseUp);
        }
        if (resizerHasFocus) {
            document.body.classList.add((0, $0ceb98ce36b03157$export$2e2bcd8739ae039)["resize-active-with-focus"]);
            elements.header.addEventListener("keydown", onKeyDown);
        }
        if (isKeyboardDragging) document.body.classList.add((0, $0ceb98ce36b03157$export$2e2bcd8739ae039)["resize-active"]);
        return ()=>{
            clearTimeout(autoGrowTimeout.current);
            document.body.classList.remove((0, $0ceb98ce36b03157$export$2e2bcd8739ae039)["resize-active"]);
            document.body.classList.remove((0, $0ceb98ce36b03157$export$2e2bcd8739ae039)["resize-active-with-focus"]);
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
            elements.header.removeEventListener("keydown", onKeyDown);
        };
    }, [
        minWidth,
        isDragging,
        isKeyboardDragging,
        resizerHasFocus,
        onWidthUpdate,
        onWidthUpdateCommit
    ]);
    const { tabIndex: resizerTabIndex } = (0, $7f9661e47bcc5460$export$4cf30df7bba16ac9)(resizerToggleRef, {
        tabIndex: tabIndex
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: resizerToggleRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $0ceb98ce36b03157$export$2e2bcd8739ae039).resizer, (resizerHasFocus || showFocusRing || isKeyboardDragging) && (0, $0ceb98ce36b03157$export$2e2bcd8739ae039)["has-focus"]),
        onMouseDown: (event)=>{
            if (event.button !== 0) return;
            event.preventDefault();
            setIsDragging(true);
        },
        onClick: ()=>{
            var _a;
            // Prevent mouse drag activation and activate keyboard dragging for VO+Space click.
            setIsDragging(false);
            setResizerHasFocus(true);
            setIsKeyboardDragging(true);
            (_a = resizerSeparatorRef.current) === null || _a === void 0 || _a.focus();
        },
        onFocus: ()=>{
            setHeaderCellWidth((0, $15e7516183277033$export$134d8f4885c418ba)(resizerToggleRef.current));
            setResizerHasFocus(true);
        },
        onBlur: (event)=>{
            // Ignoring blur event when focus moves to the resizer separator element.
            // (This focus transition is done programmatically when the resizer button is clicked).
            if (event.relatedTarget !== resizerSeparatorRef.current) setResizerHasFocus(false);
        },
        "aria-roledescription": roleDescription,
        "aria-labelledby": ariaLabelledby,
        tabIndex: resizerTabIndex,
        "data-focus-id": focusId
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $0ceb98ce36b03157$export$2e2bcd8739ae039).divider, isDragging && (0, $0ceb98ce36b03157$export$2e2bcd8739ae039)["divider-active"]),
        "data-awsui-table-suppress-navigation": true,
        ref: resizerSeparatorRef,
        id: separatorId,
        role: "separator",
        tabIndex: -1,
        "aria-hidden": !isKeyboardDragging,
        "aria-orientation": "vertical",
        "aria-valuenow": headerCellWidth,
        "aria-valuetext": headerCellWidth.toFixed(0),
        "aria-valuemin": minWidth,
        "data-focus-id": focusId,
        onBlur: ()=>{
            setResizerHasFocus(false);
            if (isKeyboardDragging) setIsKeyboardDragging(false);
            onWidthUpdateCommit();
        }
    }));
}
function $ba2285bfc0275a61$export$1a1c8e5e76867279() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $0ceb98ce36b03157$export$2e2bcd8739ae039).tracker
    });
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


class $e2d297bc4830b3ed$export$2e2bcd8739ae039 {
    constructor(state){
        this._listeners = [];
        this._state = state;
    }
    get() {
        return this._state;
    }
    set(cb) {
        const prevState = this._state;
        const newState = cb(prevState);
        this._state = newState;
        (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
            for (const [selector, listener] of this._listeners)if (selector(prevState) !== selector(newState)) listener(newState, prevState);
        });
    }
    subscribe(selector, listener) {
        this._listeners.push([
            selector,
            listener
        ]);
        return ()=>this.unsubscribe(listener);
    }
    unsubscribe(listener) {
        for(let index = 0; index < this._listeners.length; index++){
            const [, storedListener] = this._listeners[index];
            if (storedListener === listener) {
                this._listeners.splice(index, 1);
                break;
            }
        }
    }
}
function $e2d297bc4830b3ed$export$bb8178b296baf229(store, selector, effect) {
    (0, $acw62.useLayoutEffect)(()=>{
        const unsubscribe = store.subscribe(selector, (newState, prevState)=>effect(selector(newState), selector(prevState)));
        return unsubscribe;
    }, // ignoring selector and effect as they are expected to stay constant
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        store
    ]);
}
function $e2d297bc4830b3ed$export$2105062e25df4afe(store, selector) {
    const [state, setState] = (0, $acw62.useState)(selector(store.get()));
    $e2d297bc4830b3ed$export$bb8178b296baf229(store, selector, (newState)=>{
        setState(newState);
    });
    // When store changes we need the state to be updated synchronously to avoid inconsistencies.
    const prevStore = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(store);
    if (prevStore !== null && prevStore !== store) return selector(store.get());
    return state;
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $706a20e534c5f10e$export$7e25b940db2acfac(s1, s2) {
    if (s1 && s2) return s1.padInlineStart === s2.padInlineStart && s1.lastInsetInlineStart === s2.lastInsetInlineStart && s1.lastInsetInlineEnd === s2.lastInsetInlineEnd && s1.offset.insetInlineStart === s2.offset.insetInlineStart && s1.offset.insetInlineEnd === s2.offset.insetInlineEnd;
    return s1 === s2;
}
function $706a20e534c5f10e$export$dcb87506cb5a76dc(s1, s2) {
    return s1.scrollPaddingInlineStart === s2.scrollPaddingInlineStart && s1.scrollPaddingInlineEnd === s2.scrollPaddingInlineEnd;
}
function $706a20e534c5f10e$export$7ed886faf178267c(cells, props) {
    var _a, _b, _c, _d;
    const totalColumns = props.visibleColumns.length;
    const firstColumnsWidths = [];
    for(let i = 0; i < Math.min(totalColumns, props.stickyColumnsFirst); i++){
        const element = cells.get(props.visibleColumns[i]);
        const cellWidth = element ? (0, $558545a5feadf817$export$322fb6cc2f904670)(element).inlineSize : 0;
        firstColumnsWidths[i] = ((_a = firstColumnsWidths[i - 1]) !== null && _a !== void 0 ? _a : 0) + cellWidth;
    }
    const lastColumnsWidths = [];
    for(let i = 0; i < Math.min(totalColumns, props.stickyColumnsLast); i++){
        const element = cells.get(props.visibleColumns[totalColumns - 1 - i]);
        const cellWidth = element ? (0, $558545a5feadf817$export$322fb6cc2f904670)(element).inlineSize : 0;
        lastColumnsWidths[i] = ((_b = lastColumnsWidths[i - 1]) !== null && _b !== void 0 ? _b : 0) + cellWidth;
    }
    const stickyWidthInlineStart = (_c = firstColumnsWidths[props.stickyColumnsFirst - 1]) !== null && _c !== void 0 ? _c : 0;
    const stickyWidthInlineEnd = (_d = lastColumnsWidths[props.stickyColumnsLast - 1]) !== null && _d !== void 0 ? _d : 0;
    const offsets = props.visibleColumns.reduce((map, columnId, columnIndex)=>{
        var _a, _b;
        return map.set(columnId, {
            first: (_a = firstColumnsWidths[columnIndex - 1]) !== null && _a !== void 0 ? _a : 0,
            last: (_b = lastColumnsWidths[totalColumns - 1 - columnIndex - 1]) !== null && _b !== void 0 ? _b : 0
        });
    }, new Map());
    return {
        offsets: offsets,
        stickyWidthInlineStart: stickyWidthInlineStart,
        stickyWidthInlineEnd: stickyWidthInlineEnd
    };
}


// We allow the table to have a minimum of 148px of available space besides the sum of the widths of the sticky columns
// This value is an UX recommendation and is approximately 1/3 of our smallest breakpoint (465px)
const $b00a9e41f83b2a0f$var$MINIMUM_SCROLLABLE_SPACE = 148;
function $b00a9e41f83b2a0f$export$fa628f01ec57be39({ visibleColumns: visibleColumns, stickyColumnsFirst: stickyColumnsFirst, stickyColumnsLast: stickyColumnsLast }) {
    const store = (0, $acw62.useMemo)(()=>new $b00a9e41f83b2a0f$export$2e2bcd8739ae039(), []);
    const wrapperRef = (0, $acw62.useRef)(null);
    const tableRef = (0, $acw62.useRef)(null);
    const cellsRef = (0, $acw62.useRef)(new Map());
    const hasStickyColumns = stickyColumnsFirst + stickyColumnsLast > 0;
    const updateStickyStyles = (0, $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0)(()=>{
        if (wrapperRef.current && tableRef.current) store.updateCellStyles({
            wrapper: wrapperRef.current,
            table: tableRef.current,
            cells: cellsRef.current,
            visibleColumns: visibleColumns,
            stickyColumnsFirst: stickyColumnsFirst,
            stickyColumnsLast: stickyColumnsLast
        });
    });
    (0, $444535e54951fdea$export$683480f191c0e3ea)(wrapperRef, updateStickyStyles);
    (0, $444535e54951fdea$export$683480f191c0e3ea)(tableRef, updateStickyStyles);
    (0, $acw62.useEffect)(()=>{
        if (wrapperRef.current && tableRef.current) store.updateCellStyles({
            wrapper: wrapperRef.current,
            table: tableRef.current,
            cells: cellsRef.current,
            visibleColumns: visibleColumns,
            stickyColumnsFirst: stickyColumnsFirst,
            stickyColumnsLast: stickyColumnsLast
        });
    }, [
        store,
        stickyColumnsFirst,
        stickyColumnsLast,
        visibleColumns
    ]);
    // Update wrapper styles imperatively to avoid unnecessary re-renders.
    (0, $acw62.useEffect)(()=>{
        if (!hasStickyColumns) return;
        const selector = (state)=>state.wrapperState;
        const updateWrapperStyles = (state, prev)=>{
            if ((0, $706a20e534c5f10e$export$dcb87506cb5a76dc)(state, prev)) return;
            if (wrapperRef.current) {
                wrapperRef.current.style.scrollPaddingInlineStart = state.scrollPaddingInlineStart + "px";
                wrapperRef.current.style.scrollPaddingInlineEnd = state.scrollPaddingInlineEnd + "px";
            }
        };
        const unsubscribe = store.subscribe(selector, (newState, prevState)=>updateWrapperStyles(selector(newState), selector(prevState)));
        return unsubscribe;
    }, [
        store,
        hasStickyColumns
    ]);
    const setWrapper = (0, $acw62.useCallback)((node)=>{
        if (wrapperRef.current) wrapperRef.current.removeEventListener("scroll", updateStickyStyles);
        if (node && hasStickyColumns) node.addEventListener("scroll", updateStickyStyles);
        wrapperRef.current = node;
    }, [
        hasStickyColumns,
        updateStickyStyles
    ]);
    const setTable = (0, $acw62.useCallback)((node)=>{
        tableRef.current = node;
    }, []);
    const setCell = (0, $acw62.useCallback)((columnId, node)=>{
        if (node) cellsRef.current.set(columnId, node);
        else cellsRef.current.delete(columnId);
    }, []);
    return {
        store: store,
        style: {
            // Provide wrapper styles as props so that a re-render won't cause invalidation.
            wrapper: hasStickyColumns ? Object.assign({}, store.get().wrapperState) : undefined
        },
        refs: {
            wrapper: setWrapper,
            table: setTable,
            cell: setCell
        }
    };
}
function $b00a9e41f83b2a0f$export$76f0c0a58cdc31f5({ stickyColumns: stickyColumns, columnId: columnId, getClassName: getClassName }) {
    var _a;
    const setCell = stickyColumns.refs.cell;
    // unsubscribeRef to hold the function to unsubscribe from the store's updates
    const unsubscribeRef = (0, $acw62.useRef)(null);
    // refCallback updates the cell ref and sets up the store subscription
    const refCallback = (0, $acw62.useCallback)((cellElement)=>{
        if (unsubscribeRef.current) // Unsubscribe before we do any updates to avoid leaving any subscriptions hanging
        unsubscribeRef.current();
        // Update cellRef and the store's state to point to the new DOM node
        setCell(columnId, cellElement);
        // Update cell styles imperatively to avoid unnecessary re-renders.
        const selector = (state)=>{
            var _a;
            return (_a = state.cellState.get(columnId)) !== null && _a !== void 0 ? _a : null;
        };
        const updateCellStyles = (state, prev)=>{
            if ((0, $706a20e534c5f10e$export$7e25b940db2acfac)(state, prev)) return;
            const className = getClassName(state);
            if (cellElement) {
                Object.keys(className).forEach((key)=>{
                    if (className[key]) cellElement.classList.add(key);
                    else cellElement.classList.remove(key);
                });
                cellElement.style.insetInlineStart = (state === null || state === void 0 ? void 0 : state.offset.insetInlineStart) !== undefined ? `${state.offset.insetInlineStart}px` : "";
                cellElement.style.insetInlineEnd = (state === null || state === void 0 ? void 0 : state.offset.insetInlineEnd) !== undefined ? `${state.offset.insetInlineEnd}px` : "";
            }
        };
        // If the node is not null (i.e., the table cell is being mounted or updated, not unmounted),
        // set up a new subscription to the store's updates
        if (cellElement) unsubscribeRef.current = stickyColumns.store.subscribe(selector, (newState, prevState)=>{
            updateCellStyles(selector(newState), selector(prevState));
        });
    }, // getClassName is expected to be pure
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        columnId,
        setCell,
        stickyColumns.store
    ]);
    // Provide cell styles as props so that a re-render won't cause invalidation.
    const cellStyles = stickyColumns.store.get().cellState.get(columnId);
    return {
        ref: refCallback,
        className: cellStyles ? (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(getClassName(cellStyles)) : undefined,
        style: (_a = cellStyles === null || cellStyles === void 0 ? void 0 : cellStyles.offset) !== null && _a !== void 0 ? _a : undefined
    };
}
class $b00a9e41f83b2a0f$export$2e2bcd8739ae039 extends (0, $e2d297bc4830b3ed$export$2e2bcd8739ae039) {
    constructor(){
        super({
            cellState: new Map(),
            wrapperState: {
                scrollPaddingInlineStart: 0,
                scrollPaddingInlineEnd: 0
            }
        });
        this.cellOffsets = {
            offsets: new Map(),
            stickyWidthInlineStart: 0,
            stickyWidthInlineEnd: 0
        };
        this.isStuckToTheInlineStart = false;
        this.isStuckToTheInlineEnd = false;
        this.padInlineStart = false;
        this.generateCellStyles = (props)=>{
            const isEnabled = this.isEnabled(props);
            const lastLeftStickyColumnIndex = props.stickyColumnsFirst - 1;
            const lastRightStickyColumnIndex = props.visibleColumns.length - props.stickyColumnsLast;
            return props.visibleColumns.reduce((acc, columnId, index)=>{
                var _a, _b, _c, _d;
                let stickySide = "non-sticky";
                if (index < props.stickyColumnsFirst) stickySide = "inline-start";
                else if (index >= props.visibleColumns.length - props.stickyColumnsLast) stickySide = "inline-end";
                if (!isEnabled || stickySide === "non-sticky") return acc;
                // Determine the offset of the sticky column using the `cellOffsets` state object
                const isFirstColumn = index === 0;
                const stickyColumnOffsetLeft = (_b = (_a = this.cellOffsets.offsets.get(columnId)) === null || _a === void 0 ? void 0 : _a.first) !== null && _b !== void 0 ? _b : 0;
                const stickyColumnOffsetRight = (_d = (_c = this.cellOffsets.offsets.get(columnId)) === null || _c === void 0 ? void 0 : _c.last) !== null && _d !== void 0 ? _d : 0;
                acc.set(columnId, {
                    padInlineStart: isFirstColumn && this.padInlineStart,
                    lastInsetInlineStart: this.isStuckToTheInlineStart && lastLeftStickyColumnIndex === index,
                    lastInsetInlineEnd: this.isStuckToTheInlineEnd && lastRightStickyColumnIndex === index,
                    offset: {
                        insetInlineStart: stickySide === "inline-start" ? stickyColumnOffsetLeft : undefined,
                        insetInlineEnd: stickySide === "inline-end" ? stickyColumnOffsetRight : undefined
                    }
                });
                return acc;
            }, new Map());
        };
        this.updateCellOffsets = (props)=>{
            this.cellOffsets = (0, $706a20e534c5f10e$export$7ed886faf178267c)(props.cells, props);
        };
        this.isEnabled = (props)=>{
            const noStickyColumns = props.stickyColumnsFirst + props.stickyColumnsLast === 0;
            if (noStickyColumns) return false;
            const wrapperWidth = (0, $558545a5feadf817$export$322fb6cc2f904670)(props.wrapper).inlineSize;
            const tableWidth = (0, $558545a5feadf817$export$322fb6cc2f904670)(props.table).inlineSize;
            const isWrapperScrollable = tableWidth > wrapperWidth;
            if (!isWrapperScrollable) return false;
            const totalStickySpace = this.cellOffsets.stickyWidthInlineStart + this.cellOffsets.stickyWidthInlineEnd;
            const tablePaddingLeft = parseFloat(getComputedStyle(props.table).paddingLeft) || 0;
            const tablePaddingRight = parseFloat(getComputedStyle(props.table).paddingRight) || 0;
            const hasEnoughScrollableSpace = totalStickySpace + $b00a9e41f83b2a0f$var$MINIMUM_SCROLLABLE_SPACE + tablePaddingLeft + tablePaddingRight < wrapperWidth;
            if (!hasEnoughScrollableSpace) return false;
            return true;
        };
    }
    updateCellStyles(props) {
        const hasStickyColumns = props.stickyColumnsFirst + props.stickyColumnsLast > 0;
        const hadStickyColumns = this.cellOffsets.offsets.size > 0;
        if (hasStickyColumns || hadStickyColumns) {
            this.updateScroll(props);
            this.updateCellOffsets(props);
            this.set(()=>({
                    cellState: this.generateCellStyles(props),
                    wrapperState: {
                        scrollPaddingInlineStart: this.cellOffsets.stickyWidthInlineStart,
                        scrollPaddingInlineEnd: this.cellOffsets.stickyWidthInlineEnd
                    }
                }));
        }
    }
    updateScroll(props) {
        const wrapperScrollInlineStart = (0, $558545a5feadf817$export$2ba840c8e91736fd)(props.wrapper);
        const wrapperScrollWidth = props.wrapper.scrollWidth;
        const wrapperClientWidth = props.wrapper.clientWidth;
        const tablePaddingInlineStart = parseFloat(getComputedStyle(props.table).paddingInlineStart) || 0;
        const tablePaddingInlineEnd = parseFloat(getComputedStyle(props.table).paddingInlineEnd) || 0;
        this.isStuckToTheInlineStart = wrapperScrollInlineStart > tablePaddingInlineStart;
        // Math.ceil() is used here to address an edge-case in certain browsers, where they return non-integer wrapperScrollInlineStart values
        // which are lower than expected (sub-pixel difference), resulting in the table always being in the "stuck to the right" state
        this.isStuckToTheInlineEnd = Math.ceil(wrapperScrollInlineStart) < wrapperScrollWidth - wrapperClientWidth - tablePaddingInlineEnd;
        this.padInlineStart = tablePaddingInlineStart !== 0 && this.isStuckToTheInlineStart;
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4724080100e81846$var$stateToAriaSort = {
    sortable: "none",
    ascending: "ascending",
    descending: "descending"
};
const $4724080100e81846$var$getAriaSort = (sortingState)=>$4724080100e81846$var$stateToAriaSort[sortingState];
function $4724080100e81846$export$2c3bcd6eb50948d4(options) {
    const nativeProps = {};
    // Browsers have weird mechanism to guess whether it's a data table or a layout table.
    // If we state explicitly, they get it always correctly even with low number of rows.
    nativeProps.role = options.tableRole === "grid-default" ? "grid" : options.tableRole;
    nativeProps["aria-label"] = options.ariaLabel;
    nativeProps["aria-labelledby"] = options.ariaLabelledby;
    // Incrementing the total count by one to account for the header row.
    nativeProps["aria-rowcount"] = typeof options.totalItemsCount === "number" ? options.totalItemsCount + 1 : -1;
    if (options.tableRole === "grid" || options.tableRole === "treegrid") nativeProps["aria-colcount"] = options.totalColumnsCount;
    // Make table component programmatically focusable to attach focusin/focusout for keyboard navigation.
    if (options.tableRole === "grid" || options.tableRole === "treegrid") nativeProps.tabIndex = -1;
    return nativeProps;
}
function $4724080100e81846$export$9facfa3a9b67cdc8(options) {
    const nativeProps = {};
    // When the table is scrollable, the wrapper is made focusable so that keyboard users can scroll it horizontally with arrow keys.
    if (options.isScrollable) {
        nativeProps.role = "region";
        nativeProps.tabIndex = 0;
        nativeProps["aria-label"] = options.ariaLabel;
        nativeProps["aria-labelledby"] = options.ariaLabelledby;
    }
    return nativeProps;
}
function $4724080100e81846$export$db8fc6d3575bc25b(options) {
    const nativeProps = {};
    // For grids headers are treated similar to data rows and are indexed accordingly.
    if (options.tableRole === "grid" || options.tableRole === "grid-default" || options.tableRole === "treegrid") nativeProps["aria-rowindex"] = 1;
    return nativeProps;
}
function $4724080100e81846$export$70749aa7430746bc(options) {
    const nativeProps = {};
    // The data cell indices are incremented by 1 to account for the header cells.
    if (options.tableRole === "grid" || options.tableRole === "treegrid") nativeProps["aria-rowindex"] = (options.firstIndex || 1) + options.rowIndex + 1;
    else if (options.firstIndex !== undefined) nativeProps["aria-rowindex"] = options.firstIndex + options.rowIndex + 1;
    if (options.tableRole === "treegrid" && options.level && options.level !== 0) nativeProps["aria-level"] = options.level;
    if (options.tableRole === "treegrid" && options.setSize) nativeProps["aria-setsize"] = options.setSize;
    if (options.tableRole === "treegrid" && options.posInSet) nativeProps["aria-posinset"] = options.posInSet;
    return nativeProps;
}
function $4724080100e81846$export$9277a016ea496b61(options) {
    const nativeProps = {};
    nativeProps.scope = "col";
    if (options.tableRole === "grid" || options.tableRole === "treegrid") nativeProps["aria-colindex"] = options.colIndex + 1;
    if (options.sortingStatus) nativeProps["aria-sort"] = $4724080100e81846$var$getAriaSort(options.sortingStatus);
    return nativeProps;
}
function $4724080100e81846$export$df12e6f9829885b(options) {
    const nativeProps = {};
    if (options.tableRole === "grid" || options.tableRole === "treegrid") nativeProps["aria-colindex"] = options.colIndex + 1;
    if (options.isRowHeader) nativeProps.scope = "row";
    return nativeProps;
}



function $ef31a059f47373a7$export$3d583f8f97f3b3a0({ className: className, style: style, sortingStatus: sortingStatus, sortingDisabled: sortingDisabled, focusedComponent: focusedComponent, hidden: hidden, colIndex: colIndex, columnId: columnId, stickyState: stickyState, cellRef: cellRef, tableRole: tableRole, children: children }) {
    const stickyStyles = (0, $b00a9e41f83b2a0f$export$76f0c0a58cdc31f5)({
        stickyColumns: stickyState,
        columnId: columnId,
        getClassName: (props)=>(0, $d5e9c22659308d3d$export$8343e8fa60fc2e2f)((0, $93211f0fff30af11$export$2e2bcd8739ae039), props)
    });
    const cellRefObject = (0, $acw62.useRef)(null);
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(stickyStyles.ref, cellRef, cellRefObject);
    const { tabIndex: cellTabIndex } = (0, $7f9661e47bcc5460$export$4cf30df7bba16ac9)(cellRefObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", Object.assign({
        "data-focus-id": `header-${String(columnId)}`,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, {
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-fake-focus"]]: focusedComponent === `header-${String(columnId)}`,
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-sortable"]]: sortingStatus,
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-sorted"]]: sortingStatus === "ascending" || sortingStatus === "descending",
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-disabled"]]: sortingDisabled,
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-ascending"]]: sortingStatus === "ascending",
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-descending"]]: sortingStatus === "descending",
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-hidden"]]: hidden
        }, stickyStyles.className),
        style: Object.assign(Object.assign({}, style), stickyStyles.style),
        ref: mergedRef
    }, (0, $4724080100e81846$export$9277a016ea496b61)({
        tableRole: tableRole,
        sortingStatus: sortingStatus,
        colIndex: colIndex
    }), {
        tabIndex: cellTabIndex === -1 ? undefined : cellTabIndex
    }), children);
}



function $09ac39531d24690e$export$9e1517a3035b3e5c({ className: className, style: style, tabIndex: tabIndex, column: column, activeSortingColumn: activeSortingColumn, sortingDescending: sortingDescending, sortingDisabled: sortingDisabled, wrapLines: wrapLines, focusedComponent: focusedComponent, hidden: hidden, onClick: onClick, colIndex: colIndex, updateColumn: updateColumn, resizableColumns: resizableColumns, onResizeFinish: onResizeFinish, isEditable: isEditable, columnId: columnId, stickyState: stickyState, cellRef: cellRef, tableRole: tableRole, resizerRoleDescription: resizerRoleDescription, isExpandable: isExpandable }) {
    var _a;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("table");
    const sortable = !!column.sortingComparator || !!column.sortingField;
    const sorted = !!activeSortingColumn && (0, $18fb5778d4dc41bf$export$efa610630f9e181)(column, activeSortingColumn);
    const sortingStatus = (0, $18fb5778d4dc41bf$export$522d1547ed3f4c02)(sortable, sorted, !!sortingDescending, !!sortingDisabled);
    const handleClick = ()=>onClick({
            sortingColumn: column,
            isDescending: sorted ? !sortingDescending : false
        });
    // Elements with role="button" do not have the default behavior of <button>, where pressing
    // Enter or Space will trigger a click event. Therefore we need to add this ourselves.
    // The native <button> element cannot be used due to a misaligned implementation in Firefox:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=843003
    const handleKeyPress = ({ nativeEvent: e })=>{
        if (e.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).enter || e.keyCode === (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).space) {
            e.preventDefault();
            handleClick();
        }
    };
    const headerId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("table-header-");
    const clickableHeaderRef = (0, $acw62.useRef)(null);
    const { tabIndex: clickableHeaderTabIndex } = (0, $7f9661e47bcc5460$export$4cf30df7bba16ac9)(clickableHeaderRef, {
        tabIndex: tabIndex
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ef31a059f47373a7$export$3d583f8f97f3b3a0), {
        className: className,
        style: style,
        cellRef: cellRef,
        sortingStatus: sortingStatus,
        sortingDisabled: sortingDisabled,
        focusedComponent: focusedComponent,
        hidden: hidden,
        colIndex: colIndex,
        columnId: columnId,
        stickyState: stickyState,
        tableRole: tableRole
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: clickableHeaderRef,
        "data-focus-id": `sorting-control-${String(columnId)}`,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-content"], {
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-fake-focus"]]: focusedComponent === `sorting-control-${String(columnId)}`,
            [(0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-content-expandable"]]: isExpandable
        }),
        "aria-label": column.ariaLabel ? column.ariaLabel({
            sorted: sorted,
            descending: sorted && !!sortingDescending,
            disabled: !!sortingDisabled
        }) : undefined
    }, sortingStatus && !sortingDisabled ? {
        onKeyPress: handleKeyPress,
        tabIndex: clickableHeaderTabIndex,
        role: "button",
        onClick: handleClick
    } : {}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-text"], wrapLines && (0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-text-wrap"]),
        id: headerId
    }, column.header, isEditable && !isExpandable ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $93211f0fff30af11$export$2e2bcd8739ae039)["edit-icon"],
        role: "img",
        "aria-label": i18n("columnDefinitions.editConfig.editIconAriaLabel", (_a = column.editConfig) === null || _a === void 0 ? void 0 : _a.editIconAriaLabel)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "edit"
    })) : null), sortingStatus && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $93211f0fff30af11$export$2e2bcd8739ae039)["sorting-icon"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: (0, $18fb5778d4dc41bf$export$f3a117936eca5c61)(sortingStatus)
    }))), resizableColumns ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba2285bfc0275a61$export$48a76196cafe3b93), {
        tabIndex: tabIndex,
        focusId: `resize-control-${String(columnId)}`,
        showFocusRing: focusedComponent === `resize-control-${String(columnId)}`,
        onWidthUpdate: (newWidth)=>updateColumn(columnId, newWidth),
        onWidthUpdateCommit: onResizeFinish,
        ariaLabelledby: headerId,
        minWidth: typeof column.minWidth === "string" ? parseInt(column.minWidth) : column.minWidth,
        roleDescription: i18n("ariaLabels.resizerRoleDescription", resizerRoleDescription)
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba2285bfc0275a61$export$2e0a83ec2e27ecbb), {
        className: (0, $93211f0fff30af11$export$2e2bcd8739ae039)["resize-divider"]
    }));
}











const $bc555153bc24e36c$var$Thead = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ selectionType: selectionType, getSelectAllProps: getSelectAllProps, columnDefinitions: columnDefinitions, sortingColumn: sortingColumn, sortingDisabled: sortingDisabled, sortingDescending: sortingDescending, resizableColumns: resizableColumns, variant: variant, wrapLines: wrapLines, onFocusMove: onFocusMove, onSortingChange: onSortingChange, onResizeFinish: onResizeFinish, singleSelectionHeaderAriaLabel: singleSelectionHeaderAriaLabel, stripedRows: stripedRows, sticky: sticky = false, hidden: hidden = false, stuck: stuck = false, stickyState: stickyState, selectionColumnId: selectionColumnId, focusedComponent: focusedComponent, onFocusedComponentChange: onFocusedComponentChange, tableRole: tableRole, resizerRoleDescription: resizerRoleDescription, isExpandable: isExpandable, setLastUserAction: setLastUserAction }, outerRef)=>{
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const headerCellClass = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell"], (0, $93211f0fff30af11$export$2e2bcd8739ae039)[`header-cell-variant-${variant}`], sticky && (0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-sticky"], stuck && (0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-stuck"], stripedRows && (0, $93211f0fff30af11$export$2e2bcd8739ae039)["has-striped-rows"], isVisualRefresh && (0, $93211f0fff30af11$export$2e2bcd8739ae039)["is-visual-refresh"]);
    const selectionCellClass = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039)["selection-control"], (0, $7ded81c543f72294$export$2e2bcd8739ae039)["selection-control-header"], isVisualRefresh && (0, $7ded81c543f72294$export$2e2bcd8739ae039)["is-visual-refresh"]);
    const { getColumnStyles: getColumnStyles, columnWidths: columnWidths, updateColumn: updateColumn, setCell: setCell } = (0, $52cd48af6d6570d7$export$d598237875812773)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(!hidden && (0, $7ded81c543f72294$export$2e2bcd8739ae039)["thead-active"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", Object.assign({}, (0, $30c09cf06b060b34$export$abdbebe48aa0774a).all, {
        ref: outerRef,
        "aria-rowindex": 1
    }, (0, $4724080100e81846$export$db8fc6d3575bc25b)({
        tableRole: tableRole
    }), {
        onFocus: (event)=>{
            var _a;
            const focusControlElement = (0, $b679de281b3ba268$export$2e2bcd8739ae039)(event.target, (element)=>!!element.getAttribute("data-focus-id"));
            const focusId = (_a = focusControlElement === null || focusControlElement === void 0 ? void 0 : focusControlElement.getAttribute("data-focus-id")) !== null && _a !== void 0 ? _a : null;
            onFocusedComponentChange === null || onFocusedComponentChange === void 0 || onFocusedComponentChange(focusId);
        },
        onBlur: ()=>onFocusedComponentChange === null || onFocusedComponentChange === void 0 ? void 0 : onFocusedComponentChange(null)
    }), selectionType ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ef31a059f47373a7$export$3d583f8f97f3b3a0), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(headerCellClass, selectionCellClass, hidden && (0, $93211f0fff30af11$export$2e2bcd8739ae039)["header-cell-hidden"]),
        hidden: hidden,
        tableRole: tableRole,
        colIndex: 0,
        focusedComponent: focusedComponent,
        columnId: selectionColumnId,
        stickyState: stickyState
    }, getSelectAllProps ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $51374b608ac485d9$export$c5dcec1959129451), Object.assign({
        onFocusDown: (event)=>{
            onFocusMove(event.target, -1, 1);
        },
        focusedComponent: focusedComponent
    }, getSelectAllProps(), sticky ? {
        tabIndex: -1
    } : {})) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b8469ab82402f2dd$export$2e2bcd8739ae039), null, singleSelectionHeaderAriaLabel), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba2285bfc0275a61$export$2e0a83ec2e27ecbb), {
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)["resize-divider"]
    })) : null, columnDefinitions.map((column, colIndex)=>{
        const columnId = (0, $d5e9c22659308d3d$export$480219a02f196e72)(column, colIndex);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $09ac39531d24690e$export$9e1517a3035b3e5c), {
            key: columnId,
            style: getColumnStyles(sticky, columnId),
            className: headerCellClass,
            tabIndex: sticky ? -1 : 0,
            focusedComponent: focusedComponent,
            column: column,
            activeSortingColumn: sortingColumn,
            sortingDescending: sortingDescending,
            sortingDisabled: sortingDisabled,
            wrapLines: wrapLines,
            hidden: hidden,
            colIndex: selectionType ? colIndex + 1 : colIndex,
            columnId: columnId,
            updateColumn: updateColumn,
            onResizeFinish: ()=>onResizeFinish(columnWidths),
            resizableColumns: resizableColumns,
            onClick: (detail)=>{
                setLastUserAction("sorting");
                (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSortingChange, detail);
            },
            isEditable: !!column.editConfig,
            stickyState: stickyState,
            cellRef: (node)=>setCell(sticky, columnId, node),
            tableRole: tableRole,
            resizerRoleDescription: resizerRoleDescription,
            // Expandable option is only applicable to the first data column of the table.
            // When present, the header content receives extra padding to match the first offset in the data cells.
            isExpandable: colIndex === 0 && isExpandable
        });
    })));
});
var $bc555153bc24e36c$export$2e2bcd8739ae039 = $bc555153bc24e36c$var$Thead;





var $072f869ecd5e8de2$export$2e2bcd8739ae039 = {
    "expandable-toggle-wrapper": "awsui_expandable-toggle-wrapper_c6tup_1szmt_97",
    "body-cell": "awsui_body-cell_c6tup_1szmt_104",
    "body-cell-content": "awsui_body-cell-content_c6tup_1szmt_112",
    "expandable-level-0": "awsui_expandable-level-0_c6tup_1szmt_118",
    "expandable-level-1": "awsui_expandable-level-1_c6tup_1szmt_124",
    "expandable-level-2": "awsui_expandable-level-2_c6tup_1szmt_130",
    "expandable-level-3": "awsui_expandable-level-3_c6tup_1szmt_136",
    "expandable-level-4": "awsui_expandable-level-4_c6tup_1szmt_142",
    "expandable-level-5": "awsui_expandable-level-5_c6tup_1szmt_148",
    "expandable-level-6": "awsui_expandable-level-6_c6tup_1szmt_154",
    "expandable-level-7": "awsui_expandable-level-7_c6tup_1szmt_160",
    "expandable-level-8": "awsui_expandable-level-8_c6tup_1szmt_166",
    "expandable-level-9": "awsui_expandable-level-9_c6tup_1szmt_172",
    "expandable-level-next": "awsui_expandable-level-next_c6tup_1szmt_178",
    "body-cell-wrap": "awsui_body-cell-wrap_c6tup_1szmt_198",
    "is-visual-refresh": "awsui_is-visual-refresh_c6tup_1szmt_212",
    "has-striped-rows": "awsui_has-striped-rows_c6tup_1szmt_224",
    "body-cell-edit-active": "awsui_body-cell-edit-active_c6tup_1szmt_296",
    "body-cell-interactive": "awsui_body-cell-interactive_c6tup_1szmt_296",
    "body-cell-editable": "awsui_body-cell-editable_c6tup_1szmt_296",
    "has-striped-rows-sticky-cell-pad-inline-start": "awsui_has-striped-rows-sticky-cell-pad-inline-start_c6tup_1szmt_440",
    "has-selection": "awsui_has-selection_c6tup_1szmt_512",
    "body-cell-first-row": "awsui_body-cell-first-row_c6tup_1szmt_591",
    "body-cell-last-row": "awsui_body-cell-last-row_c6tup_1szmt_594",
    "body-cell-selected": "awsui_body-cell-selected_c6tup_1szmt_594",
    "has-footer": "awsui_has-footer_c6tup_1szmt_594",
    "body-cell-shaded": "awsui_body-cell-shaded_c6tup_1szmt_604",
    "sticky-cell": "awsui_sticky-cell_c6tup_1szmt_632",
    "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_c6tup_1szmt_640",
    "sticky-cell-last-inline-end": "awsui_sticky-cell-last-inline-end_c6tup_1szmt_726",
    "sticky-cell-last-inline-start": "awsui_sticky-cell-last-inline-start_c6tup_1szmt_735",
    "body-cell-next-selected": "awsui_body-cell-next-selected_c6tup_1szmt_768",
    "body-cell-prev-selected": "awsui_body-cell-prev-selected_c6tup_1szmt_774",
    "body-cell-editor-wrapper": "awsui_body-cell-editor-wrapper_c6tup_1szmt_800",
    "body-cell-success": "awsui_body-cell-success_c6tup_1szmt_807",
    "body-cell-editor": "awsui_body-cell-editor_c6tup_1szmt_800",
    "body-cell-editor-disabled": "awsui_body-cell-editor-disabled_c6tup_1szmt_834",
    "body-cell-editor-form": "awsui_body-cell-editor-form_c6tup_1szmt_843",
    "body-cell-editor-row": "awsui_body-cell-editor-row_c6tup_1szmt_853",
    "body-cell-editor-controls": "awsui_body-cell-editor-controls_c6tup_1szmt_863",
    "body-cell-editor-row-editor": "awsui_body-cell-editor-row-editor_c6tup_1szmt_866",
    "body-cell-expandable": "awsui_body-cell-expandable_c6tup_1szmt_869",
    "resizable-columns": "awsui_resizable-columns_c6tup_1szmt_890",
    "expandable-cell-content": "awsui_expandable-cell-content_c6tup_1szmt_893",
    "body-cell-has-success": "awsui_body-cell-has-success_c6tup_1szmt_962",
    "body-cell-edit-disabled-popover": "awsui_body-cell-edit-disabled-popover_c6tup_1szmt_962"
};



var $acw62 = parcelRequire("acw62");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


var $bf2dde37293df6a4$export$2e2bcd8739ae039 = {
    "expand-toggle-icon": "awsui_expand-toggle-icon_1ss49_1npai_97",
    "expand-toggle-icon-expanded": "awsui_expand-toggle-icon-expanded_1ss49_1npai_122",
    "expand-toggle": "awsui_expand-toggle_1ss49_1npai_97"
};




function $b56111ce3f78cc71$export$dee85bbd706fcf78({ isExpanded: isExpanded, onExpandableItemToggle: onExpandableItemToggle, expandButtonLabel: expandButtonLabel, collapseButtonLabel: collapseButtonLabel }) {
    const buttonRef = (0, $acw62.useRef)(null);
    const { tabIndex: tabIndex } = (0, $7f9661e47bcc5460$export$4cf30df7bba16ac9)(buttonRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: buttonRef,
        tabIndex: tabIndex,
        "aria-label": isExpanded ? collapseButtonLabel : expandButtonLabel,
        "aria-expanded": isExpanded,
        className: (0, $bf2dde37293df6a4$export$2e2bcd8739ae039)["expand-toggle"],
        onClick: onExpandableItemToggle
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        size: "small",
        name: "caret-down-filled",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $bf2dde37293df6a4$export$2e2bcd8739ae039)["expand-toggle-icon"], isExpanded && (0, $bf2dde37293df6a4$export$2e2bcd8739ae039)["expand-toggle-icon-expanded"])
    }));
}


const $2eb106c16e1c0bab$export$2e9f934a16f4a89a = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, style: style, children: children, wrapLines: wrapLines, isRowHeader: isRowHeader, isFirstRow: isFirstRow, isLastRow: isLastRow, isSelected: isSelected, isNextSelected: isNextSelected, isPrevSelected: isPrevSelected, nativeAttributes: nativeAttributes, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, isEvenRow: isEvenRow, stripedRows: stripedRows, isVisualRefresh: isVisualRefresh, hasSelection: hasSelection, hasFooter: hasFooter, columnId: columnId, colIndex: colIndex, stickyState: stickyState, tableRole: tableRole, level: level, isExpandable: isExpandable, isExpanded: isExpanded, onExpandableItemToggle: onExpandableItemToggle, expandButtonLabel: expandButtonLabel, collapseButtonLabel: collapseButtonLabel }, ref)=>{
    const Element = isRowHeader ? "th" : "td";
    nativeAttributes = Object.assign(Object.assign({}, nativeAttributes), (0, $4724080100e81846$export$df12e6f9829885b)({
        tableRole: tableRole,
        isRowHeader: isRowHeader,
        colIndex: colIndex
    }));
    const stickyStyles = (0, $b00a9e41f83b2a0f$export$76f0c0a58cdc31f5)({
        stickyColumns: stickyState,
        columnId: columnId,
        getClassName: (props)=>(0, $d5e9c22659308d3d$export$8343e8fa60fc2e2f)((0, $072f869ecd5e8de2$export$2e2bcd8739ae039), props)
    });
    const cellRefObject = (0, $acw62.useRef)(null);
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(stickyStyles.ref, ref, cellRefObject);
    const { tabIndex: cellTabIndex } = (0, $7f9661e47bcc5460$export$4cf30df7bba16ac9)(cellRefObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Element, Object.assign({
        style: Object.assign(Object.assign({}, style), stickyStyles.style),
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell"], wrapLines && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-wrap"], isFirstRow && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-first-row"], isLastRow && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-last-row"], isSelected && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-selected"], isNextSelected && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-next-selected"], isPrevSelected && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-prev-selected"], !isEvenRow && stripedRows && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-shaded"], stripedRows && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["has-striped-rows"], isVisualRefresh && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["is-visual-refresh"], hasSelection && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["has-selection"], hasFooter && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["has-footer"], level !== undefined && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-expandable"], level !== undefined && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)[`expandable-level-${$2eb106c16e1c0bab$var$getLevelClassSuffix(level)}`], stickyStyles.className),
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: mergedRef
    }, nativeAttributes, {
        tabIndex: cellTabIndex === -1 ? undefined : cellTabIndex
    }), level !== undefined && isExpandable && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["expandable-toggle-wrapper"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b56111ce3f78cc71$export$dee85bbd706fcf78), {
        isExpanded: isExpanded,
        onExpandableItemToggle: onExpandableItemToggle,
        expandButtonLabel: expandButtonLabel,
        collapseButtonLabel: collapseButtonLabel
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-content"]
    }, children));
});
function $2eb106c16e1c0bab$var$getLevelClassSuffix(level) {
    return 0 <= level && level <= 9 ? level : "next";
}




var $acw62 = parcelRequire("acw62");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $385075666feb9281$export$682608ebc9a33151(onClick) {
    const awayRef = (0, $acw62.useRef)(null);
    const onClickStable = (0, $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0)(onClick);
    (0, $acw62.useEffect)(()=>{
        function handleClick(event) {
            if (!(0, $4c778684f125e678$export$57d4cb221e1d1857)(awayRef.current, event.target)) onClickStable();
        }
        // contains returns wrong result if the next render would remove the element
        // but capture phase happens before the render, so returns correct result
        // Ref: https://github.com/facebook/react/issues/20325
        document.addEventListener("click", handleClick, {
            capture: true
        });
        return ()=>document.removeEventListener("click", handleClick, {
                capture: true
            });
    }, [
        onClickStable
    ]);
    return awayRef;
}






// A function that does nothing
const $06bd34375dd8684d$var$noop = ()=>undefined;
function $06bd34375dd8684d$export$daaca9c1047b1596({ ariaLabels: ariaLabels, item: item, column: column, onEditEnd: onEditEnd, submitEdit: submitEdit, __onRender: __onRender }) {
    var _a, _b, _c, _d;
    const [currentEditLoading, setCurrentEditLoading] = (0, $acw62.useState)(false);
    const [currentEditValue, setCurrentEditValue] = (0, $acw62.useState)();
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("table");
    const focusLockRef = (0, $acw62.useRef)(null);
    const cellContext = {
        currentValue: currentEditValue,
        setValue: setCurrentEditValue
    };
    function finishEdit({ cancelled: cancelled = false, refocusCell: refocusCell = true } = {}) {
        if (!cancelled) setCurrentEditValue(undefined);
        onEditEnd({
            cancelled: cancelled,
            refocusCell: refocusCell
        });
    }
    function onSubmitClick(evt) {
        var _a;
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            evt.preventDefault();
            if (currentEditValue === undefined) {
                finishEdit();
                return;
            }
            setCurrentEditLoading(true);
            try {
                yield submitEdit(item, column, currentEditValue);
                setCurrentEditLoading(false);
                finishEdit();
            } catch (e) {
                setCurrentEditLoading(false);
                (_a = focusLockRef.current) === null || _a === void 0 || _a.focusFirst();
            }
        });
    }
    function onCancel({ reFocusEditedCell: reFocusEditedCell = true } = {}) {
        if (currentEditLoading) return;
        finishEdit({
            cancelled: true,
            refocusCell: reFocusEditedCell
        });
    }
    function handleEscape(event) {
        if (event.key === "Escape") onCancel();
    }
    const clickAwayRef = (0, $385075666feb9281$export$682608ebc9a33151)(()=>onCancel({
            reFocusEditedCell: false
        }));
    (0, $acw62.useEffect)(()=>{
        if (__onRender) {
            const timer = setTimeout(__onRender, 1);
            return ()=>clearTimeout(timer);
        }
    }, [
        __onRender
    ]);
    // asserting non-undefined editConfig here because this component is unreachable otherwise
    const { ariaLabel: ariaLabel, validation: validation = $06bd34375dd8684d$var$noop, errorIconAriaLabel: errorIconAriaLabel, constraintText: constraintText, editingCell: editingCell } = column.editConfig;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $48646398710f9406$export$2e2bcd8739ae039), {
        restoreFocus: true,
        ref: focusLockRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "dialog",
        ref: clickAwayRef,
        "aria-label": (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.activateEditLabel) === null || _a === void 0 ? void 0 : _a.call(ariaLabels, column, item),
        onKeyDown: handleEscape
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        onSubmit: onSubmitClick,
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-editor-form"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$2e2bcd8739ae039), {
        stretch: true,
        label: ariaLabel,
        constraintText: constraintText,
        __hideLabel: true,
        __disableGutters: true,
        i18nStrings: {
            errorIconAriaLabel: errorIconAriaLabel
        },
        errorText: validation(item, currentEditValue)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-editor-row"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-editor-row-editor"]
    }, editingCell(item, cellContext)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-editor-controls"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
        direction: "horizontal",
        size: "xxs"
    }, !currentEditLoading ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        ariaLabel: (_b = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.cancelEditLabel) === null || _b === void 0 ? void 0 : _b.call(ariaLabels, column),
        formAction: "none",
        iconName: "close",
        variant: "inline-icon",
        onClick: ()=>onCancel()
    }) : null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        ariaLabel: (_c = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.submitEditLabel) === null || _c === void 0 ? void 0 : _c.call(ariaLabels, column),
        formAction: "submit",
        iconName: "check",
        variant: "inline-icon",
        loading: currentEditLoading
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), null, currentEditLoading ? i18n("ariaLabels.submittingEditText", (_d = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.submittingEditText) === null || _d === void 0 ? void 0 : _d.call(ariaLabels, column)) : "")))))));
}








var $acw62 = parcelRequire("acw62");












function $7623cc36788f036d$export$e6789685317f3993(_a) {
    var _b;
    var { className: className, item: item, column: column, ariaLabels: ariaLabels, isEditing: isEditing, onEditStart: onEditStart, onEditEnd: onEditEnd, editDisabledReason: editDisabledReason, isVisualRefresh: isVisualRefresh, interactiveCell: interactiveCell = true, resizableColumns: resizableColumns = false } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "className",
        "item",
        "column",
        "ariaLabels",
        "isEditing",
        "onEditStart",
        "onEditEnd",
        "editDisabledReason",
        "isVisualRefresh",
        "interactiveCell",
        "resizableColumns"
    ]);
    const clickAwayRef = (0, $385075666feb9281$export$682608ebc9a33151)(()=>{
        if (isEditing) onEditEnd(true);
    });
    const [hasHover, setHasHover] = (0, $acw62.useState)(false);
    const [hasFocus, setHasFocus] = (0, $acw62.useState)(false);
    // When a cell is both expandable and editable the icon is always shown.
    const showIcon = hasHover || hasFocus || isEditing || !interactiveCell;
    const iconRef = (0, $acw62.useRef)(null);
    const buttonRef = (0, $acw62.useRef)(null);
    const portalRef = (0, $acw62.useRef)(null);
    function handleEscape(event) {
        if (event.key === "Escape") onEditEnd(true);
    }
    const onClick = ()=>{
        var _a;
        onEditStart();
        (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
    };
    const { targetProps: targetProps, descriptionEl: descriptionEl } = (0, $b36e5053a31bf154$export$2e2bcd8739ae039)(editDisabledReason);
    const portalClasses = (0, $f509ecfba65f3bd6$export$464b090d8a567e1e)(portalRef);
    const { tabIndex: tabIndex } = (0, $7f9661e47bcc5460$export$4cf30df7bba16ac9)(buttonRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2eb106c16e1c0bab$export$2e9f934a16f4a89a), Object.assign({}, rest, {
        nativeAttributes: {
            "data-inline-editing-active": isEditing.toString()
        },
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-editable"], interactiveCell && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-interactive"], resizableColumns && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["resizable-columns"], isEditing && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-edit-disabled-popover"], isVisualRefresh && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["is-visual-refresh"]),
        onClick: interactiveCell && !isEditing ? onClick : undefined,
        onMouseEnter: ()=>setHasHover(true),
        onMouseLeave: ()=>setHasHover(false),
        ref: clickAwayRef
    }), column.cell(item), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-editor-wrapper"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        ref: buttonRef,
        tabIndex: tabIndex,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-editor"], (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-editor-disabled"]),
        "aria-label": (_b = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.activateEditLabel) === null || _b === void 0 ? void 0 : _b.call(ariaLabels, column, item),
        "aria-haspopup": "dialog",
        "aria-disabled": "true",
        onClick: !interactiveCell && !isEditing ? onClick : undefined,
        onFocus: ()=>setHasFocus(true),
        onBlur: ()=>setHasFocus(false),
        onKeyDown: handleEscape
    }, targetProps), showIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "lock-private",
        variant: "normal",
        __internalRootRef: iconRef
    }), descriptionEl)), isEditing && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: portalRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $014cec8599be1408$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: portalClasses
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $129a117414eb7922$export$2e2bcd8739ae039), {
        size: "medium",
        fixedWidth: false,
        position: "top",
        trackRef: iconRef,
        arrow: (position)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b971696cf22f0db1$export$2e2bcd8739ae039), {
                position: position
            }),
        renderWithPortal: true,
        zIndex: 2000
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $763097fcb7ec031e$export$2e2bcd8739ae039), {
        dismissButton: false,
        dismissAriaLabel: undefined,
        header: null,
        onDismiss: ()=>{},
        overflowVisible: "both"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-live": "polite"
    }, editDisabledReason)))))));
}


const $ca56bbf005612a36$var$submitHandlerFallback = ()=>{
    throw new Error("The function `handleSubmit` is required for editable columns");
};
function $ca56bbf005612a36$var$TableCellEditable(_a) {
    var _b, _c, _d;
    var { className: className, item: item, column: column, isEditing: isEditing, onEditStart: onEditStart, onEditEnd: onEditEnd, submitEdit: submitEdit, ariaLabels: ariaLabels, isVisualRefresh: isVisualRefresh, resizableColumns: resizableColumns = false, successfulEdit: successfulEdit = false, interactiveCell: interactiveCell = true } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "className",
        "item",
        "column",
        "isEditing",
        "onEditStart",
        "onEditEnd",
        "submitEdit",
        "ariaLabels",
        "isVisualRefresh",
        "resizableColumns",
        "successfulEdit",
        "interactiveCell"
    ]);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("table");
    const editActivateRef = (0, $acw62.useRef)(null);
    const tdNativeAttributes = {
        "data-inline-editing-active": isEditing.toString()
    };
    const isFocusMoveNeededRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!isEditing && editActivateRef.current && isFocusMoveNeededRef.current) {
            isFocusMoveNeededRef.current = false;
            editActivateRef.current.focus();
        }
    }, [
        isEditing
    ]);
    // To improve the initial page render performance we only show the edit icon when necessary.
    const [hasHover, setHasHover] = (0, $acw62.useState)(false);
    const [hasFocus, setHasFocus] = (0, $acw62.useState)(false);
    // When a cell is both expandable and editable the icon is always shown.
    const showIcon = hasHover || hasFocus || !interactiveCell;
    const prevSuccessfulEdit = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(successfulEdit);
    const prevHasFocus = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(hasFocus);
    const [showSuccessIcon, setShowSuccessIcon] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        // Hide the success icon after a successful edit, when cell loses focus.
        if (successfulEdit && prevSuccessfulEdit && !hasFocus && prevHasFocus) setShowSuccessIcon(false);
        // Show success icon right after a successful edit, when `successfulEdit` switches to true.
        if (successfulEdit && !prevSuccessfulEdit) setShowSuccessIcon(true);
    }, [
        hasFocus,
        successfulEdit,
        prevHasFocus,
        prevSuccessfulEdit
    ]);
    const { tabIndex: editActivateTabIndex } = (0, $7f9661e47bcc5460$export$4cf30df7bba16ac9)(editActivateRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2eb106c16e1c0bab$export$2e9f934a16f4a89a), Object.assign({}, rest, {
        nativeAttributes: tdNativeAttributes,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(className, (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-editable"], interactiveCell && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-interactive"], resizableColumns && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["resizable-columns"], isEditing && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-edit-active"], showSuccessIcon && showIcon && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-has-success"], isVisualRefresh && (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["is-visual-refresh"]),
        onClick: interactiveCell && !isEditing ? onEditStart : undefined,
        onMouseEnter: ()=>setHasHover(true),
        onMouseLeave: ()=>setHasHover(false)
    }), isEditing ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $06bd34375dd8684d$export$daaca9c1047b1596), {
        ariaLabels: ariaLabels,
        column: column,
        item: item,
        onEditEnd: (options)=>{
            setShowSuccessIcon(false);
            isFocusMoveNeededRef.current = options.refocusCell;
            onEditEnd(options.cancelled);
        },
        submitEdit: submitEdit !== null && submitEdit !== void 0 ? submitEdit : $ca56bbf005612a36$var$submitHandlerFallback
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, column.cell(item), showSuccessIcon && showIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-success"],
        "aria-label": (_b = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.successfulEditLabel) === null || _b === void 0 ? void 0 : _b.call(ariaLabels, column),
        role: "img",
        onMouseDown: (e)=>{
            // Prevent the editor's Button blur event to be fired when clicking the success icon.
            // This prevents unfocusing the button and triggers the `TableTdElement` onClick event which initiates the edit mode.
            e.preventDefault();
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "status-positive",
        variant: "success"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), null, i18n("ariaLabels.successfulEditLabel", (_c = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.successfulEditLabel) === null || _c === void 0 ? void 0 : _c.call(ariaLabels, column)))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-editor-wrapper"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: (0, $072f869ecd5e8de2$export$2e2bcd8739ae039)["body-cell-editor"],
        "aria-label": (_d = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.activateEditLabel) === null || _d === void 0 ? void 0 : _d.call(ariaLabels, column, item),
        ref: editActivateRef,
        onClick: !interactiveCell && !isEditing ? onEditStart : undefined,
        onFocus: ()=>setHasFocus(true),
        onBlur: ()=>setHasFocus(false),
        tabIndex: editActivateTabIndex
    }, showIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "edit"
    })))));
}
function $ca56bbf005612a36$export$948e91fcef170792(_a) {
    var _b, _c;
    var { isEditable: isEditable } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "isEditable"
    ]);
    const isExpandableColumnCell = rest.level !== undefined;
    const editDisabledReason = (_c = (_b = rest.column.editConfig) === null || _b === void 0 ? void 0 : _b.disabledReason) === null || _c === void 0 ? void 0 : _c.call(_b, rest.item);
    // Inline editing is deactivated for expandable column because editable cells are interactive
    // and cannot include interactive content such as expand toggles.
    if (editDisabledReason && !isExpandableColumnCell) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7623cc36788f036d$export$e6789685317f3993), Object.assign({
        editDisabledReason: editDisabledReason
    }, rest));
    if ((isEditable || rest.isEditing) && !isExpandableColumnCell) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ca56bbf005612a36$var$TableCellEditable, Object.assign({}, rest));
    const { column: column, item: item } = rest;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2eb106c16e1c0bab$export$2e9f934a16f4a89a), Object.assign({}, rest), column.cell(item));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



function $28a501d6671417e8$export$48c69dbc46986321({ onRowClick: onRowClick, onRowContextMenu: onRowContextMenu }) {
    const onRowClickHandler = (rowIndex, item, event)=>{
        const tableCell = (0, $38f6480185c49d6f$export$184ef262a758e3c4)(event.target, (element)=>element.tagName.toLowerCase() === "td");
        if (!tableCell || !tableCell.classList.contains((0, $7ded81c543f72294$export$2e2bcd8739ae039)["selection-control"])) {
            const details = {
                rowIndex: rowIndex,
                item: item
            };
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onRowClick, details);
        }
    };
    const onRowContextMenuHandler = (rowIndex, item, event)=>{
        const details = {
            rowIndex: rowIndex,
            item: item,
            clientX: event.clientX,
            clientY: event.clientY
        };
        (0, $fc537b925f715587$export$d7e1721720edbb03)(onRowContextMenu, details, event);
    };
    return {
        onRowClickHandler: onRowClick && onRowClickHandler,
        onRowContextMenuHandler: onRowContextMenu && onRowContextMenuHandler
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





function $9bc9293ffbf00f4c$export$a97c3cc4bf1da1ca(options) {
    const singleSelectionProps = $9bc9293ffbf00f4c$var$useSingleSelection(options);
    const multiSelectionProps = $9bc9293ffbf00f4c$var$useMultiSelection(options);
    return options.selectionType === "single" ? singleSelectionProps : multiSelectionProps;
}
function $9bc9293ffbf00f4c$var$useSingleSelection({ ariaLabels: ariaLabels, isItemDisabled: isItemDisabled = ()=>false, onSelectionChange: onSelectionChange, selectedItems: selectedItems = [], selectionType: selectionType, trackBy: trackBy }) {
    // The name assigned to all controls to combine them in a single group.
    const selectionControlName = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)();
    if (selectionType !== "single") return {
        isItemSelected: ()=>false
    };
    // Selection state for individual items.
    const selectedSet = new (0, $30c09cf06b060b34$export$685bf180035d2cea)(trackBy, selectedItems.slice(0, 1));
    const isItemSelected = selectedSet.has.bind(selectedSet);
    const handleToggleItem = (item)=>{
        if (!isItemDisabled(item) && !isItemSelected(item)) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSelectionChange, {
            selectedItems: [
                item
            ]
        });
    };
    return {
        isItemSelected: isItemSelected,
        getItemSelectionProps: (item)=>{
            var _a;
            return {
                name: selectionControlName,
                selectionType: "single",
                disabled: isItemDisabled(item),
                checked: isItemSelected(item),
                onChange: ()=>handleToggleItem(item),
                ariaLabel: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.selectionGroupLabel, (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.itemSelectionLabel) === null || _a === void 0 ? void 0 : _a.call(ariaLabels, {
                    selectedItems: selectedItems
                }, item))
            };
        }
    };
}
function $9bc9293ffbf00f4c$var$useMultiSelection({ ariaLabels: ariaLabels, isItemDisabled: isItemDisabled = ()=>false, items: items, loading: loading, onSelectionChange: onSelectionChange, selectedItems: selectedItems = [], selectionType: selectionType, trackBy: trackBy }) {
    // The name assigned to all controls to combine them in a single group.
    const selectionControlName = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)();
    const [shiftPressed, setShiftPressed] = (0, $acw62.useState)(false);
    const [lastClickedItem, setLastClickedItem] = (0, $acw62.useState)(null);
    if (selectionType !== "multi") return {
        isItemSelected: ()=>false
    };
    // Selection state for individual items.
    const selectedSet = new (0, $30c09cf06b060b34$export$685bf180035d2cea)(trackBy, selectedItems);
    const isItemSelected = selectedSet.has.bind(selectedSet);
    // Derived selection state for all-items checkbox.
    let allItemsDisabled = true;
    let allEnabledItemsSelected = true;
    for (const item of items){
        allItemsDisabled = allItemsDisabled && isItemDisabled(item);
        allEnabledItemsSelected = allEnabledItemsSelected && (isItemSelected(item) || isItemDisabled(item));
    }
    const allItemsCheckboxSelected = selectedItems.length > 0 && allEnabledItemsSelected;
    const allItemsCheckboxIndeterminate = selectedItems.length > 0 && !allEnabledItemsSelected;
    // Shift-selection helpers.
    const itemIndexesMap = new Map();
    items.forEach((item, i)=>itemIndexesMap.set((0, $d5e9c22659308d3d$export$de1681509165dcfe)(trackBy, item), i));
    const getShiftSelectedItems = (item)=>{
        const lastClickedItemIndex = lastClickedItem ? itemIndexesMap.get((0, $d5e9c22659308d3d$export$de1681509165dcfe)(trackBy, lastClickedItem)) : undefined;
        // We use lastClickedItemIndex to determine if filtering/sorting/pagination
        // made previously selected item invisible, therefore we reset state for shift-select.
        if (lastClickedItemIndex !== undefined) {
            const currentItemIndex = itemIndexesMap.get((0, $d5e9c22659308d3d$export$de1681509165dcfe)(trackBy, item));
            const start = Math.min(currentItemIndex, lastClickedItemIndex);
            const end = Math.max(currentItemIndex, lastClickedItemIndex);
            return items.slice(start, end + 1);
        }
        return [
            item
        ];
    };
    // Select items that are not already selected or disabled.
    const selectItems = (requestedItems)=>{
        const newSelectedItems = [
            ...selectedItems
        ];
        requestedItems.forEach((newItem)=>{
            if (!isItemSelected(newItem) && !isItemDisabled(newItem)) newSelectedItems.push(newItem);
        });
        return newSelectedItems;
    };
    // Unselect items unless they are disabled.
    const deselectItems = (requestedItems)=>{
        const requestedItemsSet = new (0, $30c09cf06b060b34$export$685bf180035d2cea)(trackBy, requestedItems);
        const newSelectedItems = [];
        selectedItems.forEach((selectedItem)=>{
            const shouldUnselect = requestedItemsSet.has(selectedItem);
            if (!shouldUnselect || isItemDisabled(selectedItem)) newSelectedItems.push(selectedItem);
        });
        return newSelectedItems;
    };
    const handleToggleAll = ()=>{
        const newSelectedItems = allEnabledItemsSelected ? deselectItems(items) : selectItems(items);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSelectionChange, {
            selectedItems: newSelectedItems
        });
    };
    const handleToggleItem = (item)=>{
        if (!isItemDisabled(item)) {
            const requestedItems = shiftPressed ? getShiftSelectedItems(item) : [
                item
            ];
            const selectedItems = isItemSelected(item) ? deselectItems(requestedItems) : selectItems(requestedItems);
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onSelectionChange, {
                selectedItems: selectedItems
            });
            setLastClickedItem(item);
        }
    };
    return {
        isItemSelected: isItemSelected,
        getSelectAllProps: ()=>{
            var _a;
            return {
                name: selectionControlName,
                selectionType: "multi",
                disabled: allItemsDisabled || !!loading,
                checked: allItemsCheckboxSelected,
                indeterminate: allItemsCheckboxIndeterminate,
                onChange: handleToggleAll,
                ariaLabel: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.selectionGroupLabel, (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.allItemsSelectionLabel) === null || _a === void 0 ? void 0 : _a.call(ariaLabels, {
                    selectedItems: selectedItems
                }))
            };
        },
        getItemSelectionProps: (item)=>{
            var _a;
            return {
                name: selectionControlName,
                selectionType: "multi",
                disabled: isItemDisabled(item),
                checked: isItemSelected(item),
                onChange: ()=>handleToggleItem(item),
                onShiftToggle: (value)=>setShiftPressed(value),
                ariaLabel: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.selectionGroupLabel, (_a = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.itemSelectionLabel) === null || _a === void 0 ? void 0 : _a.call(ariaLabels, {
                    selectedItems: selectedItems
                }, item))
            };
        }
    };
}




function $021f9e20e3ad3309$export$c8a0aa4990d3b09f(selectionType, totalItems) {
    if (selectionType !== "multi") return {};
    function moveFocus(sourceElement, fromIndex, direction) {
        let index = fromIndex;
        const rootContainer = $021f9e20e3ad3309$var$findRootContainer(sourceElement);
        while(index >= -1 && index < totalItems){
            index += direction;
            const control = $021f9e20e3ad3309$var$findSelectionControlByIndex(rootContainer, index);
            if (control && !control.disabled) {
                control.focus();
                break;
            }
        }
    }
    const [moveFocusDown, moveFocusUp] = [
        1,
        -1
    ].map((direction)=>{
        return (event)=>{
            const target = event.currentTarget;
            const itemNode = (0, $38f6480185c49d6f$export$184ef262a758e3c4)(target, (node)=>node.dataset.selectionItem === "item");
            const fromIndex = Array.prototype.indexOf.call(itemNode.parentElement.children, itemNode);
            moveFocus(target, fromIndex, direction);
        };
    });
    return {
        moveFocusDown: moveFocusDown,
        moveFocusUp: moveFocusUp,
        moveFocus: moveFocus
    };
}
function $021f9e20e3ad3309$var$findSelectionControlByIndex(rootContainer, index) {
    if (index === -1) // find "select all" checkbox
    return rootContainer.querySelector(`[data-${(0, $30c09cf06b060b34$export$988c58523d43232b)}="all"] .${(0, $6c95fef02beb4257$export$2e2bcd8739ae039).root} input`);
    return rootContainer.querySelectorAll(`[data-${(0, $30c09cf06b060b34$export$988c58523d43232b)}="item"] .${(0, $6c95fef02beb4257$export$2e2bcd8739ae039).root} input`)[index];
}
function $021f9e20e3ad3309$var$findRootContainer(element) {
    return (0, $38f6480185c49d6f$export$184ef262a758e3c4)(element, (node)=>node.dataset.selectionRoot === "true");
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $00ea7b4995e93369$export$5a6f6c506490de72(refs) {
    const activeElement = (0, $acw62.useRef)(null);
    return (event)=>{
        const targetElement = event.currentTarget;
        // remembers the first element that fires onscroll to align with other elements against it
        if (targetElement && (activeElement.current === null || activeElement.current === targetElement)) requestAnimationFrame(()=>{
            activeElement.current = targetElement;
            refs.forEach((ref)=>{
                const element = ref.current;
                if (element && element !== targetElement) element.scrollLeft = targetElement.scrollLeft;
            });
            // unblock the ability to scroll the synced elements
            requestAnimationFrame(()=>{
                activeElement.current = null;
            });
        });
    };
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $1280f926f00da4a8$export$2e2bcd8739ae039(containerRef, stickyRef) {
    const scrollToTop = ()=>{
        if (!containerRef.current || !stickyRef.current) return;
        const scrollingOffset = $1280f926f00da4a8$export$b68f12a4d6ccd788(containerRef.current, stickyRef.current);
        if (scrollingOffset > 0) $1280f926f00da4a8$export$a6850f124f5f264e(scrollingOffset, containerRef.current);
    };
    const scrollToItem = (item)=>{
        if (!item || !containerRef.current || !stickyRef.current) return;
        const stickyBottom = (0, $558545a5feadf817$export$322fb6cc2f904670)(stickyRef.current).insetBlockEnd;
        const scrollingOffset = stickyBottom - (0, $558545a5feadf817$export$322fb6cc2f904670)(item).insetBlockStart;
        if (scrollingOffset > 0) $1280f926f00da4a8$export$a6850f124f5f264e(scrollingOffset, containerRef.current);
    };
    return {
        scrollToTop: scrollToTop,
        scrollToItem: scrollToItem
    };
}
function $1280f926f00da4a8$export$b68f12a4d6ccd788(container, sticky) {
    const stickyRect = (0, $558545a5feadf817$export$322fb6cc2f904670)(sticky);
    const containerRect = (0, $558545a5feadf817$export$322fb6cc2f904670)(container);
    return stickyRect.insetBlockStart - containerRect.insetBlockStart;
}
function $1280f926f00da4a8$export$a6850f124f5f264e(amount, container) {
    const parent = (0, $24d40242cc6554ee$export$f32edd573b1049e6)(container);
    if (parent.length) // Take next overflow parent in stack
    parent[0].scrollTop -= amount;
    else window.scrollTo({
        top: window.pageYOffset - amount
    });
}




const $45b5dd6b7dd5660c$export$3a5ae2edeb8648ad = (tableRef, theadRef, secondaryTheadRef, secondaryTableRef, tableWrapperRef)=>{
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    // Sync the sizes of the column header copies in the sticky header with the originals
    const syncColumnHeaderWidths = (0, $acw62.useCallback)(()=>{
        if (tableRef.current && theadRef.current && secondaryTheadRef.current && secondaryTableRef.current && tableWrapperRef.current) {
            // Using the tableRef offsetWidth instead of the theadRef because in VR
            // the tableRef adds extra padding to the table and by default the theadRef will have a width
            // without the padding and will make the sticky header width incorrect.
            secondaryTableRef.current.style.inlineSize = `${tableRef.current.offsetWidth}px`;
            tableWrapperRef.current.style.marginBlockStart = `-${theadRef.current.offsetHeight}px`;
        }
    }, [
        theadRef,
        secondaryTheadRef,
        secondaryTableRef,
        tableWrapperRef,
        tableRef
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        syncColumnHeaderWidths();
    });
    (0, $444535e54951fdea$export$683480f191c0e3ea)(theadRef, syncColumnHeaderWidths);
    const scrollToTop = ()=>{
        if (!isMobile && theadRef.current && secondaryTheadRef.current && tableWrapperRef.current) {
            const scrollDist = (0, $1280f926f00da4a8$export$b68f12a4d6ccd788)(theadRef.current, secondaryTheadRef.current);
            if (scrollDist > 0) (0, $1280f926f00da4a8$export$a6850f124f5f264e)(scrollDist, tableWrapperRef.current);
        }
    };
    const { scrollToItem: scrollToItem } = (0, $1280f926f00da4a8$export$2e2bcd8739ae039)(tableWrapperRef, secondaryTheadRef);
    const scrollToRow = (itemNode)=>{
        if (!isMobile) scrollToItem(itemNode);
    };
    return {
        scrollToRow: scrollToRow,
        scrollToTop: scrollToTop
    };
};





var $9c441436201ecd93$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)($9c441436201ecd93$var$StickyHeader);
function $9c441436201ecd93$var$StickyHeader({ variant: variant, theadProps: theadProps, wrapperRef: wrapperRef, theadRef: theadRef, secondaryWrapperRef: secondaryWrapperRef, onScroll: onScroll, tableRef: tableRef, tableHasHeader: tableHasHeader, contentDensity: contentDensity, tableRole: tableRole }, ref) {
    const secondaryTheadRef = (0, $acw62.useRef)(null);
    const secondaryTableRef = (0, $acw62.useRef)(null);
    const { isStuck: isStuck } = (0, $acw62.useContext)((0, $6ffd179a45e998fe$export$277266c55937e104));
    const [focusedComponent, setFocusedComponent] = (0, $acw62.useState)(null);
    const { scrollToRow: scrollToRow, scrollToTop: scrollToTop } = (0, $45b5dd6b7dd5660c$export$3a5ae2edeb8648ad)(tableRef, theadRef, secondaryTheadRef, secondaryTableRef, wrapperRef);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            scrollToTop: scrollToTop,
            scrollToRow: scrollToRow,
            setFocus: setFocusedComponent
        }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039)["header-secondary"], (0, $7ded81c543f72294$export$2e2bcd8739ae039)[`variant-${variant}`], {
            [(0, $7ded81c543f72294$export$2e2bcd8739ae039).stuck]: isStuck,
            [(0, $7ded81c543f72294$export$2e2bcd8739ae039)["table-has-header"]]: tableHasHeader
        }),
        "aria-hidden": true,
        // Prevents receiving focus in Firefox. Focus on the overflowing table is sufficient
        // to scroll the table horizontally
        tabIndex: -1,
        ref: secondaryWrapperRef,
        onScroll: onScroll
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039).table, (0, $7ded81c543f72294$export$2e2bcd8739ae039)["table-layout-fixed"], contentDensity === "compact" && (0, $8856d0c7df08fd8d$export$6c7ba3d6c6708d3)("compact-table")),
        ref: secondaryTableRef
    }, (0, $4724080100e81846$export$2c3bcd6eb50948d4)({
        tableRole: tableRole
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bc555153bc24e36c$export$2e2bcd8739ae039), Object.assign({
        ref: secondaryTheadRef,
        sticky: true,
        stuck: isStuck,
        focusedComponent: focusedComponent
    }, theadProps))));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");
const $796a0d0b43417279$var$useEventListenersSingleton = (0, $0eab7c44803f46fb$export$dcf465db4b1d75b1)((setTarget)=>{
    function handleMouseDown(event) {
        setTarget(event.target);
    }
    function handleKeyDown() {
        setTarget(null);
    }
    window.addEventListener("mousedown", handleMouseDown);
    window.addEventListener("keydown", handleKeyDown);
    return ()=>{
        window.removeEventListener("mousedown", handleMouseDown);
        window.removeEventListener("keydown", handleKeyDown);
    };
});
function $796a0d0b43417279$export$2e2bcd8739ae039() {
    const mouseDownTargetRef = (0, $acw62.useRef)(null);
    $796a0d0b43417279$var$useEventListenersSingleton((target)=>{
        mouseDownTargetRef.current = target;
    });
    return ()=>mouseDownTargetRef.current;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

function $9c34ca8192fcd717$var$iterateTableCells(table, func) {
    table.querySelectorAll("tr").forEach((row, rowIndex)=>{
        row.querySelectorAll("td").forEach((cell, cellIndex)=>{
            func(cell, rowIndex, cellIndex);
        });
    });
}
/**
 * This hook is used to navigate between table cells using the keyboard arrow keys.
 * All the functionality is implemented in the hook, so the table component does not
 * need to implement any keyboard event handlers.
 * @param enable - Toggle functionality of the hook
 * @param tableRoot - A ref to a table container. Ideally the root element of the table (<table>); tbody is also acceptable.
 * @param columnDefinitions - The column definitions for the table.
 * @param numRows - The number of rows in the table.
 */ function $9c34ca8192fcd717$var$useTableFocusNavigation({ enableKeyboardNavigation: enableKeyboardNavigation, selectionType: selectionType, tableRoot: tableRoot, columnDefinitions: columnDefinitions, numRows: numRows }) {
    const focusableColumns = (0, $acw62.useMemo)(()=>{
        const cols = columnDefinitions.map((column)=>!!column.editConfig);
        if (selectionType) cols.unshift(false);
        return cols;
    }, [
        columnDefinitions,
        selectionType
    ]);
    const maxColumnIndex = focusableColumns.length - 1;
    const minColumnIndex = selectionType ? 1 : 0;
    const focusCell = (0, $acw62.useCallback)((rowIndex, columnIndex)=>{
        if (tableRoot === null || tableRoot === void 0 ? void 0 : tableRoot.current) $9c34ca8192fcd717$var$iterateTableCells(tableRoot.current, (cell, rIndex, cIndex)=>{
            var _a;
            if (rIndex === rowIndex && cIndex === columnIndex) {
                const editButton = cell.querySelector("button:last-child");
                if (editButton) {
                    (_a = editButton.focus) === null || _a === void 0 || _a.call(editButton);
                    (0, $24d40242cc6554ee$export$a904af9c1628c179)(editButton);
                }
            }
        });
    }, [
        tableRoot
    ]);
    const shiftFocus = (0, $acw62.useCallback)((vertical, horizontal)=>{
        var _a;
        const focusedCell = (_a = tableRoot.current) === null || _a === void 0 ? void 0 : _a.querySelector("td:focus-within");
        if (!focusedCell) return;
        const columnIndex = focusedCell.cellIndex;
        const rowIndex = focusedCell.parentElement.rowIndex;
        let newRowIndex = rowIndex;
        let newColumnIndex = columnIndex;
        if (vertical !== 0) newRowIndex = Math.min(numRows, Math.max(rowIndex + vertical, 0));
        if (horizontal !== 0) while(newColumnIndex <= maxColumnIndex && newColumnIndex >= minColumnIndex){
            newColumnIndex += horizontal;
            if (focusableColumns[newColumnIndex]) break;
        }
        if ((rowIndex !== newRowIndex || columnIndex !== newColumnIndex) && tableRoot.current) focusCell(newRowIndex, newColumnIndex);
    }, [
        focusCell,
        focusableColumns,
        maxColumnIndex,
        minColumnIndex,
        numRows,
        tableRoot
    ]);
    const handleArrowKeyEvents = (0, $acw62.useCallback)((event)=>{
        var _a, _b;
        const abort = !!((_a = tableRoot.current) === null || _a === void 0 ? void 0 : _a.querySelector('[data-inline-editing-active = "true"]')) || !((_b = document.activeElement) === null || _b === void 0 ? void 0 : _b.closest("[data-inline-editing-active]"));
        if (abort) return;
        switch(event.key){
            case "ArrowUp":
                event.preventDefault();
                shiftFocus(-1, 0);
                break;
            case "ArrowDown":
                event.preventDefault();
                shiftFocus(1, 0);
                break;
            case "ArrowLeft":
                event.preventDefault();
                shiftFocus(0, -1);
                break;
            case "ArrowRight":
                event.preventDefault();
                shiftFocus(0, 1);
                break;
            // istanbul ignore next (default case = do nothing, not testable)
            default:
                return;
        }
    }, [
        shiftFocus,
        tableRoot
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!tableRoot.current || enableKeyboardNavigation) return;
        const tableElement = tableRoot.current;
        tableRoot.current.addEventListener("keydown", handleArrowKeyEvents);
        return ()=>tableElement && tableElement.removeEventListener("keydown", handleArrowKeyEvents);
    }, [
        enableKeyboardNavigation,
        focusableColumns,
        handleArrowKeyEvents,
        tableRoot
    ]);
}
var $9c34ca8192fcd717$export$2e2bcd8739ae039 = $9c34ca8192fcd717$var$useTableFocusNavigation;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");

var $41cfe434a59dd8a5$export$2e2bcd8739ae039 = {
    "sticky-scrollbar": "awsui_sticky-scrollbar_faqt8_xzs7h_97",
    "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_faqt8_xzs7h_106",
    "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_faqt8_xzs7h_109",
    "sticky-scrollbar-native-invisible": "awsui_sticky-scrollbar-native-invisible_faqt8_xzs7h_112",
    "sticky-scrollbar-offset": "awsui_sticky-scrollbar-offset_faqt8_xzs7h_115",
    "is-visual-refresh": "awsui_is-visual-refresh_faqt8_xzs7h_118"
};







const $460a10c54a45b519$export$96612fa32333e1ce = (tableEl, wrapperEl, scrollbarEl, scrollbarContentEl, inScrollableContainer)=>{
    if (!tableEl || !scrollbarEl || !wrapperEl) return;
    const { inlineSize: tableInlineSize } = (0, $558545a5feadf817$export$322fb6cc2f904670)(tableEl);
    const { inlineSize: wrapperInlineSize } = (0, $558545a5feadf817$export$322fb6cc2f904670)(wrapperEl);
    // using 15 px as a height of transparent scrollbar on mac
    const scrollbarHeight = (0, $7b99d3a86137a2e2$export$bbb9ce125c89ccb4)().height;
    const areaIsScrollable = tableInlineSize > wrapperInlineSize;
    if (!areaIsScrollable) scrollbarEl.classList.remove((0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)["sticky-scrollbar-visible"]);
    else {
        // when scrollbar is not displayed scrollLeft property cannot be set by useScrollSync
        // that's why syncing it separately
        if (!scrollbarEl.classList.contains((0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)["sticky-scrollbar-visible"])) requestAnimationFrame(()=>{
            scrollbarEl.scrollLeft = wrapperEl.scrollLeft;
        });
        scrollbarEl.classList.add((0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)["sticky-scrollbar-visible"]);
        if (!scrollbarHeight) /* istanbul ignore next: covered by screenshot tests */ scrollbarEl.classList.add((0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)["sticky-scrollbar-native-invisible"]);
    }
    if (scrollbarHeight && scrollbarEl && scrollbarContentEl) {
        scrollbarEl.style.blockSize = `${scrollbarHeight}px`;
        scrollbarContentEl.style.blockSize = `${scrollbarHeight}px`;
    }
    if (tableEl && wrapperEl && scrollbarContentEl && scrollbarEl) {
        const wrapperElRect = (0, $558545a5feadf817$export$322fb6cc2f904670)(wrapperEl);
        const tableElRect = (0, $558545a5feadf817$export$322fb6cc2f904670)(tableEl);
        scrollbarEl.style.inlineSize = `${wrapperElRect.inlineSize}px`;
        scrollbarContentEl.style.inlineSize = `${tableElRect.inlineSize}px`;
        // when using sticky scrollbars in containers
        // we agreed to ignore dynamic bottom calculations for footer overlap
        scrollbarEl.style.insetBlockEnd = inScrollableContainer ? "0px" : `var(${(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalBottomOffset}, 0px)`;
    }
};
function $460a10c54a45b519$export$43d929acaaebf31b(scrollbarRef, scrollbarContentRef, tableRef, wrapperRef, offsetScrollbar) {
    const [inScrollableContainer, setInScrollableContainer] = (0, $acw62.useState)(false);
    const wrapperEl = wrapperRef.current;
    (0, $acw62.useEffect)(()=>{
        if (wrapperEl) setInScrollableContainer(!!(0, $38f6480185c49d6f$export$940d8225183e1404)(wrapperEl) || !!(0, $24d40242cc6554ee$export$f32edd573b1049e6)(wrapperEl)[0]);
    }, [
        wrapperEl
    ]);
    // Update scrollbar position wrapper or table size change.
    (0, $acw62.useEffect)(()=>{
        if (wrapperRef.current && tableRef.current) {
            const observer = new (0, $ba00521e8d0ae023$export$9caf76241ca21a11)(()=>{
                if (scrollbarContentRef.current) $460a10c54a45b519$export$96612fa32333e1ce(tableRef.current, wrapperRef.current, scrollbarRef.current, scrollbarContentRef.current, inScrollableContainer);
            });
            // Scrollbar width must be in sync with wrapper width.
            observer.observe(wrapperRef.current);
            // Scrollbar content width must be in sync with table width.
            observer.observe(tableRef.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        scrollbarContentRef,
        scrollbarRef,
        tableRef,
        wrapperRef,
        inScrollableContainer,
        offsetScrollbar
    ]);
    // Update scrollbar position when window resizes (vertically).
    (0, $acw62.useEffect)(()=>{
        const resizeHandler = ()=>{
            $460a10c54a45b519$export$96612fa32333e1ce(tableRef.current, wrapperRef.current, scrollbarRef.current, scrollbarContentRef.current, inScrollableContainer);
        };
        resizeHandler();
        window.addEventListener("resize", resizeHandler);
        return ()=>{
            window.removeEventListener("resize", resizeHandler);
        };
    }, [
        tableRef,
        wrapperRef,
        scrollbarRef,
        scrollbarContentRef,
        inScrollableContainer
    ]);
}







var $33348950bdbf3017$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)($33348950bdbf3017$var$StickyScrollbar);
function $33348950bdbf3017$var$StickyScrollbar({ wrapperRef: wrapperRef, tableRef: tableRef, onScroll: onScroll, hasStickyColumns: hasStickyColumns }, ref) {
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const scrollbarRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const scrollbarContentRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(ref, scrollbarRef);
    /**
     * If the height of the scrollbar is 0, we're likely on a platform that uses
     * overlay scrollbars (e.g. Mac).
     */ const offsetScrollbar = hasStickyColumns || (0, $7b99d3a86137a2e2$export$bbb9ce125c89ccb4)().height === 0;
    (0, $460a10c54a45b519$export$43d929acaaebf31b)(scrollbarRef, scrollbarContentRef, tableRef, wrapperRef, offsetScrollbar);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: mergedRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)["sticky-scrollbar"], offsetScrollbar && (0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)["sticky-scrollbar-offset"], isVisualRefresh && (0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)["is-visual-refresh"]),
        onScroll: onScroll
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: scrollbarContentRef,
        className: (0, $41cfe434a59dd8a5$export$2e2bcd8739ae039)["sticky-scrollbar-content"]
    }));
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $f202ce2250b275ba$export$2ec2f91e4944ad3b(element) {
    return element.closest("td,th");
}
function $f202ce2250b275ba$export$a7ebbc3bdaf3b563(element) {
    if (element instanceof HTMLInputElement || element instanceof HTMLButtonElement) return element.disabled;
    return false;
}
function $f202ce2250b275ba$export$4a2080a003dc3d35(target) {
    let current = target;
    while(current){
        // Stop checking for parents upon reaching the cell element as the function only aims at the cell content.
        if ($f202ce2250b275ba$export$3db443afc312b993(current)) return false;
        if (current.getAttribute("role") === "dialog" || current.getAttribute("data-awsui-table-suppress-navigation") === "true") return true;
        current = current.parentElement;
    }
    return false;
}
function $f202ce2250b275ba$export$feb0f5cc536d2180(table, targetAriaRowIndex, delta) {
    var _a;
    let targetRow = null;
    const rowElements = Array.from(table.querySelectorAll("tr[aria-rowindex]"));
    if (delta < 0) rowElements.reverse();
    for (const element of rowElements){
        const rowIndex = parseInt((_a = element.getAttribute("aria-rowindex")) !== null && _a !== void 0 ? _a : "");
        targetRow = element;
        if (rowIndex === targetAriaRowIndex) break;
        if (delta >= 0 && rowIndex > targetAriaRowIndex) break;
        if (delta < 0 && rowIndex < targetAriaRowIndex) break;
    }
    return targetRow;
}
function $f202ce2250b275ba$export$cc5f55dc4367642c(tableRow, targetAriaColIndex, delta) {
    var _a;
    let targetCell = null;
    const cellElements = Array.from(tableRow.querySelectorAll("td[aria-colindex],th[aria-colindex]"));
    if (delta < 0) cellElements.reverse();
    for (const element of cellElements){
        const columnIndex = parseInt((_a = element.getAttribute("aria-colindex")) !== null && _a !== void 0 ? _a : "");
        targetCell = element;
        if (columnIndex === targetAriaColIndex) break;
        if (delta >= 0 && columnIndex > targetAriaColIndex) break;
        if (delta < 0 && columnIndex < targetAriaColIndex) break;
    }
    return targetCell;
}
function $f202ce2250b275ba$export$3db443afc312b993(element) {
    return element.tagName === "TD" || element.tagName === "TH";
}
function $f202ce2250b275ba$export$3b0237e8566c8d65(element) {
    if (element) {
        // Table cells are not focusable by default (tabIndex=undefined) and cell.focus() is ignored.
        // To force focusing we have to imperatively set tabIndex to -1. When focused, the grid navigation
        // will update the tabIndex to 0 if the cell gets focused or set it to undefined if the cell content
        // gets focused instead.
        // We cannot make cells have tabIndex=-1 by default due to an associated bug with text selection, see: PR 2158.
        if ($f202ce2250b275ba$export$3db443afc312b993(element)) element.tabIndex = -1;
        element.focus();
    }
}








function $4fddcc6aec92a0ef$export$15a0a58a360b70b4({ keyboardNavigation: keyboardNavigation, pageSize: pageSize, getTable: getTable, children: children }) {
    const navigationAPI = (0, $acw62.useRef)(null);
    const gridNavigation = (0, $acw62.useMemo)(()=>new $4fddcc6aec92a0ef$var$GridNavigationProcessor(navigationAPI), []);
    const getTableStable = (0, $3bf45ec0c2b54dd9$export$1a8b1350915fe2e0)(getTable);
    // Initialize the processor with the table container assuming it is mounted synchronously and only once.
    (0, $acw62.useEffect)(()=>{
        if (keyboardNavigation) {
            const table = getTableStable();
            table && gridNavigation.init(table);
        }
        return ()=>gridNavigation.cleanup();
    }, [
        keyboardNavigation,
        gridNavigation,
        getTableStable
    ]);
    // Notify the processor of the props change.
    (0, $acw62.useEffect)(()=>{
        gridNavigation.update({
            pageSize: pageSize
        });
    }, [
        gridNavigation,
        pageSize
    ]);
    // Notify the processor of the new render.
    (0, $acw62.useEffect)(()=>{
        if (keyboardNavigation) gridNavigation.refresh();
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7f9661e47bcc5460$export$44f87403d31a265f), {
        ref: navigationAPI,
        navigationActive: keyboardNavigation,
        getNextFocusTarget: gridNavigation.getNextFocusTarget,
        isElementSuppressed: gridNavigation.isElementSuppressed,
        onRegisterFocusable: gridNavigation.onRegisterFocusable,
        onUnregisterFocusable: gridNavigation.onUnregisterFocusable
    }, children);
}
/**
 * This helper encapsulates the grid navigation behaviors which are:
 * 1. Responding to keyboard commands and moving the focus accordingly;
 * 2. Muting table interactive elements for only one to be user-focusable at a time;
 * 3. Suppressing the above behaviors when focusing an element inside a dialog or when instructed explicitly.
 */ class $4fddcc6aec92a0ef$var$GridNavigationProcessor {
    constructor(navigationAPI){
        // Props
        this._pageSize = 0;
        this._table = null;
        // State
        this.focusedCell = null;
        this.keepUserIndex = false;
        this.onRegisterFocusable = (focusableElement)=>{
            var _a;
            // When newly registered element belongs to the focused cell the focus must transition to it.
            const focusedElement = (_a = this.focusedCell) === null || _a === void 0 ? void 0 : _a.element;
            if (focusedElement && (0, $f202ce2250b275ba$export$3db443afc312b993)(focusedElement) && focusedElement.contains(focusableElement)) // Scroll is unnecessary when moving focus from a cell to element within the cell.
            focusableElement.focus({
                preventScroll: true
            });
        };
        this.onUnregisterFocusable = (focusable)=>{
            const isUnregisteringFocusedNode = (0, $4c778684f125e678$export$57d4cb221e1d1857)(focusable, document.activeElement);
            if (isUnregisteringFocusedNode) // Wait for unmounted node to get removed from the DOM.
            setTimeout(()=>{
                // If the focused cell appears to be no longer attached to the table we need to re-apply
                // focus to a cell with the same or closest position.
                if (this.focusedCell && !(0, $4c778684f125e678$export$57d4cb221e1d1857)(this.table, this.focusedCell.element)) this.moveFocusBy(this.focusedCell, {
                    x: 0,
                    y: 0
                });
            }, 0);
        };
        this.getNextFocusTarget = ()=>{
            var _a;
            const cell = this.focusedCell;
            const firstTableCell = this.table.querySelector("td,th");
            // A single element of the table is made user-focusable.
            // It defaults to the first interactive element of the first cell or the first cell itself otherwise.
            let focusTarget = (_a = firstTableCell && this.getFocusablesFrom(firstTableCell)[0]) !== null && _a !== void 0 ? _a : firstTableCell;
            // When a navigation-focused element is present in the table it is used for user-navigation instead.
            if (cell) focusTarget = this.getNextFocusable(cell, {
                x: 0,
                y: 0
            });
            return focusTarget;
        };
        this.isElementSuppressed = (element)=>{
            // Omit calculation as irrelevant until the table receives focus.
            if (!this.focusedCell) return false;
            return !element || (0, $f202ce2250b275ba$export$4a2080a003dc3d35)(element);
        };
        this.onFocusin = (event)=>{
            var _a;
            if (!(event.target instanceof HTMLElement)) return;
            this.updateFocusedCell(event.target);
            if (!this.focusedCell) return;
            (_a = this._navigationAPI.current) === null || _a === void 0 || _a.updateFocusTarget();
            // Focusing on cell is not eligible when it contains focusable elements in the content.
            // If content focusables are available - move the focus to the first one.
            const focusedElement = this.focusedCell.element;
            const nextTarget = (0, $f202ce2250b275ba$export$3db443afc312b993)(focusedElement) ? this.getFocusablesFrom(focusedElement)[0] : null;
            if (nextTarget) // Scroll is unnecessary when moving focus from a cell to element within the cell.
            nextTarget.focus({
                preventScroll: true
            });
            else this.keepUserIndex = false;
        };
        this.onKeydown = (event)=>{
            if (!this.focusedCell) return;
            const keys = [
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).up,
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).down,
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).left,
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).right,
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).pageUp,
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).pageDown,
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).home,
                (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).end
            ];
            const ctrlKey = event.ctrlKey ? 1 : 0;
            const altKey = event.altKey ? 1 : 0;
            const shiftKey = event.shiftKey ? 1 : 0;
            const metaKey = event.metaKey ? 1 : 0;
            const modifiersPressed = ctrlKey + altKey + shiftKey + metaKey;
            const invalidModifierCombination = modifiersPressed && !event.ctrlKey || event.ctrlKey && event.keyCode !== (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).home && event.keyCode !== (0, $bb11bd44b752b968$export$e9e0d96f49f57c33).end;
            if (invalidModifierCombination || this.isElementSuppressed(document.activeElement) || !this.isRegistered(document.activeElement) || keys.indexOf(event.keyCode) === -1) return;
            const from = this.focusedCell;
            event.preventDefault();
            (0, $d790fc2d8f354fdb$export$f11fd8c04cad088d)(event) && (0, $d790fc2d8f354fdb$export$2e2bcd8739ae039)(event, {
                onBlockStart: ()=>this.moveFocusBy(from, {
                        y: -1,
                        x: 0
                    }),
                onBlockEnd: ()=>this.moveFocusBy(from, {
                        y: 1,
                        x: 0
                    }),
                onInlineStart: ()=>this.moveFocusBy(from, {
                        y: 0,
                        x: -1
                    }),
                onInlineEnd: ()=>this.moveFocusBy(from, {
                        y: 0,
                        x: 1
                    }),
                onPageUp: ()=>this.moveFocusBy(from, {
                        y: -this.pageSize,
                        x: 0
                    }),
                onPageDown: ()=>this.moveFocusBy(from, {
                        y: this.pageSize,
                        x: 0
                    }),
                onHome: ()=>event.ctrlKey ? this.moveFocusBy(from, {
                        y: -Infinity,
                        x: -Infinity
                    }) : this.moveFocusBy(from, {
                        y: 0,
                        x: -Infinity
                    }),
                onEnd: ()=>event.ctrlKey ? this.moveFocusBy(from, {
                        y: Infinity,
                        x: Infinity
                    }) : this.moveFocusBy(from, {
                        y: 0,
                        x: Infinity
                    })
            });
        };
        this._navigationAPI = navigationAPI;
    }
    init(table) {
        this._table = table;
        this.table.addEventListener("focusin", this.onFocusin);
        this.table.addEventListener("keydown", this.onKeydown);
        this.cleanup = ()=>{
            this.table.removeEventListener("focusin", this.onFocusin);
            this.table.removeEventListener("keydown", this.onKeydown);
        };
    }
    cleanup() {
    // Do nothing before initialized.
    }
    update({ pageSize: pageSize }) {
        this._pageSize = pageSize;
    }
    refresh() {
        // Timeout ensures the newly rendered content elements are registered.
        setTimeout(()=>{
            var _a, _b;
            if (this._table) {
                // Update focused cell indices in case table rows, columns, or firstIndex change.
                this.updateFocusedCell((_a = this.focusedCell) === null || _a === void 0 ? void 0 : _a.element);
                (_b = this._navigationAPI.current) === null || _b === void 0 || _b.updateFocusTarget();
            }
        }, 0);
    }
    get pageSize() {
        return this._pageSize;
    }
    get table() {
        if (!this._table) throw new Error("Invariant violation: GridNavigationProcessor is used before initialization.");
        return this._table;
    }
    moveFocusBy(cell, delta) {
        // For vertical moves preserve column- and element indices set by user.
        // It allows keeping indices while moving over disabled actions or cells with colspan > 1.
        if (delta.y !== 0 && delta.x === 0) this.keepUserIndex = true;
        (0, $f202ce2250b275ba$export$3b0237e8566c8d65)(this.getNextFocusable(cell, delta));
    }
    isRegistered(element) {
        var _a, _b;
        return !element || ((_b = (_a = this._navigationAPI.current) === null || _a === void 0 ? void 0 : _a.isRegistered(element)) !== null && _b !== void 0 ? _b : false);
    }
    updateFocusedCell(focusedElement) {
        var _a, _b, _c, _d, _e, _f;
        if (!focusedElement) return;
        const cellElement = (0, $f202ce2250b275ba$export$2ec2f91e4944ad3b)(focusedElement);
        const rowElement = cellElement === null || cellElement === void 0 ? void 0 : cellElement.closest("tr");
        if (!cellElement || !rowElement) return;
        const colIndex = parseInt((_a = cellElement.getAttribute("aria-colindex")) !== null && _a !== void 0 ? _a : "");
        const rowIndex = parseInt((_b = rowElement.getAttribute("aria-rowindex")) !== null && _b !== void 0 ? _b : "");
        if (isNaN(colIndex) || isNaN(rowIndex)) return;
        const cellFocusables = this.getFocusablesFrom(cellElement);
        const elementIndex = cellFocusables.indexOf(focusedElement);
        const prevColIndex = (_d = (_c = this.focusedCell) === null || _c === void 0 ? void 0 : _c.colIndex) !== null && _d !== void 0 ? _d : -1;
        const prevElementIndex = (_f = (_e = this.focusedCell) === null || _e === void 0 ? void 0 : _e.elementIndex) !== null && _f !== void 0 ? _f : -1;
        this.focusedCell = {
            rowIndex: rowIndex,
            colIndex: this.keepUserIndex && prevColIndex !== -1 ? prevColIndex : colIndex,
            elementIndex: this.keepUserIndex && prevElementIndex !== -1 ? prevElementIndex : elementIndex,
            element: focusedElement
        };
    }
    getNextFocusable(from, delta) {
        var _a;
        // Find next row to move focus into (can be null if the top/bottom is reached).
        const targetAriaRowIndex = from.rowIndex + delta.y;
        const targetRow = (0, $f202ce2250b275ba$export$feb0f5cc536d2180)(this.table, targetAriaRowIndex, delta.y);
        if (!targetRow) return null;
        // Return next interactive cell content element if available.
        const cellElement = (0, $f202ce2250b275ba$export$2ec2f91e4944ad3b)(from.element);
        const cellFocusables = cellElement ? this.getFocusablesFrom(cellElement) : [];
        const nextElementIndex = from.elementIndex + delta.x;
        const isValidDirection = !!delta.x;
        const isValidIndex = from.elementIndex !== -1 && 0 <= nextElementIndex && nextElementIndex < cellFocusables.length;
        const isTargetDifferent = from.element !== cellFocusables[nextElementIndex];
        if (isValidDirection && isValidIndex && isTargetDifferent) return cellFocusables[nextElementIndex];
        // Find next cell to focus or move focus into (can be null if the left/right edge is reached).
        const targetAriaColIndex = from.colIndex + delta.x;
        const targetCell = (0, $f202ce2250b275ba$export$cc5f55dc4367642c)(targetRow, targetAriaColIndex, delta.x);
        if (!targetCell) return null;
        // When target cell matches the current cell it means we reached the left or right boundary.
        if (targetCell === cellElement && delta.x !== 0) return null;
        const targetCellFocusables = this.getFocusablesFrom(targetCell);
        // When delta.x = 0 keep element index if possible.
        let focusIndex = from.elementIndex;
        // Use first element index when moving to the right or to extreme left.
        if (isFinite(delta.x) && delta.x > 0 || delta.x === -Infinity) focusIndex = 0;
        // Use last element index when moving to the left or to extreme right.
        if (isFinite(delta.x) && delta.x < 0 || delta.x === Infinity) focusIndex = targetCellFocusables.length - 1;
        return (_a = targetCellFocusables[focusIndex]) !== null && _a !== void 0 ? _a : targetCell;
    }
    getFocusablesFrom(target) {
        const isElementRegistered = (element)=>{
            var _a;
            return (_a = this._navigationAPI.current) === null || _a === void 0 ? void 0 : _a.isRegistered(element);
        };
        return (0, $eaddf2de854ee801$export$3fcce23e1e72b35b)(target).filter((el)=>isElementRegistered(el) && !(0, $f202ce2250b275ba$export$a7ebbc3bdaf3b563)(el));
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");

function $85269665d4ad8536$export$91b87deb855561fe({ onCancel: onCancel, onSubmit: onSubmit }) {
    const [currentEditCell, setCurrentEditCell] = (0, $acw62.useState)(null);
    const [lastSuccessfulEditCell, setLastSuccessfulEditCell] = (0, $acw62.useState)(null);
    const [currentEditLoading, setCurrentEditLoading] = (0, $acw62.useState)(false);
    const startEdit = (cellId)=>{
        setLastSuccessfulEditCell(null);
        setCurrentEditCell(cellId);
    };
    const cancelEdit = (0, $acw62.useCallback)(()=>setCurrentEditCell(null), []);
    const completeEdit = (cellId, editCancelled)=>{
        const eventCancelled = (0, $fc537b925f715587$export$d7e1721720edbb03)(onCancel, {});
        if (!eventCancelled) {
            setCurrentEditCell(null);
            if (!editCancelled) setLastSuccessfulEditCell(cellId);
        }
    };
    const checkEditing = ({ rowIndex: rowIndex, colIndex: colIndex })=>rowIndex === (currentEditCell === null || currentEditCell === void 0 ? void 0 : currentEditCell.rowIndex) && colIndex === currentEditCell.colIndex;
    const checkLastSuccessfulEdit = ({ rowIndex: rowIndex, colIndex: colIndex })=>rowIndex === (lastSuccessfulEditCell === null || lastSuccessfulEditCell === void 0 ? void 0 : lastSuccessfulEditCell.rowIndex) && colIndex === lastSuccessfulEditCell.colIndex;
    const submitEdit = onSubmit ? (...args)=>(0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            setCurrentEditLoading(true);
            try {
                yield onSubmit(...args);
            } finally{
                setCurrentEditLoading(false);
            }
        }) : undefined;
    return {
        isLoading: currentEditLoading,
        startEdit: startEdit,
        cancelEdit: cancelEdit,
        checkEditing: checkEditing,
        checkLastSuccessfulEdit: checkLastSuccessfulEdit,
        completeEdit: completeEdit,
        submitEdit: submitEdit
    };
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");




function $71cec865b9338494$export$c73ef76fcb96862d({ totalColumnsCount: totalColumnsCount, hasFooter: hasFooter, loading: loading, loadingText: loadingText, empty: empty, tableRef: tableRef, containerRef: containerRef }) {
    const cellContentRef = (0, $acw62.useRef)(null);
    (0, $444535e54951fdea$export$683480f191c0e3ea)(containerRef, ({ contentBoxWidth: containerInlineSize })=>{
        if (tableRef.current && cellContentRef.current) {
            const tablePaddingInlineStart = parseFloat(getComputedStyle(tableRef.current).paddingInlineStart) || 0;
            const tablePaddingInlineEnd = parseFloat(getComputedStyle(tableRef.current).paddingInlineEnd) || 0;
            const inlineSize = containerInlineSize + tablePaddingInlineStart + tablePaddingInlineEnd;
            cellContentRef.current.style.inlineSize = Math.floor(inlineSize) + "px";
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
        colSpan: totalColumnsCount,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039)["cell-merged"], hasFooter && (0, $7ded81c543f72294$export$2e2bcd8739ae039)["has-footer"])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: cellContentRef,
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)["cell-merged-content"],
        "data-awsui-table-suppress-navigation": true
    }, loading ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ffdf6cc8746b93a$export$2e2bcd8739ae039), {
        type: "loading",
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039).loading,
        wrapText: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), {
        visible: true
    }, loadingText)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039).empty
    }, empty)));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



function $7214aee332d974de$export$fce377726b938a2f({ items: items, expandableRows: expandableRows, trackBy: trackBy, ariaLabels: ariaLabels }) {
    var _a;
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("table");
    const isExpandable = !!expandableRows;
    const expandedSet = new (0, $30c09cf06b060b34$export$685bf180035d2cea)(trackBy, (_a = expandableRows === null || expandableRows === void 0 ? void 0 : expandableRows.expandedItems) !== null && _a !== void 0 ? _a : []);
    let allItems = items;
    const itemToDetail = new Map();
    const getItemLevel = (item)=>{
        var _a, _b;
        return (_b = (_a = itemToDetail.get(item)) === null || _a === void 0 ? void 0 : _a.level) !== null && _b !== void 0 ? _b : 0;
    };
    if (isExpandable) {
        const visibleItems = new Array();
        const traverse = (item, detail)=>{
            const children = expandableRows.getItemChildren(item);
            itemToDetail.set(item, Object.assign(Object.assign({}, detail), {
                children: children
            }));
            visibleItems.push(item);
            if (expandedSet.has(item)) children.forEach((child, index)=>traverse(child, {
                    level: detail.level + 1,
                    setSize: children.length,
                    posInSet: index + 1,
                    parent: item
                }));
        };
        items.forEach((item, index)=>traverse(item, {
                level: 1,
                setSize: items.length,
                posInSet: index + 1,
                parent: null
            }));
        for(let index = 0; index < visibleItems.length; index++){
            const item = visibleItems[index];
            if (expandedSet.has(item)) {
                let insertionIndex = index + 1;
                for(insertionIndex; insertionIndex < visibleItems.length; insertionIndex++){
                    const insertionItem = visibleItems[insertionIndex];
                    if (getItemLevel(item) >= getItemLevel(insertionItem)) break;
                }
                insertionIndex--;
            }
        }
        allItems = visibleItems;
    }
    const getExpandableItemProps = (item)=>{
        var _a, _b, _c, _d;
        const { level: level = 1, setSize: setSize = 1, posInSet: posInSet = 1, parent: parent = null, children: children = [] } = (_a = itemToDetail.get(item)) !== null && _a !== void 0 ? _a : {};
        return {
            level: level,
            setSize: setSize,
            posInSet: posInSet,
            isExpandable: (_b = expandableRows === null || expandableRows === void 0 ? void 0 : expandableRows.isItemExpandable(item)) !== null && _b !== void 0 ? _b : true,
            isExpanded: expandedSet.has(item),
            onExpandableItemToggle: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(expandableRows === null || expandableRows === void 0 ? void 0 : expandableRows.onExpandableItemToggle, {
                    item: item,
                    expanded: !expandedSet.has(item)
                }),
            expandButtonLabel: i18n("ariaLabels.expandButtonLabel", (_c = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.expandButtonLabel) === null || _c === void 0 ? void 0 : _c.call(ariaLabels, item)),
            collapseButtonLabel: i18n("ariaLabels.collapseButtonLabel", (_d = ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.collapseButtonLabel) === null || _d === void 0 ? void 0 : _d.call(ariaLabels, item)),
            parent: parent,
            children: children
        };
    };
    return {
        isExpandable: isExpandable,
        allItems: allItems,
        getExpandableItemProps: getExpandableItemProps
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $d2dc99a12da72318$export$2e2bcd8739ae039 = {
    "items-loader": "awsui_items-loader_115pt_16l07_5"
};





function $85eff45af97fd1d6$export$2e59eb877e0e85de({ item: item, loadingStatus: loadingStatus, renderLoaderPending: renderLoaderPending, renderLoaderLoading: renderLoaderLoading, renderLoaderError: renderLoaderError, trackBy: trackBy }) {
    let content = null;
    if (loadingStatus === "pending" && renderLoaderPending) content = renderLoaderPending({
        item: item
    });
    else if (loadingStatus === "loading" && renderLoaderLoading) content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), {
        visible: true
    }, renderLoaderLoading({
        item: item
    }));
    else if (loadingStatus === "error" && renderLoaderError) content = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), {
        visible: true
    }, renderLoaderError({
        item: item
    }));
    else (0, $dd646455762bc7b9$export$5b28268982f175ba)("Table", "Must define `renderLoaderPending`, `renderLoaderLoading`, or `renderLoaderError` when using corresponding loading status.");
    let parentTrackId = item && trackBy ? (0, $d5e9c22659308d3d$export$d4f0c8fa4d4f6c97)(trackBy, item) : undefined;
    parentTrackId = typeof parentTrackId === "string" ? parentTrackId : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-root": item ? "false" : "true",
        "data-parentrow": parentTrackId,
        className: (0, $d2dc99a12da72318$export$2e2bcd8739ae039)["items-loader"]
    }, content);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function $21c8ce7a53dfba27$export$6bc816ed4d0c9912({ items: items, getLoadingStatus: getLoadingStatus, getExpandableItemProps: getExpandableItemProps }) {
    // The rows are either data or loader.
    // A loader row can be added to the root level (level=0) in which case it has no associated item (item=null).
    // Loader rows can be added to expandable rows (level>0) in which case they have an associated item (item!=null).
    // The "from" property of the loader row is the index of the first item to be loaded starting 0. It is used to generate unique React keys.
    const allRows = new Array();
    const getItemParent = (item)=>getExpandableItemProps(item).parent;
    const getItemChildren = (item)=>getExpandableItemProps(item).children;
    const getItemLevel = (item)=>item ? getExpandableItemProps(item).level : 0;
    const isItemExpanded = (item)=>getExpandableItemProps(item).isExpanded;
    for(let i = 0; i < items.length; i++){
        allRows.push({
            type: "data",
            item: items[i]
        });
        // Insert empty expandable item loader
        if (isItemExpanded(items[i]) && getItemChildren(items[i]).length === 0) {
            const status = getLoadingStatus === null || getLoadingStatus === void 0 ? void 0 : getLoadingStatus(items[i]);
            if (status && (status === "loading" || status === "error")) allRows.push({
                type: "loader",
                item: items[i],
                level: getItemLevel(items[i]),
                status: status,
                from: 0
            });
            else (0, $dd646455762bc7b9$export$5b28268982f175ba)("Table", 'Expanded items without children must have "loading" or "error" loading status.');
        }
        // Insert expandable items loaders
        let currentParent = getItemParent(items[i]);
        let levelsDiff = getItemLevel(items[i]) - getItemLevel(items[i + 1]);
        while(currentParent && levelsDiff > 0){
            const status = getLoadingStatus === null || getLoadingStatus === void 0 ? void 0 : getLoadingStatus(currentParent);
            if (status && status !== "finished") {
                const level = currentParent ? getItemLevel(currentParent) : 0;
                const children = currentParent ? getItemChildren(currentParent) : [];
                allRows.push({
                    type: "loader",
                    item: currentParent,
                    level: level,
                    status: status,
                    from: children.length
                });
            }
            currentParent = currentParent && getItemParent(currentParent);
            levelsDiff--;
        }
        // Insert root loader
        const rootLoadingStatus = getLoadingStatus === null || getLoadingStatus === void 0 ? void 0 : getLoadingStatus(null);
        if (i === items.length - 1 && rootLoadingStatus && rootLoadingStatus !== "finished") allRows.push({
            type: "loader",
            item: null,
            level: 0,
            status: rootLoadingStatus,
            from: items.length
        });
    }
    return {
        allRows: allRows
    };
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


/*
If the last user interaction is more than this time ago, it is not considered
to be the cause of the current loading state.
*/ const $d455eb7d4e18ed2a$var$USER_ACTION_TIME_LIMIT = 1000;
function $d455eb7d4e18ed2a$export$4141b24171098aae({ itemCount: itemCount, instanceIdentifier: instanceIdentifier, getComponentIdentifier: getComponentIdentifier, loading: loading = false }) {
    const lastUserAction = (0, $acw62.useRef)(null);
    const capturedUserAction = (0, $acw62.useRef)(null);
    const loadingStartTime = (0, $acw62.useRef)(null);
    const metadata = (0, $acw62.useRef)({
        itemCount: itemCount,
        getComponentIdentifier: getComponentIdentifier
    });
    metadata.current = {
        itemCount: itemCount,
        getComponentIdentifier: getComponentIdentifier
    };
    (0, $acw62.useEffect)(()=>{
        if (loading) {
            loadingStartTime.current = performance.now();
            if (lastUserAction.current && lastUserAction.current.time > performance.now() - $d455eb7d4e18ed2a$var$USER_ACTION_TIME_LIMIT) capturedUserAction.current = lastUserAction.current.name;
            else capturedUserAction.current = null;
        }
    }, [
        loading
    ]);
    (0, $134bbee1801695be$export$21dfe79102a9caab)(()=>{
        var _a;
        if (!loading && loadingStartTime.current !== null) {
            const loadingDuration = performance.now() - loadingStartTime.current;
            loadingStartTime.current = null;
            (0, $54d511b0978bc73c$export$68015ba807c17f26).tableInteraction({
                userAction: (_a = capturedUserAction.current) !== null && _a !== void 0 ? _a : "",
                interactionTime: Math.round(loadingDuration),
                interactionMetadata: undefined,
                componentIdentifier: metadata.current.getComponentIdentifier(),
                instanceIdentifier: instanceIdentifier,
                noOfResourcesInTable: metadata.current.itemCount
            });
        }
    }, [
        instanceIdentifier,
        loading
    ]);
    return {
        setLastUserAction: (name)=>void (lastUserAction.current = {
                name: name,
                time: performance.now()
            })
    };
}


const $232ec668ec974363$var$GRID_NAVIGATION_PAGE_SIZE = 10;
const $232ec668ec974363$var$SELECTION_COLUMN_WIDTH = 54;
const $232ec668ec974363$var$selectionColumnId = Symbol("selection-column-id");
const $232ec668ec974363$export$38570466636a45db = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { funnelSubStepProps: funnelSubStepProps } = (0, $777318d005be2fce$export$eaa6680ad4907dec)();
    const tableProps = Object.assign(Object.assign({}, props), {
        __funnelSubStepProps: funnelSubStepProps
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($232ec668ec974363$var$InternalTable, Object.assign({}, tableProps, {
        ref: ref
    }));
});
const $232ec668ec974363$var$InternalTable = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var _b, _c, _d;
    var { header: header, footer: footer, empty: empty, filter: filter, pagination: pagination, preferences: preferences, items: items, columnDefinitions: columnDefinitions, trackBy: trackBy, loading: loading, loadingText: loadingText, selectionType: selectionType, selectedItems: selectedItems, isItemDisabled: isItemDisabled, ariaLabels: ariaLabels, onSelectionChange: onSelectionChange, onSortingChange: onSortingChange, sortingColumn: sortingColumn, sortingDescending: sortingDescending, sortingDisabled: sortingDisabled, visibleColumns: visibleColumns, stickyHeader: stickyHeader, stickyHeaderVerticalOffset: stickyHeaderVerticalOffset, onRowClick: onRowClick, onRowContextMenu: onRowContextMenu, wrapLines: wrapLines, stripedRows: stripedRows, contentDensity: contentDensity, submitEdit: submitEdit, onEditCancel: onEditCancel, resizableColumns: resizableColumns, onColumnWidthsChange: onColumnWidthsChange, variant: variant, __internalRootRef: __internalRootRef, totalItemsCount: totalItemsCount, firstIndex: firstIndex, renderAriaLive: renderAriaLive, stickyColumns: stickyColumns, columnDisplay: columnDisplay, enableKeyboardNavigation: enableKeyboardNavigation, expandableRows: expandableRows, getLoadingStatus: getLoadingStatus, renderLoaderPending: renderLoaderPending, renderLoaderLoading: renderLoaderLoading, renderLoaderError: renderLoaderError, __funnelSubStepProps: __funnelSubStepProps } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "header",
        "footer",
        "empty",
        "filter",
        "pagination",
        "preferences",
        "items",
        "columnDefinitions",
        "trackBy",
        "loading",
        "loadingText",
        "selectionType",
        "selectedItems",
        "isItemDisabled",
        "ariaLabels",
        "onSelectionChange",
        "onSortingChange",
        "sortingColumn",
        "sortingDescending",
        "sortingDisabled",
        "visibleColumns",
        "stickyHeader",
        "stickyHeaderVerticalOffset",
        "onRowClick",
        "onRowContextMenu",
        "wrapLines",
        "stripedRows",
        "contentDensity",
        "submitEdit",
        "onEditCancel",
        "resizableColumns",
        "onColumnWidthsChange",
        "variant",
        "__internalRootRef",
        "totalItemsCount",
        "firstIndex",
        "renderAriaLive",
        "stickyColumns",
        "columnDisplay",
        "enableKeyboardNavigation",
        "expandableRows",
        "getLoadingStatus",
        "renderLoaderPending",
        "renderLoaderLoading",
        "renderLoaderError",
        "__funnelSubStepProps"
    ]);
    // Keyboard navigation defaults to `true` for tables with expandable rows.
    if (expandableRows && enableKeyboardNavigation === undefined) enableKeyboardNavigation = true;
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const prevStickyHeader = (0, $adcc0ef515e81249$export$5cae361ad82dce8b)(stickyHeader);
    if (prevStickyHeader !== undefined && !!stickyHeader !== !!prevStickyHeader) (0, $dd646455762bc7b9$export$5b28268982f175ba)("Table", `\`stickyHeader\` has changed from "${prevStickyHeader}" to "${stickyHeader}". It is not recommended to change the value of this property during the component lifecycle. Please set it to either "true" or "false" unconditionally.`);
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const { isExpandable: isExpandable, allItems: allItems, getExpandableItemProps: getExpandableItemProps } = (0, $7214aee332d974de$export$fce377726b938a2f)({
        items: items,
        expandableRows: expandableRows,
        trackBy: trackBy,
        ariaLabels: ariaLabels
    });
    const { allRows: allRows } = (0, $21c8ce7a53dfba27$export$6bc816ed4d0c9912)({
        items: allItems,
        getLoadingStatus: getLoadingStatus,
        getExpandableItemProps: getExpandableItemProps
    });
    const [containerWidth, wrapperMeasureRef] = (0, $6e052e2d296ab854$export$2e2bcd8739ae039)((rect)=>rect.contentBoxWidth);
    const wrapperMeasureRefObject = (0, $acw62.useRef)(null);
    const wrapperMeasureMergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(wrapperMeasureRef, wrapperMeasureRefObject);
    const [tableWidth, tableMeasureRef] = (0, $6e052e2d296ab854$export$2e2bcd8739ae039)((rect)=>rect.contentBoxWidth);
    const tableRefObject = (0, $acw62.useRef)(null);
    const secondaryWrapperRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const theadRef = (0, $acw62.useRef)(null);
    const stickyHeaderRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const scrollbarRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const _e = (0, $85269665d4ad8536$export$91b87deb855561fe)({
        onCancel: onEditCancel,
        onSubmit: submitEdit
    }), { cancelEdit: cancelEdit } = _e, cellEditing = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_e, [
        "cancelEdit"
    ]);
    /* istanbul ignore next: performance marks do not work in JSDOM */ const getHeaderText = ()=>{
        var _a, _b, _c, _d;
        return (_c = (_b = (_a = toolsHeaderPerformanceMarkRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`.${(0, $962e3f40ddca05f8$export$2e2bcd8739ae039)["heading-text"]}`)) === null || _b === void 0 ? void 0 : _b.innerText) !== null && _c !== void 0 ? _c : (_d = toolsHeaderPerformanceMarkRef.current) === null || _d === void 0 ? void 0 : _d.innerText;
    };
    const performanceMarkAttributes = (0, $d1a7bb38399fdadf$export$2ea7ecdb51f088f5)("table", true, tableRefObject, ()=>({
            loading: loading !== null && loading !== void 0 ? loading : false,
            header: getHeaderText()
        }), [
        loading
    ]);
    const analyticsMetadata = (0, $75a0355e989dd450$export$dba32c398c4b8fa1)(rest);
    const { setLastUserAction: setLastUserAction } = (0, $d455eb7d4e18ed2a$export$4141b24171098aae)({
        loading: loading,
        instanceIdentifier: analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.instanceIdentifier,
        itemCount: items.length,
        getComponentIdentifier: getHeaderText
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        var _a;
        return {
            scrollToTop: ((_a = stickyHeaderRef.current) === null || _a === void 0 ? void 0 : _a.scrollToTop) || (()=>undefined),
            cancelEdit: cancelEdit
        };
    }, [
        cancelEdit
    ]);
    const wrapperRefObject = (0, $acw62.useRef)(null);
    const handleScroll = (0, $00ea7b4995e93369$export$5a6f6c506490de72)([
        wrapperRefObject,
        scrollbarRef,
        secondaryWrapperRef
    ]);
    const { moveFocusDown: moveFocusDown, moveFocusUp: moveFocusUp, moveFocus: moveFocus } = (0, $021f9e20e3ad3309$export$c8a0aa4990d3b09f)(selectionType, allItems.length);
    const { onRowClickHandler: onRowClickHandler, onRowContextMenuHandler: onRowContextMenuHandler } = (0, $28a501d6671417e8$export$48c69dbc46986321)({
        onRowClick: onRowClick,
        onRowContextMenu: onRowContextMenu
    });
    const visibleColumnDefinitions = (0, $d5e9c22659308d3d$export$814232dd3a440b46)({
        columnDefinitions: columnDefinitions,
        columnDisplay: columnDisplay,
        visibleColumns: visibleColumns
    });
    const { isItemSelected: isItemSelected, getSelectAllProps: getSelectAllProps, getItemSelectionProps: getItemSelectionProps } = (0, $9bc9293ffbf00f4c$export$a97c3cc4bf1da1ca)({
        items: allItems,
        trackBy: trackBy,
        selectedItems: selectedItems,
        selectionType: selectionType,
        isItemDisabled: isItemDisabled,
        onSelectionChange: onSelectionChange,
        ariaLabels: ariaLabels,
        loading: loading
    });
    const isRowSelected = (row)=>row.type === "data" && isItemSelected(row.item);
    if (0, $bf737c197e11d40f$export$df77466336fe5355) {
        if (resizableColumns) (0, $6208ed25859b543f$export$9ef7e4997c031fc0)(columnDefinitions);
        if (sortingColumn === null || sortingColumn === void 0 ? void 0 : sortingColumn.sortingComparator) (0, $d5e9c22659308d3d$export$8490691ec4e40f0d)(columnDefinitions, sortingColumn.sortingComparator);
    }
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const computedVariant = isVisualRefresh ? variant : [
        "embedded",
        "full-page"
    ].indexOf(variant) > -1 ? "container" : variant;
    const hasHeader = !!(header || filter || pagination || preferences);
    const hasSelection = !!selectionType;
    const hasFooterPagination = isMobile && variant === "full-page" && !!pagination;
    const hasFooter = !!footer || hasFooterPagination;
    const headerIdRef = (0, $acw62.useRef)(undefined);
    const isLabelledByHeader = !(ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tableLabel) && !!header;
    const ariaLabelledby = isLabelledByHeader && headerIdRef.current ? headerIdRef.current : undefined;
    const setHeaderRef = (0, $acw62.useCallback)((id)=>{
        headerIdRef.current = id;
    }, []);
    const visibleColumnWidthsWithSelection = [];
    const visibleColumnIdsWithSelection = [];
    if (hasSelection) {
        visibleColumnWidthsWithSelection.push({
            id: $232ec668ec974363$var$selectionColumnId,
            width: $232ec668ec974363$var$SELECTION_COLUMN_WIDTH
        });
        visibleColumnIdsWithSelection.push($232ec668ec974363$var$selectionColumnId);
    }
    for(let columnIndex = 0; columnIndex < visibleColumnDefinitions.length; columnIndex++){
        const columnId = (0, $d5e9c22659308d3d$export$480219a02f196e72)(visibleColumnDefinitions[columnIndex], columnIndex);
        visibleColumnWidthsWithSelection.push(Object.assign(Object.assign({}, visibleColumnDefinitions[columnIndex]), {
            id: columnId
        }));
        visibleColumnIdsWithSelection.push(columnId);
    }
    const stickyState = (0, $b00a9e41f83b2a0f$export$fa628f01ec57be39)({
        visibleColumns: visibleColumnIdsWithSelection,
        stickyColumnsFirst: ((_b = stickyColumns === null || stickyColumns === void 0 ? void 0 : stickyColumns.first) !== null && _b !== void 0 ? _b : 0) + ((stickyColumns === null || stickyColumns === void 0 ? void 0 : stickyColumns.first) && hasSelection ? 1 : 0),
        stickyColumnsLast: (stickyColumns === null || stickyColumns === void 0 ? void 0 : stickyColumns.last) || 0
    });
    const hasStickyColumns = !!(((_c = stickyColumns === null || stickyColumns === void 0 ? void 0 : stickyColumns.first) !== null && _c !== void 0 ? _c : 0) + ((_d = stickyColumns === null || stickyColumns === void 0 ? void 0 : stickyColumns.last) !== null && _d !== void 0 ? _d : 0) > 0);
    const hasEditableCells = !!columnDefinitions.find((col)=>col.editConfig);
    let tableRole = "table";
    if (isExpandable) tableRole = "treegrid";
    else if (enableKeyboardNavigation) tableRole = "grid";
    else if (hasEditableCells) tableRole = "grid-default";
    const theadProps = {
        selectionType: selectionType,
        getSelectAllProps: getSelectAllProps,
        columnDefinitions: visibleColumnDefinitions,
        variant: computedVariant,
        wrapLines: wrapLines,
        resizableColumns: resizableColumns,
        sortingColumn: sortingColumn,
        sortingDisabled: sortingDisabled,
        sortingDescending: sortingDescending,
        onSortingChange: onSortingChange,
        onFocusMove: moveFocus,
        onResizeFinish (newWidth) {
            const widthsDetail = columnDefinitions.map((column, index)=>newWidth.get((0, $d5e9c22659308d3d$export$480219a02f196e72)(column, index)) || column.width || (0, $52cd48af6d6570d7$export$7c3f559e2ca95fa));
            const widthsChanged = widthsDetail.some((width, index)=>columnDefinitions[index].width !== width);
            if (widthsChanged) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onColumnWidthsChange, {
                widths: widthsDetail
            });
        },
        singleSelectionHeaderAriaLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.selectionGroupLabel,
        resizerRoleDescription: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.resizerRoleDescription,
        stripedRows: stripedRows,
        stickyState: stickyState,
        selectionColumnId: $232ec668ec974363$var$selectionColumnId,
        tableRole: tableRole,
        isExpandable: isExpandable,
        setLastUserAction: setLastUserAction
    };
    const wrapperRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(wrapperRefObject, stickyState.refs.wrapper);
    const tableRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(tableMeasureRef, tableRefObject, stickyState.refs.table);
    const wrapperProps = (0, $4724080100e81846$export$9facfa3a9b67cdc8)({
        tableRole: tableRole,
        isScrollable: !!(tableWidth && containerWidth && tableWidth > containerWidth),
        ariaLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tableLabel,
        ariaLabelledby: ariaLabelledby
    });
    const getMouseDownTarget = (0, $796a0d0b43417279$export$2e2bcd8739ae039)();
    (0, $9c34ca8192fcd717$export$2e2bcd8739ae039)({
        enableKeyboardNavigation: enableKeyboardNavigation,
        selectionType: selectionType,
        tableRoot: tableRefObject,
        columnDefinitions: visibleColumnDefinitions,
        numRows: allRows === null || allRows === void 0 ? void 0 : allRows.length
    });
    const toolsHeaderPerformanceMarkRef = (0, $acw62.useRef)(null);
    // If is mobile, we take into consideration the AppLayout's mobile bar and we subtract the tools wrapper height so only the table header is sticky
    const [toolsHeaderHeight, toolsHeaderWrapperMeasureRef] = (0, $6e052e2d296ab854$export$2e2bcd8739ae039)((rect)=>rect.borderBoxHeight);
    const toolsHeaderWrapper = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(toolsHeaderPerformanceMarkRef, toolsHeaderWrapperMeasureRef);
    const colIndexOffset = selectionType ? 1 : 0;
    const totalColumnsCount = visibleColumnDefinitions.length + colIndexOffset;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9699df5a060a9c12$export$366cdc6257b696ef).Provider, {
        value: {
            defaultVariant: "primary"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $52cd48af6d6570d7$export$9b0658a77dfa159c), {
        visibleColumns: visibleColumnWidthsWithSelection,
        resizableColumns: resizableColumns,
        containerRef: wrapperMeasureRefObject
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc8a25d23ca8ebd0$export$2e2bcd8739ae039), Object.assign({}, baseProps, {
        __internalRootRef: __internalRootRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $7ded81c543f72294$export$2e2bcd8739ae039).root),
        __funnelSubStepProps: __funnelSubStepProps,
        __fullPage: variant === "full-page",
        header: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, hasHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: toolsHeaderWrapper,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039)["header-controls"], (0, $7ded81c543f72294$export$2e2bcd8739ae039)[`variant-${computedVariant}`])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e52d1d829dbf9fa$export$85b6faccd4f04314).Provider, {
            value: {
                assignId: setHeaderRef
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d7e99db5d46311b5$export$2e2bcd8739ae039), {
            header: header,
            filter: filter,
            pagination: pagination,
            preferences: preferences,
            setLastUserAction: setLastUserAction
        })))), stickyHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c441436201ecd93$export$2e2bcd8739ae039), {
            ref: stickyHeaderRef,
            variant: computedVariant,
            theadProps: theadProps,
            wrapperRef: wrapperRefObject,
            theadRef: theadRef,
            secondaryWrapperRef: secondaryWrapperRef,
            tableRef: tableRefObject,
            onScroll: handleScroll,
            tableHasHeader: hasHeader,
            contentDensity: contentDensity,
            tableRole: tableRole
        })),
        disableHeaderPaddings: true,
        disableContentPaddings: true,
        variant: (0, $d5e9c22659308d3d$export$9704772993b3cb14)(computedVariant),
        __disableFooterPaddings: true,
        __disableFooterDivider: true,
        __disableStickyMobile: false,
        footer: hasFooter ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039)["footer-wrapper"], (0, $7ded81c543f72294$export$2e2bcd8739ae039)[`variant-${computedVariant}`])
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039).footer, hasFooterPagination && (0, $7ded81c543f72294$export$2e2bcd8739ae039)["footer-with-pagination"])
        }, footer && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, footer), hasFooterPagination && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)["footer-pagination"]
        }, pagination))) : null,
        __stickyHeader: stickyHeader,
        __mobileStickyOffset: toolsHeaderHeight !== null && toolsHeaderHeight !== void 0 ? toolsHeaderHeight : 0,
        __stickyOffset: stickyHeaderVerticalOffset
    }, (0, $30c09cf06b060b34$export$abdbebe48aa0774a).root), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: wrapperRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039).wrapper, (0, $7ded81c543f72294$export$2e2bcd8739ae039)[`variant-${computedVariant}`], {
            [(0, $7ded81c543f72294$export$2e2bcd8739ae039)["has-footer"]]: hasFooter,
            [(0, $7ded81c543f72294$export$2e2bcd8739ae039)["has-header"]]: hasHeader
        }),
        style: stickyState.style.wrapper,
        onScroll: handleScroll
    }, wrapperProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)["wrapper-content-measure"],
        ref: wrapperMeasureMergedRef
    }), !!renderAriaLive && !!firstIndex && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, renderAriaLive({
        firstIndex: firstIndex,
        lastIndex: firstIndex + items.length - 1,
        visibleItemsCount: allItems.length,
        totalItemsCount: totalItemsCount
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4fddcc6aec92a0ef$export$15a0a58a360b70b4), {
        keyboardNavigation: !!enableKeyboardNavigation,
        pageSize: $232ec668ec974363$var$GRID_NAVIGATION_PAGE_SIZE,
        getTable: ()=>tableRefObject.current
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", Object.assign({}, performanceMarkAttributes, {
        ref: tableRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039).table, resizableColumns && (0, $7ded81c543f72294$export$2e2bcd8739ae039)["table-layout-fixed"], contentDensity === "compact" && (0, $8856d0c7df08fd8d$export$6c7ba3d6c6708d3)("compact-table"))
    }, (0, $4724080100e81846$export$2c3bcd6eb50948d4)({
        tableRole: tableRole,
        totalItemsCount: totalItemsCount,
        totalColumnsCount: totalColumnsCount,
        ariaLabel: ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.tableLabel,
        ariaLabelledby: ariaLabelledby
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bc555153bc24e36c$export$2e2bcd8739ae039), Object.assign({
        ref: theadRef,
        hidden: stickyHeader,
        onFocusedComponentChange: (focusId)=>{
            var _a;
            return (_a = stickyHeaderRef.current) === null || _a === void 0 ? void 0 : _a.setFocus(focusId);
        }
    }, theadProps)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, loading || allItems.length === 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $71cec865b9338494$export$c73ef76fcb96862d), {
        totalColumnsCount: totalColumnsCount,
        hasFooter: hasFooter,
        loading: loading,
        loadingText: loadingText,
        empty: empty,
        tableRef: tableRefObject,
        containerRef: wrapperMeasureRefObject
    })) : allRows.map((row, rowIndex)=>{
        const isFirstRow = rowIndex === 0;
        const isLastRow = rowIndex === allRows.length - 1;
        const expandableProps = row.type === "data" ? getExpandableItemProps(row.item) : undefined;
        const rowRoleProps = (0, $4724080100e81846$export$70749aa7430746bc)(Object.assign({
            tableRole: tableRole,
            firstIndex: firstIndex,
            rowIndex: rowIndex,
            level: row.type === "loader" ? row.level : undefined
        }, expandableProps));
        const getTableItemKey = (item)=>(0, $d5e9c22659308d3d$export$424834ba1b0663bc)(trackBy, item, rowIndex);
        const sharedCellProps = {
            isVisualRefresh: isVisualRefresh,
            isFirstRow: isFirstRow,
            isLastRow: isLastRow,
            isSelected: hasSelection && isRowSelected(row),
            isPrevSelected: hasSelection && !isFirstRow && isRowSelected(allRows[rowIndex - 1]),
            isNextSelected: hasSelection && !isLastRow && isRowSelected(allRows[rowIndex + 1]),
            isEvenRow: rowIndex % 2 === 0,
            stripedRows: stripedRows,
            hasSelection: hasSelection,
            hasFooter: hasFooter,
            stickyState: stickyState,
            tableRole: tableRole
        };
        if (row.type === "data") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", Object.assign({
            key: getTableItemKey(row.item),
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $7ded81c543f72294$export$2e2bcd8739ae039).row, sharedCellProps.isSelected && (0, $7ded81c543f72294$export$2e2bcd8739ae039)["row-selected"]),
            onFocus: ({ currentTarget: currentTarget })=>{
                var _a;
                // When an element inside table row receives focus we want to adjust the scroll.
                // However, that behaviour is unwanted when the focus is received as result of a click
                // as it causes the click to never reach the target element.
                if (!currentTarget.contains(getMouseDownTarget())) (_a = stickyHeaderRef.current) === null || _a === void 0 || _a.scrollToRow(currentTarget);
            }
        }, (0, $30c09cf06b060b34$export$abdbebe48aa0774a).item, {
            onClick: onRowClickHandler && onRowClickHandler.bind(null, rowIndex, row.item),
            onContextMenu: onRowContextMenuHandler && onRowContextMenuHandler.bind(null, rowIndex, row.item)
        }, rowRoleProps), getItemSelectionProps && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2eb106c16e1c0bab$export$2e9f934a16f4a89a), Object.assign({}, sharedCellProps, {
            className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)["selection-control"],
            wrapLines: false,
            columnId: $232ec668ec974363$var$selectionColumnId,
            colIndex: 0
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $51374b608ac485d9$export$c5dcec1959129451), Object.assign({
            onFocusDown: moveFocusDown,
            onFocusUp: moveFocusUp
        }, getItemSelectionProps(row.item)))), visibleColumnDefinitions.map((column, colIndex)=>{
            var _a;
            const isEditing = cellEditing.checkEditing({
                rowIndex: rowIndex,
                colIndex: colIndex
            });
            const successfulEdit = cellEditing.checkLastSuccessfulEdit({
                rowIndex: rowIndex,
                colIndex: colIndex
            });
            const isEditable = !!column.editConfig && !cellEditing.isLoading;
            const cellExpandableProps = isExpandable && colIndex === 0 ? expandableProps : undefined;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ca56bbf005612a36$export$948e91fcef170792), Object.assign({
                key: (0, $d5e9c22659308d3d$export$480219a02f196e72)(column, colIndex)
            }, sharedCellProps, {
                style: resizableColumns ? {} : {
                    width: column.width,
                    minWidth: column.minWidth,
                    maxWidth: column.maxWidth
                },
                ariaLabels: ariaLabels,
                column: column,
                item: row.item,
                wrapLines: wrapLines,
                isEditable: isEditable,
                isEditing: isEditing,
                isRowHeader: column.isRowHeader,
                successfulEdit: successfulEdit,
                resizableColumns: resizableColumns,
                onEditStart: ()=>cellEditing.startEdit({
                        rowIndex: rowIndex,
                        colIndex: colIndex
                    }),
                onEditEnd: (editCancelled)=>cellEditing.completeEdit({
                        rowIndex: rowIndex,
                        colIndex: colIndex
                    }, editCancelled),
                submitEdit: cellEditing.submitEdit,
                columnId: (_a = column.id) !== null && _a !== void 0 ? _a : colIndex,
                colIndex: colIndex + colIndexOffset
            }, cellExpandableProps));
        }));
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", Object.assign({
            key: (row.item ? getTableItemKey(row.item) : "root-" + rowIndex) + "-" + row.from,
            className: (0, $7ded81c543f72294$export$2e2bcd8739ae039).row
        }, rowRoleProps), getItemSelectionProps && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2eb106c16e1c0bab$export$2e9f934a16f4a89a), Object.assign({}, sharedCellProps, {
            className: (0, $7ded81c543f72294$export$2e2bcd8739ae039)["selection-control"],
            wrapLines: false,
            columnId: $232ec668ec974363$var$selectionColumnId,
            colIndex: 0
        }), null), visibleColumnDefinitions.map((column, colIndex)=>{
            var _a;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2eb106c16e1c0bab$export$2e9f934a16f4a89a), Object.assign({
                key: (0, $d5e9c22659308d3d$export$480219a02f196e72)(column, colIndex)
            }, sharedCellProps, {
                wrapLines: false,
                columnId: (_a = column.id) !== null && _a !== void 0 ? _a : colIndex,
                colIndex: colIndex + colIndexOffset,
                isRowHeader: colIndex === 0,
                level: row.level
            }), colIndex === 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $85eff45af97fd1d6$export$2e59eb877e0e85de), {
                item: row.item,
                loadingStatus: row.status,
                renderLoaderPending: renderLoaderPending,
                renderLoaderLoading: renderLoaderLoading,
                renderLoaderError: renderLoaderError,
                trackBy: trackBy
            }) : null);
        }));
    })))), resizableColumns && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ba2285bfc0275a61$export$1a1c8e5e76867279), null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33348950bdbf3017$export$2e2bcd8739ae039), {
        ref: scrollbarRef,
        wrapperRef: wrapperRefObject,
        tableRef: tableRefObject,
        onScroll: handleScroll,
        hasStickyColumns: hasStickyColumns
    }))));
});
var $232ec668ec974363$export$2e2bcd8739ae039 = $232ec668ec974363$var$InternalTable;




const $7f9d0e5ed1593f09$var$Table = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { items: items = [], selectedItems: selectedItems = [], variant: variant = "container", contentDensity: contentDensity = "comfortable", firstIndex: firstIndex = 1 } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "items",
        "selectedItems",
        "variant",
        "contentDensity",
        "firstIndex"
    ]);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Table", {
        props: {
            contentDensity: contentDensity,
            resizableColumns: props.resizableColumns,
            selectionType: props.selectionType,
            stickyHeader: props.stickyHeader,
            stripedRows: props.stripedRows,
            variant: variant,
            wrapLines: props.wrapLines,
            enableKeyboardNavigation: props.enableKeyboardNavigation
        },
        metadata: {
            expandableRows: !!props.expandableRows,
            progressiveLoading: !!props.getLoadingStatus,
            inlineEdit: props.columnDefinitions.some((def)=>!!def.editConfig),
            disabledInlineEdit: props.columnDefinitions.some((def)=>{
                var _a;
                return !!((_a = def.editConfig) === null || _a === void 0 ? void 0 : _a.disabledReason);
            })
        }
    });
    const tableProps = Object.assign(Object.assign(Object.assign({
        items: items,
        selectedItems: selectedItems,
        variant: variant,
        contentDensity: contentDensity,
        firstIndex: firstIndex
    }, props), baseComponentProps), {
        ref: ref
    });
    if (variant === "borderless" || variant === "embedded") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $232ec668ec974363$export$2e2bcd8739ae039), Object.assign({}, tableProps));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $515d52eb9df17853$export$b1325661caf9fa0), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $232ec668ec974363$export$38570466636a45db), Object.assign({}, tableProps)));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($7f9d0e5ed1593f09$var$Table, "Table");
var $7f9d0e5ed1593f09$export$2e2bcd8739ae039 = $7f9d0e5ed1593f09$var$Table;

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $9276a314d364c5b6$export$2e2bcd8739ae039 = {
    "root": "awsui_root_1sdq3_1ywvn_97",
    "input": "awsui_input_1sdq3_1ywvn_135",
    "results": "awsui_results_1sdq3_1ywvn_139"
};



// Debounce delay for live region (based on testing with VoiceOver)
const $46786b905a0ab7fc$var$LIVE_REGION_DELAY = 2000;
function $46786b905a0ab7fc$export$aee53da69e9839be({ id: id, children: children }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $9276a314d364c5b6$export$2e2bcd8739ae039).results
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c27ae43b338ed19e$export$2e2bcd8739ae039), {
        delay: $46786b905a0ab7fc$var$LIVE_REGION_DELAY,
        visible: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: id
    }, children)));
}



const $2b86ff3bde67fdd3$var$InternalTextFilter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { filteringText: filteringText, filteringAriaLabel: filteringAriaLabel, filteringPlaceholder: filteringPlaceholder, filteringClearAriaLabel: filteringClearAriaLabel, controlId: controlId, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, disabled: disabled, countText: countText, onChange: onChange, onDelayedChange: onDelayedChange, __internalRootRef: __internalRootRef } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "filteringText",
        "filteringAriaLabel",
        "filteringPlaceholder",
        "filteringClearAriaLabel",
        "controlId",
        "ariaLabelledby",
        "ariaDescribedby",
        "disabled",
        "countText",
        "onChange",
        "onDelayedChange",
        "__internalRootRef"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const inputRef = (0, $acw62.useRef)(null);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, inputRef);
    const searchResultsId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("text-filter-search-results");
    const showResults = filteringText && countText && !disabled;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $9276a314d364c5b6$export$2e2bcd8739ae039).root),
        ref: __internalRootRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fadf349311229145$export$2e2bcd8739ae039), {
        __inheritFormFieldProps: true,
        ref: inputRef,
        className: (0, $9276a314d364c5b6$export$2e2bcd8739ae039).input,
        type: "search",
        ariaLabel: filteringAriaLabel,
        placeholder: filteringPlaceholder,
        value: filteringText,
        disabled: disabled,
        controlId: controlId,
        ariaLabelledby: ariaLabelledby,
        ariaDescribedby: (0, $49fa9e74c692ea64$export$b933cda3796739ed)(showResults ? searchResultsId : undefined, ariaDescribedby),
        autoComplete: false,
        clearAriaLabel: filteringClearAriaLabel,
        onChange: (event)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                filteringText: event.detail.value
            }),
        __onDelayedInput: (event)=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onDelayedChange, {
                filteringText: event.detail.value
            })
    }), showResults ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $46786b905a0ab7fc$export$aee53da69e9839be), {
        id: searchResultsId
    }, countText) : null);
});
var $2b86ff3bde67fdd3$export$2e2bcd8739ae039 = $2b86ff3bde67fdd3$var$InternalTextFilter;


const $f1ad38163d990f1e$var$TextFilter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("TextFilter");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2b86ff3bde67fdd3$export$2e2bcd8739ae039), Object.assign({}, props, baseComponentProps, {
        ref: ref
    }));
});
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($f1ad38163d990f1e$var$TextFilter, "TextFilter");
var $f1ad38163d990f1e$export$2e2bcd8739ae039 = $f1ad38163d990f1e$var$TextFilter;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");



var $466bcaccb2168c42$export$2e2bcd8739ae039 = {
    "css-grid": "awsui_css-grid_zqq3x_kjrw2_97",
    "grid-no-gutters": "awsui_grid-no-gutters_zqq3x_kjrw2_108",
    "grid-variant-text-grid": "awsui_grid-variant-text-grid_zqq3x_kjrw2_111",
    "item": "awsui_item_zqq3x_kjrw2_111",
    "first-column": "awsui_first-column_zqq3x_kjrw2_115"
};



const $b2e6cf3da3455bca$var$isOdd = (value)=>value % 2 !== 0;
function $b2e6cf3da3455bca$export$cea2a3d259837e9e(columns, minColumnWidth, containerWidth) {
    if (!containerWidth) return columns;
    // First, calculate how many columns we can have based on the current container width and minColumnWidth.
    const targetColumnCount = Math.min(columns, Math.floor(containerWidth / minColumnWidth));
    // When we start wrapping into fewer columns than desired, we want to keep the number of columns even.
    return Math.max(1, targetColumnCount < columns && $b2e6cf3da3455bca$var$isOdd(targetColumnCount) ? targetColumnCount - 1 : targetColumnCount);
}
function $b2e6cf3da3455bca$export$2e2bcd8739ae039({ columns: columns = 1, minColumnWidth: minColumnWidth = 0, disableGutters: disableGutters, variant: variant, children: children, __tagOverride: __tagOverride }) {
    const [containerWidth, containerRef] = (0, $6e052e2d296ab854$export$2e2bcd8739ae039)((rect)=>rect.contentBoxWidth);
    const columnCount = $b2e6cf3da3455bca$export$cea2a3d259837e9e(columns, minColumnWidth, containerWidth);
    const shouldDisableGutters = variant !== "text-grid" && disableGutters;
    // Flattening the children allows us to "see through" React Fragments and nested arrays.
    const flattenedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($dc835a13f4d26607$exports)))(children);
    const Tag = __tagOverride !== null && __tagOverride !== void 0 ? __tagOverride : "div";
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        ref: containerRef,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $466bcaccb2168c42$export$2e2bcd8739ae039)["css-grid"], (0, $466bcaccb2168c42$export$2e2bcd8739ae039)[`grid-variant-${variant}`], shouldDisableGutters && [
            (0, $466bcaccb2168c42$export$2e2bcd8739ae039)["grid-no-gutters"]
        ]),
        style: {
            gridTemplateColumns: `repeat(${columnCount}, 1fr)`
        }
    }, flattenedChildren.map((child, i)=>{
        // If this react child is a primitive value, the key will be undefined
        const key = child.key;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key ? String(key) : undefined,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $466bcaccb2168c42$export$2e2bcd8739ae039).item, {
                [(0, $466bcaccb2168c42$export$2e2bcd8739ae039)["first-column"]]: i % columnCount === 0
            })
        }, child);
    }));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $bf49903cd6edd726$export$76d90c956114f2c2(value, times) {
    const array = [];
    for(let i = 0; i < times; i++)array[i] = value;
    return array;
}




var $fdd0ba291139f043$export$2e2bcd8739ae039 = {
    "column-layout": "awsui_column-layout_vvxn7_fj3cv_97",
    "grid": "awsui_grid_vvxn7_fj3cv_132",
    "grid-no-gutters": "awsui_grid-no-gutters_vvxn7_fj3cv_138",
    "grid-variant-text-grid": "awsui_grid-variant-text-grid_vvxn7_fj3cv_142",
    "grid-breakpoint-default": "awsui_grid-breakpoint-default_vvxn7_fj3cv_150",
    "grid-columns-1": "awsui_grid-columns-1_vvxn7_fj3cv_153",
    "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vvxn7_fj3cv_153",
    "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vvxn7_fj3cv_156",
    "grid-columns-2": "awsui_grid-columns-2_vvxn7_fj3cv_159",
    "grid-columns-3": "awsui_grid-columns-3_vvxn7_fj3cv_165",
    "grid-columns-4": "awsui_grid-columns-4_vvxn7_fj3cv_171",
    "grid-vertical-borders": "awsui_grid-vertical-borders_vvxn7_fj3cv_187",
    "grid-horizontal-borders": "awsui_grid-horizontal-borders_vvxn7_fj3cv_220"
};


const $c57194b2cd59a4d0$var$COLUMN_DEFS = {
    1: {
        colspan: {
            default: 12,
            xxs: 12,
            xs: 12
        }
    },
    2: {
        colspan: {
            default: 12,
            xxs: 6,
            xs: 6
        }
    },
    3: {
        colspan: {
            default: 12,
            xxs: 6,
            xs: 4
        }
    },
    4: {
        colspan: {
            default: 12,
            xxs: 6,
            xs: 3
        }
    }
};
function $c57194b2cd59a4d0$export$2e2bcd8739ae039({ columns: columns, variant: variant, borders: borders, disableGutters: disableGutters, __breakpoint: __breakpoint, children: children, __tagOverride: __tagOverride }) {
    var _a;
    const isTextGridVariant = variant === "text-grid";
    const shouldDisableGutters = !isTextGridVariant && disableGutters;
    const shouldHaveHorizontalBorders = !isTextGridVariant && (borders === "horizontal" || borders === "all");
    const shouldHaveVerticalBorders = !isTextGridVariant && (borders === "vertical" || borders === "all");
    // Flattening the children allows us to "see through" React Fragments and nested arrays.
    const flattenedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($dc835a13f4d26607$exports)))(children);
    const [breakpoint, ref] = (0, $921c3f4037759790$export$2aa1887afbd6d218)((0, $2ae44e537ec7bbb3$export$5b6623e40ba32802));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $533fd63a0264232f$export$2e2bcd8739ae039), {
        ref: ref,
        disableGutters: true,
        gridDefinition: (0, $bf49903cd6edd726$export$76d90c956114f2c2)((_a = $c57194b2cd59a4d0$var$COLUMN_DEFS[columns]) !== null && _a !== void 0 ? _a : {}, flattenedChildren.length),
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $fdd0ba291139f043$export$2e2bcd8739ae039).grid, (0, $fdd0ba291139f043$export$2e2bcd8739ae039)[`grid-columns-${columns}`], (0, $fdd0ba291139f043$export$2e2bcd8739ae039)[`grid-variant-${variant}`], {
            [(0, $fdd0ba291139f043$export$2e2bcd8739ae039)["grid-horizontal-borders"]]: shouldHaveHorizontalBorders,
            [(0, $fdd0ba291139f043$export$2e2bcd8739ae039)["grid-vertical-borders"]]: shouldHaveVerticalBorders,
            [(0, $fdd0ba291139f043$export$2e2bcd8739ae039)["grid-no-gutters"]]: shouldDisableGutters
        }),
        __breakpoint: __breakpoint || breakpoint,
        __responsiveClassName: (breakpoint)=>breakpoint && (0, $fdd0ba291139f043$export$2e2bcd8739ae039)[`grid-breakpoint-${breakpoint}`],
        __tagOverride: __tagOverride
    }, children);
}



const $2ae44e537ec7bbb3$export$5b6623e40ba32802 = [
    "default",
    "xxs",
    "xs"
];
function $2ae44e537ec7bbb3$export$2e2bcd8739ae039(_a) {
    var { columns: columns = 1, variant: variant = "default", borders: borders = "none", disableGutters: disableGutters = false, minColumnWidth: minColumnWidth, children: children, __tagOverride: __tagOverride, __breakpoint: __breakpoint, __internalRootRef: __internalRootRef } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "columns",
        "variant",
        "borders",
        "disableGutters",
        "minColumnWidth",
        "children",
        "__tagOverride",
        "__breakpoint",
        "__internalRootRef"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $fdd0ba291139f043$export$2e2bcd8739ae039)["column-layout"]),
        ref: __internalRootRef
    }), minColumnWidth ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b2e6cf3da3455bca$export$2e2bcd8739ae039), {
        columns: columns,
        borders: borders,
        variant: variant,
        minColumnWidth: minColumnWidth,
        disableGutters: disableGutters,
        __tagOverride: __tagOverride
    }, children) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c57194b2cd59a4d0$export$2e2bcd8739ae039), {
        columns: columns,
        variant: variant,
        borders: borders,
        disableGutters: disableGutters,
        __breakpoint: __breakpoint,
        __tagOverride: __tagOverride
    }, children));
}






var $acw62 = parcelRequire("acw62");





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
function $3024c0fa705edd01$export$2e2bcd8739ae039(forwardedRef, items, value) {
    const itemRef = (0, $acw62.useRef)(null);
    const itemIndex = items && $3024c0fa705edd01$var$findIndex(items, (item)=>item.value === value);
    (0, $acw62.useImperativeHandle)(forwardedRef, ()=>({
            focus () {
                var _a;
                (_a = itemRef.current) === null || _a === void 0 || _a.focus();
            }
        }));
    return [
        itemRef,
        itemIndex !== undefined && itemIndex !== -1 ? itemIndex : 0
    ];
}
function $3024c0fa705edd01$var$findIndex(items, predicate) {
    for(let i = 0; i < items.length; i++){
        if (predicate(items[i])) return i;
    }
    return -1;
}


const $9fbcc4fc1615c1e4$var$InternalRadioGroup = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { name: name, value: value, items: items, ariaLabel: ariaLabel, ariaRequired: ariaRequired, ariaControls: ariaControls, onChange: onChange, readOnly: readOnly, __internalRootRef: __internalRootRef = null } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "name",
        "value",
        "items",
        "ariaLabel",
        "ariaRequired",
        "ariaControls",
        "onChange",
        "readOnly",
        "__internalRootRef"
    ]);
    const { ariaDescribedby: ariaDescribedby, ariaLabelledby: ariaLabelledby } = (0, $4a30639b463663e4$export$824c400da192ca1b)(props);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(props);
    const generatedName = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("awsui-radio-");
    const [radioButtonRef, radioButtonRefIndex] = (0, $3024c0fa705edd01$export$2e2bcd8739ae039)(ref, items, value);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        role: "radiogroup",
        "aria-labelledby": ariaLabelledby,
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedby,
        "aria-required": ariaRequired,
        "aria-controls": ariaControls,
        "aria-readonly": readOnly ? "true" : undefined
    }, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $a5be326d08ef0873$export$2e2bcd8739ae039).root),
        ref: __internalRootRef
    }), items && items.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0d348656d0a64072$export$2e2bcd8739ae039), {
            key: item.value,
            ref: index === radioButtonRefIndex ? radioButtonRef : undefined,
            checked: item.value === value,
            name: name || generatedName,
            value: item.value,
            label: item.label,
            description: item.description,
            disabled: item.disabled,
            onChange: onChange,
            controlId: item.controlId,
            readOnly: readOnly
        })));
});
var $9fbcc4fc1615c1e4$export$2e2bcd8739ae039 = $9fbcc4fc1615c1e4$var$InternalRadioGroup;





var $01b0d7d1e7a80e3a$export$2e2bcd8739ae039 = {
    "visible-content": "awsui_visible-content_tc96w_vl685_193",
    "visible-content-toggle": "awsui_visible-content-toggle_tc96w_vl685_194",
    "visible-content-groups": "awsui_visible-content-groups_tc96w_vl685_195",
    "visible-content-group": "awsui_visible-content-group_tc96w_vl685_195",
    "visible-content-title": "awsui_visible-content-title_tc96w_vl685_200",
    "visible-content-group-label": "awsui_visible-content-group-label_tc96w_vl685_210",
    "visible-content-option": "awsui_visible-content-option_tc96w_vl685_216",
    "visible-content-option-label": "awsui_visible-content-option-label_tc96w_vl685_229",
    "content-display-option-toggle": "awsui_content-display-option-toggle_tc96w_vl685_428",
    "content-display-option-content": "awsui_content-display-option-content_tc96w_vl685_432",
    "content-display-option": "awsui_content-display-option_tc96w_vl685_428",
    "placeholder": "awsui_placeholder_tc96w_vl685_482",
    "sorting": "awsui_sorting_tc96w_vl685_482",
    "content-display-option-label": "awsui_content-display-option-label_tc96w_vl685_509",
    "drag-overlay": "awsui_drag-overlay_tc96w_vl685_516",
    "content-display": "awsui_content-display_tc96w_vl685_428",
    "content-display-title": "awsui_content-display-title_tc96w_vl685_549",
    "content-display-description": "awsui_content-display-description_tc96w_vl685_558",
    "content-display-option-list": "awsui_content-display-option-list_tc96w_vl685_566",
    "root": "awsui_root_tc96w_vl685_573",
    "modal-root": "awsui_modal-root_tc96w_vl685_574",
    "trigger-button": "awsui_trigger-button_tc96w_vl685_575",
    "cancel-button": "awsui_cancel-button_tc96w_vl685_576",
    "confirm-button": "awsui_confirm-button_tc96w_vl685_577",
    "custom": "awsui_custom_tc96w_vl685_578",
    "second-column-small": "awsui_second-column-small_tc96w_vl685_582",
    "wrap-lines": "awsui_wrap-lines_tc96w_vl685_586",
    "striped-rows": "awsui_striped-rows_tc96w_vl685_587",
    "content-density": "awsui_content-density_tc96w_vl685_588",
    "page-size": "awsui_page-size_tc96w_vl685_589",
    "page-size-form-field": "awsui_page-size-form-field_tc96w_vl685_590",
    "page-size-radio-group": "awsui_page-size-radio-group_tc96w_vl685_591",
    "sticky-columns": "awsui_sticky-columns_tc96w_vl685_592",
    "sticky-columns-form-field": "awsui_sticky-columns-form-field_tc96w_vl685_593",
    "sticky-columns-radio-group": "awsui_sticky-columns-radio-group_tc96w_vl685_594",
    "sticky-columns-first": "awsui_sticky-columns-first_tc96w_vl685_595",
    "sticky-columns-last": "awsui_sticky-columns-last_tc96w_vl685_596"
};



const $5e0c372fb1280cb8$export$9f13f511f7531527 = ({ pageSize: pageSize, wrapLines: wrapLines, stripedRows: stripedRows, contentDensity: contentDensity, visibleContent: visibleContent, contentDisplay: contentDisplay, stickyColumns: stickyColumns, custom: custom })=>({
        pageSize: pageSize,
        wrapLines: wrapLines,
        stripedRows: stripedRows,
        contentDensity: contentDensity,
        visibleContent: visibleContent,
        contentDisplay: contentDisplay,
        stickyColumns: stickyColumns,
        custom: custom
    });
const $5e0c372fb1280cb8$export$76ff241c87799c99 = (newPref, oldPref)=>{
    const newObj = Object.assign({}, oldPref);
    const prefNames = [
        "pageSize",
        "wrapLines",
        "stripedRows",
        "contentDensity",
        "visibleContent",
        "custom",
        "contentDisplay",
        "stickyColumns"
    ];
    for (const prefName of prefNames)if (newPref[prefName] !== undefined) newObj[prefName] = newPref[prefName];
    return newObj;
};
const $5e0c372fb1280cb8$export$c84c03f16c0f8752 = ({ left: left, right: right })=>{
    const [breakpoint, ref] = (0, $921c3f4037759790$export$2aa1887afbd6d218)([
        "xs"
    ]);
    const smallContainer = breakpoint === "default";
    if (smallContainer) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref
    }, left && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, left), right && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(left && (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["second-column-small"])
    }, right));
    const columns = left && right ? 2 : 1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2ae44e537ec7bbb3$export$2e2bcd8739ae039), {
        columns: columns,
        variant: "text-grid"
    }, left && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, left), right && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, right)));
};
const $5e0c372fb1280cb8$export$e7b9797caf42ef5e = ({ title: title, options: options, value: value, onChange: onChange })=>{
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("collection-preferences");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["page-size"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$2e2bcd8739ae039), {
        label: i18n("pageSizePreference.title", title),
        stretch: true,
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["page-size-form-field"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9fbcc4fc1615c1e4$export$2e2bcd8739ae039), {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["page-size-radio-group"],
        value: `${value}`,
        items: options.map(({ label: label, value: value })=>({
                label: label,
                value: `${value}`
            })),
        onChange: ({ detail: detail })=>onChange(parseInt(detail.value, 10))
    })));
};
const $5e0c372fb1280cb8$export$9c0f52e17055efc3 = ({ label: label, description: description, value: value, onChange: onChange })=>{
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("collection-preferences");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81def5553f1b8381$export$2e2bcd8739ae039), {
        checked: !!value,
        description: i18n("wrapLinesPreference.description", description),
        onChange: ({ detail: detail })=>onChange(detail.checked),
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["wrap-lines"]
    }, i18n("wrapLinesPreference.label", label));
};
function $5e0c372fb1280cb8$export$f467017c5d8daff3({ label: label, description: description, value: value, onChange: onChange }) {
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("collection-preferences");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81def5553f1b8381$export$2e2bcd8739ae039), {
        checked: !!value,
        description: i18n("stripedRowsPreference.description", description),
        onChange: ({ detail: detail })=>onChange(detail.checked),
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["striped-rows"]
    }, i18n("stripedRowsPreference.label", label));
}
const $5e0c372fb1280cb8$export$2b48c4c5210809b9 = ({ label: label, description: description, value: value, onChange: onChange })=>{
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("collection-preferences");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81def5553f1b8381$export$2e2bcd8739ae039), {
        checked: value === "compact",
        description: i18n("contentDensityPreference.description", description),
        onChange: ({ detail: detail })=>onChange(detail.checked ? "compact" : "comfortable"),
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["content-density"]
    }, i18n("contentDensityPreference.label", label));
};
const $5e0c372fb1280cb8$var$StickyPreference = ({ firstOrLast: firstOrLast, preference: preference, value: value, onChange: onChange })=>{
    const { title: title, description: description, options: options } = preference;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)[`sticky-columns-${firstOrLast}`]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$2e2bcd8739ae039), {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["sticky-columns-form-field"],
        label: title,
        description: description
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9fbcc4fc1615c1e4$export$2e2bcd8739ae039), {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["sticky-columns-radio-group"],
        value: typeof value !== "undefined" ? `${value}` : null,
        items: options.map(({ label: label, value: value })=>({
                label: label,
                value: `${value}`
            })),
        onChange: ({ detail: detail })=>onChange(Number(detail.value))
    })));
};
const $5e0c372fb1280cb8$export$7110115eecf52680 = ({ firstColumns: firstColumns, lastColumns: lastColumns, onChange: onChange, value: value })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["sticky-columns"],
        size: "l"
    }, firstColumns && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5e0c372fb1280cb8$var$StickyPreference, {
        firstOrLast: "first",
        preference: firstColumns,
        value: value === null || value === void 0 ? void 0 : value.first,
        onChange: (newValue)=>onChange(Object.assign(Object.assign({}, value), {
                first: newValue
            }))
    }), lastColumns && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5e0c372fb1280cb8$var$StickyPreference, {
        firstOrLast: "last",
        preference: lastColumns,
        value: value === null || value === void 0 ? void 0 : value.last,
        onChange: (newValue)=>onChange(Object.assign(Object.assign({}, value), {
                last: newValue
            }))
    }));
};
const $5e0c372fb1280cb8$export$71d19cc08e222f47 = ({ value: value, customPreference: customPreference, onChange: onChange })=>{
    const [customState, setCustomState] = (0, $acw62.useState)(value);
    if (customPreference) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039).custom
    }, customPreference(customState, (value)=>{
        // prevent value to be treated as a functional callback
        setCustomState(()=>value);
        onChange(value);
    }));
    return null;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");





var $31deb4646e53fc33$export$2e2bcd8739ae039 = {
    "root": "awsui_root_4yi2u_1w171_97",
    "outline": "awsui_outline_4yi2u_1w171_133",
    "toggle-control": "awsui_toggle-control_4yi2u_1w171_155",
    "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_1w171_168",
    "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_1w171_171",
    "toggle-control-readonly": "awsui_toggle-control-readonly_4yi2u_1w171_177",
    "toggle-handle": "awsui_toggle-handle_4yi2u_1w171_181",
    "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_1w171_196",
    "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_1w171_203",
    "toggle-handle-readonly": "awsui_toggle-handle-readonly_4yi2u_1w171_207"
};



const $9b746e4e3748705e$var$InternalToggle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { controlId: controlId, checked: checked, name: name, disabled: disabled, readOnly: readOnly, children: children, description: description, ariaLabel: ariaLabel, ariaControls: ariaControls, onFocus: onFocus, onBlur: onBlur, onChange: onChange, __internalRootRef: __internalRootRef = null } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "controlId",
        "checked",
        "name",
        "disabled",
        "readOnly",
        "children",
        "description",
        "ariaLabel",
        "ariaControls",
        "onFocus",
        "onBlur",
        "onChange",
        "__internalRootRef"
    ]);
    const { ariaDescribedby: ariaDescribedby, ariaLabelledby: ariaLabelledby } = (0, $4a30639b463663e4$export$824c400da192ca1b)(rest);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const checkboxRef = (0, $acw62.useRef)(null);
    (0, $e72aa8d9fd756822$export$2e2bcd8739ae039)(ref, checkboxRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9358073d64ebb29$export$2e2bcd8739ae039), Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $31deb4646e53fc33$export$2e2bcd8739ae039).root, baseProps.className),
        controlClassName: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $31deb4646e53fc33$export$2e2bcd8739ae039)["toggle-control"], {
            [(0, $31deb4646e53fc33$export$2e2bcd8739ae039)["toggle-control-checked"]]: checked,
            [(0, $31deb4646e53fc33$export$2e2bcd8739ae039)["toggle-control-disabled"]]: disabled,
            [(0, $31deb4646e53fc33$export$2e2bcd8739ae039)["toggle-control-readonly"]]: readOnly
        }),
        outlineClassName: (0, $31deb4646e53fc33$export$2e2bcd8739ae039).outline,
        controlId: controlId,
        disabled: disabled,
        readOnly: readOnly,
        label: children,
        description: description,
        descriptionBottomPadding: true,
        ariaLabel: ariaLabel,
        ariaLabelledby: ariaLabelledby,
        ariaDescribedby: ariaDescribedby,
        ariaControls: ariaControls,
        nativeControl: (nativeControlProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", Object.assign({}, nativeControlProps, {
                ref: checkboxRef,
                type: "checkbox",
                checked: checked,
                name: name,
                "aria-disabled": readOnly && !disabled ? "true" : undefined,
                onFocus: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onFocus),
                onBlur: ()=>(0, $fc537b925f715587$export$e36a47fa496fb0d2)(onBlur),
                // empty handler to suppress React controllability warning
                onChange: ()=>{}
            })),
        onClick: ()=>{
            var _a;
            (_a = checkboxRef.current) === null || _a === void 0 || _a.focus();
            (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                checked: !checked
            });
        },
        styledControl: /*Using span, not div for HTML validity*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $31deb4646e53fc33$export$2e2bcd8739ae039)["toggle-handle"], {
                [(0, $31deb4646e53fc33$export$2e2bcd8739ae039)["toggle-handle-checked"]]: checked,
                [(0, $31deb4646e53fc33$export$2e2bcd8739ae039)["toggle-handle-disabled"]]: disabled,
                [(0, $31deb4646e53fc33$export$2e2bcd8739ae039)["toggle-handle-readonly"]]: readOnly
            })
        }),
        __internalRootRef: __internalRootRef
    }));
});
var $9b746e4e3748705e$export$2e2bcd8739ae039 = $9b746e4e3748705e$var$InternalToggle;




const $1d0e079a04a15fe6$var$isVisible = (id, visibleIds)=>visibleIds.indexOf(id) !== -1;
const $1d0e079a04a15fe6$var$className = (suffix)=>({
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)[`visible-content-${suffix}`]
    });
function $1d0e079a04a15fe6$export$2e2bcd8739ae039({ title: title, options: options, value: value = [], onChange: onChange }) {
    const idPrefix = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("visible-content");
    const flatOptionsIds = options.reduce((ids, group)=>[
            ...ids,
            ...group.options.reduce((groupIds, option)=>[
                    ...groupIds,
                    option.id
                ], [])
        ], []);
    const onToggle = (id)=>{
        if (!$1d0e079a04a15fe6$var$isVisible(id, value)) onChange([
            ...value,
            id
        ].sort((firstId, secondId)=>flatOptionsIds.indexOf(firstId) - flatOptionsIds.indexOf(secondId)));
        else onChange(value.filter((currentId)=>currentId !== id));
    };
    const selectionOption = (option, optionGroupIndex, optionIndex)=>{
        const labelId = `${idPrefix}-${optionGroupIndex}-${optionIndex}`;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
            key: optionIndex
        }, $1d0e079a04a15fe6$var$className("option")), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", Object.assign({}, $1d0e079a04a15fe6$var$className("option-label"), {
            htmlFor: labelId
        }), option.label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, $1d0e079a04a15fe6$var$className("toggle")), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9b746e4e3748705e$export$2e2bcd8739ae039), {
            checked: $1d0e079a04a15fe6$var$isVisible(option.id, value),
            onChange: ()=>onToggle(option.id),
            disabled: option.editable === false,
            controlId: labelId
        })));
    };
    const outerGroupLabelId = `${idPrefix}-outer`;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["visible-content"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", Object.assign({}, $1d0e079a04a15fe6$var$className("title"), {
        id: outerGroupLabelId
    }), title), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), Object.assign({}, $1d0e079a04a15fe6$var$className("groups"), {
        size: "xs"
    }), options.map((optionGroup, optionGroupIndex)=>{
        const groupLabelId = `${idPrefix}-${optionGroupIndex}`;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
            key: optionGroupIndex
        }, $1d0e079a04a15fe6$var$className("group"), {
            role: "group",
            "aria-labelledby": `${outerGroupLabelId} ${groupLabelId}`
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, $1d0e079a04a15fe6$var$className("group-label"), {
            id: groupLabelId
        }), optionGroup.label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, optionGroup.options.map((option, optionIndex)=>selectionOption(option, optionGroupIndex, optionIndex))));
    })));
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


function $1d5a598a97527b88$export$859eb1ee842452d4({ options: options, contentDisplay: contentDisplay }) {
    const optionsById = options.reduce((currentValue, option)=>Object.assign(Object.assign({}, currentValue), {
            [option.id]: option
        }), {});
    return contentDisplay.map(({ id: id, visible: visible })=>Object.assign(Object.assign({}, optionsById[id]), {
            visible: visible
        })).filter(Boolean);
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $0030bffa1359ca92$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $acw62.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $0030bffa1359ca92$export$71594e8a50f746f4 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $0030bffa1359ca92$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === "[object Window]" || // In Electron context the Window object serializes to [object global]
    elementString === "[object global]";
}
function $0030bffa1359ca92$export$8ee0fc9ee280b4ee(node) {
    return "nodeType" in node;
}
function $0030bffa1359ca92$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($0030bffa1359ca92$export$5a096129d439f843(target)) return target;
    if (!$0030bffa1359ca92$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $0030bffa1359ca92$export$62858bae88b53fd0(node) {
    const { Document: Document } = $0030bffa1359ca92$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $0030bffa1359ca92$export$1b3bfaa9684536aa(node) {
    if ($0030bffa1359ca92$export$5a096129d439f843(node)) return false;
    return node instanceof $0030bffa1359ca92$export$38b2d434cce3ea22(node).HTMLElement;
}
function $0030bffa1359ca92$export$17eda790a720ec57(node) {
    return node instanceof $0030bffa1359ca92$export$38b2d434cce3ea22(node).SVGElement;
}
function $0030bffa1359ca92$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($0030bffa1359ca92$export$5a096129d439f843(target)) return target.document;
    if (!$0030bffa1359ca92$export$8ee0fc9ee280b4ee(target)) return document;
    if ($0030bffa1359ca92$export$62858bae88b53fd0(target)) return target;
    if ($0030bffa1359ca92$export$1b3bfaa9684536aa(target) || $0030bffa1359ca92$export$17eda790a720ec57(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $0030bffa1359ca92$export$700979bc83e7db82 = $0030bffa1359ca92$export$71594e8a50f746f4 ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $0030bffa1359ca92$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $acw62.useRef)(handler);
    $0030bffa1359ca92$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $acw62.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $0030bffa1359ca92$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $acw62.useRef)(null);
    const set = (0, $acw62.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $acw62.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $0030bffa1359ca92$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $acw62.useRef)(value);
    $0030bffa1359ca92$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $0030bffa1359ca92$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $acw62.useRef)();
    return (0, $acw62.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $0030bffa1359ca92$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $0030bffa1359ca92$export$90fc3a17d93f704c(onChange);
    const node = (0, $acw62.useRef)(null);
    const setNodeRef = (0, $acw62.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $0030bffa1359ca92$export$5cae361ad82dce8b(value) {
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $0030bffa1359ca92$var$ids = {};
function $0030bffa1359ca92$export$c485849f2e393253(prefix, value) {
    return (0, $acw62.useMemo)(()=>{
        if (value) return value;
        const id = $0030bffa1359ca92$var$ids[prefix] == null ? 0 : $0030bffa1359ca92$var$ids[prefix] + 1;
        $0030bffa1359ca92$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $0030bffa1359ca92$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const $0030bffa1359ca92$export$e16d8520af44a096 = /*#__PURE__*/ $0030bffa1359ca92$var$createAdjustmentFn(1);
const $0030bffa1359ca92$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $0030bffa1359ca92$var$createAdjustmentFn(-1);
function $0030bffa1359ca92$export$d0e71af79cd586c6(event) {
    return "clientX" in event && "clientY" in event;
}
function $0030bffa1359ca92$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $0030bffa1359ca92$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $0030bffa1359ca92$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $0030bffa1359ca92$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $0030bffa1359ca92$export$36195c8aa1517e04(event) {
    if ($0030bffa1359ca92$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($0030bffa1359ca92$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $0030bffa1359ca92$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $0030bffa1359ca92$export$c4ffa16951855e28.Translate.toString(transform),
                $0030bffa1359ca92$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(" ");
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $0030bffa1359ca92$var$SELECTOR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function $0030bffa1359ca92$export$44f71d798fd0a62b(element) {
    if (element.matches($0030bffa1359ca92$var$SELECTOR)) return element;
    return element.querySelector($0030bffa1359ca92$var$SELECTOR);
}



var $acw62 = parcelRequire("acw62");
const $768971a59ac63485$var$hiddenStyles = {
    display: "none"
};
function $768971a59ac63485$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        style: $768971a59ac63485$var$hiddenStyles
    }, value);
}
function $768971a59ac63485$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement, ariaLiveType: ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: "fixed",
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: "hidden",
        clip: "rect(0 0 0 0)",
        clipPath: "inset(100%)",
        whiteSpace: "nowrap"
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function $768971a59ac63485$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $acw62.useState)("");
    const announce = (0, $acw62.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}


const $0bb7808e9486acbd$var$DndMonitorContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $0bb7808e9486acbd$export$1182af90218a7b81(listener) {
    const registerListener = (0, $acw62.useContext)($0bb7808e9486acbd$var$DndMonitorContext);
    (0, $acw62.useEffect)(()=>{
        if (!registerListener) throw new Error("useDndMonitor must be used within a children of <DndContext>");
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function $0bb7808e9486acbd$var$useDndMonitorProvider() {
    const [listeners] = (0, $acw62.useState)(()=>new Set());
    const registerListener = (0, $acw62.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, $acw62.useCallback)((_ref)=>{
        let { type: type, event: event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const $0bb7808e9486acbd$export$2547556495408594 = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const $0bb7808e9486acbd$export$6acb64047911dd54 = {
    onDragStart (_ref) {
        let { active: active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active: active, over: over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active: active, over: over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active: active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function $0bb7808e9486acbd$var$Accessibility(_ref) {
    let { announcements: announcements = $0bb7808e9486acbd$export$6acb64047911dd54, container: container, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions = $0bb7808e9486acbd$export$2547556495408594 } = _ref;
    const { announce: announce, announcement: announcement } = (0, $768971a59ac63485$export$97d78af8d95ca8bd)();
    const liveRegionId = (0, $0030bffa1359ca92$export$c485849f2e393253)("DndLiveRegion");
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setMounted(true);
    }, []);
    $0bb7808e9486acbd$export$1182af90218a7b81((0, $acw62.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active: active } = _ref2;
                announce(announcements.onDragStart({
                    active: active
                }));
            },
            onDragMove (_ref3) {
                let { active: active, over: over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active: active,
                    over: over
                }));
            },
            onDragOver (_ref4) {
                let { active: active, over: over } = _ref4;
                announce(announcements.onDragOver({
                    active: active,
                    over: over
                }));
            },
            onDragEnd (_ref5) {
                let { active: active, over: over } = _ref5;
                announce(announcements.onDragEnd({
                    active: active,
                    over: over
                }));
            },
            onDragCancel (_ref6) {
                let { active: active, over: over } = _ref6;
                announce(announcements.onDragCancel({
                    active: active,
                    over: over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $768971a59ac63485$export$1496ac55023363a5), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $768971a59ac63485$export$ae99b902be98b17), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, $11492dca620dcaa5$exports.createPortal)(markup, container) : markup;
}
var $0bb7808e9486acbd$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($0bb7808e9486acbd$var$Action || ($0bb7808e9486acbd$var$Action = {}));
function $0bb7808e9486acbd$var$noop() {}
function $0bb7808e9486acbd$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $acw62.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $0bb7808e9486acbd$export$19012f58216d597f() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, $acw62.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const $0bb7808e9486acbd$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $0bb7808e9486acbd$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $0bb7808e9486acbd$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $0030bffa1359ca92$export$36195c8aa1517e04)(event);
    if (!eventCoordinates) return "0 0";
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function $0bb7808e9486acbd$var$sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $0bb7808e9486acbd$var$sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $0bb7808e9486acbd$var$cornersOfRectangle(_ref5) {
    let { left: left, top: top, height: height, width: width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $0bb7808e9486acbd$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $0bb7808e9486acbd$var$centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $0bb7808e9486acbd$export$c8e785ae6b74bab8 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const centerRect = $0bb7808e9486acbd$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = $0bb7808e9486acbd$var$distanceBetween($0bb7808e9486acbd$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $0bb7808e9486acbd$export$c3a6c1c7122b31c9 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const corners = $0bb7808e9486acbd$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = $0bb7808e9486acbd$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $0bb7808e9486acbd$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $0bb7808e9486acbd$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $0bb7808e9486acbd$export$953346c40b5eb62a = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = $0bb7808e9486acbd$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $0bb7808e9486acbd$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $0bb7808e9486acbd$export$cd834c0ba378cb94 = (_ref)=>{
    let { droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && $0bb7808e9486acbd$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $0bb7808e9486acbd$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $0bb7808e9486acbd$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($0bb7808e9486acbd$var$sortCollisionsAsc);
};
function $0bb7808e9486acbd$var$adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function $0bb7808e9486acbd$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
}
function $0bb7808e9486acbd$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const $0bb7808e9486acbd$var$getAdjustedRect = /*#__PURE__*/ $0bb7808e9486acbd$var$createRectAdjustmentFn(1);
function $0bb7808e9486acbd$var$parseTransform(transform) {
    if (transform.startsWith("matrix3d(")) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith("matrix(")) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function $0bb7808e9486acbd$var$inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = $0bb7808e9486acbd$var$parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(" ") + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $0bb7808e9486acbd$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $0bb7808e9486acbd$export$b6aa1f30c53d7454(element, options) {
    if (options === void 0) options = $0bb7808e9486acbd$var$defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform: transform, transformOrigin: transformOrigin } = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(element).getComputedStyle(element);
        if (transform) rect = $0bb7808e9486acbd$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $0bb7808e9486acbd$var$getTransformAgnosticClientRect(element) {
    return $0bb7808e9486acbd$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $0bb7808e9486acbd$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $0bb7808e9486acbd$var$isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(node).getComputedStyle(node);
    return computedStyle.position === "fixed";
}
function $0bb7808e9486acbd$var$isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        "overflow",
        "overflowX",
        "overflowY"
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === "string" ? overflowRegex.test(value) : false;
    });
}
function $0bb7808e9486acbd$export$e4864aa91b5ed091(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, $0030bffa1359ca92$export$62858bae88b53fd0)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(node) || (0, $0030bffa1359ca92$export$17eda790a720ec57)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(element).getComputedStyle(node);
        if (node !== element) {
            if ($0bb7808e9486acbd$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($0bb7808e9486acbd$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $0bb7808e9486acbd$var$getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = $0bb7808e9486acbd$export$e4864aa91b5ed091(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function $0bb7808e9486acbd$var$getScrollableElement(element) {
    if (!(0, $0030bffa1359ca92$export$71594e8a50f746f4) || !element) return null;
    if ((0, $0030bffa1359ca92$export$5a096129d439f843)(element)) return element;
    if (!(0, $0030bffa1359ca92$export$8ee0fc9ee280b4ee)(element)) return null;
    if ((0, $0030bffa1359ca92$export$62858bae88b53fd0)(element) || element === (0, $0030bffa1359ca92$export$b204af158042fbac)(element).scrollingElement) return window;
    if ((0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(element)) return element;
    return null;
}
function $0bb7808e9486acbd$var$getScrollXCoordinate(element) {
    if ((0, $0030bffa1359ca92$export$5a096129d439f843)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $0bb7808e9486acbd$var$getScrollYCoordinate(element) {
    if ((0, $0030bffa1359ca92$export$5a096129d439f843)(element)) return element.scrollY;
    return element.scrollTop;
}
function $0bb7808e9486acbd$var$getScrollCoordinates(element) {
    return {
        x: $0bb7808e9486acbd$var$getScrollXCoordinate(element),
        y: $0bb7808e9486acbd$var$getScrollYCoordinate(element)
    };
}
var $0bb7808e9486acbd$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($0bb7808e9486acbd$var$Direction || ($0bb7808e9486acbd$var$Direction = {}));
function $0bb7808e9486acbd$var$isDocumentScrollingElement(element) {
    if (!(0, $0030bffa1359ca92$export$71594e8a50f746f4) || !element) return false;
    return element === document.scrollingElement;
}
function $0bb7808e9486acbd$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $0bb7808e9486acbd$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
const $0bb7808e9486acbd$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $0bb7808e9486acbd$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top: top, left: left, right: right, bottom: bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = $0bb7808e9486acbd$var$defaultThreshold;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $0bb7808e9486acbd$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $0bb7808e9486acbd$var$Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $0bb7808e9486acbd$var$Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $0bb7808e9486acbd$var$Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $0bb7808e9486acbd$var$Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $0bb7808e9486acbd$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $0bb7808e9486acbd$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $0030bffa1359ca92$export$e16d8520af44a096)(acc, $0bb7808e9486acbd$var$getScrollCoordinates(node));
    }, $0bb7808e9486acbd$export$597cbd7bbd10deb4);
}
function $0bb7808e9486acbd$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $0bb7808e9486acbd$var$getScrollXCoordinate(node);
    }, 0);
}
function $0bb7808e9486acbd$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $0bb7808e9486acbd$var$getScrollYCoordinate(node);
    }, 0);
}
function $0bb7808e9486acbd$var$scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = $0bb7808e9486acbd$export$b6aa1f30c53d7454;
    if (!element) return;
    const { top: top, left: left, bottom: bottom, right: right } = measure(element);
    const firstScrollableAncestor = $0bb7808e9486acbd$var$getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: "center",
        inline: "center"
    });
}
const $0bb7808e9486acbd$var$properties = [
    [
        "x",
        [
            "left",
            "right"
        ],
        $0bb7808e9486acbd$var$getScrollXOffset
    ],
    [
        "y",
        [
            "top",
            "bottom"
        ],
        $0bb7808e9486acbd$var$getScrollYOffset
    ]
];
class $0bb7808e9486acbd$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $0bb7808e9486acbd$export$e4864aa91b5ed091(element);
        const scrollOffsets = $0bb7808e9486acbd$var$getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $0bb7808e9486acbd$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, "rect", {
            enumerable: false
        });
    }
}
class $0bb7808e9486acbd$var$Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function $0bb7808e9486acbd$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(target);
    return target instanceof EventTarget ? target : (0, $0030bffa1359ca92$export$b204af158042fbac)(target);
}
function $0bb7808e9486acbd$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === "number") return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ("x" in measurement && "y" in measurement) return dx > measurement.x && dy > measurement.y;
    if ("x" in measurement) return dx > measurement.x;
    if ("y" in measurement) return dy > measurement.y;
    return false;
}
var $0bb7808e9486acbd$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($0bb7808e9486acbd$var$EventName || ($0bb7808e9486acbd$var$EventName = {}));
function $0bb7808e9486acbd$var$preventDefault(event) {
    event.preventDefault();
}
function $0bb7808e9486acbd$var$stopPropagation(event) {
    event.stopPropagation();
}
var $0bb7808e9486acbd$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
})($0bb7808e9486acbd$export$a8b1916dba3ae88b || ($0bb7808e9486acbd$export$a8b1916dba3ae88b = {}));
const $0bb7808e9486acbd$var$defaultKeyboardCodes = {
    start: [
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Space,
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Space,
        $0bb7808e9486acbd$export$a8b1916dba3ae88b.Enter
    ]
};
const $0bb7808e9486acbd$var$defaultKeyboardCoordinateGetter = (event, _ref)=>{
    let { currentCoordinates: currentCoordinates } = _ref;
    switch(event.code){
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case $0bb7808e9486acbd$export$a8b1916dba3ae88b.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class $0bb7808e9486acbd$export$44d67f2a438aeba9 {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $0bb7808e9486acbd$var$Listeners((0, $0030bffa1359ca92$export$b204af158042fbac)(target));
        this.windowListeners = new $0bb7808e9486acbd$var$Listeners((0, $0030bffa1359ca92$export$38b2d434cce3ea22)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($0bb7808e9486acbd$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) $0bb7808e9486acbd$var$scrollIntoViewIfNeeded(node);
        onStart($0bb7808e9486acbd$export$597cbd7bbd10deb4);
    }
    handleKeyDown(event) {
        if ((0, $0030bffa1359ca92$export$130b789831072f4c)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $0bb7808e9486acbd$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $0bb7808e9486acbd$var$defaultKeyboardCoordinateGetter, scrollBehavior: scrollBehavior = "smooth" } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $0bb7808e9486acbd$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $0bb7808e9486acbd$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right && !isRight || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down && !isBottom || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right && newScrollCoordinates <= maxScroll.x || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down && newScrollCoordinates <= maxScroll.y || direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $0030bffa1359ca92$export$e16d8520af44a096)((0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$0bb7808e9486acbd$export$44d67f2a438aeba9.activators = [
    {
        eventName: "onKeyDown",
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes: keyboardCodes = $0bb7808e9486acbd$var$defaultKeyboardCodes, onActivation: onActivation } = _ref;
            let { active: active } = _ref2;
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $0bb7808e9486acbd$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && "distance" in constraint);
}
function $0bb7808e9486acbd$var$isDelayConstraint(constraint) {
    return Boolean(constraint && "delay" in constraint);
}
class $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = $0bb7808e9486acbd$var$getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $0030bffa1359ca92$export$b204af158042fbac)(target);
        this.documentListeners = new $0bb7808e9486acbd$var$Listeners(this.document);
        this.listeners = new $0bb7808e9486acbd$var$Listeners(listenerTarget);
        this.windowListeners = new $0bb7808e9486acbd$var$Listeners((0, $0030bffa1359ca92$export$38b2d434cce3ea22)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $0030bffa1359ca92$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint, bypassActivationConstraint: bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.DragStart, $0bb7808e9486acbd$var$preventDefault);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($0bb7808e9486acbd$var$EventName.ContextMenu, $0bb7808e9486acbd$var$preventDefault);
        this.documentListeners.add($0bb7808e9486acbd$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if ($0bb7808e9486acbd$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                return;
            }
            if ($0bb7808e9486acbd$var$isDistanceConstraint(activationConstraint)) return;
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($0bb7808e9486acbd$var$EventName.Click, $0bb7808e9486acbd$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($0bb7808e9486acbd$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $0030bffa1359ca92$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates2 : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
        const delta = (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if ($0bb7808e9486acbd$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $0bb7808e9486acbd$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($0bb7808e9486acbd$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if ($0bb7808e9486acbd$var$isDelayConstraint(activationConstraint)) {
                if ($0bb7808e9486acbd$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onEnd: onEnd } = this.props;
        this.detach();
        onEnd();
    }
    handleCancel() {
        const { onCancel: onCancel } = this.props;
        this.detach();
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $0bb7808e9486acbd$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const $0bb7808e9486acbd$var$events = {
    move: {
        name: "pointermove"
    },
    end: {
        name: "pointerup"
    }
};
class $0bb7808e9486acbd$export$b26af955418d6638 extends $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $0030bffa1359ca92$export$b204af158042fbac)(event.target);
        super(props, $0bb7808e9486acbd$var$events, listenerTarget);
    }
}
$0bb7808e9486acbd$export$b26af955418d6638.activators = [
    {
        eventName: "onPointerDown",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $0bb7808e9486acbd$var$events$1 = {
    move: {
        name: "mousemove"
    },
    end: {
        name: "mouseup"
    }
};
var $0bb7808e9486acbd$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($0bb7808e9486acbd$var$MouseButton || ($0bb7808e9486acbd$var$MouseButton = {}));
class $0bb7808e9486acbd$export$b28554b50bf7f273 extends $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props){
        super(props, $0bb7808e9486acbd$var$events$1, (0, $0030bffa1359ca92$export$b204af158042fbac)(props.event.target));
    }
}
$0bb7808e9486acbd$export$b28554b50bf7f273.activators = [
    {
        eventName: "onMouseDown",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (event.button === $0bb7808e9486acbd$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $0bb7808e9486acbd$var$events$2 = {
    move: {
        name: "touchmove"
    },
    end: {
        name: "touchend"
    }
};
class $0bb7808e9486acbd$export$19b41baf2e1bcdc0 extends $0bb7808e9486acbd$var$AbstractPointerSensor {
    constructor(props){
        super(props, $0bb7808e9486acbd$var$events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($0bb7808e9486acbd$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($0bb7808e9486acbd$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
$0bb7808e9486acbd$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: "onTouchStart",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
var $0bb7808e9486acbd$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($0bb7808e9486acbd$export$eefe60e26f04c318 || ($0bb7808e9486acbd$export$eefe60e26f04c318 = {}));
var $0bb7808e9486acbd$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($0bb7808e9486acbd$export$f93aa492a37e1b0e || ($0bb7808e9486acbd$export$f93aa492a37e1b0e = {}));
function $0bb7808e9486acbd$var$useAutoScroller(_ref) {
    let { acceleration: acceleration, activator: activator = $0bb7808e9486acbd$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $0bb7808e9486acbd$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, delta: delta, threshold: threshold } = _ref;
    const scrollIntent = $0bb7808e9486acbd$var$useScrollIntent({
        delta: delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $0030bffa1359ca92$export$f4b266cd2aae9cb1)();
    const scrollSpeed = (0, $acw62.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, $acw62.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, $acw62.useMemo)(()=>{
        switch(activator){
            case $0bb7808e9486acbd$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $0bb7808e9486acbd$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, $acw62.useRef)(null);
    const autoScroll = (0, $acw62.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $acw62.useMemo)(()=>order === $0bb7808e9486acbd$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $0bb7808e9486acbd$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                "x",
                "y"
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const $0bb7808e9486acbd$var$defaultScrollIntent = {
    x: {
        [$0bb7808e9486acbd$var$Direction.Backward]: false,
        [$0bb7808e9486acbd$var$Direction.Forward]: false
    },
    y: {
        [$0bb7808e9486acbd$var$Direction.Backward]: false,
        [$0bb7808e9486acbd$var$Direction.Forward]: false
    }
};
function $0bb7808e9486acbd$var$useScrollIntent(_ref2) {
    let { delta: delta, disabled: disabled } = _ref2;
    const previousDelta = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(delta);
    return (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return $0bb7808e9486acbd$var$defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [$0bb7808e9486acbd$var$Direction.Backward]: previousIntent.x[$0bb7808e9486acbd$var$Direction.Backward] || direction.x === -1,
                [$0bb7808e9486acbd$var$Direction.Forward]: previousIntent.x[$0bb7808e9486acbd$var$Direction.Forward] || direction.x === 1
            },
            y: {
                [$0bb7808e9486acbd$var$Direction.Backward]: previousIntent.y[$0bb7808e9486acbd$var$Direction.Backward] || direction.y === -1,
                [$0bb7808e9486acbd$var$Direction.Forward]: previousIntent.y[$0bb7808e9486acbd$var$Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function $0bb7808e9486acbd$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id !== null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((cachedNode)=>{
        var _ref;
        if (id === null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $0bb7808e9486acbd$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $acw62.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $0bb7808e9486acbd$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($0bb7808e9486acbd$export$571c10ffffe014ab || ($0bb7808e9486acbd$export$571c10ffffe014ab = {}));
var $0bb7808e9486acbd$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($0bb7808e9486acbd$export$8e062c3160beefd5 || ($0bb7808e9486acbd$export$8e062c3160beefd5 = {}));
const $0bb7808e9486acbd$var$defaultValue = /*#__PURE__*/ new Map();
function $0bb7808e9486acbd$var$useDroppableMeasuring(containers, _ref) {
    let { dragging: dragging, dependencies: dependencies, config: config } = _ref;
    const [queue, setQueue] = (0, $acw62.useState)(null);
    const { frequency: frequency, measure: measure, strategy: strategy } = config;
    const containersRef = (0, $acw62.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(disabled);
    const measureDroppableContainers = (0, $acw62.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, $acw62.useRef)(null);
    const droppableRects = (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (disabled && !dragging) return $0bb7808e9486acbd$var$defaultValue;
        if (!previousValue || previousValue === $0bb7808e9486acbd$var$defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $0bb7808e9486acbd$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, $acw62.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, $acw62.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, $acw62.useEffect)(()=>{
        if (disabled || typeof frequency !== "number" || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case $0bb7808e9486acbd$export$571c10ffffe014ab.Always:
                return false;
            case $0bb7808e9486acbd$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function $0bb7808e9486acbd$var$useInitialValue(value, computeFn) {
    return (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === "function" ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function $0bb7808e9486acbd$var$useInitialRect(node, measure) {
    return $0bb7808e9486acbd$var$useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function $0bb7808e9486acbd$var$useMutationObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleMutations = (0, $0030bffa1359ca92$export$90fc3a17d93f704c)(callback);
    const mutationObserver = (0, $acw62.useMemo)(()=>{
        if (disabled || typeof window === "undefined" || typeof window.MutationObserver === "undefined") return undefined;
        const { MutationObserver: MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $0bb7808e9486acbd$var$useResizeObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleResize = (0, $0030bffa1359ca92$export$90fc3a17d93f704c)(callback);
    const resizeObserver = (0, $acw62.useMemo)(()=>{
        if (disabled || typeof window === "undefined" || typeof window.ResizeObserver === "undefined") return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $0bb7808e9486acbd$var$defaultMeasure(element) {
    return new $0bb7808e9486acbd$var$Rect($0bb7808e9486acbd$export$b6aa1f30c53d7454(element), element);
}
function $0bb7808e9486acbd$var$useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = $0bb7808e9486acbd$var$defaultMeasure;
    const [rect, measureRect] = (0, $acw62.useReducer)(reducer, null);
    const mutationObserver = $0bb7808e9486acbd$var$useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type: type, target: target } = record;
                if (type === "childList" && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: measureRect
    });
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
    function reducer(currentRect) {
        if (!element) return null;
        if (element.isConnected === false) {
            var _ref;
            // Fall back to last rect we measured if the element is
            // no longer connected to the DOM.
            return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
        }
        const newRect = measure(element);
        if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
        return newRect;
    }
}
function $0bb7808e9486acbd$var$useRectDelta(rect) {
    const initialRect = $0bb7808e9486acbd$var$useInitialValue(rect);
    return $0bb7808e9486acbd$var$getRectDelta(rect, initialRect);
}
const $0bb7808e9486acbd$var$defaultValue$1 = [];
function $0bb7808e9486acbd$var$useScrollableAncestors(node) {
    const previousNode = (0, $acw62.useRef)(node);
    const ancestors = (0, $0030bffa1359ca92$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!node) return $0bb7808e9486acbd$var$defaultValue$1;
        if (previousValue && previousValue !== $0bb7808e9486acbd$var$defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $0bb7808e9486acbd$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $acw62.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $0bb7808e9486acbd$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $acw62.useState)(null);
    const prevElements = (0, $acw62.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $acw62.useCallback)((event)=>{
        const scrollingElement = $0bb7808e9486acbd$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $0bb7808e9486acbd$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $0bb7808e9486acbd$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener("scroll", handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $0bb7808e9486acbd$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $0bb7808e9486acbd$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener("scroll", handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $acw62.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $0030bffa1359ca92$export$e16d8520af44a096)(acc, coordinates), $0bb7808e9486acbd$export$597cbd7bbd10deb4) : $0bb7808e9486acbd$var$getScrollOffsets(elements);
        return $0bb7808e9486acbd$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function $0bb7808e9486acbd$var$useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, $acw62.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== $0bb7808e9486acbd$export$597cbd7bbd10deb4;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(scrollOffsets, initialScrollOffsets.current) : $0bb7808e9486acbd$export$597cbd7bbd10deb4;
}
function $0bb7808e9486acbd$var$useSensorSetup(sensors) {
    (0, $acw62.useEffect)(()=>{
        if (!(0, $0030bffa1359ca92$export$71594e8a50f746f4)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor: sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor: sensor } = _ref2;
        return sensor;
    }));
}
function $0bb7808e9486acbd$var$useSyntheticListeners(listeners, id) {
    return (0, $acw62.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName: eventName, handler: handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function $0bb7808e9486acbd$var$useWindowRect(element) {
    return (0, $acw62.useMemo)(()=>element ? $0bb7808e9486acbd$var$getWindowClientRect(element) : null, [
        element
    ]);
}
const $0bb7808e9486acbd$var$defaultValue$2 = [];
function $0bb7808e9486acbd$var$useRects(elements, measure) {
    if (measure === void 0) measure = $0bb7808e9486acbd$export$b6aa1f30c53d7454;
    const [firstElement] = elements;
    const windowRect = $0bb7808e9486acbd$var$useWindowRect(firstElement ? (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(firstElement) : null);
    const [rects, measureRects] = (0, $acw62.useReducer)(reducer, $0bb7808e9486acbd$var$defaultValue$2);
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: measureRects
    });
    if (elements.length > 0 && rects === $0bb7808e9486acbd$var$defaultValue$2) measureRects();
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (elements.length) elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
        else {
            resizeObserver == null || resizeObserver.disconnect();
            measureRects();
        }
    }, [
        elements
    ]);
    return rects;
    function reducer() {
        if (!elements.length) return $0bb7808e9486acbd$var$defaultValue$2;
        return elements.map((element)=>$0bb7808e9486acbd$var$isDocumentScrollingElement(element) ? windowRect : new $0bb7808e9486acbd$var$Rect(measure(element), element));
    }
}
function $0bb7808e9486acbd$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(firstChild) ? firstChild : node;
}
function $0bb7808e9486acbd$var$useDragOverlayMeasuring(_ref) {
    let { measure: measure } = _ref;
    const [rect, setRect] = (0, $acw62.useState)(null);
    const handleResize = (0, $acw62.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $0030bffa1359ca92$export$1b3bfaa9684536aa)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, $acw62.useCallback)((element)=>{
        const node = $0bb7808e9486acbd$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)(handleNodeChange);
    return (0, $acw62.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const $0bb7808e9486acbd$var$defaultSensors = [
    {
        sensor: $0bb7808e9486acbd$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $0bb7808e9486acbd$export$44d67f2a438aeba9,
        options: {}
    }
];
const $0bb7808e9486acbd$var$defaultData = {
    current: {}
};
const $0bb7808e9486acbd$var$defaultMeasuringConfiguration = {
    draggable: {
        measure: $0bb7808e9486acbd$var$getTransformAgnosticClientRect
    },
    droppable: {
        measure: $0bb7808e9486acbd$var$getTransformAgnosticClientRect,
        strategy: $0bb7808e9486acbd$export$571c10ffffe014ab.WhileDragging,
        frequency: $0bb7808e9486acbd$export$8e062c3160beefd5.Optimized
    },
    dragOverlay: {
        measure: $0bb7808e9486acbd$export$b6aa1f30c53d7454
    }
};
class $0bb7808e9486acbd$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled: disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $0bb7808e9486acbd$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $0bb7808e9486acbd$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $0bb7808e9486acbd$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: $0bb7808e9486acbd$var$defaultMeasuringConfiguration,
    measureDroppableContainers: $0bb7808e9486acbd$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $0bb7808e9486acbd$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ""
    },
    dispatch: $0bb7808e9486acbd$var$noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: $0bb7808e9486acbd$var$noop
};
const $0bb7808e9486acbd$var$InternalContext = /*#__PURE__*/ (0, $acw62.createContext)($0bb7808e9486acbd$var$defaultInternalContext);
const $0bb7808e9486acbd$var$PublicContext = /*#__PURE__*/ (0, $acw62.createContext)($0bb7808e9486acbd$var$defaultPublicContext);
function $0bb7808e9486acbd$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $0bb7808e9486acbd$var$DroppableContainersMap()
        }
    };
}
function $0bb7808e9486acbd$var$reducer(state, action) {
    switch(action.type){
        case $0bb7808e9486acbd$var$Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case $0bb7808e9486acbd$var$Action.DragMove:
            if (!state.draggable.active) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case $0bb7808e9486acbd$var$Action.DragEnd:
        case $0bb7808e9486acbd$var$Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case $0bb7808e9486acbd$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $0bb7808e9486acbd$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $0bb7808e9486acbd$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $0bb7808e9486acbd$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled: disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $0bb7808e9486acbd$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $0bb7808e9486acbd$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        default:
            return state;
    }
}
function $0bb7808e9486acbd$var$RestoreFocus(_ref) {
    let { disabled: disabled } = _ref;
    const { active: active, activatorEvent: activatorEvent, draggableNodes: draggableNodes } = (0, $acw62.useContext)($0bb7808e9486acbd$var$InternalContext);
    const previousActivatorEvent = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(activatorEvent);
    const previousActiveId = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, $acw62.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, $0030bffa1359ca92$export$130b789831072f4c)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode: activatorNode, node: node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, $0030bffa1359ca92$export$44f71d798fd0a62b)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function $0bb7808e9486acbd$export$f1696300e8775372(modifiers, _ref) {
    let { transform: transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function $0bb7808e9486acbd$var$useMeasuringConfiguration(config) {
    return (0, $acw62.useMemo)(()=>({
            draggable: {
                ...$0bb7808e9486acbd$var$defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...$0bb7808e9486acbd$var$defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...$0bb7808e9486acbd$var$defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function $0bb7808e9486acbd$var$useLayoutShiftScrollCompensation(_ref) {
    let { activeNode: activeNode, measure: measure, initialRect: initialRect, config: config = true } = _ref;
    const initialized = (0, $acw62.useRef)(false);
    const { x: x, y: y } = typeof config === "boolean" ? {
        x: config,
        y: config
    } : config;
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = $0bb7808e9486acbd$var$getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = $0bb7808e9486acbd$var$getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const $0bb7808e9486acbd$var$ActiveDraggableContext = /*#__PURE__*/ (0, $acw62.createContext)({
    ...$0bb7808e9486acbd$export$597cbd7bbd10deb4,
    scaleX: 1,
    scaleY: 1
});
var $0bb7808e9486acbd$var$Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})($0bb7808e9486acbd$var$Status || ($0bb7808e9486acbd$var$Status = {}));
const $0bb7808e9486acbd$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $acw62.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id: id, accessibility: accessibility, autoScroll: autoScroll = true, children: children, sensors: sensors = $0bb7808e9486acbd$var$defaultSensors, collisionDetection: collisionDetection = $0bb7808e9486acbd$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers, ...props } = _ref;
    const store = (0, $acw62.useReducer)($0bb7808e9486acbd$var$reducer, undefined, $0bb7808e9486acbd$var$getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = $0bb7808e9486acbd$var$useDndMonitorProvider();
    const [status, setStatus] = (0, $acw62.useState)($0bb7808e9486acbd$var$Status.Uninitialized);
    const isInitialized = status === $0bb7808e9486acbd$var$Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId ? draggableNodes.get(activeId) : null;
    const activeRects = (0, $acw62.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $acw62.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $0bb7808e9486acbd$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $acw62.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $acw62.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $acw62.useState)(null);
    const latestProps = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(props, Object.values(props));
    const draggableDescribedById = (0, $0030bffa1359ca92$export$c485849f2e393253)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, $acw62.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = $0bb7808e9486acbd$var$useMeasuringConfiguration(measuring);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $0bb7808e9486acbd$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = $0bb7808e9486acbd$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, $acw62.useMemo)(()=>activatorEvent ? (0, $0030bffa1359ca92$export$36195c8aa1517e04)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = $0bb7808e9486acbd$var$useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    $0bb7808e9486acbd$var$useLayoutShiftScrollCompensation({
        activeNode: activeId ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = $0bb7808e9486acbd$var$useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = $0bb7808e9486acbd$var$useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $acw62.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $0bb7808e9486acbd$var$useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = $0bb7808e9486acbd$var$useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = $0bb7808e9486acbd$var$useWindowRect(draggingNode ? (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $0bb7808e9486acbd$var$useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = $0bb7808e9486acbd$var$useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $0bb7808e9486acbd$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $0030bffa1359ca92$export$e16d8520af44a096)(activationCoordinates, translate) : null;
    const scrollOffsets = $0bb7808e9486acbd$var$useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = $0bb7808e9486acbd$var$useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = $0bb7808e9486acbd$var$useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, $0030bffa1359ca92$export$e16d8520af44a096)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $0bb7808e9486acbd$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableRects: droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $0bb7808e9486acbd$export$ef1beab6d7287295(collisions, "id");
    const [over, setOver] = (0, $acw62.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, $0030bffa1359ca92$export$e16d8520af44a096)(modifiedTranslate, activeNodeScrollDelta);
    const transform = $0bb7808e9486acbd$var$adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const instantiateSensor = (0, $acw62.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options: options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: activatorEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    active: {
                        id: id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus($0bb7808e9486acbd$var$Status.Initializing);
                    dispatch({
                        type: $0bb7808e9486acbd$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: "onDragStart",
                        event: event
                    });
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: $0bb7808e9486acbd$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($0bb7808e9486acbd$var$Action.DragEnd),
            onCancel: createHandler($0bb7808e9486acbd$var$Action.DragCancel)
        });
        (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
            setActiveSensor(sensorInstance);
            setActivatorEvent(event.nativeEvent);
        });
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent: activatorEvent,
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $0bb7808e9486acbd$var$Action.DragEnd && typeof cancelDrop === "function") {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $0bb7808e9486acbd$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setStatus($0bb7808e9486acbd$var$Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    const eventName = type === $0bb7808e9486acbd$var$Action.DragEnd ? "onDragEnd" : "onDragCancel";
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event: event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $acw62.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = $0bb7808e9486acbd$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $0bb7808e9486acbd$var$useSensorSetup(sensors);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (activeNodeRect && status === $0bb7808e9486acbd$var$Status.Initializing) setStatus($0bb7808e9486acbd$var$Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, $acw62.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, over: over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: "onDragMove",
                event: event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $acw62.useEffect)(()=>{
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: "onDragOver",
                event: event
            });
        });
    }, [
        overId
    ]);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        sensorContext.current = {
            activatorEvent: activatorEvent,
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $0bb7808e9486acbd$var$useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    });
    const publicContext = (0, $acw62.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringConfiguration: measuringConfiguration,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $acw62.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === "object" ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === "object") return {
            ...autoScroll,
            enabled: enabled
        };
        return {
            enabled: enabled
        };
    }
});
const $0bb7808e9486acbd$var$NullContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $0bb7808e9486acbd$var$defaultRole = "button";
const $0bb7808e9486acbd$var$ID_PREFIX = "Droppable";
function $0bb7808e9486acbd$export$df30c81f5aa01ff7(_ref) {
    let { id: id, data: data, disabled: disabled = false, attributes: attributes } = _ref;
    const key = (0, $0030bffa1359ca92$export$c485849f2e393253)($0bb7808e9486acbd$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $acw62.useContext)($0bb7808e9486acbd$var$InternalContext);
    const { role: role = $0bb7808e9486acbd$var$defaultRole, roleDescription: roleDescription = "draggable", tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $acw62.useContext)(isDragging ? $0bb7808e9486acbd$var$ActiveDraggableContext : $0bb7808e9486acbd$var$NullContext);
    const [node, setNodeRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)();
    const [activatorNode, setActivatorNodeRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)();
    const listeners = $0bb7808e9486acbd$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(data);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        draggableNodes.set(id, {
            id: id,
            key: key,
            node: node,
            activatorNode: activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $acw62.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            "aria-disabled": disabled,
            "aria-pressed": isDragging && role === $0bb7808e9486acbd$var$defaultRole ? true : undefined,
            "aria-roledescription": roleDescription,
            "aria-describedby": ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        transform: transform
    };
}
function $0bb7808e9486acbd$export$4930f6bf413be70e() {
    return (0, $acw62.useContext)($0bb7808e9486acbd$var$PublicContext);
}
const $0bb7808e9486acbd$var$ID_PREFIX$1 = "Droppable";
const $0bb7808e9486acbd$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $0bb7808e9486acbd$export$d74e5d67dc2b3176(_ref) {
    let { data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig } = _ref;
    const key = (0, $0030bffa1359ca92$export$c485849f2e393253)($0bb7808e9486acbd$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $acw62.useContext)($0bb7808e9486acbd$var$InternalContext);
    const previous = (0, $acw62.useRef)({
        disabled: disabled
    });
    const resizeObserverConnected = (0, $acw62.useRef)(false);
    const rect = (0, $acw62.useRef)(null);
    const callbackId = (0, $acw62.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...$0bb7808e9486acbd$var$defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $acw62.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $0bb7808e9486acbd$var$useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $acw62.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $0030bffa1359ca92$export$bc23c270f170c912)(handleNodeChange);
    const dataRef = (0, $0030bffa1359ca92$export$86c4283a11f23f95)(data);
    (0, $acw62.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        dispatch({
            type: $0bb7808e9486acbd$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $0bb7808e9486acbd$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $acw62.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: $0bb7808e9486acbd$var$Action.SetDroppableDisabled,
                id: id,
                key: key,
                disabled: disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
function $0bb7808e9486acbd$var$AnimationManager(_ref) {
    let { animation: animation, children: children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, $acw62.useState)(null);
    const [element, setElement] = (0, $acw62.useState)(null);
    const previousChildren = (0, $0030bffa1359ca92$export$5cae361ad82dce8b)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children, clonedChildren ? (0, $acw62.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const $0bb7808e9486acbd$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function $0bb7808e9486acbd$var$NullifiedContextProvider(_ref) {
    let { children: children } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$InternalContext.Provider, {
        value: $0bb7808e9486acbd$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$ActiveDraggableContext.Provider, {
        value: $0bb7808e9486acbd$var$defaultTransform
    }, children));
}
const $0bb7808e9486acbd$var$baseStyles = {
    position: "fixed",
    touchAction: "none"
};
const $0bb7808e9486acbd$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $0030bffa1359ca92$export$130b789831072f4c)(activatorEvent);
    return isKeyboardActivator ? "transform 250ms ease" : undefined;
};
const $0bb7808e9486acbd$var$PositionedOverlay = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref, ref)=>{
    let { as: as, activatorEvent: activatorEvent, adjustScale: adjustScale, children: children, className: className, rect: rect, style: style, transform: transform, transition: transition = $0bb7808e9486acbd$var$defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...$0bb7808e9486acbd$var$baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? $0bb7808e9486acbd$var$getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === "function" ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(as, {
        className: className,
        style: styles,
        ref: ref
    }, children);
});
const $0bb7808e9486acbd$export$28c62adcaabe654c = (options)=>(_ref)=>{
        let { active: active, dragOverlay: dragOverlay } = _ref;
        const originalStyles = {};
        const { styles: styles, className: className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const $0bb7808e9486acbd$var$defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial: initial, final: final } } = _ref2;
    return [
        {
            transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(initial)
        },
        {
            transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transform.toString(final)
        }
    ];
};
const $0bb7808e9486acbd$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: "ease",
    keyframes: $0bb7808e9486acbd$var$defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ $0bb7808e9486acbd$export$28c62adcaabe654c({
        styles: {
            active: {
                opacity: "0"
            }
        }
    })
};
function $0bb7808e9486acbd$var$useDropAnimation(_ref3) {
    let { config: config, draggableNodes: draggableNodes, droppableContainers: droppableContainers, measuringConfiguration: measuringConfiguration } = _ref3;
    return (0, $0030bffa1359ca92$export$90fc3a17d93f704c)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = $0bb7808e9486acbd$var$getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform: transform } = (0, $0030bffa1359ca92$export$38b2d434cce3ea22)(node).getComputedStyle(node);
        const parsedTransform = $0bb7808e9486acbd$var$parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === "function" ? config : $0bb7808e9486acbd$var$createDefaultDropAnimation(config);
        $0bb7808e9486acbd$var$scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id: id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes: draggableNodes,
            dragOverlay: {
                node: node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers: droppableContainers,
            measuringConfiguration: measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function $0bb7808e9486acbd$var$createDefaultDropAnimation(options) {
    const { duration: duration, easing: easing, sideEffects: sideEffects, keyframes: keyframes } = {
        ...$0bb7808e9486acbd$export$10f7ab1c653bb60e,
        ...options
    };
    return (_ref4)=>{
        let { active: active, dragOverlay: dragOverlay, transform: transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active: active,
            dragOverlay: dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active: active,
            dragOverlay: dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration: duration,
            easing: easing,
            fill: "forwards"
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let $0bb7808e9486acbd$var$key = 0;
function $0bb7808e9486acbd$var$useKey(id) {
    return (0, $acw62.useMemo)(()=>{
        if (id == null) return;
        $0bb7808e9486acbd$var$key++;
        return $0bb7808e9486acbd$var$key;
    }, [
        id
    ]);
}
const $0bb7808e9486acbd$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo((_ref)=>{
    let { adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimationConfig, style: style, transition: transition, modifiers: modifiers, wrapperElement: wrapperElement = "div", className: className, zIndex: zIndex = 999 } = _ref;
    const { activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, droppableContainers: droppableContainers, dragOverlay: dragOverlay, over: over, measuringConfiguration: measuringConfiguration, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $0bb7808e9486acbd$export$4930f6bf413be70e();
    const transform = (0, $acw62.useContext)($0bb7808e9486acbd$var$ActiveDraggableContext);
    const key = $0bb7808e9486acbd$var$useKey(active == null ? void 0 : active.id);
    const modifiedTransform = $0bb7808e9486acbd$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const initialRect = $0bb7808e9486acbd$var$useInitialValue(activeNodeRect);
    const dropAnimation = $0bb7808e9486acbd$var$useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes: draggableNodes,
        droppableContainers: droppableContainers,
        measuringConfiguration: measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$NullifiedContextProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0bb7808e9486acbd$var$PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex: zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});



var $acw62 = parcelRequire("acw62");


/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $0332ec5baeac6793$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $0332ec5baeac6793$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $0332ec5baeac6793$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $0332ec5baeac6793$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
function $0332ec5baeac6793$var$itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $0332ec5baeac6793$var$normalizeDisabled(disabled) {
    if (typeof disabled === "boolean") return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const $0332ec5baeac6793$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $0332ec5baeac6793$export$7a687825fa98548a = (_ref)=>{
    var _rects$activeIndex;
    let { rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $0332ec5baeac6793$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...$0332ec5baeac6793$var$defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale
    };
};
function $0332ec5baeac6793$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $0332ec5baeac6793$export$9377a9486e3fbbe1 = (_ref)=>{
    let { rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const newRects = $0332ec5baeac6793$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $0332ec5baeac6793$export$8b26fb37076c162 = (_ref)=>{
    let { activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $0332ec5baeac6793$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $0332ec5baeac6793$export$fe2be640df2ffb9e = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...$0332ec5baeac6793$var$defaultScale$1
        };
    }
    const itemGap = $0332ec5baeac6793$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...$0332ec5baeac6793$var$defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...$0332ec5baeac6793$var$defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...$0332ec5baeac6793$var$defaultScale$1
    };
};
function $0332ec5baeac6793$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $0332ec5baeac6793$var$ID_PREFIX = "Sortable";
const $0332ec5baeac6793$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    activeIndex: -1,
    containerId: $0332ec5baeac6793$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $0332ec5baeac6793$export$9377a9486e3fbbe1,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function $0332ec5baeac6793$export$86155fde54f06e6a(_ref) {
    let { children: children, id: id, items: userDefinedItems, strategy: strategy = $0332ec5baeac6793$export$9377a9486e3fbbe1, disabled: disabledProp = false } = _ref;
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $0bb7808e9486acbd$export$4930f6bf413be70e)();
    const containerId = (0, $0030bffa1359ca92$export$c485849f2e393253)($0332ec5baeac6793$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $acw62.useMemo)(()=>userDefinedItems.map((item)=>typeof item === "object" && "id" in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $acw62.useRef)(items);
    const itemsHaveChanged = !$0332ec5baeac6793$var$itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = $0332ec5baeac6793$var$normalizeDisabled(disabledProp);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, $acw62.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $acw62.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disabled: disabled,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $0332ec5baeac6793$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0332ec5baeac6793$var$Context.Provider, {
        value: contextValue
    }, children);
}
const $0332ec5baeac6793$export$e1ca29a833a61b5e = (_ref)=>{
    let { id: id, items: items, activeIndex: activeIndex, overIndex: overIndex } = _ref;
    return $0332ec5baeac6793$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
};
const $0332ec5baeac6793$export$633d85fd1dcf5e11 = (_ref2)=>{
    let { containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $0332ec5baeac6793$var$defaultTransition = {
    duration: 200,
    easing: "ease"
};
const $0332ec5baeac6793$var$transitionProperty = "transform";
const $0332ec5baeac6793$var$disabledTransition = /*#__PURE__*/ (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transition.toString({
    property: $0332ec5baeac6793$var$transitionProperty,
    duration: 0,
    easing: "linear"
});
const $0332ec5baeac6793$var$defaultAttributes = {
    roleDescription: "sortable"
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $0332ec5baeac6793$var$useDerivedTransform(_ref) {
    let { disabled: disabled, index: index, node: node, rect: rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, $acw62.useState)(null);
    const previousIndex = (0, $acw62.useRef)(index);
    (0, $0030bffa1359ca92$export$700979bc83e7db82)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $0bb7808e9486acbd$export$b6aa1f30c53d7454)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $acw62.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $0332ec5baeac6793$export$4ebcb6201122185a(_ref) {
    let { animateLayoutChanges: animateLayoutChanges = $0332ec5baeac6793$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex: getNewIndex = $0332ec5baeac6793$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $0332ec5baeac6793$var$defaultTransition } = _ref;
    const { items: items, containerId: containerId, activeIndex: activeIndex, disabled: globalDisabled, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $acw62.useContext)($0332ec5baeac6793$var$Context);
    const disabled = $0332ec5baeac6793$var$normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, $acw62.useMemo)(()=>({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $acw62.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $0bb7808e9486acbd$export$d74e5d67dc2b3176)({
        id: id,
        data: data,
        disabled: disabled.droppable,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, setActivatorNodeRef: setActivatorNodeRef, transform: transform } = (0, $0bb7808e9486acbd$export$df30c81f5aa01ff7)({
        id: id,
        data: data,
        attributes: {
            ...$0332ec5baeac6793$var$defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled.draggable
    });
    const setNodeRef = (0, $0030bffa1359ca92$export$2f8294366bb2d67a)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $0332ec5baeac6793$var$isValidIndex(activeIndex) && $0332ec5baeac6793$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $0332ec5baeac6793$var$isValidIndex(activeIndex) && $0332ec5baeac6793$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $acw62.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $0332ec5baeac6793$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $acw62.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, $acw62.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId && !previous.current.activeId) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        data: data,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $0332ec5baeac6793$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $0030bffa1359ca92$export$130b789831072f4c)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $0030bffa1359ca92$export$c4ffa16951855e28).Transition.toString({
            ...transition,
            property: $0332ec5baeac6793$var$transitionProperty
        });
        return undefined;
    }
}
function $0332ec5baeac6793$var$normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === "boolean") return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function $0332ec5baeac6793$export$6424ec8a0d450b09(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && "sortable" in data && typeof data.sortable === "object" && "containerId" in data.sortable && "items" in data.sortable && "index" in data.sortable) return true;
    return false;
}
const $0332ec5baeac6793$var$directions = [
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Down,
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Right,
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Up,
    (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Left
];
const $0332ec5baeac6793$export$a6f27ecf02eb3a67 = (event, _ref)=>{
    let { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers, over: over, scrollableAncestors: scrollableAncestors } } = _ref;
    if ($0332ec5baeac6793$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $0bb7808e9486acbd$export$c3a6c1c7122b31c9)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, $0bb7808e9486acbd$export$ef1beab6d7287295)(collisions, "id");
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, $0bb7808e9486acbd$export$e4864aa91b5ed091)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = $0332ec5baeac6793$var$isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = $0332ec5baeac6793$var$isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function $0332ec5baeac6793$var$isSameContainer(a, b) {
    if (!$0332ec5baeac6793$export$6424ec8a0d450b09(a) || !$0332ec5baeac6793$export$6424ec8a0d450b09(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function $0332ec5baeac6793$var$isAfter(a, b) {
    if (!$0332ec5baeac6793$export$6424ec8a0d450b09(a) || !$0332ec5baeac6793$export$6424ec8a0d450b09(b)) return false;
    if (!$0332ec5baeac6793$var$isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");

var $acabd904aed1b421$export$2e2bcd8739ae039 = {
    "handle": "awsui_handle_iykw5_omtw8_97",
    "hide-focus": "awsui_hide-focus_iykw5_omtw8_111"
};


function $9cf3a14b18f3e6b9$export$2e2bcd8739ae039(props) {
    // We need to use a div with button role instead of a button
    // so that Safari will focus on it when clicking it.
    // (See https://bugs.webkit.org/show_bug.cgi?id=22261)
    // Otherwise, we can't reliably catch keyboard events coming from the handle
    // when it is being dragged.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        role: "button",
        tabIndex: 0
    }, props, {
        onPointerDown: props.onPointerDown,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $acabd904aed1b421$export$2e2bcd8739ae039).handle, props.className)
    }));
}




var $b8ce152421b53bab$export$2e2bcd8739ae039 = {
    "handle": "awsui_handle_sdha6_1v8zk_5"
};




function $02800872363c99e3$export$2e2bcd8739ae039({ attributes: attributes, hideFocus: hideFocus, listeners: listeners }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9cf3a14b18f3e6b9$export$2e2bcd8739ae039), Object.assign({
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $b8ce152421b53bab$export$2e2bcd8739ae039).handle, hideFocus && (0, $acabd904aed1b421$export$2e2bcd8739ae039)["hide-focus"])
    }, attributes, listeners), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ede5ec7997eb329$export$2e2bcd8739ae039), {
        name: "drag-indicator"
    }));
}




var $acw62 = parcelRequire("acw62");

const $d5e9a9b18af560cf$var$componentPrefix = "content-display-option";
const $d5e9a9b18af560cf$export$307b18b61172f7ed = (suffix)=>(0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)[[
        $d5e9a9b18af560cf$var$componentPrefix,
        suffix
    ].filter(Boolean).join("-")];
const $d5e9a9b18af560cf$var$ContentDisplayOption = (0, $acw62.forwardRef)(({ dragHandleAriaLabel: dragHandleAriaLabel, listeners: listeners, onToggle: onToggle, option: option }, ref)=>{
    const idPrefix = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)($d5e9a9b18af560cf$var$componentPrefix);
    const controlId = `${idPrefix}-control-${option.id}`;
    const dragHandleAttributes = {
        ["aria-label"]: [
            dragHandleAriaLabel,
            option.label
        ].join(", ")
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: $d5e9a9b18af560cf$export$307b18b61172f7ed("content")
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $02800872363c99e3$export$2e2bcd8739ae039), {
        attributes: dragHandleAttributes,
        listeners: listeners
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        className: $d5e9a9b18af560cf$export$307b18b61172f7ed("label"),
        htmlFor: controlId
    }, option.label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $d5e9a9b18af560cf$export$307b18b61172f7ed("toggle")
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9b746e4e3748705e$export$2e2bcd8739ae039), {
        checked: !!option.visible,
        onChange: ()=>onToggle && onToggle(option),
        disabled: option.alwaysVisible === true,
        controlId: controlId
    })));
});
var $d5e9a9b18af560cf$export$2e2bcd8739ae039 = $d5e9a9b18af560cf$var$ContentDisplayOption;




function $8ea9993898ad3542$export$2e2bcd8739ae039({ dragHandleAriaLabel: dragHandleAriaLabel, onKeyDown: onKeyDown, onToggle: onToggle, option: option }) {
    const { isDragging: isDragging, isSorting: isSorting, listeners: listeners, setNodeRef: setNodeRef, transform: transform } = (0, $0332ec5baeac6793$export$4ebcb6201122185a)({
        id: option.id
    });
    const style = {
        transform: (0, $0030bffa1359ca92$export$c4ffa16951855e28).Translate.toString(transform)
    };
    const combinedListeners = Object.assign(Object.assign({}, listeners), {
        onKeyDown: (event)=>{
            if (onKeyDown) onKeyDown(event);
            if (listeners === null || listeners === void 0 ? void 0 : listeners.onKeyDown) listeners.onKeyDown(event);
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $d5e9a9b18af560cf$export$307b18b61172f7ed)(), isDragging && (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039).placeholder, isSorting && (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039).sorting),
        style: style
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5e9a9b18af560cf$export$2e2bcd8739ae039), {
        ref: setNodeRef,
        listeners: combinedListeners,
        dragHandleAriaLabel: dragHandleAriaLabel,
        onToggle: onToggle,
        option: option
    }));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function $c71a166cfc63f5c4$var$isDocumentScrollingElement(element) {
    if (!(0, $0030bffa1359ca92$export$71594e8a50f746f4) || !element) return false;
    return element === document.scrollingElement;
}
function $c71a166cfc63f5c4$export$3abe133d5501edeb(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $c71a166cfc63f5c4$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
function $c71a166cfc63f5c4$export$c6839d6549bc1796(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $c71a166cfc63f5c4$export$d9e2a939777fb2bd({ currentCoordinates: currentCoordinates, direction: direction, newCoordinates: newCoordinates, scrollableAncestors: scrollableAncestors }) {
    for (const scrollContainer of scrollableAncestors){
        const coordinatesDelta = (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(newCoordinates, currentCoordinates);
        const { isTop: isTop, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $c71a166cfc63f5c4$export$3abe133d5501edeb(scrollContainer);
        const scrollElementRect = $c71a166cfc63f5c4$export$c6839d6549bc1796(scrollContainer);
        const clampedCoordinates = {
            y: Math.min(direction === (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
        };
        const canScrollY = direction === (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Down && !isBottom || direction === (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Up && !isTop;
        if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
            const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
            const canScrollToNewCoordinates = direction === (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Down && newScrollCoordinates <= maxScroll.y || direction === (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Up && newScrollCoordinates >= minScroll.y;
            if (canScrollToNewCoordinates) {
                // We don't need to update coordinates, the scroll adjustment alone will trigger
                // logic to auto-detect the new container we are over
                scrollContainer.scrollTo({
                    top: newScrollCoordinates,
                    behavior: "smooth"
                });
                return true;
            }
            break;
        }
    }
    return false;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $375deb9eb59f5d5e$export$8e49444f78fbbdb8;
(function(EventName) {
    EventName["Blur"] = "blur";
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($375deb9eb59f5d5e$export$8e49444f78fbbdb8 || ($375deb9eb59f5d5e$export$8e49444f78fbbdb8 = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $fa5c6c01f152bfff$export$3bcecaeba2732bae {
    constructor(target){
        this.target = target;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _a;
                return (_a = this.target) === null || _a === void 0 ? void 0 : _a.removeEventListener(...listener);
            });
        };
    }
    add(eventName, handler, options) {
        var _a;
        (_a = this.target) === null || _a === void 0 || _a.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

const $9a0122baf4323fa3$export$f540d32a5bb3e030 = {
    start: [
        (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Space,
        (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Enter
    ],
    cancel: [
        (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Esc
    ],
    end: [
        (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Space,
        (0, $0bb7808e9486acbd$export$a8b1916dba3ae88b).Enter
    ]
};



class $8d70165ffa441299$export$44d67f2a438aeba9 {
    constructor(props){
        this.props = props;
        this.autoScrollEnabled = false;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new (0, $fa5c6c01f152bfff$export$3bcecaeba2732bae)((0, $0030bffa1359ca92$export$b204af158042fbac)(target));
        this.windowListeners = new (0, $fa5c6c01f152bfff$export$3bcecaeba2732bae)((0, $0030bffa1359ca92$export$38b2d434cce3ea22)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        var _a;
        this.handleStart();
        this.windowListeners.add((0, $375deb9eb59f5d5e$export$8e49444f78fbbdb8).Resize, this.handleCancel);
        this.windowListeners.add((0, $375deb9eb59f5d5e$export$8e49444f78fbbdb8).VisibilityChange, this.handleCancel);
        // Customization: deactivate reordering on blur event
        (_a = this.props.event.target) === null || _a === void 0 || _a.addEventListener((0, $375deb9eb59f5d5e$export$8e49444f78fbbdb8).Blur, this.handleCancel);
        setTimeout(()=>this.listeners.add((0, $375deb9eb59f5d5e$export$8e49444f78fbbdb8).Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) (0, $24d40242cc6554ee$export$a904af9c1628c179)(node);
        onStart((0, $0bb7808e9486acbd$export$597cbd7bbd10deb4));
    }
    handleKeyDown(event) {
        if ((0, $0030bffa1359ca92$export$130b789831072f4c)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = (0, $9a0122baf4323fa3$export$f540d32a5bb3e030), coordinateGetter: coordinateGetter } = options;
            const { code: code } = event;
            if (keyboardCodes.end.indexOf(code) !== -1) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.indexOf(code) !== -1) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : (0, $0bb7808e9486acbd$export$597cbd7bbd10deb4);
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            if (!coordinateGetter) return;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const { scrollableAncestors: scrollableAncestors } = context.current;
                const direction = event.code;
                const scrolled = (0, $c71a166cfc63f5c4$export$d9e2a939777fb2bd)({
                    currentCoordinates: currentCoordinates,
                    direction: direction,
                    newCoordinates: newCoordinates,
                    scrollableAncestors: scrollableAncestors
                });
                if (!scrolled) this.handleMove(event, (0, $0030bffa1359ca92$export$4e2d2ead65e5f7e3)(newCoordinates, this.referenceCoordinates));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        // Customization: do not prevent browser from managing native focus
        if (event.type !== (0, $375deb9eb59f5d5e$export$8e49444f78fbbdb8).Blur) event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        var _a;
        // Customization: clean up listener for blur event
        (_a = this.props.event.target) === null || _a === void 0 || _a.removeEventListener((0, $375deb9eb59f5d5e$export$8e49444f78fbbdb8).Blur, this.handleCancel);
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$8d70165ffa441299$export$44d67f2a438aeba9.activators = [
    {
        eventName: "onKeyDown",
        handler: (event, { keyboardCodes: keyboardCodes = (0, $9a0122baf4323fa3$export$f540d32a5bb3e030), onActivation: onActivation }, { active: active })=>{
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.indexOf(code) !== -1) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation === null || onActivation === void 0 || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];


var $c640cc9bbb4535c7$var$KeyboardCode;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
})($c640cc9bbb4535c7$var$KeyboardCode || ($c640cc9bbb4535c7$var$KeyboardCode = {}));
function $c640cc9bbb4535c7$export$2e2bcd8739ae039({ sortedOptions: sortedOptions }) {
    const isKeyboard = (0, $acw62.useRef)(false);
    const positionDelta = (0, $acw62.useRef)(0);
    const [activeItemId, setActiveItemId] = (0, $acw62.useState)(null);
    const setActiveItem = (id)=>{
        setActiveItemId(id);
        if (!id) {
            isKeyboard.current = false;
            positionDelta.current = 0;
        }
    };
    const handleKeyDown = (event)=>{
        if (isKeyboard.current && activeItemId) {
            const currentTargetIndex = sortedOptions.findIndex(({ id: id })=>id === activeItemId) + positionDelta.current;
            if (event.key === "ArrowDown" && currentTargetIndex < sortedOptions.length - 1) positionDelta.current += 1;
            else if (event.key === "ArrowUp" && currentTargetIndex > 0) positionDelta.current -= 1;
        }
        if (activeItemId && $c640cc9bbb4535c7$var$isEscape(event.key)) // Prevent modal from closing when pressing Esc to cancel the dragging action
        event.stopPropagation();
    };
    const getClosestId = (active)=>{
        if (positionDelta.current === 0) return active.id;
        const currentIndex = sortedOptions.findIndex(({ id: id })=>id === active.id);
        const newIndex = Math.max(0, Math.min(sortedOptions.length - 1, currentIndex + positionDelta.current));
        return sortedOptions[newIndex].id;
    };
    const collisionDetection = ({ active: active, collisionRect: collisionRect, droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates })=>{
        if (isKeyboard.current) {
            // For keyboard interaction, determine the colliding container based on the movements made by the arrow keys,
            // via getClosestId
            const collidingContainer = $c640cc9bbb4535c7$var$getCollidingContainer({
                activeId: active.id,
                closestId: getClosestId(active),
                droppableContainers: droppableContainers
            });
            return collidingContainer ? [
                collidingContainer
            ] : [];
        } else // For mouse interaction, use the closest center algorithm
        return (0, $0bb7808e9486acbd$export$c8e785ae6b74bab8)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: droppableContainers,
            pointerCoordinates: pointerCoordinates
        });
    };
    const coordinateGetter = (event, { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } })=>{
        if (event.code === $c640cc9bbb4535c7$var$KeyboardCode.Up || event.code === $c640cc9bbb4535c7$var$KeyboardCode.Down) {
            event.preventDefault();
            if (!active || !collisionRect) return;
            const closestId = getClosestId(active);
            if (closestId !== null) {
                const activeDroppable = droppableContainers.get(active.id);
                const newDroppable = droppableContainers.get(closestId);
                const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
                const newNode = newDroppable === null || newDroppable === void 0 ? void 0 : newDroppable.node.current;
                if (newNode && newRect && activeDroppable && newDroppable) {
                    const isAfterActive = $c640cc9bbb4535c7$var$isAfter(activeDroppable, newDroppable);
                    const offset = {
                        x: isAfterActive ? collisionRect.width - newRect.width : 0,
                        y: isAfterActive ? collisionRect.height - newRect.height : 0
                    };
                    const rectCoordinates = {
                        x: newRect.left,
                        y: newRect.top
                    };
                    return {
                        x: rectCoordinates.x - offset.x,
                        y: rectCoordinates.y - offset.y
                    };
                }
            }
        }
    };
    const sensors = (0, $0bb7808e9486acbd$export$19012f58216d597f)((0, $0bb7808e9486acbd$export$cc72dd71f4ec69eb)((0, $0bb7808e9486acbd$export$b26af955418d6638)), (0, $0bb7808e9486acbd$export$cc72dd71f4ec69eb)((0, $8d70165ffa441299$export$44d67f2a438aeba9), {
        coordinateGetter: coordinateGetter,
        onActivation: ()=>{
            isKeyboard.current = true;
        }
    }));
    return {
        activeItem: activeItemId,
        collisionDetection: collisionDetection,
        coordinateGetter: coordinateGetter,
        handleKeyDown: handleKeyDown,
        sensors: sensors,
        setActiveItem: setActiveItem
    };
}
function $c640cc9bbb4535c7$var$isAfter(a, b) {
    return (0, $0332ec5baeac6793$export$6424ec8a0d450b09)(a) && (0, $0332ec5baeac6793$export$6424ec8a0d450b09)(b) && a.data.current.sortable.index < b.data.current.sortable.index;
}
function $c640cc9bbb4535c7$var$getCollidingContainer({ activeId: activeId, closestId: closestId, droppableContainers: droppableContainers }) {
    if (closestId === activeId) return;
    const collidingContainer = droppableContainers.find(({ id: id })=>id === closestId);
    if (collidingContainer) return {
        id: collidingContainer.id,
        data: {
            droppableContainer: collidingContainer,
            value: 0
        }
    };
}
const $c640cc9bbb4535c7$var$isEscape = (key)=>key === "Escape" || key === "Esc";



var $acw62 = parcelRequire("acw62");
function $d9c9ea54fe77eabd$export$2e2bcd8739ae039({ isDragging: isDragging, liveAnnouncementDndStarted: liveAnnouncementDndStarted, liveAnnouncementDndItemReordered: liveAnnouncementDndItemReordered, liveAnnouncementDndItemCommitted: liveAnnouncementDndItemCommitted, liveAnnouncementDndDiscarded: liveAnnouncementDndDiscarded, sortedOptions: sortedOptions }) {
    const isFirstAnnouncement = (0, $acw62.useRef)(true);
    if (!isDragging) isFirstAnnouncement.current = true;
    return {
        onDragStart ({ active: active }) {
            if (active && liveAnnouncementDndStarted) {
                const index = sortedOptions.findIndex((option)=>option.id === active.id);
                return liveAnnouncementDndStarted(index + 1, sortedOptions.length);
            }
        },
        onDragOver ({ active: active, over: over }) {
            if (liveAnnouncementDndItemReordered) {
                // Don't announce on the first dragOver because it's redundant with onDragStart.
                if (isFirstAnnouncement.current) {
                    isFirstAnnouncement.current = false;
                    if (!over || over.id === active.id) return;
                }
                const initialIndex = sortedOptions.findIndex((option)=>option.id === active.id);
                const currentIdex = over ? sortedOptions.findIndex((option)=>option.id === over.id) : initialIndex;
                return liveAnnouncementDndItemReordered(initialIndex + 1, currentIdex + 1, sortedOptions.length);
            }
        },
        onDragEnd ({ active: active, over: over }) {
            if (liveAnnouncementDndItemCommitted) {
                const initialIndex = sortedOptions.findIndex((option)=>option.id === active.id);
                const finalIndex = over ? sortedOptions.findIndex((option)=>option.id === over.id) : initialIndex;
                return liveAnnouncementDndItemCommitted(initialIndex + 1, finalIndex + 1, sortedOptions.length);
            }
        },
        onDragCancel () {
            return liveAnnouncementDndDiscarded;
        }
    };
}





const $4a5066266e744f96$var$componentPrefix = "content-display";
const $4a5066266e744f96$var$getClassName = (suffix)=>(0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)[`${$4a5066266e744f96$var$componentPrefix}-${suffix}`];
function $4a5066266e744f96$export$2e2bcd8739ae039({ title: title, description: description, options: options, value: value = options.map(({ id: id })=>({
        id: id,
        visible: true
    })), onChange: onChange, liveAnnouncementDndStarted: liveAnnouncementDndStarted, liveAnnouncementDndItemReordered: liveAnnouncementDndItemReordered, liveAnnouncementDndItemCommitted: liveAnnouncementDndItemCommitted, liveAnnouncementDndDiscarded: liveAnnouncementDndDiscarded, dragHandleAriaDescription: dragHandleAriaDescription, dragHandleAriaLabel: dragHandleAriaLabel }) {
    const idPrefix = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)($4a5066266e744f96$var$componentPrefix);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("collection-preferences");
    const onToggle = (option)=>{
        onChange(value.map((item)=>item.id === option.id ? Object.assign(Object.assign({}, item), {
                visible: !option.visible
            }) : item));
    };
    const titleId = `${idPrefix}-title`;
    const descriptionId = `${idPrefix}-description`;
    const sortedOptions = (0, $1d5a598a97527b88$export$859eb1ee842452d4)({
        options: options,
        contentDisplay: value
    });
    const { activeItem: activeItem, collisionDetection: collisionDetection, handleKeyDown: handleKeyDown, sensors: sensors, setActiveItem: setActiveItem } = (0, $c640cc9bbb4535c7$export$2e2bcd8739ae039)({
        sortedOptions: sortedOptions
    });
    const activeOption = activeItem ? sortedOptions.find(({ id: id })=>id === activeItem) : null;
    const announcements = (0, $d9c9ea54fe77eabd$export$2e2bcd8739ae039)({
        isDragging: activeItem !== null,
        liveAnnouncementDndStarted: i18n("contentDisplayPreference.liveAnnouncementDndStarted", liveAnnouncementDndStarted, (format)=>(position, total)=>format({
                    position: position,
                    total: total
                })),
        liveAnnouncementDndItemReordered: i18n("contentDisplayPreference.liveAnnouncementDndItemReordered", liveAnnouncementDndItemReordered, (format)=>(initialPosition, currentPosition, total)=>format({
                    currentPosition: currentPosition,
                    total: total,
                    isInitialPosition: `${initialPosition === currentPosition}`
                })),
        liveAnnouncementDndItemCommitted: i18n("contentDisplayPreference.liveAnnouncementDndItemCommitted", liveAnnouncementDndItemCommitted, (format)=>(initialPosition, finalPosition, total)=>format({
                    initialPosition: initialPosition,
                    finalPosition: finalPosition,
                    total: total,
                    isInitialPosition: `${initialPosition === finalPosition}`
                })),
        liveAnnouncementDndDiscarded: i18n("contentDisplayPreference.liveAnnouncementDndDiscarded", liveAnnouncementDndDiscarded),
        sortedOptions: value
    });
    const renderedDragHandleAriaDescription = i18n("contentDisplayPreference.dragHandleAriaDescription", dragHandleAriaDescription);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)[$4a5066266e744f96$var$componentPrefix]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        className: $4a5066266e744f96$var$getClassName("title"),
        id: titleId
    }, i18n("contentDisplayPreference.title", title)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: $4a5066266e744f96$var$getClassName("description"),
        id: descriptionId
    }, i18n("contentDisplayPreference.description", description)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0bb7808e9486acbd$export$2d5c5ceac203fc1e), {
        sensors: sensors,
        collisionDetection: collisionDetection,
        accessibility: {
            announcements: announcements,
            restoreFocus: false,
            screenReaderInstructions: renderedDragHandleAriaDescription ? {
                draggable: renderedDragHandleAriaDescription
            } : undefined
        },
        onDragStart: ({ active: active })=>setActiveItem(active.id),
        onDragEnd: (event)=>{
            setActiveItem(null);
            const { active: active, over: over } = event;
            if (over && active.id !== over.id) {
                const oldIndex = value.findIndex(({ id: id })=>id === active.id);
                const newIndex = value.findIndex(({ id: id })=>id === over.id);
                onChange((0, $0332ec5baeac6793$export$5d49d615ad5ea2b0)([
                    ...value
                ], oldIndex, newIndex));
            }
        },
        onDragCancel: ()=>setActiveItem(null)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: $4a5066266e744f96$var$getClassName("option-list"),
        "aria-describedby": descriptionId,
        "aria-labelledby": titleId,
        role: "list"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0332ec5baeac6793$export$86155fde54f06e6a), {
        items: sortedOptions.map(({ id: id })=>id),
        strategy: (0, $0332ec5baeac6793$export$fe2be640df2ffb9e)
    }, sortedOptions.map((option)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8ea9993898ad3542$export$2e2bcd8739ae039), {
            dragHandleAriaLabel: i18n("contentDisplayPreference.dragHandleAriaLabel", dragHandleAriaLabel),
            key: option.id,
            onKeyDown: handleKeyDown,
            onToggle: onToggle,
            option: option
        });
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $014cec8599be1408$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0bb7808e9486acbd$export$aca73479aa40659d), {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["drag-overlay"],
        dropAnimation: null,
        style: {
            zIndex: 5000
        }
    }, activeOption && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5e9a9b18af560cf$export$2e2bcd8739ae039), {
        listeners: {
            onKeyDown: handleKeyDown
        },
        dragHandleAriaLabel: i18n("contentDisplayPreference.dragHandleAriaLabel", dragHandleAriaLabel),
        onToggle: onToggle,
        option: activeOption
    })))));
}




const $5c1f45487ee29a3a$var$componentName = "CollectionPreferences";
function $5c1f45487ee29a3a$export$2e2bcd8739ae039(_a) {
    var { title: title, confirmLabel: confirmLabel, cancelLabel: cancelLabel, disabled: disabled = false, onConfirm: onConfirm, onCancel: onCancel, visibleContentPreference: visibleContentPreference, contentDisplayPreference: contentDisplayPreference, pageSizePreference: pageSizePreference, wrapLinesPreference: wrapLinesPreference, stripedRowsPreference: stripedRowsPreference, contentDensityPreference: contentDensityPreference, stickyColumnsPreference: stickyColumnsPreference, preferences: preferences, customPreference: customPreference, getModalRoot: getModalRoot, removeModalRoot: removeModalRoot } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "title",
        "confirmLabel",
        "cancelLabel",
        "disabled",
        "onConfirm",
        "onCancel",
        "visibleContentPreference",
        "contentDisplayPreference",
        "pageSizePreference",
        "wrapLinesPreference",
        "stripedRowsPreference",
        "contentDensityPreference",
        "stickyColumnsPreference",
        "preferences",
        "customPreference",
        "getModalRoot",
        "removeModalRoot"
    ]);
    const { __internalRootRef: __internalRootRef } = (0, $970c67f83063979b$export$2e2bcd8739ae039)("CollectionPreferences");
    (0, $6175122c42c548ad$export$2e2bcd8739ae039)("CollectionPreferences", "preferences", preferences, "onConfirm", onConfirm);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("collection-preferences");
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const [modalVisible, setModalVisible] = (0, $acw62.useState)(false);
    const [temporaryPreferences, setTemporaryPreferences] = (0, $acw62.useState)((0, $5e0c372fb1280cb8$export$9f13f511f7531527)(preferences || {}));
    const triggerRef = (0, $acw62.useRef)(null);
    const dialogPreviouslyOpen = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!modalVisible) dialogPreviouslyOpen.current && triggerRef.current && triggerRef.current.focus();
        else dialogPreviouslyOpen.current = true;
    }, [
        modalVisible
    ]);
    const onConfirmListener = ()=>{
        setModalVisible(false);
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onConfirm, temporaryPreferences);
    };
    const onCancelListener = ()=>{
        (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onCancel, {});
        setModalVisible(false);
        setTemporaryPreferences((0, $5e0c372fb1280cb8$export$9f13f511f7531527)(preferences || {}));
    };
    const hasContentOnTheLeft = !!(pageSizePreference || wrapLinesPreference || stripedRowsPreference || contentDensityPreference || stickyColumnsPreference || customPreference);
    const hasContentOnTheRight = !!(visibleContentPreference || contentDisplayPreference);
    const onChange = (changedPreferences)=>setTemporaryPreferences((0, $5e0c372fb1280cb8$export$76ff241c87799c99)(changedPreferences, temporaryPreferences));
    if (visibleContentPreference && contentDisplayPreference) (0, $dd646455762bc7b9$export$5b28268982f175ba)($5c1f45487ee29a3a$var$componentName, "You provided both `visibleContentPreference` and `contentDisplayPreference` props. `visibleContentPreference` will be ignored and only `contentDisplayPreference` will be rendered.");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039).root),
        ref: __internalRootRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        ref: triggerRef,
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["trigger-button"],
        disabled: disabled,
        ariaLabel: i18n("title", title),
        onClick: ()=>{
            setTemporaryPreferences((0, $5e0c372fb1280cb8$export$9f13f511f7531527)(preferences || {}));
            setModalVisible(true);
        },
        variant: "icon",
        iconName: "settings",
        formAction: "none"
    }), !disabled && modalVisible && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a5bb8d240e2baab$export$2e2bcd8739ae039), {
        className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["modal-root"],
        visible: true,
        getModalRoot: getModalRoot,
        removeModalRoot: removeModalRoot,
        header: i18n("title", title),
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
            float: "right"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
            direction: "horizontal",
            size: "xs"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["cancel-button"],
            variant: "link",
            formAction: "none",
            onClick: onCancelListener
        }, i18n("cancelLabel", cancelLabel)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            className: (0, $01b0d7d1e7a80e3a$export$2e2bcd8739ae039)["confirm-button"],
            variant: "primary",
            formAction: "none",
            onClick: onConfirmListener
        }, i18n("confirmLabel", confirmLabel)))),
        closeAriaLabel: cancelLabel,
        size: hasContentOnTheLeft && hasContentOnTheRight ? "large" : "medium",
        onDismiss: onCancelListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e0c372fb1280cb8$export$c84c03f16c0f8752), {
        left: hasContentOnTheLeft && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
            size: "l"
        }, pageSizePreference && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e0c372fb1280cb8$export$e7b9797caf42ef5e), Object.assign({
            value: temporaryPreferences.pageSize
        }, pageSizePreference, {
            onChange: (pageSize)=>onChange({
                    pageSize: pageSize
                })
        })), wrapLinesPreference && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e0c372fb1280cb8$export$9c0f52e17055efc3), Object.assign({
            value: temporaryPreferences.wrapLines
        }, wrapLinesPreference, {
            onChange: (wrapLines)=>onChange({
                    wrapLines: wrapLines
                })
        })), stripedRowsPreference && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e0c372fb1280cb8$export$f467017c5d8daff3), Object.assign({
            value: temporaryPreferences.stripedRows
        }, stripedRowsPreference, {
            onChange: (stripedRows)=>onChange({
                    stripedRows: stripedRows
                })
        })), contentDensityPreference && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e0c372fb1280cb8$export$2b48c4c5210809b9), Object.assign({
            value: temporaryPreferences.contentDensity
        }, contentDensityPreference, {
            onChange: (contentDensity)=>onChange({
                    contentDensity: contentDensity
                })
        })), stickyColumnsPreference && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e0c372fb1280cb8$export$7110115eecf52680), Object.assign({
            value: temporaryPreferences.stickyColumns
        }, stickyColumnsPreference, {
            onChange: (stickyColumns)=>onChange({
                    stickyColumns: stickyColumns
                })
        })), customPreference && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e0c372fb1280cb8$export$71d19cc08e222f47), {
            value: temporaryPreferences.custom,
            customPreference: customPreference,
            onChange: (custom)=>onChange({
                    custom: custom
                })
        })),
        right: contentDisplayPreference ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a5066266e744f96$export$2e2bcd8739ae039), Object.assign({}, contentDisplayPreference, {
            value: temporaryPreferences.contentDisplay,
            onChange: (contentDisplay)=>onChange({
                    contentDisplay: contentDisplay
                })
        })) : visibleContentPreference && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1d0e079a04a15fe6$export$2e2bcd8739ae039), Object.assign({
            value: temporaryPreferences.visibleContent
        }, visibleContentPreference, {
            onChange: (visibleItems)=>onChange({
                    visibleContent: visibleItems
                })
        }))
    })));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($5c1f45487ee29a3a$export$2e2bcd8739ae039, $5c1f45487ee29a3a$var$componentName);


function $a89636bbaa439431$export$d5a7fa40d422cbcd({ preferences: preferences, setPreferences: setPreferences, columnDisplayPreferenceOptions: columnDisplayPreferenceOptions }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c1f45487ee29a3a$export$2e2bcd8739ae039), {
        title: "Preferences",
        confirmLabel: "Confirm",
        cancelLabel: "Cancel",
        preferences: preferences,
        onConfirm: ({ detail: detail })=>setPreferences(detail),
        pageSizePreference: {
            title: "Page size",
            options: [
                {
                    value: 10,
                    label: "10 items"
                },
                {
                    value: 20,
                    label: "20 items"
                },
                {
                    value: 50,
                    label: "50 items"
                },
                {
                    value: 100,
                    label: "100 items"
                }
            ]
        },
        wrapLinesPreference: {
            label: "Wrap lines",
            description: "Select to see all the text and wrap the lines"
        },
        stripedRowsPreference: {
            label: "Striped rows",
            description: "Select to add alternating shaded rows"
        },
        contentDensityPreference: {
            label: "Compact mode",
            description: "Select to display content in a denser, more compact mode"
        },
        contentDisplayPreference: {
            title: "Column preferences",
            description: "Customize the columns visibility and order.",
            options: columnDisplayPreferenceOptions
        },
        // customPreference={(customValue, setCustomValue) => (
        //   <Checkbox
        //     checked={customValue}
        //     onChange={({ detail }) => setCustomValue(detail.checked)}
        //   >
        //     Custom field
        //   </Checkbox>
        // )}
        stickyColumnsPreference: {
            firstColumns: {
                title: "Stick first column(s)",
                description: "Keep the first column(s) visible while horizontally scrolling the table content.",
                options: [
                    {
                        label: "None",
                        value: 0
                    },
                    {
                        label: "First column",
                        value: 1
                    },
                    {
                        label: "First two columns",
                        value: 2
                    }
                ]
            },
            lastColumns: {
                title: "Stick last column",
                description: "Keep the last column visible while horizontally scrolling the table content.",
                options: [
                    {
                        label: "None",
                        value: 0
                    },
                    {
                        label: "Last column",
                        value: 1
                    }
                ]
            }
        }
    });
}







var $acw62 = parcelRequire("acw62");






const $93fef701c169bd1e$var$MenuContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $93fef701c169bd1e$export$7ce43d0a8f00d826;
(function(ColumnType) {
    ColumnType[ColumnType["String"] = 0] = "String";
    ColumnType[ColumnType["Boolean"] = 1] = "Boolean";
    ColumnType[ColumnType["Button"] = 2] = "Button";
    ColumnType[ColumnType["Link"] = 3] = "Link";
    ColumnType[ColumnType["Hidden"] = 4] = "Hidden";
    ColumnType[ColumnType["Date"] = 5] = "Date";
    ColumnType[ColumnType["CheckBox"] = 6] = "CheckBox";
})($93fef701c169bd1e$export$7ce43d0a8f00d826 || ($93fef701c169bd1e$export$7ce43d0a8f00d826 = {}));
var $93fef701c169bd1e$var$ColumnDisplay;
(function(ColumnDisplay) {
    ColumnDisplay[ColumnDisplay["Show"] = 0] = "Show";
    ColumnDisplay[ColumnDisplay["Hide"] = 1] = "Hide";
})($93fef701c169bd1e$var$ColumnDisplay || ($93fef701c169bd1e$var$ColumnDisplay = {}));
var $93fef701c169bd1e$var$ConditionComparison;
(function(ConditionComparison) {
    ConditionComparison[ConditionComparison["Equals"] = 0] = "Equals";
    ConditionComparison[ConditionComparison["NotEquals"] = 1] = "NotEquals";
    ConditionComparison[ConditionComparison["Contains"] = 2] = "Contains";
    ConditionComparison[ConditionComparison["IsNotNull"] = 3] = "IsNotNull";
    ConditionComparison[ConditionComparison["IsNull"] = 4] = "IsNull";
    ConditionComparison[ConditionComparison["GreaterThan"] = 5] = "GreaterThan";
    ConditionComparison[ConditionComparison["GreaterThanOrEqual"] = 6] = "GreaterThanOrEqual";
    ConditionComparison[ConditionComparison["LessThan"] = 7] = "LessThan";
    ConditionComparison[ConditionComparison["LessThanOrEqual"] = 8] = "LessThanOrEqual";
})($93fef701c169bd1e$var$ConditionComparison || ($93fef701c169bd1e$var$ConditionComparison = {}));
const $93fef701c169bd1e$var$MapMenuItemsToSideNavItems = (items, root = true)=>{
    const results = [];
    if (root) results.push({
        text: "Home",
        href: "/",
        type: "link"
    });
    for(let i = 0; i < items?.length; i++){
        const item = items[i];
        if (item.SubMenus && item.SubMenus.length > 0) {
            const sectionItem = {
                text: item.Name,
                type: "section",
                defaultExpanded: false,
                items: $93fef701c169bd1e$var$MapMenuItemsToSideNavItems(item.SubMenus, false)
            };
            results.push(sectionItem);
        } else //href: "#/view" + item.Event, // TODO: Make open in new tab on menu also work
        results.push({
            text: item.Name,
            href: "/" + item.Id,
            type: "link"
        });
    }
    return results;
};
const $93fef701c169bd1e$var$MapMenuItemToAppMenuItem = (items, path = "")=>{
    if (!items) return [];
    return items.map((item)=>({
            path: path + "/" + item.Id,
            href: item.Id,
            id: item.Id,
            name: item.Name,
            parentMenu: null,
            subMenus: [
                {
                    id: "#back",
                    event: null,
                    position: 0,
                    canDelete: false,
                    href: "#back/" + item.Id,
                    name: "<<",
                    parentMenu: null,
                    path: "",
                    subMenus: []
                },
                ...$93fef701c169bd1e$var$MapMenuItemToAppMenuItem(item.SubMenus, path + "/" + item.Id)
            ],
            event: item.Event,
            position: item.Position,
            canDelete: item.CanDelete
        }));
};
const $93fef701c169bd1e$export$62b22d151866115d = ({ children: children })=>{
    const [appMenuItems, setAppMenuItems] = (0, $acw62.useState)([]);
    const [sideNavMenuItems, setSideNavMenuItems] = (0, $acw62.useState)([]);
    const auth = (0, $fe9e7bfbce151564$export$1d39dc5b47e56ff0)();
    const api = (0, $ef4677a056004d8e$export$eb2799109db70ffd)();
    const { onMenuClick: onMenuClick } = (0, $ba30691687bb8563$export$bc923229a7fa61e7)();
    const { setCurrentContentType: setCurrentContentType, isReady: mainAppIsReady, showComponent: showComponent } = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    const loadMenus = async ()=>{
        const menuData = await api.makeApiCall("getUserMenu", "GET");
        const menuItems = $93fef701c169bd1e$var$MapMenuItemToAppMenuItem(menuData, "");
        const sideNavItems = $93fef701c169bd1e$var$MapMenuItemsToSideNavItems(menuData);
        setAppMenuItems(menuItems);
        setSideNavMenuItems(sideNavItems);
    };
    const onHomeClick = async ()=>{
        showComponent({
            menu: null,
            type: "home"
        });
        setCurrentContentType("default");
    };
    (0, $acw62.useEffect)(()=>{
        if (auth.isAuthenticated === true) loadMenus();
        else {
            setAppMenuItems([]);
            setSideNavMenuItems([]);
        }
    }, [
        auth.isAuthenticated
    ]);
    const checkPredefinedActions = async ()=>{
        if (window.location.search.includes("anonAction")) {
            const url = new URL(window.location.href);
            const action = url.searchParams.get("anonAction");
            const params = url.searchParams.get("params");
            await onMenuClick(parseInt(action), params);
            return;
        }
        if (window.location.search.includes("confirmed")) {
            (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                type: "success",
                content: `"Thank you for confirming you email address. You can now log in using your username and password"`
            }));
            const url = new URL(window.location.href);
            url.searchParams.delete("confirmed");
            window.history.pushState(null, "", url.toString());
        }
    };
    (0, $acw62.useEffect)(()=>{
        checkPredefinedActions();
    }, [
        mainAppIsReady
    ]);
    const value = {
        appMenuItems: appMenuItems,
        sideNavMenuItems: sideNavMenuItems,
        onHomeClick: onHomeClick
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($93fef701c169bd1e$var$MenuContext.Provider, {
        value: value,
        children: children
    });
};
const $93fef701c169bd1e$export$38eaa17faae8f579 = ()=>{
    const context = (0, $acw62.useContext)($93fef701c169bd1e$var$MenuContext);
    if (!context) throw new Error("useMenu must be used within an MenuProvider");
    return context;
};


const $e8a5e1b6e0aac306$var$parseColumnName = (columnName, data)=>{
    let value = "";
    if (columnName != null && columnName.length > 0) {
        value = data;
        var colName = columnName;
        while(colName.indexOf(".") > -1){
            var index = colName.indexOf(".");
            var partName = colName.substring(0, index);
            if (value == null) break;
            value = value[partName];
            colName = colName.substring(index + 1);
        }
        if (value != null) value = value[colName];
    }
    return value;
};
const $e8a5e1b6e0aac306$var$isConditionMet = (condition, actualValue)=>{
    var colName = condition.ColumnName;
    var comparison = condition.Comparison;
    var colVal = condition.ColumnValue;
    var compareResult = true;
    switch(comparison){
        case 0:
            return actualValue == colVal;
        case 1:
            return actualValue != colVal;
        case 2:
            return actualValue.toLowerCase().indexOf(colVal.toLowerCase()) > -1;
        case 3:
            return actualValue != null && actualValue.length > 0;
        case 4:
            return actualValue == null || actualValue.length == 0;
        case 5:
            actualValue = parseInt(actualValue);
            return actualValue != null && actualValue > colVal;
        case 6:
            actualValue = parseInt(actualValue);
            return actualValue != null && actualValue >= colVal;
        case 7:
            actualValue = parseInt(actualValue);
            return actualValue != null && actualValue < colVal;
        case 8:
            actualValue = parseInt(actualValue);
            return actualValue != null && actualValue <= colVal;
        default:
            //todo: show an error somewhere
            console.error("Unknown condition comparison type: " + comparison);
            break;
    }
    return compareResult;
};
const $e8a5e1b6e0aac306$export$9befa2eca56ffc88 = ({ rowData: rowData, column: column })=>{
    if (column.ColumnSetting != null) {
        if (column.ColumnSetting.ColumnSettingType == 0) {
            /// Show/Hide column
            var show = column.ColumnSetting.Display == 0;
            var compareResult = true;
            for(var p = 0; p < column.ColumnSetting.Conditions.length; p++){
                var condition = column.ColumnSetting.Conditions[p];
                var colName = condition.ColumnName;
                var actualValue = $e8a5e1b6e0aac306$var$parseColumnName(colName, rowData) + "";
                compareResult = compareResult && $e8a5e1b6e0aac306$var$isConditionMet(condition, actualValue);
            }
            if (compareResult == false && show == true || compareResult == true && show == false) return false;
        }
    }
    return true;
};




const $3a99089bf7fdc291$export$1724f667738c6e1d = ()=>{
    const { onMenuClick: onMenuClick } = (0, $ba30691687bb8563$export$bc923229a7fa61e7)();
    const modal = (0, $5dbc399a9d723999$export$33ffd74ebf07f060)();
    const handleViewEvent = async (column, rowData, menu)=>{
        const id = rowData[column.KeyColumn];
        const params = column.ParametersToPass || {};
        params["ViewId"] = menu.Id;
        params["RowId"] = id;
        const formData = {
            Id: id,
            data: rowData,
            viewSettings: "",
            //parameters: theColumn.ParametersToPass,
            parameters: params,
            eventParameters: menu.EventParameters
        };
        if (menu.ActionType == 7) {
            const eventId = column.Event == null ? column.EventNumber : column.Event.EventNumber;
            // execute ui action
            await onMenuClick(eventId, formData);
        } else if (column.Event == null || column.Event.ActionType == 6) {
            const eventId = column.Event == null ? column.EventNumber : column.Event.EventNumber;
            // execute ui action
            await onMenuClick(eventId, formData);
        } else if (column.Event.ActionType == 5) {
            // show message
            const data = formData || {};
            data["parameters"] = params;
            const res = await modal.getUserConfirmation(column.Event, data);
            if (res === true && column.Event.OnConfirmationUIAction > 0) await onMenuClick(column.Event.OnConfirmationUIAction, data);
            else if (res === false && column.Event.OnCancelUIAction > 0) await onMenuClick(column.Event.OnCancelUIAction, data);
        }
    };
    return {
        handleViewEvent: handleViewEvent
    };
};


const $9f358e506d11489c$var$ColButton = ({ rowData: rowData, column: column, onClick: onClick })=>{
    const visible = (0, $e8a5e1b6e0aac306$export$9befa2eca56ffc88)({
        rowData: rowData,
        column: column
    });
    const { handleViewEvent: handleViewEvent } = (0, $3a99089bf7fdc291$export$1724f667738c6e1d)();
    let label = column.ColumnLabel;
    if (column.ColumnType == (0, $93fef701c169bd1e$export$7ce43d0a8f00d826).Button || column.ColumnType == (0, $93fef701c169bd1e$export$7ce43d0a8f00d826).Link) label = column.LinkLabel;
    const buttonClick = async ()=>{
        await onClick(column, rowData);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            opacity: visible ? 1 : 0,
            display: "flex",
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
            variant: column.ColumnType == (0, $93fef701c169bd1e$export$7ce43d0a8f00d826).Link ? "inline-link" : "normal",
            onClick: buttonClick,
            wrapText: false,
            disabled: visible ? false : true,
            children: label
        })
    });
};
const $9f358e506d11489c$export$332bbb895017705d = ({ rowData: rowData, columns: columns, onClick: onClick })=>{
    if (!columns || columns.length == 0) return "";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
        float: "right",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
            direction: "horizontal",
            size: "xl",
            children: columns// .filter((c) => showColumn({ rowData, column: c }))
            .map((c, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f358e506d11489c$var$ColButton, {
                    rowData: rowData,
                    column: c,
                    onClick: onClick
                }, i))
        })
    });
};



const $14c1dd08e5f1280b$var$getNestedValue = (data, path)=>{
    return path.split(".").reduce((partValue, subPath)=>partValue && partValue[subPath], data);
};
const $14c1dd08e5f1280b$export$ff93575ad9700188 = ({ rowData: rowData, column: column })=>{
    let colVal = $14c1dd08e5f1280b$var$getNestedValue(rowData, column.ColumnName);
    if ((0, $e8a5e1b6e0aac306$export$9befa2eca56ffc88)({
        rowData: rowData,
        column: column
    })) {
        if (column.ColumnType == 1) {
            if (colVal == true) colVal = column.TrueValueDisplay;
            else if (colVal == false) colVal = column.FalseValueDisplay;
        }
    } else colVal = "";
    return colVal + ""; // else booleans don't show
};






var $7efd313040cb9ee6$exports = {};
var $e277a64de4eeade6$exports = {};
var $d26d80da1ba3948c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d26d80da1ba3948c$exports = $d26d80da1ba3948c$var$arrayMap;


var $fd2d90f592c63519$exports = {};
var $38afcbfab85a0553$exports = {};
var $0488fde9aa355453$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
$0488fde9aa355453$exports = $0488fde9aa355453$var$isArray;


var $03e9beb856e9b4cd$exports = {};

var $6b5a5095e0934938$exports = {};
var $a7f8a2555793d7d3$exports = {};
var $3ba72ebe7e4419b5$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
$3ba72ebe7e4419b5$exports = $3ba72ebe7e4419b5$var$Symbol;


var $dabe9ecbecc6d0b5$exports = {};

/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
$dabe9ecbecc6d0b5$exports = $dabe9ecbecc6d0b5$var$getRawTag;


var $3fce91ec3914aaed$exports = {};
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
$3fce91ec3914aaed$exports = $3fce91ec3914aaed$var$objectToString;


/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = "[object Null]", $a7f8a2555793d7d3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $dabe9ecbecc6d0b5$exports(value) : $3fce91ec3914aaed$exports(value);
}
$a7f8a2555793d7d3$exports = $a7f8a2555793d7d3$var$baseGetTag;


var $61269cf1f3e020be$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$61269cf1f3e020be$exports = $61269cf1f3e020be$var$isObjectLike;


/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == "symbol" || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($0488fde9aa355453$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $6b5a5095e0934938$exports(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$03e9beb856e9b4cd$exports = $03e9beb856e9b4cd$var$isKey;


var $f9135a667399ede4$exports = {};
var $6aae515404bf5dd2$exports = {};
var $17f5c88c594eac51$exports = {};
var $4902f64a16640324$exports = {};
var $df2cd4bc93f21548$exports = {};
var $8d50e526a9e9b7fa$exports = {};
var $80f20c637ba11563$exports = {};
var $e95343b7bf5d617b$exports = {};
var $5037fd2e597c2a03$exports = {};
var $8360225fb63098b3$exports = {};
var $004783abbde551e4$exports = {};

var $f9ff2e983beb6b86$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$f9ff2e983beb6b86$exports = $f9ff2e983beb6b86$var$isObject;


/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = "[object AsyncFunction]", $004783abbde551e4$var$funcTag = "[object Function]", $004783abbde551e4$var$genTag = "[object GeneratorFunction]", $004783abbde551e4$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$f9ff2e983beb6b86$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $a7f8a2555793d7d3$exports(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
$004783abbde551e4$exports = $004783abbde551e4$var$isFunction;


var $5e8d211f630cd46d$exports = {};
var $baf78e1246b3b18f$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
$baf78e1246b3b18f$exports = $baf78e1246b3b18f$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($baf78e1246b3b18f$exports && $baf78e1246b3b18f$exports.keys && $baf78e1246b3b18f$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
$5e8d211f630cd46d$exports = $5e8d211f630cd46d$var$isMasked;



var $9c6b3ec69362487e$exports = {};
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$9c6b3ec69362487e$exports = $9c6b3ec69362487e$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp("^" + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$f9ff2e983beb6b86$exports(value) || $5e8d211f630cd46d$exports(value)) return false;
    var pattern = $004783abbde551e4$exports(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($9c6b3ec69362487e$exports(value));
}
$8360225fb63098b3$exports = $8360225fb63098b3$var$baseIsNative;


var $d50b255f8680c47a$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d50b255f8680c47a$exports = $d50b255f8680c47a$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $d50b255f8680c47a$exports(object, key);
    return $8360225fb63098b3$exports(value) ? value : undefined;
}
$5037fd2e597c2a03$exports = $5037fd2e597c2a03$var$getNative;


/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $5037fd2e597c2a03$exports(Object, "create");
$e95343b7bf5d617b$exports = $e95343b7bf5d617b$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $e95343b7bf5d617b$exports ? $e95343b7bf5d617b$exports(null) : {};
    this.size = 0;
}
$80f20c637ba11563$exports = $80f20c637ba11563$var$hashClear;


var $60a2188452e03a76$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$60a2188452e03a76$exports = $60a2188452e03a76$var$hashDelete;


var $0ade0ffa62051a98$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($e95343b7bf5d617b$exports) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$0ade0ffa62051a98$exports = $0ade0ffa62051a98$var$hashGet;


var $0d7f9677a17b6bef$exports = {};

/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $e95343b7bf5d617b$exports ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
$0d7f9677a17b6bef$exports = $0d7f9677a17b6bef$var$hashHas;


var $d33db65186b62952$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $e95343b7bf5d617b$exports && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
$d33db65186b62952$exports = $d33db65186b62952$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $80f20c637ba11563$exports;
$8d50e526a9e9b7fa$var$Hash.prototype["delete"] = $60a2188452e03a76$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $0ade0ffa62051a98$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $0d7f9677a17b6bef$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $d33db65186b62952$exports;
$8d50e526a9e9b7fa$exports = $8d50e526a9e9b7fa$var$Hash;


var $dd14efc87ba1cd5b$exports = {};
var $83df40714bf7006e$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$83df40714bf7006e$exports = $83df40714bf7006e$var$listCacheClear;


var $d22fe27824ff9351$exports = {};
var $87257b05f5d9ad81$exports = {};
var $50557587dab070a0$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$50557587dab070a0$exports = $50557587dab070a0$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($50557587dab070a0$exports(array[length][0], key)) return length;
    }
    return -1;
}
$87257b05f5d9ad81$exports = $87257b05f5d9ad81$var$assocIndexOf;


/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$d22fe27824ff9351$exports = $d22fe27824ff9351$var$listCacheDelete;


var $b2e6263d81cdc1b3$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$b2e6263d81cdc1b3$exports = $b2e6263d81cdc1b3$var$listCacheGet;


var $29e2bc7b7348833e$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $87257b05f5d9ad81$exports(this.__data__, key) > -1;
}
$29e2bc7b7348833e$exports = $29e2bc7b7348833e$var$listCacheHas;


var $ff9311500b60ab72$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$ff9311500b60ab72$exports = $ff9311500b60ab72$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $83df40714bf7006e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype["delete"] = $d22fe27824ff9351$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $b2e6263d81cdc1b3$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $29e2bc7b7348833e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $ff9311500b60ab72$exports;
$dd14efc87ba1cd5b$exports = $dd14efc87ba1cd5b$var$ListCache;


var $19b02faa57603249$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $5037fd2e597c2a03$exports($23YZo, "Map");
$19b02faa57603249$exports = $19b02faa57603249$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $8d50e526a9e9b7fa$exports,
        "map": new ($19b02faa57603249$exports || $dd14efc87ba1cd5b$exports),
        "string": new $8d50e526a9e9b7fa$exports
    };
}
$df2cd4bc93f21548$exports = $df2cd4bc93f21548$var$mapCacheClear;


var $44464964ade29765$exports = {};
var $c0b23e5f03c2595b$exports = {};
var $09c4668903e66c1d$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$09c4668903e66c1d$exports = $09c4668903e66c1d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $09c4668903e66c1d$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$c0b23e5f03c2595b$exports = $c0b23e5f03c2595b$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $c0b23e5f03c2595b$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$44464964ade29765$exports = $44464964ade29765$var$mapCacheDelete;


var $ba80406da5503086$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $c0b23e5f03c2595b$exports(this, key).get(key);
}
$ba80406da5503086$exports = $ba80406da5503086$var$mapCacheGet;


var $d3abe18ea687dfb7$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $c0b23e5f03c2595b$exports(this, key).has(key);
}
$d3abe18ea687dfb7$exports = $d3abe18ea687dfb7$var$mapCacheHas;


var $347643e3dcfcc207$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $c0b23e5f03c2595b$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$347643e3dcfcc207$exports = $347643e3dcfcc207$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $df2cd4bc93f21548$exports;
$4902f64a16640324$var$MapCache.prototype["delete"] = $44464964ade29765$exports;
$4902f64a16640324$var$MapCache.prototype.get = $ba80406da5503086$exports;
$4902f64a16640324$var$MapCache.prototype.has = $d3abe18ea687dfb7$exports;
$4902f64a16640324$var$MapCache.prototype.set = $347643e3dcfcc207$exports;
$4902f64a16640324$exports = $4902f64a16640324$var$MapCache;


/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $4902f64a16640324$exports);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $4902f64a16640324$exports;
$17f5c88c594eac51$exports = $17f5c88c594eac51$var$memoize;


/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $17f5c88c594eac51$exports(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$6aae515404bf5dd2$exports = $6aae515404bf5dd2$var$memoizeCapped;


/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $6aae515404bf5dd2$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$f9135a667399ede4$exports = $f9135a667399ede4$var$stringToPath;


var $f5d9385a9cc7e413$exports = {};
var $f16f644742c27c21$exports = {};




/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($0488fde9aa355453$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $d26d80da1ba3948c$exports(value, $f16f644742c27c21$var$baseToString) + "";
    if ($6b5a5095e0934938$exports(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$f16f644742c27c21$var$INFINITY ? "-0" : result;
}
$f16f644742c27c21$exports = $f16f644742c27c21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? "" : $f16f644742c27c21$exports(value);
}
$f5d9385a9cc7e413$exports = $f5d9385a9cc7e413$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($0488fde9aa355453$exports(value)) return value;
    return $03e9beb856e9b4cd$exports(value, object) ? [
        value
    ] : $f9135a667399ede4$exports($f5d9385a9cc7e413$exports(value));
}
$38afcbfab85a0553$exports = $38afcbfab85a0553$var$castPath;


var $4d60aa8c33155976$exports = {};

/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == "string" || $6b5a5095e0934938$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$4d60aa8c33155976$var$INFINITY ? "-0" : result;
}
$4d60aa8c33155976$exports = $4d60aa8c33155976$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$4d60aa8c33155976$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$fd2d90f592c63519$exports = $fd2d90f592c63519$var$baseGet;


var $5aba4f6d9f8304a3$exports = {};
var $e780807e2b795134$exports = {};
var $ec073f38db6e7d54$exports = {};
var $bbb2d98cae25b61a$exports = {};

var $e8ee1d354807980a$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $dd14efc87ba1cd5b$exports;
    this.size = 0;
}
$e8ee1d354807980a$exports = $e8ee1d354807980a$var$stackClear;


var $b2ddb9d63293f3a5$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$b2ddb9d63293f3a5$exports = $b2ddb9d63293f3a5$var$stackDelete;


var $80d0940a423a17dc$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
$80d0940a423a17dc$exports = $80d0940a423a17dc$var$stackGet;


var $010f38d5d914cfa2$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
$010f38d5d914cfa2$exports = $010f38d5d914cfa2$var$stackHas;


var $9280d00f89f25fa9$exports = {};



/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $dd14efc87ba1cd5b$exports) {
        var pairs = data.__data__;
        if (!$19b02faa57603249$exports || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $4902f64a16640324$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$9280d00f89f25fa9$exports = $9280d00f89f25fa9$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $dd14efc87ba1cd5b$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $e8ee1d354807980a$exports;
$bbb2d98cae25b61a$var$Stack.prototype["delete"] = $b2ddb9d63293f3a5$exports;
$bbb2d98cae25b61a$var$Stack.prototype.get = $80d0940a423a17dc$exports;
$bbb2d98cae25b61a$var$Stack.prototype.has = $010f38d5d914cfa2$exports;
$bbb2d98cae25b61a$var$Stack.prototype.set = $9280d00f89f25fa9$exports;
$bbb2d98cae25b61a$exports = $bbb2d98cae25b61a$var$Stack;


var $769812b29c18141e$exports = {};
var $567f2dd161ebd4f6$exports = {};

var $1081bd3a2e361911$exports = {};
var $a29ccdc0f60e279e$exports = {};

var $dda8f7b6b589544e$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
$dda8f7b6b589544e$exports = $dda8f7b6b589544e$var$setCacheAdd;


var $66732c92c350622c$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$66732c92c350622c$exports = $66732c92c350622c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $4902f64a16640324$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $dda8f7b6b589544e$exports;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $66732c92c350622c$exports;
$a29ccdc0f60e279e$exports = $a29ccdc0f60e279e$var$SetCache;


var $aae24ad60cc3cfcb$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$aae24ad60cc3cfcb$exports = $aae24ad60cc3cfcb$var$arraySome;


var $1b44096ad4b9e2d5$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
$1b44096ad4b9e2d5$exports = $1b44096ad4b9e2d5$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $a29ccdc0f60e279e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$aae24ad60cc3cfcb$exports(other, function(othValue, othIndex) {
                if (!$1b44096ad4b9e2d5$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$1081bd3a2e361911$exports = $1081bd3a2e361911$var$equalArrays;


var $baf52b9e146f3da7$exports = {};

var $facf83d1449a27b8$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
$facf83d1449a27b8$exports = $facf83d1449a27b8$var$Uint8Array;




var $91d4444cbb077e0c$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$91d4444cbb077e0c$exports = $91d4444cbb077e0c$var$mapToArray;


var $11f509f8f53d8c36$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$11f509f8f53d8c36$exports = $11f509f8f53d8c36$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = "[object Boolean]", $baf52b9e146f3da7$var$dateTag = "[object Date]", $baf52b9e146f3da7$var$errorTag = "[object Error]", $baf52b9e146f3da7$var$mapTag = "[object Map]", $baf52b9e146f3da7$var$numberTag = "[object Number]", $baf52b9e146f3da7$var$regexpTag = "[object RegExp]", $baf52b9e146f3da7$var$setTag = "[object Set]", $baf52b9e146f3da7$var$stringTag = "[object String]", $baf52b9e146f3da7$var$symbolTag = "[object Symbol]";
var $baf52b9e146f3da7$var$arrayBufferTag = "[object ArrayBuffer]", $baf52b9e146f3da7$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $facf83d1449a27b8$exports(object), new $facf83d1449a27b8$exports(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $50557587dab070a0$exports(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $91d4444cbb077e0c$exports;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $11f509f8f53d8c36$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1081bd3a2e361911$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
$baf52b9e146f3da7$exports = $baf52b9e146f3da7$var$equalByTag;


var $ac8a81cbae0357e8$exports = {};
var $7958eecccfe4cef6$exports = {};
var $9144d49da7a47a72$exports = {};
var $cc77dbb7c08db6a8$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$cc77dbb7c08db6a8$exports = $cc77dbb7c08db6a8$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $0488fde9aa355453$exports(object) ? result : $cc77dbb7c08db6a8$exports(result, symbolsFunc(object));
}
$9144d49da7a47a72$exports = $9144d49da7a47a72$var$baseGetAllKeys;


var $51326a29f571e7cd$exports = {};
var $6549fed720324048$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$6549fed720324048$exports = $6549fed720324048$var$arrayFilter;


var $8fc9f7df9b0c06bb$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
$8fc9f7df9b0c06bb$exports = $8fc9f7df9b0c06bb$var$stubArray;


/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $8fc9f7df9b0c06bb$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $6549fed720324048$exports($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
$51326a29f571e7cd$exports = $51326a29f571e7cd$var$getSymbols;


var $08f0eaf3fbcb2fde$exports = {};
var $64568844439edb7f$exports = {};
var $b14d62a510ae7f2d$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$b14d62a510ae7f2d$exports = $b14d62a510ae7f2d$var$baseTimes;


var $7d0c6fd0eb26be0e$exports = {};
var $fb8f823cdc90f511$exports = {};


/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $fb8f823cdc90f511$var$argsTag;
}
$fb8f823cdc90f511$exports = $fb8f823cdc90f511$var$baseIsArguments;



/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $fb8f823cdc90f511$exports(function() {
    return arguments;
}()) ? $fb8f823cdc90f511$exports : function(value) {
    return $61269cf1f3e020be$exports(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, "callee") && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, "callee");
};
$7d0c6fd0eb26be0e$exports = $7d0c6fd0eb26be0e$var$isArguments;




var $f504n = parcelRequire("f504n");
var $d83738e053b5eb08$exports = {};
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$d83738e053b5eb08$exports = $d83738e053b5eb08$var$isIndex;


var $156c3727697ab085$exports = {};
var $9d076681a0e29d68$exports = {};

var $15d215b19bcf1187$exports = {};
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
$15d215b19bcf1187$exports = $15d215b19bcf1187$var$isLength;



/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = "[object Arguments]", $9d076681a0e29d68$var$arrayTag = "[object Array]", $9d076681a0e29d68$var$boolTag = "[object Boolean]", $9d076681a0e29d68$var$dateTag = "[object Date]", $9d076681a0e29d68$var$errorTag = "[object Error]", $9d076681a0e29d68$var$funcTag = "[object Function]", $9d076681a0e29d68$var$mapTag = "[object Map]", $9d076681a0e29d68$var$numberTag = "[object Number]", $9d076681a0e29d68$var$objectTag = "[object Object]", $9d076681a0e29d68$var$regexpTag = "[object RegExp]", $9d076681a0e29d68$var$setTag = "[object Set]", $9d076681a0e29d68$var$stringTag = "[object String]", $9d076681a0e29d68$var$weakMapTag = "[object WeakMap]";
var $9d076681a0e29d68$var$arrayBufferTag = "[object ArrayBuffer]", $9d076681a0e29d68$var$dataViewTag = "[object DataView]", $9d076681a0e29d68$var$float32Tag = "[object Float32Array]", $9d076681a0e29d68$var$float64Tag = "[object Float64Array]", $9d076681a0e29d68$var$int8Tag = "[object Int8Array]", $9d076681a0e29d68$var$int16Tag = "[object Int16Array]", $9d076681a0e29d68$var$int32Tag = "[object Int32Array]", $9d076681a0e29d68$var$uint8Tag = "[object Uint8Array]", $9d076681a0e29d68$var$uint8ClampedTag = "[object Uint8ClampedArray]", $9d076681a0e29d68$var$uint16Tag = "[object Uint16Array]", $9d076681a0e29d68$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $61269cf1f3e020be$exports(value) && $15d215b19bcf1187$exports(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$a7f8a2555793d7d3$exports(value)];
}
$9d076681a0e29d68$exports = $9d076681a0e29d68$var$baseIsTypedArray;


var $692cb5474f422969$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$692cb5474f422969$exports = $692cb5474f422969$var$baseUnary;



var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $692cb5474f422969$exports($156c3727697ab085$var$nodeIsTypedArray) : $9d076681a0e29d68$exports;
$156c3727697ab085$exports = $156c3727697ab085$var$isTypedArray;


/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $0488fde9aa355453$exports(value), isArg = !isArr && $7d0c6fd0eb26be0e$exports(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $156c3727697ab085$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $b14d62a510ae7f2d$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $d83738e053b5eb08$exports(key, length)))) result.push(key);
    return result;
}
$64568844439edb7f$exports = $64568844439edb7f$var$arrayLikeKeys;


var $e811d2e210fb58cc$exports = {};
var $292432068be14a79$exports = {};
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
$292432068be14a79$exports = $292432068be14a79$var$isPrototype;


var $0b26005314403d97$exports = {};
var $ff813e49bf3cca3d$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$ff813e49bf3cca3d$exports = $ff813e49bf3cca3d$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $ff813e49bf3cca3d$exports(Object.keys, Object);
$0b26005314403d97$exports = $0b26005314403d97$var$nativeKeys;


/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$292432068be14a79$exports(object)) return $0b26005314403d97$exports(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$e811d2e210fb58cc$exports = $e811d2e210fb58cc$var$baseKeys;


var $ac2c42592aa05543$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $15d215b19bcf1187$exports(value.length) && !$004783abbde551e4$exports(value);
}
$ac2c42592aa05543$exports = $ac2c42592aa05543$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $ac2c42592aa05543$exports(object) ? $64568844439edb7f$exports(object) : $e811d2e210fb58cc$exports(object);
}
$08f0eaf3fbcb2fde$exports = $08f0eaf3fbcb2fde$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $9144d49da7a47a72$exports(object, $08f0eaf3fbcb2fde$exports, $51326a29f571e7cd$exports);
}
$7958eecccfe4cef6$exports = $7958eecccfe4cef6$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $7958eecccfe4cef6$exports(object), objLength = objProps.length, othProps = $7958eecccfe4cef6$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$ac8a81cbae0357e8$exports = $ac8a81cbae0357e8$var$equalObjects;


var $474f685f496bfe31$exports = {};
var $41ce0ff3b38ee753$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $5037fd2e597c2a03$exports($23YZo, "DataView");
$41ce0ff3b38ee753$exports = $41ce0ff3b38ee753$var$DataView;



var $b0226bdea11cb834$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $5037fd2e597c2a03$exports($23YZo, "Promise");
$b0226bdea11cb834$exports = $b0226bdea11cb834$var$Promise;


var $05f44e958da968eb$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $5037fd2e597c2a03$exports($23YZo, "Set");
$05f44e958da968eb$exports = $05f44e958da968eb$var$Set;


var $aedce50092a1e6a6$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $5037fd2e597c2a03$exports($23YZo, "WeakMap");
$aedce50092a1e6a6$exports = $aedce50092a1e6a6$var$WeakMap;




/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = "[object Map]", $474f685f496bfe31$var$objectTag = "[object Object]", $474f685f496bfe31$var$promiseTag = "[object Promise]", $474f685f496bfe31$var$setTag = "[object Set]", $474f685f496bfe31$var$weakMapTag = "[object WeakMap]";
var $474f685f496bfe31$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $9c6b3ec69362487e$exports($41ce0ff3b38ee753$exports), $474f685f496bfe31$var$mapCtorString = $9c6b3ec69362487e$exports($19b02faa57603249$exports), $474f685f496bfe31$var$promiseCtorString = $9c6b3ec69362487e$exports($b0226bdea11cb834$exports), $474f685f496bfe31$var$setCtorString = $9c6b3ec69362487e$exports($05f44e958da968eb$exports), $474f685f496bfe31$var$weakMapCtorString = $9c6b3ec69362487e$exports($aedce50092a1e6a6$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $a7f8a2555793d7d3$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($41ce0ff3b38ee753$exports && $474f685f496bfe31$var$getTag(new $41ce0ff3b38ee753$exports(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $19b02faa57603249$exports && $474f685f496bfe31$var$getTag(new $19b02faa57603249$exports) != $474f685f496bfe31$var$mapTag || $b0226bdea11cb834$exports && $474f685f496bfe31$var$getTag($b0226bdea11cb834$exports.resolve()) != $474f685f496bfe31$var$promiseTag || $05f44e958da968eb$exports && $474f685f496bfe31$var$getTag(new $05f44e958da968eb$exports) != $474f685f496bfe31$var$setTag || $aedce50092a1e6a6$exports && $474f685f496bfe31$var$getTag(new $aedce50092a1e6a6$exports) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $a7f8a2555793d7d3$exports(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $9c6b3ec69362487e$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
$474f685f496bfe31$exports = $474f685f496bfe31$var$getTag;




var $f504n = parcelRequire("f504n");

/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = "[object Arguments]", $567f2dd161ebd4f6$var$arrayTag = "[object Array]", $567f2dd161ebd4f6$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $0488fde9aa355453$exports(object), othIsArr = $0488fde9aa355453$exports(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $bbb2d98cae25b61a$exports);
        return objIsArr || $156c3727697ab085$exports(object) ? $1081bd3a2e361911$exports(object, other, bitmask, customizer, equalFunc, stack) : $baf52b9e146f3da7$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $bbb2d98cae25b61a$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $bbb2d98cae25b61a$exports);
    return $ac8a81cbae0357e8$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$567f2dd161ebd4f6$exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$61269cf1f3e020be$exports(value) && !$61269cf1f3e020be$exports(other)) return value !== value && other !== other;
    return $567f2dd161ebd4f6$exports(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
$769812b29c18141e$exports = $769812b29c18141e$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $bbb2d98cae25b61a$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $769812b29c18141e$exports(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$ec073f38db6e7d54$exports = $ec073f38db6e7d54$var$baseIsMatch;


var $6b4f84f6be7f825c$exports = {};
var $0ff8edf4f90a7955$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$f9ff2e983beb6b86$exports(value);
}
$0ff8edf4f90a7955$exports = $0ff8edf4f90a7955$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $08f0eaf3fbcb2fde$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $0ff8edf4f90a7955$exports(value)
        ];
    }
    return result;
}
$6b4f84f6be7f825c$exports = $6b4f84f6be7f825c$var$getMatchData;


var $1f9d5e891556ddb9$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1f9d5e891556ddb9$exports = $1f9d5e891556ddb9$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $6b4f84f6be7f825c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $1f9d5e891556ddb9$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $ec073f38db6e7d54$exports(object, source, matchData);
    };
}
$e780807e2b795134$exports = $e780807e2b795134$var$baseMatches;


var $d5fe8a98fe4800eb$exports = {};

var $d299ac421c05c135$exports = {};

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $fd2d90f592c63519$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$d299ac421c05c135$exports = $d299ac421c05c135$var$get;


var $221e04e57e35dd04$exports = {};
var $d53c6080f339a51f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$d53c6080f339a51f$exports = $d53c6080f339a51f$var$baseHasIn;


var $85aaea8f77d790ae$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $4d60aa8c33155976$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $15d215b19bcf1187$exports(length) && $d83738e053b5eb08$exports(key, length) && ($0488fde9aa355453$exports(object) || $7d0c6fd0eb26be0e$exports(object));
}
$85aaea8f77d790ae$exports = $85aaea8f77d790ae$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $d53c6080f339a51f$exports);
}
$221e04e57e35dd04$exports = $221e04e57e35dd04$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($03e9beb856e9b4cd$exports(path) && $0ff8edf4f90a7955$exports(srcValue)) return $1f9d5e891556ddb9$exports($4d60aa8c33155976$exports(path), srcValue);
    return function(object) {
        var objValue = $d299ac421c05c135$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $221e04e57e35dd04$exports(object, path) : $769812b29c18141e$exports(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
$d5fe8a98fe4800eb$exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;


var $37dff9aa04444f9c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
$37dff9aa04444f9c$exports = $37dff9aa04444f9c$var$identity;



var $87123e72266aa58c$exports = {};
var $d45a621b4548f6bb$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$d45a621b4548f6bb$exports = $d45a621b4548f6bb$var$baseProperty;


var $e029d02f9dd10368$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $fd2d90f592c63519$exports(object, path);
    };
}
$e029d02f9dd10368$exports = $e029d02f9dd10368$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $03e9beb856e9b4cd$exports(path) ? $d45a621b4548f6bb$exports($4d60aa8c33155976$exports(path)) : $e029d02f9dd10368$exports(path);
}
$87123e72266aa58c$exports = $87123e72266aa58c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $37dff9aa04444f9c$exports;
    if (typeof value == "object") return $0488fde9aa355453$exports(value) ? $d5fe8a98fe4800eb$exports(value[0], value[1]) : $e780807e2b795134$exports(value);
    return $87123e72266aa58c$exports(value);
}
$5aba4f6d9f8304a3$exports = $5aba4f6d9f8304a3$var$baseIteratee;


var $b613e194c1b157de$exports = {};
var $35fa3296f177aa01$exports = {};
var $34edfba366a0cfa1$exports = {};
var $9f0778b809a8c692$exports = {};
var $e7bbde6376f4568a$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$e7bbde6376f4568a$exports = $e7bbde6376f4568a$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $e7bbde6376f4568a$exports();
$9f0778b809a8c692$exports = $9f0778b809a8c692$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $9f0778b809a8c692$exports(object, iteratee, $08f0eaf3fbcb2fde$exports);
}
$34edfba366a0cfa1$exports = $34edfba366a0cfa1$var$baseForOwn;


var $f03eae3721f9ace8$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f03eae3721f9ace8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$ac2c42592aa05543$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$f03eae3721f9ace8$exports = $f03eae3721f9ace8$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $35fa3296f177aa01$var$baseEach = $f03eae3721f9ace8$exports($34edfba366a0cfa1$exports);
$35fa3296f177aa01$exports = $35fa3296f177aa01$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b613e194c1b157de$var$baseMap(collection, iteratee) {
    var index = -1, result = $ac2c42592aa05543$exports(collection) ? Array(collection.length) : [];
    $35fa3296f177aa01$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$b613e194c1b157de$exports = $b613e194c1b157de$var$baseMap;


var $6f370ce7a904568e$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $6f370ce7a904568e$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$6f370ce7a904568e$exports = $6f370ce7a904568e$var$baseSortBy;



var $b53b4bd61680c3b6$exports = {};
var $13e53edf809f77b7$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $13e53edf809f77b7$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $6b5a5095e0934938$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $6b5a5095e0934938$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$13e53edf809f77b7$exports = $13e53edf809f77b7$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $b53b4bd61680c3b6$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $13e53edf809f77b7$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$b53b4bd61680c3b6$exports = $b53b4bd61680c3b6$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $e277a64de4eeade6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $d26d80da1ba3948c$exports(iteratees, function(iteratee) {
        if ($0488fde9aa355453$exports(iteratee)) return function(value) {
            return $fd2d90f592c63519$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $37dff9aa04444f9c$exports
    ];
    var index = -1;
    iteratees = $d26d80da1ba3948c$exports(iteratees, $692cb5474f422969$exports($5aba4f6d9f8304a3$exports));
    var result = $b613e194c1b157de$exports(collection, function(value, key, collection) {
        var criteria = $d26d80da1ba3948c$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $6f370ce7a904568e$exports(result, function(object, other) {
        return $b53b4bd61680c3b6$exports(object, other, orders);
    });
}
$e277a64de4eeade6$exports = $e277a64de4eeade6$var$baseOrderBy;



/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $7efd313040cb9ee6$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$0488fde9aa355453$exports(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$0488fde9aa355453$exports(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $e277a64de4eeade6$exports(collection, iteratees, orders);
}
$7efd313040cb9ee6$exports = $7efd313040cb9ee6$var$orderBy;


// Function to create a default column
const $98339aa869f255f6$var$createDefaultColumn = ({ id: id })=>({
        id: id,
        visible: true
    });
const $98339aa869f255f6$var$getDefaultPreference = (columns)=>{
    return {
        stickyColumns: {
            first: 0,
            last: 0
        },
        contentDisplay: columns.map((c)=>$98339aa869f255f6$var$createDefaultColumn(c)),
        pageSize: 20
    };
};
// Function to check if a column exists in the provided definitions
const $98339aa869f255f6$var$isColumnInDefinitions = (column, definitions)=>definitions.some((definition)=>definition.id === column.id);
const $98339aa869f255f6$var$test = {
    Name: "Department 1",
    Id: "03956867-301d-4758-8a49-89b69508752a",
    CanDelete: true
};
const $98339aa869f255f6$export$73903224e3a9e478 = ({ menuItem: menuItem, isEmbedded: isEmbedded = false, defaultData: defaultData = null, handleOnActionColumnClick: handleOnActionColumnClick = ()=>{
    return Promise.resolve();
} })=>{
    const { appName: appName, setSelectedTableRow: setSelectedTableRow, displayStack: displayStack, selectedRow: selectedRow } = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    const { handleViewEvent: handleViewEvent } = (0, $3a99089bf7fdc291$export$1724f667738c6e1d)();
    const { onMenuClick: onMenuClick } = (0, $ba30691687bb8563$export$bc923229a7fa61e7)();
    const api = (0, $ef4677a056004d8e$export$eb2799109db70ffd)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [columnDefinitions, setColumnDefinitions] = (0, $acw62.useState)([]);
    const [tableItems, setTableItems] = (0, $acw62.useState)([]);
    const [selectedItems, setSelectedItems] = (0, $acw62.useState)(selectedRow?.rowData ? [
        selectedRow?.rowData
    ] : []);
    //const [selectedRow, setSelectedRow] = useState<any>({});
    const [sortingColumn, setSortingColumn] = (0, $acw62.useState)(null);
    const [sortingDescending, setSortingDescending] = (0, $acw62.useState)(false);
    const onSortingChange = ({ detail: { isDescending: isDescending, sortingColumn: sortingColumn } })=>{
        setSortingDescending(Boolean(isDescending));
        setSortingColumn(sortingColumn);
        if (isEmbedded == false) doReload(filterText, null, sortingColumn.sortingField, !isDescending);
        else {
            const sortedItems = (0, (/*@__PURE__*/$parcel$interopDefault($7efd313040cb9ee6$exports)))([
                ...tableItems
            ], sortingColumn.sortingField, isDescending ? "desc" : "asc");
            setTableItems(sortedItems);
        }
    };
    const [viewSettings, setViewSettings] = (0, $acw62.useState)({
        totalLines: -1,
        currentPage: 1,
        pageCount: 1
    });
    const [filterText, setFilterText] = (0, $acw62.useState)("");
    const [viewMenu, setViewMenu] = (0, $acw62.useState)([]);
    const [preferences, setPreferences] = (0, $acw62.useState)(null);
    const preferenceKey = appName + "_" + menuItem?.Id + "_preference_cache";
    const filterKey = appName + "_" + menuItem?.Id + "_filter_cache";
    const columnPreferenceKey = appName + "_" + menuItem?.Id + "_column_preference_cache";
    const updateFilterValue = (value)=>{
        localStorage.setItem(filterKey, value);
        setFilterText(value);
        if (value == null || value.length == 0) localStorage.removeItem(filterKey);
    };
    const updateColumnPreferences = (value)=>{
        const savedColumnPreferenceString = localStorage.getItem(columnPreferenceKey);
        let newColumnPreferences = {};
        if (savedColumnPreferenceString) newColumnPreferences = JSON.parse(savedColumnPreferenceString);
        for(let i = 0; i < columnDefinitions.length; i++){
            const colDef = columnDefinitions[i];
            newColumnPreferences[colDef.id] = value.widths[i];
        }
        localStorage.setItem(columnPreferenceKey, JSON.stringify(newColumnPreferences));
    };
    const updatePreferences = (value)=>{
        localStorage.setItem(preferenceKey, JSON.stringify(value));
        let currentPage = viewSettings.currentPage;
        if (value.pageSize > preferences.pageSize) currentPage = 1;
        setViewSettings({
            ...viewSettings,
            currentPage: currentPage
        });
        setPreferences(value);
    };
    const doReload = async (filter = "", _viewSettings = null, sortColumn = "", sortAscending = true)=>{
        await retrieveData(filter, _viewSettings || viewSettings, sortColumn, sortAscending);
    };
    const retrieveData = async (filter = "", _viewSettings, sortColumn = "", sortAscending = true)=>{
        setLoading(true);
        try {
            let data = {
                Data: {
                    viewSettings: {
                        currentPage: _viewSettings.currentPage,
                        linesPerPage: preferences.pageSize,
                        totalLines: -1
                    },
                    filter: filter,
                    sortColumn: sortColumn,
                    sortAscending: sortAscending,
                    parameters: menuItem.Parameters,
                    eventParameters: menuItem.EventParameters
                }
            };
            if (isEmbedded) data = {
                Data: defaultData
            };
            const viewData = await api.makeApiCall("updateViewData/" + menuItem.Id, "POST", data);
            if (viewData && viewData.ViewData) updateItems(viewData.ViewData, _viewSettings.currentPage);
        } catch (err) {
            console.log("error loading data");
            console.log(err);
        } finally{
            setLoading(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (defaultData != null) updateItems(defaultData);
    }, [
        defaultData
    ]);
    const updateItems = (data, pageNumber = 1)=>{
        setTableItems(data);
    //updateCounts(data.length, pageNumber);
    };
    const onActionColumnClick = async (column, rowData)=>{
        setLoading(true);
        try {
            await handleOnActionColumnClick(column, rowData);
            await handleViewEvent(column, rowData, column);
            if (isEmbedded) doRefresh();
        } finally{
            setLoading(false);
        }
    };
    const loadConfig = async ()=>{
        const columnsToShow = menuItem?.Columns?.filter((c)=>c.ColumnType == 0 || c.ColumnType == 1 // 0-string, 1-boolean
        );
        const actionColumnsToShow = menuItem?.Columns?.filter((c)=>c.ColumnType == 2 || c.ColumnType == 3 // 2-button, 3-link
        );
        const hiddenColumns = menuItem?.Columns?.filter((c)=>c.ColumnType == 4 // 4-hiden
        ); // not sure if we need to do anything with this
        // 5-date, 6-checkbox // maybe later can format and do other stuff
        if (!columnsToShow) return;
        const savedPreferencesString = localStorage.getItem(preferenceKey);
        const savedColumnPreferenceString = localStorage.getItem(columnPreferenceKey);
        let defaultColumnPreferences = {};
        if (savedColumnPreferenceString) defaultColumnPreferences = JSON.parse(savedColumnPreferenceString);
        const viewColumns = columnsToShow.map((c)=>({
                id: c.ColumnName,
                header: c.ColumnLabel,
                cell: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $14c1dd08e5f1280b$export$ff93575ad9700188), {
                        rowData: row,
                        column: c
                    }),
                width: defaultColumnPreferences[c.ColumnName] || 250,
                sortingField: c.ColumnName.includes(".") ? null : c.ColumnName
            }));
        const cols = [
            ...viewColumns
        ];
        if (actionColumnsToShow.length > 0) cols.push({
            id: "actions",
            header: "Actions",
            cell: (rowData)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f358e506d11489c$export$332bbb895017705d), {
                    rowData: rowData,
                    columns: actionColumnsToShow,
                    onClick: (c, r)=>onActionColumnClick(c, r)
                })
        });
        let updatedPreferences = $98339aa869f255f6$var$getDefaultPreference(cols);
        if (savedPreferencesString) try {
            updatedPreferences = JSON.parse(savedPreferencesString);
        } catch (err) {
            console.log("error parsing saved preferences for menu item: ", menuItem);
            console.log(err);
        }
        // sync saved preferences with any updates made since they were saved
        if (updatedPreferences && updatedPreferences.contentDisplay) {
            // Start with columns from preferences to keep the user order and filter out deprecated columns
            const existingColumns = updatedPreferences.contentDisplay.filter((column)=>$98339aa869f255f6$var$isColumnInDefinitions(column, cols));
            const columnDefinitionIds = cols.filter(({ id: id })=>id).map(({ id: id })=>({
                    id: id
                }));
            let preferencesContentDisplay = [
                ...updatedPreferences.contentDisplay
            ];
            // Add new columns from definitions
            const newColumns = columnDefinitionIds.filter((column)=>!$98339aa869f255f6$var$isColumnInDefinitions(column, preferencesContentDisplay)).map($98339aa869f255f6$var$createDefaultColumn);
            const contentDisplay = [
                ...existingColumns,
                ...newColumns
            ];
            updatedPreferences = {
                ...updatedPreferences,
                contentDisplay: contentDisplay
            };
        }
        setPreferences(updatedPreferences);
        setColumnDefinitions(cols);
    };
    const loadViewMenu = async ()=>{
        const data = {
            data: menuItem.DataForGettingMenu
        };
        const viewMenu = await api.makeApiCall("getViewMenu/" + menuItem.Id, "POST", data);
        setViewMenu(viewMenu);
    };
    const updateCounts = (totalLines, currentPage)=>{
        const pageSize = preferences?.pageSize || 100000;
        let pageCount = Math.floor(totalLines / pageSize);
        if (totalLines % pageSize > 0) pageCount++;
        if (currentPage > pageCount) currentPage = pageCount;
        setViewSettings({
            ...viewSettings,
            currentPage: currentPage,
            totalLines: totalLines,
            pageCount: pageCount
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (preferences && menuItem) {
            // clear page settings
            setSortingDescending(false);
            setSortingColumn(null);
            updateCounts(menuItem.TotalLines, viewSettings.currentPage);
            const storedFilterValue = localStorage.getItem(filterKey);
            updateFilterValue(storedFilterValue || "");
            if (!isEmbedded) doReload(storedFilterValue);
        }
    }, [
        preferences,
        menuItem
    ]);
    (0, $acw62.useEffect)(()=>{
        if (menuItem) {
            loadConfig();
            loadViewMenu(); // this loads even it was previously shown. I think react clears state when a component is re-rendered. Might have to store my own state for this to work in the main app somehow
        }
    }, [
        menuItem
    ]);
    const debouncedFilterChange = ()=>(0, $154d4ea6bbdaf516$export$21805fee57372823)(()=>{
            doReload(filterText, null, sortingColumn?.sortingField, !sortingDescending);
        }, "refresh", 500);
    const viewMenuItemClick = async (item)=>{
        const data = {
            // data: item.ParametersToPass, // i am dissabling this because for adding in detail section, the parameters value should be what was set in parameters
            // parameters: {
            //   ViewId: item.EventNumber,
            // },
            parameters: item.ParametersToPass
        };
        await handleOnActionColumnClick(null, null);
        await onMenuClick(item.EventNumber, data);
    };
    const tableActions = viewMenu?.map((m, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
            variant: "normal",
            onClick: ()=>viewMenuItemClick(m),
            children: m.Label
        }, i));
    const doRefresh = ()=>{
        doReload(filterText, null, sortingColumn?.sortingField, !sortingDescending);
    };
    if (!isEmbedded) tableActions.unshift(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
        variant: "icon",
        iconName: "refresh",
        onClick: doRefresh
    }, "refresh"));
    const onSelectionChange = (items)=>{
        setSelectedItems(items);
        const selectedRow = items?.length === 1 ? items[0] : null;
        setSelectedTableRow({
            menuItem: menuItem,
            rowData: selectedRow
        });
    };
    // TODO: E.g. - on Departments to view the expenses.
    //              will have to get/set via mainApp
    // TODO: I wanted to add the details section as something that can be passed from the back-end.
    //       It might have to be a child component or something as the details panel can have multiple tabs.
    //       Maybe a field that returns a list of MenuNumbers of ViewDetail classes.
    //       But maybe there's a way then to use something other than MenuNumbers so that we can prevent users from adding the wrong number by accident.
    //       Maybe ask for the types only?
    //       --> have a method with an object where users can call config.AddDetailView<T>(); // where T is the detail view type. I think this is the best.
    //           or just initialize the class like inputView
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9d0e5ed1593f09$export$2e2bcd8739ae039), {
        items: tableItems,
        loading: loading,
        resizableColumns: true,
        onColumnWidthsChange: (e)=>updateColumnPreferences(e.detail),
        loadingText: "Loading data",
        columnDefinitions: columnDefinitions,
        variant: isEmbedded ? "embedded" : "full-page",
        sortingDisabled: menuItem?.AllowSorting === false,
        sortingColumn: sortingColumn,
        sortingDescending: sortingDescending,
        onSortingChange: onSortingChange,
        onSelectionChange: ({ detail: detail })=>{
            onSelectionChange(detail.selectedItems);
        },
        selectedItems: selectedItems,
        selectionType: isEmbedded || !menuItem.DetailSectionId ? null : "single",
        empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
            margin: {
                vertical: "xs"
            },
            textAlign: "center",
            color: "inherit",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                size: "m",
                children: filterText.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            children: "No matches found "
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                updateFilterValue("");
                                doReload("", null, sortingColumn.sortingField, !sortingDescending);
                            },
                            children: "Clear filter"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                    children: "No resources"
                })
            })
        }),
        header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $417cbce8ab3dcc04$export$2e2bcd8739ae039), {
            variant: "awsui-h1-sticky",
            counter: `(${isEmbedded ? tableItems.length : viewSettings.totalLines})`,
            actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                direction: "horizontal",
                size: "xs",
                children: tableActions
            }),
            children: menuItem?.Title
        }),
        filter: isEmbedded ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1ad38163d990f1e$export$2e2bcd8739ae039), {
            filteringPlaceholder: "Filter items",
            onChange: ({ detail: detail })=>updateFilterValue(detail.filteringText),
            onDelayedChange: (x)=>{
                if (x.detail.filteringText == null || x.detail.filteringText == "") doReload("", null, sortingColumn?.sortingField, !sortingDescending);
                else debouncedFilterChange();
            },
            filteringText: filterText,
            countText: tableItems.length === 1 ? "1 match" : tableItems.length + " matches"
        }),
        columnDisplay: preferences?.contentDisplay,
        contentDensity: preferences?.contentDensity,
        stripedRows: preferences?.stripedRows,
        wrapLines: preferences?.wrapLines,
        stickyColumns: preferences?.stickyColumns,
        pagination: isEmbedded ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ede657b6d0ca61ed$export$2e2bcd8739ae039), {
            currentPageIndex: viewSettings.currentPage,
            pagesCount: viewSettings.pageCount,
            onChange: ({ detail: detail })=>{
                const newViewSettings = {
                    ...viewSettings,
                    currentPage: detail.currentPageIndex
                };
                setViewSettings(newViewSettings);
                doReload(filterText, newViewSettings, sortingColumn?.sortingField || "", !sortingDescending);
            }
        }),
        preferences: isEmbedded ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a89636bbaa439431$export$d5a7fa40d422cbcd), {
            preferences: preferences,
            setPreferences: updatePreferences,
            columnDisplayPreferenceOptions: columnDefinitions.map(({ id: id, header: header, isRowHeader: isRowHeader })=>({
                    id: id,
                    label: header,
                    alwaysVisible: isRowHeader
                }))
        })
    });
};


const $a53b2bb5fbfe6059$export$cec7cafc710f5d68 = ({ menuItem: menuItem })=>{
    const mainApp = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const dispatch = (0, $c0aa018cd5ecdf0e$export$f51d452c10d5b956)();
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    const [errors, setErrors] = (0, $acw62.useState)({});
    const [values, setValues] = (0, $acw62.useState)({});
    const [fieldVisibility, setFieldVisibility] = (0, $acw62.useState)({});
    const [fieldSources, setFieldSources] = (0, $acw62.useState)({});
    const api = (0, $ef4677a056004d8e$export$eb2799109db70ffd)();
    const { handleAction: handleAction } = (0, $ba30691687bb8563$export$bc923229a7fa61e7)();
    const valuesRef = (0, $acw62.useRef)({});
    const [formCache, setFormCache] = (0, $acw62.useState)(null);
    valuesRef.current = values;
    const getInputValue = async (field, onChangeValue = null)=>{
        let value = null;
        if (onChangeValue != null) value = onChangeValue;
        else if (valuesRef.current[field.InputName] != null) value = valuesRef.current[field.InputName];
        if (field.InputType == 3) {
            // combo box
            const selectedItem = value;
            if (selectedItem) value = selectedItem?.value;
        } else if (field.InputType == 5) {
            // list selection
            const selectedItems = value;
            value = selectedItems?.filter((s)=>s != null).map((s)=>s.value);
        } else if (field.InputType == 6) // date
        {
            if (value) value = new Date(value).toISOString().split("T")[0]; // example date = 2024-07-21T00:00:00.000Z
        //TODO: make sure dates are working - test adding/editing/prop changed, etc
        // This code is so it works in Odyssey I think
        // const date = new Date(value);
        // value =
        //   String(date.getDate()).padStart(2, "0") +
        //   "-" +
        //   String(date.getMonth() + 1).padStart(2, "0") +
        //   "-" +
        //   String(date.getFullYear()).padStart(2, "0");
        // TODO: revert this
        } else if (field.InputType == 8) {
            // input view
            value = valuesRef.current[field.InputName];
            return value;
        } else if (field.InputType == 9) // file
        {
            if (value && value.length > 0) {
                value = await readFile(value[0]);
                return value;
            }
        }
        return value;
    };
    const readFile = async (file)=>{
        return new Promise(function(resolve, reject) {
            const reader = new FileReader();
            reader.onload = function(e) {
                const arrayBuffer = e.target.result;
                const byteArray = new Uint8Array(arrayBuffer);
                // Convert Uint8Array to binary string
                let binaryString = "";
                for(let i = 0; i < byteArray.length; i++)binaryString += String.fromCharCode(byteArray[i]);
                const base64String = window.btoa(binaryString);
                const filename = file.name;
                const parts = filename.split(".");
                const extension = parts.length > 1 ? parts[parts.length - 1] : "";
                const nameWithoutExtension = parts[0];
                const result = {
                    Data: base64String,
                    FileName: nameWithoutExtension,
                    MimeType: file.type,
                    FileExtension: extension,
                    Size: file.size
                };
                resolve(result);
            };
            reader.onerror = function(err) {
                reject(err);
            };
            reader.readAsArrayBuffer(file);
        }).catch(function(err) {
            console.error(err);
            dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                type: "error",
                content: `Error reading file, see logs for details (${err})`
            }));
        });
    };
    const getInputValues = async (includeAll = false)=>{
        const result = {};
        for(let i = 0; i < menuItem.InputFields.length; i++){
            const field = menuItem.InputFields[i];
            if (includeAll != true) {
                const isVisible = fieldVisibility[field.InputName];
                if (!isVisible) continue;
            }
            result[field.InputName] = await getInputValue(field);
        }
        return result;
    };
    const onButtonClick = async (button)=>{
        setLoading(true);
        // TODO: conditional mandatory setting
        // TODO: test that all inputs and features are working
        try {
            if (button.ValidateInput) //todo : validate all input fields -> currentMenu.fields with values
            for(let i = 0; i < menuItem.InputFields.length; i++){
                const field = menuItem.InputFields[i];
                const value = await getInputValue(field);
                const validationResult = validateField(field, value);
                if (validationResult.length > 0) return;
            }
            const params = await getInputValues();
            const data = {
                Data: params || "",
                ActionId: button.ActionNumber
            };
            // call api
            const resp = await api.makeApiCall("processEvent/" + menuItem.Id, "POST", data);
            //await formEvents.handleEvents(resp);
            for(let i = 0; i < resp?.length; i++)handleAction(resp[i]);
        } catch (error) {
            console.log(error);
            let message = "Unexpected error: " + error;
            dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                type: "error",
                content: message
            }));
        } finally{
            setLoading(false);
        }
    };
    const validateField = (field, value, forcedCheck = false)=>{
        if (field.Mandatory === true && (fieldVisibility[field.InputName] !== false || forcedCheck === true)) {
            if (value === null || value === "") return field.InputLabel + " is required";
            if (field.InputType == 3) ;
            else if (field.InputType == 5) {
                if (value == null || value.length == 0) return field.InputLabel + " is required";
            } else if (field.InputType == 9) {
                if (value == null || value.length == 0) return field.InputLabel + " is required";
            }
        }
        return "";
    };
    const buildInputs = ()=>{
        const fields = menuItem.InputFields;
        const defaultVisibility = fields.reduce((prev, f)=>{
            prev[f.InputName] = true;
            return prev;
        }, {});
        const defaultFieldSources = fields.filter((f)=>f.InputType == 5 || f.InputType == 3).reduce((prev, f)=>{
            prev[f.InputName] = f.InputType == 5 ? f.ListSource : f.ListItems;
            return prev;
        }, {});
        setFieldSources(defaultFieldSources);
        setFieldVisibility(defaultVisibility);
        fields.forEach((f)=>{
            let defaultValue = f.DefaultValue;
            switch(f.InputType){
                case 3:
                    // combo box
                    if (f.DefaultValue) defaultValue = {
                        label: f.ListItems.filter((l)=>l.Key == f.DefaultValue)[0]?.Value,
                        value: f.DefaultValue
                    };
                    else defaultValue = null;
                    break;
                case 4:
                    // boolean
                    defaultValue = f.DefaultValue === true ? true : false;
                    break;
                case 5:
                    {
                        // multi select
                        let listDefaultValue = f.DefaultValue || "";
                        if (listDefaultValue.constructor.name != "Array") listDefaultValue = listDefaultValue.split(",");
                        const tmpDefaultValues = listDefaultValue;
                        defaultValue = tmpDefaultValues.map((d)=>{
                            const label = f.ListSource.filter((l)=>l.Key == d)[0]?.Value;
                            return {
                                label: label,
                                value: d
                            };
                        }).filter((x)=>x.label && x.label != "");
                        break;
                    }
                case 6:
                    // date input
                    defaultValue = f.DefaultValue || "";
                    if (defaultValue) // convert from mainApp.dateFormat
                    try {
                        //defaultValue = parse("23-06-2024", "dd-MM-YYYY", new Date());
                        defaultValue = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(defaultValue, "DD-MMM-YYYY").format("YYYY-MM-DD");
                    } catch (err) {
                        console.log("error parsing date: " + defaultValue);
                        console.log(err);
                    }
                    break;
                case 8:
                    break;
                case 9:
                    // file input
                    defaultValue = [];
                    break;
                default:
                    break;
            }
            onChange(f, defaultValue, true); // to update the visbility
        });
    };
    const [dummy, setDummy] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        if (menuItem) {
            buildInputs();
            setDummy("reload-done"); // using this because we need various state values set before calling the onChange method (i.e. getting/setting the value state variable)
        }
    }, [
        menuItem
    ]);
    (0, $acw62.useEffect)(()=>{
        if (dummy == "reload-done") {
            const fields = menuItem.InputFields;
            const valuesToUse = formCache?.cacheValue ?? values;
            fields.forEach((f)=>{
                const fieldValue = valuesToUse[f.InputName];
                onChange(f, fieldValue); // raise on property changed now to update visibility conditions etc
            });
            setDummy("");
        }
    }, [
        dummy
    ]);
    (0, $acw62.useEffect)(()=>{
        if (mainApp.inputViewUpdateData != null && formCache != null) {
            const currentValue = values[formCache.fieldName] || [];
            const inputViewUpdateData = mainApp.inputViewUpdateData;
            let newValue = [];
            if (inputViewUpdateData == null) // this was a cancellation
            return;
            if (inputViewUpdateData === -1) {
                // delete item
                newValue = currentValue;
                newValue.splice(formCache.rowId, 1);
            } else if (formCache.rowId == -1) {
                // this is for a new item
                let rowId = -1;
                for(let j = 0; j < currentValue.length; j++)rowId = Math.max(rowId, currentValue[j].rowId);
                rowId++;
                inputViewUpdateData.rowId = rowId;
                newValue = [
                    ...currentValue,
                    inputViewUpdateData
                ];
            } else {
                // this is when an item is modified
                const rowIndex = formCache.rowId;
                newValue = currentValue;
                inputViewUpdateData.rowId = rowIndex;
                newValue[rowIndex] = inputViewUpdateData;
            }
            // update all rowIds
            let index = 0;
            for(let j = 0; j < newValue.length; j++){
                newValue[j].rowId = index;
                index++;
            }
            setValues((prevValues)=>({
                    ...prevValues,
                    [formCache.fieldName]: newValue
                }));
        }
    }, [
        mainApp.inputViewUpdateData
    ]);
    const conditionIsMet = (condition, value)=>{
        if (condition.Comparison == 0) // Equals
        return value === condition.ColumnValue;
        else if (condition.Comparison == 1) // Not-Equals
        return value != condition.ColumnValue;
        else if (condition.Comparison == 2) // Contains
        return value.indexOf(condition.ColumnValue) > -1;
        else if (condition.Comparison == 3) // IsNotNull
        return value != null && (value + "").length > 0;
        else if (condition.Comparison == 4) // IsNull
        return value == null || (value + "").length == 0;
        else {
            console.log("Error", "Unknown comparison: " + condition.Comparison);
            return false;
        }
    };
    const raisePropertyChangedEvent = async (field, fieldValue)=>{
        setLoading(true);
        try {
            const data = {
                Data: {
                    PropertyName: field.InputName,
                    PropertyValue: fieldValue,
                    EventId: menuItem.Id
                }
            };
            const resp = await api.makeApiCall("propertyChanged/" + menuItem.Id, "POST", data);
            if (resp && resp.length > 0) for(let i = 0; i < resp.length; i++){
                let item = resp[i];
                switch(item.ActionType){
                    case 10:
                        {
                            // update combo box
                            setFieldSources((prevValues)=>({
                                    ...prevValues,
                                    [item.InputName]: item.ListItems
                                }));
                            const fld = menuItem.InputFields.filter((f)=>f.InputName == item.InputName)[0];
                            const currentValue = await getInputValue(fld);
                            if (currentValue) {
                                if (fld.InputType == 3) {
                                    const validValues = item.ListItems.map((l)=>l.Key);
                                    if (!validValues.includes(currentValue)) setValues((prevValues)=>({
                                            ...prevValues,
                                            [item.InputName]: null
                                        }));
                                } else if (fld.InputType == 5) {
                                    const validValues = item.ListItems.map((l)=>l.Key);
                                    let newCurrentValue = values[item.InputName];
                                    const updatedValue = newCurrentValue.filter((n)=>validValues.includes(n.value));
                                    if (!validValues.includes(currentValue)) setValues((prevValues)=>({
                                            ...prevValues,
                                            [item.InputName]: updatedValue
                                        }));
                                }
                            }
                            break;
                        }
                    case 17:
                        // UpdateInputVisibility
                        setFieldVisibility((prevValues)=>({
                                ...prevValues,
                                [item.InputName]: item.InputIsVisible
                            }));
                        break;
                    default:
                        console.log("unknown action type: " + item.ActionType);
                        dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                            type: "error",
                            content: "Unknown action type: " + item.ActionType
                        }));
                        break;
                }
            }
        } finally{
            setLoading(false);
        }
    };
    const debouncedPropertyChanged = (propName, timeout, field, ...x)=>(0, $154d4ea6bbdaf516$export$21805fee57372823)(raisePropertyChangedEvent, propName, timeout, ...[
            field,
            ...x
        ]);
    const updateFieldVisibilities = (fieldChanged, valueChanged)=>{
        const otherFields = menuItem.InputFields.filter((f)=>f.VisibilityConditions.filter((v)=>v.ColumnName == fieldChanged.InputName).length > 0);
        for(let i = 0; i < otherFields.length; i++){
            const field = otherFields[i];
            const matchedConditions = field.VisibilityConditions.filter((condition)=>conditionIsMet(condition, valueChanged?.toString()));
            if (matchedConditions.length > 0) {
                const otherValue = values[field.InputName];
                updateFieldErrors(field, otherValue, true);
            }
            setFieldVisibility((prevValues)=>({
                    ...prevValues,
                    [field.InputName]: matchedConditions.length > 0
                }));
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (errors) {
            const keys = Object.keys(errors);
            let thereAreErrors = false;
            for(let i = 0; i < keys.length; i++){
                const error = errors[keys[i]];
                const visibility = fieldVisibility[keys[i]];
                if (error && visibility === true) thereAreErrors = true;
            }
            if (thereAreErrors === true) setErrorMessage("There are invalid inputs. Make sure to check all tabs.");
            else setErrorMessage("");
        }
    }, [
        errors
    ]);
    const updateFieldErrors = async (field, value, forcedValidation = false // because this might be checked while changing visibility
    )=>{
        const actualValue = await getInputValue(field, value);
        const fieldError = validateField(field, actualValue, forcedValidation);
        setErrors((prevErrors)=>({
                ...prevErrors,
                [field.InputName]: fieldError
            }));
    };
    const onChange = async (field, value, isScreenSetup = false)=>{
        setValues((prevValues)=>({
                ...prevValues,
                [field.InputName]: value
            }));
        await updateFieldErrors(field, value);
        if (isScreenSetup === true) return; // don't handle property changed events or check visibility conditions during screen setup
        const fieldValue = await getInputValue(field, value);
        updateFieldVisibilities(field, fieldValue);
        if (field.RaisePropertyChangedEvent === true) {
            let timeoutValue = 0;
            if (field.InputType == 0 || field.InputType == 1 || field.InputType == 10) timeoutValue = 500;
            debouncedPropertyChanged(field.InputName, timeoutValue, field, fieldValue);
        }
    };
    const onInputViewColumnActionClick = async (field, rowData)=>{
        const currentInputs = valuesRef.current;
        mainApp.setInputViewUpdateData(null); // clear any values here
        const cacheItem = {
            fieldName: field.InputName,
            cacheValue: currentInputs,
            rowId: rowData?.rowId ?? -1
        };
        setFormCache(cacheItem);
        return Promise.resolve();
    };
    const getInputField = (field, setAutoFocus)=>{
        switch(field.InputType){
            case 0:
            case 1:
                if (field.MultiLineText == true) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $def0f31f988660f4$export$2e2bcd8739ae039), {
                    placeholder: field.InputLabel,
                    autoFocus: setAutoFocus,
                    value: values?.[field.InputName],
                    onChange: ({ detail: { value: value } })=>onChange(field, value)
                });
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc0ce5a84f6f2813$export$2e2bcd8739ae039), {
                    placeholder: field.InputLabel,
                    autoFocus: setAutoFocus,
                    type: field.InputType == 1 ? "password" : "text",
                    value: values?.[field.InputName],
                    onChange: ({ detail: { value: value } })=>onChange(field, value)
                });
            case 2:
                return null;
            case 3:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a3c01a344cfcaf3$export$2e2bcd8739ae039), {
                    autoFocus: setAutoFocus,
                    selectedOption: values?.[field.InputName],
                    onChange: ({ detail: detail })=>{
                        onChange(field, detail.selectedOption);
                    },
                    options: fieldSources[field.InputName]?.map((x)=>({
                            label: x.Value,
                            value: x.Key
                        }))
                });
            case 4:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f975e47fe9face4d$export$2e2bcd8739ae039), {
                    onChange: ({ detail: detail })=>onChange(field, detail.checked),
                    checked: values?.[field.InputName],
                    children: field.InputLabel
                });
            case 5:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8bb34a8468c146d7$export$2e2bcd8739ae039), {
                    tokenLimit: 10,
                    autoFocus: setAutoFocus,
                    selectedOptions: values?.[field.InputName],
                    onChange: ({ detail: detail })=>{
                        onChange(field, detail.selectedOptions);
                    },
                    options: fieldSources[field.InputName]?.map((x)=>({
                            label: x.Value,
                            value: x.Key
                        }))
                });
            case 6:
                console.log("getting date picker for value " + values?.[field.InputName]);
                const userLocale = navigator.language || navigator.languages[0];
                const today = new Date();
                // Format today's date using the user's locale
                const formattedDate = new Intl.DateTimeFormat(userLocale).format(today);
                console.log("user info:");
                console.log("user locale = " + userLocale);
                console.log("user's formatted date = " + formattedDate);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0fddd550297817b9$export$2e2bcd8739ae039), {
                    locale: "en-CA" // en-CA uses the date format YYYY-MM-DD, which is what we use (i think)
                    ,
                    value: values?.[field.InputName],
                    autoFocus: setAutoFocus,
                    onChange: ({ detail: { value: value } })=>onChange(field, value),
                    placeholder: field.InputLabel
                });
            case 8:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60822fbe2c08caa5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $98339aa869f255f6$export$73903224e3a9e478), {
                        menuItem: field.ViewForInput,
                        isEmbedded: true,
                        defaultData: values?.[field.InputName],
                        handleOnActionColumnClick: (c, data)=>onInputViewColumnActionClick(field, data)
                    })
                });
            case 9:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0caa904d8e7106e8$export$2e2bcd8739ae039), {
                    onChange: ({ detail: { value: value } })=>onChange(field, value),
                    value: values?.[field.InputName],
                    i18nStrings: {
                        uploadButtonText: (e)=>e ? "Choose files" : "Choose file",
                        dropzoneText: (e)=>e ? "Drop files to upload" : "Drop file to upload",
                        removeFileAriaLabel: (e)=>`Remove file ${e + 1}`,
                        limitShowFewer: "Show fewer files",
                        limitShowMore: "Show more files",
                        errorIconAriaLabel: "Error"
                    },
                    showFileLastModified: false,
                    showFileSize: true,
                    showFileThumbnail: true
                });
            case 10:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc0ce5a84f6f2813$export$2e2bcd8739ae039), {
                    autoFocus: setAutoFocus,
                    type: "number",
                    placeholder: field.InputLabel,
                    value: values?.[field.InputName],
                    onChange: ({ detail: { value: value } })=>onChange(field, value)
                });
            case 11:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: field.DefaultValue
                });
            default:
                console.error("unhandled input type: " + field.InputType);
                console.log(field);
                dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                    type: "error",
                    content: "Unknown input type: " + field.InputType + " for field " + field.InputLabel
                }));
                return null;
        }
    };
    const getTabContent = (tabName)=>{
        const fields = menuItem.InputFields.filter((x)=>x.TabName == tabName || tabName == null && x.TabName == "");
        const formFields = fields.filter((f)=>f.InputType != 2 /* exclude hidden fields */ ).map((f, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: fieldVisibility[f.InputName] != true ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d07d035b542ec3e4$export$2e2bcd8739ae039), {
                    label: f.InputLabel,
                    errorText: errors?.[f.InputName],
                    children: getInputField(f, i == 0)
                }, f.InputName)
            }, f.InputName));
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
            size: "l",
            children: formFields
        });
    };
    const getTabs = ()=>{
        if (menuItem == null) return null;
        // Get unique tab names, ignore hidden inputs
        const uniqueTabs = new Set();
        menuItem.InputFields.forEach((field)=>{
            if (field.InputType != 2) uniqueTabs.add(field.TabName || "");
        });
        const tabNames = Array.from(uniqueTabs?.values()).filter((x)=>x != null && x.length > 0);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                tabNames.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9b1a89cfa249459$export$2e2bcd8739ae039), {
                    tabs: tabNames.map((t)=>({
                            label: t,
                            id: t,
                            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                                size: "l",
                                children: getTabContent(t)
                            })
                        }))
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                    size: "l",
                    children: getTabContent(null)
                })
            ]
        });
    };
    const onFormSubmit = (e)=>{
        e.preventDefault();
    // button events handle the submit case
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
        onSubmit: onFormSubmit,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3128a80b6a88093c$export$2e2bcd8739ae039), {
            variant: "full-page",
            header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $417cbce8ab3dcc04$export$2e2bcd8739ae039), {
                variant: "awsui-h1-sticky",
                children: menuItem?.Title
            }),
            // errorText="Some error"
            errorText: errorMessage,
            actions: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74ee220a592e3066$export$2e2bcd8739ae039), {
                direction: "horizontal",
                size: "xs",
                alignItems: "end",
                children: menuItem?.InputButtons?.map((b)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cee4eab59be790b$export$2e2bcd8739ae039), {
                        variant: "primary",
                        loading: loading,
                        onClick: ()=>onButtonClick(b),
                        children: b.Label
                    }, b.Label))
            }),
            children: getTabs()
        })
    });
};




const $d236e265f1464cfc$export$f845437bf1d007fd = ({ menuItem: menuItem })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $98339aa869f255f6$export$73903224e3a9e478), {
        menuItem: menuItem
    });
};





var $acw62 = parcelRequire("acw62");





function $d2db684d56659d26$export$2e2bcd8739ae039(_a) {
    var { gridDefinition: gridDefinition = [], disableGutters: disableGutters = false, children: children } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "gridDefinition",
        "disableGutters",
        "children"
    ]);
    const baseComponentProps = (0, $970c67f83063979b$export$2e2bcd8739ae039)("Grid", {
        props: {
            disableGutters: disableGutters
        }
    });
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const [breakpoint, ref] = (0, $921c3f4037759790$export$2aa1887afbd6d218)(undefined);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $533fd63a0264232f$export$2e2bcd8739ae039), Object.assign({}, baseProps, baseComponentProps, {
        ref: ref,
        __breakpoint: breakpoint,
        gridDefinition: gridDefinition,
        disableGutters: disableGutters
    }), children);
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($d2db684d56659d26$export$2e2bcd8739ae039, "Grid");



const $54090c4ee8bb0552$var$ServiceFeatureListItem = ({ title: title, description: description })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
                variant: "h3",
                padding: "n",
                fontWeight: "normal",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
                variant: "p",
                children: description
            })
        ]
    });
const $54090c4ee8bb0552$export$b94310965bed44e6 = ()=>{
    const mainApp = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c3c7a1fd2ca4107$export$2e2bcd8739ae039), {
        header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2db684d56659d26$export$2e2bcd8739ae039), {
            gridDefinition: [
                {
                    colspan: {
                        default: 12,
                        xs: 8,
                        s: 9
                    }
                },
                {
                    colspan: {
                        default: 12,
                        xs: 4,
                        s: 3
                    }
                }
            ],
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
                padding: "s",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09d4a5bf5140299c$export$2e2bcd8739ae039), {
                        fontSize: "display-l",
                        fontWeight: "bold",
                        variant: "h1",
                        padding: "n",
                        children: mainApp.appName
                    }),
                    "HOME"
                ]
            })
        })
    });
};


const $e26b8abf7ea53dd6$var$MainAppContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $e26b8abf7ea53dd6$var$homeDisplayItem = {
    menu: null,
    type: "home",
    visible: true,
    id: "home",
    component: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54090c4ee8bb0552$export$b94310965bed44e6), {}),
    splitPanelContents: ()=>null
};
let $e26b8abf7ea53dd6$var$clearingStack = false;
const $e26b8abf7ea53dd6$export$e3f0b906e9bc3bad = ({ children: children })=>{
    const [appName, setAppName] = (0, $acw62.useState)("");
    const [appVersion, setAppVersion] = (0, $acw62.useState)("");
    const [dateFormat, setDateFormat] = (0, $acw62.useState)("");
    const [isReady, setIsReady] = (0, $acw62.useState)(false);
    const [selectedRow, setRow] = (0, $acw62.useState)(null);
    const [currentContentType, setCurrentContentType] = (0, $acw62.useState)("default");
    const [displayStack, setDisplayStack] = (0, $acw62.useState)([
        $e26b8abf7ea53dd6$var$homeDisplayItem
    ]);
    const makeLastItemVisible = (stack)=>{
        if (stack.length > 0) stack[stack.length - 1].visible = true;
    };
    const hideAllItems = (stack)=>{
        for(let i = 0; i < stack.length; i++)stack[i].visible = false;
    };
    const getComponent = (display)=>{
        switch(display.type){
            case "login":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bed6b8339cc09029$export$21a94553ffa41578), {});
            case "form":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a53b2bb5fbfe6059$export$cec7cafc710f5d68), {
                    menuItem: display.menu
                }); //TODO: not creating a new copy of form - all state values need to be handled somewhere else then
            case "view":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d236e265f1464cfc$export$f845437bf1d007fd), {
                    menuItem: display.menu
                });
            case "home":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54090c4ee8bb0552$export$b94310965bed44e6), {});
        }
    };
    const addDisplayItem = (item, visible, stack)=>{
        const stackItem = {
            id: (0, $3fa3ae484854b431$export$2e2bcd8739ae039)(),
            visible: visible,
            menu: item.menu,
            type: item.type,
            component: getComponent(item),
            splitPanelContents: ()=>null
        };
        //TODO: if view, set split panel stuff somehow
        stack.push(stackItem);
    };
    const showComponent = (displayItem)=>{
        let stack = [
            ...displayStack
        ];
        hideAllItems(stack);
        if ($e26b8abf7ea53dd6$var$clearingStack === true) {
            $e26b8abf7ea53dd6$var$clearingStack = false;
            stack = [
                $e26b8abf7ea53dd6$var$homeDisplayItem
            ];
        }
        if (displayItem == -1) {
            // remove current item
            if (stack.length > 0) {
                const index = stack.length - 1;
                const lastItem = stack[index];
                stack = [
                    ...stack.slice(0, index),
                    ...stack.slice(index + 1)
                ];
            }
            if (displayStack.length == 0) addDisplayItem($e26b8abf7ea53dd6$var$homeDisplayItem, true, stack);
        } else addDisplayItem(displayItem, true, stack);
        makeLastItemVisible(stack);
        setDisplayStack(stack);
    };
    const [inputViewUpdateData, setInputViewUpdateData] = (0, $acw62.useState)(null);
    const initializeSystem = async ()=>{
        try {
            const cacheControl = `&_=${Date.now()}`; // don't cache stuff
            const urlToCall = `${(0, $d8475b95fcbdc3b7$export$923ea8233b386e99)}initializeSystem?v=${cacheControl}`;
            const resp = await fetch(urlToCall);
            const systemInfo = await resp.json();
            if (systemInfo) {
                if (systemInfo.ConstructionError) {
                    console.log("There was an error in the system initialization code:");
                    console.log(systemInfo.ConstructionError);
                    (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                        type: "error",
                        content: `"There was an error in the system initialization code:" ${systemInfo.ConstructionError}`
                    }));
                } else {
                    setAppName(systemInfo.ApplicationName);
                    setAppVersion(systemInfo.Version);
                    setDateFormat(systemInfo.DateFormat);
                    document.title = `${systemInfo.ApplicationName} ${systemInfo.Version}`;
                    setIsReady(true);
                }
            }
        } catch (err) {
            console.error("Fatal error calling initialize system:");
            // wouldn't really happen because back-end hosts front-end
            console.error(err);
            (0, $b38651f901ccdd09$export$6f57813fe9f31bf9).dispatch((0, $e94319ab67c021b4$export$16fdb433d434f08)({
                type: "error",
                content: `Fatal error: ${err}`
            }));
        }
    };
    const setSelectedTableRow = (selection)=>{
        setRow(selection);
    };
    (0, $acw62.useEffect)(()=>{
        initializeSystem();
    }, []);
    const clearDisplayStack = ()=>{
        $e26b8abf7ea53dd6$var$clearingStack = true;
        const stack = [];
        addDisplayItem($e26b8abf7ea53dd6$var$homeDisplayItem, true, stack);
        setDisplayStack(stack);
    };
    const value = {
        appName: appName,
        appVersion: appVersion,
        dateFormat: dateFormat,
        isReady: isReady,
        currentContentType: currentContentType,
        setCurrentContentType: setCurrentContentType,
        inputViewUpdateData: inputViewUpdateData,
        setInputViewUpdateData: setInputViewUpdateData,
        showComponent: showComponent,
        displayStack: displayStack,
        clearDisplayStack: clearDisplayStack,
        setSelectedTableRow: setSelectedTableRow,
        selectedRow: selectedRow
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e26b8abf7ea53dd6$var$MainAppContext.Provider, {
        value: value,
        children: children
    });
};
const $e26b8abf7ea53dd6$export$916c34e134c838e3 = ()=>{
    const context = (0, $acw62.useContext)($e26b8abf7ea53dd6$var$MainAppContext);
    if (!context) throw new Error("useMainApp must be used within an MainAppProvider");
    return context;
};










var $acw62 = parcelRequire("acw62");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");


var $8a00154a77cc4ed8$export$2e2bcd8739ae039 = {
    "column-layout": "awsui_column-layout_vj6p7_tp6ux_97",
    "grid": "awsui_grid_vj6p7_tp6ux_132",
    "grid-no-gutters": "awsui_grid-no-gutters_vj6p7_tp6ux_138",
    "grid-variant-text-grid": "awsui_grid-variant-text-grid_vj6p7_tp6ux_142",
    "grid-breakpoint-default": "awsui_grid-breakpoint-default_vj6p7_tp6ux_150",
    "grid-columns-1": "awsui_grid-columns-1_vj6p7_tp6ux_153",
    "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vj6p7_tp6ux_153",
    "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vj6p7_tp6ux_156",
    "grid-columns-2": "awsui_grid-columns-2_vj6p7_tp6ux_159",
    "grid-columns-3": "awsui_grid-columns-3_vj6p7_tp6ux_165",
    "grid-columns-4": "awsui_grid-columns-4_vj6p7_tp6ux_171",
    "grid-vertical-borders": "awsui_grid-vertical-borders_vj6p7_tp6ux_187",
    "grid-horizontal-borders": "awsui_grid-horizontal-borders_vj6p7_tp6ux_220",
    "root": "awsui_root_vj6p7_tp6ux_274",
    "tile-container": "awsui_tile-container_vj6p7_tp6ux_312",
    "refresh": "awsui_refresh_vj6p7_tp6ux_327",
    "has-metadata": "awsui_has-metadata_vj6p7_tp6ux_331",
    "selected": "awsui_selected_vj6p7_tp6ux_337",
    "disabled": "awsui_disabled_vj6p7_tp6ux_342",
    "readonly": "awsui_readonly_vj6p7_tp6ux_347",
    "columns": "awsui_columns_vj6p7_tp6ux_363",
    "column-1": "awsui_column-1_vj6p7_tp6ux_369",
    "breakpoint-xs": "awsui_breakpoint-xs_vj6p7_tp6ux_376",
    "breakpoint-xxs": "awsui_breakpoint-xxs_vj6p7_tp6ux_380",
    "column-2": "awsui_column-2_vj6p7_tp6ux_384",
    "column-3": "awsui_column-3_vj6p7_tp6ux_399",
    "column-4": "awsui_column-4_vj6p7_tp6ux_414",
    "control": "awsui_control_vj6p7_tp6ux_430",
    "no-image": "awsui_no-image_vj6p7_tp6ux_434",
    "image": "awsui_image_vj6p7_tp6ux_438"
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");





const $66f1afa3a11b864e$export$235cb65c20ad2b7 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ item: item, selected: selected, name: name, breakpoint: breakpoint, onChange: onChange, readOnly: readOnly }, forwardedRef)=>{
    const internalRef = (0, $acw62.useRef)(null);
    const isVisualRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(internalRef, forwardedRef);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8a00154a77cc4ed8$export$2e2bcd8739ae039)["tile-container"], {
            [(0, $8a00154a77cc4ed8$export$2e2bcd8739ae039)["has-metadata"]]: item.description || item.image
        }, {
            [(0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).selected]: selected
        }, {
            [(0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).disabled]: !!item.disabled
        }, {
            [(0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).readonly]: readOnly
        }, {
            [(0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).refresh]: isVisualRefresh
        }, (0, $8a00154a77cc4ed8$export$2e2bcd8739ae039)[`breakpoint-${breakpoint}`]),
        "data-value": item.value,
        onClick: ()=>{
            var _a;
            if (item.disabled || readOnly) return;
            (_a = internalRef.current) === null || _a === void 0 || _a.focus();
            if (!selected) (0, $fc537b925f715587$export$e36a47fa496fb0d2)(onChange, {
                value: item.value
            });
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).control, {
            [(0, $8a00154a77cc4ed8$export$2e2bcd8739ae039)["no-image"]]: !item.image
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0d348656d0a64072$export$2e2bcd8739ae039), {
        checked: selected,
        ref: mergedRef,
        name: name,
        value: item.value,
        label: item.label,
        description: item.description,
        disabled: item.disabled,
        controlId: item.controlId,
        readOnly: readOnly
    })), item.image && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).image, {
            [(0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).disabled]: !!item.disabled
        })
    }, item.image));
});



const $2f11c66273c15e56$var$COLUMN_TRIGGERS = [
    "default",
    "xxs",
    "xs"
];
const $2f11c66273c15e56$var$InternalTiles = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { name: name, value: value, items: items, ariaLabel: ariaLabel, ariaRequired: ariaRequired, ariaControls: ariaControls, columns: columns, onChange: onChange, readOnly: readOnly, __internalRootRef: __internalRootRef = null } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "name",
        "value",
        "items",
        "ariaLabel",
        "ariaRequired",
        "ariaControls",
        "columns",
        "onChange",
        "readOnly",
        "__internalRootRef"
    ]);
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(rest);
    const { ariaDescribedby: ariaDescribedby, ariaLabelledby: ariaLabelledby } = (0, $4a30639b463663e4$export$824c400da192ca1b)(rest);
    const generatedName = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("awsui-tiles-");
    const [tileRef, tileRefIndex] = (0, $3024c0fa705edd01$export$2e2bcd8739ae039)(ref, items, value);
    const [breakpoint, breakpointRef] = (0, $921c3f4037759790$export$2aa1887afbd6d218)($2f11c66273c15e56$var$COLUMN_TRIGGERS);
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(breakpointRef, __internalRootRef);
    const columnCount = $2f11c66273c15e56$var$getColumnCount(items, columns);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        role: "radiogroup",
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        "aria-required": ariaRequired,
        "aria-controls": ariaControls,
        "aria-readonly": readOnly ? "true" : undefined
    }, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).root),
        ref: mergedRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8a00154a77cc4ed8$export$2e2bcd8739ae039).columns, (0, $8a00154a77cc4ed8$export$2e2bcd8739ae039)[`column-${columnCount}`])
    }, items && items.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66f1afa3a11b864e$export$235cb65c20ad2b7), {
            ref: index === tileRefIndex ? tileRef : undefined,
            key: item.value,
            item: item,
            selected: item.value === value,
            name: name || generatedName,
            breakpoint: breakpoint,
            onChange: onChange,
            readOnly: readOnly
        }))));
});
function $2f11c66273c15e56$var$getColumnCount(items, columns) {
    if (columns) return columns;
    const nItems = items ? items.length : 0;
    const columnsLookup = {
        0: 1,
        1: 1,
        2: 2,
        4: 2,
        8: 2
    };
    return columnsLookup[nItems] || 3;
}
var $2f11c66273c15e56$export$2e2bcd8739ae039 = $2f11c66273c15e56$var$InternalTiles;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

var $40202e927744a3f5$export$2e2bcd8739ae039 = {
    "preference-icon--svg": "awsui_preference-icon--svg_d4xxm_1022u_97",
    "preference-icon--layout-border": "awsui_preference-icon--layout-border_d4xxm_1022u_103",
    "preference-icon--layout-background": "awsui_preference-icon--layout-background_d4xxm_1022u_107",
    "preference-icon--layout-header": "awsui_preference-icon--layout-header_d4xxm_1022u_110",
    "preference-icon--border": "awsui_preference-icon--border_d4xxm_1022u_113",
    "preference-icon--primary-button": "awsui_preference-icon--primary-button_d4xxm_1022u_117",
    "preference-icon--secondary": "awsui_preference-icon--secondary_d4xxm_1022u_120",
    "preference-icon--disabled-element": "awsui_preference-icon--disabled-element_d4xxm_1022u_123",
    "preference-icon--separator": "awsui_preference-icon--separator_d4xxm_1022u_126",
    "preference-icon--focus-text": "awsui_preference-icon--focus-text_d4xxm_1022u_129",
    "preference-icon-refresh--svg": "awsui_preference-icon-refresh--svg_d4xxm_1022u_133",
    "preference-icon-refresh--layout-top": "awsui_preference-icon-refresh--layout-top_d4xxm_1022u_139",
    "preference-icon-refresh--layout-main": "awsui_preference-icon-refresh--layout-main_d4xxm_1022u_142",
    "preference-icon-refresh--primary": "awsui_preference-icon-refresh--primary_d4xxm_1022u_145",
    "preference-icon-refresh--disabled": "awsui_preference-icon-refresh--disabled_d4xxm_1022u_148",
    "preference-icon-refresh--column-header": "awsui_preference-icon-refresh--column-header_d4xxm_1022u_151",
    "preference-icon-refresh--window": "awsui_preference-icon-refresh--window_d4xxm_1022u_154",
    "preference-icon-refresh--secondary": "awsui_preference-icon-refresh--secondary_d4xxm_1022u_158",
    "preference-icon-refresh--default": "awsui_preference-icon-refresh--default_d4xxm_1022u_161",
    "preference-icon-refresh--separator": "awsui_preference-icon-refresh--separator_d4xxm_1022u_164",
    "preference-icon-refresh--input-default": "awsui_preference-icon-refresh--input-default_d4xxm_1022u_167",
    "preference-icon-refresh--heading": "awsui_preference-icon-refresh--heading_d4xxm_1022u_170"
};


const $de45693ec3978042$var$sidePositionIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--svg"],
    focusable: false,
    viewBox: "0 0 239 134",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--layout-border"],
    strokeWidth: "2",
    x: "1",
    y: "1",
    width: "223",
    height: "125",
    rx: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--layout-background"],
    x: "11.25",
    y: "0",
    width: "203.4375",
    height: "125"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--layout-header"],
    d: "M2,0 L223,0 C224.104569,-2.02906125e-16 225,0.8954305 225,2 L225,10 L225,10 L0,10 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(20.000000, 22.000000)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--border"],
    strokeWidth: "2",
    x: "1",
    y: "1",
    width: "182",
    height: "110",
    rx: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--primary-button"],
    x: "152",
    y: "6",
    width: "26",
    height: "10"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "122",
    y: "6",
    width: "26",
    height: "10"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "92",
    y: "6",
    width: "26",
    height: "10"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "122",
    y: "29",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "92",
    y: "29",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--focus-text"],
    points: "19 29 49 29 49 32 19 32"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--focus-text"],
    points: "10 10 40 10 40 13 10 13"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    points: "10 29 13 29 13 32 10 32"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--separator"],
    x1: "3",
    y1: "22.7619048",
    x2: "181",
    y2: "22.7619048",
    strokeWidth: "2",
    strokeLinecap: "square"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(3.000000, 37.285714)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "119",
    y: "6",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "89",
    y: "6",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--focus-text"],
    points: "16 6 46 6 46 9 16 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    points: "7 6 10 6 10 9 7 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--separator"],
    x1: "0",
    y1: "0.666666667",
    x2: "178",
    y2: "0.666666667",
    strokeLinecap: "square"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(3.000000, 51.714286)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "119",
    y: "6",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "89",
    y: "6",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--focus-text"],
    points: "16 6 46 6 46 9 16 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    points: "7 6 10 6 10 9 7 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--separator"],
    x1: "0",
    y1: "0.666666667",
    x2: "178",
    y2: "0.666666667",
    strokeLinecap: "square"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(3.000000, 80.571429)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "119",
    y: "6",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "89",
    y: "6",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--focus-text"],
    points: "16 6 46 6 46 9 16 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    points: "7 6 10 6 10 9 7 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--separator"],
    x1: "0",
    y1: "0.666666667",
    x2: "178",
    y2: "0.666666667",
    strokeLinecap: "square"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(3.000000, 66.142857)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "119",
    y: "6",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "89",
    y: "6",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--focus-text"],
    points: "16 6 46 6 46 9 16 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    points: "7 6 10 6 10 9 7 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--separator"],
    x1: "0",
    y1: "0.666666667",
    x2: "178",
    y2: "0.666666667",
    strokeLinecap: "square"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(3.000000, 95.000000)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "119",
    y: "6",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "89",
    y: "6",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--focus-text"],
    points: "16 6 46 6 46 9 16 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    points: "7 6 10 6 10 9 7 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--separator"],
    x1: "0",
    y1: "0.666666667",
    x2: "178",
    y2: "0.666666667",
    strokeLinecap: "square"
}))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(182.000000, 28.000000)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--border"],
    strokeWidth: "2",
    x: "1",
    y: "1",
    width: "55",
    height: "97",
    rx: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--secondary"],
    x: "39.5474354",
    y: "5.86666667",
    width: "14",
    height: "6.41666667"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--focus-text"],
    points: "3.62672811 7.88333333 24.6267281 7.88333333 24.6267281 10.6333333 3.62672811 10.6333333"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(4.000000, 22.000000)",
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--secondary"]
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "0 0 23 0 23 2 0 2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "26 0 49 0 49 2 26 2"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(4.000000, 32.000000)",
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--secondary"]
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "0 0 23 0 23 2 0 2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "26 0 49 0 49 2 26 2"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(4.000000, 43.000000)",
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--secondary"]
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "0 0 23 0 23 2 0 2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "26 0 49 0 49 2 26 2"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(4.000000, 51.000000)",
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--secondary"]
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "0 0 23 0 23 2 0 2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "26 0 49 0 49 2 26 2"
})))));
var $de45693ec3978042$export$2e2bcd8739ae039 = $de45693ec3978042$var$sidePositionIcon;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

const $a4a5e8c22cf2abb7$var$bottomPositionIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--svg"],
    focusable: false,
    viewBox: "0 0 240 134",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--layout-border"],
    strokeWidth: "2",
    x: "1",
    y: "1",
    width: "238",
    height: "125",
    rx: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--layout-background"],
    x: "12",
    y: "0",
    width: "217",
    height: "126"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--layout-header"],
    d: "M2,0 L238,0 C239.104569,-1.58997828e-14 240,0.8954305 240,2 L240,10 L240,10 L0,10 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(28.000000, 22.000000)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--border"],
    strokeWidth: "2",
    x: "1",
    y: "1",
    width: "182",
    height: "110",
    rx: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--primary-button"],
    x: "152",
    y: "6",
    width: "26",
    height: "10"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "122",
    y: "6",
    width: "26",
    height: "10"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "92",
    y: "6",
    width: "26",
    height: "10"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "122",
    y: "29",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "92",
    y: "29",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--focus-text"],
    points: "19 29 49 29 49 32 19 32"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--focus-text"],
    points: "10 10 40 10 40 13 10 13"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    points: "10 29 13 29 13 32 10 32"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--separator"],
    x1: "3",
    y1: "22.7619048",
    x2: "181",
    y2: "22.7619048",
    strokeWidth: "2",
    strokeLinecap: "square"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(3.000000, 37.285714)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "119",
    y: "6",
    width: "55",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    x: "89",
    y: "6",
    width: "26",
    height: "3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--focus-text"],
    points: "16 6 46 6 46 9 16 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--disabled-element"],
    points: "7 6 10 6 10 9 7 9"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--separator"],
    x1: "0",
    y1: "0.666666667",
    x2: "178",
    y2: "0.666666667",
    strokeLinecap: "square"
}))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    transform: "translate(12.000000, 74.000000)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--border"],
    strokeWidth: "2",
    x: "1",
    y: "1",
    width: "215",
    height: "58",
    rx: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--secondary"],
    x: "177",
    y: "8",
    width: "30.6630435",
    height: "10"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--focus-text"],
    points: "10 12 45.3804348 12 45.3804348 15 10 15"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--secondary"],
    transform: "translate(9.000000, 40.000000)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "-3.55271368e-15 0 39 0 39 3 -3.55271368e-15 3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "53 0 92 0 92 3 53 3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "107 0 146 0 146 3 107 3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "160 0 199 0 199 3 160 3"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "-3.55271368e-15 9 39 9 39 12 -3.55271368e-15 12"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "53 9 92 9 92 12 53 12"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "107 9 146 9 146 12 107 12"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    points: "160 9 199 9 199 12 160 12"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--focus-text"],
    points: "10 23 32 23 32 26 10 26"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
    className: (0, $40202e927744a3f5$export$2e2bcd8739ae039)["preference-icon--secondary"],
    points: "40 23 62 23 62 26 40 26"
})))));
var $a4a5e8c22cf2abb7$export$2e2bcd8739ae039 = $a4a5e8c22cf2abb7$var$bottomPositionIcon;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

const $3ca8dc093164aa5b$export$307b18b61172f7ed = (suffix)=>(0, $40202e927744a3f5$export$2e2bcd8739ae039)[`preference-icon-refresh--${suffix}`];
const $3ca8dc093164aa5b$var$TableRow = ({ offset: offset, separator: separator = true, isHeader: isHeader })=>{
    const offsetTop = 0.4482;
    const offsetBottom = 3.4482;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: `translate(0, ${offset})`,
        className: $3ca8dc093164aa5b$export$307b18b61172f7ed(isHeader ? "column-header" : "disabled")
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M19 ${offsetTop}2H22V${offsetBottom}H19V${offsetTop}Z`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M27 ${offsetTop}H51V${offsetBottom}H27V${offsetTop}Z`,
        className: !isHeader ? $3ca8dc093164aa5b$export$307b18b61172f7ed("secondary") : undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M90 ${offsetTop}H110V${offsetBottom}H90V${offsetTop}Z`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M113 ${offsetTop}H157V${offsetBottom}H113V${offsetTop}Z`
    }), separator && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 8H159.387",
        className: $3ca8dc093164aa5b$export$307b18b61172f7ed("separator"),
        strokeLinecap: "square"
    }));
};
const $3ca8dc093164aa5b$var$SidePanelRow = ({ offset: offset })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: `translate(0, ${offset})`,
        className: $3ca8dc093164aa5b$export$307b18b61172f7ed("secondary")
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M177 0H190V3H177V0Z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M195 0H208V3H195V0Z"
    }));
};
const $3ca8dc093164aa5b$var$bottomPositionIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed("svg"),
    focusable: false,
    viewBox: "0 0 230 128",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M2 1H214C214.552 1 215 1.44772 215 2V126C215 126.552 214.552 127 214 127H2.00001C1.44772 127 1 126.552 1 126V2C1 1.44772 1.44772 1 2 1Z",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed("window"),
    strokeWidth: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: "awsui-context-top-navigation"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    x: "2",
    y: "2",
    width: "212",
    height: "6",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed("layout-top")
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M2 8H214V23H2V8Z",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed("layout-main")
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed("default")
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M9 15.5C9 16.8807 7.88071 18 6.5 18C5.11929 18 4 16.8807 4 15.5C4 14.1193 5.11929 13 6.5 13C7.88071 13 9 14.1193 9 15.5Z",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed("disabled")
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M16 14H46.1484V17H16V14Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M92 15.5C92 13.567 93.567 12 95.5 12H108.86C110.793 12 112.36 13.567 112.36 15.5C112.36 17.433 110.793 19 108.86 19H95.5C93.567 19 92 17.433 92 15.5Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M116 15.5C116 13.567 117.567 12 119.5 12H132.86C134.793 12 136.36 13.567 136.36 15.5C136.36 17.433 134.793 19 132.86 19H119.5C117.567 19 116 17.433 116 15.5Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M139 15.5C139 13.567 140.567 12 142.5 12H155.86C157.793 12 159.36 13.567 159.36 15.5C159.36 17.433 157.793 19 155.86 19H142.5C140.567 19 139 17.433 139 15.5Z",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed("primary")
}))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 27,
    isHeader: true
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 39
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 51
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 63
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 75
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 87
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 99
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$TableRow, {
    offset: 111,
    separator: false
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    x: "166",
    y: "13",
    width: "62",
    height: "108",
    rx: "5",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed("window"),
    strokeWidth: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    x: "169",
    y: "62",
    width: "3",
    height: "8",
    rx: "1.5",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed("input-default")
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M216 14V120",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed("separator")
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed("disabled")
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M224 19.5C224 20.8807 222.881 22 221.5 22C220.119 22 219 20.8807 219 19.5C219 18.1193 220.119 17 221.5 17C222.881 17 224 18.1193 224 19.5Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M224 27.5C224 28.8807 222.881 30 221.5 30C220.119 30 219 28.8807 219 27.5C219 26.1193 220.119 25 221.5 25C222.881 25 224 26.1193 224 27.5Z"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M177 23H191V28H177V23Z",
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed("heading")
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: $3ca8dc093164aa5b$export$307b18b61172f7ed("secondary")
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M207 23H212V28H207V23Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M199 23H204V28H199V23Z"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$SidePanelRow, {
    offset: 36
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$SidePanelRow, {
    offset: 48
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$SidePanelRow, {
    offset: 60
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3ca8dc093164aa5b$var$SidePanelRow, {
    offset: 72
}));
var $3ca8dc093164aa5b$export$2e2bcd8739ae039 = $3ca8dc093164aa5b$var$bottomPositionIcon;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");

const $5c7830951f90ff27$var$TableRow = ({ offset: offset, isHeader: isHeader })=>{
    const offsetTop = 0.4482;
    const offsetBottom = 3.4482;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: `translate(0, ${offset})`,
        className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)(isHeader ? "column-header" : "disabled")
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M31 ${offsetTop}H34V${offsetBottom}H31V${offsetTop}Z`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M39 ${offsetTop}H63V${offsetBottom}H39V${offsetTop}Z`,
        className: !isHeader ? (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("secondary") : undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M135 ${offsetTop}H155V${offsetBottom}H135V${offsetTop}Z`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: `M158 ${offsetTop}H202V${offsetBottom}H158V${offsetTop}Z`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M26 8H204.388",
        className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("separator"),
        strokeLinecap: "square"
    }));
};
const $5c7830951f90ff27$var$SidePanelRow = ({ offset: offset })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: `translate(0, ${offset})`,
        className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("secondary")
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M27 0H59V3H27V0Z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M75 0H107V3H75V0Z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M123 0H155V3H123V0Z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M171 0H203V3H171V0Z"
    }));
};
const $5c7830951f90ff27$var$bottomPositionIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("svg"),
    focusable: false,
    viewBox: "0 0 230 128",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M2 1H228C228.552 1 229 1.44772 229 2V117C229 117.552 228.552 118 228 118H2C1.44772 118 1 117.552 1 117V2C1 1.44772 1.44772 1 2 1Z",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("window"),
    strokeWidth: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: "awsui-context-top-navigation"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    x: "2",
    y: "2",
    width: "226",
    height: "6",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("layout-top")
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M2 8H228V23H2V8Z",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("layout-main")
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("default")
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M9 15.5C9 16.8807 7.88071 18 6.5 18C5.11929 18 4 16.8807 4 15.5C4 14.1193 5.11929 13 6.5 13C7.88071 13 9 14.1193 9 15.5Z",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("disabled")
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M26 14H56.1484V17H26V14Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M139 15.5C139 13.567 140.567 12 142.5 12H155.86C157.793 12 159.36 13.567 159.36 15.5C159.36 17.433 157.793 19 155.86 19H142.5C140.567 19 139 17.433 139 15.5Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M163 15.5C163 13.567 164.567 12 166.5 12H179.86C181.793 12 183.36 13.567 183.36 15.5C183.36 17.433 181.793 19 179.86 19H166.5C164.567 19 163 17.433 163 15.5Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M186 15.5C186 13.567 187.567 12 189.5 12H202.86C204.793 12 206.36 13.567 206.36 15.5C206.36 17.433 204.793 19 202.86 19H189.5C187.567 19 186 17.433 186 15.5Z",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("primary")
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
    cx: "223.5",
    cy: "15.5",
    r: "2.5",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("disabled")
}))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c7830951f90ff27$var$TableRow, {
    offset: 27,
    isHeader: true
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c7830951f90ff27$var$TableRow, {
    offset: 39
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c7830951f90ff27$var$TableRow, {
    offset: 51
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c7830951f90ff27$var$TableRow, {
    offset: 63
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    x: "8",
    y: "75",
    width: "214",
    height: "52",
    rx: "5",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("window"),
    strokeWidth: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    x: "111",
    y: "79",
    width: "8",
    height: "3",
    rx: "1.5",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("input-default")
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M27 87H57V92H27V87Z",
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("heading")
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
    className: (0, $3ca8dc093164aa5b$export$307b18b61172f7ed)("secondary")
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M198 87H203V92H198V87Z"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M190 87H195V92H190V87Z"
})), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c7830951f90ff27$var$SidePanelRow, {
    offset: 99
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c7830951f90ff27$var$SidePanelRow, {
    offset: 106
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5c7830951f90ff27$var$SidePanelRow, {
    offset: 113
}));
var $5c7830951f90ff27$export$2e2bcd8739ae039 = $5c7830951f90ff27$var$bottomPositionIcon;


var $13d7a8b65fe18c8d$export$2e2bcd8739ae039 = (props)=>{
    const [position, setPosition] = (0, $acw62.useState)(props.preferences.position);
    const onCancel = ()=>{
        setPosition(props.preferences.position);
        props.onDismiss();
    };
    const onConfirm = ()=>{
        props.onConfirm({
            position: position
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a5bb8d240e2baab$export$2e2bcd8739ae039), {
        size: "medium",
        visible: props.visible,
        onDismiss: props.onDismiss,
        header: props.i18nStrings.header,
        closeAriaLabel: props.i18nStrings.cancel,
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $897e30f655d0e79f$export$2e2bcd8739ae039), {
            float: "right"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbf1224d55e2b5c5$export$2e2bcd8739ae039), {
            direction: "horizontal",
            size: "xs"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            onClick: onCancel,
            formAction: "none",
            variant: "link"
        }, props.i18nStrings.cancel), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
            onClick: onConfirm,
            variant: "primary"
        }, props.i18nStrings.confirm))),
        __internalRootRef: props.__internalRootRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e58f0606af63724$export$2e2bcd8739ae039), {
        label: props.i18nStrings.positionLabel,
        description: props.i18nStrings.positionDescription
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2f11c66273c15e56$export$2e2bcd8739ae039), {
        onChange: (e)=>setPosition(e.detail.value),
        value: position,
        columns: 2,
        items: [
            {
                label: props.i18nStrings.positionBottom,
                image: props.isRefresh ? (0, $5c7830951f90ff27$export$2e2bcd8739ae039) : (0, $a4a5e8c22cf2abb7$export$2e2bcd8739ae039),
                value: "bottom"
            },
            {
                label: props.i18nStrings.positionSide,
                image: props.isRefresh ? (0, $3ca8dc093164aa5b$export$2e2bcd8739ae039) : (0, $de45693ec3978042$export$2e2bcd8739ae039),
                value: "side",
                disabled: props.disabledSidePosition
            }
        ]
    })));
};








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $acw62 = parcelRequire("acw62");





var $8865c966f929fe61$export$2e2bcd8739ae039 = {
    "drawer": "awsui_drawer_1r9lg_10v1l_197",
    "refresh": "awsui_refresh_1r9lg_10v1l_197",
    "animating": "awsui_animating_1r9lg_10v1l_211",
    "drawer-closed": "awsui_drawer-closed_1r9lg_10v1l_266",
    "drawer-content-side": "awsui_drawer-content-side_1r9lg_10v1l_271",
    "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_10v1l_287",
    "position-bottom": "awsui_position-bottom_1r9lg_10v1l_294",
    "with-toolbar": "awsui_with-toolbar_1r9lg_10v1l_311",
    "position-side": "awsui_position-side_1r9lg_10v1l_324",
    "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_10v1l_330",
    "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_10v1l_341",
    "open-button-side": "awsui_open-button-side_1r9lg_10v1l_352",
    "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_10v1l_361",
    "drawer-mobile": "awsui_drawer-mobile_1r9lg_10v1l_371",
    "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_10v1l_375",
    "content-bottom": "awsui_content-bottom_1r9lg_10v1l_384",
    "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_10v1l_400",
    "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_10v1l_405",
    "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_10v1l_409",
    "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_10v1l_413",
    "content-side": "awsui_content-side_1r9lg_10v1l_418",
    "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_10v1l_428",
    "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_10v1l_434",
    "header": "awsui_header_1r9lg_10v1l_442",
    "header-text": "awsui_header-text_1r9lg_10v1l_452",
    "header-actions": "awsui_header-actions_1r9lg_10v1l_465",
    "divider": "awsui_divider_1r9lg_10v1l_473"
};



function $60a72ee6b286b276$export$ab0ba9aff65ad1d3({ style: style, baseProps: baseProps, splitPanelRef: splitPanelRef, toggleRef: toggleRef, header: header, children: children, resizeHandle: resizeHandle, isOpen: isOpen, cappedSize: cappedSize, openButtonAriaLabel: openButtonAriaLabel, panelHeaderId: panelHeaderId, onToggle: onToggle }) {
    const { topOffset: topOffset, bottomOffset: bottomOffset } = (0, $0b5fa47dfe2910a6$export$5a37a347a11159b8)();
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $8865c966f929fe61$export$2e2bcd8739ae039).drawer, (0, $8865c966f929fe61$export$2e2bcd8739ae039)["position-side"], (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039).root, {
            [(0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)["open-position-side"]]: isOpen,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039)["drawer-closed"]]: !isOpen
        }),
        style: Object.assign({
            width: isOpen && isRefresh ? cappedSize : undefined,
            maxWidth: isRefresh ? "100%" : undefined
        }, style),
        ref: splitPanelRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)["drawer-content-side"],
        style: {
            top: topOffset,
            bottom: bottomOffset
        },
        onClick: ()=>!isOpen && onToggle(),
        "aria-labelledby": panelHeaderId,
        role: "region"
    }, isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)["slider-wrapper-side"]
    }, resizeHandle) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$2e2bcd8739ae039), {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)["open-button"], (0, $8865c966f929fe61$export$2e2bcd8739ae039)["open-button-side"]),
        iconName: "angle-left",
        variant: "icon",
        formAction: "none",
        ariaLabel: openButtonAriaLabel,
        ariaExpanded: isOpen,
        ref: isRefresh ? null : toggleRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)["content-side"],
        "aria-hidden": !isOpen
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)["pane-header-wrapper-side"]
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)["pane-content-wrapper-side"]
    }, children))));
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


var $acw62 = parcelRequire("acw62");








function $40f40a5866db94fc$export$acf43145a1f7fbaa({ baseProps: baseProps, isOpen: isOpen, state: state, transitioningElementRef: transitioningElementRef, splitPanelRef: splitPanelRef, cappedSize: cappedSize, header: header, resizeHandle: resizeHandle, children: children, appLayoutMaxWidth: appLayoutMaxWidth, panelHeaderId: panelHeaderId, onToggle: onToggle }) {
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const hasToolbar = (0, $a1afd02c366f84c0$export$cdbb7c478433ee77)("appLayoutWidget");
    const { bottomOffset: bottomOffset, leftOffset: leftOffset, rightOffset: rightOffset, disableContentPaddings: disableContentPaddings, contentWrapperPaddings: contentWrapperPaddings, reportHeaderHeight: reportHeaderHeight } = (0, $0b5fa47dfe2910a6$export$5a37a347a11159b8)();
    const transitionContentBottomRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(splitPanelRef || null, transitioningElementRef);
    const isMobile = (0, $60d79f8943c0bbd8$export$d7da5fa076846028)();
    const headerRef = (0, $acw62.useRef)(null);
    (0, $444535e54951fdea$export$683480f191c0e3ea)(headerRef, (entry)=>reportHeaderHeight(entry.borderBoxHeight));
    (0, $acw62.useEffect)(()=>{
        // report empty height when unmounting the panel
        return ()=>reportHeaderHeight(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const centeredMaxWidthClasses = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
        [(0, $8865c966f929fe61$export$2e2bcd8739ae039)["pane-bottom-center-align"]]: isRefresh,
        [(0, $8865c966f929fe61$export$2e2bcd8739ae039)["pane-bottom-content-nav-padding"]]: contentWrapperPaddings === null || contentWrapperPaddings === void 0 ? void 0 : contentWrapperPaddings.closedNav,
        [(0, $8865c966f929fe61$export$2e2bcd8739ae039)["pane-bottom-content-tools-padding"]]: contentWrapperPaddings === null || contentWrapperPaddings === void 0 ? void 0 : contentWrapperPaddings.closedTools
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, baseProps, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(baseProps.className, (0, $8865c966f929fe61$export$2e2bcd8739ae039).drawer, (0, $8865c966f929fe61$export$2e2bcd8739ae039)["position-bottom"], (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039).root, {
            [(0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)["open-position-bottom"]]: isOpen,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039)["drawer-closed"]]: !isOpen,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039)["drawer-mobile"]]: isMobile,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039)["drawer-disable-content-paddings"]]: disableContentPaddings,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039).animating]: isRefresh && (state === "entering" || state === "exiting"),
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039).refresh]: isRefresh,
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039)["with-toolbar"]]: hasToolbar
        }),
        onClick: ()=>!isOpen && onToggle(),
        style: {
            insetBlockEnd: bottomOffset,
            insetInlineStart: leftOffset,
            insetInlineEnd: rightOffset,
            blockSize: isOpen ? cappedSize : undefined
        },
        ref: transitionContentBottomRef
    }), isOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)["slider-wrapper-bottom"]
    }, resizeHandle), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)["drawer-content-bottom"],
        "aria-labelledby": panelHeaderId,
        role: "region"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039)["pane-header-wrapper-bottom"], centeredMaxWidthClasses),
        ref: headerRef
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039)["content-bottom"], centeredMaxWidthClasses),
        "aria-hidden": !isOpen
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            [(0, $8865c966f929fe61$export$2e2bcd8739ae039)["content-bottom-max-width"]]: isRefresh
        }),
        style: appLayoutMaxWidth
    }, children))));
}







const $6af898269f33764d$export$8f213b5bf43ac777 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, __internalRootRef)=>{
    var { header: header, children: children, hidePreferencesButton: hidePreferencesButton = false, closeBehavior: closeBehavior = "collapse", i18nStrings: i18nStrings } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "header",
        "children",
        "hidePreferencesButton",
        "closeBehavior",
        "i18nStrings"
    ]);
    const isRefresh = (0, $1306e73bd1cbbb9a$export$976bb239ea6ecef8)();
    const { position: position, topOffset: topOffset, bottomOffset: bottomOffset, rightOffset: rightOffset, contentWidthStyles: contentWidthStyles, isOpen: isOpen, isForcedPosition: isForcedPosition, onPreferencesChange: onPreferencesChange, onResize: onResize, onToggle: onToggle, size: size, relativeSize: relativeSize, setSplitPanelToggle: setSplitPanelToggle, refs: refs } = (0, $0b5fa47dfe2910a6$export$5a37a347a11159b8)();
    const baseProps = (0, $75a0355e989dd450$export$a7ec8144096537e7)(restProps);
    const i18n = (0, $4d65e7166b5544ac$export$35d4b88fdfc54b46)("split-panel");
    const [isPreferencesOpen, setPreferencesOpen] = (0, $acw62.useState)(false);
    const appLayoutMaxWidth = isRefresh && position === "bottom" ? contentWidthStyles : undefined;
    const openButtonAriaLabel = i18n("i18nStrings.openButtonAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.openButtonAriaLabel);
    (0, $acw62.useEffect)(()=>{
        setSplitPanelToggle({
            displayed: closeBehavior === "collapse",
            ariaLabel: openButtonAriaLabel
        });
    }, [
        setSplitPanelToggle,
        openButtonAriaLabel,
        closeBehavior
    ]);
    const splitPanelRefObject = (0, $acw62.useRef)(null);
    const sizeControlProps = {
        position: position,
        panelRef: splitPanelRefObject,
        handleRef: refs.slider,
        onResize: onResize
    };
    const onSliderPointerDown = (0, $0d7a0c5aa5b38dc9$export$69c48c1cbbd6dc69)(sizeControlProps);
    const onKeyDown = (0, $f3562f2817c11205$export$2ba6c1a0edf6483a)(sizeControlProps);
    const contentStyle = {
        [(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalTopOffset]: topOffset,
        [(0, $822db745899a2b07$export$2e2bcd8739ae039).stickyVerticalBottomOffset]: bottomOffset
    };
    const panelHeaderId = (0, $cbf2b8f79dc6eee9$export$c485849f2e393253)("split-panel-header");
    const wrappedHeader = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039).header,
        style: appLayoutMaxWidth
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)((0, $8865c966f929fe61$export$2e2bcd8739ae039)["header-text"], (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)["header-text"]),
        id: panelHeaderId
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039)["header-actions"]
    }, !hidePreferencesButton && isOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        className: (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)["preferences-button"],
        iconName: "settings",
        variant: "icon",
        onClick: ()=>setPreferencesOpen(true),
        formAction: "none",
        ariaLabel: i18n("i18nStrings.preferencesTitle", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesTitle),
        ref: refs.preferences
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $8865c966f929fe61$export$2e2bcd8739ae039).divider
    })), isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        className: (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)["close-button"],
        iconName: isRefresh && closeBehavior === "collapse" ? position === "side" ? "angle-right" : "angle-down" : "close",
        variant: "icon",
        onClick: onToggle,
        formAction: "none",
        ariaLabel: i18n("i18nStrings.closeButtonAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.closeButtonAriaLabel),
        ariaExpanded: isOpen
    }) : position === "side" ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aceff6b46a02363$export$6e98354c7167985b), {
        className: (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039)["open-button"],
        iconName: "angle-up",
        variant: "icon",
        formAction: "none",
        ariaLabel: i18n("i18nStrings.openButtonAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.openButtonAriaLabel),
        ref: refs.toggle,
        ariaExpanded: isOpen
    })));
    const resizeHandle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df0c014177452109$export$2e2bcd8739ae039), {
        ref: refs.slider,
        className: (0, $e24acb969e7c7c7f$export$2e2bcd8739ae039).slider,
        ariaLabel: i18n("i18nStrings.resizeHandleAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.resizeHandleAriaLabel),
        // Allows us to use the logical left/right keys to move the slider left/right,
        // but match aria keyboard behavior of using left/right to decrease/increase
        // the slider value.
        ariaValuenow: position === "bottom" ? relativeSize : 100 - relativeSize,
        position: position,
        onKeyDown: onKeyDown,
        onPointerDown: onSliderPointerDown
    });
    /*
    This effect forces the browser to recalculate the layout
    whenever the split panel might have moved.

    This is needed as a workaround for a bug in Safari, which does
    not automatically calculate the new position of the split panel
    _content_ when the split panel moves.
  */ (0, $acw62.useLayoutEffect)(()=>{
        const root = splitPanelRefObject.current;
        if (root) {
            const property = "transform";
            const temporaryValue = "translateZ(0)";
            const valueBefore = root.style[property];
            root.style[property] = temporaryValue;
            // This line forces the browser to recalculate the layout
            root.offsetHeight;
            root.style[property] = valueBefore;
        }
    }, [
        rightOffset,
        __internalRootRef
    ]);
    const mergedRef = (0, $adb603d9351d0211$export$74665b213cb5c4cf)(splitPanelRefObject, __internalRootRef);
    if (closeBehavior === "hide" && !isOpen) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    /**
     * The AppLayout factor moved the circular buttons out of the
     * SplitPanel and into the Tools component. This conditional
     * is still needed for the early return to prevent execution
     * of the following code.
     */ if (isRefresh && !isOpen && position === "side") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29f6cc3f65ba768c$export$be58926105124dd4), {
        in: isOpen !== null && isOpen !== void 0 ? isOpen : false
    }, (state, transitioningElementRef)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, position === "side" && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $60a72ee6b286b276$export$ab0ba9aff65ad1d3), {
            style: contentStyle,
            resizeHandle: resizeHandle,
            baseProps: baseProps,
            isOpen: isOpen,
            splitPanelRef: mergedRef,
            cappedSize: size,
            onToggle: onToggle,
            openButtonAriaLabel: i18n("i18nStrings.openButtonAriaLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.openButtonAriaLabel),
            toggleRef: refs.toggle,
            header: wrappedHeader,
            panelHeaderId: panelHeaderId
        }, children), position === "bottom" && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $40f40a5866db94fc$export$acf43145a1f7fbaa), {
            style: contentStyle,
            resizeHandle: resizeHandle,
            baseProps: baseProps,
            isOpen: isOpen,
            splitPanelRef: mergedRef,
            cappedSize: size,
            onToggle: onToggle,
            header: wrappedHeader,
            panelHeaderId: panelHeaderId,
            state: state,
            transitioningElementRef: transitioningElementRef,
            appLayoutMaxWidth: appLayoutMaxWidth
        }, children), isPreferencesOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $13d7a8b65fe18c8d$export$2e2bcd8739ae039), {
            visible: true,
            preferences: {
                position: position
            },
            disabledSidePosition: position === "bottom" && isForcedPosition,
            isRefresh: isRefresh,
            i18nStrings: {
                header: i18n("i18nStrings.preferencesTitle", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesTitle),
                confirm: i18n("i18nStrings.preferencesConfirm", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesConfirm),
                cancel: i18n("i18nStrings.preferencesCancel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesCancel),
                positionLabel: i18n("i18nStrings.preferencesPositionLabel", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesPositionLabel),
                positionDescription: i18n("i18nStrings.preferencesPositionDescription", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesPositionDescription),
                positionBottom: i18n("i18nStrings.preferencesPositionBottom", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesPositionBottom),
                positionSide: i18n("i18nStrings.preferencesPositionSide", i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.preferencesPositionSide)
            },
            onConfirm: (preferences)=>{
                onPreferencesChange(Object.assign({}, preferences));
                setPreferencesOpen(false);
            },
            onDismiss: ()=>{
                setPreferencesOpen(false);
            }
        })));
});
const $6af898269f33764d$export$dc1769a3f3539a1e = (0, $2b25eacde88e3edd$export$ade51c185567c090)($6af898269f33764d$export$8f213b5bf43ac777);


const $814a3471d5eb41d1$export$27aae29291ab1e43 = (0, $6af898269f33764d$export$dc1769a3f3539a1e)();


function $e7f721cddf93eaf5$export$2e2bcd8739ae039(_a) {
    var { hidePreferencesButton: hidePreferencesButton = false, closeBehavior: closeBehavior = "collapse" } = _a, restProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "hidePreferencesButton",
        "closeBehavior"
    ]);
    const { __internalRootRef: __internalRootRef } = (0, $970c67f83063979b$export$2e2bcd8739ae039)("SplitPanel", {
        props: {
            closeBehavior: closeBehavior,
            hidePreferencesButton: hidePreferencesButton
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $814a3471d5eb41d1$export$27aae29291ab1e43), Object.assign({}, restProps, {
        ref: __internalRootRef,
        hidePreferencesButton: hidePreferencesButton,
        closeBehavior: closeBehavior
    }));
}
(0, $bc3b0639056cd743$export$12dc22cc47108d02)($e7f721cddf93eaf5$export$2e2bcd8739ae039, "SplitPanel");




var $acw62 = parcelRequire("acw62");


const $b4ce7ab90b4000a3$var$splitPanelI18nStrings = {
    preferencesTitle: "Split panel preferences",
    preferencesPositionLabel: "Split panel position",
    preferencesPositionDescription: "Choose the default split panel position for the service.",
    preferencesPositionSide: "Side",
    preferencesPositionBottom: "Bottom",
    preferencesConfirm: "Confirm",
    preferencesCancel: "Cancel",
    closeButtonAriaLabel: "Close panel",
    openButtonAriaLabel: "Open panel",
    resizeHandleAriaLabel: "Resize split panel"
};
const $b4ce7ab90b4000a3$export$dbfe7a0a83d60a06 = ({ showContent: showContent })=>{
    const mainApp = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)();
    const api = (0, $ef4677a056004d8e$export$eb2799109db70ffd)();
    const [detailComponents, setDetailComponents] = (0, $acw62.useState)([]);
    const [title, setTitle] = (0, $acw62.useState)("");
    const loadComponentDetails = async ()=>{
        const resp = await api.makeApiCall("getViewDetailSection/" + mainApp.selectedRow.menuItem.DetailSectionId, "POST", mainApp?.selectedRow?.rowData);
        setTitle(resp.Title);
        if (resp.Components) setDetailComponents(resp.Components);
        else setDetailComponents([]);
    //TODO: disable selection if no components are set
    };
    (0, $acw62.useEffect)(()=>{
        if (mainApp.selectedRow?.menuItem?.DetailSectionId) loadComponentDetails();
    }, [
        mainApp.selectedRow
    ]);
    return mainApp.selectedRow == null || detailComponents.length == 0 ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7f721cddf93eaf5$export$2e2bcd8739ae039), {
        header: title || "No item selected",
        hidePreferencesButton: false,
        i18nStrings: $b4ce7ab90b4000a3$var$splitPanelI18nStrings,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9b1a89cfa249459$export$2e2bcd8739ae039), {
            tabs: showContent == false ? [] : detailComponents.map((x)=>({
                    id: x.Id.toString(),
                    label: x.Title,
                    content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $98339aa869f255f6$export$73903224e3a9e478), {
                        isEmbedded: true,
                        defaultData: x.Data,
                        menuItem: {
                            ViewData: x.Data,
                            DataForGettingMenu: x.DataForGettingMenu,
                            Columns: x.Columns,
                            Id: x.Id,
                            Title: x.Title,
                            TotalLines: -1
                        }
                    })
                }))
        })
    });
};


const $1a74b96f2bb2a4a2$var$findClickedItem = (id, items)=>{
    for (const item of items){
        if (item.id === id) return item;
        if (item.subMenus) {
            const foundItem = $1a74b96f2bb2a4a2$var$findClickedItem(id, item.subMenus);
            if (foundItem) return foundItem;
        }
    }
    return null;
};
const $1a74b96f2bb2a4a2$export$ce4bc3b0184ba3a7 = (_props)=>{
    const [activeHref, setActiveHref] = (0, $acw62.useState)("/");
    const { messages: messages } = (0, $c0aa018cd5ecdf0e$export$a7347740d65f620b)((0, $e94319ab67c021b4$export$31ff3874607c5ef8));
    const dispatch = (0, $c0aa018cd5ecdf0e$export$f51d452c10d5b956)();
    const menus = (0, $93fef701c169bd1e$export$38eaa17faae8f579)();
    const { onMenuClick: onMenuClick } = (0, $ba30691687bb8563$export$bc923229a7fa61e7)();
    const [splitPanelOpen, setSplitPanelOpen] = (0, $acw62.useState)(false);
    const mainApp = (0, $e26b8abf7ea53dd6$export$916c34e134c838e3)(); // auto injected because it's a context provider
    const auth = (0, $fe9e7bfbce151564$export$1d39dc5b47e56ff0)();
    // TODO: make these provider things too
    // TODO: - it might be easier to wait for main app to be ready, and call all these things manually
    //       - then I can call them as "startApplication" same as before
    // flow:
    // call 'initialize system' to get system information   -> only happens once ever
    // then (a.k.a. startApplication)
    // then auth initialize
    //    -> get local stored stuff
    //    -> call perform token refresh is needed
    // then main app initialize
    //    -> check anon actions
    //    -> call 'initialize'
    //    -> if web call fails with 401
    //           --> call perform token refresh
    //           --> if this errors show login dialog
    //           --> if login dialog succeeds, start this flow again
    // then load menus
    //    -> if this errors check for anon functions
    const handleMenuClick = (itemRef)=>{
        mainApp.setSelectedTableRow(null);
        if (itemRef == "/") {
            menus.onHomeClick();
            return;
        }
        const itemId = itemRef.substring(1);
        const menuItemClicked = $1a74b96f2bb2a4a2$var$findClickedItem(itemId, menus.appMenuItems);
        mainApp.clearDisplayStack();
        onMenuClick(menuItemClicked.event);
    };
    const clearAllViewFilterCaches = ()=>{
        // Get the number of items in local storage
        const localStorageLength = localStorage.length;
        // Remove keys that match filter cache
        for(let i = 0; i < localStorageLength; i++){
            const key = localStorage.key(i);
            if (key && (key.includes("_filter_cache") || key.includes("_form_values_cache"))) localStorage.removeItem(key);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (mainApp?.selectedRow) setSplitPanelOpen(true);
    }, [
        mainApp.selectedRow
    ]);
    const currentDisplayItem = mainApp.displayStack.filter((d)=>d.visible == true)?.[0]; // this seems to work
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: "h",
                style: {
                    position: "sticky",
                    top: 0,
                    zIndex: 1002
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a6eb6096d647f226$export$2e2bcd8739ae039), {
                    identity: {
                        href: "/",
                        title: mainApp.appName || "QBic"
                    },
                    utilities: auth.isAuthenticated ? [
                        {
                            type: "button",
                            text: auth?.user?.User
                        },
                        {
                            type: "button",
                            text: "Logout",
                            onClick: auth.logout
                        }
                    ] : []
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $12de04d549d06eb2$export$2e2bcd8739ae039), {
                headerSelector: "#h",
                splitPanelOpen: splitPanelOpen,
                onSplitPanelToggle: ()=>setSplitPanelOpen(!splitPanelOpen),
                splitPanel: currentDisplayItem.type == "view" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4ce7ab90b4000a3$export$dbfe7a0a83d60a06), {
                    showContent: currentDisplayItem.type == "view"
                }) : null,
                // we need the <div and id here because without it, components share state and also lose state, etc. It has to do with order of rendering etc.
                // TODO: this might break with a react or cloudscape upgrade at some point.
                //       a possible solution is to just move all form state to a state context provider or something
                content: mainApp.displayStack?.map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            display: d.visible == true ? "block" : "none"
                        },
                        children: d?.component
                    }, d.id)),
                contentType: mainApp.currentContentType,
                toolsHide: true,
                navigationHide: !auth.isAuthenticated,
                navigation: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ea79e02d828b2693$export$2e2bcd8739ae039), {
                    activeHref: activeHref,
                    onFollow: (event)=>{
                        event.preventDefault();
                        clearAllViewFilterCaches();
                        setActiveHref(event.detail.href);
                        handleMenuClick(event.detail.href);
                    },
                    items: menus.sideNavMenuItems
                }),
                notifications: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $295a537205c57cb7$export$2e2bcd8739ae039), {
                        items: messages.map((message)=>{
                            return {
                                ...message,
                                onDismiss: ()=>{
                                    if (message.id) dispatch((0, $e94319ab67c021b4$export$f9a3c275d8ffdac0)(message.id));
                                }
                            };
                        }),
                        stackItems: true
                    })
                })
            })
        ]
    });
};






const $6f8f8e4dbdc52acc$export$81834d6e76217dcb = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe9e7bfbce151564$export$87091915187a1a85), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5dbc399a9d723999$export$178405afcd8c5eb), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba30691687bb8563$export$9ba8495ab9fb7661), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93fef701c169bd1e$export$62b22d151866115d), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a74b96f2bb2a4a2$export$ce4bc3b0184ba3a7), {})
                })
            })
        })
    });
};





function $cd93687958c8007e$var$App() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55388fc2f116d4d7$export$2881499e37b75b9a), {
        store: (0, $b38651f901ccdd09$export$6f57813fe9f31bf9),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e26b8abf7ea53dd6$export$e3f0b906e9bc3bad), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f8f8e4dbdc52acc$export$81834d6e76217dcb), {})
        })
    });
}
var $cd93687958c8007e$export$2e2bcd8739ae039 = $cd93687958c8007e$var$App;


const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("root"));
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=index.f2e5e128.js.map
